(function () {
    'use strict';

    angular
        .module('app.report', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        var viewAsAdminResolver = ['$q', 'AuthenticationService', function ($q, AuthenticationService) {
            var deferer = $q.defer();

            AuthenticationService.getUserPermissionsAsync().then(function (permissions) {
                if (AuthenticationService.hasPermissions(['VIEW_REPORTS'])) {
                    deferer.resolve(true);
                } else {
                    deferer.resolve(false);
                }
            }, function () {
                deferer.resolve(false);
            })

            return deferer.promise;
        }];

        // State
        $stateProvider
            .state('app.reports', {
                url: '/reports',
                abstract: true,
                views: {
                    'main@app': {
                        template: '<div ui-view></div>'
                    }
                },
            })
            .state('app.reports.list', {
                url: '/',
                templateUrl: 'app/report/reports.html',
                controller: 'ReportsListController',
                controllerAs: 'vm',
                protect: true
            })
            .state('app.reports.confirmed-users-daily', {
                url: '/confirmed-users-daily',
                templateUrl: 'app/report/system/confirmed-users-daily.html',
                controller: 'ConfirmedUsersDailyReportController',
                controllerAs: 'vm',
                protect: true,
                permissions: ['VIEW_CONFIRMED_USERS_DAILY_REPORT']
            })
            .state('app.reports.statement-of-account', {
                url: '/statement-of-account',
                templateUrl: 'app/report/merchant/statement-of-account.html',
                controller: 'StatementOfAccountReportController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver 
                }
            })
            .state('app.reports.statement-of-account-redpay', {
                url: '/statement-of-account-redpay',
                templateUrl: 'app/report/merchant/statement-of-account-redpay.html',
                controller: 'StatementOfAccountRedpayReportController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver
                }
            }).state('app.reports.outlet-transactions', {
                url: '/outlet-transactions',
                templateUrl: 'app/report/merchant/outlet-transactions.html',
                controller: 'OutletTransactionsReportController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver
                }
            }).state('app.reports.voucher-summary', {
                url: '/voucher-summary',
                templateUrl: 'app/report/merchant/voucher-summary.html',
                controller: 'VoucherSummaryReportController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver
                }
            }).state('app.reports.promotion-summary', {
                url: '/promotion-summary',
                templateUrl: 'app/report/merchant/promotion-summary.html',
                controller: 'PromotionSummaryReportController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver
                }
            }).state('app.reports.webcash-settlement', {
                url: '/webcash-settlement',
                templateUrl: 'app/report/merchant/webcash-settlement.html',
                controller: 'WebcashSettlementReportController',
                controllerAs: 'vm',
                protect: true,
                permissions: ['VIEW_WEBCASH_SETTLEMENT_REPORT']
            }).state('app.reports.mobilityone-settlement', {
                url: '/least-cost-routing-transactions',
                templateUrl: 'app/report/system/mobilityone-settlement.html',
                controller: 'MobilityoneSettlementReportController',
                controllerAs: 'vm',
                protect: true,
                permissions: ['VIEW_MOBILITYONE_SETTLEMENT_REPORT']
            }).state('app.reports.merchants-list', {
                url: '/merchants-list',
                templateUrl: 'app/report/merchant/merchants-list.html',
                controller: 'MerchantsListReportController',
                controllerAs: 'vm',
                protect: true,
                permissions: ['VIEW_MERCHANTS_LIST_REPORT']
            }).state('app.reports.store-list', {
                url: '/store-list',
                templateUrl: 'app/report/merchant/store-list.html',
                controller: 'StoreListReportController',
                controllerAs: 'vm',
                protect: true,
                permissions: ['VIEW_STORE_LIST_REPORT']
            }).state('app.reports.merchant-gap', {
                url: '/merchant-gap',
                templateUrl: 'app/report/merchant/merchant-gap.html',
                controller: 'MerchantGapReportController',
                controllerAs: 'vm',
                protect: true,
                permissions: ['VIEW_MERCHANT_GAP_REPORT']
            }).state('app.reports.merchant-terminals', {
                url: '/merchant-terminals',
                templateUrl: 'app/report/merchant/merchant-terminals.html',
                controller: 'MerchantTerminalReportController',
                controllerAs: 'vm',
                protect: true,
                permissions: ['VIEW_MERCHANT_TERMINAL_REPORT']
            }).state('app.reports.storecardtransactions', {
                url: '/storecard-transactions',
                templateUrl: 'app/report/merchant/storecard-transactions.html',
                controller: 'StoreCardTransactionsReportController',
                controllerAs: 'vm',
                protect: true,
                permissions: ['VIEW_STORECARD_TRANSACTION_REPORT']
            }).state('app.reports.exception-transactions', {
                url: '/exception-transactions',
                templateUrl: 'app/report/merchant/exception-transactions.html',
                controller: 'ExceptionTransactionsReportController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver
                }
            }).state('app.reports.bonus-credit', {
                url: '/report-bonus-credit',
                templateUrl: 'app/report/bonus/credit-report.html',
                controller: 'creditReportController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver
                }
            }).state('app.reports.bonus-disbursement-report', {
                url: '/bonus-disbursement-report',
                templateUrl: 'app/report/bonus/disbursement/bonus-disbursement-report.html',
                controller: 'DisbursementReportController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver
                }
            }).state('app.reports.community-report', {
                url: '/community-report',
                templateUrl: 'app/report/merchant/community-report.html',
                controller: 'communityReportController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver
                }
            }).state('app.reports.peer-to-peer', {
                url: '/report-peer-to-peer',
                templateUrl: 'app/report/bonus/peer-report.html',
                controller: 'peerReportController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver
                }
            }).state('app.reports.wallet-source-of-fund-report', {
                url: '/wallet-source-of-fund-report',
                templateUrl: 'app/report/wallet/walletSourceOfFundReport/wallet-source-of-fund-report.html',
                controller: 'walletSourceOfFundReportController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver
                }
            }).state('app.reports.kiplemart-trans', {
                url: '/report-kiplemart-trans',
                templateUrl: 'app/report/kiplemart/trans-report.html',
                controller: 'kiplemartTransController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver
                }
            }).state('app.reports.zakat-transaction-report', {
                url: '/zakat-transaction-report',
                templateUrl: 'app/report/zakat/zakatTransaction/zakat-transaction-report.html',
                controller: 'zakatTransactionReportController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver
                }
            }).state("app.reports.user-registration-report", {
              url: "/user-registration-report",
              templateUrl: "app/report/system/user-registration-report.html",
              controller: "UserRegistrationReportController",
              controllerAs: "vm",
              protect: true,
            }).state('app.reports.externaltransactions', {
                url: '/external-transactions',
                templateUrl: 'app/report/external/transactions.html',
                controller: 'ExternalTransactionsReportController',
                controllerAs: 'vm',
                protect: true,
                permissions: ['VIEW_EXTERNAL_TRANSACTION_REPORT']
            }).state('app.reports.genericautomation', {
                url: '/generic-automation',
                templateUrl: 'app/report/generic/automation.html',
                controller: 'GenericAutomationReportController',
                controllerAs: 'vm',
                protect: true,
                permissions: ['VIEW_GENERIC_AUTOMATION_REPORT']
            }).state('app.reports.genericautomation.create', {
                url: '/create',
                views: {
                    'main@app': {
                        templateUrl: 'app/report/generic/automation.detail.html',
                        controller: 'GenericAutomationReportDetailController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['CREATE_GENERIC_REPORT']
            }).state('app.reports.genericautomation.edit', {
                url: '/edit/:id',
                views: {
                    'main@app': {
                        templateUrl: 'app/report/generic/automation.detail.html',
                        controller: 'GenericAutomationReportDetailController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['EDIT_GENERIC_REPORT']
            }).state('app.reports.remittance-report', {
                url: '/remittance-report',
                templateUrl: 'app/report/external/remittance-report.html',
                controller: 'RemittanceReportController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver
                }
            }).state('app.reports.insurance-report', {
                url: '/insurance-report',
                templateUrl: 'app/report/external/insurance-report.html',
                controller: 'InsuranceReportController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver
                }
            }).state('app.reports.monthly-wallet-utilization', {
                url: '/monthly-wallet-utilization',
                templateUrl: 'app/report/wallet/monthlyWalletUtilization/wallet-monthly-wallet-utilization.html',
                controller: 'monthlyWalletUtilizationController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver
                }
            }).state('app.reports.redpay-transaction', {
                url: '/redpay-transaction',
                templateUrl: 'app/report/redpay/redpayTransaction/redpay-transaction.html',
                controller: 'redpayTransactionController',
                controllerAs: 'vm',
                protect: true,
                resolve: {
                    $$viewAsAdmin: viewAsAdminResolver
                }
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/report');

    }
})();
(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('zakatTransactionReportController', zakatTransactionReportController);


    zakatTransactionReportController.$inject = ['DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter', '$numUtils', 'bonusService', 'UniversityService', 'AuthenticationService', 'TransactionActionHashMap'];

    function zakatTransactionReportController(DTOptionsBuilder, DTColumnBuilder, $q, $filter, $numUtils, bonusService, universityService, authenticationService, TransactionActionHashMap) {
        var vm = this;

        vm.errorMsg = '';
        vm.transanctionTypeList = [
            TransactionActionHashMap['Payment'],
            TransactionActionHashMap['TransactionVoid'],
            TransactionActionHashMap['PurchaseVoucher'],
            TransactionActionHashMap['PayAtTable'],
            TransactionActionHashMap['RedeemVoucher'],
            TransactionActionHashMap['GetFreeVoucher'],
            TransactionActionHashMap['ZakatReward'],
        ];
        vm.serachModel = {
            university: '',
            universityId: '',
            userName: '',
            transanctionType: '',
            beginTime: null,
            endTime: null
        };
        vm.isShowUniversity = authenticationService.hasPermissions('ADMIN_USER');
   
        vm.getUniversities = function () {
            vm.isReadonly = false;
            universityService.GetPortalUniversity().then(function (data) {
                vm.UniversityItems = data.list;
                var hasAdminPermission = authenticationService.hasPermissions(["ADMIN_USER"]);
                if (hasAdminPermission) {
                    vm.serachModel.university = "";
                    vm.isReadonly = false;
                } else {
                    for (var i = 0; i < data.list.length; i++) {
                        var permission = data.list[i].UniversityId.trim() + "_ZAKAT_PIC";
                        var hasPermission = authenticationService.hasPermissions([permission]);
                        if (hasPermission) {
                            vm.serachModel.university = data.list[i].UniversityId;
                            vm.isReadonly = true;
                            break;
                        }
                    }
                }
            })

        }

        vm.dtInstance = {};

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();
                deferer.resolve([]);
                return deferer.promise;

            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Bonus Zakat Transaction Report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Bonus Zakat Transaction Report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('TransactionDate').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('WebcashId'),
                DTColumnBuilder.newColumn('UserName'),
                DTColumnBuilder.newColumn('FullName'),
                DTColumnBuilder.newColumn('Email'),
                DTColumnBuilder.newColumn('University'),
                DTColumnBuilder.newColumn('UniversityID'),
                DTColumnBuilder.newColumn('ZakatGained').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('ZakatUtilised').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('TransactionType'),
                DTColumnBuilder.newColumn('ZakatExpired').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('EndingBalance').withOption('render', function (data) { return $numUtils.toFixed(data); }),
            ]
        };

        vm.searchReport = function () {
            vm.errorMsg = null;

            if (vm.serachModel.beginTime && vm.serachModel.endTime) {
                var beginTime = moment(vm.serachModel.beginTime);
                var endTime = moment(vm.serachModel.endTime);

                var diff = moment(endTime).diff(beginTime, 'minutes');

                if (diff < 0) {
                    vm.errorMsg = "begin time cannot be greater than end time";

                    return;
                }
            }

            vm.dtInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            var jsonData = {
                UserName: vm.serachModel.userName,
                University: vm.serachModel.university,
                UniversityID: vm.serachModel.universityId,
                TransactionType: vm.serachModel.transanctionType,
                TransactionBeginDate: vm.serachModel.beginTime,
                TransactionEndDate: vm.serachModel.endTime
            };
            var defer = $q.defer();
            bonusService.searchZakatTransactionReport(jsonData).then(function (response) {
                defer.resolve(response.data.data);
            }, function (responseError) {
                dealErrorDefer(defer);
            });

            return defer.promise;
        }
         function dealErrorDefer(defer) {
            var message = "Failed! Something has gone wrong. Please contact a system administrator.";
              alert(message);
            defer.resolve();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('monthlyWalletUtilizationController', monthlyWalletUtilizationController);

    monthlyWalletUtilizationController.$inject = ['DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter', 'MerchantReportService'];

    function monthlyWalletUtilizationController(DTOptionsBuilder, DTColumnBuilder, $q, $filter, MerchantReportService) {
        var vm = this;

        vm.appTypes = [];

        vm.searchModel = {
            startMonth: null,
            endMonth: null,
            userId: '',
            webcashId: '',
            fullName: '',
            walletType: '',
            ekycStatus: '',
            ewagesEmployer: '',
            regDate: null,
            partner: ''
        };

        vm.init = function () {
            MerchantReportService.getAppTypes().then(function (data) {
                vm.appTypes = data;
            });
        };

        vm.tableInstance = {};

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();
                deferer.resolve([]);
                return deferer.promise;
            })
                .withBootstrap()
                .withOption('pageLength', 100)
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Monthly Wallet Utilization Report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Monthly_Wallet_Utilization_Report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('TransactionMonth').withTitle('Month').renderWith(function (data) {
                    return moment(data).format("MM/YYYY");
                }),
                DTColumnBuilder.newColumn('RegDate').withTitle('Reg Date').renderWith(function (data) {
                    return moment(data).format("YYYY-MM-DD HH:mm:ss");
                }),
                DTColumnBuilder.newColumn('UserId').withTitle('User ID'),
                DTColumnBuilder.newColumn('WebcashID').withTitle('Webcash ID'),
                DTColumnBuilder.newColumn('Partner').withTitle('Partner').renderWith(function (data) {
                    return data || 'N/A';
                }),
                DTColumnBuilder.newColumn('FullName').withTitle('Full Name').renderWith(function (data) {
                    return data ? data.toUpperCase() : 'N/A';
                }),
                DTColumnBuilder.newColumn('WalletType').withTitle('Wallet Type').renderWith(function (data) {
                    switch (data) {
                        case 0:
                            return 'Basic';
                        case 1:
                            return 'Premium';
                        case 2:
                            return 'Platinum';
                        default:
                            return 'Unknown';
                    }
                }),
                DTColumnBuilder.newColumn('eKYCStatus').withTitle('eKYC Status').renderWith(function (data) {
                    return data ? data : 'N/A';
                }),
                DTColumnBuilder.newColumn('eWagesEmployer').withTitle('eWages Employer Name').renderWith(function (data) {
                    return data ? data : 'N/A';
                }),
                DTColumnBuilder.newColumn('Cards').withTitle('In: Cards').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('FPX').withTitle('In: FPX').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('P2PIncoming').withTitle('In: P2P').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('Prefund').withTitle('In: Prefund').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('Zakat').withTitle('In: Zakat').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('VisaRefund').withTitle('In: Visa Refund').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('WUIncoming').withTitle('In: WU').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('VirtualAccount').withTitle('In: Virtual Account').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('OTC').withTitle('In: OTC').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('TotalIncomingFunds').withTitle('Total Incoming Funds').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('P2POutgoing').withTitle('Out: P2P').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('Visa').withTitle('Out: Visa').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('ATM').withTitle('Out: ATM').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('PTPTN').withTitle('Out: PTPTN').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('Bills').withTitle('Out: Bills').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('QRPayments').withTitle('Out: QR Payments').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('WUOutgoing').withTitle('Out: WU').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('DuitNow').withTitle('Out: DuitNow').renderWith(function (data) {
                    return data ? data : '0';
                }),
                DTColumnBuilder.newColumn('TotalOutgoingFunds').withTitle('Total Outgoing Funds').renderWith(function (data) {
                    return data ? data : '0';
                })
                
            ]
        };

        vm.searchReport = function () {
            var startMonth = $("#startMonth").val();
            var endMonth = $("#endMonth").val();

            if (!startMonth || !endMonth) {
                alert("Please select both start and end month.");
                return;
            }

            if (moment(endMonth).isBefore(startMonth)) {
                alert("End month cannot be before start month.");
                return;
            }

            getReportPromise().then(function (data) {
                if (vm.tableInstance.DataTable) {
                    vm.tableInstance.DataTable.clear();
                    vm.tableInstance.DataTable.rows.add(data);
                    vm.tableInstance.DataTable.draw();
                }
            });
        };

        function getReportPromise() {
            var eKYCStatusValue = vm.searchModel.ekycStatus ? parseInt(vm.searchModel.ekycStatus) : null;

            var jsonData = {
                StartMonth: vm.searchModel.startMonth,
                EndMonth: vm.searchModel.endMonth,
                UserId: vm.searchModel.userId,
                WebcashID: vm.searchModel.webcashId,
                FullName: vm.searchModel.fullName,
                WalletType: vm.searchModel.walletType,
                eKYCStatus: eKYCStatusValue,
                eWagesEmployer: vm.searchModel.ewagesEmployer,
                RegDate: vm.searchModel.regDate,
                Partner: vm.searchModel.partner
            };

            var defer = $q.defer();
            MerchantReportService.getWalletUtilizationReportAsync(jsonData).then(function (response) {
                defer.resolve(response);
            }, function (error) {
                alert("Failed to retrieve data. Please try again later.");
                defer.resolve([]);
            });

            return defer.promise;
        }

        vm.dtInstanceCallback = function (dtInstance) {
            vm.tableInstance.DataTable = dtInstance.DataTable;
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('walletSourceOfFundReportController', walletSourceOfFundReportController);


    walletSourceOfFundReportController.$inject = ['DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter', '$numUtils', 'SystemReportService'];

    function walletSourceOfFundReportController(DTOptionsBuilder, DTColumnBuilder, $q, $filter, $numUtils, SystemReportService) {
        var vm = this;

        vm.errorMsg = '';
        vm.serachModel = {
            userName: '',
            beginTime: null,
            endTime: null
        };

        vm.dtInstance = {};

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();
                deferer.resolve([]);
                return deferer.promise;

            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false) 
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Wallet Source of Fund Report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Wallet Source of Fund Report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('TransacionId'),
                DTColumnBuilder.newColumn('TransactionDate').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('WebcashId'),
                DTColumnBuilder.newColumn('UserName'),
                DTColumnBuilder.newColumn('FullName'),
                DTColumnBuilder.newColumn('Email'),
                DTColumnBuilder.newColumn('WalletCategory'),
                DTColumnBuilder.newColumn('TotalWallet'),
                DTColumnBuilder.newColumn('FPX1'),
                DTColumnBuilder.newColumn('CC2'),
                DTColumnBuilder.newColumn('LinkCard3'),
                DTColumnBuilder.newColumn('CommissionPayout4'),
                DTColumnBuilder.newColumn('BonusCredit5'),
                DTColumnBuilder.newColumn('BonusZakatTransfer6'),
                DTColumnBuilder.newColumn('Remittance7'),
                DTColumnBuilder.newColumn('VirtualAccount8'),
                DTColumnBuilder.newColumn('VirtualAccount8'),
                DTColumnBuilder.newColumn('TransferWithinKipleWallet9'),
                DTColumnBuilder.newColumn('Offline10'),
                DTColumnBuilder.newColumn('DuitNow12')
            ]
        };

        vm.searchReport = function () {
            vm.errorMsg = null;
            var sdate = $("#sdate").val();
            var edate = $("#edate").val();
            if (sdate == null || sdate == "") {
                alert("Please select start date");
                return;
            }
            if (edate == null || edate == "") {
                alert("Please select end date");
                return;
            }
            if(! vm.serachModel.userName){
                alert("User name should not be null.");
                return;
            }

            if (vm.serachModel.beginTime && vm.serachModel.endTime) {
                var beginTime = moment(vm.serachModel.beginTime);
                var endTime = moment(vm.serachModel.endTime);

                var diff = moment(endTime).diff(beginTime, 'minutes');

                if (diff < 0) {
                    vm.errorMsg = "begin time cannot be greater than end time";

                    return;
                }
            } 
            vm.dtInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            var jsonData = {
                UserName: vm.serachModel.userName,
                TransactionBeginDate: vm.serachModel.beginTime,
                TransactionEndDate: vm.serachModel.endTime
            };
            var defer = $q.defer();
            SystemReportService.searchWalletSourceOfFundReportAsync(jsonData).then(function (response) {
            defer.resolve(response.data.data);
            }, function (responseError) { 
                if(!!responseError&&!!responseError.data&&!!responseError.data.Message){
                 alert(responseError.data.Message);
                 defer.resolve();
                }else{ 
                    dealErrorDefer(defer);
                } 
            }); 

            return defer.promise;
        }
        function dealErrorDefer(defer) {
            var message = "Failed! Something has gone wrong. Please contact a system administrator.";
            alert(message);
            defer.resolve();
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('DisbursementReportController', DisbursementReportController);


    DisbursementReportController.$inject = ['DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter', '$numUtils', 'bonusService', 'UniversityService', 'AuthenticationService'];

    function DisbursementReportController(DTOptionsBuilder, DTColumnBuilder, $q, $filter, $numUtils, bonusService, UniversityService, AuthenticationService) {
        var vm = this;

        vm.errorMsg = '';
        vm.isReadonly = true;
        vm.statusList = [
            { status: 0, displayText: 'Pending' }, 
            { status: 1, displayText: 'Fail' }, 
            { status: 2, displayText: 'Approved' }, 
            { status: 3, displayText: 'Successful' }, 
            { status: 4, displayText: 'Rejected' }
        ];
        vm.serachModel = {
            disbursementReportStartDate: null,
            disbursementReportEndDate: null,
            userName: '',
            idNo: '',
            universityId: '',
            universityCode: '',
            status: null,
        };
        vm.getUniversities = function () {
            vm.isReadonly = false;
            UniversityService.GetPortalUniversity().then(function (data) {
                vm.UniversityItems = data.list;
                var hasAdminPermission = AuthenticationService.hasPermissions(["ADMIN_USER"]);
                if (hasAdminPermission) {
                    vm.serachModel.universityCode = "";
                    vm.isReadonly = false;
                } else {
                    for (var i = 0; i < data.list.length; i++) {
                        var permission = data.list[i].UniversityId.trim() + "_ZAKAT_PIC";
                        var hasPermission = AuthenticationService.hasPermissions([permission]);
                        if (hasPermission) {
                            vm.serachModel.universityCode = data.list[i].UniversityId;
                            vm.isReadonly = true;
                            break;
                        }
                    }
                }
            })

        }
        vm.UniversityIdClick = function () {
        }

        vm.dtInstance = {};

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();
                deferer.resolve([]);
                return deferer.promise;

            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Bonus Zakat Disbursement Report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Bonus Zakat Disbursement Report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('DisbursementDateTime').withClass('center').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('UserName'),
                DTColumnBuilder.newColumn('IdNo'),
                DTColumnBuilder.newColumn('UniversityId'),
                //DTColumnBuilder.newColumn('EntitlementDate').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('UniversityCode'),
                DTColumnBuilder.newColumn('TotalPrefund'),
                DTColumnBuilder.newColumn('Status'),
                DTColumnBuilder.newColumn('Remark'),
            ]
        };

        vm.searchReport = function () {
            vm.errorMsg = null;
            if (vm.serachModel.disbursementReportStartDate && vm.serachModel.disbursementReportEndDate) {
                var beginTime = moment(vm.serachModel.disbursementReportStartDate);
                var endTime = moment(vm.serachModel.disbursementReportEndDate);

                var diff = moment(endTime).diff(beginTime, 'minutes');

                if (diff < 0) {
                    vm.errorMsg = "begin time cannot be greater than end time";

                    return;
                }
            }

            vm.dtInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            var jsonData = {
                DisbursementReportStartDate: vm.serachModel.disbursementReportStartDate,
                DisbursementReportEndDate: vm.serachModel.disbursementReportEndDate,
                UserName: vm.serachModel.userName,
                IdNo: vm.serachModel.idNo,
                UniversityId: vm.serachModel.universityId,
                UniversityCode: vm.serachModel.universityCode,
                Status: vm.serachModel.status,
            };
            var defer = $q.defer();
            bonusService.searchDisbursementReport(jsonData).then(function (response) {
                defer.resolve(response.data);
            }, function (responseError) {
                dealErrorDefer(defer);
            });

            return defer.promise;
        }
         function dealErrorDefer(defer) {
            var message = "Failed! Something has gone wrong. Please contact a system administrator.";
              alert(message);
            defer.resolve();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('redpayTransactionController', redpayTransactionController);

    redpayTransactionController.$inject = ['DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter', 'MerchantReportService'];

    function redpayTransactionController(DTOptionsBuilder, DTColumnBuilder, $q, $filter, MerchantReportService) {
        var vm = this;

        vm.searchModel = {
            startDate: null,
            endDate: null,
            username: '',
            fullName: '',
            transactionType: '',
            merchantName: ''
        };

        vm.datePopup = {
            StartOpen: false,
            EndOpen: false
        };

        function formatDate(date) {
            if (!date) return '';
            return moment(date).format('YYYY-MM-DD');
        }

        function getReportPromise() {
            var defer = $q.defer();
            var filter = {
                startDate: formatDate(vm.searchModel.startDate),
                endDate: formatDate(vm.searchModel.endDate),
                username: vm.searchModel.username,
                fullName: vm.searchModel.fullName,
                transactionType: vm.searchModel.transactionType,
                merchantName: vm.searchModel.merchantName
            };

            MerchantReportService.getRedPayTransactionReportAsync(filter)
                .then(function (response) {
                    console.log('API Response:', response); // Debug log
                    defer.resolve(response || []);
                }, function (error) {
                    vm.errorMsg = "Failed to retrieve data. Please try again later.";
                    defer.resolve([]);
                });

            return defer.promise;
        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(getReportPromise)
                .withBootstrap()
                .withDOM('Bfrtip')
                .withOption('processing', true)
                .withOption('serverSide', false)
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('order', [[0, 'desc']])
                .withButtons([
                    {
                        extend: 'print',
                        title: 'RedPay Transaction Report'
                    },
                    {
                        extend: 'csv',
                        filename: 'RedPay_Transaction_Report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('TransactionDate').withTitle('Transaction Date').renderWith(function (data) {
                    return moment(data).format("YYYY-MM-DD HH:mm:ss");
                }),
                DTColumnBuilder.newColumn('UserId').withTitle('User ID'),
                DTColumnBuilder.newColumn('Username').withTitle('Username'),
                DTColumnBuilder.newColumn('FullName').withTitle('Full Name'),
                DTColumnBuilder.newColumn('TransactionType').withTitle('Transaction Type'),
                DTColumnBuilder.newColumn('TransactionSubType').withTitle('Transaction Sub Type'),
                DTColumnBuilder.newColumn('GrossAmount').withTitle('Gross Amount').renderWith(function (data) {
                    return data ? $filter('currency')(data, 'RM ') : '';
                }),
                DTColumnBuilder.newColumn('Status').withTitle('Status'),
                DTColumnBuilder.newColumn('Remarks').withTitle('Remarks'),
                DTColumnBuilder.newColumn('OffsetAmount').withTitle('Offset Amount').renderWith(function (data) {
                    return data ? $filter('currency')(data, 'RM ') : '';
                }),
                DTColumnBuilder.newColumn('RewardLinkFee').withTitle('Rewardlink Fee').renderWith(function (data) {
                    return data ? $filter('currency')(data, 'RM ') : '';
                }),
                DTColumnBuilder.newColumn('OffsetPercentage').withTitle('Offset Percentage').renderWith(function (data) {
                    return data ? data + '%' : '';
                }),
                DTColumnBuilder.newColumn('ConversionRate').withTitle('Conversion Rate'),
                DTColumnBuilder.newColumn('RebatePercentage').withTitle('Rebate (%)').renderWith(function (data) {
                    return data ? data + '%' : '';
                }),
                DTColumnBuilder.newColumn('RebateAmount').withTitle('Rebate (RM)').renderWith(function (data) {
                    return data ? $filter('currency')(data, 'RM ') : '';
                }),
                DTColumnBuilder.newColumn(null).withTitle('Merchant Name').renderWith(function (data) {
                    return data.VisaMerchantName || data.WalletMerchantName || '';
                }),
                DTColumnBuilder.newColumn('PrefundUtilization').withTitle('Prefund Utilization').renderWith(function (data) {
                    return data ? $filter('currency')(data, 'RM ') : '';
                }),
                DTColumnBuilder.newColumn('LDRShareRate').withTitle('LDR Share Rate (RM)').renderWith(function (data) {
                    return data ? $filter('currency')(data, 'RM ') : '';
                })
            ]
        };

        vm.init = function () {
            // Set default dates (last 30 days)
            vm.searchModel.endDate = new Date();
            vm.searchModel.startDate = new Date();
            vm.searchModel.startDate.setDate(vm.searchModel.startDate.getDate() - 30);
            vm.searchReport();
        };

        vm.searchReport = function () {
            if (!vm.searchModel.startDate || !vm.searchModel.endDate) {
                vm.errorMsg = "Please select both start and end dates.";
                return;
            }

            if (moment(vm.searchModel.endDate).isBefore(vm.searchModel.startDate)) {
                vm.errorMsg = "End date cannot be before start date.";
                return;
            }

            vm.errorMsg = "";

            if (vm.dtInstance && vm.dtInstance.rerender) {
                vm.dtInstance.rerender();
            }
        };

        vm.dtInstance = {};
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.admin', {
                url: '/admin',
                abstract: true
            })
            .state('app.admin.group', {
                url: '/group',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/group/group.html',
                        controller: 'GroupController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_GROUP']
            })
            .state('app.admin.banner', {
                url: '/banner',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/banner/banner.html',
                        controller: 'BannerController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_BRAND']
               
            })
            .state('app.admin.referralbanner', {
                url: '/referral-banner',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/referral-banner/referral-banner.html',
                        controller: 'ReferralBannerController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_BRAND']

            })
            .state('app.admin.home-page-main-services', {
                url: '/home-page-main-services',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/home-page-main-services/home-page-main-services.html',
                        controller: 'HomePageMainServiceInfoController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['ADMIN_USER']

            }).state('app.admin.education-service', {
                url: '/education-service',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/education-service/education-service.html',
                        controller: 'educationServiceController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['ADMIN_USER']

            })
            .state('app.admin.brand', {
                url: '/brand',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/brand/brand.html',
                        controller: 'BrandController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_BRAND']
            })
            .state('app.admin.configuration', {
                url: '/configuration',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/configuration/configuration.html',
                        controller: 'ConfigurationController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['SYSTEM_CONFIGURATION']
            })
            .state('app.admin.fraudManagement', {
                url: '/fraudManagement',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/fraudManagement/fraudManagement.html',
                        controller: 'FraudController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['SYSTEM_FRAUD_MANAGEMENT']
            })
            .state('app.admin.tierSetting', {
                url: '/tierSetting',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/tierSetting/tierSetting.html',
                        controller: 'TierSettingController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_TIER_SETTING']
            })
            .state('app.admin.tierSetting.edit', {
                url: '/tierSetting/detail/:id',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/tierSetting/detail/tierSetting.detail.html',
                        controller: 'TierSettingDetailController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['EDIT_TIER_SETTING']
            })
            .state('app.admin.tierSetting.new', {
                url: '/tierSetting/detail',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/tierSetting/detail/tierSetting.detail.html',
                        controller: 'TierSettingDetailController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['CREATE_TIER_SETTING']
            })
            .state('app.admin.sharedStoreCard', {
                url: '/sharedStoreCard',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/sharedStoreCard/sharedStoreCard.html',
                        controller: 'SharedStoreCardController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_SHARED_STORECARD']
            })
            .state('app.admin.sharedStoreCard.edit', {
                url: '/sharedStoreCard/detail/:id',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/sharedStoreCard/detail/sharedStoreCard.detail.html',
                        controller: 'SharedStoreCardDetailController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['EDIT_SHARED_STORECARD']
            })
            .state('app.admin.sharedStoreCard.new', {
                url: '/sharedStoreCard/detail',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/sharedStoreCard/detail/sharedStoreCard.detail.html',
                        controller: 'SharedStoreCardDetailController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['CREATE_SHARED_STORECARD']
            })
            .state('app.admin.user', {
                url: '/user',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/user/user.html',
                        controller: 'UserController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_USER']
            })
            .state('app.admin.mobile-number-change', {
                url: '/mobile-number-change',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/mobile-number-change/mobile-number-change.html',
                        controller: 'MobileNumberChangeController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_USER']
            })
            .state('app.admin.user.detail', {
                url: '/user/detail/:id',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/user/user.detail.html',
                        controller: 'UserDetailController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_USER']
            })
            .state('app.admin.user.transaction', {
                url: '/user/transaction/:id',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/user/user.transaction.html',
                        controller: 'UserTransactionController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_USER']
            })
            .state('app.admin.user.wallet', {
                url: '/user/wallet/:id?balance?name',
               
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/user/user.wallet.html',
                        controller: 'UserWalletController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_USER']
            })
            .state('app.admin.user.storecard', {
                url: '/user/storecard/:id?balance',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/user/user.storecard.html',
                        controller: 'UserStoreCardController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_USER']
            })
            .state('app.admin.user.kiplekash', {
                url: '/user/kiplekash/:id?balance',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/user/user.kiplekash.html',
                        controller: 'UserKipleKashController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_USER']
            })
            .state('app.admin.admin-user', {
                url: '/admin-user',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/admin-user/admin-user.html',
                        controller: 'AdminUserController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['ADMIN_USER']
            })
            .state('app.admin.category', {
                url: '/category',
                abstract: true
            })
            .state('app.admin.category.merchant', {
                url: '/merchant',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/category/merchant/category-merchant.html',
                        controller: 'CategoryMerchantController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_CATEGORY']
            })
            .state('app.admin.tag', {
                url: '/tag',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/tag/tag.html',
                        controller: 'TagController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_TAG']
            })
            .state('app.admin.notificationlist', {
                url: '/notificationlist',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/notification/notificationlist.html',
                        controller: 'NotificationlistController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['SEND_NOTIFICATION']
            })
            .state('app.admin.notification', {
                url: '/notification',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/notification/notification.html',
                        controller: 'NotificationController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['SEND_NOTIFICATION']
            })
            .state('app.admin.announcement', {
                url: '/announcement',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/announcement/announcement.html',
                        controller: 'announcementController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['SEND_ANNOUNCEMENT']
            })
            .state('app.admin.co-brand-artwork-configuration', {
                url: '/co-brand-artwork-configuration',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/co-brand-artwork-configuration/co-brand-artwork-configuration.html',
                        controller: 'CoBrandArtWorkController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['SEND_ANNOUNCEMENT']
            })
            .state('app.admin.promotion', {
                url: '/promotions',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/promotion/promotion.view.layout.html'
                    },
                    'registrationCode@app.admin.promotion': {
                        templateUrl: 'app/admin/promotion/promotion.view.registrationcode.html',
                        controller: 'PromotionController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_PROMOTION']
            })
            .state('app.admin.refund', {
                url: '/refund',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/refund/refund.html',
                        controller: 'RefundController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['REFUND']
            })
            .state('app.admin.bonus', {
                url: '/bonus',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/bonus/bonus.html',
                        controller: 'bonusController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['BONUS_CREDIT']
            })
            .state('app.admin.bonus-disbursement-request-approve', {
                url: '/bonus-disbursement-request-approve',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/bonus-disbursement-request-approve/bonus-disbursement-request-approve.html',
                        controller: 'DisbursementRequestApprovalController',
                        controllerAs: 'vm'
                    }
                },
                protect: true, 
                permissions: ['ZAKAT_PRODUCT_FINANCE_OPERATION','ADMIN_USER']
            })
            .state('app.admin.bonus-storecard', {
                url: '/bonus-storecard',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/bonus-storecard/bonus-storecard.html',
                        controller: 'BonusStorecardController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['BONUS_STORECARD']
            })
            .state('app.admin.least-cost-routing', {
                url: '/least-cost-routing',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/least-cost-routing/least-cost-routing.html',
                        controller: 'LeastCostRoutingController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['LEAST_COST_ROUTING']
            })
            .state('app.admin.bonus-kiplekash', {
                url: '/bonus-kiplekash',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/bonus-kiplekash/bonus-kiplekash.html',
                        controller: 'BonusKiplekashController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['BONUS_KIPLEKASH']
            })
            .state('app.admin.BulkRegister-partner', {
                url: '/BulkRegister-partner',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/BulkRegister/BulkRegister-partner/BulkRegister-partner.html',
                        controller: 'BulkRegisterPartnerController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['ADMIN_USER', 'BATCH_CREATE_MYKASIH_USERS','COMMISSION_PAYOUT_BULK_UPLOAD']
            })
            .state('app.admin.user-creation-report', {
                url: '/user-creation-report',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/BulkRegister/user-creation-report/user-creation-report.html',
                        controller: 'UserCreationReportController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['ADMIN_USER','COMMISSION_PAYOUT_BULK_UPLOAD']
            })
            .state('app.admin.user-profile-report', {
                url: '/user-profile-report',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/BulkRegister/user-profile-report/user-profile-report.html',
                        controller: 'UserProfileReportController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['ADMIN_USER', 'COMMISSION_PAYOUT_BULK_UPLOAD']
            })
            .state('app.admin.user-wallet-upgrade', {
                url: '/user-wallet-upgrade',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/BulkRegister/user-wallet-upgrade/user-wallet-upgrade.html',
                        controller: 'UserWalletUpgradeController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['ADMIN_USER', 'COMMISSION_PAYOUT_BULK_UPLOAD']
            })
            .state('app.admin.BulkRegister-kiplekash', {
                url: '/BulkRegister-kiplekash',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/BulkRegister-kiplekash/BulkRegister-kiplekash.html',
                        controller: 'BulkRegisterController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['ADMIN_USER']
            })

            .state('app.admin.settlement-transaction', {
                url: '/settlemen-transaction',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/settlement-transaction/settlement-transaction.html',
                        controller: 'SettlementTransactionController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['MANAGE_SETTLEMENT_TRANSACTION']
            })
            .state('app.admin.settlement-transaction-search', {
                url: '/settlemen-transaction/:sDate/:eDate/:mId',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/settlement-transaction/settlement-transaction.html',
                        controller: ('SettlementTransactionController'),
                        controllerAs: 'vm',
                        params: { sDate: null, eDate: null, mId: null }
                    }
                },
                protect: true,
                permissions: ['MANAGE_SETTLEMENT_TRANSACTION']
            })
            .state('app.admin.settlement-summary', {
                url: '/summary',
                views: {
                    'main@app': {
                        templateUrl: 'app/admin/settlement-summary/settlement-summary.html',
                        controller: 'SettlementTransactionSummaryController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['MANAGE_SETTLEMENT_TRANSACTION']
            });
        // Translation
        $translatePartialLoaderProvider.addPart('app/admin');

    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('SharedStoreCardDetailController', SharedStoreCardDetailController);

    /** @ngInject */
    function SharedStoreCardDetailController(SVCS, $translate, SharedStoreCardService, $stateParams, $scope, $timeout, $state, MerchantService) {
        var vm = this;
        vm.sharedStoreCard = {
            Name: null,
            MerchantId: null,
            DisplayOnKiplePayApp: false
        }

        if ($stateParams.id != null) {
            SharedStoreCardService.Get($stateParams.id).then(function (data) {
                vm.sharedStoreCard = data;
                MerchantService.Get(data.MerchantId).then(function (res) {
                    MerchantService.Search({ Keyword: res.FullName }).then(function (res) {
                        vm.merchants = res.Items;
                    });
                });
            })
        }

        vm.save = function () {
            if (!$scope.sharedStoreCardForm.$valid) {
                angular.forEach($scope.sharedStoreCardForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#sharedStoreCardForm .ng-invalid')[0].focus();
                //if ($('input[type=search] .ng-invalid').length === 1) {
                //    $('input[type=search] .ng-invalid')[0].focus();
                //}
                //$scope.$broadcast('focusMerchant');
                return;
            }
            if ($stateParams.id != null) {
                SharedStoreCardService.Update(vm.sharedStoreCard).then(function (data) {
                    $state.go('app.admin.sharedStoreCard');
                })
            }
            else {
                SharedStoreCardService.Create(vm.sharedStoreCard).then(function (data) {
                    $state.go('app.admin.sharedStoreCard');
                })
            }
        }

        vm.loadMerchant = function (keyword) {
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = res.Items;
                });
            } else {
                vm.merchants = null;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('UserWalletController', UserWalletController);

    /** @ngInject */
    function UserWalletController(UserService, $scope, $stateParams, $numUtils) {
        var vm = this;

        //#region Search transaction for user
        vm.criteria = {
            UserId: $stateParams.id,
            Page: 1,
            Length: 10,
            Csvfrom: 1,
            CsvTo: 1000,
            StartDate: null,
            EndDate: null
        };
        vm.user = {
            UserName: "",
            WalletId: "",
            WalletBalance:""
        }
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 3;
        vm.ItemsCount = 0;
        vm.resetPage = function () {
            vm.criteria = {
                UserId: $stateParams.id,
                Page: 1,
                Length: 10,
                Csvfrom: 1,
                CsvTo: 1000,
                StartDate: null,
                EndDate: null
            };
           
            vm.search();
        }

        vm.reset = function () {
            vm.search();
        }
        vm.searchPagination = function () {
            vm.search();
        }
        vm.search = function () {
            var criteria = vm.criteria;
            criteria.Page = vm.currentPage;
            if ((new Date(criteria.StartDate) <= new Date(criteria.EndDate)) || ((criteria.StartDate == null) || (criteria.EndDate == null))) {
                UserService.GetWalletTransaction(criteria).then(function (data) {
                    vm.transactions = data.Items.WalletTransaction;
                    if (data.Items.WalletTransaction != null) {
                        vm.user.UserName = data.Items.UserName;
                        vm.user.WalletId = data.Items.WalletId;
                    }
                    vm.user.WalletBalance = $stateParams.balance;
                    var tempTrans = [];
                    // Rounding 2 decimal
                    angular.forEach(vm.transactions, function (trans) {
                        var temp = angular.copy(trans);
                        temp.Amount = $numUtils.toFixed(temp.Amount);
                        temp.In = $numUtils.toFixed(temp.In);
                        temp.Out = $numUtils.toFixed(temp.Out);
                        temp.Balance = $numUtils.toFixed(temp.Balance);
                        temp.Fee = $numUtils.toFixed(temp.Fee);
                        tempTrans.push(temp);
                    }, tempTrans);
                    if (criteria.StartDate == null) {
                        vm.criteria.StartDate = criteria.StartDate
                    }
                    else {
                        vm.criteria.StartDate = new Date(criteria.StartDate);
                    }

                    if (criteria.EndDate == null) {
                        vm.criteria.EndDate = criteria.EndDate
                    }
                    else {
                        vm.criteria.EndDate = new Date(criteria.EndDate);
                    }
                    vm.transactions = tempTrans;

                    vm.totalItems = data.Total;
                    vm.ItemsCount = data.Total;
                });
            }
            else {
                alert("Start date should not be greater than end date");
            }
        }

        vm.export = function () {

            vm.exportdata();
        }
        vm.exportdata = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;

            if ((new Date(criteria.StartDate) <= new Date(criteria.EndDate)) || ((criteria.StartDate==null) || (criteria.EndDate==null))) {
                if (criteria.Csvfrom < criteria.CsvTo) {
                    if (criteria.Csvfrom == 0 || criteria.CsvTo == 0) {
                        alert("Csvfrom and CsvTo should not be zero");
                    }
                    else {
                        criteria.Csvfrom = criteria.Csvfrom - 1;
                        UserService.ExportUserWallet(criteria);
                    }
                }
                else {
                    alert("Csvfrom should not be greater than CsvTo");
                }

            }
            else {
                alert("Start date should not be greater than end date");
            }
        }
        vm.search();
        //#endregion
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('UserTransactionController', UserTransactionController);

    /** @ngInject */
    function UserTransactionController(UserService, $scope, $stateParams, $numUtils) {
        var vm = this;

        //#region Search transaction for user
        vm.criteria = {
            UserId: $stateParams.id,
            TransactionAction: null,
            Page: 1,
            Length: 20
        };

        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 3;
        vm.IsReverse = false;
        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        };

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            UserService.GetTransaction(criteria).then(function (data) {
                vm.transactions = data.Items;

                var tempTrans = [];
                // Rounding 2 decimal
                angular.forEach(vm.transactions, function (trans) {
                    var temp = angular.copy(trans);
                    temp.Amount = $numUtils.toFixed(temp.Amount);
                    temp.Kiplekash = $numUtils.toFixed(temp.Kiplekash);
                    temp.StoreCard = $numUtils.toFixed(temp.StoreCard);
                    temp.Cash = $numUtils.toFixed(temp.Cash);
                    temp.KiplekashCashback = $numUtils.toFixed(temp.KiplekashCashback);
                    temp.StoreCardCashback = $numUtils.toFixed(temp.StoreCardCashback);

                    tempTrans.push(temp);
                }, tempTrans);

                vm.transactions = tempTrans;

                vm.totalItems = data.Total;
            });
        }
        vm.sort = function (sortId) {
            vm.sortParam = sortId;
            if (vm.IsReverse) {
                vm.IsReverse = false;
            }
            else {
                vm.IsReverse = true;
            }

        };  

        vm.Download = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            UserService.ExportUserTransaction(criteria);
        }
        vm.search();
        //#endregion
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('UserStoreCardController', UserStoreCardController);

    /** @ngInject */
    function UserStoreCardController(UserService, $scope, $stateParams, $numUtils) {
        var vm = this;

        //#region Search transaction for user
        vm.criteria = {
            UserId: $stateParams.id,
            Page: 1,
            Length: 10,
            Csvfrom: 1,
            CsvTo: 1000,
            StartDate: null,
            EndDate: null
        };
        vm.user = {
            UserName: "",
            WalletId: "",
            StoreCardBalance: ""
        }
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 3;
        vm.ItemsCount = 0;
        vm.resetPage = function () {
            vm.criteria = {
                UserId: $stateParams.id,
                Page: 1,
                Length: 10,
                Csvfrom: 1,
                CsvTo: 1000,
                StartDate: null,
                EndDate: null
            };

            vm.search();
        }
        vm.reset = function () {
            vm.search();
        }
        vm.searchPagination = function () {
            vm.search();
        }
        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            if ((new Date(criteria.StartDate) <= new Date(criteria.EndDate)) || ((criteria.StartDate == null) || (criteria.EndDate == null))) {
                UserService.GetStoreCardTransaction(criteria).then(function (data) {
                    vm.transactions = data.Items.WalletTransaction;
                    if (data.Items.WalletTransaction != null) {
                        vm.user.UserName = data.Items.UserName;
                        vm.user.WalletId = data.Items.WalletId;
                    }
                    vm.user.StoreCardBalance = $stateParams.balance;
                    var tempTrans = [];
                    // Rounding 2 decimal
                    angular.forEach(vm.transactions, function (trans) {
                        var temp = angular.copy(trans);
                        temp.Amount = $numUtils.toFixed(temp.Amount);
                        temp.In = $numUtils.toFixed(temp.In);
                        temp.Out = $numUtils.toFixed(temp.Out);
                        temp.Balance = $numUtils.toFixed(temp.Balance);
                        temp.Fee = $numUtils.toFixed(temp.Fee);
                        tempTrans.push(temp);
                    }, tempTrans);

                    vm.transactions = tempTrans;

                    vm.totalItems = data.Total;
                    vm.ItemsCount = data.Total;
                });
            }
            else {
                alert("Start date should not be greater than end date");
            }
        }
        vm.search();

        vm.export = function () {

            vm.exportdata();
        }
        vm.exportdata = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            if ((new Date(criteria.StartDate) <= new Date(criteria.EndDate)) || ((criteria.StartDate == null) || (criteria.EndDate == null))) {
                if (criteria.Csvfrom < criteria.CsvTo) {
                    if (criteria.Csvfrom == 0 || criteria.CsvTo == 0) {
                        alert("Csvfrom or CsvTo should not be zero");
                    }
                    else {
                        criteria.Csvfrom = criteria.Csvfrom - 1;
                        UserService.ExportUserStorecard(criteria);
                        if (criteria.StartDate == null) {
                            vm.criteria.StartDate = criteria.StartDate
                        }
                        else {
                            vm.criteria.StartDate = new Date(criteria.StartDate);
                        }

                        if (criteria.EndDate == null) {
                            vm.criteria.EndDate = criteria.EndDate
                        }
                        else {
                            vm.criteria.EndDate = new Date(criteria.EndDate);
                        }
                    }
                }
                else {
                    alert("Csvfrom should not be greater than CsvTo");
                }
            }
            else {
                alert("Start date should not be greater than end date");
            }
        }
        //#endregion
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('UserKipleKashController', UserKipleKashController);

    /** @ngInject */
    function UserKipleKashController(UserService, $scope, $stateParams, $numUtils) {
        var vm = this;

        //#region Search transaction for user
        vm.criteria = {
            UserId: $stateParams.id,
            Page: 1,
            Length: 10,
            Csvfrom: 1,
            CsvTo: 1000,
            StartDate: null,
            EndDate:null
        };
        vm.user = {
            UserName: "",
            WalletId: "",
            KiplekashBalance: ""
        }
       
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 3;
        vm.ItemsCount = 0;
        vm.reset = function () {
            vm.search();
        }
        vm.resetPage = function () {
            vm.criteria = {
                UserId: $stateParams.id,
                Page: 1,
                Length: 10,
                Csvfrom: 1,
                CsvTo: 1000,
                StartDate: null,
                EndDate: null
            };

            vm.search();
        }
        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            
            if ((new Date(criteria.StartDate) <= new Date(criteria.EndDate)) || ((criteria.StartDate == null) || (criteria.EndDate == null))) {
                UserService.GetKipleKashTransaction(criteria).then(function (data) {
                    vm.transactions = data.Items.WalletTransaction;
                    if (data.Items.UserName != null) {
                        vm.user.UserName = data.Items.UserName;
                        vm.user.WalletId = data.Items.WalletId;
                    }
                    vm.user.KiplekashBalance = $stateParams.balance;
                    var tempTrans = [];
                    // Rounding 2 decimal
                    angular.forEach(vm.transactions, function (trans) {
                        var temp = angular.copy(trans);
                        temp.Amount = $numUtils.toFixed(temp.Amount);
                        temp.In = $numUtils.toFixed(temp.In);
                        temp.Out = $numUtils.toFixed(temp.Out);
                        temp.Balance = $numUtils.toFixed(temp.Balance);
                        temp.Fee = $numUtils.toFixed(temp.Fee);
                        tempTrans.push(temp);
                    }, tempTrans);

                    vm.transactions = tempTrans;

                    vm.totalItems = data.Total;
                    vm.ItemsCount = data.Total;
                    if (criteria.StartDate == null) {
                        vm.criteria.StartDate = criteria.StartDate
                    }
                    else {
                        vm.criteria.StartDate = new Date(criteria.StartDate);
                    }

                    if (criteria.EndDate == null) {
                        vm.criteria.EndDate = criteria.EndDate
                    }
                    else {
                        vm.criteria.EndDate = new Date(criteria.EndDate);
                    }

                });
            }
            else {
                alert("Start date should not be greater than end date");
            }
        }

        vm.export = function () {

            vm.exportdata();
        }

        vm.searchPagination = function () {
            vm.search();
        }
        vm.exportdata = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;

            if ((new Date(criteria.StartDate) <= new Date(criteria.EndDate)) || ((criteria.StartDate == null) || (criteria.EndDate == null))) {
                if (criteria.Csvfrom < criteria.CsvTo) {
                    if (criteria.Csvfrom == 0 || criteria.CsvTo == 0) {
                        alert("Csvfrom or CsvTo should not be zero");
                    }
                    else {
                        criteria.Csvfrom = criteria.Csvfrom - 1;
                        UserService.ExportUserKiplekash(criteria);
                    }
                }
                else {
                    alert("Csvfrom should not be greater than CsvTo");
                }
            }
            else {
                alert("Start date should not be greater than end date");
            }
        }



        vm.search();
        //#endregion
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('UserDetailController', UserDetailController);
    let eWageEmp;
    let eResiAddr;
    let newPhoneNumber;
    let newEmail;
    /** @ngInject */
    function UserDetailController(UserService, $scope, $stateParams, AuthenticationService) {
        var vm = this;
        vm.Tag = localStorage.getItem('apptype');
        UserService.Get($stateParams.id).then(function (res) {
            vm.user = res;
            eWageEmp = vm.user.EWagesEmployer;
            newPhoneNumber = vm.user.MobileNumber;
            eResiAddr = vm.user.ResidentalAddress;
            newEmail = vm.user.Email;
        });

        vm.edit = function () {
            vm.viewConfig.ShowEmployerDialog = true;
            $('#eWagesEmployer1').val(eWageEmp);
        }

        vm.editPhoneNumber = function () {
            vm.viewConfig.ShowPhoneNumberDialog = true;
        }

        vm.editEmail = function () {
            vm.viewConfig.ShowEmailDialog = true;
        }

        vm.editAddress = function () {
            vm.viewConfig.ShowResidentialDialog = true;
            $('#ResidentialAddress1').val(eResiAddr);
        }
        vm.save = function () {
        var updateEWageEmp = {
            id: vm.user.WalletId,
            eWagesEmployer: $("#eWagesEmployer1").val(),
        }
        UserService.UpdateEWagesEmployer(updateEWageEmp).then(function () {
            vm.updateEmployer(vm.user.WalletId);
            eWageEmp = $("#eWagesEmployer1").val();
            vm.user.EWagesEmployer = eWageEmp;
        });
        vm.viewConfig.ShowEmployerDialog = false;
        }
        vm.saveResidentialAddress = function () {
        var updateAddress = {
            AccountId: vm.user.WalletId,
            ResidentalAddress: $("#ResidentialAddress1").val(),
        }
        UserService.UpdateAddress(updateAddress).then(function () {
            vm.updateEmployer(vm.user.WalletId);
            eResiAddr = $("#ResidentialAddress1").val();
            vm.user.ResidentalAddress = eResiAddr;
        });
        vm.viewConfig.ShowResidentialDialog = false;
        }
        vm.savePhoneNumber = function () {
        var updatPhone = {
            AccountId: vm.user.Id,
            PhoneNumber: $("#PhoneNumberUpdate").val(),
            OldPhoneNumber: vm.user.MobileNumber,
        }
        AuthenticationService.UpdatePhoneNumber(updatPhone).then(function () {
            vm.updateEmployer(vm.user.Id);
            newPhoneNumber = $("#PhoneNumberUpdate").val();
            UserService.Get($stateParams.id).then(function (res) {
            vm.user = res;
            vm.viewConfig.ShowPhoneNumberDialog = false;
            });
        });
        vm.viewConfig.ShowEmployerDialog = false;
        }
        vm.isValidEmail = function (email) {
        var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
        }
        vm.saveEmail = function () {
        var validEmail = vm.isValidEmail($("#EmailUpdate").val());
        if (validEmail) {
            var updatEmail = {
            AccountId: vm.user.Id,
            Email: $("#EmailUpdate").val(),
            OldPhoneNumber: vm.user.MobileNumber,
            }
            AuthenticationService.UpdatePhoneNumber(updatEmail)
            .then(function () {
                vm.updateEmployer(vm.user.Id);
                newEmail = $("#EmailUpdate").val();
                UserService.Get($stateParams.id).then(function (res) {
                vm.user = res;
                vm.viewConfig.ShowEmailDialog = false;
                alert("Email updated successfully!");
                });
            })
            .catch(function (error) {
                var errorMessage = "Failed to update email. Please try again.";

                try {
                var possibleSources = [
                    error && error.data,
                    error && error.response && error.response.data,
                    error && error.message,
                    error && error.statusText,
                    error && error.toString(),
                ];

                for (var i = 0; i < possibleSources.length; i++) {
                    var source = possibleSources[i];
                    if (!source) continue;

                    if (typeof source === "string") {
                    var jsonStart = source.indexOf("{");
                    var jsonEnd = source.lastIndexOf("}");

                    if (jsonStart !== -1 && jsonEnd !== -1) {
                        var jsonString = source.substring(jsonStart, jsonEnd + 1);

                        try {
                        var errorData = JSON.parse(jsonString);

                        if (errorData.Message) {
                            errorMessage = errorData.Message;
                            break;
                        }
                        } catch (parseError) {
                        }
                    }
                    }
                    else if (typeof source === "object" && source.Message) {
                    errorMessage = source.Message;
                    break;
                    }
                }
                } catch (e) {
                }

                alert("Error: " + errorMessage);
            });
            } else {
                alert("Invalid Email Format");
                $('#EmailUpdate').val("")
                return;
            }
        }


        vm.cancel = function () {
            vm.user.EWagesEmployer = eWageEmp;
            vm.user.ResidentalAddress = eResiAddr;
            vm.user.MobileNumber = newPhoneNumber;
            vm.user.Email = newEmail;
            vm.viewConfig.ShowEmployerDialog = false;
            vm.viewConfig.ShowPhoneNumberDialog = false;
            vm.viewConfig.ShowResidentialDialog = false;
            vm.viewConfig.ShowEmailDialog = false;
        }

        vm.updateEmployer = function (id) {
            vm.user.EWagesEmployer = vm.user.EWagesEmployer;
        }
        vm.unBind = function (Id) {
            UserService.unBind(vm.user.WalletId).then(function (res) {
                if (res.data == true) {
                    alert("User unbinded from RewardsLink Successfully!");
                    $("#idRewardLinkStatus").html('-');
                }
                else {
                    alert("Something went wrong. Please try again.");
                }
            });
            vm.viewConfig.ShowEmployerDialog = false;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('UserController', UserController);

    /** @ngInject */
    function UserController(UserService, $scope, UserStatusHashMap, DTOptionsBuilder, DTColumnBuilder, $filter, $q, $numUtils) {
        var vm = this;
        vm.UserStatusHashMap = UserStatusHashMap;
        vm.tableInstanc = {};
        var loc = window.location;
        vm.Tag = localStorage.getItem('apptype');
        if (loc.pathname.indexOf('/admin/user/user/detail/') == -1) {
            if (loc.pathname.indexOf('/admin/user/user/wallet/') == -1) {
                if (loc.pathname.indexOf('/admin/user/user/storecard/') == -1) {
                    if (loc.pathname.indexOf('/admin/user/user/transaction/') == -1) {
                        if (loc.pathname.indexOf('/admin/user/user/kiplekash/') == -1) {
                            localStorage.setItem("UserSearchCriteria", "");
                        }
                    }
                }
            }
        }
      
        //#region Search user
        vm.criteria = {
            Name: null,
            EmailAddress: null,
            Status: null,
            UserName: null,
            PhoneNumber: null,
            Tag: null,
            Page: 1,
            Length: 10,
            Csvfrom: 1,
            CsvTo: 1000,
            //StartDate: null,
            //EndDate: null,
            Email: null,
            ICPassport: null,
            EDDStatus: null,
            VIPStatus: null,
        };
        vm.EmailToSend = null;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 3;
        vm.ItemsCount = 0;
        vm.resetPage = function () {
            vm.criteria = {
                Name: null,
                EmailAddress: null,
                Status: null,
                UserName: null,
                PhoneNumber: null,
                Tag: null,
                Page: 1,
                Length: 10,
                Csvfrom: 1,
                CsvTo: 1000,
                //StartDate: null,
                //EndDate: null,
                Email: null,
                ICPassport:null,
                EDDStatus: null,
                VIPStatus: null,
            };
            localStorage.setItem("UserSearchCriteria", "");
            vm.search();
        }
        vm.TransactionStatus = [

           
            { "Id": 0, "Name": "InActive" },
            { "Id": 1, "Name": "Active" },
            { "Id": 2, "Name": "Suspended" },
            { "Id": 3, "Name": "Closed" },
            { "Id": 4, "Name": "Locked" }


        ];

        vm.AppType = [
            { "Id": 0, "Name": "KiplePay" },
            { "Id": 1, "Name": "KiplePark" },
            { "Id": 5, "Name": "RedPay" },
            { "Id": 2, "Name": "TBFX" },
            { "Id": 4, "Name": "LineClear" }
        ];

        vm.VIPStatus = [
            { "Id": 0, "Name": "VIP" },
            { "Id": 1, "Name": "Non VIP" },
        ];

        vm.EDDStatus = [
            { "Id": 0, "Name": "Approved" },
            { "Id": 1, "Name": "Rejected" },
            { "Id": 2, "Name": "Under Review" },
            { "Id": 3, "Name": "Not EDD" },
        ];

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                localStorage.setItem("UserSearchCriteria", "");
                vm.search();
            }
        };

        vm.searchPagination = function () {
            localStorage.setItem("UserSearchCriteria", "");
            vm.search();
        }
        
      
        vm.search = function () {
         //   if ((new Date(vm.criteria.StartDate) <= new Date(vm.criteria.EndDate)) || ((vm.criteria.StartDate == null) || (vm.criteria.EndDate == null))) {
                if (localStorage.getItem("UserSearchCriteria") == "") {
                    var criteria = vm.criteria;
                    criteria.Page = vm.currentPage;
                }
                else {
                    var criteria = JSON.parse(localStorage.getItem('UserSearchCriteria'));

                }

                UserService.Search(criteria).then(function (data) {
                    vm.EmailToSend = null;
                    localStorage.setItem("UserSearchCriteria", JSON.stringify(criteria));
                    vm.users = data.Items;
                    vm.totalItems = data.Total;
                    vm.ItemsCount = data.Total;
                    //vm.criteria = {
                    //    Name: criteria.Name,
                    //    EmailAddress: criteria.EmailAddress,
                    //    Status: criteria.Status,
                    //    UserName: criteria.UserName,
                    //    PhoneNumber: criteria.PhoneNumber,
                    //    Tag: criteria.Tag,
                    //    Page: criteria.Page,
                    //    Length: criteria.Length,
                    //    Csvfrom: criteria.Csvfrom,
                    //    CsvTo: criteria.CsvTo
                    //};
                    vm.criteria = criteria;
                    //if (criteria.StartDate == null) {
                    //    vm.criteria.StartDate = criteria.StartDate
                    //}
                    //else {
                    //    vm.criteria.StartDate = new Date(criteria.StartDate);
                    //}

                    //if (criteria.EndDate == null) {
                    //    vm.criteria.EndDate = criteria.EndDate
                    //}
                    //else {
                    //    vm.criteria.EndDate = new Date(criteria.EndDate);
                    //}
             
                    vm.currentPage = criteria.Page;
                });
            //} 
            //else {
            //    alert("Start date should not be greater than end date");
            //}
        }

        vm.reset = function () {
            localStorage.setItem("UserSearchCriteria", "");
            vm.search();
        }

        vm.export = function () {

            vm.exportdata();
        }
        vm.exportdata = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            //if ((new Date(criteria.StartDate) <= new Date(criteria.EndDate)) || ((criteria.StartDate == null) || (criteria.EndDate == null))) {
                if (criteria.Csvfrom < criteria.CsvTo) {
                    if (criteria.Csvfrom == 0 || criteria.CsvTo == 0) {
                        alert("Csvfrom or CsvTo should not be zero");
                    }
                    else {
                        criteria.Csvfrom = criteria.Csvfrom - 1;
                        UserService.ExportUser(criteria);
                    }
                }
                else {
                    alert("Csvfrom should not be greater than CsvTo");
                }
            //}
            //else {
            //    alert("Start date should not be greater than end date");
            //}
          
        }
        vm.unBlock = function (user) {
            UserService.Unblock(user.Id).then(function () {
                user.Status = 'Active';
            })
        }
        vm.resetPassword = function (user) {
            UserService.ResetPassword(user.Id).then(function (data) {
                alert("Password Sent successfully");
            })
        }
        vm.search();

        vm.cancel = function () {
            vm.viewConfig.ShowDialogTest = false;
            vm.EmailToSend = null;

        };
        vm.OpenMailModel = function () {
            vm.viewConfig.ShowDialogTest = true;
            vm.EmailToSend = null;
        }
        vm.sendmail = function () {
            var criteria = vm.criteria;
            criteria.Email = vm.EmailToSend;
            criteria.Csvfrom = criteria.Csvfrom - 1;
          //  if ((new Date(criteria.StartDate) <= new Date(criteria.EndDate)) || ((criteria.StartDate == null) || (criteria.EndDate == null))) {
                UserService.SendToEmail(criteria).then(function (res) {
                });
                vm.viewConfig.ShowDialogTest = false;
            //} else {
            //    alert("Start date should not be greater than end date");
            //}
           // vm.criteria.Email = null;
        }
      
        //#endregion
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('TierSettingDetailController', TierSettingDetailController);

    /** @ngInject */
    function TierSettingDetailController(SVCS, $translate, TierSettingService, $stateParams, $scope, $timeout, $state) {
        var vm = this;
       
        vm.tier = {
            Name: null,
            AnnualFee: 0,
            POSAndroidTerminalsThreshold: 0,
            POSAndroidTerminalsAmount: 0.0,
            UserReferralFee: 0.0,
            MDRThreshold: 0.0,
            MDRAdditionalAmount: 0.0,
            MDRActiveDay: 0.0,
            ConcurrentPromos: 0,
            ConcurrentDealVouchers: 0,
            MinimumCashBackRequired: 0.0,
            DealVoucherCommission: 0.0,
            CashBackMatching: 0.0,
            FeaturedMerchantListing: 0,
            DealVoucherEDMBlastAmount: 0,
            DealVoucherEDMBlastMonthThreshold: 0,
            PopupNotifications: 0.0,
            FeaturedMerchantEmailAmount: 0,
            FeaturedMerchantEmailMonthsThreshold: 0,
            RegisterationCodes: false,
            SalesReports: false,
            MarketingCampaignReports: false,
            OnlineWebPortal: false,
            RevenueShare: false,
            RevenueShareOptions: [
                {
                    PercentNumber: 0,
                    Months: 0
                }
            ],
            MdrTierSettingOptions: [],
            TopupFPXMDR: 0,
            TopupCreditCardMDR: 0,
            RevenueShareDailyReport: false,
            RevenueShareMonthlyReport: false,
            MonthlyDateReport: null,
            DailyDateReport: null,
            TopupCreditCardMDRFixed: 0,
            TopupFPXMDRFixed: 0,
            FixedMDRAdditionalAmount: 0,
            MdrOptionType: 1,
            TopupFPXType: 1,
            TopupCreditCardMDRType: 1,
            MdrType: 1,
            CreditCardPaymentMdr: 1,
            DebitCardPaymentMdr: 1,
            ForeignCardPaymentMdr:1,
            CreditCardPaymentMDRValue: 0,
            DebitCardPaymentMDRValue: 0,
            ForeignCardPaymentMDRValue: 0,
            CreditCardRevenueShareValue: 0,
            DebitCardRevenueShareValue: 0,
            ForeignCardRevenueShareValue: 0,
            TnGPaymentOption:1,
            GrabPayPaymentOption: 1,
            BoostPaymentOption: 1,
            WeChatPaymentOption: 1,
            AlipayPaymentOption: 1,
            MayBankPaymentOption: 1,
            RazerPayPaymentOption: 1,
            WechatIntPaymentOption: 1,
            AlipayIntPayPaymentOption: 1,
            TNGMDRValue: 0,
            TNGRevenueShareValue: 0,
            GrabPayMDRValue: 0,
            GrabPayRevenueShareValue: 0,
            BoostPaymentMDRValue: 0,
            BoostRevenueShareValue: 0,
            WechatPaymentMDRValue: 0,
            WeChatRevenueShareValue: 0,
            AlipayPaymentMDRValue: 0,
            AlipayRevenueShareValue: 0,
            MayBankPaymentMDRValue: 0,
            MayBankRevenueShareValue: 0,
            RazerPayPaymentMDRValue: 0,
            RazerPayRevenueShareValue: 0,
            WechatIntPaymentMDRValue: 0,
            WechatIntRevenueShareValue: 0,
            AlipayIntyPaymentMDRValue: 0,
            AlipayIntRevenueShareValue: 0,
            SelangkahWalletPaymentOption: 1,
            SelangkahWalletPaymentMDRValue: 0,
            SelangkahWalletRevenueShareValue: 0,
            DuitNowPaymentOption: 1,
            DuitNowPaymentMDRValue: 0,
            DuitNowRevenueShareValue: 0,
            LDRShareRate: 0
        }

        vm.topupFPXMDRoptionList = [
            { Id: 1, Name: "Percentage" },
            { Id: 2, Name: "Fixed" },
            { Id: 3, Name: "Whichever higher" }]

        vm.MdrOptionTypeList = [
            { Id: 1, Name: "Percentage" },
            { Id: 2, Name: "Fixed" }]

        vm.daysOfMonth = [
            { Id: "1", Name: "1" },
            { Id: "2", Name: "2" },
            { Id: "3", Name: "3" },
            { Id: "4", Name: "4" },
            { Id: "5", Name: "5" },
            { Id: "6", Name: "6" },
            { Id: "7", Name: "7" },
            { Id: "8", Name: "8" },
            { Id: "9", Name: "9" },
            { Id: "10", Name: "10" },
            { Id: "11", Name: "11" },
            { Id: "12", Name: "12" },
            { Id: "13", Name: "13" },
            { Id: "14", Name: "14" },
            { Id: "15", Name: "15" },
            { Id: "16", Name: "16" },
            { Id: "17", Name: "17" },
            { Id: "18", Name: "18" },
            { Id: "19", Name: "19" },
            { Id: "20", Name: "20" },
            { Id: "21", Name: "21" },
            { Id: "22", Name: "22" },
            { Id: "23", Name: "23" },
            { Id: "24", Name: "24" },
            { Id: "25", Name: "25" },
            { Id: "26", Name: "26" },
            { Id: "27", Name: "27" },
            { Id: "28", Name: "28" },
            { Id: "29", Name: "29" },
            { Id: "30", Name: "30" },
            { Id: "31", Name: "31" },
        ];

        vm.hours = [
            { Id: "00", Name: "00" },
            { Id: "01", Name: "01" },
            { Id: "02", Name: "02" },
            { Id: "03", Name: "03" },
            { Id: "04", Name: "04" },
            { Id: "05", Name: "05" },
            { Id: "06", Name: "06" },
            { Id: "07", Name: "07" },
            { Id: "08", Name: "08" },
            { Id: "09", Name: "09" },
            { Id: "10", Name: "10" },
            { Id: "11", Name: "11" },
            { Id: "12", Name: "12" },
            { Id: "13", Name: "13" },
            { Id: "14", Name: "14" },
            { Id: "15", Name: "15" },
            { Id: "16", Name: "16" },
            { Id: "17", Name: "17" },
            { Id: "18", Name: "18" },
            { Id: "19", Name: "19" },
            { Id: "20", Name: "20" },
            { Id: "21", Name: "21" },
            { Id: "22", Name: "22" },
            { Id: "23", Name: "23" }
        ];

        vm.mins = [
            { Id: "00", Name: "00" },
            { Id: "01", Name: "01" },
            { Id: "02", Name: "02" },
            { Id: "03", Name: "03" },
            { Id: "04", Name: "04" },
            { Id: "05", Name: "05" },
            { Id: "06", Name: "06" },
            { Id: "07", Name: "07" },
            { Id: "08", Name: "08" },
            { Id: "09", Name: "09" },
            { Id: "10", Name: "10" },
            { Id: "11", Name: "11" },
            { Id: "12", Name: "12" },
            { Id: "13", Name: "13" },
            { Id: "14", Name: "14" },
            { Id: "15", Name: "15" },
            { Id: "16", Name: "16" },
            { Id: "17", Name: "17" },
            { Id: "18", Name: "18" },
            { Id: "19", Name: "19" },
            { Id: "20", Name: "20" },
            { Id: "21", Name: "21" },
            { Id: "22", Name: "22" },
            { Id: "23", Name: "23" },
            { Id: "24", Name: "24" },
            { Id: "25", Name: "25" },
            { Id: "26", Name: "26" },
            { Id: "27", Name: "27" },
            { Id: "28", Name: "28" },
            { Id: "29", Name: "29" },
            { Id: "30", Name: "30" },
            { Id: "31", Name: "31" },
            { Id: "32", Name: "32" },
            { Id: "33", Name: "33" },
            { Id: "34", Name: "34" },
            { Id: "35", Name: "35" },
            { Id: "36", Name: "36" },
            { Id: "37", Name: "37" },
            { Id: "38", Name: "38" },
            { Id: "39", Name: "39" },
            { Id: "40", Name: "40" },
            { Id: "41", Name: "41" },
            { Id: "42", Name: "42" },
            { Id: "43", Name: "43" },
            { Id: "44", Name: "44" },
            { Id: "45", Name: "45" },
            { Id: "46", Name: "46" },
            { Id: "47", Name: "47" },
            { Id: "48", Name: "48" },
            { Id: "49", Name: "49" },
            { Id: "50", Name: "50" },
            { Id: "51", Name: "51" },
            { Id: "52", Name: "52" },
            { Id: "53", Name: "53" },
            { Id: "54", Name: "54" },
            { Id: "55", Name: "55" },
            { Id: "56", Name: "56" },
            { Id: "57", Name: "57" },
            { Id: "58", Name: "58" },
            { Id: "59", Name: "59" },
        ];

        vm.monthly = {
            day: null,
            hour: null,
            min: null
        };

        vm.daily = {
            hour: null,
            min: null
        };

        vm.removeOption = function (index) {
            vm.tier.RevenueShareOptions.splice(index, 1);
        }

        vm.removeLast = function () {
            vm.tier.RevenueShareOptions = [
                {
                    PercentNumber: 0,
                    Months: 0
                }
            ];
        }

        vm.addNew = function () {
            vm.tier.RevenueShareOptions.push(
                {
                    PercentNumber: 0,
                    Months: 0
                }
            );

        }
        vm.AmountChange = function (index) {



            if (index != 0) {
                var ThresholdToValue = vm.tier.MdrTierSettingOptions[index].MaxThreshold;
                var ThresholdFromValue = vm.tier.MdrTierSettingOptions[index - 1].MaxThreshold;
                if (ThresholdToValue < ThresholdFromValue) {

                    alert("Please give amount greater than threshold from value");
                    vm.tier.MdrTierSettingOptions[index].MaxThreshold = 0;
                    vm.tier.MdrTierSettingOptions[index + 1].MaxThreshold = 0;
                }
                else {
                    vm.tier.MdrTierSettingOptions[index + 1].MaxThreshold = ThresholdToValue;

                }

            }


        }
        vm.removeThresholdOption = function (index) {
            vm.tier.MdrTierSettingOptions.splice(index, 1);

            var len = vm.tier.MdrTierSettingOptions.length;

            var Items = vm.tier.MdrTierSettingOptions;
            vm.tier.MdrTierSettingOptions = [];
            if (len >= 1) {
                vm.disabledMDRActiveDay = true;
                vm.disabledMDRThreshold = true;
                vm.DisableMDRAdditionalAmount = true;
                vm.DisableMdrOptionType = true;
            }
            else {
                vm.disabledMDRActiveDay = false;
                vm.disabledMDRThreshold = false;
                vm.DisableMDRAdditionalAmount = false;
                vm.DisableMdrOptionType = false;
            }
            for (var i = 0; i < len; i++) {
                if (i == 3) {
                    if (len == 4) {
                        vm.tier.MdrTierSettingOptions.push({
                            ForThreshold: ">=",
                            MaxThreshold: Items[2].MaxThreshold,
                            MDRValue: Items[2].MDRValue
                        });
                        vm.disabledMaxThreshold0 = true;
                        vm.disabledMaxThreshold1 = true;
                        vm.disabledMaxThreshold2 = false;
                        vm.disabledMaxThreshold3 = true;

                    }
                    else {
                        vm.tier.MdrTierSettingOptions.push({
                            ForThreshold: ">= " + Items[2].MaxThreshold + " <",
                            MaxThreshold: Items[3].MaxThreshold,
                            MDRValue: Items[3].MDRValue
                        });
                    }

                }
                if (i == 2) {
                    if (len == 3) {
                        vm.tier.MdrTierSettingOptions.push({
                            ForThreshold: ">=",
                            MaxThreshold: Items[1].MaxThreshold,
                            MDRValue: Items[1].MDRValue
                        });
                        vm.disabledMaxThreshold0 = true;
                        vm.disabledMaxThreshold1 = false;
                        vm.disabledMaxThreshold2 = true;
                    }
                    else {
                        vm.tier.MdrTierSettingOptions.push({
                            ForThreshold: ">= " + Items[1].MaxThreshold + " <",
                            MaxThreshold: Items[2].MaxThreshold,
                            MDRValue: Items[2].MDRValue
                        });
                    }

                }
                if (i == 1) {
                    if (len == 2) {
                        vm.tier.MdrTierSettingOptions.push({
                            ForThreshold: ">=",
                            MaxThreshold: Items[0].MaxThreshold,
                            MDRValue: Items[0].MDRValue
                        });
                        vm.disabledMaxThreshold0 = false;
                        vm.disabledMaxThreshold1 = true;
                    }
                    else {
                        vm.tier.MdrTierSettingOptions.push({
                            ForThreshold: ">= " + Items[0].MaxThreshold + " <",
                            MaxThreshold: Items[1].MaxThreshold,
                            MDRValue: Items[1].MDRValue
                        });
                    }

                }
                if (i == 0) {

                    vm.tier.MdrTierSettingOptions.push({
                        ForThreshold: "<",
                        MaxThreshold: Items[0].MaxThreshold,
                        MDRValue: Items[0].MDRValue
                    });
                    if (len == 1) {
                        vm.disabledMaxThreshold0 = false;
                    }
                }
            }

        }

        vm.addThreshold = function () {
            vm.tier.MdrOptionType = 1;

            vm.tier.MDRActiveDay = 0;
            vm.disabledMDRActiveDay = true;
            vm.disabledMDRThreshold = true;
            vm.DisableMDRAdditionalAmount = true;
            vm.DisableMdrOptionType = true;
            if (vm.tier.MdrTierSettingOptions.length < 5) {

                if (vm.tier.MdrTierSettingOptions.length != 0) {
                    //angular.forEach(vm.tier.mdrOptions, function (Field) {
                    var len = vm.tier.MdrTierSettingOptions.length;

                    if (len == 4) {
                        if (vm.tier.MdrTierSettingOptions[3].MaxThreshold != 0) {
                            if ((vm.tier.MdrTierSettingOptions[2].ForThreshold).indexOf('<') == -1) {
                                vm.tier.MdrTierSettingOptions.push({
                                    ForThreshold: ">=",
                                    MaxThreshold: vm.tier.MdrTierSettingOptions[3].MaxThreshold,
                                    MDRValue: 0
                                });
                                vm.disabledMaxThreshold0 = true;
                                vm.disabledMaxThreshold1 = true;
                                vm.disabledMaxThreshold2 = true;
                                vm.disabledMaxThreshold3 = false;
                                vm.disabledMaxThreshold4 = true;
                                vm.tier.MdrTierSettingOptions[3].ForThreshold = ">= " + vm.tier.MdrTierSettingOptions[2].MaxThreshold + " <"
                            }
                            else {
                                var splittedValue = vm.tier.MdrTierSettingOptions[2].ForThreshold.split(" ");
                                if (splittedValue[1] == vm.tier.MdrTierSettingOptions[2].MaxThreshold) {
                                    alert("Please give amount greater than threshold from value");
                                }
                                else if (vm.tier.MdrTierSettingOptions[3].ForThreshold == ">=") {
                                    if (vm.tier.MdrTierSettingOptions[2].MaxThreshold > vm.tier.MdrTierSettingOptions[3].MaxThreshold) {
                                        alert("Please give amount greater than threshold from value");
                                    }
                                    else {
                                        vm.tier.MdrTierSettingOptions.push({
                                            ForThreshold: ">=",
                                            MaxThreshold: vm.tier.MdrTierSettingOptions[3].MaxThreshold,
                                            MDRValue: 0
                                        });
                                        vm.disabledMaxThreshold0 = true;
                                        vm.disabledMaxThreshold1 = true;
                                        vm.disabledMaxThreshold2 = true;
                                        vm.disabledMaxThreshold3 = false;
                                        vm.disabledMaxThreshold4 = true;
                                        vm.tier.MdrTierSettingOptions[3].ForThreshold = ">= " + vm.tier.MdrTierSettingOptions[2].MaxThreshold + " <"
                                    }
                                }
                                else {
                                    vm.tier.MdrTierSettingOptions.push({
                                        ForThreshold: ">=",
                                        MaxThreshold: vm.tier.MdrTierSettingOptions[3].MaxThreshold,
                                        MDRValue: 0
                                    });
                                    vm.disabledMaxThreshold0 = true;
                                    vm.disabledMaxThreshold1 = true;
                                    vm.disabledMaxThreshold2 = true;
                                    vm.disabledMaxThreshold3 = false;
                                    vm.disabledMaxThreshold4 = true;
                                    vm.tier.MdrTierSettingOptions[3].ForThreshold = ">= " + vm.tier.MdrTierSettingOptions[2].MaxThreshold + " <"
                                }
                            }
                        }
                        else {
                            alert("Please Enter MDR Value should not be zero");
                        }
                    }
                    if (len == 3) {
                        if (vm.tier.MdrTierSettingOptions[2].MaxThreshold != 0) {
                            if ((vm.tier.MdrTierSettingOptions[1].ForThreshold).indexOf('<') == -1) {
                                vm.tier.MdrTierSettingOptions.push({
                                    ForThreshold: ">=",
                                    MaxThreshold: vm.tier.MdrTierSettingOptions[2].MaxThreshold,
                                    MDRValue: 0
                                });
                                vm.disabledMaxThreshold0 = true;
                                vm.disabledMaxThreshold1 = true;
                                vm.disabledMaxThreshold2 = true;
                                vm.disabledMaxThreshold3 = false;
                                vm.tier.MdrTierSettingOptions[2].ForThreshold = ">= " + vm.tier.MdrTierSettingOptions[1].MaxThreshold + " <"
                            }
                            else {
                                var splittedValue = vm.tier.MdrTierSettingOptions[1].ForThreshold.split(" ");
                                if (splittedValue[1] == vm.tier.MdrTierSettingOptions[1].MaxThreshold) {
                                    alert("Please give amount greater than threshold from value");
                                }
                                else if (vm.tier.MdrTierSettingOptions[2].ForThreshold == ">=") {
                                    if (vm.tier.MdrTierSettingOptions[1].MaxThreshold > vm.tier.MdrTierSettingOptions[2].MaxThreshold) {
                                        alert("Please give amount greater than threshold from value");
                                    }
                                    else {
                                        vm.tier.MdrTierSettingOptions.push({
                                            ForThreshold: ">=",
                                            MaxThreshold: vm.tier.MdrTierSettingOptions[2].MaxThreshold,
                                            MDRValue: 0
                                        });
                                        vm.disabledMaxThreshold0 = true;
                                        vm.disabledMaxThreshold1 = true;
                                        vm.disabledMaxThreshold2 = false;
                                        vm.disabledMaxThreshold3 = true;
                                        vm.tier.MdrTierSettingOptions[2].ForThreshold = ">= " + vm.tier.MdrTierSettingOptions[1].MaxThreshold + " <"
                                    }
                                }
                                else {
                                    vm.tier.MdrTierSettingOptions.push({
                                        ForThreshold: ">=",
                                        MaxThreshold: vm.tier.MdrTierSettingOptions[2].MaxThreshold,
                                        MDRValue: 0
                                    });
                                    vm.disabledMaxThreshold0 = true;
                                    vm.disabledMaxThreshold1 = true;
                                    vm.disabledMaxThreshold2 = false;
                                    vm.disabledMaxThreshold3 = true;
                                    vm.tier.MdrTierSettingOptions[2].ForThreshold = ">= " + vm.tier.MdrTierSettingOptions[1].MaxThreshold + " <"
                                }
                            }
                        }
                        else {
                            alert("Please Enter MDR Value should not be zero");
                        }
                    }
                    if (len == 2) {
                        if (vm.tier.MdrTierSettingOptions[1].MaxThreshold != 0) {
                            if ((vm.tier.MdrTierSettingOptions[1].ForThreshold).indexOf('<') != -1) {
                                vm.tier.MdrTierSettingOptions.push({
                                    ForThreshold: ">=",
                                    MaxThreshold: vm.tier.MdrTierSettingOptions[1].MaxThreshold,
                                    MDRValue: 0
                                });
                                vm.disabledMaxThreshold0 = true;
                                vm.disabledMaxThreshold1 = false;
                                vm.disabledMaxThreshold2 = true;
                                vm.tier.MdrTierSettingOptions[1].ForThreshold = ">= " + vm.tier.MdrTierSettingOptions[0].MaxThreshold + " <"
                            }
                            else {

                                if (vm.tier.MdrTierSettingOptions[1].ForThreshold == ">=") {
                                    if (vm.tier.MdrTierSettingOptions[0].MaxThreshold > vm.tier.MdrTierSettingOptions[1].MaxThreshold) {
                                        alert("Please give amount greater than threshold from value");
                                    }
                                    else {
                                        vm.tier.MdrTierSettingOptions.push({
                                            ForThreshold: ">=",
                                            MaxThreshold: vm.tier.MdrTierSettingOptions[1].MaxThreshold,
                                            MDRValue: 0
                                        });
                                        vm.disabledMaxThreshold0 = true;
                                        vm.disabledMaxThreshold1 = false;
                                        vm.disabledMaxThreshold2 = true;
                                        vm.tier.MdrTierSettingOptions[1].ForThreshold = ">= " + vm.tier.MdrTierSettingOptions[0].MaxThreshold + " <"
                                    }
                                }
                                //var splittedValue = vm.tier.MdrTierSettingOptions[1].ForThreshold.split(" ");

                                //if (splittedValue[1] == vm.tier.MdrTierSettingOptions[1].MaxThreshold) {
                                //    alert("Please Enter MDR Value");
                                //}


                            }

                        }
                        else {
                            alert("Please Enter MDR Value should not be zero");
                        }
                    }
                    if (len == 1) {
                        if (vm.tier.MdrTierSettingOptions[0].MaxThreshold != 0) {
                            if (vm.tier.MdrTierSettingOptions[0].MdrType != "undefined") {
                                vm.tier.MdrTierSettingOptions.push({
                                    ForThreshold: ">=",
                                    MaxThreshold: vm.tier.MdrTierSettingOptions[0].MaxThreshold,
                                    MDRValue: 0
                                });
                                vm.disabledMaxThreshold0 = true;
                                vm.disabledMaxThreshold1 = true;
                            }
                            else {
                                alert("Please Select MDR Type");
                            }
                        }
                        else {
                            alert("Please Enter MDR Value should not be zero");

                        }
                    }


                }
                else {
                    vm.tier.MdrTierSettingOptions.push({
                        ForThreshold: "<",
                        MaxThreshold: 0,
                        MDRValue: 0
                    });
                    vm.disabledMaxThreshold0 = false;
                }
            }
            else {
                alert("Allowed only 5 Options");

            }
        }

        vm.alertTitle = "Success!";
        vm.showMessage = false;
        vm.isSuccess = true;
        vm.doFade = false;

        vm.disabledMDR = false;
        vm.disabledMDRActiveDay = false;
        vm.disabledMDRThreshold = false;
        vm.DisableMDRAdditionalAmount = false;
        vm.FixedMDRAdditionalAmount = false;
        vm.DisableMdrOptionType = false;


        vm.viewConfig = { Action: null };

        vm.MonthlyDateReportTemp = null;
        vm.DailyDateReportTemp = null;
        vm.RevenueShareTemp = null;
        if ($stateParams.id != null) {
            TierSettingService.Get($stateParams.id).then(function (data) {
                vm.tier = data;



                if (vm.tier.RevenueShareOptions == null || vm.tier.RevenueShareOptions.length == 0) {
                    vm.tier.RevenueShareOptions = [
                        {
                            PercentNumber: 0,
                            Months: 0
                        }
                    ];
                }

                if (vm.tier.MdrTierSettingOptions.length > 0) {
                    vm.disabledMDRActiveDay = true;
                    vm.disabledMDRThreshold = true;
                    vm.DisableMDRAdditionalAmount = true;
                    vm.FixedMDRAdditionalAmount = true;
                    vm.DisableMdrOptionType = true;
                }
                else if (vm.tier.MDRActiveDay > 0) {
                    vm.disabledMDR = true;
                    vm.disabledMDRThreshold = true;
                    vm.disabledMDRActiveDay = false;
                    vm.DisableMDRAdditionalAmount = true;
                    vm.FixedMDRAdditionalAmount = true;
                    vm.DisableMdrOptionType = true;

                }
                else if (vm.tier.MDRThreshold > 0 || vm.tier.MDRAdditionalAmount > 0 || vm.tier.FixedMDRAdditionalAmount > 0) {
                    vm.disabledMDR = false;
                    vm.disabledMDRActiveDay = true;
                    vm.disabledMDRThreshold = false;
                    vm.DisableMDRAdditionalAmount = false;
                    vm.FixedMDRAdditionalAmount = false;
                    vm.DisableMdrOptionType = false;
                }

                var len = vm.tier.MdrTierSettingOptions.length;
                if (vm.tier.MdrOptionType == 0) {
                    vm.tier.MdrOptionType = 1;
                }
                if (len == 1) {
                    vm.disabledMaxThreshold0 = false;


                }
                else if (len == 2) {
                    vm.disabledMaxThreshold0 = false;
                    vm.disabledMaxThreshold1 = true;


                }
                else if (len == 3) {
                    vm.disabledMaxThreshold0 = true;
                    vm.disabledMaxThreshold1 = false;
                    vm.disabledMaxThreshold2 = true;

                }
                else if (len == 4) {
                    vm.disabledMaxThreshold0 = true;
                    vm.disabledMaxThreshold1 = true;
                    vm.disabledMaxThreshold2 = false;
                    vm.disabledMaxThreshold3 = true;
                }
                else {
                    vm.disabledMaxThreshold0 = true;
                    vm.disabledMaxThreshold1 = true;
                    vm.disabledMaxThreshold2 = true;
                    vm.disabledMaxThreshold3 = false;
                    vm.disabledMaxThreshold4 = true;
                }

                if (vm.tier.MonthlyDateReport != null) {
                    var monthly = vm.tier.MonthlyDateReport.split("-");
                    vm.monthly.day = monthly[0];
                    vm.monthly.hour = monthly[1];
                    vm.monthly.min = monthly[2];
                }

                if (vm.tier.DailyDateReport != null) {
                    var daily = vm.tier.DailyDateReport.split("-");
                    vm.daily.hour = daily[0];
                    vm.daily.min = daily[1];
                }

                vm.MonthlyDateReportTemp = vm.tier.MonthlyDateReport;
                vm.DailyDateReportTemp = vm.tier.DailyDateReport;
                vm.RevenueShareTemp = vm.tier.RevenueShare;
            })
        }

        vm.checkNull = function () {
            for (var prop in vm.tier) {
                if (vm.tier[prop] === null || vm.tier[prop] === undefined) {
                    vm.tier[prop] = 0;
                }
            }
        }

        vm.save = function () {
            var status = 0;
               if (vm.tier.TNGRevenueShareValue > vm.tier.TNGMDRValue) {
                   status = 1;
            }
            if (vm.tier.GrabPayRevenueShareValue > vm.tier.GrabPayMDRValue) {
                status = 1;
            }
            if (vm.tier.BoostRevenueShareValue > vm.tier.BoostPaymentMDRValue) {
                status = 1;
            }
            if (vm.tier.WeChatRevenueShareValue > vm.tier.WechatPaymentMDRValue) {
                status = 1;
            }
            if (vm.tier.AlipayRevenueShareValue > vm.tier.AlipayPaymentMDRValue) {
                status = 1;
            }
            if (vm.tier.MayBankRevenueShareValue > vm.tier.MayBankPaymentMDRValue) {
                status = 1;
            }
            if (vm.tier.RazerPayRevenueShareValue > vm.tier.RazerPayPaymentMDRValue) {
                status = 1;
            }
            if (vm.tier.WechatIntRevenueShareValue > vm.tier.WechatIntPaymentMDRValue) {
                status = 1;
            }
            if (vm.tier.AlipayIntRevenueShareValue > vm.tier.AlipayIntyPaymentMDRValue) {
                status = 1;
            }
            if (vm.tier.CreditCardRevenueShareValue > vm.tier.CreditCardPaymentMDRValue) {
                status = 1;
            }
            if (vm.tier.DebitCardRevenueShareValue > vm.tier.DebitCardPaymentMDRValue) {
                status = 1;
            }
            if (vm.tier.ForeignCardRevenueShareValue > vm.tier.ForeignCardPaymentMDRValue) {
                status = 1;
            }
            if (vm.tier.DuitNowRevenueShareValue > vm.tier.DuitNowPaymentMDRValue) {
                status = 1;
            }
            if (status == 1) {
                alert("Partner's MDR Share should not be higher than Merchant MDR");
            }
            if (status == 0) {
                vm.isSuccess = true;
                vm.alertTitle = "Success!";
                if (!$scope.tierForm.$valid) {
                    angular.forEach($scope.tierForm.$error, function (field) {
                        angular.forEach(field, function (errorField) {
                            errorField.$setTouched();
                        })
                    });
                    $('#tierForm .ng-invalid')[0].focus();
                    return;
                }

                if ($stateParams.id != null) {
                    if (vm.monthly.day != null && vm.monthly.hour != null && vm.monthly.min) {
                        vm.tier.MonthlyDateReport = vm.monthly.day + "-" + vm.monthly.hour + "-" + vm.monthly.min;
                    }
                    if (vm.daily.hour != null && vm.daily.min != null) {
                        vm.tier.DailyDateReport = vm.daily.hour + "-" + vm.daily.min;
                    }

                    if (vm.tier.MdrTierSettingOptions.length > 0) {
                        angular.forEach(vm.tier.MdrTierSettingOptions, function (Field) {

                            var splittedValue = Field.ForThreshold.split(" ");
                            if (splittedValue[1] == Field.MaxThreshold) {
                                status = 1;
                            }
                            else if (Field.MaxThreshold == 0) {
                                status = 1;
                            }

                        });
                    }
                    //else if (vm.tier.MDRThreshold<=0){
                    //    status = 2;
                    //}
                    if (status == 0) {
                        TierSettingService.Update(vm.tier).then(function (data) {
                            vm.tier = data;
                            $translate('admin.tierSetting.save_success').then(function (msg) {
                                vm.showAlert(msg);
                            })

                            var message = '';

                            if (vm.tier.RevenueShare && vm.RevenueShareTemp != vm.tier.RevenueShare) {
                                message = 'Please update the latest tier setting in Merchant Page.\r\nPlease update the service date in Merchant Page.';
                            }

                            if (vm.DailyDateReportTemp != vm.tier.DailyDateReport || vm.MonthlyDateReportTemp != vm.tier.MonthlyDateReport) {
                                message = 'Please update the latest tier setting in Merchant Page.';
                            }

                            if (message != '') {
                                alert(message);
                            }

                            $state.go('app.admin.tierSetting');
                        })
                    }
                    else {
                        if (status == 1) {
                            vm.showAlert("Please enter proper max transaction value");
                            vm.isSuccess = false;
                            vm.alertTitle = "Error: ";
                        }
                        else {
                            vm.showAlert("Please enter transaction value");
                            vm.isSuccess = false;
                            vm.alertTitle = "Error: ";
                        }
                    }
                }
                else {
                    if (vm.monthly.day != null && vm.monthly.hour != null && vm.monthly.min) {
                        vm.tier.MonthlyDateReport = vm.monthly.day + "-" + vm.monthly.hour + "-" + vm.monthly.min;
                    }
                    if (vm.daily.hour != null && vm.daily.min != null) {
                        vm.tier.DailyDateReport = vm.daily.hour + "-" + vm.daily.min;
                    }
                    if (vm.tier.MdrTierSettingOptions.length > 0) {
                        angular.forEach(vm.tier.MdrTierSettingOptions, function (Field) {

                            var splittedValue = Field.ForThreshold.split(" ");
                            if (splittedValue[1] == Field.MaxThreshold) {
                                status = 1;
                            }
                            else if (Field.MaxThreshold == 0) {
                                status = 1;
                            }

                        });
                    }
                    //else if (vm.tier.MDRThreshold <= 0) {
                    //    status = 2;
                    //}


                    if (status == 0) {
                        TierSettingService.Create(vm.tier).then(function (data) {
                            vm.tier = data;
                            $translate('admin.tierSetting.save_success').then(function (msg) {
                                vm.showAlert(msg);
                            })
                            $state.go('app.admin.tierSetting');
                        });
                    }
                    else {
                        if (status == 1) {
                            vm.showAlert("Please enter proper max transaction value");
                            vm.isSuccess = false;
                            vm.alertTitle = "Error: ";
                            //  vm.errorMessage = "Please enter proper max transaction value";
                            //  alert("Please enter proper max transaction value");
                            // return false;
                        }
                        else {
                            vm.showAlert("Please enter transaction value");
                            vm.isSuccess = false;
                            vm.alertTitle = "Error: ";
                            // vm.errorMessage = "Please enter transaction value";
                            //alert("Please enter transaction value");
                            //return false;
                        }
                    }
                }
            }
        }

        vm.cancel = function () {
            vm.viewConfig.ShowDialog = false;
            //vm.group = undefined;
            vm.Action = null;
        }

        vm.showAlert = function (message) {
            //reset
            vm.showMessage = false;
            vm.doFade = false;

            vm.showMessage = true;

            vm.errorMessage = message;

            $timeout(function () {
                vm.doFade = true;
            }, 2500);
        };

        vm.remove = function (tier) {
            $translate("admin.tierSetting.confirm_remove").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }
                TierSettingService.Remove(tier.Id).then(function (res) { vm.tierSetting.removeItem(tier) });
            })
        }

        //vm.checkMDrRevnueshare = function () {

        //    //if (vm.tier.CreditCardRevenueShareValue > vm.tier.CreditCardPaymentMDRValue) {
        //    //    alert("Credit card Revenue share should not be higher than mdr value");
        //    //}
        //    //if (vm.tier.DebitCardRevenueShareValue > vm.tier.DebitCardPaymentMDRValue) {
        //    //    alert("Debit card Revenue share should not be higher than mdr value");
        //    //}
        //    //if (vm.tier.ForeignCardRevenueShareValue > vm.tier.ForeignCardPaymentMDRValue) {
        //    //    alert("Foreign card Revenue share should not be higher than mdr value");
        //    //}
        //    if (vm.tier.TNGRevenueShareValue > vm.tier.TNGMDRValue) {
        //        alert("TnG Revenue share should not be higher than mdr value");
        //        return false;
        //    }
        //    if (vm.tier.GrabPayRevenueShareValue > vm.tier.GrabPayMDRValue) {
        //        alert("Grab Revenue share should not be higher than mdr value");
        //        return false;
        //    }
        //    if (vm.tier.BoostRevenueShareValue > vm.tier.BoostPaymentMDRValue) {
        //        alert("Boost Revenue share should not be higher than mdr value");
        //        return false;
        //    }
        //    if (vm.tier.WeChatRevenueShareValue > vm.tier.WechatPaymentMDRValue) {
        //        alert("Wechat Revenue share should not be higher than mdr value");
        //        return false;
        //    }
        //    if (vm.tier.AlipayRevenueShareValue > vm.tier.AlipayPaymentMDRValue) {
        //        alert("Alipay Revenue share should not be higher than mdr value");
        //        return false;
        //    }
        //    if (vm.tier.MayBankRevenueShareValue > vm.tier.MayBankPaymentMDRValue) {
        //        alert("MayBank Revenue share should not be higher than mdr value");
        //        return false;
        //    }
        //    if (vm.tier.RazerPayRevenueShareValue > vm.tier.RazerPayPaymentMDRValue) {
        //        alert("RazerPay Revenue share should not be higher than mdr value");
        //        return false;
        //    }
        //    if (vm.tier.WechatIntRevenueShareValue >vm.tier.WechatIntPaymentMDRValue) {
        //        alert("WechatInt Revenue share should not be higher than mdr value");
        //        return false;
        //    }
        //    if (vm.tier.AlipayIntRevenueShareValue > vm.tier.AlipayIntyPaymentMDRValue) {
        //        alert("AlipayInt Revenue share should not be higher than mdr value");
        //        return false;
        //    }
        //}

   
        vm.checkMDRType = function () {
            if (vm.tier.MDRActiveDay > 0) {
                vm.disabledMDR = true;
                vm.disabledMDRThreshold = true;
                vm.disabledMDRActiveDay = false;
                vm.DisableMDRAdditionalAmount = true;
                vm.FixedMDRAdditionalAmount = true;
                vm.DisableMdrOptionType = true;
            }
            else {
                vm.disabledMDRThreshold = false;
                vm.FixedMDRAdditionalAmount = false;
                vm.DisableMDRAdditionalAmount = false;
                vm.DisableMdrOptionType = false;
            }
            if (vm.tier.MDRThreshold > 0 || vm.tier.MDRAdditionalAmount > 0 || vm.tier.FixedMDRAdditionalAmount > 0) {
                vm.disabledMDR = false;
                vm.disabledMDRActiveDay = true;

            }
            //if (vm.tier.MDRThreshold <= 0) {
            //    vm.tier.MDRAdditionalAmount = 0;
            //    vm.tier.FixedMDRAdditionalAmount = 0;
            //}
            if (vm.tier.MDRActiveDay == 0 && vm.tier.MDRThreshold == 0) {
                vm.disabledMDR = false;
                vm.disabledMDRActiveDay = false;
            }
        }

        //$timeout(function () {
        //    vm.checkMDRType();
        //}, 200);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin').filter('roundup', function () {
            return function (value) {
                return Math.ceil(value);
            };
        })
        .controller('SettlementTransactionSummaryController', SettlementTransactionSummaryController);

    // settlement_transaction.summary.$inject = ['$location'];

    function SettlementTransactionSummaryController(SVCS, SettlementTransactionService, MasterMerchantService, MerchantService, $scope, $state, $window, $location, $translate, TagService) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'settlement_transaction_summary';

        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 4;
        vm.itemsPerPage = 100;
        vm.settlementTransactions = { TransactionIds: [], SummaryIds: [], Date: null, Status: null };
        vm.criteria = { ClientName: null, MerchantId: null, MasterMerchantId: null, Status: null, Date: null, EndDate: null, Page: 1, Length: 100 };
        vm.viewConfig = { ShowDialog: false };

        vm.transactionSummaryItems = [];
        //vm.transactionSummaryItems = [{ MerchantId: null, storeId: null, startDate: null, EndDate: null }];

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.summary('summary');
            }
        }

        vm.reset = function () {
            vm.criteria = { ClientName: null, MerchantId: null, MasterMerchantId: null, Status: null, Date: null, EndDate: null, Page: 1, Length: 100 };

            vm.currentPage = 1;
            vm.summary('summary');
        }

        vm.summary = function (type) {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            SettlementTransactionService.Summary(criteria).then(function (res) {
                vm.transactions = res.Items;
               // console.log(res);
                vm.totalItems = res.Total;

                vm.isCheckAll = false;
                if (type == 'summary') {

                    resetUpdate();
                }
                else {


                    var flag = true;
                    angular.forEach(vm.transactions, function (item) {
                        if (vm.settlementTransactions.TransactionIds.indexOf(item.Id) != -1) {
                            item.IsChecked = true;

                        }
                        else {
                            flag = false;

                        }
                    });
                    if (flag) vm.isCheckAll = true;
                }
            });
        };


        vm.checkAll = function () {
            if (vm.isCheckAll) {
                angular.forEach(vm.transactions, function (item) {
                    item.IsChecked = true;
                    vm.settlementTransactions.TransactionIds.push((item.TransactionIds).split(',').map(parseFloat));
                    vm.settlementTransactions.SummaryIds.push((item.Id));
                });

                vm.isShowCommitButton = true;
            }
            else {
                resetUpdate();
            }
        };

        vm.checkItem = function (transaction) {
            //console.log('transaction:');
            //console.log(transaction);
            if (transaction.IsChecked) {
                vm.settlementTransactions.TransactionIds.push((transaction.TransactionIds).split(',').map(parseFloat));
                vm.settlementTransactions.SummaryIds.push((transaction.Id));

            }
            else {

                var dataset = vm.settlementTransactions.TransactionIds;
                var indexs = [];
                dataset.filter(function (elem, index, array) {
                    if (elem == transaction.TransactionIds) {
                        indexs.push(index);
                    }
                });

                vm.settlementTransactions.TransactionIds.splice(indexs[0], 1);

                vm.settlementTransactions.SummaryIds.removeItem((transaction.Id));

            }

            if (vm.settlementTransactions.TransactionIds.length > 0) {

                vm.isShowCommitButton = true;
            }
            else {
                vm.isShowCommitButton = false;

            }
        };

        vm.openDialog = function () {
            vm.viewConfig.ShowDialog = true;
        };

        vm.save = function () {
            if (!$scope.transactionForm.$valid) {
                angular.forEach($scope.transactionForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    });
                });
                $('#transactionForm .ng-invalid')[0].focus();
                return;
            }


            vm.tempTransactionIds = vm.settlementTransactions.TransactionIds;
            vm.newvalue = [];
            vm.tempTransactionIds.forEach(function (item) {

                item.forEach(function (item1) {
                    vm.newvalue.push(item1);
                });
            });

            vm.settlementTransactions.TransactionIds = vm.newvalue;
            console.log(vm.settlementTransactions);
            SettlementTransactionService.UpdateSummary(vm.settlementTransactions).then(function (res) {
                vm.cancel();
                vm.summary('summary');
            });
        };

        vm.cancel = function () {
            vm.viewConfig.ShowDialog = false;
            vm.settlementTransactions.Date = null;
            vm.settlementTransactions.Status = null;
            $scope.transactionForm.$setPristine();
            $scope.transactionForm.$setUntouched();
        };

        vm.loadMerchant = function (keyword) {          
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = res.Items;
                });
            } else {
                vm.merchants = null;
            }
        }


        function resetUpdate() {
            angular.forEach(vm.transactions, function (item) {
                item.IsChecked = false;
            })
            vm.settlementTransactions = { TransactionIds: [], SummaryIds: [], Date: null, Status: null };
            vm.isShowCommitButton = false;
        }



        vm.summary();


        //get list master merchant
        MasterMerchantService.Search({ Keyword: null }).then(function (res) {
            vm.masterMerchants = res.Items;
            console.log(vm.masterMerchants);
        });




        $scope.getTotal = function () {
            vm.result = { totalamt: null, totalSettlementamt: null, totalMDR: null, totalCount: null };
            vm.result.totalamt = 0;
            vm.result.totalSettlementamt = 0;
            vm.result.totalMDR = 0;
            vm.result.totalCount = 0;
            if (vm.totalItems != null) { 
            for (var i = 0; i < vm.totalItems; i++) {
                var product = vm.transactions[i];
                if (product != null && product != undefined) {
                    vm.result.totalamt += (product.TotalAmount == null || product.TotalAmount == undefined)? 0 : (product.TotalAmount);
                    vm.result.totalSettlementamt += (product.SettlementAmount == null || product.SettlementAmount == undefined) ? 0 :(product.SettlementAmount);
                    vm.result.totalMDR += (product.MDRFee == null || product.MDRFee == undefined) ? 0 :(product.MDRFee);
                    vm.result.totalCount += (product.Count == null || product.Count == undefined) ? 0 :(product.Count);
                }
               
            }
        }
            return vm.result;
        };

        vm.redirectToTransactions = function (transaction) {
            //alert($location.path());
            //alert(window.location);
            //alert(window.location.host);
            //alert(window.location.hostname);
            //alert(window.location.href);

            //alert($location.url('/admin/settlemen-transaction'));
            // $window.open('https://www.google.com', '_blank');
            //  $window.open(window.location.hostname + '/admin/settlemen-transaction', '_blank');

             $state.go('app.admin.settlement-transaction-search', { sDate: transaction.StartDate, eDate: transaction.EndDate, mId: transaction.MerchantId});
            //var url = $state.href('app.admin.settlement-transaction-search', { sDate: transaction.StartDate, eDate: transaction.EndDate, mId: transaction.MerchantId, sId: transaction.StoreId });
            //window.open(url, '_blank');
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('CategoryMerchantService', CategoryMerchantService);
    /** @ngInject */
    function CategoryMerchantService($q, $http, CoreService, SVCS) {
        var merchantServer = SVCS.Merchant;

        var service = {
            Get: Get,
            Search: Search,
            Create: Create,
            Update: Update,
            Delete: Delete,
            UploadPhoto: UploadPhoto
        };

        return service;

        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/categories/' + id).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/categories', criteria).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function Create(category) {
            var deferer = $q.defer();

            $http.post(merchantServer + '/api/categories', category).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        function Update(category) {
            var deferer = $q.defer();

            $http.put(merchantServer + '/api/categories', category).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        function Delete(id) {
            var deferer = $q.defer();

            CoreService.Delete(merchantServer + '/api/categories/' + id).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function UploadPhoto(img) {
            var deferer = $q.defer();

            var formData = new FormData();
            formData.append('file', img);
            $http.post(merchantServer + '/api/photos/uploadCategory', formData, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .directive('isCategoryMerchantNameAvailableBrand', isCategoryMerchantNameAvailableBrand);

    /** @ngInject **/
    function isCategoryMerchantNameAvailableBrand($q, $http, $timeout, SVCS) {
        return {
            require: 'ngModel',

            link: function (scope, elm, attrs, ctrl) {

                var checkingTask = null;

                var baseUrl = SVCS.Merchant;

                ctrl.$asyncValidators.isCategoryMerchantNameAvailableBrand = function (modelValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return $q.when();
                    }

                    var def = $q.defer();

                    if (checkingTask != null) {
                        $timeout.cancel(checkingTask);
                        checkingTask = null;
                    }

                    var id = scope.$eval(attrs.isCategoryMerchantNameAvailableBrand);

                    checkingTask = $timeout(function () {
                        $http.post(baseUrl + '/api/categories/is-category-name-available', { Name: modelValue, Id: id }).then(function (response) {
                            if (response.data) {
                                def.resolve();
                            } else {
                                def.reject();
                            }
                        }, function (responseError) {
                            def.reject();
                        })
                    }, 500)

                    return def.promise;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('CategoryMerchantController', CategoryMerchantController);

    /** @ngInject */
    function CategoryMerchantController(CategoryMerchantService, $translate, $scope, $timeout) {
        var vm = this;

        vm.channelList = [
            {
                Value: "",
                Text: "Select an option"
            },
            {
                Value: "Kiplepay",
                Text: "Kiplepay"
            }
        ];

        //#region Brand
        vm.searchBrand = function () {
            CategoryMerchantService.Search().then(function (res) {
                vm.categoriesBrand = res.Items;
            });
        };
        vm.searchBrand();

        vm.refreshCategoriesFilteredBrand = function () {
            vm.categories_filteredBrand = [];
            angular.forEach(vm.categoriesBrand, function (value, key) {
                if (vm.categoryBrand.Id && vm.categoryBrand.Id == value.Id) {

                } else {
                    vm.categories_filteredBrand.push(value);
                }
            });
        }

        vm.toggle = function (scope) {
            scope.toggle();
        };

        vm.showDetailBrand = function (id) {
            CategoryMerchantService.Get(id).then(function (res) {
                vm.categoryBrand = res;
                vm.refreshCategoriesFilteredBrand();
            });
        }

        vm.clearFormBrand = function () {
            $scope.categoryFormBrand.$setPristine();
            $scope.categoryFormBrand.$setUntouched();
        }

        vm.addNewBrand = function () {
            vm.categoryBrand = {}
            vm.refreshCategoriesFilteredBrand();
            vm.clearFormBrand();

            $timeout(function (){
                $('#nameBrand')[0].focus();
                vm.categoryBrand.Channel = "";
            },100);
        }

        vm.cancelBrand = function () {
            vm.categoryBrand = null;
            vm.clearFormBrand();
        }
       
        vm.saveBrand = function () {
            if (!$scope.categoryFormBrand.$valid) {
                angular.forEach($scope.categoryFormBrand.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#categoryFormBrand .ng-invalid')[0].focus();
                return;
            }

            if (vm.categoryBrand.Id) {
                // Update
                CategoryMerchantService.Update(vm.categoryBrand).then(function () {
                    vm.searchBrand();
                    vm.categoryBrand = null;
                });
            }
            else {
                // Add new
                CategoryMerchantService.Create(vm.categoryBrand).then(function () {
                    vm.searchBrand();
                    vm.categoryBrand = null;
                });
            }
        }

        vm.removeBrand = function (id) {
            $translate("admin.category.confirm_remove").then(function(message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }
                CategoryMerchantService.Delete(id).then(function(res) {
                    vm.searchBrand();
                    vm.categoryBrand = null;
                });
            });
        };

        vm.removePhoto = function (type) {
            if (type === 1) {
                vm.categoryBrand.HomeLogo = null;
            } else {
                vm.categoryBrand.MailLogo = null;
            }
        }

        vm.uploadPhoto = function (files, invalidFiles, type) {
            if (invalidFiles.length) {
                $translate('banner.validate.photo.file_invalid', { name: invalidFiles[0].name }).then(function(msg) {
                    alert(msg);
                });
                return;
            }

            if (!files || !files.length) {
                return;
            }

            CategoryMerchantService.UploadPhoto(files[0]).then(function(resPhoto) {
                if (type === 1) {
                    vm.categoryBrand.HomeLogo = resPhoto.Result;
                } else {
                    vm.categoryBrand.MailLogo = resPhoto.Result;
                }
            }).catch(function(error) {
                console.log(error);
                alert('file invalid');
            });
        };
        //#endregion
    }

})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('UserWalletUpgradeController', UserWalletUpgradeController);

    /** @ngInject */
    function UserWalletUpgradeController(SVCS, BulkRegisterPartnerService, $scope, $timeout) {
        var vm = this;
        vm.templateLink = SVCS.Merchant + "/Merchant/Content/UserProfileReport-template.csv";

        var errorType = 0;
        vm.checkRow = function (data) {
            if (!isEmpty(data[0])) {
                
                return true;
            }
            else {
                errorType = 1;
                
                return false;
            }
        }

        function isEmpty(val) {
            return (val === undefined || val == null || val.length <= 0) ? true : false;
        }
       
        vm.save = function () {
            if (!vm.fileContent) {
                alert("Please choose a csv file.");
            }
            else {
                var invalid = false;
                
                var title = [
                    "UserName"];
                angular.forEach(vm.fileContent.split("\r\n"), function (row, index) {
                    var char = "";
                    if (row.indexOf(";") !== -1) {
                        char = ";";
                    }
                    else {
                        char = ",";
                    }
                    var data = row.split(char);                  
                    if (index == 0) {                       
                        if (!angular.equals(title, data)) {
                            invalid = true;
                            alert("The title is invalid. (" + title + ")");
                        }
                    }
                    else {                      
                                                    
               //         if (!vm.checkRow(data)) {
                 //           invalid = true;
                   //         var base_message = "Data of row " + index + " is invalid.\n";
                     //       var message = base_message;

                       //     switch (errorType) {
                         //       case 1:
                           //         message = base_message + "UserName is mandatory";
                             //       break;
                           //}
                            //alert(message);

                       // }
                    }
                });

                if (!invalid) { 

                    var fileUpload = $('.input_file').get(0);
                    var files = fileUpload.files;
                    var data = new FormData();
                    for (var i = 0; i < files.length; i++) {
                        data.append(files[i].name, files[i]);
                    }

                    BulkRegisterPartnerService.ImportWalletUpgradeCSVIForm(data).then(function (res) {
                        if (res.status == 200) {
                            alert(res.data);
                            $('.input_file').val(null);
                        }
                    });

                }

            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('UserProfileReportController', UserProfileReportController);

    /** @ngInject */
    function UserProfileReportController(SVCS, BulkRegisterPartnerService, $scope, $timeout) {
        var vm = this;
        vm.templateLink = SVCS.Merchant + "/Merchant/Content/UserProfileReport-template.csv";

        var errorType = 0;
        vm.checkRow = function (data) {
            if (!isEmpty(data[0])) {
                
                return true;
            }
            else {
                errorType = 1;
                
                return false;
            }
        }

        function isEmpty(val) {
            return (val === undefined || val == null || val.length <= 0) ? true : false;
        }
       
        vm.save = function () {
            if (!vm.fileContent) {
                alert("Please choose a csv file.");
            }
            else {
                var invalid = false;
                
                var title = [
                    "UserName"];
                angular.forEach(vm.fileContent.split("\r\n"), function (row, index) {
                    var char = "";
                    if (row.indexOf(";") !== -1) {
                        char = ";";
                    }
                    else {
                        char = ",";
                    }
                    var data = row.split(char);                  
                    if (index == 0) {                       
                        if (!angular.equals(title, data)) {
                            invalid = true;
                            alert("The title is invalid. (" + title + ")");
                        }
                    }
                    else {                      
                                                    
               //         if (!vm.checkRow(data)) {
                 //           invalid = true;
                   //         var base_message = "Data of row " + index + " is invalid.\n";
                     //       var message = base_message;

                       //     switch (errorType) {
                         //       case 1:
                           //         message = base_message + "UserName is mandatory";
                             //       break;
                           //}
                            //alert(message);

                       // }
                    }
                });

                if (!invalid) { 

                    var fileUpload = $('.input_file').get(0);
                    var files = fileUpload.files;
                    var data = new FormData();
                    for (var i = 0; i < files.length; i++) {
                        data.append(files[i].name, files[i]);
                    }

                    BulkRegisterPartnerService.ImportUserProfileReportCSVIForm(data)

                }

            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('UserCreationReportController', UserCreationReportController);


    UserCreationReportController.$inject = ['DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter', 'BulkRegisterPartnerService', '$scope', '$compile','SVCS','CoreService'];

    function UserCreationReportController(DTOptionsBuilder, DTColumnBuilder, $q, $filter,   BulkRegisterPartnerService,  $scope, $compile,SVCS,CoreService) {
        var vm = this;

        vm.errorMsg = '';
        vm.isReadonly = true;
        vm.statusList = [
            { status: 0, displayText: 'Pending' }, 
            { status: 1, displayText: 'Partial Failed' }, 
            { status: 2, displayText: 'Successful' }, 
            { status: 3, displayText: 'Failed' },     
        ];
        vm.creationTypeList=[
            { status: 1, displayText: 'UserCreation+KipleVisaCard' },  
        ];
        vm.serachModel = {
            CreationStartDate: null,
            CreationEndDate: null, 
            creationType: null,
            status: null,
        }; 
        vm.dtInstance = {};
        vm.approve = approve; 

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();
                deferer.resolve([]);
                return deferer.promise;

            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withOption('createdRow', createdRow) , 
            columns: [
                DTColumnBuilder.newColumn('BatchNo'),
                DTColumnBuilder.newColumn('CreatedAt').withClass('center').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'yyyy-MM-dd HH:mm:ss'); }),
                DTColumnBuilder.newColumn('CreationTypeName'),
                DTColumnBuilder.newColumn('CreationId'),
                DTColumnBuilder.newColumn('TotalCreationProfile'),
                DTColumnBuilder.newColumn('BatchUserCreationStatus'),
                DTColumnBuilder.newColumn('CreatedBy'),
                DTColumnBuilder.newColumn('action').withClass('action').renderWith(function (data, type, rowData) {
                      var buttonStr = '<div class="center"><button type="button" class="btn btn-primary"   ng-click="vm.download(\'' + rowData.BatchNo + '\')" >Download</button></div>';
                     return buttonStr;
                }),
            ]
        };

        vm.searchReport = function () {
            vm.errorMsg = null;
            if (vm.serachModel.CreationStartDate && vm.serachModel.CreationEndDate) {
                var beginTime = moment(vm.serachModel.CreationStartDate);
                var endTime = moment(vm.serachModel.CreationEndDate);

                var diff = moment(endTime).diff(beginTime, 'minutes');

                if (diff < 0) {
                    vm.errorMsg = "begin time cannot be greater than end time";

                    return;
                }
            }

            vm.dtInstance.changeData(getReportPromise);
        }
        vm.download=function(batchNo){ 
            CoreService.Get(SVCS.Wallet + '/api/BulkRegister/export?batchNo='+batchNo).then(function (response) {
                var file_name = batchNo+'.csv';
                var csvData = new Blob([response], { type: 'text/csv' });
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                    window.navigator.msSaveOrOpenBlob(csvData, file_name);
                } else { // for Non-IE (chrome, firefox etc.)
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    var csvUrl = URL.createObjectURL(csvData);
                    a.href = csvUrl;
                    a.download = file_name;
                    a.click();
                    URL.revokeObjectURL(a.href)
                    a.remove();
                }
                deferer.resolve(response);
            })
        }
        vm.resetPage=function (){
            vm.serachModel = {
                CreationStartDate: null,
                CreationEndDate: null, 
                creationType: null,
                status: null,
            };

        }
        function approve(id) {
            BulkRegisterPartnerService.CreationApprove(id).then(function (response) {
                vm.dtInstance.changeData(getReportPromise);
            }, function (responseError) {
                alertError();
            });
        }; 
        function getReportPromise() { 
            var jsonData = {
                CreationStartDate: vm.serachModel.CreationStartDate,
                CreationEndDate: vm.serachModel.CreationEndDate,
                CreationType: vm.serachModel.creationType,
                Status: vm.serachModel.status,
            };
            var defer = $q.defer();
            BulkRegisterPartnerService.searchUserCreationReport(jsonData).then(function (response) {
                defer.resolve(response.data);
            }, function (responseError) {
                dealErrorDefer(defer);
            });

            return defer.promise;
        }
        function dealErrorDefer(defer) {
            alertError();
            defer.resolve();
        }

        function alertError() {
            var message = "Failed! Something has gone wrong. Please contact a system administrator.";
            alert(message);
        }

        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT  
            $compile(angular.element(row).contents())($scope);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('BulkRegisterPartnerController', BulkRegisterPartnerController);

    /** @ngInject */
    function BulkRegisterPartnerController(SVCS, BulkRegisterPartnerService, $scope, $timeout) {
        var vm = this;
        vm.templateLink = SVCS.Merchant + "/Merchant/Content/BulkRegisterPartner-template-New.csv";

        var errorType = 0;
        vm.checkRow = function (data) {
            if (!isEmpty(data[0]) && !isEmpty(data[1]) && !isEmpty(data[2]) && !isEmpty(data[3]) &&
                !isEmpty(data[4]) && !isEmpty(data[5]) && !isEmpty(data[6]) && !isEmpty(data[7]) &&
                !isEmpty(data[8]) && !isEmpty(data[9]) && !isEmpty(data[10]) && !isEmpty(data[11]) &&
                !isEmpty(data[12]) && !isEmpty(data[13]) &&
                !isEmpty(data[16]) && !isEmpty(data[18])) {
                return true;
            }
            else {
                errorType = 1;
                return false;
            }
        }

        function isEmpty(val) {
            return (val === undefined || val == null || val.length <= 0) ? true : false;
        }

        vm.save = function () {
            if (!vm.fileContent) {
                alert("Please choose a csv file.");
            }
            else {
                var invalid = false;
                
                var title =[ 
                    "LoginID", "Nationality", "IDNo", "IDType", "EmailId", "MobileNo", "FullName", "City", "State", "PostalCode", "Delivery Address", "Occupation", "Position", "Industry", "Community", "CampaignID", "IsVisaRegistration","eWagesEmployer","DOB"];
                angular.forEach(vm.fileContent.split("\r\n"), function (row, index) {
                    var char = row.indexOf(";") !== -1 ? ";" : ",";
                    var data = row.split(char);
                    if (index == 0) {
                        if (!angular.equals(title, data)) {
                            invalid = true;
                            alert("The title is invalid. Expected: " + title.join(", "));
                        }
                    }
                    else {
                        if (data.length == title.length) {
                            if (!vm.checkRow(data)) {
                                invalid = true;
                                var base_message = "Data of row " + index + " is invalid.\n";
                                var message = base_message;

                                switch (errorType) {
                                    case 1:
                                    message = base_message + "(LoginID, Nationality, IDNo, EmailId, MobileNo, FullName, City, State, PostalCode, Delivery Address, Community, CampaignID) are mandatory.";
                                    break;
                                }
                                alert(message);
                            }
                        }
                    }
                });

                if (!invalid) {

                    var fileUpload = $('.input_file').get(0);
                    var files = fileUpload.files;
                    var newdata = new FormData();
                    for (var i = 0; i < files.length; i++) {
                        newdata.append(files[i].name, files[i]);
                    }

                    BulkRegisterPartnerService.ImportCSVIForm(newdata).then(function (res) {
                        if (res.status == 200) {
                            alert(res.data);
                        }
                    });

                }

            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.university', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.university', {
                url: '/university',
                abstract: true
            })
            .state('app.university.verify-student', {
                url: '/verify-student',
                views: {
                    'main@app': {
                        templateUrl: 'app/university/verify-student/verify.student.html',
                        controller: 'verifyStudentController',
                        controllerAs: 'vm'
                    }
                },
                protect: true
            })
             .state('app.university.university-merchant', {
                url: '/university-merchant',
                views: {
                    'main@app': {
                        templateUrl: 'app/university/university-merchant/merchant.html',
                        controller: 'universityMerchantController',
                        controllerAs: 'vm'
                    }
                },
                protect: true
            }).state('app.university.university-outlet-report', {
                url: '/university-outlet-report',
                views: {
                    'main@app': {
                        templateUrl: 'app/university/university-report/outlet-transactions.html',
                        controller: 'UniversityOutletReportController',
                        controllerAs: 'vm'
                    }
                },
                protect: true
            }).state('app.university.university-payment-report', {
                url: '/university-payment-report',
                views: {
                    'main@app': {
                        templateUrl: 'app/university/university-report/university-payment-report.html',
                        controller: 'UniversityPaymentReportController',
                        controllerAs: 'vm'
                    }
                },
                protect: true
            })

            .state('app.university.referral-code-summary-report', {
                url: '/referral-code-summary-report',
                views: {
                    'main@app': {
                        templateUrl: 'app/university/university-report/referral-code-summary-report.html',
                        controller: 'ReferralCodeSummaryReportController',
                        controllerAs: 'showcase'
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_BRAND']
            })
              
            .state('app.university.university-report', {
                url: '/university-report',
                views: {
                    'main@app': {
                        templateUrl: 'app/university/university-report/university-statement-of-account.html',
                        controller: 'UniversityStatementOfAccountReportController',
                        controllerAs: 'vm'
                    }
                },
                protect: true
            })

        //uni crud function
        .state('app.university.university-portal', {
            url: '/university-portal',
            views: {
                'main@app': {
                    templateUrl: 'app/university/university-portal/portal.html',
                    controller: 'portalController',
                    controllerAs: 'vm'
                }
            },
            protect: true
            })

        //campus

            .state('app.university.campus-portal', {
                url: '/campus_portal',
                views: {
                    'main@app': {
                        templateUrl: 'app/university/university-portal/portal-campus.html',
                        controller: 'portalcampusController',
                        controllerAs: 'vm'
                    }
                },
                protect: true
            })
        //end campus

        // Translation
        $translatePartialLoaderProvider.addPart('app/university');

    }
})();
(function () {
    'use strict';

    angular
        .module('app.university')
        .controller('verifyStudentController', verifyStudentController);

    /** @ngInject */
    function verifyStudentController($rootScope, $scope, $state, AuthenticationService, UniversityService,  $cookies) {
        var vm = this;
        vm.model = { OldPassword: null, NewPassword: null };

        vm.verifyStudent = function () {
            //if ($scope.changePasswordForm.$invalid) {
            //    return;
            //}
            var fileUpload = $('.input_file').get(0);
            var files = fileUpload.files;
            var data = new FormData();
            for (var i = 0; i < files.length; i++) {
                data.append(files[i].name, files[i]);
            }    

            UniversityService.UploadCSV(data).then(function (res) {
                if (res.status == 200) {
                    alert(res.data);
                }
            });

            //AuthenticationService.changeMyPassword(vm.model).then(function () {
            //    var accountType = $cookies.get('account_type');

            //    if (accountType == 2) {
            //        $state.go('app.merchant.info', { 'merchantId': null });
            //    }
            //    else {
            //        $state.go('app.merchant.list');
            //    }
            //}, function (error) {
            //    alert(error.Message);
            //});
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.university')
        .controller('portalcampusController', portalcampusController);

    /** @ngInject */
    function portalcampusController($rootScope, $scope, $state, AuthenticationService, UniversityService,  $cookies) {
        var vm = this;
        var uni = [];
        vm.model = { OldPassword: null, NewPassword: null };
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;
        vm.brand = {};
        vm.criteria = { Keyword: null, Page: 1, Length: 10 };
        vm.viewConfig = { ShowDialog: false, Action: null, UploadLogo: false };
        var uploadImgControl = null;
        vm.disabledDeleteLogo = true;
        vm.id = null;
        //$("#universityBlock2").css("color", "black");

      
        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }

        vm.getUniversities = function () {
            UniversityService.GetPortalUniversity().then(function (data) {
                vm.universtyList = data.list;
            })
        }

        //search 
        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            UniversityService.GetAllCampus(criteria).then(function (res) {
                vm.campusList = res.result.Items;;
                vm.totalItems = res.result.Total;
            });
        }

        vm.reset = function () {
            $("#searchtxt").val('');
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }

        vm.campuses = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            UniversityService.GetAllCampuses().then(function (res) {
                vm.campusList = res.Items;
                vm.totalItems = res.Total;
            });
        }

        vm.cancel = function () {

            vm.viewConfig.ShowDialog = false;
            $("#universityId").val('');
        }

        $scope.clearForm = function () {
            $scope.brandForm.$setPristine();
            $scope.brandForm.$setUntouched();
        }

        vm.openDialog = function (action, id, brandForm) {
            brandForm.$setPristine();
            brandForm.$setUntouched();
            //$("#universityBlock2").css("color", "black");
            brandForm.UniversityId.$setUntouched();
            vm.viewConfig.Action = action;
            if (action == 'new') {
                $("#universityBlock2").show();
                $("#universityBlock1").hide();
                $("input[name=CampusId]").prop("readonly", false);
                $("input[name=UniversityId]").prop("readonly", false);
                $("input[name=UniversityId]").val('');
                $("input[name=CampusId]").val('');
                $("input[name=CampusName]").val('');
                $("input[name=CampusLocation]").val('');
                $("input[name=CampusAddress]").val('');

                 vm.viewConfig.ShowDialog = true;
            }
            if (action == 'edit' && id != null) {
                UniversityService.GetCampus(id).then(function (res) {
                    vm.id = id;
                    $("input[name=CampusId]").prop("readonly", true);
                    $("input[name=UniversityId]").prop("readonly", true);
                    $("input[name=UniversityId]").val(res.result.UniveristyId);
                    $("input[name=CampusId]").val(res.result.CmapusId);
                    $("input[name=CampusName]").val(res.result.Name);
                    $("input[name=CampusLocation]").val(res.result.Location);
                    $("input[name=CampusAddress]").val(res.result.Address);
                    $("#universityBlock1").show();
                    $("#universityBlock2").hide();
                    vm.viewConfig.ShowDialog = true;
                });
            }

            if (action == 'remove' && id != null) {
                UniversityService.RemoveCampus(id).then(function (res) {
                   
                    alert(res.Message);
                    vm.search();

                });
            }
            
        }

        vm.getSelected = function (brandForm) {
            if ($("#UniversityId").val() == null || $("#UniversityId").val() == "") {
                //$("#universityBlock2").css("color", "#a94442");
                brandForm.UniversityId.$setTouched();
            } else {
                //$("#universityBlock2").css("color", "black");
                brandForm.UniversityId.$setUntouched();
            }
        }

        //publish /unpublish
        vm.publish = function (id, val) {
            val = val == 0 ? true : false;
            UniversityService.PublishCampus(id, val).then(function (res) {
                //alert(res);ConvertNormalStore
             if(val == false && res != null){
                  UniversityService.ConvertNormalStore(id).then(function (res){})
              }
               alert(res);     
               vm.reset();
            });
        }

        //save
        vm.save = function (brandForm) {
       
            var uid = $("input[name=UniversityId]").val();
            //if ($("#UniversityId").val() == null || $("#UniversityId").val() == "" && vm.viewConfig.Action == 'new') {
               
            //    //$("#universityBlock2").css("color", "#a94442");
            //}
            
            var cid = $("input[name=CampusId]").val();
            var name = $("input[name=CampusName]").val();
            var location = $("input[name=CampusLocation]").val();
            var address = $("input[name=CampusAddress]").val();
            brandForm.UniversityId.$setUntouched();
            
            if (uid == null || uid == "") {
                brandForm.UniversityId.$setTouched();
            }
            if (name == null || name == "") {
                brandForm.CampusName.$setTouched();
            }
            if (location == null || location == "") {
                brandForm.CampusLocation.$setTouched();
            }
            if (address == null || address == "") {
                brandForm.CampusAddress.$setTouched();

            }
           

            if (name == null || name == "" || location == null || location == "" || address == null || address == "") {
                return;
            }
            if (vm.viewConfig.Action == 'new') {
               
                var uid = $("input[name=UniversityId]").val();

                UniversityService.AddCampus(vm.campus).then(function (res) {
                    alert(res);
                    vm.viewConfig.ShowDialog = false;
                    vm.disabledDeleteLogo = false;
                    $("#universityId").val('');
                    vm.search();
                })
            }
            else if (vm.viewConfig.Action == 'edit') {
                var uid = $("input[name=UniversityId]").val();
                var campus = { UniveristyId: uid, CmapusId: cid, Name: name, Location: location, Address: address };
                UniversityService.UpdateCampus(campus, vm.id).then(function (res) {
                    alert(res.Message);
                    vm.viewConfig.ShowDialog = false;
                    vm.disabledDeleteLogo = false;
                    vm.reset();
                    vm.id = null;
                })
                
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .directive('isBrandNameAvailable', isBrandNameAvailable);

    /** @ngInject **/
    function isBrandNameAvailable($q, $http, $timeout, SVCS) {
        return {
            require: 'ngModel',

            link: function (scope, elm, attrs, ctrl) {

                var checkingTask = null;

                var baseUrl = SVCS.Merchant;

                ctrl.$asyncValidators.isBrandNameAvailable = function (modelValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return $q.when();
                    }

                    var def = $q.defer();

                    if (checkingTask != null) {
                        $timeout.cancel(checkingTask);
                        checkingTask = null;
                    }

                    var id = scope.$eval(attrs.isBrandNameAvailable);

                    checkingTask = $timeout(function () {
                        $http.post(baseUrl + '/api/brands/is-brand-name-available', { Name: modelValue, Id: id }).then(function (response) {
                            if (response.data) {
                                def.resolve();
                            } else {
                                def.reject();
                            }
                        }, function (responseError) {
                            def.reject();
                        })
                    }, 500)

                    return def.promise;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.university')
        .controller('portalController', portalController);

    /** @ngInject */
    function portalController($rootScope, $scope, $state, AuthenticationService, UniversityService, MerchantService, $cookies, CommunityService) {
        var vm = this;
        var uni = [];
        vm.model = { OldPassword: null, NewPassword: null };
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;
        vm.brand = {};
        vm.criteria = { Keyword: null, Page: 1, Length: 10 };
        vm.viewConfig = { ShowDialog: false, Action: null, UploadLogo: false };
        var uploadImgControl = null;
        vm.disabledDeleteLogo = true;
        vm.id = null;
        var brand = null;
        var logo = null;
        $("#Brand").css("color", "black");
        vm.university = {};
        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }

        vm.getSelected = function (brandForm) {
          
            var id = $("#BrandId").val();
           
            if ($("#BrandId").val() == null || $("#BrandId").val() == "") {
                brandForm.BrandId.$setTouched();
            } else {
                brandForm.BrandId.$setUntouched();
            }
            MerchantService.GetBrands().then(function (data) {
                var rr = data.find(function (x) { if (x.Id == id) return x; });
                logo = rr.LogoUrl;
            })
        }

        //search 
        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            UniversityService.GetAllUniversity(criteria).then(function (res) {
                vm.universtyList = res.result.Items;;
                vm.totalItems = res.result.Total;
            });
        }

        vm.reset = function () {
            $("#searchtxt").val('');
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }

        vm.universities = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            UniversityService.GetAllUniversity().then(function (res) {
                vm.universtyList = res.Items;
                vm.totalItems = res.Total;
            });
        }

        vm.cancel = function (brandForm) {

            vm.viewConfig.ShowDialog = false;
            $("input[name=universityId]").val('');
            $("input[name=universityname]").val('');
            $("BrandId").empty();
            $("#universitylogo").val('');
            $("#universityname").empty();
            $scope.vm.university.UniversityId = null;
            brandForm.$setPristine();
            vm.getBrands('new');
        }

        vm.openDialog = function (action, id, brandForm) {
            brandForm.$setPristine();
            brandForm.$setUntouched();
            brandForm.universityname.$setValidity('required', false);
            brandForm.universityId.$setValidity('required', false);
            vm.viewConfig.Action = action;
            $("BrandId").empty();
            $("BrandId").val('');
            $("#universitylogo").val('');
            $("#universityname").val('');
            
            if (action == 'new') {
                vm.getBrands('new');
                $("input[name=universityId]").prop("readonly", false);
                $("BrandId").prop("readonly", false);
                $("input[name=universityId]").val('');
                $("input[name=universityname]").val('');
                vm.viewConfig.ShowDialog = true;
                vm.university.Badges = [];           
            }
            if (action == 'edit' && id != null) {
                $("input[name=universityId]").prop("readonly", true);
                $("BrandId").prop("readonly", true);
                UniversityService.GetUniversity(id).then(function (res) {
                    vm.university = {
                        BrandId: res.BrandId,
                        UniversityId: res.UniversityId,
                        Name: res.Name,
                        LogoUrl: res.LogoUrl,
                        Badges: [],
                        IsZakatAvailable: res.IsZakatAvailable,
                        IsBankIslamEnabled: res.IsBankIslamEnabled,
                        IsMealPlanEnabled: res.IsMealPlanEnabled,
                        IsZakatTransferEnabled:res.IsZakatTransferEnabled,
                    };
                    vm.university.Badges.push(res.Badges);
                    vm.id = id;
                    brand = res.BrandId;
                    vm.getBrands('edit');
                    $("input[name=universityId]").val(res.UniversityId);
                    $("input[name=universitylogo]").val(res.LogoUrl);
                    $("input[name=universityname]").val(res.Name);                   
                    vm.viewConfig.ShowDialog = true;
                });
            }

            if (action == 'remove' && id != null) {
                UniversityService.RemoveUniversity(id).then(function (res) {
                    alert(res);
                    vm.reset();

                });
            }

        }
        //publish /unpublish
        vm.publish =  function (id, val)
        {
          val =  val == 0 ? true : false;
          UniversityService.PublishUniversity(id, val).then(function (res) {
              if (res != null && val == false) { UniversityService.ConvertNormalMerchant(id); }
                    alert(res);
                    vm.reset();
                });
        }

        vm.publishPortal = function (id, val) {
            val = val == 0 ? true : false;
            UniversityService.PublishPortalUniversity(id, val).then(function (res) {
          
                alert(res);
                vm.reset();
            });
        }


        vm.getBrands = function (action) {
            MerchantService.GetBrands().then(function (data) {
                $("#BrandId").val('');
                if (action == 'edit') {
                    var arr = [];
                    var index = null;
                    $.each(data, function (x, v) {
                        arr.push(v);
                        if (v.Id == parseInt(brand)) {
                            index = x;
                            arr.splice(0, 0, v);
                            $("#BrandId").append('<option value="' + v.Id + '" selected="selected">' + v.Name + '</option>');
                        }
                        $("#BrandId").append('<option value="' + v.Id + '">' + v.Name + '</option>');
                    })

                } else {

                    //var myArr = data.sort(function (a, b) {
                    //    return a.Name.localeCompare(b.Name);
                    //})
                    //$("#BrandId").append('<option value="" ng-selected="selected">Select Brand</option>');
                    $.each(data, function (i, v) {
                        $("#BrandId").append('<option value="' + v.Id + '">' + v.Name + '</option>');
                    });

                }
            })
        }

        vm.changetext = function ($event) {
            var Universityid = $("input[name=universityId]").val();
            if (Universityid.indexOf(' ') !== -1) {
                alert("Spaces not allowed in universityId");
               
            }
        }
        //save
        vm.save = function (brandForm) {

            var id = $("input[name=universityId]").val();
            var name = $("input[name=universityname]").val();
            var brand = $("#BrandId").val();

            if (id.indexOf(' ') !== -1) {
                alert("Spaces not allowed in universityId");
            }
            else {

                //var zakat = $("#Zakat").val();
                var zakat = vm.university.IsZakatAvailable;
                var IsBankIslamEnabled = vm.university.IsBankIslamEnabled;
                var IsMealPlanEnabled = vm.university.IsMealPlanEnabled;
                var IsZakatTransferEnabled = vm.university.IsZakatTransferEnabled;

                brandForm.BrandId.$setUntouched();
                if (id == null || id == "") {
                    brandForm.universityId.$setTouched();

                    //brandForm.universityId.$setValidity('required', false);
                }
                if (name == null || name == "") {
                    brandForm.universityname.$setTouched();
                    //brandForm.universityId.$setValidity('required', false);
                }
                if (brand == null || brand == "") {
                    //$("#Brand").css("color", "#a94442");
                    brandForm.BrandId.$setTouched();
                }

                if (id == null || id == "" || name == null || name == "" || brand == null || brand == "") {
                    return;
                }
                if (vm.university.Badges.length == 0) {
                    alert("Please Select Badges");
                }
                else if(vm.viewConfig.Action == 'new') {
                    var university = { UniversityId: id, Name: name, BrandId: brand, LogoUrl: vm.university.LogoUrl, IsZakatAvailable: zakat, IsBankIslamEnabled: IsBankIslamEnabled, IsMealPlanEnabled: IsMealPlanEnabled, Badges:vm.university.Badges , IsZakatTransferEnabled: IsZakatTransferEnabled};
                    UniversityService.AddUniversity(university).then(function (res) {
                        alert(res);
                        $("#universitylogo").val('');
                        $("#universitylogo").empty();
                        vm.viewConfig.ShowDialog = false;
                        vm.disabledDeleteLogo = false;
                        vm.reset();
                    })
                }
                else if (vm.viewConfig.Action == 'edit') {
                    var university = { UniversityId: id, Name: name, BrandId: brand, LogoUrl: vm.university.LogoUrl, IsZakatAvailable: zakat, IsBankIslamEnabled: IsBankIslamEnabled, IsMealPlanEnabled: IsMealPlanEnabled, Badges:vm.university.Badges, IsZakatTransferEnabled: IsZakatTransferEnabled };
                    UniversityService.UpdateUniversity(university, vm.id).then(function (res) {
                        alert(res);
                        vm.viewConfig.ShowDialog = false;
                        vm.disabledDeleteLogo = false;
                        vm.reset();
                        vm.id = null;
                    })
                }
            }

        }
        vm.temp1 = {};
        vm.uploadBadges = function (files, invalidFiles) {

            if (invalidFiles.length) {
                $translate('Community.configuration.validate.photo.file_invalid', { name: invalidFiles[0].name }).then(function (msg) {
                    alert(msg);
                })
                return;
            }

            if (!files || !files.length) {
                return;
            }

            sequentialUploadBadge(files, 0, [], sequentialUploadCompleted);


        };

        vm.removeBadge = function (idx) {
            vm.university.Badges.splice(idx, 1);
        }

        function sequentialUploadBadge(files, i, errorsFiles, callback) {
            CommunityService.UploadPhoto(files[i]).then(function (photo) {
                vm.university.Badges.push(photo.Result);
            }, function (error) {
                errorsFiles.push({ file: files[i], error: error });
            }).then(function () {
                if (files.length === i + 1) {
                    callback(errorsFiles);
                } else {
                    sequentialUploadBadge(files, i + 1, errorsFiles, callback);
                }
            });
        }

        function sequentialUploadCompleted(errorsFiles) {
            var filesNames = [];
            if (errorsFiles && errorsFiles.length) {
                angular.forEach(errorsFiles, function (item) {
                    filesNames.push(errorsFiles.file.name);
                })
            }

            if (filesNames.length) {
                $translate('Community.configuration.validate.photo.upload_error', { names: filesNames.join(', ') }).then(function (msg) {
                    alert(msg);
                })
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.university')
        .controller('universityMerchantController', UniversityMerchantController);

    /** @ngInject */
    function UniversityMerchantController($rootScope, $scope, $state, AuthenticationService, UniversityService,  $cookies) {
        var vm = this;
        vm.model = { OldPassword: null, NewPassword: null };
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;
        vm.brand = {};
        vm.criteria = { Keyword: null, Page: 1, Length: 10 };
        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            var cookie = $cookies.getObject('university');
            var uni = null;
            if (cookie[1] == 1) {
                uni = "UUM";
            } else if (cookie[3] == 1) {
                uni = "UiTM";
            }
            else if (cookie[5] == 1) {
                uni = "UPM";
            }
            if (cookie[1] == 1 && cookie[3] == 1 && cookie[5] == 1) {
                uni = null;
            }
            criteria.Name = uni;          
            UniversityService.GetAllUniversityWithMer(criteria).then(function (res) {
                vm.merchants = res.Items;
                vm.totalItems = res.Total;
            });
        }
        vm.reset = function () {
            $("#searchtxt").val('');
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.universityMerchantList();
        }
        vm.universityMerchantList = function () {
            var merchant = [];
            var criteria = {
                Name: null,
                City: null,
                District: null,
                Province: null,
                Page: 1,
                Length: 10
            }
            var cookie = $cookies.getObject('university');
            var uni = null;
            if (cookie[1] == 1) {
                uni = "UUM";
            } else if (cookie[3] == 1) {
                uni = "UiTM";
            }
            else if (cookie[5] == 1) {
                uni = "UPM";
            }
            if (cookie[1] == 1 && cookie[3] == 1 && cookie[5] == 1) {
                uni = null;
            }
            criteria.Name = uni;
            UniversityService.GetAllUniversityWithMer(criteria).then(function (res) {
                vm.merchants = res.Items;
                vm.totalItems = res.Total;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.university')
        .controller('UniversityStatementOfAccountReportController', UniversityStatementOfAccountReportController);

    /** @ngInject */
    function UniversityStatementOfAccountReportController(DTOptionsBuilder, DTColumnBuilder, MerchantReportService, UniversityService, $filter,
        MerchantService, TransactionActionHashMap, PaymentChannelHashMap, AuthenticationService, $q, $numUtils, $cookies) {
        var vm = this;
        // default date
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!

        var yyyy = today.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        var today = dd + '/' + mm + '/' + yyyy;
        var tomorrow = dd + 1 + '/' + mm + '/' + yyyy;
        document.getElementById("sdate").value = today;
        document.getElementById("edate").value = tomorrow;


        vm.TransactionActionHashMap = TransactionActionHashMap;

        vm.filter = {
            TransactionId: null,
            MerchantId: null,
            TransactionAction: null,
            TransactionStartDate: null,
            TransactionEndDate: null,
            CampusId: null,
            CampaignName:null,
            PaymentChannel: null
        }
        
        vm.actionOptions = [
            TransactionActionHashMap['Payment'],
            TransactionActionHashMap['TransactionVoid'],
            TransactionActionHashMap['PurchaseVoucher'],
            TransactionActionHashMap['PayAtTable']
        ];

        vm.PaymentChannel = [
            PaymentChannelHashMap['Boost'],
            PaymentChannelHashMap['AliPay'],
            PaymentChannelHashMap['Grab'],
            PaymentChannelHashMap['MayPay'],
            PaymentChannelHashMap['RazorPay'],
            PaymentChannelHashMap['TnG'],
            PaymentChannelHashMap['WeChatPay'],
            PaymentChannelHashMap['WeChatPayInt'],
            PaymentChannelHashMap['AliPayInt']
        ];

        vm.showMerchantFilter = false;

        vm.merchants = [];

        //if ($$viewAsAdmin) {
        //    alert();
        //}
        var uni = null;
        var accountType = $cookies.get('account_type');
        if (accountType != 1) {
            $("#univeristyDiv").hide();
        }
        var cookie = $cookies.getObject('university');
        if (cookie[1] == 1) {
            uni = "UUM";
        } else if (cookie[3] == 1) {
            uni = "UiTM";
        } else if (cookie[5] == 1) {
            uni = "UPM";
        }
        vm.getSelected = function () {
            
            var merchant = [];
            var campus = [];

            uni = $("#UniversityId").val();
            if (uni == "all" || uni == "" || uni == null) {
                var universityArray = [];
                vm.CampusList = [];
                UniversityService.GetPortalUniversity().then(function (data) {
                    $.each(data.list, function (i, v) {
                        universityArray.push(v.UniversityId);
                        UniversityService.GetAllMerchantsPublicInfo(v.UniversityId).then(function (res) {

                            $.each(res.Items, function (i, v) {
                                if (v.State != "Deleted") {
                                    merchant.push(v);
                                }
                            })
                        })
                    })
                })
                vm.merchants = merchant;
            } else {
                vm.LoadCampus(uni);
                UniversityService.GetAllMerchantsPublicInfo(uni).then(function (res) {
                    $.each(res.Items, function (i, v) {
                        if (v.State != "Deleted") {
                            merchant.push(v);
                        }
                    })
                    vm.merchants = merchant;
                })
            }
        }

        vm.LoadCampus = function (id) {
            UniversityService.GetCampusByUniversityId(id).then(function (res) {
                vm.CampusList = res.list;
            })

        }
        
        vm.getUniversities = function () {
            UniversityService.GetPortalUniversity().then(function (data) {
                vm.universtyList = data.list;
            })
        }

        UniversityService.GetAllMerchantsPublicInfo(uni).then(function (res) {
            var merchant = [];
             $.each(res.Items, function (i, v) {
                    if (v.State != "Deleted") {
                        merchant.push(v);
                    }
                })

            vm.merchants = merchant;
        })

        

        vm.tableInstance = {};

        vm.getReport = function () {
            var sdate = $("#sdate").val();
            var edate = $("#edate").val();
            if (sdate == null || sdate == "") {
                alert("Please select start date");
                return;
            }
            if (edate == null || edate == "") {
                alert("Please select end date");
                return;
            }
            vm.tableInstance.changeData(getReportPromise);

        }

        function getReportPromise() {

            var sdate = null;
            var edate = null;

            sdate = $("#sdate").val();
            edate = $("#edate").val();
            if (sdate != null && sdate != "") {
                var date1 = sdate.split('/');
                sdate = date1[2] + '-' + date1[1] + '-' + date1[0];
            }

            if (edate != null && edate != "") {
                var date2 = edate.split('/');
                edate = date2[2] + '-' + date2[1] + '-' + date2[0];
            }
            var tid = vm.filter.TransactionId;
            var type = vm.filter.TransactionAction;
            var merchantId = vm.filter.MerchantId;
            var storeId = vm.filter.StoreId;
            var cid = vm.filter.CampusId;
            var cName = vm.filter.CampaignName;
            var pid = vm.filter.PaymentChannel;
            if (accountType == 1 && $("#UniversityId").val() == "") {
                alert("Please select university");
                return;
            }

            return UniversityService.GetAccountStatement(sdate, edate, tid, type, merchantId, null, uni, cid,cName,pid);

        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Statement of account report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Statement of account report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('Id'),
                DTColumnBuilder.newColumn('CreatedAt').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('MerchantName').withOption('render', function (data) { if (data == null || data == "") return ""; else return data; }),
                DTColumnBuilder.newColumn('Action').withOption('render', function (data) {
                    if (TransactionActionHashMap[data] !== undefined) {
                        return $filter('translate')(TransactionActionHashMap[data].display);
                    }
                    else {
                        return data;
                    }
                }),
                DTColumnBuilder.newColumn('RazorPayPaymentChannel').withOption('render', function (data) { if (data == null || data == "") return ""; else return data; }),
                DTColumnBuilder.newColumn('ComputedAmount').withOption('render', function (data) { if (data == null || data == "") return 0; else return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('MDRFee').withOption('render', function (data) { if (data == null || data == "") return 0; else return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('GSTFeeOnMDR').withOption('render', function (data) { if (data == null || data == "") return 0; else return $numUtils.toFixed(data); }),
               
                {
                    data: null,
                    render: function (data, type, row) {
                        if (data['Action'] == 'TransactionVoid') {
                            return $numUtils.toFixed(-data['Amount'] - (-data['MDRFee'] - data['GSTFeeOnMDR']));
                        }
                        return $numUtils.toFixed(data['Amount'] - data['MDRFee'] - data['GSTFeeOnMDR']);
                    }
                },
                DTColumnBuilder.newColumn('WalletId'),
                DTColumnBuilder.newColumn('UserCategoryType').withOption('render', function (data) { if (data == null || data == "") return "NA"; else return data; }),
                DTColumnBuilder.newColumn('StoreId'),
                DTColumnBuilder.newColumn('CampaignName').withOption('render', function (data) { if (data == null || data == "") return ""; else return data; }),
                DTColumnBuilder.newColumn('StudentId').withOption('render', function (data) { if (data == null || data == "") return "NA"; else return data; }),
                DTColumnBuilder.newColumn('InasisValue')
            ]
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.university')
        .controller('UniversityPaymentReportController', UniversityPaymentReportController);

    /** @ngInject */
    function UniversityPaymentReportController(DTOptionsBuilder, DTColumnBuilder, UniversityService, $filter
       , $q, $numUtils, $cookies) {
        var vm = this;
       

        vm.filter = {
            UniversityId: null,
            TransactionStartDate: null,
            TransactionEndDate: null,
            UserName: "",
            OrganizationCategory:null
        }
        
        vm.OrganizationCategory = [
            { Id: "1", Name: "University" },
            { Id: "2", Name: "IPT Fees" }
        ];

       

        //if ($$viewAsAdmin) {
        //    alert();
        //}
        var uni = null;
        var accountType = $cookies.get('account_type');
        if (accountType != 1) {
            $("#univeristyDiv").hide();
        }
        var cookie = $cookies.getObject('university');
        if (cookie[1] == 1) {
            uni = "UUM";
        } else if (cookie[3] == 1) {
            uni = "UiTM";
        } else if (cookie[5] == 1) {
            uni = "UPM";
        }
        

      
        
        vm.getUniversities = function () {
            UniversityService.GetPortalUniversity().then(function (data) {
                vm.universtyList = data.list;
            })
        }

       

        vm.tableInstance = {};

        vm.getReport = function () {
            var sdate = $("#sdate").val();
            var edate = $("#edate").val();
            if (sdate == null || sdate == "") {
                alert("Please select start date");
                return;
            }
            if (edate == null || edate == "") {
                alert("Please select end date");
                return;
            }
            vm.tableInstance.changeData(getReportPromise);

        }

        function getReportPromise() {

            var sdate = null;
            var edate = null;

            sdate = $("#sdate").val();
            edate = $("#edate").val();
            if (sdate != null && sdate != "") {
                var date1 = sdate.split('/');
                sdate = date1[2] + '-' + date1[1] + '-' + date1[0];
            }

            if (edate != null && edate != "") {
                var date2 = edate.split('/');
                edate = date2[2] + '-' + date2[1] + '-' + date2[0];
            }
            var username = vm.filter.UserName;
            var uId = vm.filter.UniversityId;
            var sId = vm.filter.OrganizationCategory;
            if (accountType == 1 && $("#UniversityId").val() == "") {
                alert("Please select university");
                return;
            }

            return UniversityService.getUniversityPaymentReport(sdate, edate, username, uId, sId);

        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'University Payment report'
                    },
                    {
                        extend: 'csv',
                        filename: 'University Payment report'
                    }
                ]),

            columns: [
                //DTColumnBuilder.newColumn('Id'),
                DTColumnBuilder.newColumn('TransactionId'),
                DTColumnBuilder.newColumn('CreatedAt').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('UserName'),
                DTColumnBuilder.newColumn('Email').withOption('render', function (data) { if (data == null || data == "") return ""; else return data; }),
                DTColumnBuilder.newColumn('OrganizationCategory'),
                DTColumnBuilder.newColumn('UniversityId'),
                DTColumnBuilder.newColumn('MerchantName').withOption('render', function (data) { if (data == null || data == "") return ""; else return data; }),
                DTColumnBuilder.newColumn('BillCode').withOption('render', function (data) { if (data == null || data == "") return ""; else return data; }),
                DTColumnBuilder.newColumn('AccountNumber').withOption('render', function (data) { if (data == null || data == "") return ""; else return data; }),
                DTColumnBuilder.newColumn('Cash').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Kiplekash').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Card').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Amount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Status'),
                DTColumnBuilder.newColumn('StudentId').withOption('render', function (data) { if (data == null || data == "") return "NA"; else return data; }),
                DTColumnBuilder.newColumn('InasisValue').withOption('render', function (data) { if (data == null || data == "") return ""; else return data; })
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.university')
        .controller('ReferralCodeSummaryReportController', ReferralCodeSummaryReportController);

    /** @ngInject */
    function ReferralCodeSummaryReportController(DTOptionsBuilder, DTColumnBuilder, MerchantReportService, $filter,
        MerchantService, UniversityService, StoreService, TransactionActionHashMap, AuthenticationService, $q, $numUtils, $cookies, $scope, $compile) {
        var vm = this;
        $("#PrincipalUserNameDiv").hide();
        $("#PrincipalReferralCodeDiv").hide();
        vm.filter = {
            RegStartDate: null,
            RegEndDate: null,
            RefStartDate: null,
            RefEndDate: null,
            ReferralCode:null
        };

        vm.Referral = {
            UserName: "",
            ReferralCode: ""
        };

       
        vm.edit = edit;
        vm.tableInstance = {};
        vm.UserDetails = {};
        //vm.getCount = {};
        vm.getReport = function () {
            var s = getReportPromise;
            vm.tableInstance.changeData(s);
        };
     

        function edit(full) {
            $("#PrincipalUserNameDiv").show();
            $("#PrincipalReferralCodeDiv").show();
             $("#Regsdate").val("");
             $("#Regedate").val("");
             $("#Refsdate").val("");
             $("#Refedate").val("");
             $("#RCodeFilter").val("");
            $("#PrincipalUserName").text(vm.UserDetails["UserName" + full]);
            if (vm.UserDetails["ReferralCode" + full] != null) {
                if (vm.UserDetails["ReferralCode" + full] != "") {
                    $("#PrincipalReferralCode").text(vm.UserDetails["ReferralCode" + full]);
                  //  vm.Referral.ReferralCode = vm.UserDetails["ReferralCode"];
                }
            }
            vm.tableInstance.changeData(UniversityService.GetReferralCodeSummaryReportBasedOnId(full))
        };

        //vm.getCount = function() {
        //    console.log("AB");
        //};


        function getReportPromise() {
            vm.UserDetails = {};
            $("#PrincipalUserNameDiv").hide();
            $("#PrincipalReferralCodeDiv").hide();
            var Regsdate = $("#Regsdate").val();
            var Regedate = $("#Regedate").val();
            var Refsdate = $("#Refsdate").val();
            var Refedate = $("#Refedate").val();
            var RCodeFilter =$("#RCodeFilter").val();
            if (Regsdate != null && Regsdate != "") {
                var date1 = Regsdate.split('/');
                Regsdate = date1[2] + '-' + date1[1] + '-' + date1[0];
            }

            if (Regedate != null && Regedate != "") {
                var date2 = Regedate.split('/');
                Regedate = date2[2] + '-' + date2[1] + '-' + date2[0];
            }

            if (Refsdate != null && Refsdate != "") {
                var date2 = Refsdate.split('/');
                Refsdate = date2[2] + '-' + date2[1] + '-' + date2[0];
            }
            if (Refedate != null && Refedate != "") {
                var date2 = Refedate.split('/');
                Refedate = date2[2] + '-' + date2[1] + '-' + date2[0];
            }

            if ( new Date(Regsdate) > new Date(Regedate)) {
                alert("End date should be greated than Start date");
                return;
            }
            if (new Date(Refsdate) > new Date(Refedate)) {
                alert("End date should be greated than Start date");
                return;
            }
            vm.filter = {
                RegStartDate: Regsdate,
                RegEndDate: Regedate,
                RefStartDate: Refsdate,
                RefEndDate: Refedate,
                ReferralCode: RCodeFilter
            };
            //var sdate = null;
            //var edate = null;

            //vm.filter = {
            //    RegStartDate: null,
            //    RegEndDate: null,
            //    RefStartDate: null,
            //    RefEndDate: null

            //};
         
            return UniversityService.GetReferralCodeSummaryReport(vm.filter);
        };

       
       
        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withOption('createdRow', createdRow)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Statement of account report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Statement of account report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('UserId'),
                DTColumnBuilder.newColumn('Name'),
                DTColumnBuilder.newColumn('Email'),
                DTColumnBuilder.newColumn('PhoneNumber'),
                DTColumnBuilder.newColumn('ReferalCode'),
                DTColumnBuilder.newColumn('ReferalDate').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
              //  DTColumnBuilder.newColumn('Count').withOption('render', function (data) { return "<a onclick='getReport();'>" + data + "</a>" }),
                DTColumnBuilder.newColumn('Used').renderWith(function (data, type, full) {
                    vm.UserDetails["UserName" + full.Id ] = full.Name;
                    vm.UserDetails["ReferralCode" + full.Id] = full.ReferalCode;
                    var typ = type;
                    var userId = full.UserId;
                    if (data == 0) {
                        return 0;
                    }
                    else {
                        return '<a href="#" ng-click="showcase.edit(' + full.Id + ')" style="text-decoration: underline">' + data + '</a>';
                    }
                    
                }),
                DTColumnBuilder.newColumn('Shared'),
                DTColumnBuilder.newColumn('RegistrationDate').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('Status'),
                DTColumnBuilder.newColumn('Tag')
              
            ]
        }
        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT  
            $compile(angular.element(row).contents())($scope);
        }  
    }
})();

(function () {
    'use strict';

    angular
        .module('app.university')
        .controller('UniversityOutletReportController', UniversityOutletReportController);

    /** @ngInject */
    function UniversityOutletReportController(DTOptionsBuilder, DTColumnBuilder, MerchantReportService, $filter,
        MerchantService, UniversityService, StoreService, TransactionActionHashMap, AuthenticationService, $q, $numUtils, $cookies) {
        var vm = this;

        vm.TransactionActionHashMap = TransactionActionHashMap;

        vm.filter = {
            TransactionId: null,
            MerchantId: null,
            StoreId: null,
            TransactionAction: null,
            TransactionStartDate: null,
            TransactionEndDate: null,
            CampusId: null            
        }
        
        vm.actionOptions = [
            TransactionActionHashMap['Payment'],
            TransactionActionHashMap['TransactionVoid'],
            TransactionActionHashMap['RedeemVoucher'],
            TransactionActionHashMap['PayAtTable']
        ];

        vm.showMerchantFilter = false;

        vm.merchants = [];
        vm.stores = [];

        //if ($$viewAsAdmin) {
        //    vm.showMerchantFilter = true;
        var uni = null;
        var accountType = $cookies.get('account_type');
        if (accountType != 1) {
            $("#univeristyDiv").hide();
        }

        var cookie = $cookies.getObject('university');
        if (cookie[1] == 1) {
            uni = "UUM";
        } else if (cookie[3] == 1) {
            uni = "UiTM";
        } else if (cookie[5] == 1) {
            uni = "UPM";
        }

        vm.getSelected = function () {
           uni = $("#UniversityId").val();
           var merchant = [];
            uni = $("#UniversityId").val();
            if (uni == "all" || uni == "" || uni == null) {
                var universityArray = [];
                UniversityService.GetListOfUniveristies().then(function (data) {
                    $.each(data.list, function (i, v) {
                        universityArray.push(v.UniversityId);
                        UniversityService.GetAllMerchantsPublicInfo(v.UniversityId).then(function (res) {

                            $.each(res.Items, function (i, v) {
                                if (v.State != "Deleted") {
                                    merchant.push(v);
                                }
                            })
                        })
                    })
                })
                //$("#UniversityId").val('');
                vm.merchants = merchant;
            } else {
                vm.LoadCampus(uni);
                UniversityService.GetAllMerchantsPublicInfo(uni).then(function (res) {

                    $.each(res.Items, function (i, v) {
                        if (v.State != "Deleted") {
                            merchant.push(v);
                        }
                    })
                    vm.merchants = merchant;
                })
            }
        }

        vm.LoadCampus = function (id) {
            UniversityService.GetCampusByUniversityId(id).then(function (res) {
                vm.CampusList = res.list;
            })

        }

        vm.getUniversities = function () {
            UniversityService.GetListOfUniveristies().then(function (data) {
                vm.universtyList = data.list;
            })
        }

        UniversityService.GetAllMerchantsPublicInfo(uni).then(function (res) {
           var merchant = [];
             $.each(res.Items, function (i, v) {
                    if (v.State != "Deleted") {
                        merchant.push(v);
                    }
                })


              vm.merchants = merchant;
            })

        

        StoreService.GetStoresPublicInfoGroupByMerchant({ MerchantId: vm.filter.MerchantId })
            .then(function (stores) {
                vm.stores = stores;
            })

        vm.tableInstance = {};

        vm.getReport = function () {
           var sdate = $("#sdate").val();
           var edate = $("#edate").val();
           if (sdate == null || sdate == "") {
                alert("Please select start date");
                return;
           }
           if (edate == null || edate == "") {
               alert("Please select end date");
               return;
           }
        
            vm.tableInstance.changeData(getReportPromise);
        }

        function getReportPromise() {

            var sdate = null;
            var edate = null;

            sdate = $("#sdate").val();
            edate = $("#edate").val();
          
            if (sdate != null && sdate != "") {
                var date1 = sdate.split('/');
                sdate = date1[2] + '-' + date1[1] + '-' + date1[0];
            }

            if (edate != null && edate != "") {
                var date2 = edate.split('/');
                edate = date2[2] + '-' + date2[1] + '-' + date2[0];
            }

            var tid = vm.filter.TransactionId;
            var type = vm.filter.TransactionAction;
            var merchantId = vm.filter.MerchantId;
            var storeId = vm.filter.StoreId;
            var cid = vm.filter.CampusId;
            var cName = '';
           
            if (accountType == 1 && $("#UniversityId").val() == "") {
                alert("Please select university");
                return;
            }
            return UniversityService.GetAccountStatement(sdate, edate, tid, type, merchantId, storeId, uni, cid,cName,null);
        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Outlet transactions report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('Id'),
                DTColumnBuilder.newColumn('CreatedAt').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('MerchantName'),
                DTColumnBuilder.newColumn('Action').withOption('render', function (data) {
                    if (TransactionActionHashMap[data] !== undefined) {
                        return $filter('translate')(TransactionActionHashMap[data].display);
                    }
                    else {
                        return data;
                    }
                }),
                DTColumnBuilder.newColumn('ComputedAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('KiplekashCashback').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Remarks'),
                DTColumnBuilder.newColumn('WalletId'),
                DTColumnBuilder.newColumn('UserCategoryType').withOption('render', function (data) { if (data == null || data == "") return "NA"; else return data; }),
                DTColumnBuilder.newColumn('StudentId').withOption('render', function (data) { if (data == null || data == "") return "NA"; else return data; }),               
                DTColumnBuilder.newColumn('CampaignName'),
                DTColumnBuilder.newColumn('InasisValue')
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.store', ['mwl.confirm', 'ngFileUpload', 'uiGmapgoogle-maps'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.store', {
                url: '/store',
                abstract: true,
                protect: true
            })
            .state('app.store.list', {
                url: '/',
                views: {
                    'main@app': {
                        templateUrl: 'app/store/store.html',
                        controller: 'StoreController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_STORE'],
                resolve: {
                    /** @ngInject */
                    ngGMap: function (uiGmapGoogleMapApi) {
                        return uiGmapGoogleMapApi;
                    }
                }
            })
            .state('app.store.manager', {
                url: '/manager',
                views: {
                    'main@app': {
                        templateUrl: 'app/store/manager/store.manager.html',
                        controller: 'ManagerController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['ADD_MANAGER_TO_STORE']
            })
            .state('app.store.terminal', {
                url: '/terminal',
                views: {
                    'main@app': {
                        templateUrl: 'app/store/terminal/store.terminal.html',
                        controller: 'TerminalController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['ADD_TERMINAL_TO_STORE', 'REMOVE_TERMINAL_FROM_STORE']
            })
            .state('app.store.table', {
                url: '/table',
                views: {
                    'main@app': {
                        templateUrl: 'app/store/table/table.html',
                        controller: 'TableController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['MANAGE_TABLE']
            })
            .state('app.store.static_qr', {
                url: '/:storeId/static-qr',
                views: {
                    'main@app': {
                        templateUrl: 'app/store/static-qr/static-qr.html',
                        controller: 'StaticQRController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['MANAGE_STATIC_QR']
            })
            .state('app.store.profile', {
                url: '/profile',
                views: {
                    'main@app': {
                        templateUrl: 'app/store/profile/store.profile.html',
                        controller: 'StoreProfileController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['VIEW_STORE', 'EDIT_STORE']
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/store');

    }
})();
(function () {
    'use strict';

    angular
        .module('app.store')
        .factory('TerminalService', TerminalService);

    /** @ngInject */
    function TerminalService(SVCS, $http, $q, CoreService) {
        var gatewayServer = SVCS.Gateway;
        var authServer = SVCS.Auth;
        var service = {
            Search: Search,
            Update: Update,
            Remove: Remove
        };

        return service;

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Post(gatewayServer + '/api/internal/user/search/store/terminal', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(terminal) {
            var deferer = $q.defer();

            CoreService.Put(authServer + '/api/account/internal/store/terminal', terminal).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Remove(posId) {
            var deferer = $q.defer();

            CoreService.Delete(authServer + '/api/account/internal/store/' + posId).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.store')
        .controller('TerminalController', TerminalController);

    /** @ngInject */
    function TerminalController(SVCS, TerminalService, StoreService) {
        var vm = this;
        vm.criteria = { Keyword: null, Page: 1, Length: 10 };
        vm.showDialog = false;
        vm.itemsPerPage = vm.criteria.Length;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.terminal = {}
        vm.viewConfig = { ShowEditUserDialog: false };

        vm.search = function () {
            vm.criteria.Page = vm.currentPage;
            TerminalService.Search(vm.criteria).then(function (res) {
                vm.terminals = res.Items;
                vm.totalItems = res.Total;
            })
        }

        vm.reset = function () {
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }

        vm.search();

        vm.edit = function (terminal) {
            vm.viewConfig.ShowEditUserDialog = true;
            vm.terminal = terminal;
        }

        vm.saveTerminal = function (terminal) {

            TerminalService.Update(terminal).then(function () {
                vm.viewConfig.ShowEditUserDialog = false;
            })
        }

        vm.removeTerminal = function (terminalId) {
            StoreService.RemoveTerminal(terminalId).then(function (res) {
                vm.search();
            })
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.store')
        .factory('StaticQRService', StaticQRService);

    /** @ngInject */
    function StaticQRService(SVCS, $http, $q, CoreService) {
        var merchantServer = SVCS.Merchant;

        var service = {
            Get: Get,
            Search: Search,
            Create: Create,
            Update: Update,
            Remove: Remove
        };

        return service;

        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/static-qrs/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/static-qrs/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(static_qr) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/static-qrs', static_qr).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(static_qr) {
            var deferer = $q.defer();

            CoreService.Put(merchantServer + '/api/static-qrs', static_qr).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Remove(id) {
            var deferer = $q.defer();

            CoreService.Delete(merchantServer + '/api/static-qrs/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.store')
        .controller('StaticQRController', StaticQRController);

    /** @ngInject */
    function StaticQRController(SVCS, $translate, $cookies, $scope, $timeout, $rootScope, StaticQRService, $stateParams, StoreService, QRCodeService, AuthenticationService, $state) {
        var vm = this;
        vm.criteria = { Keyword: null, Page: 1, Length: 10, StoreId: $stateParams.storeId};
        vm.showDialog = false;
        vm.qrcodeDialog = false;
        vm.action;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;
        vm.Tag = localStorage.getItem('apptype');
        AuthenticationService.GetPermission($cookies.get("account_id")).then(function (res) {
            if (res.indexOf("MANAGE_STATIC_QR") == -1) {
                alert("You don't have this permission, please login again...");
                AuthenticationService.signOut();
                $state.go('auth.login');
            }
        });

        StoreService.Get($stateParams.storeId).then(function (res) {
            vm.storeName = res.Name;
        });

        vm.search = function () {
            vm.criteria.Page = vm.currentPage;
            StaticQRService.Search(vm.criteria).then(function (res) {
                vm.static_qrs = res.Items;
                vm.totalItems = res.Total;
            })
        }

        vm.add = function () {
            $scope.staticQRForm.$setPristine();
            $scope.staticQRForm.$setUntouched();
            vm.showDialog = true;
            vm.action = 'new';
            vm.static_qr = { StoreId: $stateParams.storeId };
        }

        vm.getQRCode = function (id) {
            QRCodeService.Create(id).then(function (res) {
                vm.qrcode = "data:image/png;base64," + res.Result;
                vm.qrcodeDialog = true;
            })
        }

        vm.print = function () {
            var divToPrint = document.getElementById('qrcodeBody');

            var newWin = window.open('', 'Print-Window');

            newWin.document.open();

            newWin.document.write('<html><body onload="window.print()">' + divToPrint.innerHTML + '</body></html>');

            newWin.document.close();

            setTimeout(function () { newWin.close(); }, 10);
        }

        vm.edit = function (staticQR) {
            $scope.staticQRForm.$setPristine();
            $scope.staticQRForm.$setUntouched();
            vm.showDialog = true;
            vm.action = 'edit';

            vm.static_qr = angular.copy(staticQR);
        }

        vm.save = function () {
            if (!$scope.staticQRForm.$valid) {
                angular.forEach($scope.staticQRForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#staticQRForm .ng-invalid')[0].focus();
                return;
            }

            if (vm.action == 'new') {
                StaticQRService.Create(vm.static_qr).then(function (res) {
                    vm.showDialog = false;
                    vm.action = undefined;
                    vm.search();
                })
            }
            else if (vm.action = 'edit') {
                StaticQRService.Update(vm.static_qr).then(function (res) {
                    vm.showDialog = false;
                    vm.action = undefined;
                    vm.search();
                })
            }
        }

        vm.remove = function (id) {
            $translate("store.static_qr.confirm_remove").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }
                StaticQRService.Remove(id).then(function (res) {
                    var static_qr = vm.static_qrs.findItem('Id', id);
                    if (static_qr) {
                        vm.static_qrs.removeItem(static_qr);
                    }
                });
            })
        }

        vm.search();

        // Active & Inactive
        vm.inActive = function (staticQR) {
            QRCodeService.InActive(staticQR.QrCodeId).then(function (res) {
                staticQR.Status = 'InActive';
            })
        }

        vm.active = function (staticQR) {
            QRCodeService.Active(staticQR.QrCodeId).then(function (res) {
                staticQR.Status = 'Active';
            })
        }
        // End

        vm.createFull = function () {
            vm.listQRCodeDialog = true;

            vm.qrCodes = [];

            StaticQRService.Search({ StoreId: $stateParams.storeId }).then(function (res) {
                angular.forEach(res.Items, function (static_qr) {
                    QRCodeService.Create(static_qr.QrCodeId).then(function (image) {
                        vm.qrCodes.push({ Image: "data:image/png;base64," + image.Result, TableName: static_qr.Name });
                    })
                });
            })
        }

        vm.printList = function () {
            var divToPrint = document.getElementById('qrCodeListBody');

            var newWin = window.open('', 'Print-Window');

            var css = "";
            css += "<style>";
            css += "\
                .modal-content-A {\
                    -webkit-transform: scale(1.5);  /* Saf3.1+, Chrome */\
                    -moz-transform: scale(1.5);  /* FF3.5+ */\
                    -ms-transform: scale(1.5);  /* IE9 */\
                    -o-transform: scale(1.5);  /* Opera 10.5+ */\
                    transform: scale(1.5);\
                    transform-origin: 0 0;\
                    width: 562px; }\
                .modal-content-A .qr-code {\
                    width: 140px;\
                    height: 192px;\
                    float: left; }\
                .modal-content-A .qr-code .image {\
                    width: 105px;\
                    height: 105px;\
                    margin: 17.5px 17.5px 0 17.5px; }\
                .modal-content-A .qr-code .title {\
                    display: inline-block;\
                    width: 105px;\
                    height: 30px;\
                    margin: 0 17.5px 17.5px 17.5px;\
                    text-align: center; }\
                \
                .modal-content-B {\
                    -webkit-transform: scale(1.5);  /* Saf3.1+, Chrome */\
                    -moz-transform: scale(1.5);  /* FF3.5+ */\
                    -ms-transform: scale(1.5);  /* IE9 */\
                    -o-transform: scale(1.5);  /* Opera 10.5+ */\
                    transform: scale(1.5);\
                    transform-origin: 0 0;\
                    width: 527px; }\
                .modal-content-B .qr-code {\
                    width: 105px;\
                    height: 143px;\
                    float: left; }\
                .modal-content-B .qr-code .image {\
                    width: 70px;\
                    height: 70px;\
                    margin: 12.5px 17.5px 0 17.5px; }\
                .modal-content-B .qr-code .title {\
                    display: inline-block;\
                    width: 70px;\
                    height: 25px;\
                    margin: 0 17.5px 12.5px 17.5px;\
                    text-align: center; }\
            ";
            css += "</style>";

            newWin.document.open();

            if (vm.qrCodes.length <= 16) {
                newWin.document.write('<html><body onload="window.print()"><div class="modal-content-A">' + css + divToPrint.innerHTML + '</div></body></html>');
            }
            else {
                newWin.document.write('<html><body onload="window.print()"><div class="modal-content-B">' + css + divToPrint.innerHTML + '</div></body></html>');
            }

            newWin.document.close();

            setTimeout(function () { newWin.close(); }, 10);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.store')
        .factory('TableService', TableService);

    /** @ngInject */
    function TableService(SVCS, $http, $q, CoreService) {
        var merchantServer = SVCS.Merchant;

        var service = {
            Search: Search,
            Create: Create,
            Update: Update,
            Remove: Remove
        };

        return service;

        function Search(criteria) {
            var deferer = $q.defer();
            CoreService.Get(merchantServer + '/api/tables/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(table) {
            var deferer = $q.defer();
            CoreService.Post(merchantServer + '/api/tables', table).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(table) {
            var deferer = $q.defer();

            CoreService.Put(merchantServer + '/api/tables', table).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Remove(tableId, storeId) {
            var deferer = $q.defer();

            CoreService.Delete(merchantServer + '/api/tables/' + tableId + '/' + storeId).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.store')
        .controller('TableController', TableController);

    /** @ngInject */
    function TableController(SVCS, $translate, $cookies, TableService, QRCodeService, StoreService, BrandService, $scope, MerchantService, $timeout, $rootScope ) {
        var vm = this;
        vm.criteria = { Keyword: null, Page: 1, Length: 10 };
        vm.showDialog = false;
        vm.qrcodeDialog = false;
        vm.action;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;

        vm.selectedStoreId = '';
        vm.isAdmin = $cookies.get('account_type') == 1 ? true : false;

        vm.search = function () {
            vm.criteria.Page = vm.currentPage;
            TableService.Search(vm.criteria).then(function (res) {
                vm.tables = res.Items;
                vm.totalItems = res.Total;
            })
        }

        vm.reset = function () {
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }

        vm.LoadStoreDetails = function (key) {
            if (key.length > 2) {
                if (vm.isAdmin) {
                    vm.criteria = { Keyword: key };
                    StoreService.Search(vm.criteria).then(function (res) {
                        vm.stores = [];
                        angular.forEach(res.Items, function (item) {
                            vm.stores = res.Items;
                            //vm.stores.push({ Id: item.Id, FullName: item.Name });
                        })

                    });
                }
                else {
                    vm.getListStoreByMerchantId();
                }
            }
        }


        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }

        vm.add = function () {
            $scope.tableForm.$setPristine();
            $scope.tableForm.$setUntouched();
            vm.showDialog = true;
            vm.action = 'new';
            vm.table = {};

            //if (vm.isAdmin) {
            //    StoreService.Search().then(function (res) {
            //        vm.stores = [];
            //        angular.forEach(res.Items, function (item) {
            //      //      vm.stores = res.Items;
            //            //vm.stores.push({ Id: item.Id, FullName: item.Name });
            //        })

            //    });
            //}
            //else {
            //    vm.getListStoreByMerchantId();
            //}
        }

        vm.edit = function (table) {
            $scope.tableForm.$setPristine();
            $scope.tableForm.$setUntouched();
            vm.showDialog = true;
            vm.action = 'edit';
            vm.table = {};

            if (vm.isAdmin) {
                StoreService.Get(table.StoreId).then(function (res) {
                    vm.stores = [];
                    if (res != null) {
                        //angular.forEach(res.Items, function (item) {
                        vm.stores.push({ Id: res.Id, Name: res.Name });
                            //  vm.stores = res.Items;
                        //})
                    }
                });
            }
            else {
                vm.getListStoreByMerchantId();
            }

            vm.table = angular.copy(table);
        }

        vm.chooseActionCeateQRCodeDialog = false;
        vm.actionCreateQRCode = "PayAtTable";
        vm.getQRCode = function (table) {
            vm.showUnifyQR = false;
            vm.actionType = ''
            StoreService.IsStoreBelongToPrimaryMerchant(table.StoreId).then(function (res) {
                if (res) {
                    StoreService.IsStoreBelongToUnifyQr(table.StoreId).then(function (result) {
                        if (result) {
                            BrandService.GetByStoreId(table.StoreId).then(function (res) {
                                qrcode = { Action: 'UnifyQR', Payload: { TableId: table.Id, StoreId: table.StoreId, TableName: table.Name, BrandId: res.Id, BrandName: res.Name } };

                                QRCodeService.Generate(qrcode).then(function (res) {
                                    vm.qrcode = "data:image/png;base64," + res.Result;
                                    vm.qrcodeDialog = true;
                                    vm.tableName = table.Name;
                                    vm.storeName = table.StoreName;
                                    vm.actionType = 'UnifyQR'
                                });
                                vm.chooseActionCeateQRCodeDialog = false;
                            })
                        }
                        vm.table = table;
                    });
                }
                else {
                    var qrcode = { Action: 'PayAtTable', Payload: { TableId: table.Id, StoreId: table.StoreId, TableName: table.Name } };

                    QRCodeService.Generate(qrcode).then(function (res) {
                        vm.qrcode = "data:image/png;base64," + res.Result;
                        vm.qrcodeDialog = true;
                        vm.tableName = table.Name;
                        vm.storeName = table.StoreName;
                        vm.actionType = 'Order@Table/Pay@Table';
                    });
                }
            });
        }

        vm.generateQRCode = function () {
            var table = vm.table;
            var qrcode = null;

            if (vm.actionCreateQRCode == 'UnifyQR') {
                BrandService.GetByStoreId(table.StoreId).then(function (res) {
                    qrcode = { Action: 'UnifyQR', Payload: { TableId: table.Id, StoreId: table.StoreId, TableName: table.Name, BrandId: res.Id, BrandName: res.Name } };

                    QRCodeService.Generate(qrcode).then(function (res) {
                        vm.qrcode = "data:image/png;base64," + res.Result;
                        vm.qrcodeDialog = true;
                        vm.tableName = table.Name;
                        vm.storeName = table.StoreName;
                    });
                    vm.chooseActionCeateQRCodeDialog = false;
                })
            }
            else {
                qrcode = { Action: 'PayAtTable', Payload: { TableId: table.Id, StoreId: table.StoreId, TableName: table.Name } };

                QRCodeService.Generate(qrcode).then(function (res) {
                    vm.qrcode = "data:image/png;base64," + res.Result;
                    vm.qrcodeDialog = true;
                    vm.tableName = table.Name;
                    vm.storeName = table.StoreName;
                });
                vm.chooseActionCeateQRCodeDialog = false;
            }
        }

        vm.print = function () {
            var divToPrint = document.getElementById('qrcodeBody');

            var newWin = window.open('', 'Print-Window');

            newWin.document.open();

            newWin.document.write('<html><body onload="window.print()">' + divToPrint.innerHTML + '</body></html>');

            newWin.document.close();

            setTimeout(function () { newWin.close(); }, 10);
        }

        vm.save = function () {

            if (!$scope.tableForm.$valid) {
                angular.forEach($scope.tableForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#tableForm .ng-invalid')[0].focus();
                return;
            }

            if (vm.action == 'new') {
                TableService.Create(vm.table).then(function (res) {
                    vm.tables.unshift({ Id: res.Id, Name: res.Name, NumberOfSeat: res.NumberOfSeat, StoreId: res.StoreId, StoreName: res.StoreName });
                    vm.showDialog = false;
                    vm.action = undefined;
                })
            }
            else {
                TableService.Update(vm.table).then(function () {
                    vm.showDialog = false;
                    vm.action = undefined;
                    vm.search();
                })
            }
        }

        vm.remove = function (tableId) {
            $translate("store.confirm_remove_table").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }
                var table = vm.tables.findItem('Id', tableId);
                var storeId = table.StoreId;

                TableService.Remove(tableId, storeId).then(function (res) {
                    var table = vm.tables.findItem('Id', tableId);
                    if (table) {
                        vm.tables.removeItem(table);
                    }
                });
            })
        }

        vm.getListStoreByMerchantId = function () {
            StoreService.GetStoresByMerchantLogin().then(function (res) {
                vm.stores = res;
            });
        };

        vm.search();

        //#region Create QR Code
        vm.openQRCode = function () {
            vm.createQRCodeDialog = true;
            vm.qrCode = {};
            $scope.qrCodeForm.$setPristine();
            $scope.qrCodeForm.$setUntouched();

            if (!vm.isAdmin) {
                $timeout(function () {
                    vm.qrCode.MerchantId = $rootScope.authenticationService.account.Id;
                    
                    vm.merchantIdChanged();
                }, 100);
            } else {
                MerchantService.Search({}).then(function (res) {
                    vm.merchants = res.Items;
                });
            }
        }
        vm.merchantIdChanged = function () {
            StoreService.Search({ MerchantId: vm.qrCode.MerchantId}).then(function (res) {
                vm.stores = res.Items;
            });

            MerchantService.Get(vm.qrCode.MerchantId).then(function (data) {
                vm.merchant = data;
            });

            $scope.qrCodeForm.$setPristine();
            $scope.qrCodeForm.$setUntouched();
        }

        vm.storeIdChanged = function () {
            vm.showUnifyQR = false;
            //vm.qrCode.StoreId = "";
            vm.isUnify = false;
            StoreService.IsStoreBelongToUnifyQr(vm.qrCode.StoreId).then(function (result) {
                if (result) {
                    vm.isUnify = true;
                }

                if (vm.isUnify) {
                    vm.showUnifyQR = true;
                }
            })
        };

        vm.createQRCode = function (e) {
            if (!$scope.qrCodeForm.$valid) {
                angular.forEach($scope.qrCodeForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#qrCodeForm .ng-invalid')[0].focus();
                return;
            }

            if (!vm.merchant.IsMain && vm.qrCode.Action == 'UnifyQR') {
                alert('You can not create Unify QR for non primary merchant');
                return;
            }

            vm.createQRCodeDialog = false;

            vm.qrCodes = [];
            
            var action = vm.qrCode.Action;           
            if (action == 'PayAtTable') {
                TableService.Search({}).then(function (tables) {
                    angular.forEach(tables.Items, function (table) {
                        if (table.StoreId == vm.qrCode.StoreId) {
                            QRCodeService.Generate({
                                Action: "PayAtTable",
                                Payload: { TableId: table.Id, StoreId: table.StoreId, TableName: table.Name, StoreName: table.StoreName, MerchantName: table.MerchantName }

                            }).then(function (image) {
                                vm.qrCodes.push({ Image: "data:image/png;base64," + image.Result, Id: table.Id, TableName: table.Name });
                                vm.listQRCodeDialog = true;
                            })
                        }
                    });
                })
            } else {
                TableService.Search({}).then(function (tables) {
                    angular.forEach(tables.Items, function (table) {
                        if (table.StoreId == vm.qrCode.StoreId) {
                            BrandService.GetByStoreId(table.StoreId).then(function (res) {
                                var qrcode = { Action: 'UnifyQR', Payload: { TableId: table.Id, StoreId: table.StoreId, TableName: table.Name, BrandId: res.Id, BrandName: res.Name } };
                                QRCodeService.Generate(qrcode).then(function (image) {      
                                    vm.qrCodes.push({ Image: "data:image/png;base64," + image.Result, Id: table.Id, TableName: table.Name });
                                    vm.listQRCodeDialog = true;
                                });                                
                            })
                        }
                    });
                });               
            }
        }

        vm.printList = function () {
            var divToPrint = document.getElementById('qrCodeListBody');

            var newWin = window.open('','Print-Window');

            var css = "";
            css += "<style>";
            css += "\
                .modal-content-A {\
                    -webkit-transform: scale(1.5);  /* Saf3.1+, Chrome */\
                    -moz-transform: scale(1.5);  /* FF3.5+ */\
                    -ms-transform: scale(1.5);  /* IE9 */\
                    -o-transform: scale(1.5);  /* Opera 10.5+ */\
                    transform: scale(1.5);\
                    transform-origin: 0 0;\
                    width: 562px; }\
                .modal-content-A .qr-code {\
                    width: 140px;\
                    height: 192px;\
                    float: left; }\
                .modal-content-A .qr-code .image {\
                    width: 105px;\
                    height: 105px;\
                    margin: 17.5px 17.5px 0 17.5px; }\
                .modal-content-A .qr-code .title {\
                    display: inline-block;\
                    width: 105px;\
                    height: 30px;\
                    margin: 0 17.5px 17.5px 17.5px;\
                    text-align: center; }\
                \
                .modal-content-B {\
                    -webkit-transform: scale(1.5);  /* Saf3.1+, Chrome */\
                    -moz-transform: scale(1.5);  /* FF3.5+ */\
                    -ms-transform: scale(1.5);  /* IE9 */\
                    -o-transform: scale(1.5);  /* Opera 10.5+ */\
                    transform: scale(1.5);\
                    transform-origin: 0 0;\
                    width: 527px; }\
                .modal-content-B .qr-code {\
                    width: 105px;\
                    height: 143px;\
                    float: left; }\
                .modal-content-B .qr-code .image {\
                    width: 70px;\
                    height: 70px;\
                    margin: 12.5px 17.5px 0 17.5px; }\
                .modal-content-B .qr-code .title {\
                    display: inline-block;\
                    width: 70px;\
                    height: 25px;\
                    margin: 0 17.5px 12.5px 17.5px;\
                    text-align: center; }\
            ";
            css += "</style>";

            newWin.document.open();

            if (vm.qrCodes.length <= 16) {
                newWin.document.write('<html><body onload="window.print()"><div class="modal-content-A">' + css + divToPrint.innerHTML + '</div></body></html>');
            }
            else {
                newWin.document.write('<html><body onload="window.print()"><div class="modal-content-B">' + css + divToPrint.innerHTML + '</div></body></html>');
            }

            newWin.document.close();

            setTimeout(function () { newWin.close(); }, 10);
        }
        
        //#endregion

        vm.cleanStoreChanged = function () {
            vm.qrCode.MerchantId = "";
            vm.qrCode.StoreId = "";
            vm.showDialog = false;
            vm.stores = [];
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.store')
        .controller('ManagerController', ManagerController);

    /** @ngInject */
    function ManagerController(SVCS, $cookies, ManagerService, StoreService) {
        var vm = this;
        vm.criteria = {
            Keyword: null,
            Page: 1,
            Length: 10,
        }

        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 5;
        vm.itemsPerPage = 5;
        vm.isAdmin = $cookies.get('account_type') == 1 ? true : false;


        vm.search = function () {
            vm.criteria.Page = vm.currentPage;
            ManagerService.Search(vm.criteria).then(function (res) {
                vm.managers = res.Items;
                vm.totalItems = res.Total;
            })
        }

        vm.setStatus = function (manager, status) {
            var model = { Id: manager.Id, Status: status };
            ManagerService.UpdateStatus(model).then(function () {
                manager.Status = status;
            })
        }
      

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }

        vm.reset = function () {
            vm.criteria = {
                Keyword: null,
                Page: 1,
                Length: 10,
                SortName: '',
                OrderBy: '',
            }
            vm.currentPage = 1;
            vm.search();
        }  

        vm.search();

        vm.searchStore = function () {
            vm.criteria.Page = vm.currentPage;

            StoreService.Search(vm.criteria).then(function (res) {
                vm.stores = res.Items;
                vm.totalItems = res.Total;
            })
        }

        vm.reset = function () {
            vm.criteria = {
                Keyword: null,
                AveragePrice: null,
                Page: 1,
                Length: 10,
                MerchantId: null,
                SortName: '',
                OrderBy: '',
            }
            vm.currentPage = 1;
            vm.search();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.store')
        .factory('ManagerService', ManagerService);

    /** @ngInject */
    function ManagerService(SVCS, $http, $q, CoreService) {
        var managerServer = SVCS.Merchant;
        var service = {
            Search: Search,
            UpdateStatus: UpdateStatus,
            Create: Create
        };

        return service;

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Post(managerServer + '/api/store/managers/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function UpdateStatus(model) {
            var deferer = $q.defer();

            CoreService.Put(managerServer + '/api/store/managers/update/status', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(model) {
            var deferer = $q.defer();

            CoreService.Post(managerServer + '/api/store/managers', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
    }
})();
(function () {
  "use strict";

  angular.module("app.rcbmara", [
    "app.core",
    "datatables",
    "datatables.bootstrap",
    "datatables.buttons",
  ]);
})();

(function () {
  "use strict";

  angular
    .module("app.rcbmara")
    .factory("RcbMaraReportService", RcbMaraReportService);

  /** @ngInject */
  function RcbMaraReportService(SVCS, $http, $q) {
    var service = {
      getEaseWithdrawalReport: getEaseWithdrawalReport,
    };

    return service;

    function getEaseWithdrawalReport(filter) {
      var deferer = $q.defer();

      console.log("RcbMaraReportService: API request", filter);

      $http
        .get(SVCS.Report + "/api/rcbmara/ease-withdrawal", { params: filter })
        .then(
          function (response) {
            console.log(
              "RcbMaraReportService: API response success",
              response.data
            );
            deferer.resolve(response.data);
          },
          function (responseError) {
            console.error(
              "RcbMaraReportService: API response error",
              responseError
            );
            deferer.reject(responseError.data || responseError);
          }
        );

      return deferer.promise;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("app.rcbmara")
    .controller(
      "EaseWithdrawalReportController",
      EaseWithdrawalReportController
    );

  EaseWithdrawalReportController.$inject = [
    "DTOptionsBuilder",
    "DTColumnBuilder",
    "$q",
    "$filter",
    "RcbMaraReportService",
  ];

  /** @ngInject */
  function EaseWithdrawalReportController(
    DTOptionsBuilder,
    DTColumnBuilder,
    $q,
    $filter,
    RcbMaraReportService
  ) {
    var vm = this;

    vm.datePopup = {
      StartOpen: false,
      EndOpen: false,
    };

    vm.filter = {
      TransactionStartDate: null,
      TransactionEndDate: null,
    };

    vm.tableInstance = {
      reloadData: function () {
      },
    };

    $.fn.dataTable.Buttons = $.fn.DataTable.Buttons;

    vm.dataTable = {
      options: DTOptionsBuilder.fromFnPromise(function () {
        var deferer = $q.defer();
        deferer.resolve([]);
        return deferer.promise;
      })
        .withBootstrap()
        .withOption("pageLength", 100)
        .withOption("searching", true)
        .withOption("lengthChange", true)
        .withDOM("Blfrtip")
        .withOption(
          "dom",
          '<"row"<"col-sm-6"l><"col-sm-6"f>><"row"<"col-sm-12"B>><"row"<"col-sm-12"tr>><"row"<"col-sm-5"i><"col-sm-7"p>>'
        )
        .withButtons([
          {
            extend: "print",
            text: "Print",
            title: "EASE Withdrawal Report",
            exportOptions: {
              modifier: {
                page: "current",
              },
            },
          },
          {
            extend: "csv",
            text: "CSV",
            filename: function () {
              return (
                "EASE_Withdrawal_Report_" + moment().format("YYYYMMDD_HHmmss")
              );
            },
            exportOptions: {
              columns: ":visible",
            },
            action: function (e, dt, button, config) {
              console.log(
                "CSV button clicked. Data length:",
                dt.rows().count()
              );

              if (dt.rows().count() === 0) {
                alert("No data available to export.");
                return false;
              }

              try {
                var exportData = dt.buttons.exportData(config.exportOptions);
                $.fn.dataTable.ext.buttons.csvHtml5.action.call(
                  this,
                  e,
                  dt,
                  button,
                  config
                );
              } catch (error) {
                console.error("CSV export error:", error);
                alert("Error exporting to CSV: " + error.message);
              }
            },
          },
        ]),

      columns: [
        DTColumnBuilder.newColumn("Mid").withTitle("MID"),
        DTColumnBuilder.newColumn("TransactionId").withTitle("Transaction ID"),
        DTColumnBuilder.newColumn("WakaluTransactionId").withTitle(
          "Wakalu Transaction ID"
        ),
        DTColumnBuilder.newColumn("TransactionDate")
          .withTitle("Transaction Date")
          .renderWith(function (data) {
            return moment(data).format("DD/MM/YYYY HH:mm:ss");
          }),
        DTColumnBuilder.newColumn("UserName").withTitle("UserName"),
        DTColumnBuilder.newColumn("FullName").withTitle("FullName"),
        DTColumnBuilder.newColumn("IdType")
          .withTitle("IDType")
          .renderWith(function (data) {
            return data === "1" ||
              (typeof data === "string" && data.toLowerCase() === "nric")
              ? "NRIC"
              : data;
          }),
        DTColumnBuilder.newColumn("IdNumber").withTitle("ID Number (NRIC)"),
        DTColumnBuilder.newColumn("TransactionType").withTitle(
          "Transaction Type"
        ),
        DTColumnBuilder.newColumn("WithdrawalReason").withTitle(
          "Withdrawal Reason"
        ),
        DTColumnBuilder.newColumn("Status").withTitle("Status"),
        DTColumnBuilder.newColumn("RequestedAmount")
          .withTitle("Requested Amount")
          .renderWith(function (data) {
            return data ? $filter("currency")(data, "RM ") : "RM 0.00";
          }),
        DTColumnBuilder.newColumn("CreditedAmount")
          .withTitle("Credited Amount")
          .renderWith(function (data) {
            return data ? $filter("currency")(data, "RM ") : "RM 0.00";
          }),
        DTColumnBuilder.newColumn("ProcessingFee")
          .withTitle("Processing Fee")
          .renderWith(function (data) {
            return data ? $filter("currency")(data, "RM ") : "RM 0.00";
          }),
      ],
    };

    vm.getReport = function () {
      if (!vm.filter.TransactionStartDate || !vm.filter.TransactionEndDate) {
        alert("Please select both start and end dates.");
        return;
      }

      if (
        moment(vm.filter.TransactionEndDate).isBefore(
          vm.filter.TransactionStartDate
        )
      ) {
        alert("End date cannot be before start date.");
        return;
      }

      var startDate = moment(vm.filter.TransactionStartDate).format(
        "YYYY-MM-DD"
      );
      var endDate = moment(vm.filter.TransactionEndDate).format("YYYY-MM-DD");

      var promiseFn = function () {
        return getReportPromise(startDate, endDate);
      };

      if (vm.tableInstance && angular.isFunction(vm.tableInstance.changeData)) {
        vm.tableInstance.changeData(promiseFn);
        return;
      }

      vm.dataTable.options = DTOptionsBuilder.fromFnPromise(promiseFn)
        .withBootstrap()
        .withOption("pageLength", 100)
        .withOption("searching", true)
        .withOption("lengthChange", true)
        .withOption("processing", true)
        .withDOM("Blfrtip")
        .withOption(
          "dom",
          '<"row"<"col-sm-6"l><"col-sm-6"f>><"row"<"col-sm-12"B>><"row"<"col-sm-12"tr>><"row"<"col-sm-5"i><"col-sm-7"p>>'
        )
        .withButtons([
          {
            extend: "print",
            text: "Print",
            title: "EASE Withdrawal Report",
            exportOptions: { modifier: { page: "current" } },
          },
          {
            extend: "csv",
            text: "CSV",
            filename: function () {
              return (
                "EASE_Withdrawal_Report_" + moment().format("YYYYMMDD_HHmmss")
              );
            },
            exportOptions: { columns: ":visible" },
            action: function (e, dt, button, config) {
              if (dt.rows().count() === 0) {
                alert("No data available to export.");
                return false;
              }
              $.fn.dataTable.ext.buttons.csvHtml5.action.call(
                this,
                e,
                dt,
                button,
                config
              );
            },
          },
        ]);

      if (vm.tableInstance && vm.tableInstance.reloadData) {
        vm.tableInstance.reloadData();
      }
    };

    function getReportPromise(startDate, endDate) {
      var jsonData = {
        TransactionStartDate: startDate,
        TransactionEndDate: endDate,
      };

      var defer = $q.defer();


      RcbMaraReportService.getEaseWithdrawalReport(jsonData).then(
        function (response) {

          if (response && response.records && response.records.length > 0) {
            vm.hasData = true;
            vm.reportData = response.records;
            defer.resolve(response.records);
          } else {
            vm.hasData = false;
            vm.reportData = [];
            alert(
              "No EASE withdrawal transactions found for the selected period."
            );
            defer.resolve([]);
          }
        },
        function (error) {
          vm.hasData = false;
          vm.reportData = [];
          alert(
            "Failed to retrieve data. Please try again later. Error: " +
              (error.message || "Unknown error")
          );
          defer.resolve([]);
        }
      );

      return defer.promise;
    }

    // Manual CSV export function as fallback
    vm.exportToCSV = function () {
      if (!vm.reportData || vm.reportData.length === 0) {
        alert("No data available to export.");
        return;
      }

      try {
        // Create CSV content
        var csvContent = "data:text/csv;charset=utf-8,";

        // Add header row
        var headers = [
          "MID",
          "Transaction ID",
          "Wakalu Transaction ID",
          "Transaction Date",
          "UserName",
          "FullName",
          "IDType",
          "ID Number (NRIC)",
          "Transaction Type",
          "Withdrawal Reason",
          "Status",
          "Requested Amount",
          "Credited Amount",
          "Processing Fee",
        ];
        csvContent += headers.join(",") + "\n";

        // Add data rows
        vm.reportData.forEach(function (row) {
          var formattedRow = [
            row.Mid || "",
            row.TransactionId || "",
            row.WakaluTransactionId || "",
            moment(row.TransactionDate).format("DD/MM/YYYY HH:mm:ss"),
            row.UserName || "",
            row.FullName ? '"' + row.FullName.replace(/"/g, '""') + '"' : "",
            row.IdType || "",
            row.IdNumber || "",
            row.TransactionType || "",
            row.WithdrawalReason
              ? '"' + row.WithdrawalReason.replace(/"/g, '""') + '"'
              : "",
            row.Status || "",
            row.RequestedAmount || "0.00",
            row.CreditedAmount || "0.00",
            row.ProcessingFee || "0.00",
          ];
          csvContent += formattedRow.join(",") + "\n";
        });

        // Create download link and trigger download
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute(
          "download",
          "EASE_Withdrawal_Report_" +
            moment().format("YYYYMMDD_HHmmss") +
            ".csv"
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Manual CSV export error:", error);
        alert("Error exporting to CSV: " + error.message);
      }
    };

    // Callback to get the datatable instance
    vm.dtInstanceCallback = function (dtInstance) {
      vm.tableInstance = dtInstance;
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .factory('SystemReportService', SystemReportService);

    /** @ngInject */
    function SystemReportService(SVCS, $http, $q) {

        var service = {
            getConfirmedUsersDailyReportAsync: getConfirmedUsersDailyReportAsync,
            getMobilityoneSettlementReportAsync: getMobilityoneSettlementReportAsync,
            getCommunityReportAsync: getCommunityReportAsync,
            getPeerToPeerReportAsync: getPeerToPeerReportAsync,
            searchWalletSourceOfFundReportAsync:searchWalletSourceOfFundReportAsync,
        };

        return service;

        function getConfirmedUsersDailyReportAsync() {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/users/confirmed-users-daily-report')
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function getMobilityoneSettlementReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/mobilityone/settlement', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }
        function getMobilityoneSettlementReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/mobilityone/settlement', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function getCommunityReportAsync(filter) {
            var deferer = $q.defer();
            $http.get(SVCS.Report + '/api/users/community-users-report', { params: filter }).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

        return deferer.promise;
    }

        function getPeerToPeerReportAsync(filter) {
            var deferer = $q.defer();
            $http.get(SVCS.Report + '/api/users/peer-to-peer-report', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }
        function searchWalletSourceOfFundReportAsync(filter) {
            var deferer = $q.defer();

            $http.post(SVCS.Report + '/api/report/wallet-source-of-fund', filter, { headers: { 'Content-Type': 'application/json' } })
                .then(function (response) {
                    deferer.resolve(response);
                }, function (responseError) {
                    deferer.reject(responseError);
                });

            return deferer.promise;
        }
        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.report')
        .factory('StoreCardTransactionReportService', StoreCardTransactionReportService);

    /** @ngInject */
    function StoreCardTransactionReportService(SVCS, $http, $q) {

        var service = {
            getTopupSummaryReportAsync: getTopupSummaryReportAsync,
            getTopupDetailReportAsync: getTopupDetailReportAsync,
            getRedemptionSummaryReportAsync: getRedemptionSummaryReportAsync,
            getRedemptionDetailReportAsync: getRedemptionDetailReportAsync,
            getAdjustmentSummaryReportAsync: getAdjustmentSummaryReportAsync,
            getAdjustmentDetailReportAsync: getAdjustmentDetailReportAsync,
            getStatementSummaryReportAsync: getStatementSummaryReportAsync,
            getStatementDetailReportAsync: getStatementDetailReportAsync,
        };

        return service;

        function getTopupSummaryReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/storecard-transactions/topup-summary', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        };       

        function getTopupDetailReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/storecard-transactions/topup-detail', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        };      

        function getRedemptionSummaryReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/storecard-transactions/redemption-summary', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        };      

        function getRedemptionDetailReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/storecard-transactions/redemption-detail', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        };     

        function getAdjustmentSummaryReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/storecard-transactions/adjustment-summary', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        };     

        function getAdjustmentDetailReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/storecard-transactions/adjustment-detail', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        };     

        function getStatementSummaryReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/storecard-transactions/statement-summary', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        };     

        function getStatementDetailReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/storecard-transactions/statement-detail', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        };     
    }
})();
(function () {
    'use strict';

    angular
        .module('app.report')
        .factory('MerchantReportService', MerchantReportService);

    /** @ngInject */
    function MerchantReportService(SVCS, $http, $q) {

        var service = {
            getStatementOfAccountReportAsync: getStatementOfAccountReportAsync,
            getVoucherSummaryReportAsync: getVoucherSummaryReportAsync,
            getMerchantListReportAsync: getMerchantListReportAsync,
            getStoreListReportAsync: getStoreListReportAsync,
            getMerchantGapReportAsync: getMerchantGapReportAsync,
            getMerchantTerminalReportAsync: getMerchantTerminalReportAsync,
            getPromotionSummaryReportAsync: getPromotionSummaryReportAsync,
            getExceptionTransactionsReportAsync: getExceptionTransactionsReportAsync,
            getRemittanceReportAsync: getRemittanceReportAsync,
            getWalletUtilizationReportAsync: getWalletUtilizationReportAsync,
            getRedPayTransactionReportAsync: getRedPayTransactionReportAsync,
            getAppTypes: getAppTypes,
            getWalletTypes: getWalletTypes,
            getUserRegistrationReport: getUserRegistrationReport,
            getInsuranceReportAsync: getInsuranceReportAsync
        };

        return service;

        function getStatementOfAccountReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/merchants/statements', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function getVoucherSummaryReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/merchants/vouchers', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function getMerchantListReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/merchants/list', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function getStoreListReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/merchants/stores', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function getMerchantGapReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/merchants/gap', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function getMerchantTerminalReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/merchants/terminals', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function getPromotionSummaryReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/merchants/promotions', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function getExceptionTransactionsReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/merchants/exceptions', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }
        function getRemittanceReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/merchants/remittance-report', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }
        function getWalletUtilizationReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/merchants/wallet-utilization-report', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function getRedPayTransactionReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/merchants/redpay-transaction-report', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }
        function getInsuranceReportAsync(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Report + '/api/merchants/insurance-report', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }
        function getAppTypes() {
            return $http.get(SVCS.Report + '/api/merchants/app-types')
                .then(function(response) {
                    return response.data;
                })
                .catch(function(error) {
                    console.error('Failed to fetch app types:', error);
                    return $q.reject(error);
                });
        }

        function getWalletTypes() {
          var walletTypes = [
            { Id: "", Name: "All" },
            { Id: 0, Name: "Basic" },
            { Id: 1, Name: "Premium" },
            { Id: 2, Name: "Platinum" },
          ];
    
          return $q.when(walletTypes);
        }
    
        function getUserRegistrationReport(filter) {
          var deferer = $q.defer();
    
          $http
            .get(SVCS.Report + "/api/merchants/user-registration-report", {
              params: filter,
            })
            .then(
              function (response) {
                deferer.resolve(response.data);
              },
              function (responseError) {
                deferer.reject(responseError.data);
              }
            );
    
          return deferer.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .factory('GenericAutomationReportService', GenericAutomationReportService);

    /** @ngInject */
    function GenericAutomationReportService(SVCS, $http, $q, CoreService) {
        var reportServer = SVCS.Report;

        var service = {
            Search: Search,
            Active: Active,
            InActive: InActive,
            Delete: Delete,
            Create: Create,
            Get: Get,
            Update: Update,
            ExecuteSql: ExecuteSql,
            SendToEmail: SendToEmail
        };

        return service;

        function Get(id) {
            var deferer = $q.defer();
            CoreService.Get(reportServer + '/api/generic-automation/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();
            CoreService.Post(reportServer + '/api/generic-automation/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Active(reportId) {
            var deferer = $q.defer();
            var model = { Id: reportId };
            CoreService.Put(reportServer + '/api/generic-automation/active', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function InActive(reportId) {
            var deferer = $q.defer();
            var model = { Id: reportId };
            CoreService.Put(reportServer + '/api/generic-automation/inactive', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(report) {
            var deferer = $q.defer();
            CoreService.Post(reportServer + '/api/generic-automation/create', report).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(report) {
            var deferer = $q.defer();
            CoreService.Post(reportServer + '/api/generic-automation/update', report).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function SendToEmail(test) {
            var deferer = $q.defer();
            CoreService.Post(reportServer + '/api/generic-automation/send-to-email', test).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Delete(id) {
            var deferer = $q.defer();
            CoreService.Delete(reportServer + '/api/generic-automation/' + id).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function ExecuteSql(sql) {
            var deferer = $q.defer();
            CoreService.Post(reportServer + '/api/generic-automation/executesql', sql).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.report')
        .factory('ExternalTransactionReportService', ExternalTransactionReportService);

    /** @ngInject */
    function ExternalTransactionReportService(SVCS, $http, $q) {

        var service = {
            getTransactionHistory: getTransactionHistory,
            getRemittanceType: getRemittanceType,
            getReceiveMethods: getReceiveMethods,
            getTransactionType: getTransactionType
        };

        return service;

        function getTransactionHistory(filter) {
            var deferer = $q.defer();

            $http.get(SVCS.Wallet + '/api/histories/admin/transaction/external', { params: filter })
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function getRemittanceType() {
            var deferer = $q.defer();

            $http.get(SVCS.Wallet + '/api/western-union/GetPortaltRemittanceType')
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }
        function getReceiveMethods() {
            var deferer = $q.defer();

            $http.get(SVCS.Wallet + '/api/western-union/GetReceiveMethods')
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }
        function getTransactionType() {
            var deferer = $q.defer();

            $http.get(SVCS.Wallet + '/api/western-union/GetTransactionType')
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }
    }
})();
(function () {
  "use strict";

  angular
    .module("app.report")
    .controller(
      "UserRegistrationReportController",
      UserRegistrationReportController
    );

  UserRegistrationReportController.$inject = [
    "DTOptionsBuilder",
    "DTColumnBuilder",
    "$q",
    "$filter",
    "MerchantReportService",
    "$http",
    "$window",
  ];

  /** @ngInject */
  function UserRegistrationReportController(
    DTOptionsBuilder,
    DTColumnBuilder,
    $q,
    $filter,
    MerchantReportService,
    $http,
    $window
  ) {
    var vm = this;

    vm.data = [];
    vm.loading = true;
    vm.currentPage = 1;
    vm.pageSize = 100;
    vm.totalCount = 0;
    vm.totalPages = 0;
    vm.pages = [];
    vm.errorMsg = null;

    vm.appTypes = [];
    vm.idTypes = [];
    vm.visaCardStatuses = [];
    vm.walletTypes = [];

    vm.datePopup = {
      StartOpen: false,
      EndOpen: false,
    };

    vm.searchModel = {
      registrationStartDate: null,
      registrationEndDate: null,
      projectType: "",
      idType: "",
      visaCardStatus: "",
      ekycStatus: "",
      walletStatus: "",
      walletType: "",
    };

    vm.maxDate = new Date();

    vm.searchReport = searchReport;
    vm.reset = reset;
    vm.goToPage = goToPage;
    vm.exportToCSV = exportToCSV;
    vm.activate = activate;
    vm.loadFilterOptions = loadFilterOptions;

    activate();

    function activate() {
      loadFilterOptions().then(function () {
        vm.loading = false;
      });
    }

    function loadFilterOptions() {
      var deferred = $q.defer();
      var promises = [];

      var appTypesPromise = MerchantReportService.getAppTypes()
        .then(function (data) {
          vm.appTypes = data || [];
        })
        .catch(function (error) {
          vm.appTypes = [];
        });

      promises.push(appTypesPromise);

      var walletTypesPromise = MerchantReportService.getWalletTypes()
        .then(function (data) {
          vm.walletTypes = data || getDefaultWalletTypes();
        })
        .catch(function (error) {
          vm.walletTypes = getDefaultWalletTypes();
        });

      promises.push(walletTypesPromise);

      vm.idTypes = getDefaultIdTypes();
      vm.visaCardStatuses = getDefaultVisaCardStatuses();

      $q.all(promises)
        .then(function () {
          deferred.resolve();
        })
        .catch(function () {
          deferred.resolve();
        });

      return deferred.promise;
    }

    function getDefaultIdTypes() {
      return ["NRIC", "Passport", "Other"];
    }

    function getDefaultVisaCardStatuses() {
      return [
        "NotApplied",
        "Active",
        "Applied",
        "Validated",
        "CardReplaced",
        "FreezeCardByUser",
        "FreezeCardByBackend",
        "Retired",
        "Unknown",
      ];
    }

    function getDefaultWalletTypes() {
      return [
        { Id: "", Name: "All" },
        { Id: "Basic", Name: "Basic" },
        { Id: "Premium", Name: "Premium" },
        { Id: "Platinum", Name: "Platinum" },
      ];
    }

    function searchReport() {
      vm.loading = true;
      vm.errorMsg = null;

      var isUserInitiatedSearch = true;

      if (
        isUserInitiatedSearch &&
        (!vm.searchModel.registrationStartDate ||
          !vm.searchModel.registrationEndDate)
      ) {
        alert(
          "Please provide both Registration Start Date and Registration End Date."
        );
        vm.loading = false;
        return;
      }

      var today = new Date();

      if (
        vm.searchModel.registrationStartDate >
        vm.searchModel.registrationEndDate
      ) {
        alert(
          "Registration Start Date cannot be later than Registration End Date."
        );
        vm.loading = false;
        return;
      }

      if (vm.searchModel.registrationEndDate > today) {
        alert("Registration End Date cannot be in the future.");
        vm.loading = false;
        return;
      }

      getReportPromise()
        .then(function (data) {
          vm.loading = false;
          if (vm.tableInstance.DataTable) {
            vm.tableInstance.DataTable.clear();
            vm.tableInstance.DataTable.rows.add(data);
            vm.tableInstance.DataTable.draw();
          }
        })
        .catch(function (error) {
          vm.loading = false;
          alert("Failed to retrieve data. Please try again.");
        });
    }

    function getReportPromise() {
      var ekycStatusValue = vm.searchModel.ekycStatus || null;
      var walletStatusValue = vm.searchModel.walletStatus
        ? vm.searchModel.walletStatus === "1"
          ? "Active"
          : "Inactive"
        : null;
      var walletTypeValue = vm.searchModel.walletType
        ? parseInt(vm.searchModel.walletType)
        : null;

      var formattedStartDate = vm.searchModel.registrationStartDate
        ? $filter("date")(vm.searchModel.registrationStartDate, "yyyy-MM-dd")
        : null;
      var formattedEndDate = vm.searchModel.registrationEndDate
        ? $filter("date")(vm.searchModel.registrationEndDate, "yyyy-MM-dd")
        : null;

      var jsonData = {
        StartDate: formattedStartDate,
        EndDate: formattedEndDate,
        ProjectType: vm.searchModel.projectType,
        IdType: vm.searchModel.idType,
        VisaCardStatus: vm.searchModel.visaCardStatus,
        EKYCStatus: ekycStatusValue,
        WalletStatus: walletStatusValue,
        WalletType: walletTypeValue,
      };

      var defer = $q.defer();
      MerchantReportService.getUserRegistrationReport(jsonData)
        .then(function (response) {
          vm.data = response || [];
          defer.resolve(response || []);
        })
        .catch(function (error) {
          alert("Failed to retrieve data. Please try again.");
          defer.resolve([]);
        });

      return defer.promise;
    }

    function reset() {
      vm.searchModel = {
        registrationStartDate: null,
        registrationEndDate: null,
        projectType: "",
        idType: "",
        visaCardStatus: "",
        ekycStatus: "",
        walletStatus: "",
        walletType: "",
      };
      vm.currentPage = 1;
      vm.errorMsg = null;

      if (vm.tableInstance.DataTable) {
        vm.tableInstance.DataTable.clear();
        vm.tableInstance.DataTable.draw();
      }
    }

    function goToPage(page) {
      if (page < 1 || page > vm.totalPages) {
        return;
      }
      vm.currentPage = page;
      searchReport();
    }

    function updatePaginationInfo() {
      vm.pages = [];
      var startPage = Math.max(1, vm.currentPage - 2);
      var endPage = Math.min(vm.totalPages, startPage + 4);

      if (endPage - startPage < 4 && vm.totalPages > 4) {
        startPage = Math.max(1, endPage - 4);
      }

      for (var i = startPage; i <= endPage; i++) {
        vm.pages.push(i);
      }
    }

    function exportToCSV() {
      vm.loading = true;
      vm.errorMsg = null;
      var params = angular.copy(vm.searchModel);

      if (!params.registrationStartDate || !params.registrationEndDate) {
        alert(
          "Please provide both Registration Start Date and Registration End Date."
        );
        vm.loading = false;
        return;
      }

      var formattedStartDate = params.registrationStartDate
        ? $filter("date")(params.registrationStartDate, "yyyy-MM-dd")
        : null;
      var formattedEndDate = params.registrationEndDate
        ? $filter("date")(params.registrationEndDate, "yyyy-MM-dd")
        : null;

      var requestData = {
        StartDate: formattedStartDate,
        EndDate: formattedEndDate,
        ProjectType: params.projectType,
        IdType: params.idType,
        VisaCardStatus: params.visaCardStatus,
        EKYCStatus: params.ekycStatus || null,
        WalletStatus: params.walletStatus
          ? params.walletStatus === "1"
            ? "Active"
            : "Inactive"
          : null,
        WalletType: params.walletType,
        Export: true,
      };

      MerchantReportService.getUserRegistrationReport(requestData)
        .then(function (response) {
          createCSVContent(response || []);
        })
        .catch(function (error) {
          alert("Failed to export data. Please try again.");
        })
        .finally(function () {
          vm.loading = false;
        });
    }

    function createCSVContent(data) {
      if (!data || data.length === 0) {
        $window.alert("No data to export.");
        return;
      }

      var csvContent = "data:text/csv;charset=utf-8,";
      var header = [
        "No",
        "Username (Mobile No.)",
        "Registration Date",
        "Full Name",
        "ID Type",
        "Gender",
        "Webcash ID",
        "Nationality",
        "Partner",
        "eWages Employer",
        "VISA Card Status",
        "Visa Activation Date",
        "MID",
        "eKYC Status",
        "Wallet Status",
        "Wallet Type",
      ];

      csvContent += header.join(",") + "\r\n";

      data.forEach(function (user, index) {
        var registrationDate = user.RegistrationDate
          ? $filter("date")(
              new Date(user.RegistrationDate),
              "dd-MM-yyyy HH:mm:ss"
            )
          : "";
        var visaActivationDate = user.VisaActivationDate
          ? $filter("date")(
              new Date(user.VisaActivationDate),
              "dd-MM-yyyy HH:mm:ss"
            )
          : "";

        var walletTypeText = "";
        switch (user.WalletType) {
          case 0:
            walletTypeText = "Basic";
            break;
          case 1:
            walletTypeText = "Premium";
            break;
          case 2:
            walletTypeText = "Platinum";
            break;
          default:
            walletTypeText = "Unknown";
        }

        var genderText = "";
        switch (user.Gender) {
          case "0":
          case 0:
            genderText = "Male";
            break;
          case "1":
          case 1:
            genderText = "Female";
            break;
          default:
            genderText = user.Gender || "N/A";
        }

        var idTypeText = "";
        if (!user.IdType) {
          idTypeText = "N/A";
        } else {
          var idType = user.IdType.toUpperCase();

          if (idType.includes("NRIC") || idType === "1") {
            idTypeText = "NRIC";
          } else if (idType.includes("PASSPORT") || idType === "2") {
            idTypeText = "Passport";
          } else if (idType.includes("OTHER") || idType === "3") {
            idTypeText = "Other";
          } else {
            idTypeText = user.IdType;
          }
        }

        var row = [
          index + 1,
          '"' + (user.Username || "") + '"',
          '"' + registrationDate + '"',
          '"' + (user.FullName || "") + '"',
          '"' + idTypeText + '"',
          '"' + genderText + '"',
          '"' + (user.WebcashId || "") + '"',
          '"' + (user.Nationality || "") + '"',
          '"' + (user.ProjectType || "") + '"',
          '"' + (user.EWagesEmployer || "") + '"',
          '"' + (user.VisaCardStatus || "") + '"',
          '"' + visaActivationDate + '"',
          '"' + (user.MID || "") + '"',
          '"' + (user.EKYCStatus || "") + '"',
          '"' + (user.WalletStatus || "") + '"',
          '"' + walletTypeText + '"',
        ];

        csvContent += row.join(",") + "\r\n";
      });

      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);

      var today = $filter("date")(new Date(), "yyyy-MM-dd");
      link.setAttribute(
        "download",
        "user-registration-report-" + today + ".csv"
      );

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    vm.tableInstance = {};

    vm.dataTable = {
      options: DTOptionsBuilder.fromFnPromise(function () {
        var deferer = $q.defer();
        deferer.resolve([]);
        return deferer.promise;
      })
        .withBootstrap()
        .withOption("pageLength", 100)
        .withOption("searching", false)
        .withOption("lengthChange", false)
        .withButtons([
          {
            extend: "print",
            title: "User Registration Report",
          },
          {
            extend: "csv",
            filename: "User_Registration_Report",
          },
        ]),

      columns: [
        DTColumnBuilder.newColumn(null)
          .withTitle("No")
          .renderWith(function (data, type, full, meta) {
            return meta.row + 1;
          }),
        DTColumnBuilder.newColumn("Username").withTitle(
          "Username (Mobile No.)"
        ),
        DTColumnBuilder.newColumn("RegistrationDate")
          .withTitle("Registration Date")
          .renderWith(function (data) {
            return $filter("date")(data, "dd-MM-yyyy HH:mm:ss");
          }),
        DTColumnBuilder.newColumn("FullName").withTitle("Full Name"),
        DTColumnBuilder.newColumn("IdType")
          .withTitle("ID Type")
          .renderWith(function (data) {
            if (!data) return "N/A";

            var idType = data.toUpperCase();

            if (idType.includes("NRIC") || idType === "1") {
              return "NRIC";
            } else if (idType.includes("PASSPORT") || idType === "2") {
              return "Passport";
            } else if (idType.includes("OTHER") || idType === "3") {
              return "Other";
            } else {
              return data;
            }
          }),
        DTColumnBuilder.newColumn("Gender")
          .withTitle("Gender")
          .renderWith(function (data) {
            switch (data) {
              case "0":
              case 0:
                return "Male";
              case "1":
              case 1:
                return "Female";
              default:
                return data || "N/A";
            }
          }),
        DTColumnBuilder.newColumn("WebcashId").withTitle("Webcash ID"),
        DTColumnBuilder.newColumn("Nationality").withTitle("Nationality"),
        DTColumnBuilder.newColumn("ProjectType").withTitle("Partner"),
        DTColumnBuilder.newColumn("EWagesEmployer").withTitle(
          "eWages Employer"
        ),
        DTColumnBuilder.newColumn("VisaCardStatus").withTitle(
          "VISA Card Status"
        ),
        DTColumnBuilder.newColumn("VisaActivationDate")
          .withTitle("Visa Activation Date")
          .renderWith(function (data) {
            return data ? $filter("date")(data, "dd-MM-yyyy HH:mm:ss") : "N/A";
          }),
        DTColumnBuilder.newColumn("MID").withTitle("MID"),
        DTColumnBuilder.newColumn("EKYCStatus").withTitle("eKYC Status"),
        DTColumnBuilder.newColumn("WalletStatus").withTitle("Wallet Status"),
        DTColumnBuilder.newColumn("WalletType")
          .withTitle("Wallet Type")
          .renderWith(function (data) {
            switch (data) {
              case 0:
                return "Basic";
              case 1:
                return "Premium";
              case 2:
                return "Platinum";
              default:
                return "Unknown";
            }
          }),
      ],
    };

    vm.dtInstanceCallback = function (dtInstance) {
      vm.tableInstance.DataTable = dtInstance.DataTable;
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('MobilityoneSettlementReportController', MobilityoneSettlementReportController);

    /** @ngInject */
    function MobilityoneSettlementReportController(DTOptionsBuilder, DTColumnBuilder, SystemReportService, MerchantReportService, $filter,
        AuthenticationService, TransactionActionHashMap, $q, $numUtils) {
        var vm = this;

        vm.appTypes = [];

        vm.transactionActions = [
            TransactionActionHashMap['ReloadMobile'],
            TransactionActionHashMap['PayBill']
        ]

        vm.lcrPartners = [
            { Id: "PayHub", Name: 'Pay Hub' },
            { Id: "MobilityOne", Name: 'Mobility One' },
            { Id: "PTPTN", Name: 'PTPTN' }
        ]

        vm.filter = {
            TransactionAction: null,
            TransactionStartDate: null,
            TransactionEndDate: null,
            LCRPartner: null,
            Partner: null
        }

        vm.report = {};

        vm.tableInstance = {};

        vm.init = function () {
            MerchantReportService.getAppTypes().then(function (data) {
                vm.appTypes = data;
            });
        };

        vm.getReport = function () {
            var sdate = $("#sdate").val();
            var edate = $("#edate").val();
            if (sdate == null || sdate == "") {
                alert("Please select start date");
                return;
            }
            if (edate == null || edate == "") {
                alert("Please select end date");
                return;
            }
            vm.tableInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            var deferer = $q.defer();

            SystemReportService.getMobilityoneSettlementReportAsync(vm.filter).then(function (report) {
                report.TotalCash = $numUtils.toFixed(report.TotalCash);
                report.TotalKiplekash = $numUtils.toFixed(report.TotalKiplekash);
                report.TotalAmount = $numUtils.toFixed(report.TotalAmount);
                vm.report = report;
                deferer.resolve(report.Records);
            }, function (errors) {
                deferer.reject();
            })


            return deferer.promise;
        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withOption('order', [1, 'asc'])
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Least cost routing transaction report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Least cost routing transaction report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('Id'),
                DTColumnBuilder.newColumn('CreatedAt').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('WalletId'),
                DTColumnBuilder.newColumn('UserName'),
                DTColumnBuilder.newColumn('Email'),
                DTColumnBuilder.newColumn('PhoneNumber'),
                DTColumnBuilder.newColumn('Status'),
                DTColumnBuilder.newColumn('Action').withOption('render', function (data) {
                    if (TransactionActionHashMap[data] !== undefined) {
                        return $filter('translate')(TransactionActionHashMap[data].display);
                    }
                    else {
                        return data;
                    }
                }),
                DTColumnBuilder.newColumn('LCRPartner').withOption('render', function (data) {
                 
                    if (data == vm.lcrPartners[0].Id) {
                        return $filter('translate')(vm.lcrPartners[0].Name);
                    }
                    else if (data == vm.lcrPartners[1].Id) {
                        return $filter('translate')(vm.lcrPartners[1].Name);
                    }
                    else {
                        return data;
                    }
                }),
                DTColumnBuilder.newColumn('OperatorCode'),
                DTColumnBuilder.newColumn('AccountMobileNumber'),
                DTColumnBuilder.newColumn('Cash').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Kiplekash').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('CreditDebitCardAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Amount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('AccountNo'),
                DTColumnBuilder.newColumn('LoanNo'),
                DTColumnBuilder.newColumn('SenderIC'),
                DTColumnBuilder.newColumn('BeneficiatoryIC').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('EWagesEmployer'),
                DTColumnBuilder.newColumn('RewardOffSetAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('RewardOffsetPercentage').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('RewardOffSetPoints').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Partner')
                .withTitle('Partner')
                .renderWith(function (data) {
                    return data ? data : 'N/A';
                })
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('ConfirmedUsersDailyReportController', ConfirmedUsersDailyReportController);

    /** @ngInject */
    function ConfirmedUsersDailyReportController(DTOptionsBuilder, DTColumnBuilder, SystemReportService, $filter, $numUtils) {
        var vm = this;

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                return SystemReportService.getConfirmedUsersDailyReportAsync();
            }).withBootstrap().withOption('searching', false)
                .withOption('lengthChange', false)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Confirmed users daily report'
                    },
                    {
                        extend: 'csv',
                        filename:'Confirmed users daily report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('Date').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'yyyy-MM-dd'); }),
                DTColumnBuilder.newColumn('TotalConfirmedUser')
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('WebcashSettlementReportController', WebcashSettlementReportController);

    /** @ngInject */
    function WebcashSettlementReportController(DTOptionsBuilder, DTColumnBuilder, MerchantReportService, $filter,
        MerchantService, AuthenticationService, $q, $numUtils) {
        var vm = this;

        vm.filter = {
            MerchantId: null,
            TransactionStartDate: null,
            TransactionEndDate: null
        }

        vm.merchants = [];

        MerchantService.GetAllMerchantsOfKiplePay().then(function (merchants) {
            vm.merchants = merchants;
        })

        vm.loadMerchant = function (keyword) {
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = [{ "Id": null, "Name": "All" }].concat(res.Items);
                });
            } else {
                vm.merchants = null;
            }
        }

        vm.tableInstance = {};

        vm.getReport = function () {
            vm.tableInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            return MerchantReportService.getStatementOfAccountReportAsync(vm.filter);
        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Webcash settlement report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Webcash settlement report'
                    }
                ]).withOption('rowGroup', {
                    startRender: function (rows, group, val) {
                        var firstRow = rows.data()[0];
                        if (firstRow['MerchantWebCashId'] == null) {
                            return 'Topup'
                        } else {
                            return firstRow['MerchantWebCashId'] + ' - ' + firstRow['MerchantName'];
                        }
                    },
                    dataSrc: 'MerchantWebCashId'
                }),

            columns: [
                {
                    data: null,
                    render: function (data, type, row) {
                        if (data['MerchantWebCashId'] == null) {
                            return '-'
                        } else {
                            return data['MerchantWebCashId'] + ' - ' + data['MerchantName'];
                        }
                    }
                },
                DTColumnBuilder.newColumn('CreatedAt').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('Id'),
                DTColumnBuilder.newColumn('WebCashTransactionId'),
                DTColumnBuilder.newColumn('ComputedAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Cash').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Kiplekash').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('StoreCard').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('CreditDebitCardAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('MDRFee').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('DeductionGST').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('StoreCard').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                {
                    data: null,
                    render: function (data, type, row) {
                        return $numUtils.toFixed(data['MDRFee'] + data['GSTFee'] + data['StoreCard']) // TODO: correct the deduction subtotal
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                        return $numUtils.toFixed(data['Amount'] - data['MDRFee'] - data['GSTFee'] - data['StoreCard']) // TODO: correct the merchant settlement
                    }
                }
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('VoucherSummaryReportController', VoucherSummaryReportController);

    /** @ngInject */
    function VoucherSummaryReportController(DTOptionsBuilder, DTColumnBuilder, MerchantReportService, $filter,
        MerchantService, AuthenticationService, $$viewAsAdmin, $q, VoucherStatusHashMap, $numUtils) {
        var vm = this;

        vm.voucherStatus = VoucherStatusHashMap;

        vm.filter = {
            MerchantId: null,
            VoucherName: null,
            Status: null,
            CampaignName:null
        }

        vm.showMerchantFilter = false;

        vm.merchants = [];

        if ($$viewAsAdmin) {
            vm.showMerchantFilter = true;
            MerchantService.GetAllMerchantsOfKiplePay().then(function (merchants) {
                vm.merchants = merchants;
            })
        }

        vm.loadMerchant = function (keyword) {
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = [{ "Id": null, "Name": "All" }].concat(res.Items);
                });
            } else {
                vm.merchants = null;
            }
        }

        vm.tableInstance = {};

        vm.getReport = function () {
            vm.tableInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            return MerchantReportService.getVoucherSummaryReportAsync(vm.filter);
        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50),

            columns: [
                DTColumnBuilder.newColumn('Id'),
                DTColumnBuilder.newColumn('Name'),
                DTColumnBuilder.newColumn('MerchantName'),
                DTColumnBuilder.newColumn('OldPrice').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Price').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Amount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('CampaignName'),
                DTColumnBuilder.newColumn('Subsidy').withOption('render', function (data) { return data == '0' ? 'Fixed Amount' : 'Fixed Amount' }),
                DTColumnBuilder.newColumn('KipleSubsidyAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('MerchantSubsidyAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('DiscountType').withOption('render', function (data) { return data == 'FixedAmount' ? 'Fixed Amount' : 'Percentage' }),
                DTColumnBuilder.newColumn('MaxQuantity'),
                DTColumnBuilder.newColumn('PurchasedQty'),
                DTColumnBuilder.newColumn('RedeemedQty'),
                DTColumnBuilder.newColumn('SaleStartDate').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy'); }),
                DTColumnBuilder.newColumn('SaleEnddate').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy'); }),
                DTColumnBuilder.newColumn('ExpireDate').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy'); }),
                DTColumnBuilder.newColumn('Status').withOption('render', function (data, type, row) {
                    var status = data;

                    var expireDate = new Date(row['ExpireDate']);
                    var isExpired = new Date() > expireDate;

                    if (data != VoucherStatusHashMap['Deleted'].value && isExpired) {
                        status = 'Expired';
                    }

                    return $filter('translate')(VoucherStatusHashMap[status].display);
                }),
                DTColumnBuilder.newColumn('UserCategory').withOption('render', function (data) { return data == '0' ? 'NormalUser' : 'UniversityUser' }),
                DTColumnBuilder.newColumn('UniversityId'),
                DTColumnBuilder.newColumn('IsUniversity').withOption('render', function (data) { return data == '0' ? 'NonUniversity' : 'University' }),
                DTColumnBuilder.newColumn('IsPublish').withOption('render', function (data) { return data == '0' ? 'UnPublish' : 'Publish' }),
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('StoreCardTransactionsReportController', StoreCardTransactionsReportController);

    /** @ngInject */
    function StoreCardTransactionsReportController(DTOptionsBuilder, DTColumnBuilder, StoreCardTransactionReportService, $filter, $cookies,
        MerchantService, AuthenticationService, $q, $numUtils) {
        var vm = this;
        vm.isAdmin = $cookies.get('account_type') === 1 ? true : false;

        vm.filter = {
            MerchantId: null,
            TransactionStartDate: null,
            TransactionEndDate: null
        }

        vm.merchants = [];

        MerchantService.GetAllMerchantsPublicInfo().then(function (merchants) {
            vm.merchants = merchants;
        })

        vm.loadMerchant = function (keyword) {
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = [{ "Id": null, "Name": "All" }].concat(res.Items);
                });
            } else {
                vm.merchants = null;
            }
        }

        vm.topupSummaryDTInstance = {};
        vm.topupDetailDTInstance = {};
        vm.redemptionSummaryDTInstance = {};
        vm.redemptionDetailDTInstance = {};
        vm.adjustmentSummaryDTInstance = {};
        vm.adjustmentDetailDTInstance = {};
        vm.statementSummary = {};
        vm.statementDetailDTInstance = {};


        vm.getReport = function () {
            vm.topupSummaryDTInstance.changeData(StoreCardTransactionReportService.getTopupSummaryReportAsync(vm.filter));
            vm.topupDetailDTInstance.changeData(StoreCardTransactionReportService.getTopupDetailReportAsync(vm.filter));
            vm.redemptionSummaryDTInstance.changeData(StoreCardTransactionReportService.getRedemptionSummaryReportAsync(vm.filter));
            vm.redemptionDetailDTInstance.changeData(StoreCardTransactionReportService.getRedemptionDetailReportAsync(vm.filter));
            vm.adjustmentSummaryDTInstance.changeData(StoreCardTransactionReportService.getAdjustmentSummaryReportAsync(vm.filter));
            vm.adjustmentDetailDTInstance.changeData(StoreCardTransactionReportService.getAdjustmentDetailReportAsync(vm.filter));
            //vm.statementSummary = StoreCardTransactionReportService.getStatementSummaryReportAsync(vm.filter);

            StoreCardTransactionReportService.getStatementSummaryReportAsync(vm.filter).then(function (response) {
                vm.statementSummary = response;
            });
            vm.statementDetailDTInstance.changeData(StoreCardTransactionReportService.getStatementDetailReportAsync(vm.filter));
        }
        
        vm.topupSummaryDT = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('paging', false)
                .withOption('bInfo', false)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Topup Summary'
                    },
                    {
                        extend: 'csv',
                        filename: 'Topup Details'
                    }
                ]),
            columns: [               
                DTColumnBuilder.newColumn('Outlet'),
                DTColumnBuilder.newColumn('TotalTopupOTCAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('TotalTopupOnlineAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('TotalTopupBonusAmount').withOption('render', function (data) { return $numUtils.toFixed(data); })
            ]
        }

        vm.topupDetailDT = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 30)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Topup Summary'
                    },
                    {
                        extend: 'csv',
                        filename: 'Topup Details'
                    }
                ]),
            columns: [
                DTColumnBuilder.newColumn('Outlet'),
                DTColumnBuilder.newColumn('Media'),
                DTColumnBuilder.newColumn('TnxDateTime').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('BillNo'),
                DTColumnBuilder.newColumn('MembershipNo'),
                DTColumnBuilder.newColumn('Amount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Bonus').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Commission').withOption('render', function (data) { return $numUtils.toFixed(data); })
            ]
        }

        vm.redemptionSummaryDT = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 30)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Redemption Summary'
                    },
                    {
                        extend: 'csv',
                        filename: 'Redemption Details'
                    }
                ]),
            columns: [
                DTColumnBuilder.newColumn('Outlet'),
                DTColumnBuilder.newColumn('Total').withOption('render', function (data) { return $numUtils.toFixed(data); })
            ]
        }

        vm.redemptionDetailDT = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 30)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'redemption Summary'
                    },
                    {
                        extend: 'csv',
                        filename: 'redemption Details'
                    }
                ]),
            columns: [
                DTColumnBuilder.newColumn('Outlet'),
                DTColumnBuilder.newColumn('TnxDateTime').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('BillNo'),
                DTColumnBuilder.newColumn('MembershipNo'),
                DTColumnBuilder.newColumn('Amount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
            ]
        }

        vm.adjustmentSummaryDT = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('paging', false)
                .withOption('bInfo', false)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Adjustment Summary'
                    },
                    {
                        extend: 'csv',
                        filename: 'Adjustment Details'
                    }
                ]),
            columns: [
                DTColumnBuilder.newColumn('Outlet'),
                DTColumnBuilder.newColumn('Total').withOption('render', function (data) { return $numUtils.toFixed(data); })
            ]
        }

        vm.adjustmentDetailDT = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 30)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Adjustment Summary'
                    },
                    {
                        extend: 'csv',
                        filename: 'Adjustment Details'
                    }
                ]),
            columns: [
                DTColumnBuilder.newColumn('Outlet'),
                DTColumnBuilder.newColumn('TnxDateTime').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('VoidType'),
                DTColumnBuilder.newColumn('BillNo'),
                DTColumnBuilder.newColumn('MembershipNo'),
                DTColumnBuilder.newColumn('Amount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Reason')
            ]
        }

        vm.statementDetailDT = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 30)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Statement Summary'
                    },
                    {
                        extend: 'csv',
                        filename: 'Statement Details'
                    }
                ]),
            columns: [
                DTColumnBuilder.newColumn('MembershipNo'),
                DTColumnBuilder.newColumn('OpeningBalance').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('TopupOnline').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('TopupOverCounter').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Bonus').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Adjustment').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('ClosingBalance').withOption('render', function (data) { return $numUtils.toFixed(data); })
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('StoreListReportController', StoreListReportController);

    /** @ngInject */
    function StoreListReportController(DTOptionsBuilder, DTColumnBuilder, MerchantReportService, $filter,
        MerchantService, $q) {

        var vm = this;
        
        vm.filter = {
            MerchantId: null
        }

        vm.merchants = [];
        MerchantService.GetAllMerchantsOfKiplePay().then(function (merchants) {
            vm.merchants = merchants;
        })

        vm.tableInstance = {};

        vm.getReport = function () {
            vm.tableInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            return MerchantReportService.getStoreListReportAsync(vm.filter);
        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50),

            columns: [
                DTColumnBuilder.newColumn('MerchantName'),
                DTColumnBuilder.newColumn('Name'),
                DTColumnBuilder.newColumn('Address'),
                DTColumnBuilder.newColumn('ContactNumber'),
                DTColumnBuilder.newColumn('MobileNumber')
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('StatementOfAccountReportController', StatementOfAccountReportController);

    /** @ngInject */
    function StatementOfAccountReportController(DTOptionsBuilder, DTColumnBuilder, MerchantReportService, $filter,
        MerchantService, TransactionActionHashMap, PaymentChannelHashMap, AuthenticationService, $$viewAsAdmin, $q, $numUtils) {
        var vm = this;

        vm.TransactionActionHashMap = TransactionActionHashMap;

        vm.filter = {
            TransactionId: null,
            MerchantId: null,
            TransactionAction: null,
            TransactionStartDate: null,
            TransactionEndDate: null,
            CampaignName: null,
            SaleStartDate:null,
            SaleEndDate:null,
            PaymentChannel: null,
            UserName: null
        }
        
        vm.actionOptions = [
            TransactionActionHashMap['Payment'],
            TransactionActionHashMap['TransactionVoid'],
            TransactionActionHashMap['PurchaseVoucher'],
            TransactionActionHashMap['PayAtTable'],
            TransactionActionHashMap['RedeemVoucher'],
            TransactionActionHashMap['GetFreeVoucher'],
            TransactionActionHashMap['ZakatReward']
        ];

        vm.PaymentChannel = [
            PaymentChannelHashMap['Boost'],
            PaymentChannelHashMap['AliPay'],
            PaymentChannelHashMap['Grab'],
            PaymentChannelHashMap['MayPay'],
            PaymentChannelHashMap['RazorPay'],
            PaymentChannelHashMap['TnG'],
            PaymentChannelHashMap['WeChatPay'],
            PaymentChannelHashMap['WeChatPayInt'],
            PaymentChannelHashMap['SelangkahWallet'],
        ];

        vm.showMerchantFilter = false;

        vm.merchants = [];

        if ($$viewAsAdmin) {
            vm.showMerchantFilter = true;

            MerchantService.GetAllMerchantsPublicInfo().then(function (merchants) {
                vm.merchants = merchants;
            })
        }

        vm.tableInstance = {};

        vm.getReport = function () {
            var sdate = $("#sdate").val();
            var edate = $("#edate").val();
            if (sdate == null || sdate == "") {
                alert("Please select start date");
                return;
            }
            if (edate == null || edate == "") {
                alert("Please select end date");
                return;
            }
            vm.tableInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            vm.filter.AppType = 1;
            return MerchantReportService.getStatementOfAccountReportAsync(vm.filter);
        }

        vm.loadMerchant = function (keyword) {
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = [{ "Id": null, "Name": "All" }].concat(res.Items);
                });
            } else {
                vm.merchants = null;
            }
        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Statement of account report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Statement of account report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('Id'),
                DTColumnBuilder.newColumn('ExternalReferenceId'),
                DTColumnBuilder.newColumn('CreatedAt').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('MerchantName'),
                DTColumnBuilder.newColumn('Action').withOption('render', function (data) {
                    if (TransactionActionHashMap[data] !== undefined) {
                        return $filter('translate')(TransactionActionHashMap[data].display);
                    }
                    else {
                        return data;
                    }
                }),
                DTColumnBuilder.newColumn('RazorPayPaymentChannel'),
                {
                    data: null,
                    render: function (data, type, row) {
                   
                        if (data['Action'] == 'TransactionVoid') {
                            return '-' + $numUtils.toFixed(data['Cash']);;
                        }
                        return $numUtils.toFixed(data['Cash']);;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                   
                        if (data['Action'] == 'VisaPayment') {
                            return  $numUtils.toFixed(data['Amount']);;
                        }
                        return $numUtils.toFixed(0);;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                   
                        if (data['Action'] == 'TransactionVoid') {
                            return '-' + $numUtils.toFixed(data['Kiplekash']);;
                        }
                        return $numUtils.toFixed(data['Kiplekash']);;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                   
                        if (data['Action'] == 'TransactionVoid') {
                            return '-' + $numUtils.toFixed(data['MealCard']);;
                        }
                        return $numUtils.toFixed(data['MealCard']);;
                    }
                },   
                {
                    data: null,
                    render: function (data, type, row) {
                        if (data['Action'] == 'TransactionVoid' && !!data['CreditDebitCardNumber']) {
                            return  '-' + $numUtils.toFixed(data['CreditDebitCardAmount']);
                        }
                        if (!!data['CreditDebitCardNumber']) {
                            return  $numUtils.toFixed(data['CreditDebitCardAmount']);
                        }
                        return $numUtils.toFixed(0);;
                    }
                },          
                DTColumnBuilder.newColumn('ComputedAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('VoucherID'),
                DTColumnBuilder.newColumn('CampaignName'),
                DTColumnBuilder.newColumn('KipleSubsidyAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('MerchantSubsidyAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('MDRFee').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('GSTFeeOnMDR').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                {
                    data: null,
                    render: function (data, type, row) {
                   
                        if (data['Action'] == 'TransactionVoid') {
                            return '-' + $numUtils.toFixed(data['StoreCard']);;
                        }
                        return $numUtils.toFixed(data['StoreCard']);;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                        if (data['Id'] == 148405) {
                            console.log(data)
                        }
                        
                        if (data['ClientName'] == "PETRONAS") {
                            //if user only pay by storecard, the formular will different
                            if (data['Action'] == 'TransactionVoid') {
                                return $numUtils.toFixed(-data['Amount'] - (-data['MDRFee'] - data['GSTFeeOnMDR']));
                            }
                            return $numUtils.toFixed(data['Amount'] - data['MDRFee'] - data['GSTFeeOnMDR']);
                        } else {
                            if (data['Action'] == 'TransactionVoid') {
                                return $numUtils.toFixed(-data['Amount'] - (-data['MDRFee'] - data['GSTFeeOnMDR'] - data['StoreCard']));
                            }

                            var amount = data['Amount'] - data['MDRFee'] - data['GSTFeeOnMDR'] - data['StoreCard'];                          
                            return $numUtils.toFixed(amount);
                        }                        
                    }
                },
                DTColumnBuilder.newColumn('StoreCardCashback').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('WalletId'),
                DTColumnBuilder.newColumn('StoreId'),
                DTColumnBuilder.newColumn('OutletCode'),
                DTColumnBuilder.newColumn('UserName'),
                DTColumnBuilder.newColumn('BeforeCash'),
                DTColumnBuilder.newColumn('AfterWalletBalance'),
                DTColumnBuilder.newColumn('RewardOffSetAmount'),
                DTColumnBuilder.newColumn('RewardOffSetPoints'),
                DTColumnBuilder.newColumn('RewardOffsetPercentage')
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('StatementOfAccountRedpayReportController', StatementOfAccountRedpayReportController);

    /** @ngInject */
    function StatementOfAccountRedpayReportController(DTOptionsBuilder, DTColumnBuilder, MerchantReportService, $filter,
        MerchantService, TransactionActionHashMap, PaymentChannelHashMap, AuthenticationService, $$viewAsAdmin, $q, $numUtils) {
        var vm = this;  
        vm.TransactionActionHashMap = TransactionActionHashMap;

        vm.filter = {
            TransactionId: null,
            MerchantId: null,
            TransactionAction: null,
            TransactionStartDate: null,
            TransactionEndDate: null,
            CampaignName: null,
            SaleStartDate:null,
            SaleEndDate:null,
            PaymentChannel: null,
            UserName: null
        }
        
        vm.actionOptions = [
            TransactionActionHashMap['Payment'],
        ];

        vm.PaymentChannel = [
            PaymentChannelHashMap['RedPay'],
        ];

        //vm.showMerchantFilter = false;

        vm.merchants = [];

        if ($$viewAsAdmin) {
            //vm.showMerchantFilter = true;

            MerchantService.GetAllMerchantsPublicInfo().then(function (merchants) {
                vm.merchants = merchants;
            })
        }

        vm.tableInstance = {};

        vm.getReport = function () {
            var sdate = $("#sdate").val();
            var edate = $("#edate").val();
            if (sdate == null || sdate == "") {
                alert("Please select start date");
                return;
            }
            if (edate == null || edate == "") {
                alert("Please select end date");
                return;
            }
            vm.tableInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            vm.filter.AppType = 2;
            return MerchantReportService.getStatementOfAccountReportAsync(vm.filter);
        }

        vm.loadMerchant = function (keyword) {
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = [{ "Id": null, "Name": "All" }].concat(res.Items);
                });
            } else {
                vm.merchants = null;
            }
        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Statement of account redpay report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Statement of account redpay report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('Id'),
                DTColumnBuilder.newColumn('ExternalReferenceId'),
                DTColumnBuilder.newColumn('CreatedAt').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('MerchantName'),
                DTColumnBuilder.newColumn('Action').withOption('render', function (data) {
                    if (TransactionActionHashMap[data] !== undefined) {
                        return $filter('translate')(TransactionActionHashMap[data].display);
                    }
                    else {
                        return data;
                    }
                }),
                DTColumnBuilder.newColumn('RazorPayPaymentChannel'),
                {
                    data: null,
                    render: function (data, type, row) {
                   
                        if (data['Action'] == 'TransactionVoid') {
                            return '-' + $numUtils.toFixed(data['Cash']);;
                        }
                        return $numUtils.toFixed(data['Cash']);;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                   
                        if (data['Action'] == 'VisaPayment') {
                            return  $numUtils.toFixed(data['Amount']);;
                        }
                        return $numUtils.toFixed(0);;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                   
                        if (data['Action'] == 'TransactionVoid') {
                            return '-' + $numUtils.toFixed(data['Kiplekash']);;
                        }
                        return $numUtils.toFixed(data['Kiplekash']);;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                   
                        if (data['Action'] == 'TransactionVoid') {
                            return '-' + $numUtils.toFixed(data['MealCard']);;
                        }
                        return $numUtils.toFixed(data['MealCard']);;
                    }
                },   
                {
                    data: null,
                    render: function (data, type, row) {
                        if (data['Action'] == 'TransactionVoid' && !!data['CreditDebitCardNumber']) {
                            return  '-' + $numUtils.toFixed(data['CreditDebitCardAmount']);
                        }
                        if (!!data['CreditDebitCardNumber']) {
                            return  $numUtils.toFixed(data['CreditDebitCardAmount']);
                        }
                        return $numUtils.toFixed(0);;
                    }
                },
                DTColumnBuilder.newColumn('ComputedAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('VoucherID'),
                DTColumnBuilder.newColumn('CampaignName'),
                DTColumnBuilder.newColumn('KipleSubsidyAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('MerchantSubsidyAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('MDRFee').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('GSTFeeOnMDR').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                {
                    data: null,
                    render: function (data, type, row) {
                   
                        if (data['Action'] == 'TransactionVoid') {
                            return '-' + $numUtils.toFixed(data['StoreCard']);;
                        }
                        return $numUtils.toFixed(data['StoreCard']);;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                        if (data['Id'] == 148405) {
                            console.log(data)
                        }
                        
                        if (data['ClientName'] == "PETRONAS") {
                            //if user only pay by storecard, the formular will different
                            if (data['Action'] == 'TransactionVoid') {
                                return $numUtils.toFixed(-data['Amount'] - (-data['MDRFee'] - data['GSTFeeOnMDR']));
                            }
                            return $numUtils.toFixed(data['Amount'] - data['MDRFee'] - data['GSTFeeOnMDR']);
                        } else {
                            if (data['Action'] == 'TransactionVoid') {
                                return $numUtils.toFixed(-data['Amount'] - (-data['MDRFee'] - data['GSTFeeOnMDR'] - data['StoreCard']));
                            }

                            var amount = data['Amount'] - data['MDRFee'] - data['GSTFeeOnMDR'] - data['StoreCard'];                          
                            return $numUtils.toFixed(amount);
                        }                        
                    }
                },
                DTColumnBuilder.newColumn('StoreCardCashback').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('WalletId'),
                DTColumnBuilder.newColumn('StoreId'),
                DTColumnBuilder.newColumn('OutletCode'),
                DTColumnBuilder.newColumn('UserName'),
                DTColumnBuilder.newColumn('BeforeCash'),
                DTColumnBuilder.newColumn('AfterWalletBalance'),
                DTColumnBuilder.newColumn('RewardOffSetAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('RewardOffsetPercentage').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('RewardConverstionRate').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('RewardOffSetPoints').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('RewardLinkProcessingFee').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('LDRShareRate').withOption('render', function (data) { return $numUtils.toFixed(data); })
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('RemittanceReportController', RemittanceReportController);

    /** @ngInject */
    function RemittanceReportController(DTOptionsBuilder, DTColumnBuilder, MerchantReportService, $filter,
        MerchantService, TransactionActionHashMap, PaymentChannelHashMap, AuthenticationService, $$viewAsAdmin, $q, $numUtils) {
        var vm = this;

        vm.filter = {
            UserName: null,
            MTCN: null,
            RemittanceType: null,
            TransactionAction: null,
            ReceiveMoneyMethods: null,
            TransactionStartDate: null,
            TransactionEndDate:null
        }
        
       

       

        vm.tableInstance = {};

        vm.getReport = function () {
            vm.tableInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            return MerchantReportService.getStatementOfAccountReportAsync(vm.filter);
        }

        vm.loadMerchant = function (keyword) {
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = [{ "Id": null, "Name": "All" }].concat(res.Items);
                });
            } else {
                vm.merchants = null;
            }
        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Statement of account report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Statement of account report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('Id'),
                DTColumnBuilder.newColumn('ExternalReferenceId'),
                DTColumnBuilder.newColumn('CreatedAt').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('MerchantName'),
                DTColumnBuilder.newColumn('Action').withOption('render', function (data) {
                    if (TransactionActionHashMap[data] !== undefined) {
                        return $filter('translate')(TransactionActionHashMap[data].display);
                    }
                    else {
                        return data;
                    }
                }),
                DTColumnBuilder.newColumn('RazorPayPaymentChannel'),
                DTColumnBuilder.newColumn('ComputedAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('VoucherID'),
                DTColumnBuilder.newColumn('CampaignName'),
                DTColumnBuilder.newColumn('KipleSubsidyAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('MerchantSubsidyAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('MDRFee').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('GSTFeeOnMDR').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                {
                    data: null,
                    render: function (data, type, row) {
                   
                        if (data['Action'] == 'TransactionVoid') {
                            return '-' + $numUtils.toFixed(data['StoreCard']);;
                        }
                        return $numUtils.toFixed(data['StoreCard']);;
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                        if (data['Id'] == 148405) {
                            console.log(data)
                        }
                        
                        if (data['ClientName'] == "PETRONAS") {
                            //if user only pay by storecard, the formular will different
                            if (data['Action'] == 'TransactionVoid') {
                                return $numUtils.toFixed(-data['Amount'] - (-data['MDRFee'] - data['GSTFeeOnMDR']));
                            }
                            return $numUtils.toFixed(data['Amount'] - data['MDRFee'] - data['GSTFeeOnMDR']);
                        } else {
                            if (data['Action'] == 'TransactionVoid') {
                                return $numUtils.toFixed(-data['Amount'] - (-data['MDRFee'] - data['GSTFeeOnMDR'] - data['StoreCard']));
                            }

                            var amount = data['Amount'] - data['MDRFee'] - data['GSTFeeOnMDR'] - data['StoreCard'];                          
                            return $numUtils.toFixed(amount);
                        }                        
                    }
                },
                DTColumnBuilder.newColumn('StoreCardCashback').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('WalletId'),
                DTColumnBuilder.newColumn('StoreId'),
                DTColumnBuilder.newColumn('OutletCode')
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('PromotionSummaryReportController', PromotionSummaryReportController);

    /** @ngInject */
    function PromotionSummaryReportController(DTOptionsBuilder, DTColumnBuilder, MerchantReportService, $filter,
        MerchantService, AuthenticationService, $$viewAsAdmin, $q, PromotionStatusHashMap, ECouponLifecycleHashMap, PromotionTypeHashMap, $numUtils) {
        var vm = this;

        vm.promotionStatus = PromotionStatusHashMap;

        vm.filter = {
            MerchantId: null,
            PromotionName: null,
            PromotionStatus: null
        }

        vm.showMerchantFilter = false;

        vm.merchants = [];

        if ($$viewAsAdmin) {
            vm.showMerchantFilter = true;

            MerchantService.GetAllMerchantsPublicInfo().then(function (merchants) {
                vm.merchants = merchants;
            })
        }

        vm.tableInstance = {};

        vm.getReport = function () {
            vm.tableInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            return MerchantReportService.getPromotionSummaryReportAsync(vm.filter);
        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50),

            columns: [
                DTColumnBuilder.newColumn('Id'),
                DTColumnBuilder.newColumn('Name'),
                DTColumnBuilder.newColumn('MerchantName'),
                DTColumnBuilder.newColumn('Type').withOption('render', function (data) { return $filter('translate')(PromotionTypeHashMap[data].display); }),
                DTColumnBuilder.newColumn('ECouponLifecycle').withOption('render', function (data) { return data == ECouponLifecycleHashMap['MultipleTimes'].value ? 'Yes' : 'No' }),
                DTColumnBuilder.newColumn('Price').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('NumberOfCards'),
                { // grabbed quantity
                    render: function () {
                        return 'TODO';
                    }
                },
                { // redeemed quantity
                    render: function () {
                        return 'TODO';
                    }
                },
                DTColumnBuilder.newColumn('SaleStartDate').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy'); }),
                DTColumnBuilder.newColumn('SaleEndDate').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy'); }),
                DTColumnBuilder.newColumn('ExpiredAt').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy'); }),
                DTColumnBuilder.newColumn('Status').withOption('render', function (data, type, row) {
                    var status = data;

                    var expireDate = new Date(row['ExpiredAt']);
                    var isExpired = new Date() > expireDate;

                    if (data != PromotionStatusHashMap['Deleted'].value && isExpired) {
                        status = 'Expired';
                    }

                    if (PromotionStatusHashMap[status] !== undefined) {
                        return $filter('translate')(PromotionStatusHashMap[status].display);
                    }
                    else {
                        return status;
                    }
                })
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('OutletTransactionsReportController', OutletTransactionsReportController);

    /** @ngInject */
    function OutletTransactionsReportController(DTOptionsBuilder, DTColumnBuilder, MerchantReportService, $filter,
        MerchantService, StoreService, TransactionActionHashMap, AuthenticationService, $$viewAsAdmin, $q, $numUtils, $rootScope) {
        var vm = this;

        vm.TransactionActionHashMap = TransactionActionHashMap;

        vm.filter = {
            TransactionId: null,
            MerchantId: null,
            StoreId: null,
            TransactionAction: null,
            TransactionStartDate: null,
            TransactionEndDate: null
        }
        
        vm.actionOptions = [
            TransactionActionHashMap['Payment'],
            TransactionActionHashMap['TransactionVoid'],
            TransactionActionHashMap['RedeemVoucher'],
            TransactionActionHashMap['PayAtTable']
        ];

        vm.showMerchantFilter = false;

        vm.merchants = [];
        vm.stores = [];

        if ($$viewAsAdmin) {
            vm.showMerchantFilter = true;

            MerchantService.GetAllMerchantsOfKiplePay().then(function (merchants) {
                vm.merchants = merchants;
            })
        } else {
            vm.filter.MerchantId = $rootScope.authenticationService.account.Id;
        }

        vm.loadMerchant = function (keyword) {
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = [{ "Id": null, "Name": "All" }].concat(res.Items);
                });
            } else {
                vm.merchants = null;
            }
        }

        StoreService.GetStoresPublicInfoGroupByMerchant({ MerchantId: vm.filter.MerchantId })
            .then(function (stores) {
                vm.stores = stores;
            })

        vm.tableInstance = {};

        vm.getReport = function () {
            var sdate = $("#sdate").val();
            var edate = $("#edate").val();
            if (sdate == null || sdate == "") {
                alert("Please select start date");
                return;
            }
            if (edate == null || edate == "") {
                alert("Please select end date");
                return;
            }
            vm.tableInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            return MerchantReportService.getStatementOfAccountReportAsync(vm.filter);
        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Outlet transactions report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('Id'),
                DTColumnBuilder.newColumn('CreatedAt').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('MerchantName'),
                DTColumnBuilder.newColumn('Action').withOption('render', function (data) {
                    if (TransactionActionHashMap[data] !== undefined) {
                        return $filter('translate')(TransactionActionHashMap[data].display);
                    }
                    else {
                        return data;
                    }
                }),
                DTColumnBuilder.newColumn('Amount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('StoreCardCashback').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Remarks'),
                DTColumnBuilder.newColumn('WalletId'),
                DTColumnBuilder.newColumn('OutletCode')
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('MerchantsListReportController', MerchantsListReportController);

    /** @ngInject */
    function MerchantsListReportController(DTOptionsBuilder, DTColumnBuilder, MerchantReportService, $filter,
        AuthenticationService, $q, MerchantStateHashMap) {

        var vm = this;
        
        vm.merchantStatus = MerchantStateHashMap;

        vm.filter = {
            MerchantName: null,
            MerchantStatus: null
        }

        vm.tableInstance = {};

        vm.getReport = function () {
            vm.tableInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            return MerchantReportService.getMerchantListReportAsync(vm.filter);
        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50),

            columns: [
                DTColumnBuilder.newColumn('Id'),
                DTColumnBuilder.newColumn('MerchantName'),
                DTColumnBuilder.newColumn('Tags'),
                DTColumnBuilder.newColumn('CompanyMainContactPerson'),
                DTColumnBuilder.newColumn('CompanyMainContactNumber'),
                DTColumnBuilder.newColumn('CompanyEmail'),
                { // address
                    data: null,
                    render: function (row) {
                        var addresses = [];

                        if (row['CompanyAddressStreet']) {
                            addresses.push(row['CompanyAddressStreet']);
                        }
                        if (row['CompanyAddressDistrict']) {
                            addresses.push(row['CompanyAddressDistrict']);
                        }
                        if (row['CompanyAddressStreet']) {
                            addresses.push(row['CompanyAddressCity']);
                        }
                        if (row['CompanyAddressStreet']) {
                            addresses.push(row['CompanyAddressProvince']);
                        }
                        if (row['CompanyAddressStreet']) {
                            addresses.push(row['CompanyAddressState']);
                        }
                        if (row['CompanyAddressStreet']) {
                            addresses.push(row['CompanyAddressCountry']);
                        }

                        return addresses.join(', ');
                    }
                },
                DTColumnBuilder.newColumn('ContractDate').withOption('type', 'Date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy'); }),
                DTColumnBuilder.newColumn('ServiceDate').withOption('type', 'Date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy'); }),
                DTColumnBuilder.newColumn('WebCashId'),
                DTColumnBuilder.newColumn('HashKey'),
                DTColumnBuilder.newColumn('State').withOption('render', function (data) { return $filter('translate')(MerchantStateHashMap[data].display); })
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('MerchantTerminalReportController', MerchantTerminalReportController);

    /** @ngInject */
    function MerchantTerminalReportController(DTOptionsBuilder, DTColumnBuilder, MerchantReportService, $filter,
        MerchantService, $q) {

        var vm = this;
        
        vm.filter = {
            MerchantId: null
        }

        vm.merchants = [];
        MerchantService.GetAllMerchantsOfKiplePay().then(function (merchants) {
            vm.merchants = merchants;
        })

        vm.tableInstance = {};

        vm.getReport = function () {
            vm.tableInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            return MerchantReportService.getMerchantTerminalReportAsync(vm.filter);
        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50),

            columns: [
                DTColumnBuilder.newColumn('POSId'),
                DTColumnBuilder.newColumn('StoreName'),
                DTColumnBuilder.newColumn('StoreAddress'),
                DTColumnBuilder.newColumn('StoreContactNumber'),
                DTColumnBuilder.newColumn('StoreMobileNumber'),
                DTColumnBuilder.newColumn('LastActivityDateTime').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'yyyy-MM-dd HH:mm:ss'); }),
                DTColumnBuilder.newColumn('LastTransactionDateTime').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'yyyy-MM-dd HH:mm:ss'); }),
                DTColumnBuilder.newColumn('AppVersion')
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('MerchantGapReportController', MerchantGapReportController);

    /** @ngInject */
    function MerchantGapReportController(DTOptionsBuilder, DTColumnBuilder, MerchantReportService, $filter,
        MerchantService, AuthenticationService, $q, MerchantStateHashMap) {

        var vm = this;
        
        vm.filter = {
            MerchantStatus: null
        }

        vm.merchantStatus = MerchantStateHashMap;
        
        vm.tableInstance = {};

        vm.getReport = function () {
            vm.tableInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            return MerchantReportService.getMerchantGapReportAsync(vm.filter);
        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50),

            columns: [
                DTColumnBuilder.newColumn('MerchantName'),
                DTColumnBuilder.newColumn('VoucherQty'),
                DTColumnBuilder.newColumn('VoucherActiveQty'),
                DTColumnBuilder.newColumn('VoucherPurchasedQty'),
                DTColumnBuilder.newColumn('VoucherRedeemedQty'),
                DTColumnBuilder.newColumn('State').withOption('render', function (data) {
                    return $filter('translate')(MerchantStateHashMap[data].display);
                })
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('ExceptionTransactionsReportController', ExceptionTransactionsReportController);

    /** @ngInject */
    function ExceptionTransactionsReportController(DTOptionsBuilder, DTColumnBuilder, MerchantReportService, $filter,
        MerchantService, TransactionActionHashMap, AuthenticationService, $$viewAsAdmin, $q, $numUtils) {
        var vm = this;

        vm.filter = {           
            TransactionStartDate: null,
            TransactionEndDate: null
        }
                

        vm.tableInstance = {};

        vm.getReport = function () {
            vm.tableInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            return MerchantReportService.getExceptionTransactionsReportAsync(vm.filter);
        }

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', true)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Exception transaction report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Exception transaction  report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('TransactionDateTime').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('MerchantName'),
                DTColumnBuilder.newColumn('GrossAmount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('DeductionMDR').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('DeductionGST').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('SettlementToMerchant').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('UserID'),
                DTColumnBuilder.newColumn('OutletID')
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('communityReportController', communityReportController);


    communityReportController.$inject = ['DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter', '$numUtils', 'SystemReportService'];

    function communityReportController(DTOptionsBuilder, DTColumnBuilder, $q, $filter, $numUtils, SystemReportService) {
        var vm = this;

        vm.errorMsg = '';
       
        vm.searchModel = {
            username: '',
            category: '',
            TransactionStartDate: null,
            TransactionEndDate: null
        };
        
       
        vm.dtInstance = {};

        vm.searchReport = function () {
            var sdate = $("#sdate").val();
            var edate = $("#edate").val();
            if (sdate == null || sdate == "") {
                alert("Please select start date");
                return;
            }
            if (edate == null || edate == "") {
                alert("Please select end date");
                return;
            }
            vm.errorMsg = null;

            vm.dtInstance.changeData(getReportPromise);
        };
        function getReportPromise() {
         var categoryObj = R.compose(R.take(1),R.filter(function(x){
            var istrue=  vm.searchModel.category === x.Id; 
            return istrue;
          }))(vm.CommunityList);
            var Category;
            if(!!categoryObj&&categoryObj.length>0){
                Category=categoryObj[0].Name;
            }  
           var jsonData = {
                UserName: vm.searchModel.username,
               CommunityCategory: Category,
               TransactionStartDate: vm.searchModel.TransactionStartDate,
                   TransactionEndDate:vm.searchModel.TransactionEndDate
            };
           
            return SystemReportService.getCommunityReportAsync(jsonData);
            
        };

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();
                deferer.resolve([]);
                return deferer.promise;

            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Community Report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Community Report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('CreatedAt').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),,
                DTColumnBuilder.newColumn('WebcashId'),
                DTColumnBuilder.newColumn('UserName'),
                DTColumnBuilder.newColumn('IDNo'),
                DTColumnBuilder.newColumn('CommunityCategory'),
                DTColumnBuilder.newColumn('CommunityPartner'),
                DTColumnBuilder.newColumn('VerifiedBy'),
                DTColumnBuilder.newColumn('CommunityId'),
                DTColumnBuilder.newColumn('UserCategory'),
                DTColumnBuilder.newColumn('Status'),
                DTColumnBuilder.newColumn('Remarks'),
            ] 
        };

        

        

        vm.CommunityList = [
            { Id: 0, Name: 'KipleUNI' },
            { Id: 2, Name: 'KipleRider' },
            { Id: 3, Name: 'KipleSME' },
            { Id: 4, Name: 'KipleWorker' } 
        ];
      
        
        
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('kiplemartTransController', kiplemartTransController);


    kiplemartTransController.$inject = ['DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter', '$numUtils', 'kiplemartService','MerchantService'];

    function kiplemartTransController(DTOptionsBuilder, DTColumnBuilder, $q, $filter, $numUtils, kiplemartService, merchantService) {
        var vm = this;

        vm.errorMsg = '';

        vm.loadMerchant = function (keyword) {
            if (keyword.length >= 3) {
                merchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = res.Items;
                });
            } else {
                vm.merchants = null;
            }
        }

        vm.statusList = [
            { paymentStatus: 0, displayText: 'Pending' },
            { paymentStatus: 1, displayText: 'Successful' },
            { paymentStatus: 2, displayText: 'Failed' },
            { paymentStatus: 3, displayText: 'Refund In Progress' },
            { paymentStatus: 4, displayText: 'Refunded' }
        ];
        vm.serachCriteria = {
            transactionId: null,
            merchantRefNo: '',
            merchantId: null,
            paymentStatus: null,
            beginTime: null,
            endTime: null
        };

        vm.dtInstance = {};

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();
                deferer.resolve([]);
                return deferer.promise;

            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Kiplemart Transaction Report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Kiplemart Transaction Report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('TransactionId'),
                DTColumnBuilder.newColumn('TransactionDatetime').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),,
                DTColumnBuilder.newColumn('UserId'),
                DTColumnBuilder.newColumn('MerchantRefNo'),
                DTColumnBuilder.newColumn('MerchantName'),
                DTColumnBuilder.newColumn('Amount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('DeliveryCharge').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Discount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('VoucherId'),
                DTColumnBuilder.newColumn('PaymentType'),
                DTColumnBuilder.newColumn('PaymentStatusText'),
                DTColumnBuilder.newColumn('IsRefundText'),
                DTColumnBuilder.newColumn('ChannelText')
            ]
        };

        vm.searchReport = function () {
            vm.errorMsg = null;

            if (vm.serachCriteria.beginTime && vm.serachCriteria.endTime) {
                var beginTime = moment(vm.serachCriteria.beginTime);
                var endTime = moment(vm.serachCriteria.endTime);

                var diff = moment(endTime).diff(beginTime, 'minutes');

                if (diff < 0) {
                    vm.errorMsg = "begin time cannot be greater than end time";
                    return;
                }
                var monthDiff = moment(endTime).diff(moment(beginTime), 'months', true);
                
                if (monthDiff > 3) {
                    vm.errorMsg = "range of search up to 3 months";
                    return;
                }
            }
            vm.dtInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            var jsonData = {
                TransactionID: vm.serachCriteria.transactionId,
                MerchantRefNo: vm.serachCriteria.merchantRefNo,
                MerchantId: vm.serachCriteria.merchantId,
                paymentStatus: vm.serachCriteria.paymentStatus,
                BeginTime: vm.serachCriteria.beginTime,
                EndTime: vm.serachCriteria.endTime
            };
            var defer = $q.defer();
            kiplemartService.searchKiplemartTranstFn(jsonData).then(function (response) {
                defer.resolve(response.data);
            });

            return defer.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .service('kiplemartService', kiplemartService);

    kiplemartService.$inject = ['SVCS', '$http'];

    function kiplemartService(SVCS, $http) {

        var searchKiplemartTranstFn = function (jsonData) {
            var url = '{0}/api/orders/v1/kiplemart-trans'.format(SVCS.Wallet);
            return $http.post(url, jsonData, { headers: { 'Content-Type': 'application/json' } });
        };

        return {
            searchKiplemartTranstFn: searchKiplemartTranstFn
        };
    };
})();
(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('peerReportController', peerReportController);


    peerReportController.$inject = ['DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter', '$numUtils', 'SystemReportService'];

    function peerReportController(DTOptionsBuilder, DTColumnBuilder, $q, $filter, $numUtils, SystemReportService) {
        var vm = this;

        vm.errorMsg = '';

        vm.transactionType = [
            { Id: "Split Bill Request", displayText: 'Split Bill Request' },
            { Id: 'Split Bill Transfer', displayText: 'Split Bill Transfer' },
            { Id: 'Send', displayText: 'Send' },
            { Id: 'ReceivedMoney', displayText: 'ReceivedMoney' },
            { Id: 'Request', displayText: 'Request' },
        ];
        vm.searchModel = {
            transactionId:null,
            campaignName: '',
            userName: '',
            transactionType: null,
            beginTime: null,
            endTime: null
        };

        vm.dtInstance = {};

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();
                deferer.resolve([]);
                return deferer.promise;

            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Peer to Peer Report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Peer to Peer Report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('RequestId'),
                DTColumnBuilder.newColumn('TransactionDateTime').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('TransactionType'),
                DTColumnBuilder.newColumn('UserName'),
                DTColumnBuilder.newColumn('Email'),
                DTColumnBuilder.newColumn('PhoneNumber'),
                DTColumnBuilder.newColumn('PaymentType'),
                DTColumnBuilder.newColumn('Amount').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('Status'),
                DTColumnBuilder.newColumn('CampaignName'),
                DTColumnBuilder.newColumn('Remarks'),
                DTColumnBuilder.newColumn('Recipent1'),
                DTColumnBuilder.newColumn('Amount1').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent2'),
                DTColumnBuilder.newColumn('Amount2').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent3'),
                DTColumnBuilder.newColumn('Amount3').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent4'),
                DTColumnBuilder.newColumn('Amount4').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent5'),
                DTColumnBuilder.newColumn('Amount5').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent6'),
                DTColumnBuilder.newColumn('Amount6').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent7'),
                DTColumnBuilder.newColumn('Amount7').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent8'),
                DTColumnBuilder.newColumn('Amount8').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent9'),
                DTColumnBuilder.newColumn('Amount9').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent10'),
                DTColumnBuilder.newColumn('Amount10').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent11'),
                DTColumnBuilder.newColumn('Amount11').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent12'),
                DTColumnBuilder.newColumn('Amount12').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent13'),
                DTColumnBuilder.newColumn('Amount13').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent14'),
                DTColumnBuilder.newColumn('Amount14').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent15'),
                DTColumnBuilder.newColumn('Amount15').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent16'),
                DTColumnBuilder.newColumn('Amount16').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent17'),
                DTColumnBuilder.newColumn('Amount17').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent18'),
                DTColumnBuilder.newColumn('Amount18').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent19'),
                DTColumnBuilder.newColumn('Amount19').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                }),
                DTColumnBuilder.newColumn('Recipent20'),
                DTColumnBuilder.newColumn('Amount20').withOption('render', function (data) {
                    if (data == 0) {
                        return '';
                    }
                    else {
                        return $numUtils.toFixed(data);
                    }
                })
            ]
        };

        vm.searchReport = function () {
            vm.errorMsg = null;
            var sdate = $("#sdate").val();
            var edate = $("#edate").val();
            if (sdate == null || sdate == "") {
                alert("Please select start date");
                return;
            }
            if (edate == null || edate == "") {
                alert("Please select end date");
                return;
            }
            if (vm.searchModel.beginTime && vm.searchModel.endTime) {
                var beginTime = moment(vm.searchModel.beginTime);
                var endTime = moment(vm.searchModel.endTime);

                var diff = moment(endTime).diff(beginTime, 'minutes');

                if (diff < 0) {
                    vm.errorMsg = "begin time cannot be greater than end time";

                    return;
                }
            }

            vm.dtInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            var jsonData = {
                TransactionId: vm.searchModel.transactionId,
                UserName: vm.searchModel.userName,
                TransactionType: vm.searchModel.transactionType,
                CampaignName: vm.searchModel.campaignName,
                BeginTime: vm.searchModel.beginTime,
                EndTime: vm.searchModel.endTime
            };
            var defer = $q.defer();
            SystemReportService.getPeerToPeerReportAsync(jsonData).then(function (response) {
                defer.resolve(response);
            });

            return defer.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('creditReportController', creditReportController);


    creditReportController.$inject = ['DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter','$numUtils', 'bonusService'];

    function creditReportController(DTOptionsBuilder, DTColumnBuilder, $q, $filter, $numUtils, bonusService) {
        var vm = this;

        vm.errorMsg = '';

        vm.statusList = [
            { creditStatus: 0, displayText: 'Pending' },
            { creditStatus: 1, displayText: 'Done' },
            { creditStatus: 2, displayText: 'Failure' },
        ];
        vm.serachModel = {
            campaignName: '',
            userName: '',
            status: '',
            beginTime: null,
            endTime: null
        };

        vm.dtInstance = {};

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();
                deferer.resolve([]);
                return deferer.promise;

            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Bonus Credit Report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Bonus Credit Report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('CampaignName'),
                DTColumnBuilder.newColumn('CreationTime').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('UserName'),
                DTColumnBuilder.newColumn('IDNumber'),
                DTColumnBuilder.newColumn('EWalletCredit').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                //DTColumnBuilder.newColumn('EntitlementDate').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('CreditStatus'),
            ]
        };

        vm.searchReport = function () {
            vm.errorMsg = null;
            var sdate = $("#sdate").val();
            var edate = $("#edate").val();
            if (sdate == null || sdate == "") {
                alert("Please select start date");
                return;
            }
            if (edate == null || edate == "") {
                alert("Please select end date");
                return;
            }
            if (vm.serachModel.beginTime && vm.serachModel.endTime) {
                var beginTime = moment(vm.serachModel.beginTime);
                var endTime = moment(vm.serachModel.endTime);

                var diff = moment(endTime).diff(beginTime, 'minutes');

                if (diff < 0) {
                    vm.errorMsg = "begin time cannot be greater than end time";

                    return;
                }
            }

            vm.dtInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            var jsonData = {
                UserName: vm.serachModel.userName,
                IDNumber: vm.serachModel.IDNumber,
                CampaignName: vm.serachModel.campaignName,
                CreditStatus: vm.serachModel.status,
                BeginTime: vm.serachModel.beginTime,
                EndTime: vm.serachModel.endTime
            };
            var defer = $q.defer();
            bonusService.searchCreditReport(jsonData).then(function (response) {
                defer.resolve(response.data);
            });

            return defer.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.product', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.product', {
                url: '/product',
                abstract: true,
                protect: true,
                permissions: ['VIEW_PRODUCT']
            })
            .state('app.product.list', {
                url: '/',
                views: {
                    'main@app': {
                        templateUrl: 'app/product/product.html',
                        controller: 'ProductController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['VIEW_PRODUCT']
            })
            .state('app.product.create', {
                url: '/create',
                views: {
                    'main@app': {
                        templateUrl: 'app/product/product.detail.html',
                        controller: 'ProductDetailController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['CREATE_PRODUCT']
            })
            .state('app.product.edit', {
                url: '/edit/:id',
                views: {
                    'main@app': {
                        templateUrl: 'app/product/product.detail.html',
                        controller: 'ProductDetailController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['EDIT_PRODUCT']
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/product');
    }
})();
(function () {
    'use strict';

    angular
        .module('app.product')
        .controller('GenericAutomationReportDetailController', GenericAutomationReportDetailController);

    /** @ngInject */

    function GenericAutomationReportDetailController(SVCS, GenericAutomationReportService, $state, $scope, $translate, $timeout, $stateParams, $cookies, $rootScope) {
        var vm = this;

        vm.clear = function () {
            var checkday = 0;
            vm.day = "1";
            vm.activemon = false;
            vm.activetue = false;
            vm.activewed = false;
            vm.activethu = false;
            vm.activefri = false;
            vm.activesat = false;
            vm.activesun = false;
            vm.report = {
                GenericAutomationReportItems: [
                    {
                        Name: null,
                        Sql: null
                    }
                ]
            }
        }
        vm.clear();
        vm.clearActive = function () {
            vm.activemon = false;
            vm.activetue = false;
            vm.activewed = false;
            vm.activethu = false;
            vm.activefri = false;
            vm.activesat = false;
            vm.activesun = false;
        }

        vm.pageHeader = $state.current.name == 'app.reports.genericautomation.create' ? "report.generic_automation.create" : "report.generic_automation.edit";

         //Add New Report
        if (vm.pageHeader == "report.generic_automation.create") {
           
            vm.GenericAutomationReportItems = []
            vm.report = {
                GenericAutomationReportItems: [
                    {
                        Name: null,
                        Sql: null
                    }
                ]
            }
            vm.report.RepeatToInterval = "Daily";
            vm.openDay = null;
            vm.activedaily = true;
            vm.test = {
                Email: null,
                Model: null
            }
        }

        //Edit New Report
        if ($stateParams.id != null) {

            GenericAutomationReportService.Get($stateParams.id).then(function (data) {
                vm.report = data;
                if (vm.report.RepeatToInterval == 'Daily') {
                    vm.openDay = null;
                    vm.activedaily = true;
                }

                if (vm.report.RepeatToInterval == 'Weekly') {
                    vm.openDay = true;
                    vm.activeweekly = true;
                }

                if (vm.report.RepeatToInterval == 'Monthly') {
                    vm.openDay = false;
                    vm.activemonthly = true;
                }

                vm.time = new Date(vm.report.ScheduleAt);

                if (vm.report.RepeatToDay != null) {
                    var RepeatToDay = vm.report.RepeatToDay.split(";");

                    if (vm.report.RepeatToInterval == 'Monthly') {
                        for (var i = 0; i < RepeatToDay.length - 1; i++) {
                            if (RepeatToDay[i] == "First") {
                                vm.activefirst = true;
                            } else if (RepeatToDay[i] == "Last") {
                                vm.activelast = true;
                            } else {
                                angular.forEach(vm.specificdays, function (value, key) {
                                    if (value.Value == RepeatToDay[i]) {
                                        vm.day = RepeatToDay[i];
                                        vm.activespecific = true;
                                    }
                                });
                            }
                        }
                    } else {
                        for (var i = 0; i < RepeatToDay.length - 1; i++) {
                            if (RepeatToDay[i] == "Mon")
                                vm.activemon = true;
                            if (RepeatToDay[i] == "Tue")
                                vm.activetue = true;
                            if (RepeatToDay[i] == "Wed")
                                vm.activewed = true;
                            if (RepeatToDay[i] == "Thu")
                                vm.activethu = true;
                            if (RepeatToDay[i] == "Fri")
                                vm.activefri = true;
                            if (RepeatToDay[i] == "Sat")
                                vm.activesat = true;
                            if (RepeatToDay[i] == "Sun")
                                vm.activesun = true;
                        }
                    }
                }
            })
        }

        // Change Report
        vm.addreportOption = function () {
            vm.report.GenericAutomationReportItems.push(
                {
                    Name: null,
                    Sql: null,
                }
            );
        }

        vm.removeOption = function (index) {
            vm.report.GenericAutomationReportItems.splice(index, 1);
        }

        vm.Mon = function () {
            if (vm.report.RepeatToInterval == 'Weekly') {
                if (vm.activemon) {
                    vm.report.RepeatToDay = vm.report.RepeatToDay.replace("Mon;", "");
                    vm.activemon = !vm.activemon;
                }
                else {
                    vm.clearActive();
                    vm.report.RepeatToDay = "";
                    vm.report.RepeatToDay += "Mon;";
                    vm.activemon = !vm.activemon;
                }
            } else {
                if (vm.activemon) {
                    vm.report.RepeatToDay = vm.report.RepeatToDay.replace("Mon;", "");
                    vm.activemon = !vm.activemon;
                }
                else {
                    vm.report.RepeatToDay += "Mon;";
                    vm.activemon = !vm.activemon;
                }
            }
            
        }
        vm.Tue = function () {
            if (vm.report.RepeatToInterval == 'Weekly') {
                if (vm.activetue) {
                    vm.report.RepeatToDay = vm.report.RepeatToDay.replace("Tue;", "");
                    vm.activetue = !vm.activetue;
                }
                else {
                    vm.clearActive();
                    vm.report.RepeatToDay = "";
                    vm.report.RepeatToDay += "Tue;";
                    vm.activetue = !vm.activetue;
                }
            } else {
                if (vm.activetue) {
                    vm.report.RepeatToDay = vm.report.RepeatToDay.replace("Tue;", "");
                    vm.activetue = !vm.activetue;
                }
                else {
                    vm.report.RepeatToDay += "Tue;";
                    vm.activetue = !vm.activetue;
                }
            }
           
        }
        vm.Wed = function () {
            if (vm.report.RepeatToInterval == 'Weekly') {
                if (vm.activewed) {
                    vm.report.RepeatToDay = vm.report.RepeatToDay.replace("Wed;", "");
                    vm.activewed = !vm.activewed;
                }
                else {
                    vm.clearActive();
                    vm.report.RepeatToDay = "";
                    vm.report.RepeatToDay += "Wed;";
                    vm.activewed = !vm.activewed;
                }
            } else {
                if (vm.activewed) {
                    vm.report.RepeatToDay = vm.report.RepeatToDay.replace("Wed;", "");
                    vm.activewed = !vm.activewed;
                }
                else {
                    vm.report.RepeatToDay += "Wed;";
                    vm.activewed = !vm.activewed;
                }
            }
            
        }
        vm.Thu = function () {
            if (vm.report.RepeatToInterval == 'Weekly') {
                if (vm.activethu) {
                    vm.report.RepeatToDay = vm.report.RepeatToDay.replace("Thu;", "");
                    vm.activethu = !vm.activethu;
                }
                else {
                    vm.clearActive();
                    vm.report.RepeatToDay = "";
                    vm.report.RepeatToDay += "Thu;";
                    vm.activethu = !vm.activethu;
                }
            } else {
                if (vm.activethu) {
                    vm.report.RepeatToDay = vm.report.RepeatToDay.replace("Thu;", "");
                    vm.activethu = !vm.activethu;
                }
                else {
                    vm.report.RepeatToDay += "Thu;";
                    vm.activethu = !vm.activethu;
                }
            }
            
        }
        vm.Fri = function () {
            if (vm.report.RepeatToInterval == 'Weekly') {
                if (vm.activefri) {
                    vm.report.RepeatToDay = vm.report.RepeatToDay.replace("Fri;", "");
                    vm.activefri = !vm.activefri;
                }
                else {
                    vm.clearActive();
                    vm.report.RepeatToDay = "";
                    vm.report.RepeatToDay += "Fri;";
                    vm.activefri = !vm.activefri;
                }
            } else {
                if (vm.activefri) {
                    vm.report.RepeatToDay = vm.report.RepeatToDay.replace("Fri;", "");
                    vm.activefri = !vm.activefri;
                }
                else {
                    vm.report.RepeatToDay += "Fri;";
                    vm.activefri = !vm.activefri;
                }
            }
        }
        vm.Sat = function () {
            if (vm.report.RepeatToInterval == 'Weekly') {
                if (vm.activesat) {
                    vm.report.RepeatToDay = vm.report.RepeatToDay.replace("Sat;", "");
                    vm.activesat = !vm.activesat;
                }
                else {
                    vm.clearActive();
                    vm.report.RepeatToDay = "";
                    vm.report.RepeatToDay += "Sat;";
                    vm.activesat = !vm.activesat;
                }
            } else {
                if (vm.activesat) {
                    vm.report.RepeatToDay = vm.report.RepeatToDay.replace("Sat;", "");
                    vm.activesat = !vm.activesat;
                }
                else {
                    vm.report.RepeatToDay += "Sat;";
                    vm.activesat = !vm.activesat;
                }
            }

        }
        vm.Sun = function () {
            if (vm.report.RepeatToInterval == 'Weekly') {
                if (vm.activesun) {
                    vm.report.RepeatToDay = vm.report.RepeatToDay.replace("Sun;", "");
                    vm.activesun = !vm.activesun;
                }
                else {
                    vm.clearActive();
                    vm.report.RepeatToDay = "";
                    vm.report.RepeatToDay += "Sun;";
                    vm.activesun = !vm.activesun;
                }
            } else {
                if (vm.activesun) {
                    vm.report.RepeatToDay = vm.report.RepeatToDay.replace("Sun;", "");
                    vm.activesun = !vm.activesun;
                }
                else {
                    vm.report.RepeatToDay += "Sun;";
                    vm.activesun = !vm.activesun;
                }
            }
        }

        vm.First = function () {

            if (vm.activefirst) {
                vm.report.RepeatToDay = vm.report.RepeatToDay.replace("First;", "");
                vm.activefirst = !vm.activefirst;
            }
            else {
                vm.report.RepeatToDay = "";
                vm.report.RepeatToDay += "First;";
                vm.activefirst = !vm.activefirst;
                vm.activelast = false;
                vm.activespecific = false;
            }
        }
        vm.Last = function () {

            if (vm.activelast) {
                vm.report.RepeatToDay = vm.report.RepeatToDay.replace("Last;", "");
                vm.activelast = !vm.activelast;
            }
            else {
                vm.report.RepeatToDay = "";
                vm.report.RepeatToDay += "Last;";
                vm.activelast = !vm.activelast;
                vm.activefirst = false;
                vm.activespecific = false;
            }
        }
        vm.Specific = function () {

            if (vm.activespecific) {
                vm.activespecific = !vm.activespecific;
            }
            else {
                vm.report.RepeatToDay = "";
                vm.report.RepeatToDay += "1;";
                vm.activespecific = !vm.activespecific;
                vm.activefirst = false;
                vm.activelast = false;
                vm.day = 1;
            }
        }
        vm.dayandweeks = [
            { Name: "Mon", Value: "1", Active: false },
            { Name: "Tue", Value: "2", Active: false },
            { Name: "Wed", Value: "3", Active: false },
            { Name: "Thu", Value: "4", Active: false },
            { Name: "Fri", Value: "5", Active: false },
            { Name: "Sat", Value: "6", Active: false },
            { Name: "Sun", Value: "7", Active: false }
        ];
        vm.specificdays = [
            { Name: "1", Value: "1" },
            { Name: "2", Value: "2" },
            { Name: "3", Value: "3" },
            { Name: "4", Value: "4" },
            { Name: "5", Value: "5" },
            { Name: "6", Value: "6" },
            { Name: "7", Value: "7" },
            { Name: "8", Value: "8" },
            { Name: "9", Value: "9" },
            { Name: "10", Value: "10" },
            { Name: "11", Value: "11" },
            { Name: "12", Value: "12" },
            { Name: "13", Value: "13" },
            { Name: "14", Value: "14" },
            { Name: "15", Value: "15" },
            { Name: "16", Value: "16" },
            { Name: "17", Value: "17" },
            { Name: "18", Value: "18" },
            { Name: "19", Value: "19" },
            { Name: "20", Value: "20" },
            { Name: "21", Value: "21" },
            { Name: "22", Value: "22" },
            { Name: "23", Value: "23" },
            { Name: "24", Value: "24" },
            { Name: "25", Value: "25" },
            { Name: "26", Value: "26" },
            { Name: "27", Value: "27" },
            { Name: "28", Value: "28" },
            { Name: "29", Value: "29" },
            { Name: "30", Value: "30" },
            { Name: "31", Value: "31" }
        ];
        vm.ChooseDay = function (number) {
            vm.report.RepeatToDay = "";
            vm.day = number;
            vm.report.RepeatToDay += (vm.day + ";");
        }

        vm.Daily = function () {
            vm.openDay = null;
            vm.report.RepeatToInterval = "Daily";

            if (!vm.activeweekly) {
                vm.report.RepeatToDay = "";
            }
            vm.clearActive();
            vm.activedaily = true;
            vm.activeweekly = false;
            vm.activemonthly = false;
            vm.report.RepeatToDay = "";
        }
        vm.Weekly = function () {
            vm.openDay = true;
            vm.report.RepeatToInterval = "Weekly";

            if (!vm.activedaily) {
                vm.report.RepeatToDay = "";
            }
            vm.clearActive();
            vm.report.RepeatToDay += "Mon;";
            vm.activemon = true;
            vm.activedaily = false;
            vm.activeweekly = true;
            vm.activemonthly = false;

        }
        vm.Monthly = function () {
            vm.openDay = false;
            vm.report.RepeatToInterval = "Monthly";
            vm.report.RepeatToDay = "";
            vm.report.RepeatToDay += "First;";
            vm.activefirst = true;
            vm.activespecific = false;
            vm.activelast = false;
            vm.activedaily = false;
            vm.activeweekly = false;
            vm.activemonthly = true;
        }

        vm.save = function () {
            if (!$scope.reportForm.$valid) {
                angular.forEach($scope.reportForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#reportForm .ng-invalid')[0].focus();
                return;
            }

            var i = vm.report.GenericAutomationReportItems.length;
            var j = 1;
            angular.forEach(vm.report.GenericAutomationReportItems, function (value, key) {
                
                GenericAutomationReportService.ExecuteSql(value).then(function (data) {

                    if (data.Body == "NotRun") {
                        alert("Invalid query " + (key + 1) + " , please check again !");
                        return;
                    }else {
                        if (i == j) {
                            vm.datenow = new Date();
                            var date = vm.datenow.getDate();
                            vm.time.setDate(date);
                            var month = vm.datenow.getMonth();
                            vm.time.setMonth(month);
                            var year = vm.datenow.getFullYear();
                            vm.time.setFullYear(year);
                            var scheduleat = vm.time;
                            vm.report.ScheduleAt = scheduleat;

                            if ($stateParams.id != null) {
                                if (vm.report.LastTrigger == null)
                                    vm.report.LastTrigger = "";
                                GenericAutomationReportService.Update(vm.report).then(function (res) {
                                    $state.go('app.reports.genericautomation');
                                })
                            }
                            else {
                                if (vm.report.LastTrigger == null)
                                    vm.report.LastTrigger = "";
                                GenericAutomationReportService.Create(vm.report).then(function (res) {
                                    $state.go('app.reports.genericautomation');
                                })
                                vm.clear();
                            }
                        }
                    }
                    j++;
                })


            });
        }

        vm.sendmail = function () {

            vm.test = {
                Email: vm.test.EmailTest,
                Model: vm.report
            }
            GenericAutomationReportService.SendToEmail(vm.test).then(function (res) {
            })
            vm.viewConfig.ShowDialogTest = false;
        }

        vm.executesql = function (report) {
            
            GenericAutomationReportService.ExecuteSql(report).then(function (data) {
               
                if (data.Header != "Error," && data.Header != "Empty,") {
                    vm.sqlheader = data.Header.split(",");
                    vm.rows = angular.fromJson(data.Body);
                    vm.total = vm.rows.length;

                    for (var i = 0; i < vm.rows.length - 1; i++) {
                        if (vm.rows[i] != "") {
                            vm.rows[i] = vm.rows[i];
                        }
                    }
                }
                else {
                    vm.sqlheader = data.Header;
                    vm.rows = data.Body;
                }
                vm.viewConfig.ShowDialog = true;
            })
        }

        vm.openDialog = function (action, group) {
            vm.viewConfig.Action = action;
            vm.group = {};
            if (action == 'edit') {
                vm.group = angular.copy(group);
            }
            vm.viewConfig.ShowDialog = true;
        }

        vm.checkinput = function (action, group) {

            if (!$scope.reportForm.$valid) {
                angular.forEach($scope.reportForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });

                $('#reportForm .ng-invalid')[0].focus();

                return;
            }

            vm.viewConfig.ShowDialogTest = true;
        }

        vm.cancel = function (action, group) {
            vm.viewConfig.ShowDialog = false;
            vm.viewConfig.ShowDialogTest = false;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('GenericAutomationReportController', GenericAutomationReportController);

    /** @ngInject */
    function GenericAutomationReportController(GenericAutomationReportService, $filter, $cookies) {
        var vm = this;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 5;
        vm.itemsPerPage = 10;
        vm.viewConfig = { ShowMerchantDialog: false, MerchantAction: null, ShowAddUserDialog: false };

        vm.criteria = {
            Keyword: null,
            Page: 1,
            Length: 10
        };

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }

        vm.add = function () {
            vm.viewConfig.ShowDialog = true;
            vm.viewConfig.Action = 'new';
        }


        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            vm.criteria.Page = vm.currentPage;
            vm.criteria.Length = vm.itemsPerPage;
            GenericAutomationReportService.Search(vm.criteria).then(function (res) {
                vm.reports = res.Items;
                vm.totalItems = res.Total;
            })
        }

        vm.search();

        vm.inactive = function (report) {
            GenericAutomationReportService.InActive(report.Id).then(function (res) {
                vm.search();
            })
        }

        vm.active = function (report) {
            GenericAutomationReportService.Active(report.Id).then(function (res) {
                vm.search();
            })
        }


        vm.reset = function () {
            vm.criteria = {
                Keyword: null,
                Page: 1,
                Length: 10
            };
            vm.currentPage = 1;
            vm.search();
        }

        vm.delete = function (report) {

            var message = 'Are you sure you want to remove this report ?';
            var confirm = window.confirm(message);
            if (!confirm) {
                return;
            }
            GenericAutomationReportService.Delete(report.Id).then(function (res) {
                vm.search();
            })
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('ExternalTransactionsReportController', ExternalTransactionsReportController);

    /** @ngInject */
    function ExternalTransactionsReportController(ExternalTransactionReportService, MasterMerchantService, $filter, $cookies) {
        var vm = this;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 5;
        vm.itemsPerPage = 20;

        vm.filter = {
            MasterMerchantId: null
        };

        MasterMerchantService.Search().then(function (res) {
            vm.masterMerchants = res.Items;
        })

        vm.search = function () {
            vm.filter.Page = vm.currentPage;
            vm.filter.Length = vm.itemsPerPage;
            ExternalTransactionReportService.getTransactionHistory(vm.filter).then(function (res) {
                vm.transactions = res.Items;
                vm.totalItems = res.Total;
            })
        }

        vm.search();
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('RemittanceReportController', RemittanceReportController);

    /** @ngInject */
    function RemittanceReportController(DTOptionsBuilder, DTColumnBuilder, ExternalTransactionReportService, MerchantReportService, $filter,
         $q, $numUtils) {
        var vm = this;

        vm.appTypes = [];

        vm.filter = {
            UserName: null,
            MTCN: null,
            RemittanceType: null,
            TransactionAction: null,
            ReceiveMoneyMethods: null,
            TransactionStartDate: null,
            TransactionEndDate:null,
            Partner: null
        }

        vm.tableInstance = {};

        vm.init = function () {
            MerchantReportService.getAppTypes().then(function (data) {
                vm.appTypes = data;
            });
        };

        vm.LoadSearchData = function () {
            vm.getRemittanceType();
            vm.getTransactionType();
            vm.getReceiveMethods();
        }
        
        vm.getRemittanceType = function () {
            ExternalTransactionReportService.getRemittanceType().then(function (remittanceType) {
                vm.RemittanceType = remittanceType;
            });
        };
        vm.getReceiveMethods = function () {
            ExternalTransactionReportService.getReceiveMethods().then(function (ReceiveMethods) {
                vm.ReceiveMoneyOptions = ReceiveMethods;
            });
        };
        vm.getTransactionType = function () {
            ExternalTransactionReportService.getTransactionType().then(function (TransactionType) {
                vm.actionOptions = TransactionType;
            });
        }


        vm.LoadSearchData();
        vm.init();

        vm.getReport = function () {
            var sdate = $("#sdate").val();
            var edate = $("#edate").val();
            if (sdate == null || sdate == "") {
                alert("Please select start date");
                return;
            }
            if (edate == null || edate == "") {
                alert("Please select end date");
                return;
            }
            vm.tableInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            return MerchantReportService.getRemittanceReportAsync(vm.filter);
        }

      

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Remittance Report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Statement of account report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('AccountId'),
                DTColumnBuilder.newColumn('TransactionId').withOption('render', function (data, type, row) {
                    if (row['Status'] == 'Successful') {
                        return data;
                    }
                    else {
                        return ''
                    }
                }),,
                DTColumnBuilder.newColumn('UserName'),
                {
                    data: null,
                    render: function (data, type, row) {
                        if (data['RecFirstName'] == null || data['RecFirstName'] == '') {
                            return '';
                        }
                        else {
                            return data['RecFirstName'] + ' ' + data['RecMiddleName'] + ' ' + data['RecLastName']
                        }
                      
                    }
                },
                {
                    data: null,
                    render: function (data, type, row) {
                        if (data['SenFirstName'] == null || data['SenFirstName'] == '') {
                            return '';
                        }
                        else {
                            return data['SenFirstName'] + ' ' + data['SenMiddleName'] + ' ' + data['SenLastName']
                        }

                    }
                },
                DTColumnBuilder.newColumn('Status').withOption('render', function (data) {
                    if (data == null || data == '') {
                        return 'Failed';
                    }
                    else {
                        return data;
                    }
                }),
                DTColumnBuilder.newColumn('MTCN'),
                DTColumnBuilder.newColumn('RemittanceType'),
                DTColumnBuilder.newColumn('CreatedAt').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('CreatedAt').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('DestinationAmount').withOption('render', function (data, type, row) {
                    if (row['RemittanceType'] == 'WuReceiveMoney') {
                        return $numUtils.toFixed(data);
                    }
                    else {
                        return $numUtils.toFixed(row['OriginationAmount'])
                    }
                }),
                DTColumnBuilder.newColumn('DestinationCountryCode'),
                DTColumnBuilder.newColumn('OriginationCountryCode').withOption('render', function (data, type, row) {
                    if (row['RemittanceType'] == 'WuReceiveMoney') {
                        return data;
                    }
                    else {
                        return 'MY'
                    }
                }),
                DTColumnBuilder.newColumn('Fee').withOption('render', function (data) { return $numUtils.toFixed(data); }),
                DTColumnBuilder.newColumn('ServiceType').withOption('render', function (data, type, row) {
                    if (row['RemittanceType'] == 'WuReceiveMoney') {
                        return '';
                    }
                    else {
                        return data
                    }
                }),
                DTColumnBuilder.newColumn('Reason'),
                DTColumnBuilder.newColumn('Relation'),
                DTColumnBuilder.newColumn('EWagesEmployer'),
                DTColumnBuilder.newColumn('Partner')
                .withTitle('Partner')
                .renderWith(function(data) {
                    return data ? data : 'N/A';
                })
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('InsuranceReportController', InsuranceReportController);

    /** @ngInject */
    function InsuranceReportController(DTOptionsBuilder, DTColumnBuilder, ExternalTransactionReportService, MerchantReportService, $filter,
         $q, $numUtils) {
        var vm = this;

        vm.appTypes = [];

        vm.filter = {
            Employer: null,
            InsuranceProvider: null,
            InsuranceType: null,
            Status: null,
            TransactionStartDate: null,
            TransactionEndDate:null,
            Partner: null
        }
        vm.maxDate = new Date();
        vm.dateOptions = {
            maxDate: vm.maxDate,
            showWeeks: false
        };
        vm.tableInstance = {};

        vm.init = function () {
            MerchantReportService.getAppTypes().then(function (data) {
                vm.appTypes = data;
            });
        };

        vm.LoadSearchData = function () {
            vm.getTransactionType();
            vm.init();
        }
        vm.InsuranceProvider = [
            { Id: 1, Name: 'Vsure' }
        ];
        vm.InsuranceType = [
            { Id: 1, Name: 'EzPA (RM7)' },
            { Id: 2, Name: 'EzPA Silver (RM15)' },
            { Id: 3, Name: 'EzPA Gold (RM30)' },
            { Id: 4, Name: 'EzPA Platinum (RM36)' }
        ];
        vm.getTransactionType = function () {
            ExternalTransactionReportService.getTransactionType().then(function (TransactionType) {
                vm.actionOptions = TransactionType;
            });
        }
        vm.reset = function () {
            vm.filter = {
                Employer: null,
                InsuranceProvider: null,
                InsuranceType: null,
                Status: null,
                TransactionStartDate: null,
                TransactionEndDate: null,
                Partner: null
            }
        }

        vm.LoadSearchData();
        vm.getReport = function () {
            var sdate = $("#sdate").val();
            var edate = $("#edate").val();
            if (sdate == null || sdate == "") {
                alert("Please select start date");
                return;
            }
            if (edate == null || edate == "") {
                alert("Please select end date");
                return;
            }
            vm.tableInstance.changeData(getReportPromise);
        }

        function getReportPromise() {
            return MerchantReportService.getInsuranceReportAsync(vm.filter);
        }

      

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();

                deferer.resolve([]);

                return deferer.promise;
            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 100)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Insurance Report',
                        exportOptions: {
                            columns: ':visible'
                        },
                    },
                    {
                        extend: 'csv',
                        filename: 'Insurance report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('CreatedAt').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('TransactionId'),
                DTColumnBuilder.newColumn('UserName'),
                DTColumnBuilder.newColumn('FullName'),
                DTColumnBuilder.newColumn('DocumentType'),
                DTColumnBuilder.newColumn('NoPlate'),
                DTColumnBuilder.newColumn('PostalCode'),
                DTColumnBuilder.newColumn('InsuranceType'),
                DTColumnBuilder.newColumn('VehicleCoverType'),
                DTColumnBuilder.newColumn('AddOn'),
                DTColumnBuilder.newColumn('SumInsured').withOption('render', function (data, type, row) {
                    return $numUtils.toFixed(data);
                }),
                DTColumnBuilder.newColumn('Amount').withOption('render', function (data, type, row) {
                    return $numUtils.toFixed(data);
                }),
                DTColumnBuilder.newColumn('SST').withOption('render', function (data, type, row) {
                    return $numUtils.toFixed(data);
                }),
                DTColumnBuilder.newColumn('Status').withOption('render', function (data, type, row) {
                    if (data == null) {
                        return 'Failed';
                    }
                    else {
                        return data
                    }
                }),
                DTColumnBuilder.newColumn('Partner'),
                DTColumnBuilder.newColumn('Issuer'),
                DTColumnBuilder.newColumn('Employer')
            ]
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.partner', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.partner', {
                url: '/partner',
                views: {
                    'main@app': {
                        templateUrl: 'app/partner/partnerCategory.html',
                        controller: 'PartnerCategoryController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_SHARED_STORECARD']
            })
            .state('app.partner.edit', {
                url: '/partner/detail/:id',
                views: {
                    'main@app': {
                        templateUrl: 'app/partner/detail/partnerCategory.detail.html',
                        controller: 'PartnerCategoryDetailController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['EDIT_SHARED_STORECARD']
            })
            .state('app.partner.new', {
                url: '/partner/detail',
                views: {
                    'main@app': {
                        templateUrl: 'app/partner/detail/partnerCategory.detail.html',
                        controller: 'PartnerCategoryDetailController',
                        controllerAs: 'vm',
                    }
                },
                protect: true,
                permissions: ['CREATE_SHARED_STORECARD']
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/partner');

    }
})();
(function () {
    'use strict';

    angular
        .module('app.partner')
        .controller('PartnerCategoryDetailController', PartnerCategoryDetailController);

    /** @ngInject */
    function PartnerCategoryDetailController(SVCS, $translate, PartnerCategoryService, $stateParams, $scope, $timeout, $state, MerchantService) {
        var vm = this;
        vm.partnerCategory = {
            Name: null,
            MerchantId: null,
            PartnerType: null
        }

        vm.partnerTypes = [
            { Id: "Settlement", Name: "With Settlement" },
            { Id: "NoSettlement", Name: "Without Settlement" },
            { Id: "RevShare", Name: "Project with Revenue Share" }
        ];

        if ($stateParams.id != null) {
            PartnerCategoryService.Get($stateParams.id).then(function (data) {
                vm.partnerCategory = data;
                if (data.MerchantId) {
                    MerchantService.Get(data.MerchantId).then(function (res) {
                        MerchantService.Search({ Keyword: res.FullName }).then(function (res) {
                            vm.merchants = res.Items;
                        });
                    });
                }
            })
        }

        vm.save = function () {
            if (!$scope.partnerCategoryForm.$valid) {
                angular.forEach($scope.partnerCategoryForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#partnerCategoryForm .ng-invalid')[0].focus();
                return;
            }
            if ($stateParams.id != null) {


                PartnerCategoryService.Get($stateParams.id).then(function (data) {
                    vm.existPartnerCategory = data;

                    var message = '';

                    if (vm.existPartnerCategory.MerchantId != vm.partnerCategory.MerchantId) {

                        if (vm.partnerCategory.MerchantId == null) {
                            message = 'Are you sure you want to remove this merchant?';
                        }
                        else {
                            message = 'Are you sure you want to change this merchant?';
                        }
                    }

                    if (vm.existPartnerCategory.Name != vm.partnerCategory.Name) {
                        var message = 'Are you sure you want to change this merchant? Merchants tagged under this partner will be change too.';
                    }

                    if (message != '') {
                        var confirm = window.confirm(message);
                        if (!confirm) {
                            return;
                        }
                    }

                    PartnerCategoryService.Update(vm.partnerCategory).then(function (data) {
                        $state.go('app.partner');
                    })
                })
            }
            else {
                PartnerCategoryService.Create(vm.partnerCategory).then(function (data) {
                    $state.go('app.partner');
                })
            }
        }

        vm.loadMerchant = function (keyword) {           
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = res.Items;
                });
            } else {
                vm.merchants = null;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.product')
        .controller('ProductDetailController', ProductDetailController);

    /** @ngInject */

    function ProductDetailController(SVCS, ProductService, StoreService, MerchantService, $state, $scope, $translate, $timeout, $stateParams, $cookies, $rootScope) {
        var vm = this;
        vm.productServer = SVCS.Product + '/';
        vm.product = {
            Photos: [],
            Price: 0
        };
        vm.isAdmin = $cookies.get('account_type') == 1 ? true : false;

        vm.pageHeader = $state.current.name == 'app.product.create' ? "product.create_title" : "product.update_title";

        //#region Options of product
        vm.optionTypes = [
            { Id: "OneChoice", Name: "product.options_type.one_choice" },
            { Id: "OneChoiceWithValue", Name: "product.options_type.one_choice_with_value" },
            { Id: "Multichoice", Name: "product.options_type.multichoice" },
            { Id: "MultichoiceWithValue", Name: "product.options_type.multichoice_with_value" }
        ];

        vm.product.Options = []

        vm.addNewOption = function () {
            vm.product.Options.push(
                {
                    Text: null,
                    Type: null,
                    IsRequired: false,
                    OfferOptions: [
                        {
                            Text: null,
                            Value: null
                        }
                    ]
                }
            );
        }
        vm.removeOption = function (index) {
            vm.product.Options.splice(index, 1);
        }

        vm.addNewOfferOption = function (index) {
            vm.product.Options[index].OfferOptions.push(
                {
                    Text: null,
                    Value: null
                }
            );
        }
        vm.removeOfferOption = function (parentIndex, index) {
            vm.product.Options[parentIndex].OfferOptions.splice(index, 1);
        }

        vm.typeChanged = function (index) {
            if (vm.product.Options[index].Type != vm.optionTypes[2].Id) {
                angular.forEach(vm.product.Options[index].OfferOptions, function (item) {
                    item.Value = null;
                });
            }
        }
        //#endregion

        //#region Clear product
        vm.clearForm = function () {
            vm.product = {
                Name: null,
                ShortDescription: null,
                Description: null,
                Thumbnail: null,
                Photos: null,
                OldPrice: null,
                Price: null,
                Quantity: null,
                Sku: null,
                Tags: [],
                Options: [],
                Stores: []
            }

            if (uploadImgControl) {
                uploadImgControl.val('');
            }

            $scope.productForm.$setPristine();
            $scope.productForm.$setUntouched();

        }
        //#endregion
        
        // Get store
        if (!vm.isAdmin) {
            StoreService.GetStoresByMerchantLogin().then(function (res) {
                vm.stores = res;
            });
            $timeout(function () {
                vm.merchantName = $rootScope.authenticationService.account.FullName;
                vm.product.OwnerId = $rootScope.authenticationService.account.Id;
            }, 500);
        }
        else {
            MerchantService.Search({}).then(function (res) {
                vm.merchants = res.Items;
            })
        }

        // Get tag
        ProductService.GetAllTag().then(function (res) {
            vm.tags = res;
        });

        vm.merchantChanged = function () {
            vm.product.StoreIds = null;

            StoreService.Search({MerchantId: vm.product.OwnerId}).then(function (res) {
                vm.stores = [];
                angular.forEach(res.Items, function (item) {
                    vm.stores.push({ Id: item.Id, FullName: item.Name });
                })
            });
        }
        //#endregion

        //#region Create/Update product
        if ($state.current.name == 'app.product.create') {
            
        }
        else if ($state.current.name == 'app.product.edit') {
            ProductService.Get($stateParams.id).then(function (res) {
                vm.product = res;

                StoreService.Search({ MerchantId: vm.product.OwnerId }).then(function (res) {
                    vm.stores = [];
                    angular.forEach(res.Items, function (item) {
                        vm.stores.push({ Id: item.Id, FullName: item.Name });
                    })
                });
            });
            
        }

        vm.save = function () {
            if (!$scope.productForm.$valid) {
                angular.forEach($scope.productForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#informationTab').tab('show');
                $timeout(function () {
                    $('#productForm .ng-invalid')[0].focus();
                }, 200);
                return;
            }
            
            if (!$scope.productOptionForm.$valid) {
                angular.forEach($scope.productOptionForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#optionsTab').tab('show');
                $timeout(function () {
                    $('#productOptionForm .ng-invalid')[0].focus();
                }, 200);
                return;
            }

            $timeout(function () {
           
                if ($state.current.name == 'app.product.create') {
                    ProductService.Create(vm.product).then(function (res) {
                        $state.go('app.product.list');
                    });
                }
                else if ($state.current.name == 'app.product.edit') {
                    ProductService.Update(vm.product).then(function (res) {
                        $state.go('app.product.list');
                    });
                }
            }, 500);
        }
        vm.cancel = function () {
            $state.go('app.product.list');
        }
        //#endregion

        //#region Upload photos
        vm.temp = {};
        vm.uploadPhoto = function (files, invalidFiles) {
            if (invalidFiles.length) {
                $translate('product.validate.photo.file_invalid', { name: invalidFiles[0].name }).then(function (msg) {
                    alert(msg);
                })
                return;
            }

            if (!files || !files.length) {
                return;
            }

            sequentialUpload(files, 0, [], sequentialUploadCompleted);
        };

        vm.removePhoto = function (idx) {
            vm.product.Photos.splice(idx, 1);
        }

        function sequentialUpload(files, i, errorsFiles, callback) {
            ProductService.UploadPhoto(files[i]).then(function (photo) {
                vm.product.Photos.push(photo.Result);
            }, function (error) {
                errorsFiles.push({ file: files[i], error: error });
            }).then(function () {
                if (files.length === i + 1) {
                    callback(errorsFiles);
                } else {
                    sequentialUpload(files, i + 1, errorsFiles, callback);
                }
            });
        }

        function sequentialUploadCompleted(errorsFiles) {
            var filesNames = [];
            if (errorsFiles && errorsFiles.length) {
                angular.forEach(errorsFiles, function (item) {
                    filesNames.push(errorsFiles.file.name);
                })
            }

            if (filesNames.length) {
                $translate('product.validate.photo.upload_error', { names: filesNames.join(', ') }).then(function (msg) {
                    alert(msg);
                })
            }
        }
        //#endregion
    }
})();

(function () {
    'use strict';

    angular
        .module('app.product')
        .controller('ProductController', ProductController);

    /** @ngInject */

    function ProductController(SVCS, ProductService, MerchantService, $state, $scope, $translate, $cookies) {
        var vm = this;
        vm.productServer = SVCS.Product + '/';
        vm.isAdmin = $cookies.get('account_type') == 1 ? true : false;

        // Search product
        vm.criteria = {
            Keyword: null,
            State: null,
            OwnerId: null,
            Page: 1,
            Length: 10
        };

        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;

        vm.states = [
            { Id: "publish", Name: 'product.states.publish' },
            { Id: "unpublish", Name: 'product.states.unpublish' }
        ]

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        };

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            ProductService.Search(criteria).then(function (data) {
                vm.products = data.Items;
                vm.totalItems = data.Total;

                GetOwnerName();
            });
        }

        vm.reset = function () {
            vm.criteria = {
                Keyword: null,
                Category: null,
                State: null,
                OwnerId: null,
                Page: 1,
                Length: 10
            };
            vm.currentPage = 1;
            if (vm.isAdmin) {
                MerchantService.Search({ Page: 1, Length: 10 }).then(function (res) {
                    vm.merchants = res.Items;
                    vm.search();
                })
            }
            else {
                vm.search();
            }
        }

        if (vm.isAdmin) {
            vm.search();
            //MerchantService.Search({ Page: 1, Length: 10 }).then(function (res) {
            //    vm.merchants = res.Items;
            //    vm.search();
            //})
        }
        else {
            vm.search();
        }

        vm.loadMerchant = function (keyword) {
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = res.Items;
                });
            } else {
                vm.merchants = null;
            }
        }

        function GetOwnerName() {
            if (!vm.merchants) {
                return;
            }

            angular.forEach(vm.products, function (item) {
                var merchant = vm.merchants.findItem('Id', item.OwnerId);
                if (merchant) {
                    item.OwnerName = merchant.Name;
                }
            })
        }
        // End - Search product

        // Publish & Unpublish product
        vm.unpublish = function (product) {
            ProductService.Unpublish(product.Id).then(function (res) {
                product.State = 'Unpublish';
            })
        }

        vm.publish = function (product) {
            ProductService.Publish(product.Id).then(function (res) {
                product.State = 'Publish';
            })
        }
        // End - Publish & Unpublish product

        // Delete product
        vm.delete = function (id) {
            ProductService.Delete(id).then(function (res) {
                vm.search();
            })
        }
        // End - Delete product
    }
})();

(function () {
    'use strict';

    angular
        .module('app.merchant', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.merchant', {
                url: '/merchant',
                abstract: true
            })
            .state('app.merchant.master', {
                url: '/master',
                views: {
                    'main@app': {
                        templateUrl: 'app/merchant/master-merchant/master-merchant.html',
                        controller: 'MasterMerchantController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_MASTER_MERCHANT', 'CREATE_MASTER_MERCHANT', 'EDIT_MASTER_MERCHANT', 'DELETE_MASTER_MERCHANT']
            })
            .state('app.merchant.list', {
                url: '/',
                views: {
                    'main@app': {
                        templateUrl: 'app/merchant/merchant.html',
                        controller: 'MerchantController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['VIEW_LIST_MERCHANT','COMMISSION_PAYOUT_ADMIN']
            })
            .state('app.merchant.user', {
                url: '/user',
                views: {
                    'main@app': {
                        templateUrl: 'app/merchant/user/merchant.user.html',
                        controller: 'MerchantUserController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['ADD_USER_TO_MERCHANT', 'REMOVE_USER_FROM_MERCHANT']
            })
            .state('app.merchant.info', {
                url: '/:merchantId',
                views: {
                    'main@app': {
                        templateUrl: 'app/merchant/info/merchant.view.layout.html'
                    },
                    'merchantInfo@app.merchant.info': {
                        templateUrl: 'app/merchant/info/merchant.view.info.html',
                        params: {'merchantId': null},
                        controller: 'MerchantInfoController',
                        controllerAs: 'vm'
                    },
                    'merchantStoreCard@app.merchant.info': {
                        templateUrl: 'app/merchant/info/merchant.view.storecard.html',
                        params: { 'merchantId': null },
                        controller: 'MerchantStoreCardController',
                        controllerAs: 'vm'
                    },
                    'merchantWallet@app.merchant.info': {
                        templateUrl: 'app/merchant/info/merchant.view.wallet.html',
                        params: { 'merchantId': null },
                        controller: 'MerchantWalletController',
                        controllerAs: 'vm'
                    },
                    'merchantWebhook@app.merchant.info': {
                        templateUrl: 'app/merchant/info/merchant.view.webhook.html',
                        params: { 'merchantId': null },
                        controller: 'MerchantWebhookController',
                        controllerAs: 'vm'
                    }, 
                    'merchantPrefund@app.merchant.info': {
                        templateUrl: 'app/merchant/info/merchant.view.prefund.html',
                        controller: 'MerchantPrefundController',
                        controllerAs: 'vm'
                    }
                },
                protect: true,
                permissions: ['VIEW_MERCHANT', 'EDIT_MERCHANT']
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/merchant');

    }
})();
(function () {
    'use strict';

    angular
        .module('app.merchant')
        .factory('UserPermissionService', UserPermissionService);

    /** @ngInject */
    function UserPermissionService(SVCS, $http, $q, CoreService) {
        var authServer = SVCS.Auth;
        var gatewayServer = SVCS.Gateway;

        var service = {
            Search: Search,
            UpdateUserPermission: UpdateUserPermission
        };

        return service;

        function Search(criteria) {
            var deferer = $q.defer();
            CoreService.Post(gatewayServer + '/api/internal/user/search/merchant', criteria).then(function (response) {
                deferer.resolve(response);
            })
            return deferer.promise;
        }

        function UpdateUserPermission(userPermissionModel) {
            var deferer = $q.defer();

            CoreService.Put(authServer + '/api/account/internal/permission', userPermissionModel).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.merchant')
        .controller('MerchantUserController', MerchantUserController);

    /** @ngInject */
    function MerchantUserController(SVCS, $translate, UserPermissionService, MerchantService, $scope, $cookies, $rootScope, $timeout, AuthenticationService) {
        var vm = this;
        vm.currentUserId = $cookies.get('account_id');

        vm.criteria = { Keyword: null, Page: 1, Length: 10 };
        vm.permissions = [
            { Name: "common.permission.view", Value: "VIEW_MERCHANT" },
            { Name: "common.permission.edit", Value: "EDIT_MERCHANT" },
            //{ Name: "common.permission.merchant.add_new_user", Value: "ADD_USER_TO_MERCHANT" },
            //{ Name: "common.permission.merchant.remove_user", Value: "REMOVE_USER_FROM_MERCHANT" },
            { Name: "common.permission.merchant.change_password_user", Value: "CHANGE_PASSWORD_USER_MERCHANT" },
            { Name: "common.permission.merchant.commission_payout_configuration", Value: "COMMISSION_PAYOUT_CONFIGURATION" },
            { Name: "common.permission.merchant.commission_payout_bulk_upload", Value: "COMMISSION_PAYOUT_BULK_UPLOAD" },
            { Name: "common.permission.merchant.commission_payout_report", Value: "COMMISSION_PAYOUT_REPORT" },
            { Name: "common.permission.store.view_list_store", Value: "VIEW_LIST_STORE" },
            { Name: "common.permission.store.create", Value: "CREATE_STORE" },
            { Name: "common.permission.store.edit", Value: "EDIT_STORE" },
            { Name: "common.permission.store.publish", Value: "PUBLISH_STORE" },
            { Name: "common.permission.store.remove", Value: "DELETE_STORE" },
            { Name: "common.permission.store.add_new_manager", Value: "ADD_MANAGER_TO_STORE" },
            { Name: "common.permission.product.view", Value: "VIEW_PRODUCT" },
            { Name: "common.permission.product.edit", Value: "EDIT_PRODUCT" },
            { Name: "common.permission.product.delete", Value: "DELETE_PRODUCT" },
            { Name: "common.permission.product.create", Value: "CREATE_PRODUCT" },
            { Name: "common.permission.product.publish", Value: "PUBLISH_PRODUCT" },
            { Name: "common.permission.store.manage_table", Value: "MANAGE_TABLE" },
            { Name: "common.permission.store.manage_static_qr", Value: "MANAGE_STATIC_QR" },
            { Name: "common.permission.store.view_storecard_transactions_report", Value: "VIEW_STORECARD_TRANSACTION_REPORT" }
        ];

        if (AuthenticationService.hasPermissions('COMMISSION_PAYOUT_ADMIN')) {
            vm.permissions.push({ Name: "common.permission.merchant.commission_payout_admin", Value: "COMMISSION_PAYOUT_ADMIN" });
            vm.permissions.push({ Name: "common.permission.merchant.view_list_merchant", Value: "VIEW_LIST_MERCHANT" });
            vm.permissions.push({ Name: "common.permission.merchant.create_merchant", Value: "CREATE_MERCHANT" });
            vm.permissions.push({ Name: "common.permission.merchant.delete_merchant", Value: "DELETE_MERCHANT" });
            vm.permissions.push({ Name: "common.permission.merchant.publish_merchant", Value: "PUBLISH_MERCHANT" });
            vm.permissions.push({ Name: "common.permission.merchant.add_new_user", Value: "ADD_USER_TO_MERCHANT" });
            vm.permissions.push({ Name: "common.permission.merchant.remove_user", Value: "REMOVE_USER_FROM_MERCHANT" });
        }
        
        vm.showDialog = false;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 5;
        vm.itemsPerPage = 10;
        vm.isAdmin = $cookies.get('account_type') == 1 ? true : false;

        vm.user = { UserName: null, Password: null, ConfirmPassword: null, ObjectId: null, ObjectType: 'Merchant', AccountType: 'Merchant', Permissions: [] };

        vm.isMerchantUser = $cookies.get('account_type') == 2 ? true : false;

      
        MerchantService.GetAllMerchantsPublicInfo().then(function (res) {
            vm.merchants = res;
        })

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            criteria.MerchantId = vm.criteria.MerchantId;
            UserPermissionService.Search(criteria).then(function (res) {
                vm.users = [];
                vm.totalItems = res.Total;
                angular.forEach(res.Items, function (item) {
                    var user = { UserId: item.UserId, UserName: item.UserName, ObjectId: item.ObjectId, ObjectName: item.ObjectName, Permissions: [] };
                    angular.forEach(item.Permissions, function (permission) {
                        var temp = vm.permissions.findItem('Value', permission);
                        if (temp != undefined) {
                            user.Permissions.push(temp.Value);
                        }
                    })
                    vm.users.push(user);
                })
            })
        }

        vm.reset = function () {
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }

        vm.edit = function (user) {
            vm.showDialog = true;
            vm.user = user;
        }

        vm.SelectedAll = true;

        vm.selectAll = function () {
            if (vm.SelectedAll)
            {
                vm.user.Permissions = [];
                angular.forEach(vm.permissions, function (item) {
                    vm.user.Permissions.push(item.Value);
                });

                vm.SelectedAll = false;
            }
            else {
                vm.user.Permissions = [];
                vm.SelectedAll = true;
            }
        }

        vm.addPermission = function (permission) {
            if (vm.user.Permissions.indexOf(permission) != -1) {
                vm.user.Permissions.removeItem(permission);
            }
            else {
                vm.user.Permissions.push(permission);
            }
        }

        vm.cancelAddUser = function () {
            vm.search();
            vm.showDialog = false;
        };

        vm.permissionSelected = function (value) {
            if (vm.user == undefined) {
                return;
            }

            if (vm.user.Permissions.indexOf(value) != -1) {
                return true;
            }
            else {
                return false;
            }
        }

        vm.saveUser = function () {
            var user = { Id: vm.user.UserId, Permissions: vm.user.Permissions };
            UserPermissionService.UpdateUserPermission(user).then(function () {
                vm.showDialog = false;
                vm.user = undefined;
            })
        }

        vm.removeUser = function (userId) {
            $translate("merchant.confirm_remove_user").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }

                MerchantService.RemoveUser(userId).then(function (res) {
                    var user = vm.users.findItem('UserId', userId);
                    if (user) {
                        vm.users.removeItem(user);
                    }
                });
            })
        }

        // Merchant add user
        vm.viewConfig = { ShowAddUserDialog: false, ShowChangePasswordDialog: false };

        vm.addUser = function () {
            vm.viewConfig.ShowAddUserDialog = true;
        }

        vm.changePassword = function (userId) {
            vm.changePasswordModel = { AccountId: userId, NewPassword: null, ConfirmPassword: null };
            vm.viewConfig.ShowChangePasswordDialog = true;
        }

        vm.saveChangePassword = function () {
            MerchantService.ChangePassword(vm.changePasswordModel).then(function () {
                vm.changePasswordModel = undefined;
                vm.viewConfig.ShowChangePasswordDialog = false;
            })
        }

        vm.saveNewUser = function () {
            if (!$scope.merchantUserForm.$valid) {
                angular.forEach($scope.merchantUserForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#merchantUserForm .ng-invalid')[0].focus();
                return;
            }

            vm.user.ObjectId = 0;

            MerchantService.AddUser(vm.user).then(function (res) {
                vm.viewConfig.ShowAddUserDialog = false;
                vm.user = { UserName: null, Password: null, ComfirmPassword: null, ObjectId: null, ObjectType: 'Merchant', AccountType: 'Merchant', Permissions: [] };
                vm.search();
            })
        }

        vm.search();

        vm.loadMerchant = function (keyword) {            
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = res.Items;
                });
            } else {
                vm.merchants = null;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.merchant')
        .controller('MerchantWebhookController', MerchantWebhookController);

    /** @ngInject */
    function MerchantWebhookController(SVCS, $translate, WebhookService, $scope, $rootScope, $stateParams) {
        var vm = this;
        vm.merchantId = $stateParams.merchantId;
        $("div").removeClass("modal-backdrop");
        vm.getWebhook = function () {

            WebhookService.GetByMerchant(vm.merchantId).then(function (res) {
                setDefaultWebhook(vm.merchantId);

                setDeeplinkWebhook(vm.merchantId);

                angular.forEach(vm.webhooks, function (item) {
                    var webhook = res.findItem('Type', item.Type);
                    if (webhook) {
                        item.CallBackUrl = webhook.CallBackUrl;
                    }
                })

                angular.forEach(vm.deeplinks, function (item) {
                    var webhook = res.findItem('Type', item.Type);
                    if (webhook) {
                        item.CallBackUrl = webhook.CallBackUrl;
                    }
                })

            })
        }

        vm.saveWebhook = function () {
            var webhooks = [];
            angular.forEach(vm.webhooks, function (item) {
                if (!utils.isNullOrEmpty(item.CallBackUrl)) {
                    item.MerchantId = vm.merchantId;
                    webhooks.push(item);
                }
            })

            angular.forEach(vm.deeplinks, function (item) {
                if (!utils.isNullOrEmpty(item.CallBackUrl)) {
                    item.MerchantId = vm.merchantId;
                    webhooks.push(item);
                }
            })

            if (webhooks.length == 0) {
                WebhookService.Delete(vm.merchantId);
            }
            else {
                WebhookService.CreateOrUpdate(webhooks).then(function (res) { })
            }
        }

        function setDefaultWebhook(merchantId) {
            vm.webhooks = [
                { CallBackUrl: null, Type: 'SignUp', TypeName: 'Account registration', MerchantId: merchantId, Rank: 0 },
                { CallBackUrl: null, Type: 'Topup', TypeName: 'Topup', MerchantId: merchantId, Rank: 1 },
                { CallBackUrl: null, Type: 'Payment', TypeName: 'Payment', MerchantId: merchantId, Rank: 2 },
                { CallBackUrl: null, Type: 'Hold', TypeName: 'Hold', MerchantId: merchantId, Rank: 3 },
                { CallBackUrl: null, Type: 'CompleteHold', TypeName: 'Commit hold', MerchantId: merchantId, Rank: 4 },
                { CallBackUrl: null, Type: 'Void', TypeName: 'Void transaction', MerchantId: merchantId, Rank: 5 }
            ]
        }

        function setDeeplinkWebhook(merchantId) {
            vm.deeplinks = [
                { CallBackUrl: null, Type: 'Deeplink', TypeName: 'Deeplink', MerchantId: merchantId, Rank: 6 }
            ]
        }

        vm.getWebhook();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.merchant')
        .controller('MerchantWalletController', MerchantWalletController);

    /** @ngInject */
    function MerchantWalletController(SVCS, $translate, MerchantService, SharedStoreCardService, PartnerCategoryService, $scope, $rootScope, $filter, $stateParams, $cookies, $timeout, $window, $numUtils, AdminUserService, $state) {
        var vm = this;
        vm.alertTitle = "Success!";
        vm.showMessage = false;
        vm.isSuccess = true;
        vm.doFade = false;
        vm.userWalletModel = {};
        $("div").removeClass("modal-backdrop");
        // vm.getPartnerCategories = function () {
        //     PartnerCategoryService.All().then(function (data) {
        //         vm.partnerCategories = data;
        //         angular.forEach(vm.partnerCategories, function (partercategory) {
        //             if (vm.merchant.IsPartnerMerchant) {
        //                 if (partercategory.Id == vm.merchant.PartnerCategoryId) {
        //                     vm.partnerCategoryName = partercategory.Name;
        //                 }
        //             }
        //         })
        //     })
        // }

        var accountType = $cookies.get('account_type');
        $rootScope.accountType = accountType;

        if (accountType == 2) {
            MerchantService.GetProfile().then(function (data) {
                vm.merchant = data;
                vm.getWalletInfo(vm.merchant.Id);
            });
        }
        if (accountType == 1) {
            MerchantService.Get($stateParams.merchantId).then(function (data) {
                vm.merchant = data;
                vm.getWalletInfo(vm.merchant.Id);
            });
        }

        // Upload logo
        vm.loading = { UploadMerchantLogo: false }
        // End upload logo
        vm.viewConfig = { ShowMerchantDialog: false };

        vm.isNoUserData = true;
        vm.getWalletInfo = function (merchantId) {
            MerchantService.GetWalletInfo(merchantId).then(function (data) {
                vm.userWalletInfos = data;
                if (vm.userWalletInfos.length == 0) {
                    vm.isNoUserData = true;
                } else {

                    var totalBalance = 0;

                    var tempInfo = [];
                    // Rounding 2 decimal
                    angular.forEach(vm.userWalletInfos, function (info) {
                        var temp = angular.copy(info);
                        temp.Amount = $numUtils.toFixed(temp.CurrentBalance);

                        totalBalance = totalBalance + temp.Amount;

                        tempInfo.push(temp);
                    }, tempInfo);

                    vm.userWalletInfos = tempInfo;

                    vm.totalBalance = $numUtils.toFixed(totalBalance);
                    vm.isNoUserData = false;
                }
            }, function (error) {
            });
        }

        vm.criteria = {
            MerchantId: $stateParams.merchantId,
            Page: 1,
            Length: 10,
            TransactionStartDate: null,
            TransactionEndDate: null
        }
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 5;
        vm.itemsPerPage = 10;
    }
})();
(function () {
    'use strict';

    angular
        .module('app.merchant')
        .controller('MerchantStoreCardController', MerchantStoreCardController);

    /** @ngInject */
    function MerchantStoreCardController(SVCS, $translate, MerchantService, SharedStoreCardService, PartnerCategoryService, $scope, $rootScope, $filter, $stateParams, $cookies, $timeout, $window, $numUtils, AdminUserService, $state) {
        var vm = this;
        $("div").removeClass("modal-backdrop");
        vm.getSharedStoreCardSetting = function (brandId) {
            SharedStoreCardService.GetByBrandId(brandId).then(function (data) {
                vm.sharedStoreCardSetting = data;
                if (vm.merchant.Id > 0) {
                    vm.sharedStoreCardSetting = $.grep(vm.sharedStoreCardSetting, function (b) {
                        return b.MerchantId != vm.merchant.Id;
                    });
                }
            })
        }

        vm.getPartnerCategories = function () {
            PartnerCategoryService.All().then(function (data) {
                vm.partnerCategories = data;
                angular.forEach(vm.partnerCategories, function (partercategory) {
                    if (vm.merchant.IsPartnerMerchant) {
                        if (partercategory.Id == vm.merchant.PartnerCategoryId) {
                            vm.partnerCategoryName = partercategory.Name;
                        }
                    }
                })
            })
        }

        vm.requiredWebcashId = true;

        vm.getPartnerType = function (partnerCategoryId) {
            angular.forEach(vm.partnerCategories, function (val) {
                if (val.Id == partnerCategoryId) {
                    if (val.PartnerType == "NoSettlement") {
                        vm.requiredWebcashId = false;
                    }
                    else {
                        vm.requiredWebcashId = true;
                    }
                }
            })
        }

        var accountType = $cookies.get('account_type');
        $rootScope.accountType = accountType;

        if (accountType == 2) {
            MerchantService.GetProfile().then(function (data) {
                vm.merchant = data;
                //vm.getPartnerCategories();
                $rootScope.storeCardSetting = vm.merchant.StoreCardEnabled;
                if (vm.merchant.ServiceDate) {
                    vm.merchant.ServiceDate = new Date(vm.merchant.ServiceDate);
                }
                if (vm.merchant.ContractDate) {
                    vm.merchant.ContractDate = new Date(vm.merchant.ContractDate);
                }
                //if (vm.merchant.StoreCardSettings.length != 0) {
                //    var maxAmount = $filter('filter')(vm.merchant.StoreCardSettings, function (setting) { return setting.Name === "Max Amount"; })[0];
                //    vm.MaxAmount = maxAmount != undefined ? maxAmount.Value : '';
                //    if (vm.MaxAmount != '') {
                //        vm.maxAmountSettingAction = 'Edit';
                //    } else {
                //        vm.maxAmountSettingAction = 'Create';
                //    }

                //    var validityPeriod = $filter('filter')(vm.merchant.StoreCardSettings, function (setting) { return setting.Name === "Validity Period"; })[0];
                //    vm.ValidityPeriod = validityPeriod != undefined ? validityPeriod.Value : '';
                //    if (vm.ValidityPeriod != '') {
                //        vm.validityPeriodSettingAction = 'Edit';
                //    } else {
                //        vm.validityPeriodSettingAction = 'Create';
                //    }

                //    var termAndConditions = $filter('filter')(vm.merchant.StoreCardSettings, function (setting) { return setting.Name === "Terms and Conditions"; })[0];
                //    vm.TermAndConditions = termAndConditions != undefined ? termAndConditions.Value : '';
                //    if (vm.TermAndConditions != '') {
                //        vm.termAndConditionsSettingAction = 'Edit';
                //    } else {
                //        vm.termAndConditionsSettingAction = 'Create';
                //    }
                //}

                vm.merchantId = vm.merchant.Id;
                //vm.getWalletInfo(vm.merchant.Id);
            });
        }

        if (accountType == 1) {
            MerchantService.Get($stateParams.merchantId).then(function (data) {
                vm.merchant = data;
                //vm.getPartnerCategories();

                if (vm.merchant.PartnerCategoryId) {
                    vm.getPartnerType(vm.merchant.PartnerCategoryId);
                }

                $rootScope.storeCardSetting = vm.merchant.StoreCardEnabled;
                if (vm.merchant.ServiceDate) {
                    vm.merchant.ServiceDate = new Date(vm.merchant.ServiceDate);
                }
                if (vm.merchant.ContractDate) {
                    vm.merchant.ContractDate = new Date(vm.merchant.ContractDate);
                }
                if (vm.merchant.StoreCardSettings.length != 0) {
                    var maxAmount = $filter('filter')(vm.merchant.StoreCardSettings, function (setting) { return setting.Name === "Max Amount"; })[0];
                    vm.MaxAmount = maxAmount != undefined ? maxAmount.Value : '';
                    if (vm.MaxAmount != '') {
                        vm.maxAmountSettingAction = 'Edit';
                    } else {
                        vm.maxAmountSettingAction = 'Create';
                    }

                    var validityPeriod = $filter('filter')(vm.merchant.StoreCardSettings, function (setting) { return setting.Name === "Validity Period"; })[0];
                    vm.ValidityPeriod = validityPeriod != undefined ? validityPeriod.Value : '';
                    if (vm.ValidityPeriod != '') {
                        vm.validityPeriodSettingAction = 'Edit';
                    } else {
                        vm.validityPeriodSettingAction = 'Create';
                    }

                    var termAndConditions = $filter('filter')(vm.merchant.StoreCardSettings, function (setting) { return setting.Name === "Terms and Conditions"; })[0];
                    vm.TermAndConditions = termAndConditions != undefined ? termAndConditions.Value : '';
                    if (vm.TermAndConditions != '') {
                        vm.termAndConditionsSettingAction = 'Edit';
                    } else {
                        vm.termAndConditionsSettingAction = 'Create';
                    }
                }

                vm.merchantId = vm.merchant.Id;
                //vm.getWalletInfo(vm.merchant.Id);
            });
        }

        //#region StoreCard
        vm.viewConfig = { ShowMerchantDialog: false };
        vm.isMaxAmountEditing = false;
        vm.isValidityPeriorEditing = false;
        vm.isTermsAndConditionsEditing = false;

        vm.editMaxAmountSetting = function () {
            vm.isMaxAmountEditing = true;
        }

        vm.editValidityPeriodSetting = function () {
            vm.isValidityPeriorEditing = true;
        }

        vm.editTermsAndConditionsSetting = function () {
            vm.isTermsAndConditionsEditing = true;
        }

        vm.updateStoreCardSetting = function () {

            if (!$scope.storeCardForm.$valid) {
                angular.forEach($scope.storeCardForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });

                return;
            }

            if (vm.isMaxAmountEditing) {

                vm.settingModel = { MerchantId: vm.merchantId };
                vm.settingModel.Name = "Max Amount";
                vm.settingModel.Value = vm.MaxAmount;
                if (vm.maxAmountSettingAction == 'Edit') {
                    MerchantService.UpdateStoreCardSetting(vm.settingModel).then(function (data) {
                        vm.newSetting = data;
                    }, function (error) {
                    });
                } else if (vm.maxAmountSettingAction == 'Create') {
                    MerchantService.CreateStoreCardSetting(vm.settingModel).then(function (data) {
                        vm.newSetting = data;
                        vm.maxAmountSettingAction == 'Edit'
                    }, function (error) {
                    });
                }

                vm.isMaxAmountEditing = false;
            }

            if (vm.isValidityPeriorEditing) {

                vm.settingModel = { MerchantId: vm.merchantId };
                vm.settingModel.Name = "Validity Period";
                vm.settingModel.Value = vm.ValidityPeriod;

                if (vm.validityPeriodSettingAction == 'Edit') {
                    MerchantService.UpdateStoreCardSetting(vm.settingModel).then(function (data) {
                        vm.newSetting = data;
                    }, function (error) {
                    });
                } else if (vm.validityPeriodSettingAction == 'Create') {
                    MerchantService.CreateStoreCardSetting(vm.settingModel).then(function (data) {
                        vm.newSetting = data;
                        vm.validityPeriodSettingAction == 'Edit';
                    }, function (error) {
                    });
                }
                vm.isValidityPeriorEditing = false;
            }

            if (vm.isTermsAndConditionsEditing) {

                vm.settingModel = { MerchantId: vm.merchantId };
                vm.settingModel.Name = "Terms and Conditions";
                vm.settingModel.Value = vm.TermAndConditions;

                if (vm.termAndConditionsSettingAction == 'Edit') {
                    MerchantService.UpdateStoreCardSetting(vm.settingModel).then(function (data) {
                        vm.newSetting = data;
                    }, function (error) {
                    });
                } else if (vm.termAndConditionsSettingAction == 'Create') {
                    MerchantService.CreateStoreCardSetting(vm.settingModel).then(function (data) {
                        vm.newSetting = data;
                        vm.termAndConditionsSettingAction = 'Edit';
                    }, function (error) {
                    });
                }
                vm.isTermsAndConditionsEditing = false;
            }
        }

        //#endregion



        
       
        

        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.merchant')
        .controller('MerchantPrefundController', MerchantPrefundController);

    /** @ngInject */
    function MerchantPrefundController(SVCS, $translate, MerchantService, SharedStoreCardService, PartnerCategoryService, $scope, $rootScope, $filter, $stateParams, $cookies, $timeout, $window, $numUtils, AdminUserService, $state) {
        var vm = this;
        vm.alertTitle = "Success!";
        vm.showMessage = false;
        vm.isSuccess = true;
        vm.doFade = false;
        vm.userWalletModel = {};
        $("div").removeClass("modal-backdrop");
      
        var accountType = $cookies.get('account_type');
        $rootScope.accountType = accountType;
        
        if (accountType == 2) {
            MerchantService.GetProfile().then(function (data) {
                vm.merchant = data;
                //vm.getPartnerCategories();
                $rootScope.storeCardSetting = vm.merchant.StoreCardEnabled;
                if (vm.merchant.ServiceDate) {
                    vm.merchant.ServiceDate = new Date(vm.merchant.ServiceDate);
                }
                if (vm.merchant.ContractDate) {
                    vm.merchant.ContractDate = new Date(vm.merchant.ContractDate);
                }
                vm.merchantId = vm.merchant.Id;
               // vm.getWalletInfo(vm.merchant.Id);
            });
        }
        if (accountType == 1) {
            MerchantService.Get($stateParams.merchantId).then(function (data) {
                vm.merchant = data;
                //vm.getPartnerCategories();

                if (vm.merchant.PartnerCategoryId) {
                    vm.getPartnerType(vm.merchant.PartnerCategoryId);
                }

                $rootScope.storeCardSetting = vm.merchant.StoreCardEnabled;
                if (vm.merchant.ServiceDate) {
                    vm.merchant.ServiceDate = new Date(vm.merchant.ServiceDate);
                }
                if (vm.merchant.ContractDate) {
                    vm.merchant.ContractDate = new Date(vm.merchant.ContractDate);
                }
                if (vm.merchant.StoreCardSettings.length != 0) {
                    var maxAmount = $filter('filter')(vm.merchant.StoreCardSettings, function (setting) { return setting.Name === "Max Amount"; })[0];
                    vm.MaxAmount = maxAmount != undefined ? maxAmount.Value : '';
                    if (vm.MaxAmount != '') {
                        vm.maxAmountSettingAction = 'Edit';
                    } else {
                        vm.maxAmountSettingAction = 'Create';
                    }

                    var validityPeriod = $filter('filter')(vm.merchant.StoreCardSettings, function (setting) { return setting.Name === "Validity Period"; })[0];
                    vm.ValidityPeriod = validityPeriod != undefined ? validityPeriod.Value : '';
                    if (vm.ValidityPeriod != '') {
                        vm.validityPeriodSettingAction = 'Edit';
                    } else {
                        vm.validityPeriodSettingAction = 'Create';
                    }

                    var termAndConditions = $filter('filter')(vm.merchant.StoreCardSettings, function (setting) { return setting.Name === "Terms and Conditions"; })[0];
                    vm.TermAndConditions = termAndConditions != undefined ? termAndConditions.Value : '';
                    if (vm.TermAndConditions != '') {
                        vm.termAndConditionsSettingAction = 'Edit';
                    } else {
                        vm.termAndConditionsSettingAction = 'Create';
                    }
                }

                vm.merchantId = vm.merchant.Id;
               // vm.getWalletInfo(vm.merchant.Id);
            });
        }

        // Upload logo
        vm.loading = { UploadMerchantLogo: false }
        // End upload logo
        vm.viewConfig = { ShowMerchantDialog: false };

        vm.getPrefundHistory = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            MerchantService.GetPrefundHistories(criteria).then(function (res) {
                vm.prefundHistories = res.Items;
                vm.totalItems = res.Total;
            })
        }

        vm.search = function () {
            vm.getPrefundHistory();
        };
        vm.showAlert = function (message) {
            //reset
            vm.showMessage = false;
            vm.doFade = false;

            vm.showMessage = true;

            vm.errorMessage = message;

            $timeout(function () {
                vm.doFade = true;
            }, 2500);
        };
        
        vm.getCSV = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            MerchantService.ExportCSVPrefundHistory(criteria).then(function (res) {
                var anchor = angular.element('<a/>');
                anchor.attr({
                    href: 'data:attachment/csv;charset=utf-8,' + encodeURI(res),
                    target: '_blank',
                    download: 'get-prefund-history.csv'
                })[0].click();
            })
        };

        vm.updatePrefundInfo = function () {

            if (!$scope.prefundForm.$valid) {
                angular.forEach($scope.prefundForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    });
                });

                return;
            }

            if (accountType == 2) {
                MerchantService.UpdateMe(vm.merchant).then(function () {
                    vm.getPrefundHistory();
                });
                vm.showAlert();
            }
            if (accountType == 1) {
                MerchantService.Update(vm.merchant).then(function () {
                    vm.getPrefundHistory();
                });
                vm.showAlert();
            }
        };

      
        vm.openDialog = function (action) {
            if (!$scope.prefundForm.$valid) {
                angular.forEach($scope.prefundForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });

                return;
            }

            MerchantService.Get($stateParams.merchantId).then(function (data) {
                vm.tempMerchant = data;
                if (vm.tempMerchant.PercentAlertAmount != 0 && vm.tempMerchant.AlertPrefundEmail != null) {
                    vm.viewConfig.Action = action;
                    vm.viewConfig.ShowDialog = true;
                    // Clear add prefund model
                    vm.PrefundAmount = '';
                    vm.PrefundDescription = '';
                    $scope.addPrefundForm.$setUntouched();
                }
                else {
                    $translate('merchant.prefund.update_alert_info').then(function (msg) {
                        alert(msg);
                    })
                }
            });
        }

        vm.cancel = function () {
            vm.viewConfig.ShowDialog = false;
            vm.Action = null;
            // Clear add prefund model
            vm.PrefundAmount = '';
            vm.PrefundDescription = '';
            $scope.addPrefundForm.$setUntouched();
        };

        vm.criteria = {
            MerchantId: $stateParams.merchantId,
            Page: 1,
            Length: 10,
            TransactionStartDate: null,
            TransactionEndDate: null
        }

        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 5;
        vm.itemsPerPage = 10;

        vm.getPrefundHistory();

        vm.updatePrefund = function () {
            if (!$scope.addPrefundForm.$valid) {
                angular.forEach($scope.addPrefundForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    });
                });

                return;
            }

            var prefundModel = {
                MerchantId: $stateParams.merchantId,
                PrefundAmount: vm.PrefundAmount,
                Description: vm.PrefundDescription
            };

            MerchantService.UpdatePrefundAmount(prefundModel).then(function (res) {
                vm.viewConfig.ShowDialog = false;
                vm.Action = null;

                MerchantService.Get($stateParams.merchantId).then(function (data) {
                    vm.merchant = data;
                });

                vm.getPrefundHistory();
            });
        };
    }
})  ();
(function () {
    'use strict';

    angular
        .module('app.merchant')
        .controller('MerchantInfoController', MerchantInfoController);

    /** @ngInject */
    function MerchantInfoController(SVCS, $translate, MerchantService, SharedStoreCardService, PartnerCategoryService, $scope, $rootScope, $filter, $stateParams, $cookies, $timeout, $window, $numUtils, AdminUserService, $state) {
        var vm = this;
        $("div").removeClass("modal-backdrop");
        vm.alertTitle = "Success!";
        vm.showMessage = false;
        vm.isSuccess = true;
        vm.doFade = false;
        vm.userWalletModel = {};
        vm.tierSettings = [];
        vm.criteria = {
            MerchantId: $stateParams.merchantId,
            Page: 1,
            Length: 10,
            TransactionStartDate: null,
            TransactionEndDate: null
        }

        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 5;
        vm.itemsPerPage = 10;

        vm.getListTierSetting = function () {
            MerchantService.GetTierSettings().then(function (data) {
                vm.tierSettings = data;
            })
        }

        vm.getListTierSetting();

        vm.getSharedStoreCardSetting = function (brandId) {
            SharedStoreCardService.GetByBrandId(brandId).then(function (data) {
                vm.sharedStoreCardSetting = data;
                if (vm.merchant.Id > 0) {
                    vm.sharedStoreCardSetting = $.grep(vm.sharedStoreCardSetting, function (b) {
                        return b.MerchantId != vm.merchant.Id;
                    });
                }
            })
        }

        vm.getPartnerCategories = function () {
            PartnerCategoryService.All().then(function (data) {
                vm.partnerCategories = data;
                angular.forEach(vm.partnerCategories, function (partercategory) {
                    if (vm.merchant.IsPartnerMerchant) {
                        if (partercategory.Id == vm.merchant.PartnerCategoryId) {
                            vm.partnerCategoryName = partercategory.Name;
                        }
                    }
                })
            })
        }

        vm.requiredWebcashId = true;

        vm.getPartnerType = function (partnerCategoryId) {
            angular.forEach(vm.partnerCategories, function (val) {
                if (val.Id == partnerCategoryId) {
                    if (val.PartnerType == "NoSettlement") {
                        vm.requiredWebcashId = false;
                    }
                    else {
                        vm.requiredWebcashId = true;
                    }
                }
            })
        }

        vm.requiredServiceDate = false;
        vm.checkRevenueShare = function () {
            angular.forEach(vm.tierSettings, function (val) {
                if (val.Id == vm.merchant.MerchantTierId) {
                    if (val.RevenueShare) {
                        vm.requiredServiceDate = true;
                    }
                    else {
                        vm.requiredServiceDate = false;
                    }
                }
            })
        }

        vm.merchantStates = [
            { Id: "Active", Name: "merchant.states.active" },
            { Id: "OnHold", Name: "merchant.states.on_hold" },
            { Id: "Denied", Name: "merchant.states.denied" },
            { Id: "Terminated", Name: "merchant.states.terminated" }
        ];

        //#region Get subscribed services list
        vm.subscribedServices = [
            { Id: "OrderAtTable", Name: "merchant.subscribed_services_type.order_at_table" },
            { Id: "PayAtTable", Name: "merchant.subscribed_services_type.pay_at_table" },
            { Id: "SalesOfVoucher", Name: "merchant.subscribed_services_type.sales_of_voucher" },
            { Id: "SalesOfStoreCard", Name: "merchant.subscribed_services_type.sales_of_store_card" },
            { Id: "TopUpOfStoreCard", Name: "merchant.subscribed_services_type.top_up_of_store_card" },
            { Id: "MarketingCampaign", Name: "merchant.subscribed_services_type.marketing_campaign" },
            { Id: "AcceptAlipay", Name: "merchant.subscribed_services_type.accept_alipay" },
            { Id: "StaticQR", Name: "merchant.subscribed_services_type.static_qr" },
            { Id: "PayAndGo", Name: "merchant.subscribed_services_type.PayAndGo" },
            { Id: "StorecardPaymentAPI", Name: "merchant.subscribed_services_type.StorecardPaymentAPI" },
            { Id: "DeeplinkPayment", Name: "merchant.subscribed_services_type.DeeplinkPayment" },
            { Id: "LaundryPayment", Name: "merchant.subscribed_services_type.LaundryPayment" }
        ];
        //#endregion

        var accountType = $cookies.get('account_type');
        $rootScope.accountType = accountType;

        if (accountType == 2) {
            MerchantService.GetProfile().then(function (data) {
                vm.merchant = data;
                vm.getPartnerCategories();
                $rootScope.storeCardSetting = vm.merchant.StoreCardEnabled;
                if (vm.merchant.ServiceDate) {
                    vm.merchant.ServiceDate = new Date(vm.merchant.ServiceDate);
                }
                if (vm.merchant.ContractDate) {
                    vm.merchant.ContractDate = new Date(vm.merchant.ContractDate);
                }
                //if (vm.merchant.StoreCardSettings.length != 0) {
                //    var maxAmount = $filter('filter')(vm.merchant.StoreCardSettings, function (setting) { return setting.Name === "Max Amount"; })[0];
                //    vm.MaxAmount = maxAmount != undefined ? maxAmount.Value : '';
                //    if (vm.MaxAmount != '') {
                //        vm.maxAmountSettingAction = 'Edit';
                //    } else {
                //        vm.maxAmountSettingAction = 'Create';
                //    }

                //    var validityPeriod = $filter('filter')(vm.merchant.StoreCardSettings, function (setting) { return setting.Name === "Validity Period"; })[0];
                //    vm.ValidityPeriod = validityPeriod != undefined ? validityPeriod.Value : '';
                //    if (vm.ValidityPeriod != '') {
                //        vm.validityPeriodSettingAction = 'Edit';
                //    } else {
                //        vm.validityPeriodSettingAction = 'Create';
                //    }

                //    var termAndConditions = $filter('filter')(vm.merchant.StoreCardSettings, function (setting) { return setting.Name === "Terms and Conditions"; })[0];
                //    vm.TermAndConditions = termAndConditions != undefined ? termAndConditions.Value : '';
                //    if (vm.TermAndConditions != '') {
                //        vm.termAndConditionsSettingAction = 'Edit';
                //    } else {
                //        vm.termAndConditionsSettingAction = 'Create';
                //    }
                //}

                vm.merchantId = vm.merchant.Id;
                //vm.getWalletInfo(vm.merchant.Id);
            });
        }

        if (accountType == 1) {
            MerchantService.Get($stateParams.merchantId).then(function (data) {
                vm.merchant = data;
                vm.getPartnerCategories();

                if (vm.merchant.PartnerCategoryId) {
                    vm.getPartnerType(vm.merchant.PartnerCategoryId);
                }

                $rootScope.storeCardSetting = vm.merchant.StoreCardEnabled;
                if (vm.merchant.ServiceDate) {
                    vm.merchant.ServiceDate = new Date(vm.merchant.ServiceDate);
                }
                if (vm.merchant.ContractDate) {
                    vm.merchant.ContractDate = new Date(vm.merchant.ContractDate);
                }
                if (vm.merchant.StoreCardSettings.length != 0) {
                    var maxAmount = $filter('filter')(vm.merchant.StoreCardSettings, function (setting) { return setting.Name === "Max Amount"; })[0];
                    vm.MaxAmount = maxAmount != undefined ? maxAmount.Value : '';
                    if (vm.MaxAmount != '') {
                        vm.maxAmountSettingAction = 'Edit';
                    } else {
                        vm.maxAmountSettingAction = 'Create';
                    }

                    var validityPeriod = $filter('filter')(vm.merchant.StoreCardSettings, function (setting) { return setting.Name === "Validity Period"; })[0];
                    vm.ValidityPeriod = validityPeriod != undefined ? validityPeriod.Value : '';
                    if (vm.ValidityPeriod != '') {
                        vm.validityPeriodSettingAction = 'Edit';
                    } else {
                        vm.validityPeriodSettingAction = 'Create';
                    }

                    var termAndConditions = $filter('filter')(vm.merchant.StoreCardSettings, function (setting) { return setting.Name === "Terms and Conditions"; })[0];
                    vm.TermAndConditions = termAndConditions != undefined ? termAndConditions.Value : '';
                    if (vm.TermAndConditions != '') {
                        vm.termAndConditionsSettingAction = 'Edit';
                    } else {
                        vm.termAndConditionsSettingAction = 'Create';
                    }
                }

                vm.merchantId = vm.merchant.Id;
                //vm.getWalletInfo(vm.merchant.Id);
            });
        }

        vm.changeIsPartnerMerchant = function () {
            if (vm.merchant.IsPartnerMerchant) {
                vm.getPartnerType(vm.merchant.PartnerCategoryId);
            } else {
                vm.requiredWebcashId = true;
            }
        }

        vm.save = function () {
            if (!vm.merchant.UseSharedStoreCard) {
                vm.merchant.SharedStoreCardSettingId = 0;
            }

            if (!vm.merchant.IsPartnerMerchant) {
                vm.merchant.PartnerCategoryId = null;
            }

            if (!$scope.merchantForm.$valid) {
                angular.forEach($scope.merchantForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#merchantTab').tab('show');
                $timeout(function () {
                    $('#merchantForm .ng-invalid')[0].focus();
                }, 200);
                return;
            }

            if (!$scope.storeCardTopupOptionsForm.$valid) {
                angular.forEach($scope.storeCardTopupOptionsForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#storeCardTopupOptionsTab').tab('show');
                $timeout(function () {
                    $('#storeCardTopupOptionsForm .ng-invalid')[0].focus();
                }, 200);
                return;
            }

            $timeout(function () {

                if (accountType == 2) {
                    MerchantService.UpdateMe(vm.merchant);
                    $rootScope.storeCardSetting = vm.merchant.StoreCardEnabled;
                }
                if (accountType == 1) {
                    MerchantService.Update(vm.merchant);
                    $rootScope.storeCardSetting = vm.merchant.StoreCardEnabled;
                }

                $rootScope.authenticationService.account = vm.merchant;
                $rootScope.authenticationService.account.FullName = vm.merchant.Company.Name;
                vm.viewConfig.ShowMerchantDialog = false;
                if (vm.merchant.MerchantTierId !== undefined && vm.merchant.MerchantTierId !== 0) {
                    var model = {
                        MerchantId: vm.merchant.Id,
                        MerchantTierId: vm.merchant.MerchantTierId
                    }
                    MerchantService.AssignTierSettingToMerchant(model);
                }

                MerchantService.IsMerchantHasProductNoPrice(vm.merchant.Id).then(function (res) {
                    if (res) {
                        vm.error = "There are some products have no price, please update them";
                    }
                    else {
                        vm.error = null;
                    }
                });
            }, 500);
        }

        //#region Upload logo
        vm.loading = { UploadMerchantLogo: false }
        vm.onMerchantLogoSelected = function (files, controlGetter) {
            uploadImgControl = controlGetter();
            if (files != null && files.length) {
                vm.loading.UploadMerchantLogo = true;
                MerchantService.UploadMerchantLogo(files[0]).then(function (path) {
                    vm.loading.UploadMerchantLogo = false;
                    vm.disabledDeleteLogo = false;
                    if (path) {
                        vm.merchant.Logo = path.Result;
                        //$scope.merchantForm.Logo.$setTouched();

                    }
                }, function (error) {
                    vm.loading.UploadMerchantLogo = false;
                })
            }
        }

        vm.deleteLogo = function () {
            if (vm.merchant.Logo) {
                MerchantService.DeleteLogo(vm.merchant.Logo)
                    .then(function () {
                        vm.merchant.Logo = null;
                        vm.disabledDeleteLogo = true;
                    }, function (error) {
                    });
            }
            else {
                return;
            }
        }
        //#endregion
        
        //#region StoreCard
        vm.viewConfig = { ShowMerchantDialog: false };

        vm.edit = function () {

            vm.getSharedStoreCardSetting(vm.merchant.BrandId);

            if (vm.merchant.SharedStoreCardSettingId == 0) {
                vm.merchant.SharedStoreCardSettingId = null
            }

            vm.viewConfig.ShowMerchantDialog = true;
            angular.forEach(vm.tierSettings, function (val) {
                if (val.Id == vm.merchant.MerchantTierId) {
                    if (val.RevenueShare) {
                        vm.requiredServiceDate = true;
                    }
                    else {
                        vm.requiredServiceDate = false;
                    }
                }
            })

        }
        
        // vm.isMaxAmountEditing = false;
        // vm.isValidityPeriorEditing = false;
        // vm.isTermsAndConditionsEditing = false;

        // vm.editMaxAmountSetting = function () {
        //     vm.isMaxAmountEditing = true;
        // }

        // vm.editValidityPeriodSetting = function () {
        //     vm.isValidityPeriorEditing = true;
        // }

        // vm.editTermsAndConditionsSetting = function () {
        //     vm.isTermsAndConditionsEditing = true;
        // }

        // vm.updateStoreCardSetting = function () {

        //     if (!$scope.storeCardForm.$valid) {
        //         angular.forEach($scope.storeCardForm.$error, function (field) {
        //             angular.forEach(field, function (errorField) {
        //                 errorField.$setTouched();
        //             })
        //         });

        //         return;
        //     }

        //     if (vm.isMaxAmountEditing) {

        //         vm.settingModel = { MerchantId: vm.merchantId };
        //         vm.settingModel.Name = "Max Amount";
        //         vm.settingModel.Value = vm.MaxAmount;
        //         if (vm.maxAmountSettingAction == 'Edit') {
        //             MerchantService.UpdateStoreCardSetting(vm.settingModel).then(function (data) {
        //                 vm.newSetting = data;
        //             }, function (error) {
        //             });
        //         } else if (vm.maxAmountSettingAction == 'Create') {
        //             MerchantService.CreateStoreCardSetting(vm.settingModel).then(function (data) {
        //                 vm.newSetting = data;
        //                 vm.maxAmountSettingAction == 'Edit'
        //             }, function (error) {
        //             });
        //         }

        //         vm.isMaxAmountEditing = false;
        //     }

        //     if (vm.isValidityPeriorEditing) {

        //         vm.settingModel = { MerchantId: vm.merchantId };
        //         vm.settingModel.Name = "Validity Period";
        //         vm.settingModel.Value = vm.ValidityPeriod;

        //         if (vm.validityPeriodSettingAction == 'Edit') {
        //             MerchantService.UpdateStoreCardSetting(vm.settingModel).then(function (data) {
        //                 vm.newSetting = data;
        //             }, function (error) {
        //             });
        //         } else if (vm.validityPeriodSettingAction == 'Create') {
        //             MerchantService.CreateStoreCardSetting(vm.settingModel).then(function (data) {
        //                 vm.newSetting = data;
        //                 vm.validityPeriodSettingAction == 'Edit';
        //             }, function (error) {
        //             });
        //         }
        //         vm.isValidityPeriorEditing = false;
        //     }

        //     if (vm.isTermsAndConditionsEditing) {

        //         vm.settingModel = { MerchantId: vm.merchantId };
        //         vm.settingModel.Name = "Terms and Conditions";
        //         vm.settingModel.Value = vm.TermAndConditions;

        //         if (vm.termAndConditionsSettingAction == 'Edit') {
        //             MerchantService.UpdateStoreCardSetting(vm.settingModel).then(function (data) {
        //                 vm.newSetting = data;
        //             }, function (error) {
        //             });
        //         } else if (vm.termAndConditionsSettingAction == 'Create') {
        //             MerchantService.CreateStoreCardSetting(vm.settingModel).then(function (data) {
        //                 vm.newSetting = data;
        //                 vm.termAndConditionsSettingAction = 'Edit';
        //             }, function (error) {
        //             });
        //         }
        //         vm.isTermsAndConditionsEditing = false;
        //     }
        // }

        //#endregion


        // vm.isNoUserData = true;

        // vm.getWalletInfo = function (merchantId) {
        //     MerchantService.GetWalletInfo(merchantId).then(function (data) {
        //         vm.userWalletInfos = data;

        //         if (vm.userWalletInfos.length == 0) {
        //             vm.isNoUserData = true;
        //         } else {

        //             var totalBalance = 0;

        //             var tempInfo = [];
        //             // Rounding 2 decimal
        //             angular.forEach(vm.userWalletInfos, function (info) {
        //                 var temp = angular.copy(info);
        //                 temp.Amount = $numUtils.toFixed(temp.CurrentBalance);

        //                 totalBalance = totalBalance + temp.Amount;

        //                 tempInfo.push(temp);
        //             }, tempInfo);

        //             vm.userWalletInfos = tempInfo;

        //             vm.totalBalance = $numUtils.toFixed(totalBalance);
        //             vm.isNoUserData = false;
        //         }
        //     }, function (error) {
        //     });
        // }

        vm.openServiceDatePopup = function () {
            vm.serviceDatePopup.opened = true;
        };
        vm.openContractDatePopup = function () {
            vm.contractDatePopup.opened = true;
        };

        vm.serviceDatePopup = {
            opened: false
        };
        vm.contractDatePopup = {
            opened: false
        };

        //vm.height = $window.outerHeight - 363;
        $('#merchantForm').height(vm.height);
        $('#storeCardTopupOptionsForm').height(vm.height);

        vm.addStoreCardTopupOption = function () {
            vm.merchant.StoreCardTopupOptions.push({
                Name: null,
                Amount: null,
                Bonus: null
            });
        }

        vm.removeStoreCardTopupOption = function (index) {
            vm.merchant.StoreCardTopupOptions.splice(index, 1);
        }
        
        vm.createHashKey = function () {
            vm.merchant.HashKey = Math.random().toString(36).substring(2);
        };

        // vm.showAlert = function (message) {
        //     //reset
        //     vm.showMessage = false;
        //     vm.doFade = false;

        //     vm.showMessage = true;

        //     vm.errorMessage = message;

        //     $timeout(function () {
        //         vm.doFade = true;
        //     }, 2500);
        // };

        // vm.getPrefundHistory = function () {
        //     var criteria = angular.copy(vm.criteria);
        //     criteria.Page = vm.currentPage;
        //     MerchantService.GetPrefundHistories(criteria).then(function (res) {
        //         vm.prefundHistories = res.Items;
        //         vm.totalItems = res.Total;
        //     })
        // }

        // vm.search = function () {
        //     vm.getPrefundHistory();
        // };

        // vm.getCSV = function () {
        //     var criteria = angular.copy(vm.criteria);
        //     criteria.Page = vm.currentPage;
        //     MerchantService.ExportCSVPrefundHistory(criteria).then(function (res) {
        //         debugger;
        //         var anchor = angular.element('<a/>');
        //         anchor.attr({
        //             href: 'data:attachment/csv;charset=utf-8,' + encodeURI(res),
        //             target: '_blank',
        //             download: 'get-prefund-history.csv'
        //         })[0].click();
        //     })
        // };

        // vm.updatePrefundInfo = function () {

        //     if (!$scope.prefundForm.$valid) {
        //         angular.forEach($scope.prefundForm.$error, function (field) {
        //             angular.forEach(field, function (errorField) {
        //                 errorField.$setTouched();
        //             });
        //         });

        //         return;
        //     }

        //     if (accountType == 2) {
        //         MerchantService.UpdateMe(vm.merchant).then(function () {
        //             vm.getPrefundHistory();
        //         });
        //         vm.showAlert();
        //     }
        //     if (accountType == 1) {
        //         MerchantService.Update(vm.merchant).then(function () {
        //             vm.getPrefundHistory();
        //         });
        //         vm.showAlert();
        //     }
        // };


        // vm.openDialog = function (action) {
        //     if (!$scope.prefundForm.$valid) {
        //         angular.forEach($scope.prefundForm.$error, function (field) {
        //             angular.forEach(field, function (errorField) {
        //                 errorField.$setTouched();
        //             })
        //         });

        //         return;
        //     }

        //     MerchantService.Get($stateParams.merchantId).then(function (data) {
        //         vm.tempMerchant = data;
        //         if (vm.tempMerchant.PercentAlertAmount != 0 && vm.tempMerchant.AlertPrefundEmail != null) {
        //             vm.viewConfig.Action = action;
        //             vm.viewConfig.ShowDialog = true;
        //             // Clear add prefund model
        //             vm.PrefundAmount = '';
        //             vm.PrefundDescription = '';
        //             $scope.addPrefundForm.$setUntouched();
        //         }
        //         else {
        //             $translate('merchant.prefund.update_alert_info').then(function (msg) {
        //                 alert(msg);
        //             })
        //         }
        //     });
        // }

        // vm.cancel = function () {
        //     vm.viewConfig.ShowDialog = false;
        //     vm.Action = null;
        //     // Clear add prefund model
        //     vm.PrefundAmount = '';
        //     vm.PrefundDescription = '';
        //     $scope.addPrefundForm.$setUntouched();
        // };


        // vm.getPrefundHistory();

        // vm.updatePrefund = function () {
        //     if (!$scope.addPrefundForm.$valid) {
        //         angular.forEach($scope.addPrefundForm.$error, function (field) {
        //             angular.forEach(field, function (errorField) {
        //                 errorField.$setTouched();
        //             });
        //         });

        //         return;
        //     }

        //     var prefundModel = {
        //         MerchantId: $stateParams.merchantId,
        //         PrefundAmount: vm.PrefundAmount,
        //         Description: vm.PrefundDescription
        //     };

        //     MerchantService.UpdatePrefundAmount(prefundModel).then(function (res) {
        //         vm.viewConfig.ShowDialog = false;
        //         vm.Action = null;

        //         MerchantService.Get($stateParams.merchantId).then(function (data) {
        //             vm.merchant = data;
        //         });

        //         vm.getPrefundHistory();
        //     });
        // };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.merchant')
        .factory('MasterMerchantService', MasterMerchantService);

    /** @ngInject */
    function MasterMerchantService(SVCS, $http, $q, CoreService) {
        var merchantServer = SVCS.Merchant;

        var service = {
            Get: Get,
            Search: Search,
            Create: Create,
            Update: Update,
            Delete: Delete
        };

        return service;
        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/master-merchant/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/master-merchant/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(merchant) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/master-merchant', merchant).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(merchant) {
            var deferer = $q.defer();

            CoreService.Put(merchantServer + '/api/master-merchant', merchant).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Delete(id) {
            var deferer = $q.defer();

            CoreService.Delete(merchantServer + '/api/master-merchant/' + id).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.merchant')
        .controller('MasterMerchantController', MasterMerchantController);

    /** @ngInject */
    function MasterMerchantController(SVCS, CoreService, MasterMerchantService, $scope, $timeout, $window) {
        var vm = this;
        var controllerName = "MasterMerchant";

        vm.init = function () {
            var data = CoreService.getInfoSearch();
            //console.log(data);
            if(CoreService.checkSearchOfController(controllerName)==false){
                CoreService.removeInfoSearch();
                vm.Pageload("",1);
            }
            if ((data.KeyWord || data.CurrentPage) && CoreService.checkSearchOfController(controllerName)==true) {
                vm.Pageload(data.KeyWord, data.CurrentPage);
            } else {
                vm.Pageload("", 1);
            }
        }
         
        vm.Pageload = function (KeyWord, CurrentPage) {
            vm.criteria = { Keyword: KeyWord, Page: CurrentPage || 1, Length: 5 }
            vm.totalItems = 0;
            vm.currentPage = CurrentPage;
            vm.maxSize = 5;
            vm.itemsPerPage = vm.criteria.Length;
            vm.viewConfig = { ShowMerchantDialog: false, MerchantAction: null };
            vm.merchant = {};
            vm.search();
        }

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            MasterMerchantService.Search(criteria).then(function (res) {
                vm.merchants = res.Items;
                vm.totalItems = res.Total;
                // check correct controller 
                if (CoreService.checkSearchOfController(controllerName)==true || 
                CoreService.getInfoSearch().Controller==""){
                    CoreService.saveInfoSearch(criteria.Keyword, criteria.Page, controllerName);
                }
            })
        }

        vm.reset = function () {
            vm.criteria = { Keyword: "", Page: 1, Length: 5 };
            CoreService.removeInfoSearch();
            vm.Pageload("",1);
        }

        vm.add = function () {
            vm.viewConfig.ShowMerchantDialog = true;
            vm.viewConfig.MerchantAction = 'new';
        }

        vm.edit = function (merchantId) {
            MasterMerchantService.Get(merchantId).then(function (res) {
                vm.merchant = res;
                vm.viewConfig.ShowMerchantDialog = true;
                vm.viewConfig.MerchantAction = 'edit';
            })
        }

        vm.remove = function (merchantId) {
            var conf = window.confirm("Do you want to delete this item?");
            if (!conf) return;
            MasterMerchantService.Delete(merchantId).then(function () { vm.search() });
        }

        vm.save = function () {

            if (!$scope.merchantForm.$valid) {
                angular.forEach($scope.merchantForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#merchantForm .ng-invalid')[0].focus();
                return;
            }

            if (vm.viewConfig.MerchantAction == 'new') {
                MasterMerchantService.Create(vm.merchant).then(function (res) {
                    vm.cancel();
                    vm.search();
                })
            }
            else {
                MasterMerchantService.Update(vm.merchant).then(function (res) {
                    vm.cancel();
                    vm.search();
                })
            }
        }

        vm.cancel = function () {
            vm.viewConfig.ShowMerchantDialog = false;
            vm.merchant = undefined;
            vm.viewConfig.MerchantAction = null
            $scope.merchantForm.$setPristine();
            $scope.merchantForm.$setUntouched();
        }

        vm.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core',
        [
            'ngAnimate',
            'ngAria',
            'ngCookies',
            'ngMessages',
            'ngResource',
            'ngSanitize',
            'pascalprecht.translate',
            'ui.router',
            'ui.bootstrap',
            'ui.select',
            'summernote',
            'ui.tree',
            'ui.bootstrap.datetimepicker'
        ]);
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('sideNavigation', sideNavigation)
        .directive('landingScrollspy', landingScrollspy)
        .directive('minimalizaSidebar', minimalizaSidebar)
        .directive('commonBsModal', bsModalDirective)
        .directive('uploadControl', uploadControl)
        .directive('ngFormTouchedOnSubmit', ngFormTouchedOnSubmit)
        .directive('theadOrder', theadOrderDirective)
        .directive('thOrder', thOrderDirective);

    /** @ngInject */
    function bsModalDirective() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(function () {
                    return scope.$eval(attrs.bsModalShow);
                }, function (value) {
                    if (value) {
                        $(element).modal('show');
                    } else if (!value) {
                        $(element).modal('hide');
                    }
                });

                $(element).on('show.bs.modal', function () {
                    if (attrs.bsModalOnShow) {
                        scope.$evalAsync(attrs.bsModalOnShow);
                    }
                });

                $(element).on('shown.bs.modal', function () {
                    var focusTo = element.find('[focus-on-shown]');
                    focusTo.focus();

                    $('body').addClass('modal-open');

                    if (attrs.bsModalOnShown) {
                        scope.$evalAsync(attrs.bsModalOnShown);
                    }
                });

                $(element).on('hide.bs.modal', function () {
                    setTimeout(function () {
                        scope.$apply(function () {
                            try {
                                scope.$eval(attrs.bsModalShow + "=false");
                            }
                            catch (err) { }
                        });
                    }, 0);

                    if (attrs.bsModalOnHide) {
                        scope.$evalAsync(attrs.bsModalOnHide);
                    }
                });

                $(element).on('hidden.bs.modal', function () {

                    $('body').removeClass('modal-open');

                    if (attrs.bsModalOnHidden) {
                        scope.$evalAsync(attrs.bsModalOnHidden);
                    }
                });
            }
        }
    }

    /**
 * sideNavigation - Directive for run metsiMenu on sidebar navigation
 */
    function sideNavigation($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call the metsiMenu plugin and plug it to sidebar navigation
                $timeout(function () {
                    element.metisMenu();

                });

                // Colapse menu in mobile mode after click on element
                var menuElement = $('#side-menu a:not([href$="\\#"])');
                menuElement.click(function () {
                    if ($(window).width() < 769) {
                        $("body").toggleClass("mini-navbar");
                    }
                });

                // Enable initial fixed sidebar
                if ($("body").hasClass('fixed-sidebar')) {
                    var sidebar = element.parent();
                    sidebar.slimScroll({
                        height: '100%',
                        railOpacity: 0.9,
                    });
                }
            }
        };
    }

    /**
 * landingScrollspy - Directive for scrollspy in landing page
 */
    function landingScrollspy() {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.scrollspy({
                    target: '.navbar-fixed-top',
                    offset: 80
                });
            }
        }
    }

    function minimalizaSidebar($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope, $element) {
                $scope.minimalize = function () {
                    $("body").toggleClass("mini-navbar");
                    if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        $('#side-menu').hide();
                        // For smoothly turn on menu
                        setTimeout(
                            function () {
                                $('#side-menu').fadeIn(400);
                            }, 200);
                    } else if ($('body').hasClass('fixed-sidebar')) {
                        $('#side-menu').hide();
                        setTimeout(
                            function () {
                                $('#side-menu').fadeIn(400);
                            }, 100);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        $('#side-menu').removeAttr('style');
                    }
                }
            }
        };
    };

    function uploadControl() {
        return {
            restrict: 'A',
            controller: [
                '$scope', function ($scope) {
                    this.$setControl = function (control) {
                        $scope.$control = function () {
                            return control;
                        }
                    }
                    this.$setFiles = function (files) {
                        $scope.$files = files;
                    }
                    this.$callback = function (callback) {
                        $scope.$evalAsync(callback);
                    }
                }
            ],
            controllerAs: '$uploader',
            link: function (scope, element, attrs, ctrl) {
                var $uploader = ctrl;

                var input = $(element.find('input')[0]);

                $uploader.$setControl(input);

                var clicked = false;
                element.click(function (event) {
                    if (!clicked) {
                        clicked = true;
                        input.click();
                        clicked = false;
                    }
                });

                input.change(function (event) {

                    $uploader.$setFiles(this.files);

                    if (attrs.onFileSelected) {

                        var _URL = window.URL || window.webkitURL;

                        var file, img;

                        if ((file = this.files[0])) {
                            img = new Image();
                            img.onload = function () {
                                var height = this.height;
                                var width = this.width;
                                if ((height < 230 || width < 400) || ((width / height) < 1.5)) {
                                    alert("Image size must have at least 400x230px or image has invalid ratio.");
                                    return;
                                }

                                $uploader.$callback(attrs.onFileSelected);
                            };

                            img.onerror = function () {
                                alert("Not a valid file: " + file.type);
                            };

                            img.src = _URL.createObjectURL(file);
                        }
                    }
                });
            }
        }
    }

    /** @ngInject */
    function ngFormTouchedOnSubmit($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                if ((element.prop('tagName') !== 'FORM' || !attrs.name) && !attrs.ngForm) {
                    console.error('ng-form-touched-on-submit directive must use on a form has name');
                    return;
                }

                var formName = attrs.ngForm ? attrs.ngForm : attrs.name;

                element.submit(function () {
                    var form = scope[formName];
                    if (form.$invalid) {
                        $timeout(function () {
                            angular.forEach(form.$error, function (field) {
                                angular.forEach(field, function (errorField) {
                                    errorField.$setTouched();
                                })
                            });
                        })
                    }
                })
            }
        }
    }

    /** @ngInject **/
    function theadOrderDirective($parse) {

        function controller() {

            var ctrl = this;

            var callback = null;

            ctrl.current = {
                name: null,
                direction: null
            }

            ctrl.cancelOpts = {
                name: null,
                direction: null
            }

            ctrl.setCallback = function (fn) {
                callback = fn;
            }

            ctrl.sort = function (name, direction) {
                ctrl.cancelOpts.name = ctrl.current.name;
                ctrl.cancelOpts.direction = ctrl.current.direction;
                ctrl.current.name = name;
                ctrl.current.direction = direction;
                callback(name, direction);
            }

            ctrl.cancel = function () {
                ctrl.current.name = ctrl.cancelOpts.name
                ctrl.current.direction = ctrl.cancelOpts.direction;
                ctrl.cancelOpts.name = null;
                ctrl.cancelOpts.direction = null;
            }
        }

        return {
            restrict: 'A',
            controller: controller,
            controllerAs: '$theadOrder',
            link: function (scope, element, attrs, ctrl) {
                ctrl.setCallback(function (name, direction) {
                    $parse(attrs.theadOrder)(scope, {
                        $sortOpts: {
                            name: name,
                            direction: direction,
                            cancel: function () {
                                ctrl.cancel();
                            }
                        }
                    })
                });
            }
        }
    }

    /** @ngInject **/
    function thOrderDirective($parse, $compile) {
        return {
            restrict: 'A',
            require: '^theadOrder',
            scope: true,
            link: function (scope, element, attrs, $theadOrderCtrl) {

                scope.$$isSortMe = isSortMe;
                scope.$$isSortMeAscending = isSortMeAscending;
                scope.$$isSortMeDescending = isSortMeDescending;

                element.click(function () {
                    var direction = 'OrderBy';
                    var name = $parse(attrs.thOrder)(scope);
                    if (isSortMeAscending()) {
                        direction = 'OrderByDescending';
                    }
                    scope.$apply(function () {
                        $theadOrderCtrl.sort(name, direction);
                    })
                })

                var sortIcons = '<span ng-class="{ascending: $$isSortMeAscending(), descending: $$isSortMeDescending()}" class="sort-icons-wrapper"><span class="sort-icon ascending"><i class="fa fa-sort-asc"></i></span><span class="sort-icon descending"><i class="fa fa-sort-desc"></i></span></span>';

                var sortIconsCompiled = $compile(sortIcons)(scope);

                element.append(sortIconsCompiled);

                function isSortMe() {
                    var name = $parse(attrs.thOrder)(scope);
                    return angular.equals(name, $theadOrderCtrl.current.name);
                }

                function isSortMeAscending() {
                    return isSortMe() && $theadOrderCtrl.current.direction == 'OrderBy';
                }

                function isSortMeDescending() {
                    return isSortMe() && $theadOrderCtrl.current.direction == 'OrderByDescending';
                }
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.commissionpayout', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.commissionpayout', {
                url: '/commissionpayout',
                abstract: true
            })
            .state('app.commissionpayout.configuration', {
                url: '/configuration',
                views: {
                    'main@app': {
                        templateUrl: 'app/commissionpayout/configuration/configuration.html',
                        controller: 'configurationController',
                        controllerAs: 'vm'
                    }
                },
                protect: true
            })
            .state('app.commissionpayout.bulkupload', {
                url: '/bulkupload/:id',
                views: {
                    'main@app': {
                        templateUrl: 'app/commissionpayout/bulkupload/bulkupload.html',
                        controller: 'bulkuploadController',
                        controllerAs: 'vm'
                    }
                },
                protect: true
            })
            .state('app.commissionpayout.detail', {
                url: '/detail/:id',
                views: {
                    'main@app': {
                        templateUrl: 'app/commissionpayout/detail/detail.html',
                        controller: 'ViewBatchController',
                        controllerAs: 'vm',
                    }
                },
                protect: true
            })
            .state('app.commissionpayout.transaction', {
                url: '/transaction/:id',
                views: {
                    'main@app': {
                        templateUrl: 'app/commissionpayout/transaction/transaction.html',
                        controller: 'ViewBatchTransactionController',
                        controllerAs: 'vm',
                    }
                },
                protect: true
            })
            .state('app.commissionpayout.report', {
                url: '/report/:id',
                views: {
                    'main@app': {
                        templateUrl: 'app/commissionpayout/report/report.html',
                        controller: 'reportController',
                        controllerAs: 'vm'
                    }
                },
                protect: true
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/commissionpayout');
    }
})();
(function () {
    'use strict';

    angular
        .module('app.commissionpayout')
        .controller('reportController', reportController);

   

    reportController.$inject = ['$scope', 'DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter', '$numUtils', 'commissionService', '$timeout', '$stateParams',
        '$rootScope']

    function reportController($scope, DTOptionsBuilder, DTColumnBuilder, $q, $filter, $numUtils, commissionService, $timeout, $stateParams, $rootScope) {

        var vm = this;

        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;


        vm.errorMsg = '';
        vm.serachModel = {
            transactionType: '',
            commissionCreditStatus: '',
            beginTime: null,
            endTime: null,
            Page: 1,
            Length: 10,
            ActionBy: null,
            MID: null,
            CampaignName: null
        };

        vm.userList = [];
        vm.merchantList = [];
        vm.campaignList = [];
        vm.topupUsers = [];
        vm.topupMerchants = [];

        vm.initLists = function() {
            vm.errorMsg = null;
            
            var promises = [
                commissionService.getUsers()
                    .then(function(response) {
                        vm.userList = response.data;
                    }),
                commissionService.getMerchants()
                    .then(function(response) {
                        vm.merchantList = response.data;
                    }),
                commissionService.getCampaigns()
                    .then(function(response) {
                        vm.campaignList = response.data;
                    })
            ];

            $q.all(promises)
                .catch(function(error) {
                    console.error('Error initializing lists:', error);
                    vm.errorMsg = error.data && error.data.Message ? error.data.Message : 'Failed to load filter data';
                });
        };

        vm.initTopupLists = function() {
            vm.merchantTopupErrorMsg = null;
            
            var promises = [
                commissionService.getTopupUsers()
                    .then(function(response) {
                        vm.topupUsers = response.data;
                    }),
                commissionService.getTopupMerchants()
                    .then(function(response) {
                        vm.topupMerchants = response.data;
                    })
            ];

            $q.all(promises)
                .catch(function(error) {
                    console.error('Error initializing topup lists:', error);
                    vm.merchantTopupErrorMsg = error.data && error.data.Message ? error.data.Message : 'Failed to load filter data';
                });
        };

        vm.initLists();
        vm.initTopupLists();

        vm.merchantTopupErrorMsg=''
        vm.merchantTopupSerachModel = {
            merchantTopupStatus: '',
            beginTime: null,
            endTime: null,
            ActionBy: null,
            MID: null
        };
        vm.listType = [
            { value: 0, name: 'Request' },
            { value: 1, name: 'Payout' },
        ];

        vm.listStatus = [
            { value: 0, name: 'Pending' },
            { value: 1, name: 'Rejected' },
            { value: 2, name: 'Partial Failed' },
            { value: 3, name: 'Successful' },
            { value: 4, name: 'Failed' }
        ];

        vm.batchListData = [];

        vm.reset = function () {
            vm.serachModel = {
                transactionType: '',
                commissionCreditStatus: '',
                beginTime: null,
                endTime: null,
                ActionBy: null,
                MID: null,
                CampaignName: null,
                Page: 1,
                Length: 10,

            };
            vm.searchReport();
        };
        vm.searchReport = function () {
            vm.errorMsg = null;
           
            if (vm.serachModel.beginTime && vm.serachModel.endTime) {
                var beginTime = moment(vm.serachModel.beginTime);
                var endTime = moment(vm.serachModel.endTime);

                var diff = moment(endTime).diff(beginTime, 'minutes');

                if (diff < 0) {
                    vm.errorMsg = "begin time cannot be greater than end time";

                    return;
                }
            }

            var criteria = angular.copy(vm.serachModel);
            criteria.Page = vm.currentPage;

            if ($stateParams.id != 0 && $rootScope.isPagetransRedirect == true) {
                vm.currentPage = $rootScope.transpageNo;
            }
            if ($rootScope.isPagetransRedirect == true) {
                $rootScope.isPagetransRedirect = false;
            }
            //if ($stateParams.id != 0) {
            //    vm.currentPage = $rootScope.transpageNo;
            //}
            $rootScope.transpageNo = vm.currentPage;
            criteria.Page = vm.currentPage;
            commissionService.searchBatchReport(criteria)
                .then(function (response) {
                    vm.batchListData = response.data.Items;
                    vm.totalItems = response.data.Total;
                });
        }
        if ($rootScope.transpageNo == 1) {
            vm.reset();
        }
        if ($stateParams.id != 0) {
            vm.activeTabIndex = 0;
            vm.currentPage = $rootScope.transpageNo;
         //   vm.searchReport();
        } else {
            vm.activeTabIndex = 1;
            vm.currentPage = 1;
            $rootScope.transpageNo = 0;
        }


        vm.downloadCSV = function (batch) {

            console.log(batch);

            var fileName = batch.BatchNo + "_KiplePay_Bulk_Payout_Report.csv";

            commissionService.downloadReportCSV(batch.BatchNo)
                .then(function (responseData) {
                    var strCsv = responseData.data;
                    if (strCsv) {
                        vm.commonDowndCSV(fileName, strCsv);
                    }
                });
        };

        vm.downloadfullList = function () {

            if (vm.serachModel.beginTime && vm.serachModel.endTime) {
                var beginTime = moment(vm.serachModel.beginTime);
                var endTime = moment(vm.serachModel.endTime);

                var diff = moment(endTime).diff(beginTime, 'minutes');

                if (diff < 0) {
                    vm.errorMsg = "begin time cannot be greater than end time";

                    return;
                }
            }

            var criteria = angular.copy(vm.serachModel);
            criteria.Page = 0;

            var fileName = "KiplePay_Bulk_Payout_Report.csv";

            commissionService.downloadBatchReport(criteria)
                .then(function (responseData) {
                    var strCsv = responseData.data;
                    if (strCsv) {
                        vm.commonDowndCSV(fileName, strCsv);
                    }
                });
        };

        vm.commonDowndCSV = function (fileName, csvText) {
            var blob = new Blob([csvText], { type: 'text/csv;charset=utf-8;' });
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, fileName);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", fileName);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        };


        vm.totalMerchantTopupItems = 0;
        vm.currentMerchantTopupPage = 1;
        vm.maxMerchantTopupSize = 10;
        vm.itemsMerchantTopupPerPage = 10;

        vm.merchantTopupData = [];
        vm.merchantTopupDataTotalItems = 0;
        vm.merchantTopupStatus = [
            { value: 0, name: 'Pending' },
            { value: 1, name: 'Successfully' },
            { value: 2, name: 'Failed' }
        ];
        vm.merchantTopupReset = function () { 
            vm.merchantTopupSerachModel = {
                beginTime: null,
                endTime: null,
                merchantTopupStatus: '',
                ActionBy: null,
                MID: null
            };

            vm.searchMerchantTopupReport();
        };

        vm.dtInstance = {};

        vm.merchantTopUpdataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();
                deferer.resolve([]);
                return deferer.promise;

            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 10)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Merchant Wallet Topup Report'
                    },
                    {
                        extend: 'csv',
                        filename: 'Merchant Wallet Topup Report'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('ID'),
                DTColumnBuilder.newColumn('WebCashId'),
                DTColumnBuilder.newColumn('TransactionDate').withClass('center').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('ReferenceNo'),
                DTColumnBuilder.newColumn('TotalAmount'),
                DTColumnBuilder.newColumn('MerchantTopupStatus'),
                DTColumnBuilder.newColumn('CreateBy'),
            ]
        };
        function getReportPromise() {
            var defer = $q.defer();
            var criteria = angular.copy(vm.merchantTopupSerachModel);
            criteria.Page = vm.currentMerchantTopupPage;
            commissionService.searchMerchantTopupBatchReport(criteria)
                .then(function (response) { 
                    defer.resolve(response.data.Items);
                }, function (responseError) {
                    dealErrorDefer(defer);
                });
            return defer.promise;
        }
        function dealErrorDefer(defer) {
            var message = "Failed! Something has gone wrong. Please contact a system administrator.";
            alert(message);
            defer.resolve();
        }
        vm.searchMerchantTopupReport = function () {
            vm.merchantTopupErrorMsg = null;

            if (vm.merchantTopupSerachModel.beginTime && vm.merchantTopupSerachModel.endTime) {
                var beginTime = moment(vm.merchantTopupSerachModel.beginTime);
                var endTime = moment(vm.merchantTopupSerachModel.endTime);

                var diff = moment(endTime).diff(beginTime, 'minutes');

                if (diff < 0) {
                    vm.merchantTopupErrorMsg = "begin time cannot be greater than end time";

                    return;
                }
            } 
            vm.dtInstance.changeData(getReportPromise);
        }

        vm.approvers = [];
        vm.merchantIds = [];
        vm.campaigns = [
            { id: 'ewages', name: 'eWages' }
        ];

        vm.initFilters = function() {
            vm.errorMsg = null;
            
            var promises = [
                commissionService.getUsers()
                    .then(function(response) {
                        vm.approvers = response.data;
                    }),
                commissionService.getMerchants()
                    .then(function(response) {
                        vm.merchantIds = response.data;
                    }),
                commissionService.getCampaigns()
                    .then(function(response) {
                        vm.campaigns = response.data;
                    }),
                commissionService.getTopupUsers()
                    .then(function(response) {
                        vm.approvers = response.data;
                    }),
                commissionService.getTopupMerchants()
                    .then(function(response) {
                        vm.merchantIds = response.data;
                    }),
            ];

            $q.all(promises)
                .catch(function(error) {
                    console.error('Error initializing filters:', error);
                    vm.errorMsg = error.data && error.data.Message ? error.data.Message : 'Failed to load filter data';
                });
        };

        vm.initFilters();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.commissionpayout')
        .controller('ViewBatchController', ViewBatchController);

   

    ViewBatchController.$inject = ['$scope', 'commissionService', '$stateParams','$rootScope'];

    function ViewBatchController($scope, commissionService, $stateParams, $rootScope) {

        var vm = this;
        vm.listStatus = [
            { value: 0, name: 'Pending' },
            { value: 1, name: 'Rejected' },
            { value: 2, name: 'Partial Failed' },
            { value: 3, name: 'Success' },
            { value: 4, name: 'Failed' }
        ];

        vm.batchListData = [];
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 50;
        vm.previousPage = $rootScope.pageNo;
        vm.errorMsg = '';
        vm.serachModel = {
            BatchNo: $stateParams.id,
            commissionCreditStatus: '',
            Page: 1,
            Length: 50
        };

        commissionService.ViewBatch(vm.serachModel).then(function (res) {
            vm.batchListData = res.data.Items;
            vm.totalItems = res.data.Total;
            vm.Id = $stateParams.id;
            $rootScope.isPageRedirect = true;
        });
      
        vm.searchReport = function () {
            vm.errorMsg = null;
            var criteria = angular.copy(vm.serachModel);
            criteria.Page = vm.currentPage;
            $rootScope.isPageRedirect = true;
            commissionService.ViewBatch(criteria).then(function (res) {
                vm.batchListData = res.data.Items;
                vm.totalItems = res.data.Total;
                vm.Id = $stateParams.id;
            });
        }

        vm.downloadCSV = function () {
            var fileName = $stateParams.id + "_KiplePay_Bulk_Payout_Upload.csv";

            commissionService.downloadBatchCSV($stateParams.id)
                .then(function (responseData) {
                    var strCsv = responseData.data;
                    if (strCsv) {
                        vm.commonDowndCSV(fileName, strCsv);
                    }
                });
        };

        vm.commonDowndCSV = function (fileName, csvText) {
            var blob = new Blob([csvText], { type: 'text/csv;charset=utf-8;' });
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, fileName);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", fileName);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.commissionpayout')
        .controller('ViewBatchTransactionController', ViewBatchTransactionController);

   

    ViewBatchTransactionController.$inject = ['$scope', 'commissionService', '$stateParams', '$rootScope'];

    function ViewBatchTransactionController($scope, commissionService, $stateParams, $rootScope) {

        var vm = this;
        vm.listStatus = [
            { value: 0, name: 'Pending' },
            { value: 1, name: 'Rejected' },
            { value: 2, name: 'Partial Failed' },
            { value: 3, name: 'Success' },
            { value: 4, name: 'Failed' }
        ];

        vm.batchListData = [];
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 50;

        vm.previousPage = $rootScope.transpageNo;
        vm.errorMsg = '';
        vm.serachModel = {
            BatchNo: $stateParams.id,
            commissionCreditStatus: '',
            Page: 1,
            Length: 50
        };

        commissionService.ViewReport(vm.serachModel).then(function (res) {
            $rootScope.isPagetransRedirect = true;
            vm.batchListData = res.data.Items;
            vm.totalItems = res.data.Total;
            vm.Id = $stateParams.id;
        });
      
        vm.searchReport = function () {
            vm.errorMsg = null;
            var criteria = angular.copy(vm.serachModel);
            criteria.Page = vm.currentPage;
            $rootScope.isPagetransRedirect = true;
            commissionService.ViewReport(criteria).then(function (res) {
                vm.batchListData = res.data.Items;
                vm.totalItems = res.data.Total;
                vm.Id = $stateParams.id;
            });
        }

        vm.downloadCSV = function () {
            var fileName = $stateParams.id + "_KiplePay_Bulk_Payout_Report.csv";

            commissionService.downloadReportCSV($stateParams.id)
                .then(function (responseData) {
                    var strCsv = responseData.data;
                    if (strCsv) {
                        vm.commonDowndCSV(fileName, strCsv);
                    }
                });
        };

        vm.commonDowndCSV = function (fileName, csvText) {
            var blob = new Blob([csvText], { type: 'text/csv;charset=utf-8;' });
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, fileName);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", fileName);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        };
    }
})();
(function () {
    angular
        .module('app.admin')
        .controller('configurationCreateOrUpdateCtrl', configurationCreateOrUpdateCtrl)

    configurationCreateOrUpdateCtrl.$inject = [
        '$scope',
        "$uibModalInstance",
        "modalData",
        "commissionService"
    ];

    function configurationCreateOrUpdateCtrl($scope, $uibModalInstance, modalData, commissionService) {
        var vm = this;

        vm.merchants = [];
        vm.modalData = modalData;
        vm.formData = vm.modalData.entity || {};

        vm.isCreateFlag = vm.formData.MerchantId == null;

        if (vm.formData.MerchantId > 0) {
            commissionService.searchMerchant({ Keyword: vm.formData.MerchantName }).then(function (res) {
                vm.merchants = res.data.Items;
            });
        }
        
        vm.formError = "";
        vm.modal = {
            ok: function (result) {
                $uibModalInstance.close(result);
            },
            cancel: function () {
                $uibModalInstance.dismiss('cancel');
            }
        };

        vm.onSubmit = function (isValid) {
            if (!isValid) {
                return;
            }
            vm.formError = "";

            if (vm.isCreateFlag) {
                vm.doCreatePrefundAccount(vm.formData);
            } else {
                vm.doUpdatePrefundAccount(vm.formData);
            }
        };

        vm.doCreatePrefundAccount = function (entityData) {
            commissionService.createPrefundAccount(entityData)
                .then(function (response) {
                    vm.modal.ok(response.data);
                })
                .catch(function (errorInfo) {
                    vm.formError = errorInfo.data.Message;
                });
            return false;
        };

        vm.doUpdatePrefundAccount = function (entityData) {
            commissionService.updatePrefundAccount(entityData)
                .then(function (response) {
                    vm.modal.ok(response.data);
                })
                .catch(function (errorInfo) {
                    vm.formError = errorInfo.data.Message;
                });
            return false;
        };


        vm.loadMerchant = function (keyword) {
            if (keyword.length >= 3) {
                commissionService.searchMerchant({ Keyword: keyword }).then(function (res) {
                    console.log(res);
                    vm.merchants = res.data.Items;
                });
            } else {
                vm.merchants = [];
            }
        }
    }
})();
(function () {
    angular
        .module('app.admin')
        .controller('emailCreateOrUpdateCtrl', emailCreateOrUpdateCtrl)

    emailCreateOrUpdateCtrl.$inject = [
        '$scope',
        "$uibModalInstance",
        "modalData",
        "commissionService"
    ];

    function emailCreateOrUpdateCtrl($scope, $uibModalInstance, modalData, commissionService) {
        var vm = this;

        vm.merchants = [];
        vm.modalData = modalData;
        vm.formData = vm.modalData.entity || {};

        vm.isCreateFlag = vm.formData.PrefundEmailId === 0;
        
        vm.formError = "";
        vm.modal = {
            ok: function (result) {
                $uibModalInstance.close(result);
            },
            cancel: function () {
                $uibModalInstance.dismiss('cancel');
            }
        };

        vm.onSubmit = function (isValid) {
            if (!isValid) {
                return;
            }
            vm.formError = "";

            if (vm.isCreateFlag) {
                vm.doCreatePrefundEmail(vm.formData);
            } else {
                vm.doUpdatePrefundEmail(vm.formData);
            }
        };

        vm.doCreatePrefundEmail = function (entityData) {
            commissionService.createPrefundEmail(entityData)
                .then(function (response) {
                    vm.modal.ok(response.data);
                })
                .catch(function (errorInfo) {
                    vm.formError = errorInfo.data.Message;
                });
            return false;
        };

        vm.doUpdatePrefundEmail = function (entityData) {
            commissionService.updatePrefundEmail(entityData)
                .then(function (response) {
                    vm.modal.ok(response.data);
                })
                .catch(function (errorInfo) {
                    vm.formError = errorInfo.data.Message;
                });
            return false;
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.commissionpayout')
        .controller('configurationController', configurationController);

    configurationController.$inject = [
        '$scope',
        '$timeout',
        'AuthenticationService',
        "popupService",
        "commissionService",
    ];

    /** @ngInject */
    function configurationController($scope, $timeout, _authService, popupService, commissionService) {
        var vm = this;

        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.itemsPerPage = 10;

        vm.emailTotalItems = 0;
        vm.emailCurrentPage = 1;
        vm.emailItemsPerPage = 10;

        vm.criteria = { Keyword: null, Page: 1, Length: 10 };
        vm.merchantListData = [];
        vm.emailListData = [];

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.initMerchantList();
            }
        }

        vm.initMerchantList = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            criteria.Length = vm.itemsPerPage;
            commissionService.searchPrefundAccount(criteria)
                .then(function (response) {
                    vm.merchantListData = response.data.Items;
                    vm.totalItems = response.data.Total;
                });
        };

        vm.initEmailList = function () {
            var criteria = { Keyword: null, Page: vm.emailCurrentPage, Length: vm.emailItemsPerPage };
            commissionService.searchPrefundEmail(criteria)
                .then(function (response) {
                    vm.emailListData = response.data.Items;
                    vm.emailTotalItems = response.data.Total;
                });
        };

        vm.showAddPrefund = function () {
            var userType = +localStorage.getItem('user_type');
            if (userType === 1) {
                return true;
            }

            var flag = userType !== 1 && vm.merchantListData.length === 0 ? true : false;
            return flag;
        };

        vm.showAddPrefundForEmail = function () {
            var userName = localStorage.getItem('user_name');
            var email = R.find(R.propEq('CreateBy', userName), vm.emailListData)
            return R.isNil(email);
        };

        vm.disableEmailAction = function (prefundEmail) {
            var isAdmin = _authService.hasPermissions('COMMISSION_PAYOUT_ADMIN');
            if (isAdmin) {
                return true;
            } else {
                var userName = localStorage.getItem('user_name');
                return prefundEmail.CreateBy === userName;
            }
        };

        vm.popupCreateOrUpdateForm = function (entityId) {
            entityId = entityId || "";
            var tmpEntity = _.find(vm.merchantListData, function (cat) {
                return _.isEqual(cat.MerchantId, entityId);
            }) || {};

            var customModalOptions = {
                closeButtonText: 'Cancel',
                okButtonText: 'Sumbit',
                headerText: "Manage Prefund Account",
                bodyText: '',
                isCreateFlag: entityId ? true : false
            };

            var modalDefaults = {
                templateUrl: "app/commissionpayout/configuration/updatecreate.view.html",
                controller: "configurationCreateOrUpdateCtrl",
                controllerAs: "vm",
                resolve: {
                    modalData: function () {
                        return {
                            options: customModalOptions,
                            entity: {
                                MerchantId: tmpEntity.MerchantId || null,
                                MerchantName: tmpEntity.MerchantName || '',
                                EmailAddress: tmpEntity.EmailAddress || ''
                            }
                        };
                    }
                }
            };

            popupService.showModal(modalDefaults, customModalOptions).then(function (result) {
                vm.initMerchantList();
            }).catch(function (errorInfo) {

            });
        };

        vm.popupEmailCreateOrUpdateForm = function (entityId) {
            entityId = entityId || "";
            var tmpEntity = _.find(vm.emailListData, function (cat) {
                return _.isEqual(cat.PrefundEmailId, entityId);
            }) || {};

            var customModalOptions = {
                closeButtonText: 'Cancel',
                okButtonText: 'Sumbit',
                headerText: "Manage User List",
                bodyText: '',
                isCreateFlag: entityId ? true : false
            };

            var modalDefaults = {
                templateUrl: "app/commissionpayout/configuration/email.updatecreate.view.html",
                controller: "emailCreateOrUpdateCtrl",
                controllerAs: "vm",
                resolve: {
                    modalData: function () {
                        return {
                            options: customModalOptions,
                            entity: {
                                PrefundEmailId: tmpEntity.PrefundEmailId || 0,
                                EmailAddress: tmpEntity.EmailAddress || ''
                            }
                        };
                    }
                }
            };

            popupService.showModal(modalDefaults, customModalOptions).then(function (result) {
                vm.initEmailList();
            }).catch(function (errorInfo) {

            });
        };

        vm.popupRemoveEmailForm = function (entityId) {
            var customModalOptions = {
                closeButtonText: 'Cancel',
                okButtonText: 'Confirm',
                headerText: "Delete Prefund Email",
                bodyText: "Are you sure you want to delete this prefund email?"
            };

            popupService.showModal({}, customModalOptions).then(function (result) {
                commissionService.deletePrefundEmail(entityId)
                    .then(function (response) {
                        $timeout(function () {
                            vm.initEmailList();
                        }, 500);
                    })
                    .catch(function (errorInfo) {
                        alert(errorInfo.data.Message);
                    });
            }).catch(function (errorInfo) {
            });
        }

        vm.popupremoveForm = function (entityId) {
            var customModalOptions = {
                closeButtonText: 'Cancel',
                okButtonText: 'Confirm',
                headerText: "Delete Prefund Account",
                bodyText: "Are you sure you want to delete this prefund account?"
            };

            popupService.showModal({}, customModalOptions).then(function (result) {
                commissionService.deletePrefundAccount(entityId)
                    .then(function (response) {
                        $timeout(function () {
                            vm.initMerchantList();
                        }, 500);
                    })
                    .catch(function (errorInfo) {
                    });
            }).catch(function (errorInfo) {

            });
        }
    }
})();
(function () {
    'use strict';
    angular
        .module('app.commissionpayout')
        .directive('validFile', function () {
            return {
                require: 'ngModel',
                link: function (scope, el, attrs, ngModel) {
                    //change event is fired when file is selected
                    el.bind('change', function () {
                        scope.$apply(function () {
                            ngModel.$setViewValue(el.val());
                            ngModel.$render();
                        });
                    });
                }
            }
        });

    angular
        .module('app.commissionpayout')
        .controller('bulkuploadController', bulkuploadController);

    bulkuploadController.$inject = [
        '$scope',
        'SVCS',
        '$timeout',
        'popupService',
        "commissionService",
        "AuthenticationService",
        "$cookies",
        "$q",
        "$stateParams",
        "$rootScope"
    ];
 
    function bulkuploadController($scope, SVCS, $timeout, popupService, commissionService, _authService, $cookies, $q, $stateParams, $rootScope) {
        var vm = this;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;
        vm.criteria = {
            Keyword: null,
            commissionCreditStatus: '',
            beginTime: null,
            endTime: null,
            Page: 1,
            Length: 10,
            ActionBy: null,
            MID: null
        };
        
        vm.userList = [];
        vm.merchantList = [];

        vm.initLists = function() {
            vm.errorMsg = null;
            
            var promises = [
                commissionService.getUsers()
                    .then(function(response) {
                        vm.userList = response.data;
                    }),
                commissionService.getMerchants()
                    .then(function(response) {
                        vm.merchantList = response.data;
                    })
            ];

            $q.all(promises)
                .catch(function(error) {
                    console.error('Error initializing lists:', error);
                    vm.errorMsg = error.data && error.data.Message ? error.data.Message : 'Failed to load filter data';
                });
        };

        vm.initLists();

        vm.listStatus = [
            { value: 0, name: 'Pending' },
            { value: 1, name: 'Rejected' },
            { value: 2, name: 'Partial Failed' },
            { value: 3, name: 'Success' },
            { value: 4, name: 'Failed' }
        ];

        vm.batchListData = [];
        vm.viewConfig = { ShowDialog: false };
        vm.webcahshRequest = {};
        //vm.searchByKeyword = function ($event) {
        //    if ($event.which == 13) {
        //        vm.initBatchList();
        //    }
        //}
        vm.reset = function () {
            vm.criteria = {
                Keyword: null,
                commissionCreditStatus: '',
                beginTime: null,
                endTime: null,
                Page: 1,
                Length: 10,
                ActionBy: null,
                MID: null
            };
            vm.currentPage = 1;
            vm.initBatchList();
        }
       
        vm.initBatchList = function () {
            vm.errorMsg = null;
            
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            if ($stateParams.id != 0 && $rootScope.isPageRedirect==true) {
                vm.currentPage = $rootScope.pageNo;
            }
            if ($rootScope.isPageRedirect == true) {
                $rootScope.isPageRedirect = false;
            }
            $rootScope.pageNo = vm.currentPage;
            criteria.Page = vm.currentPage;
            if (vm.criteria.beginTime && vm.criteria.endTime) {
                var beginTime = moment(vm.criteria.beginTime);
                var endTime = moment(vm.criteria.endTime);

                var diff = moment(endTime).diff(beginTime, 'minutes');

                if (diff < 0) {
                    vm.errorMsg = "begin time cannot be greater than end time";

                    return;
                }
            }
            commissionService.searchBatch(criteria)
                .then(function (response) {
                    vm.batchListData = response.data.Items;
                    vm.totalItems = response.data.Total;
                });
        };
        if ($rootScope.pageNo == 1) {
            vm.reset();
        }
        if ($stateParams.id != 0) {
            vm.activeTabIndex = 1;
            vm.currentPage = $rootScope.pageNo;
        } else {
            vm.activeTabIndex = 0;
            vm.currentPage = 1;
            $rootScope.pageNo = 0;
        }
        vm.merchantBalance = 0;

        vm.getMerchantBalance = function () {
            var accountType = $cookies.get('account_type');
            if (accountType == 2) {
                //  $("#merchantId").prop("disabled", true);
                commissionService.getMerchantBalance()
                    .then(function (response) {
                        $("#MerchantId").attr('disabled', 'disabled');
                        vm.merchantBalance = response.data.Amount;
                        vm.MerchantId = response.data.WebCashId;
                    }).catch(function (responseError) {
                        vm.bulkUploadModel.errorMsg = responseError.data.Message;
                    });
            }
            else if (accountType == 1) {
                var entity = {};
                entity.UserId = vm.MerchantId;
                commissionService.getMerchantInfo(entity)
                    .then(function (response) {
                        $("#MerchantId").removeAttr("disabled", false);
                        vm.merchantBalance = response.data.Amount;
                        vm.MerchantId = response.data.WebCashId;
                    }).catch(function (responseError) {
                        vm.bulkUploadModel.errorMsg = responseError.data.Message;
                    });
            }
            //else if (accountType == 1 && a) {
            //    commissionService.getMerchantInfolnkPrefundAcct()
            //        .then(function (response) {
            //            $("#MerchantId").removeAttr("disabled", false);
            //            vm.merchantBalance = response.data.Amount;
            //            vm.MerchantId = response.data.WebCashId;
            //        }).catch(function (responseError) {
            //            vm.bulkUploadModel.errorMsg = responseError.data.Message;
            //        });
            //}
           
        };
        vm.getMerchantBalance();
        vm.hasMerchantAdmin = function (batch) {
            return _authService.hasPermissions('COMMISSION_PAYOUT_ADMIN') && batch.CommissionCreditStatus === 'Pending';
        };

        vm.popupApproveBatch = function (entityId) {
            var customModalOptions = {
                closeButtonText: 'Cancel',
                okButtonText: 'Confirm',
                headerText: "Approve Batch Credit List",
                bodyText: "Are you sure to approve the list?"
            };

            popupService.showModal({}, customModalOptions).then(function (result) {

                commissionService.approveBatch(entityId)
                    .then(function (response) {
                        $timeout(function () {
                            vm.initBatchList();
                        }, 500);
                    })
                    .catch(function (errorInfo) {
                    });
            }).catch(function (errorInfo) {

            });
        }

        vm.popupRejectBatch = function (entityId) {
            var customModalOptions = {
                closeButtonText: 'Cancel',
                okButtonText: 'Confirm',
                headerText: "Reject Batch Credit List",
                bodyText: "Are you sure to reject the list?"
            };

            popupService.showModal({}, customModalOptions).then(function (result) {

                commissionService.rejectBatch(entityId)
                    .then(function (response) {
                        $timeout(function () {
                            vm.initBatchList();
                        }, 500);
                    })
                    .catch(function (errorInfo) {
                    });
            }).catch(function (errorInfo) {

            });
        }
        vm.popupDeleteBatch = function (entityId) {
            var customModalOptions = {
                closeButtonText: 'Cancel',
                okButtonText: 'Confirm',
                headerText: "Confirm Delete?",
                bodyText: "Are you confirmed to delete this file?"
            };

            popupService.showModal({}, customModalOptions).then(function (result) {

                commissionService.deleteBatch(entityId)
                    .then(function (response) {
                        $timeout(function () {
                            vm.initBatchList();
                        }, 500);
                    })
                    .catch(function (errorInfo) {
                    });
            }).catch(function (errorInfo) {

            });
        }

        vm.creditTmpLink = SVCS.Merchant + '/Merchant/Content/commission-payout-bulk-upload-template.csv';

        vm.bulkUploadModel = {
            csvFilePath: '',
            csvText: '',
            errorMsg: '',
            tipMsg: '',
            showErrorCsvButton: false
        };

        vm.resetForm = function (formModel) {
            formModel.csvFilePath = '';
            formModel.csvText = '';
            formModel.errorMsg = '';
            formModel.tipMsg = '';
            formModel.showErrorCsvButton = false;
            localStorage.setItem('bulkupload_error_csv', '');
        };

        vm.downloadCSV = function (batch) {

            var fileName = batch.BatchNo + "_KiplePay_Bulk_Payout_Upload.csv";

            commissionService.downloadBatchCSV(batch.BatchNo)
                .then(function (responseData) {
                    var strCsv = responseData.data;
                    if (strCsv) {
                        vm.commonDowndCSV(fileName, strCsv);
                    }
                });
        };

        vm.downloadErrorCSV = function () {

            var strCsv = localStorage.getItem('bulkupload_error_csv');

            var exportedFilenmae = (new Date()).toLocaleDateString() + '.error.csv';

            vm.commonDowndCSV(exportedFilenmae, strCsv);
        };

        vm.commonDowndCSV = function (fileName, csvText) {
            var blob = new Blob([csvText], { type: 'text/csv;charset=utf-8;' });
            if (navigator.msSaveBlob) { // IE 10+
                navigator.msSaveBlob(blob, fileName);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) { // feature detection
                    // Browsers that support HTML5 download attribute
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", fileName);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        };

        vm.submitBulkForm = function (isValid) {
            vm.bulkUploadModel.tipMsg = '';
            vm.bulkUploadModel.errorMsg = '';
            if (!isValid) {
                vm.bulkUploadModel.errorMsg = "Please choose a csv file.";
                return;
            }
            console.log(vm.bulkUploadModel);
            var columns = ['WebCashId', 'userName', 'campaignName', 'entitlementDate', 'eWalletCredit', 'additional_note', 'ErrorMessage', 'AppType'];
            var jsonData = vm.csvToJson(columns, vm.bulkUploadModel.csvText);

            commissionService.uploadCommissionCsv(jsonData)
                .then(function (responseData) {
                    var strErrorCsv = responseData.data;
                    if (strErrorCsv) {
                        localStorage.setItem('bulkupload_error_csv', strErrorCsv);
                        vm.bulkUploadModel.errorMsg = 'Wrong with csv file, please download error csv file to change';
                        vm.bulkUploadModel.showErrorCsvButton = true;
                    } else {
                        vm.bulkUploadModel.tipMsg = 'Successful';
                        vm.initBatchList();
                    }
                })
                .catch(function (responseError) {
                    vm.bulkUploadModel.tipMsg = '';
                    if (responseError.status === 500) {
                        vm.bulkUploadModel.errorMsg = 'Failed! Something has gone wrong. Please contact a system administrator.';
                        return;
                    }
                    vm.bulkUploadModel.errorMsg = responseError.data.Message;
                });
        };

        vm.csvToJson = function (columns, csv) {

            var strJosn = R.compose(
                R.map(R.compose(
                    R.zipObj(columns),
                    R.split(',')
                )),
                R.filter(function (x) { return R.length(x) > 1 }),
                R.tail,
                R.split('\n')
            )(csv);

            return strJosn
        };
        vm.openDialog = function () {
            vm.viewConfig.ShowDialog = true;
            vm.clearForm();
            vm.mainService.TopupAmount = 0;
        }
        vm.save = function (form) {
            if (!$scope.MerchantWebcashTopupForm.$valid) {
                angular.forEach($scope.MerchantWebcashTopupForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#MerchantWebcashTopupForm .ng-invalid')[0].focus();
                return;
            }
            commissionService.getMerchantTopupLink(vm.mainService.TopupAmount).then(function (responseData) {
                vm.webcahshRequest = responseData.data;
                var formEle = document.getElementById("RequestWebcashForm");
                formEle.elements["ord_date"].value = vm.webcahshRequest.ord_date;
                formEle.elements["ord_totalamt"].value = vm.webcahshRequest.ord_totalamt;
                formEle.elements["ord_mercID"].value = vm.webcahshRequest.ord_mercID;
                formEle.elements["ord_mercref"].value = vm.webcahshRequest.ord_mercref;
                formEle.elements["ord_returnURL"].value = vm.webcahshRequest.ord_returnURL;
                formEle.elements["merchant_hashvalue"].value = vm.webcahshRequest.merchant_hashvalue;
                formEle.elements["topup_merchant_id"].value = vm.webcahshRequest.topup_merchant_id;
                formEle.action = responseData.data.webcahs_topup_url;
                formEle.submit();
            })
                .catch(function (responseError) {
                    vm.bulkUploadModel.tipMsg = '';
                    if (responseError.statusredirectToWebcash === 500) {
                        vm.bulkUploadModel.errorMsg = 'Failed! Something has gone wrong. Please contact a system administrator.';
                        return;
                    }
                    vm.bulkUploadModel.errorMsg = responseError.data.Message;
                    vm.viewConfig.ShowDialog = false;
                });

        }
        vm.clearForm = function () {
            vm.mainService = {
                TopupAmount: 0
            }
            $scope.MerchantWebcashTopupForm.$setPristine();
            $scope.MerchantWebcashTopupForm.$setUntouched();
        }

        vm.cancel = function () {
            vm.viewConfig.ShowDialog = false;
        } 
        var pathInfo = window.location.search.split('=');
        if (pathInfo.length >= 2) {
           if(pathInfo[1]==="Valid"){
            this.bulkUploadModel.tipMsg = "Merchant Topup Successful."
            vm.bulkUploadModel.errorMsg = ""
           } 
        } else {
            this.bulkUploadModel.tipMsg = ""
            vm.bulkUploadModel.errorMsg = "" 
        }

        vm.approvers = [];
        vm.merchantIds = [];
        
        vm.initFilters = function() {
            vm.errorMsg = null;
            
            var promises = [
                commissionService.getUsers()
                    .then(function(response) {
                        vm.approvers = response.data;
                    }),
                commissionService.getMerchants()
                    .then(function(response) {
                        vm.merchantIds = response.data;
                    })
            ];

            $q.all(promises)
                .catch(function(error) {
                    console.error('Error initializing filters:', error);
                    vm.errorMsg = error.data && error.data.Message ? error.data.Message : 'Failed to load filter data';
                });
        };

        vm.initFilters();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.community', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.community', {
                url: '/community',
                abstract: true
            })
            .state('app.community.configuration', {
                url: '/community',
                views: {
                    'main@app': {
                        templateUrl: 'app/community/configuration/configuration.html',
                        controller: 'CommunityConfigurationController',
                        controllerAs: 'vm'
                    }
                },
                protect: true
            })

        // Translation
        $translatePartialLoaderProvider.addPart('app/community');
    }
})();
(function () {
    'use strict';

    angular
        .module('app.community')
        .controller('CommunityConfigurationController', CommunityConfigurationController);

  

    /** @ngInject */
    function CommunityConfigurationController($scope, $timeout, popupService, CommunityService) {
        var vm = this;
        vm.community = {
            Id: 0,
            Name: "",
            Description: "",
            Photos: [],
            Badges: []
        };
    
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;
      
        vm.criteria = { Keyword: null, Page: 1, Length: 10 };
        vm.viewConfig = { ShowDialog: false, Action: null, UploadLogo: false };

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }
        //search 
        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            CommunityService.Search(criteria).then(function (res) {
                vm.CommunityList = res.Items;
                vm.totalItems = res.Total;
            });
        }

        vm.reset = function () {
            $("#searchtxt").val('');
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.viewConfig = { ShowDialog: false, Action: null, UploadLogo: false };
            vm.currentPage = 1;
            vm.search();
        }

      

        vm.cancel = function (CommunityForm) {
            vm.community = {
                Id: 0,
                Name: "",
                Description: "",
                Photos: [],
                Badges: []
            };
            vm.reset();
        }

        vm.openDialog = function (action, id, CommunityForm) {
          
            vm.viewConfig.Action = action;
            if (action == 'new') {
                vm.community = {
                    Id: 0,
                    Name: "",
                    Description: "",
                    Photos: [],
                    Badges: []
                };
                vm.viewConfig.ShowDialog = true;
            }
            if (action == 'edit' && id != null) {
                CommunityService.Get(id).then(function (res) {
                    vm.community = {
                        Id: res.Id,
                        Name: res.Name,
                        Description: res.Description,
                        Photos: [],
                        Badges: []
                    }
                    vm.community.Photos.push(res.Logo);
                    if (res.Badges != null) {
                        vm.community.Badges.push(res.Badges);
                    }
                    vm.viewConfig.ShowDialog = true;
                });
            }
        }
        //publish /unpublish
        vm.publish = function (id, val) {
            CommunityService.PublishCommunity(id, val).then(function (res) {
                alert(res);
                vm.reset();
            });
        }
        //save
        vm.save = function () {
            if (vm.community.Name == "" || vm.community.Name==null ) {
                alert("Please Enter Name");
            }
            else if (vm.community.Description == "" || vm.community.Description == null) {
                alert("Please Enter Description");
            }
            else if (vm.community.Photos.length == 0) {
                alert("Please Select Image");
            }
            else if (vm.community.Badges.length == 0) {
                alert("Please Select Badges");
            }
            else {
                if (vm.viewConfig.Action == 'new') {
                    var CommunityModel = { Id: 0, Name: vm.community.Name, Description: vm.community.Description, Photos: vm.community.Photos, Badges:vm.community.Badges };
                    CommunityService.Create(CommunityModel).then(function (res) {
                        if (res != null) {
                            vm.cancel();
                            alert("Saved Successfully");
                        }
                    });


                }
                else {
                    var CommunityModel = { Id: vm.community.Id, Name: vm.community.Name, Description: vm.community.Description, Photos: vm.community.Photos, Badges:vm.community.Badges };
                    CommunityService.Update(CommunityModel).then(function (res) {
                        if (res != null) {
                            vm.cancel();
                            alert("Updated Successfully");
                        }
                    });
                }
            }
        }

        //#region Upload photos
        vm.temp1 = {};
        vm.uploadBadges = function (files, invalidFiles) {

            if (invalidFiles.length) {
                $translate('Community.configuration.validate.photo.file_invalid', { name: invalidFiles[0].name }).then(function (msg) {
                    alert(msg);
                })
                return;
            }

            if (!files || !files.length) {
                return;
            }

            sequentialUploadBadge(files, 0, [], sequentialUploadCompleted);


        };

        vm.removeBadge = function (idx) {
            vm.community.Badges.splice(idx, 1);
        }

        function sequentialUploadBadge(files, i, errorsFiles, callback) {
            CommunityService.UploadPhoto(files[i]).then(function (photo) {
                vm.community.Badges.push(photo.Result);
            }, function (error) {
                errorsFiles.push({ file: files[i], error: error });
            }).then(function () {
                if (files.length === i + 1) {
                    callback(errorsFiles);
                } else {
                    sequentialUploadBadge(files, i + 1, errorsFiles, callback);
                }
            });
        }

        function sequentialUploadCompleted(errorsFiles) {
            var filesNames = [];
            if (errorsFiles && errorsFiles.length) {
                angular.forEach(errorsFiles, function (item) {
                    filesNames.push(errorsFiles.file.name);
                })
            }

            if (filesNames.length) {
                $translate('Community.configuration.validate.photo.upload_error', { names: filesNames.join(', ') }).then(function (msg) {
                    alert(msg);
                })
            }
        }


        vm.temp = {};
        vm.uploadPhoto = function (files, invalidFiles) {

            if (invalidFiles.length) {
                $translate('Community.configuration.validate.photo.file_invalid', { name: invalidFiles[0].name }).then(function (msg) {
                    alert(msg);
                })
                return;
            }

            if (!files || !files.length) {
                return;
            }

            sequentialUpload(files, 0, [], sequentialUploadCompleted);


        };

        vm.removePhoto = function (idx) {
            vm.community.Photos.splice(idx, 1);
        }

        function sequentialUpload(files, i, errorsFiles, callback) {
            CommunityService.UploadPhoto(files[i]).then(function (photo) {
                vm.community.Photos.push(photo.Result);
            }, function (error) {
                errorsFiles.push({ file: files[i], error: error });
            }).then(function () {
                if (files.length === i + 1) {
                    callback(errorsFiles);
                } else {
                    sequentialUpload(files, i + 1, errorsFiles, callback);
                }
            });
        }

        
        //#endregion
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth', ['ngCookies', 'ui.router'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        
        // Translation
        $translatePartialLoaderProvider.addPart('app/auth');
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth')
        .controller('ChangePasswordController', ChangePasswordController);

    /** @ngInject */
    function ChangePasswordController($rootScope, $scope, $state, AuthenticationService,  $cookies) {
        var vm = this;
        $("div").removeClass("modal-backdrop");
        vm.model = { OldPassword: null, NewPassword: null };

        vm.changePassword = function () {
            if ($scope.changePasswordForm.$invalid) {
                return;
            }

            AuthenticationService.changeMyPassword(vm.model).then(function () {
               
                    AuthenticationService.signOut();
                    $state.go('auth.login');
            }, function (error) {
                alert(error.Message);
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($rootScope, $scope, $state, AuthenticationService, $cookies, $timeout) {
        var vm = this;
        //alert("logincont" + JSON.stringify(vm));
        vm.signInModel = {
            userName: null,
            password: null,
            remember: false
        }
        vm.showPassword = false;
        vm.showCode = false;
        vm.viewConfig = {
            ShowDialog: false
        };
        vm.verify = {
            code: null
        };
        vm.model = {
            UserName: null,
            PIN: null
        };
        vm.errors = null;
        vm.redirect = {
            state: null,
            params: null
        };
        vm.totalcountDown = 600;
        vm.countDown_tick = vm.totalcountDown;
        vm.signingIn = false;
        vm.login = function (IsProceed) {

            if ($scope.signInForm.$invalid) {
                return;
            }

            vm.signingIn = true;
            vm.errors = null;
            var device_model = platform.name; // 'IE'
            var appversion = platform.version; // '10.0'
            var brand = platform.product; // 'iPad'
            var manufacturer = platform.manufacturer;
            var osversion = platform.os.family;
            const d = new Date();
            var day = d.getDate();
            var month = d.getMonth() + 1;
            var year = d.getFullYear();
            var hours = d.getHours();
            var mm = d.getMinutes();
            var ss = d.getSeconds();
            var Session_ID = year +""+month +""+ day +""+ hours +""+ mm +""+ ss; 
            AuthenticationService
                .signInAsync(vm.signInModel.userName, vm.signInModel.password, vm.signInModel.remember, osversion, manufacturer, device_model, brand, appversion, Session_ID, IsProceed)
                .then(function (redirect) {
                    var arr = [];
                    $cookies.remove("university");
                    if (AuthenticationService.hasPermissions('VIEW_UUM_LIST_MERCHANT')) {

                        arr.push('uum', 1);
                    } else {

                        arr.push('uum', 0);
                    }
                    if (AuthenticationService.hasPermissions('VIEW_UiTM_LIST_MERCHANT')) {

                        arr.push('uitm', 1);
                    } else {

                        arr.push('uitm', 0);
                    }
                    if (AuthenticationService.hasPermissions('VIEW_UPM_LIST_MERCHANT')) {

                        arr.push('upm', 1);
                    } else {

                        arr.push('upm', 0);
                    }
                    vm.signingIn = false;
                    var cookieOptions = {
                        path: '/',
                        samesite: 'lax',
                        secure: true
                    };


                    $cookies.putObject('university', arr, cookieOptions);
                  
                    console.log($cookies.getObject('university'));
                    vm.timer();
                    vm.redirect = angular.copy(redirect);
                    vm.resendCode('new');
                    

                }, function (error) {

                    vm.signingIn = false;
                    vm.viewConfig.ShowDialog = false;
                    if (error) {
                        if (error.Code === 'USER_PREVIOUS_SESSION_IN_ACTIVE') {

                            vm.errors = {
                                UserSignAgain: true,
                                Message: error.Message
                            }
                        }
                        else if (error.Code === 'INCORRECT_LOGIN') {
                            vm.errors = {
                                incorrect: true
                            }
                        }
                        else if (error.Code === 'ACCOUNT_INACTIVE') {
                            vm.errors = {
                                inactived: true
                            }
                        }
                        else if (error.Code === 'ACCOUNT_SUSPEND') {
                            vm.errors = {
                                suspended: true
                            }
                        }
                        else if (error.Code === 'ACCOUNT_CLOSED') {
                            vm.errors = {
                                closed: true
                            }
                        }
                        else if (error.Code === 'ACCOUNT_BLOCKED') {
                            vm.errors = {
                                locked: true
                            }
                        }
                        else {
                            vm.errors = {
                                cannotSignIn: true
                            }
                        }
                    }
                    else {
                        vm.errors = {
                            cannotSignIn: true
                        }
                    }

                })
        }
        vm.signIn = function () {
            var IsProceed = "0";
               if ($scope.signInForm.$invalid) {
                return;
            }

            vm.signingIn = true;
            vm.errors = null;
            var device_model = platform.name; // 'IE'
            var appversion = platform.version; // '10.0'
            var brand = platform.product; // 'iPad'
            var manufacturer = platform.manufacturer;
            var osversion = platform.os.family;
            

            const d = new Date();
            var day = d.getDate();
            var month = d.getMonth() + 1;
            var year = d.getFullYear();
            var hours = d.getHours();
            var mm = d.getMinutes();
            var ss = d.getSeconds();
            var Session_ID = year + "" + month + "" + day + "" + hours + "" + mm + "" + ss; 

            AuthenticationService
                .signInAsync(vm.signInModel.userName, vm.signInModel.password, vm.signInModel.remember, osversion, manufacturer, device_model, brand, appversion, Session_ID, IsProceed)
                .then(function (redirect) {
                    var arr = [];
                    $cookies.remove("university");
                    if (AuthenticationService.hasPermissions('VIEW_UUM_LIST_MERCHANT')) {

                        arr.push('uum', 1);
                    } else {

                        arr.push('uum', 0);
                    }
                    if (AuthenticationService.hasPermissions('VIEW_UiTM_LIST_MERCHANT')) {

                        arr.push('uitm', 1);
                    } else {

                        arr.push('uitm', 0);
                    }
                    if (AuthenticationService.hasPermissions('VIEW_UPM_LIST_MERCHANT')) {

                        arr.push('upm', 1);
                    } else {

                        arr.push('upm', 0);
                    }
                    vm.signingIn = false;
                    var cookieOptions = {
                        path: '/',
                        samesite: 'lax',
                        secure: true
                    };

                    vm.viewConfig.ShowDialog = true;
                    $cookies.putObject('university', arr, cookieOptions);
                   
                    console.log($cookies.getObject('university'));
                    vm.timer();
                    vm.redirect = angular.copy(redirect);
                    vm.resendCode('new');

                }, function (error) {

                    vm.signingIn = false;
                    vm.viewConfig.ShowDialog = false;
                    if (error) {
                        if (error.Code === 'USER_PREVIOUS_SESSION_IN_ACTIVE') {
                            var confirm = window.confirm(error.Message);
                                if (!confirm) {
                                    return;
                                }
                                else {
                                    vm.login("1");
                                }
                        }
                        else if (error.Code === 'INCORRECT_LOGIN') {
                            vm.errors = {
                                incorrect: true
                            }
                        }
                        else if (error.Code === 'ACCOUNT_INACTIVE') {
                            vm.errors = {
                                inactived: true
                            }
                        }
                        else if (error.Code === 'ACCOUNT_SUSPEND') {
                            vm.errors = {
                                suspended: true
                            }
                        }
                        else if (error.Code === 'ACCOUNT_CLOSED') {
                            vm.errors = {
                                closed: true
                            }
                        }
                        else if (error.Code === 'ACCOUNT_BLOCKED') {
                            vm.errors = {
                                locked: true
                            }
                        }
                        else {
                            vm.errors = {
                                cannotSignIn: true
                            }
                        }
                    }
                    else {
                        vm.errors = {
                            cannotSignIn: true
                        }
                    }

                })
            
        }
        vm.resendCode = function (redirect) {
            vm.verify.code = null;
            AuthenticationService
                .sendVerifyCode(vm.signInModel.userName)
                .then(function (response) {
                    if (response != undefined) {
                        if (redirect == 'edit') {
                            vm.totalcountDown = 600;
                            vm.timer();
                        };
                        alert(response.Result);
                    };
                   
                }, function (error) {
                    if (error) {
                        alert(error.Message);
                    }
                })
          
        }

        //vm.timer = function () {
        //    if (vm.totalcountDown < 0) {
        //        vm.totalcountDown = 0;
        //        return;
        //    }
        //    else if() {
        //        vm.countDown_tick = vm.totalcountDown;
        //        vm.totalcountDown--;
        //        $timeout(function () {
        //            vm.timer();
        //        }, 1000);
        //    }
        //};



        vm.timer = function () {
         
            if (vm.totalcountDown > 0) {
                vm.countDown_tick = vm.secondsToTime(vm.totalcountDown);
                vm.totalcountDown--;
                $timeout(function () { vm.timer(); }, 1000);
            } else {
                vm.countDown_tick = '00:00';
            }

        };
        vm.secondsToTime = function (secs) {

            var divisor_for_minutes = secs % (60 * 60);
            var minutes = Math.floor(divisor_for_minutes / 60);

            var divisor_for_seconds = divisor_for_minutes % 60;
            var seconds = Math.ceil(divisor_for_seconds);
            var minutes1 = minutes < 10 ? "0" + minutes : minutes;
            var seconds1 = seconds < 10 ? "0" + seconds : seconds;
            return minutes1 + ':' + seconds1;
        };
        vm.VerifyCode = function () {
            if (vm.verify.code != null) {
                if (vm.verify.code.length < 6) {
                    alert("Please enter 6-digit OTP sent to your emailid");
                    vm.verify.code = null;
                    return;
                }
            }
            vm.model = {
                UserName: vm.signInModel.userName,
                VerificationCode: vm.verify.code
            };
            AuthenticationService
                .verifyCode(vm.model)
                .then(function (response) {
                    if (response.Result) {
                     //   vm.signingIn = true;
                        var accountType = $cookies.get('account_type');
                        if (AuthenticationService.hasPermissions('REDIRECT_CHANGEPASSWORD')) {
                            $state.go('app.account.change-password');
                            vm.viewConfig.ShowDialog = false;
                        }
                        else if (vm.redirect && vm.redirect.state) {
                            $state.go(vm.redirect.state, vm.redirect.params);
                        }
                        else if (accountType == 1) {
                            vm.viewConfig.ShowDialog = false;
                            $state.go('app.dashboard');
                        
                        }
                        else if (accountType == 2) {
                            if (AuthenticationService.hasPermissions('VIEW_MERCHANT')) {
                                $state.go('app.merchant.info', { 'merchantId': null });
                                vm.viewConfig.ShowDialog = false;
                            } else {
                                $state.go('app.dashboard');
                                vm.viewConfig.ShowDialog = false;
                              
                            }
                        }
                        else {
                            //$state.go('app.merchant.list');
                            vm.viewConfig.ShowDialog = false;
                            $state.go('app.dashboard');
                        }
                    }
                }, function (error) {
                    if (error) {
                        alert(error.Message);
                    }
                })
        }
        vm.toggleShowPassword = function () {
             vm.showPassword = !vm.showPassword;
        }
        vm.toggleShowCode = function () {
            vm.showCode = !vm.showCode;
        }
        vm.searchByKeyword = function ($event) {
            var charCode = ($event.which) ? $event.which : $event.keyCode
            if (charCode > 31 && (charCode < 48 || charCode > 57)) {
                alert("Please enter 6-digit OTP sent to your emailid");
                vm.verify.code = null;
                return false;
            }
              
            
        }
        vm.cancelVerify = function () {
            vm.signingIn = false;
            vm.viewConfig.ShowDialog = false;
            $cookies.remove("university");
            vm.errors = {
                cannotSignIn: true
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('SharedStoreCardService', SharedStoreCardService);

    /** @ngInject */
    function SharedStoreCardService(SVCS, $http, $q, CoreService) {
        var merchantServer = SVCS.Merchant;

        var service = {
            All: All,
            GetByBrandId: GetByBrandId,
            Get: Get,
            Create: Create,
            Update: Update,
            Remove: Remove,
            Search: Search
        };

        return service;

        function GetByBrandId(brandId) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/shared-storecards/get-by-brand-id/' + brandId).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function All() {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/shared-storecards').then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/shared-storecards/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(sharedStoreCard) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/shared-storecards', sharedStoreCard).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(sharedStoreCard) {
            var deferer = $q.defer();

            CoreService.Put(merchantServer + '/api/shared-storecards', sharedStoreCard).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Remove(id) {
            var deferer = $q.defer();

            CoreService.Delete(merchantServer + '/api/shared-storecards/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/shared-storecards/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
    }
})();
//(function () {
//    'use strict';

//    angular
//        .module('app.admin')
//        .directive('isMerchantTierNameAvailable', isMerchantTierNameAvailable);

//    /** @ngInject **/
//    function isMerchantTierNameAvailable($q, $http, $timeout, SVCS) {
//        return {
//            require: 'ngModel',
            
//            link: function (scope, elm, attrs, ctrl) {
                
//                var checkingTask = null;

//                var baseUrl = SVCS.Merchant;

//                ctrl.$asyncValidators.isMerchantTierNameAvailable = function (modelValue) {
//                    if (ctrl.$isEmpty(modelValue)) {
//                        return $q.when();
//                    }

//                    var def = $q.defer();

//                    if (checkingTask != null) {
//                        $timeout.cancel(checkingTask);
//                        checkingTask = null;
//                    }

//                    var id = scope.$eval(attrs.isMerchantTierNameAvailable);
//                    checkingTask = $timeout(function () {
//                        $http.post(baseUrl + '/api/merchant-tiers/is-merchant-tier-name-available', { Name: modelValue, Id: id }).then(function (response) {
//                            if (response.data) {
//                                def.resolve();
//                            } else {
//                                def.reject();
//                            }
//                        }, function (responseError) {
//                            def.reject();
//                        })
//                    }, 500)

//                    return def.promise;
//                };
//            }
//        };
//    }
//})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('SharedStoreCardController', SharedStoreCardController);

    /** @ngInject */
    function SharedStoreCardController(SVCS, $translate, SharedStoreCardService, MerchantService, AdminUserService, $scope) {
        var vm = this;
        vm.sharedStoreCard = [];
        vm.criteria = {
            Keyword: null,
            Page: 1,
            Length: 10
        };
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.itemsPerPage = 10;
        vm.maxSize = 10;

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        };

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
          
            SharedStoreCardService.Search(criteria).then(function (data) {
                vm.sharedStoreCard = data.Items;
                vm.totalItems = data.Total;

                // Get merchant name
                MerchantService.GetAllMerchantsPublicInfo().then(function (merchants) {
                    vm.sharedStoreCard.forEach(function (sharedStoreCard) {
                        sharedStoreCard.MerchantName = merchants.filter(function (merchant) {
                            return merchant.Id === sharedStoreCard.MerchantId
                        })[0].Name;
                    })
                })

                // Get created name
                AdminUserService.Search({}).then(function (data) {
                    vm.sharedStoreCard.forEach(function(sharedStoreCard){
                        sharedStoreCard.CreatedBy = data.Items.filter(function (user) {
                            return user.Id === sharedStoreCard.CreatedBy
                        })[0].UserName;
                    })
                });
            })
        }
        vm.search();

        vm.reset = function () {
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }

        vm.remove = function (sharedStoreCard) {
            $translate("admin.sharedStoreCard.confirm_remove").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }

                SharedStoreCardService.Remove(sharedStoreCard.Id).then(function () {
                    vm.search();
                });
            })
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($rootScope, $scope, $state, AuthenticationService,  $cookies) {
        var vm = this;
        vm.userName = null;

        vm.requestResetPassword = function () {
            if ($scope.forgotPasswordForm.$invalid) {
                return;
            }

            AuthenticationService.requestResetPassword(vm.userName).then(function () {
                $state.go('auth.login');
            }, function (error) {
                alert(error.Message);
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('UserService', UserService);

    /** @ngInject */
    function UserService(SVCS, $http, $q, CoreService) {
        var profileServer = SVCS.Profile;
        var walletServer = SVCS.Wallet;

        var service = {
            Search: Search,
            SearchV1: SearchV1,
            Get: Get,
            GetTransaction: GetTransaction,
            Unblock: Unblock,
            ExportUser: ExportUser,
            ExportUserMobileChange: ExportUserMobileChange,
            GetWalletTransaction: GetWalletTransaction,
            GetStoreCardTransaction: GetStoreCardTransaction,
            GetKipleKashTransaction: GetKipleKashTransaction,
            ExportUserWallet: ExportUserWallet,
            ExportUserStorecard: ExportUserStorecard,
            ExportUserKiplekash: ExportUserKiplekash,
            SendToEmail: SendToEmail,
            SendToEmailPhoneNumberChange: SendToEmailPhoneNumberChange,
            ExportUserTransaction: ExportUserTransaction,
            UpdateEWagesEmployer: UpdateEWagesEmployer,
            ResetPassword: ResetPassword,
            unBind: unBind,
            UpdateAddress: UpdateAddress
        };

        return service;

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/profiles/web/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function SearchV1(criteria) {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/profiles/web/search/v1', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function ExportUser(criteria) {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/profiles/Export', criteria).then(function (response) {
                var file_name = 'UserReport.csv';
                var csvData = new Blob([response], { type: 'text/csv' });
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                    window.navigator.msSaveOrOpenBlob(csvData, file_name);
                } else { // for Non-IE (chrome, firefox etc.)
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    var csvUrl = URL.createObjectURL(csvData);
                    a.href = csvUrl;
                    a.download = file_name;
                    a.click();
                    URL.revokeObjectURL(a.href)
                    a.remove();
                }
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function ExportUserWallet(criteria) {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/histories/ExportWalletTransaction', criteria).then(function (response) {
                var file_name = 'UserWalletReport.csv';
                var csvData = new Blob([response], { type: 'text/csv' });
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                    window.navigator.msSaveOrOpenBlob(csvData, file_name);
                } else { // for Non-IE (chrome, firefox etc.)
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    var csvUrl = URL.createObjectURL(csvData);
                    a.href = csvUrl;
                    a.download = file_name;
                    a.click();
                    URL.revokeObjectURL(a.href)
                    a.remove();
                }
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function ExportUserStorecard(criteria) {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/histories/ExportstorecardHistories', criteria).then(function (response) {
                var file_name = 'UserStorecardReport.csv';
                var csvData = new Blob([response], { type: 'text/csv' });
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                    window.navigator.msSaveOrOpenBlob(csvData, file_name);
                } else { // for Non-IE (chrome, firefox etc.)
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    var csvUrl = URL.createObjectURL(csvData);
                    a.href = csvUrl;
                    a.download = file_name;
                    a.click();
                    URL.revokeObjectURL(a.href)
                    a.remove();
                }
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        function ExportUserKiplekash(criteria) {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/histories/ExportKipleKashHistories', criteria).then(function (response) {
                var file_name = 'UserZakatReport.csv';
                var csvData = new Blob([response], { type: 'text/csv' });
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                    window.navigator.msSaveOrOpenBlob(csvData, file_name);
                } else { // for Non-IE (chrome, firefox etc.)
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    var csvUrl = URL.createObjectURL(csvData);
                    a.href = csvUrl;
                    a.download = file_name;
                    a.click();
                    URL.revokeObjectURL(a.href)
                    a.remove();
                }
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/profiles/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function GetTransaction(criteria) {
            var deferer = $q.defer();

            CoreService.Get(walletServer + '/api/histories/admin', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        };

        function GetWalletTransaction(criteria) {
            var deferer = $q.defer();

            CoreService.Get(walletServer + '/api/histories/GetWalletTransaction', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        };


        function GetStoreCardTransaction(criteria) {
            var deferer = $q.defer();

            CoreService.Get(walletServer + '/api/histories/GetStoreCardTransaction', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function GetKipleKashTransaction(criteria) {
            var deferer = $q.defer();

            CoreService.Get(walletServer + '/api/histories/GetKipleKashTransaction', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        function Unblock(id) {
            var deferer = $q.defer();

            CoreService.Get(SVCS.Auth + '/api/account/admin/unblock?accountId=' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        function ResetPassword(id) {
            var deferer = $q.defer();

            CoreService.Get(SVCS.Auth + '/api/account/admin/resetpasswordv1?accountId=' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        function unBind(id) {
            var deferer = $q.defer();

            CoreService.Get(SVCS.Auth + '/api/rewardlink/unBindRewardLink?accountId=' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        function SendToEmail(criteria) {
            var deferer = $q.defer();
            CoreService.Post(profileServer + '/api/profiles/send-to-email', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function SendToEmailPhoneNumberChange(criteria) {
            var deferer = $q.defer();
            CoreService.Post(profileServer + '/api/profiles/send-to-email-mobile-change', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        //function GetWalletTransaction(criteria) {
        //    var deferer = $q.defer();

        //    CoreService.Get(walletServer + '/api/histories/admin/walletTransaction', criteria).then(function (response) {
        //        deferer.resolve(response);
        //    })

        //    return deferer.promise;
        //}
        function ExportUserTransaction(criteria) {
            var deferer = $q.defer();

            CoreService.Get(walletServer + '/api/histories/export/user-transaction', criteria).then(function (response) {
                var file_name = 'UserTransaction.csv';
                var csvData = new Blob([response], { type: 'text/csv' });
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                    window.navigator.msSaveOrOpenBlob(csvData, file_name);
                } else { // for Non-IE (chrome, firefox etc.)
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    var csvUrl = URL.createObjectURL(csvData);
                    a.href = csvUrl;
                    a.download = file_name;
                    a.click();
                    URL.revokeObjectURL(a.href)
                    a.remove();
                }
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function UpdateEWagesEmployer(criteria) {
            var deferer = $q.defer();

            CoreService.Post(profileServer + '/api/account/Ewages/update-eWages-employer', criteria , { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        function UpdateAddress(criteria) {
            var deferer = $q.defer();

            CoreService.Post(profileServer + '/api/profiles/admin/update-user-profile', criteria, { headers: { 'Content-Type': 'application/json' } }).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        function ExportUserMobileChange(criteria) {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/profiles/ExportMobileChangeUserData', criteria).then(function (response) {
                var file_name = 'UserReport.csv';
                var csvData = new Blob([response], { type: 'text/csv' });
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                    window.navigator.msSaveOrOpenBlob(csvData, file_name);
                } else { 
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    var csvUrl = URL.createObjectURL(csvData);
                    a.href = csvUrl;
                    a.download = file_name;
                    a.click();
                    URL.revokeObjectURL(a.href)
                    a.remove();
                }
                deferer.resolve(response);
            })

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('TierSettingService', TierSettingService);

    /** @ngInject */
    function TierSettingService(SVCS, $http, $q, CoreService) {
        var merchantServer = SVCS.Merchant;

        var service = {
            All: All,
            Get: Get,
            Create: Create,
            Update: Update,
            Remove: Remove
        };

        return service;

        function All() {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/merchant-tiers').then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/merchant-tiers/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(tier) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/merchant-tiers',tier).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(tier) {
            var deferer = $q.defer();

            CoreService.Put(merchantServer + '/api/merchant-tiers', tier).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Remove(tierId) {
            var deferer = $q.defer();

            CoreService.Delete(merchantServer + '/api/merchant-tiers/' + tierId).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .directive('isMerchantTierNameAvailable', isMerchantTierNameAvailable);

    /** @ngInject **/
    function isMerchantTierNameAvailable($q, $http, $timeout, SVCS) {
        return {
            require: 'ngModel',
            
            link: function (scope, elm, attrs, ctrl) {
                
                var checkingTask = null;

                var baseUrl = SVCS.Merchant;

                ctrl.$asyncValidators.isMerchantTierNameAvailable = function (modelValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return $q.when();
                    }

                    var def = $q.defer();

                    if (checkingTask != null) {
                        $timeout.cancel(checkingTask);
                        checkingTask = null;
                    }

                    var id = scope.$eval(attrs.isMerchantTierNameAvailable);
                    checkingTask = $timeout(function () {
                        $http.post(baseUrl + '/api/merchant-tiers/is-merchant-tier-name-available', { Name: modelValue, Id: id }).then(function (response) {
                            if (response.data) {
                                def.resolve();
                            } else {
                                def.reject();
                            }
                        }, function (responseError) {
                            def.reject();
                        })
                    }, 500)

                    return def.promise;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('TierSettingController', TierSettingController);

    /** @ngInject */
    function TierSettingController(SVCS, $translate, TierSettingService, $scope) {
        var vm = this;
        vm.tierSetting = [];
        vm.viewConfig = { ShowDialog: false, Action: null };

        TierSettingService.All().then(function (data) {
            vm.tierSetting = data;
        })

        //vm.clearForm = function () {
        //    vm.group = {
        //        Name: null,
        //        Description: null,
        //    }

        //    $scope.groupForm.$setPristine();
        //    $scope.groupForm.$setUntouched();
        //}

        //vm.openDialog = function (action, group) {
        //    vm.viewConfig.Action = action;
        //    vm.group = {};
        //    vm.clearForm();
        //    if (action == 'edit') {
        //        vm.group = group;
        //    }
        //    vm.viewConfig.ShowDialog = true;
        //}

        //vm.save = function () {

        //    if (!$scope.groupForm.$valid) {
        //        angular.forEach($scope.groupForm.$error, function (field) {
        //            angular.forEach(field, function (errorField) {
        //                errorField.$setTouched();
        //            })
        //        });
        //        return;
        //    }

        //    if (vm.viewConfig.Action == 'new') {
        //        GroupService.Create(vm.group).then(function (res) {
        //            vm.groups.unshift({ Id: res.Id, Name: res.Name, Description: res.Description });
        //            vm.cancel();
        //        })
        //    }
        //    else {
        //        GroupService.Update(vm.group).then(function (res) {
        //            vm.cancel();
        //        })
        //    }
        //}

        //vm.cancel = function () {
        //    vm.viewConfig.ShowDialog = false;
        //    //vm.group = undefined;
        //    vm.Action = null;
        //}

        vm.remove = function (tier) {
            $translate("admin.tierSetting.confirm_remove").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }

                TierSettingService.Remove(tier.Id).then(function (res) { vm.tierSetting.removeItem(tier) });
            })
        }
    }
})();
(function () {

    angular
        .module('app.admin')
        .controller('tagCreateOrUpdateCtrl', tagCreateOrUpdateCtrl);

    tagCreateOrUpdateCtrl.$inject = [
        '$scope',
        "$uibModalInstance",
        "modalData",
        "TagService"
    ];

    function tagCreateOrUpdateCtrl($scope, $uibModalInstance, modalData, TagService) {
        var vm = this;
        vm.channelList = [];
        vm.categoryList = [];
        vm.initBasicData = function () {
            TagService.GetTagBasicData().then(function (response) {
                //vm.channelList = response.data.ChannelList;
                vm.categoryList = response.data.CategoryList;
            });
        }
        vm.channelList = [
            {
                Value: "",
                Text: "Select an option"
            },
            {
                Value: "Kiplepay",
                Text: "Kiplepay"
            }
        ];

        vm.modalData = modalData;
        vm.formData = vm.modalData.entity || {};

        vm.isCreateFlag = vm.formData.TagId == null;


        console.log(vm.modalData);

        vm.initBasicData();
        vm.formError = "";
        vm.modal = {
            ok: function (result) {
                $uibModalInstance.close(result);
            },
            cancel: function () {
                $uibModalInstance.dismiss('cancel');
            }
        };

        vm.onSubmit = function (isValid) {
            if (!isValid) {
                return;
            }
            vm.formError = "";
            if (vm.isCreateFlag) {
                vm.doCreateTag(vm.formData);
            } else {
                vm.doUpdateTag(vm.formData);
            }
        };

        vm.doCreateTag = function (entityData) {
            TagService.createTag(entityData)
                .then(function (response) {
                    vm.modal.ok(response.data);
                })
                .catch(function (errorInfo) {
                    vm.formError = errorInfo.data.Message;
                });
            return false;
        };

        vm.doUpdateTag = function (entityData) {
            TagService.updateTag(entityData)
                .then(function (response) {
                    vm.modal.ok(response.data);
                })
                .catch(function (errorInfo) {
                    vm.formError = errorInfo.data.Message;
                });
            return false;
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('TagService', TagService);

    /** @ngInject */
    function TagService($q, $http, CoreService, SVCS) {
        var productServer = SVCS.Product;
        var merchantServer = SVCS.Merchant;

        var service = {
            Get: Get,
            Search: Search,
            createTag: createTag,
            updateTag: updateTag,
            Delete: Delete,
            GetBrand: GetBrand,
            SearchBrand: SearchBrand,
            CreateBrand: CreateBrand,
            UpdateBrand: UpdateBrand,
            DeleteBrand: DeleteBrand,
            GetTagBasicData: GetTagBasicData
        };

        return service;

        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(productServer + '/api/tags/' + id).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Get(productServer + '/api/tags/dashboard/search', criteria).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function createTag(entity) {
            return $http.post(productServer + '/api/tags/create',
                entity,
                { headers: { 'Content-Type': 'application/json' } });
        }

        function updateTag(entity) {
            return $http.put(productServer + '/api/tags/update',
                entity,
                { headers: { 'Content-Type': 'application/json' } });

            return deferer.promise;
        }

        function Delete(id) {
            var deferer = $q.defer();

            CoreService.Delete(productServer + '/api/tags/' + id).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function GetBrand(id) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/tags/' + id).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function SearchBrand(criteria) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/tags/dashboard/search', criteria).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function CreateBrand(tag) {
            var deferer = $q.defer();
            var tagdata = {
                TagId: tag.Id,
                TagName: tag.Name
            };
            CoreService.Post(productServer + '/api/tags/create', tagdata).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function UpdateBrand(tag) {
            var deferer = $q.defer();
            var tagdata = {
                TagId: tag.Id,
                TagName: tag.Name
            };
            CoreService.Put(productServer + '/api/tags/update', tagdata).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function DeleteBrand(id) {
            var deferer = $q.defer();

            CoreService.Delete(merchantServer + '/api/tags/' + id).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function GetTagBasicData() {
            return $http.get(merchantServer + '/api/tags/get-basic-data');
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .directive('isTagNameAvailable', isTagNameAvailable)
        .directive('isTagNameAvailableBrand', isTagNameAvailableBrand);

    /** @ngInject **/
    function isTagNameAvailable($q, $http, $timeout, SVCS) {
        return {
            require: 'ngModel',
            
            link: function (scope, elm, attrs, ctrl) {
                
                var checkingTask = null;

                var baseUrl = SVCS.Product;

                ctrl.$asyncValidators.isTagNameAvailable = function (modelValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return $q.when();
                    }

                    var def = $q.defer();

                    if (checkingTask != null) {
                        $timeout.cancel(checkingTask);
                        checkingTask = null;
                    }

                    var id = scope.$eval(attrs.isTagNameAvailable);

                    checkingTask = $timeout(function () {
                        $http.get(baseUrl + '/api/tags/is-tag-name-available/' + modelValue + '/' + id).then(function (response) {
                            if (response.data) {
                                def.resolve();
                            } else {
                                def.reject();
                            }
                        }, function (responseError) {
                            def.reject();
                        })
                    }, 500)

                    return def.promise;
                };
            }
        };
    }

    /** @ngInject **/
    function isTagNameAvailableBrand($q, $http, $timeout, SVCS) {
        return {
            require: 'ngModel',

            link: function (scope, elm, attrs, ctrl) {

                var checkingTask = null;

                var baseUrl = SVCS.Merchant;

                ctrl.$asyncValidators.isTagNameAvailableBrand = function (modelValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return $q.when();
                    }

                    var def = $q.defer();

                    if (checkingTask != null) {
                        $timeout.cancel(checkingTask);
                        checkingTask = null;
                    }

                    var id = scope.$eval(attrs.isTagNameAvailableBrand);

                    checkingTask = $timeout(function () {
                        $http.get(baseUrl + '/api/tags/is-tag-name-available/' + modelValue + '/' + id).then(function (response) {
                            if (response.data) {
                                def.resolve();
                            } else {
                                def.reject();
                            }
                        }, function (responseError) {
                            def.reject();
                        })
                    }, 500)

                    return def.promise;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('TagController', TagController);

    TagController.$inject = [
        '$scope',
        '$timeout',
        '$translate',
        "popupService",
        "TagService"
    ];

    /** @ngInject */
    function TagController($scope, $timeout, $translate, popupService, TagService) {
        var vm = this;

        //#region Voucher
        //#region Search & paging
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 5;

        vm.criteria = {
            keyword: null,
            Page: 1,
            Length: 10
        }

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            TagService.Search(criteria).then(function (res) {
                vm.tags = res.Items;
                vm.totalItems = res.Total;
            });
        }

        vm.reset = function () {
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }

        vm.search();
        //#endregion

        //#region Clear form
        vm.clearForm = function () {
            vm.tag = {
                Id: null,
                Name: null
            };
            $scope.tagForm.$setPristine();
            $scope.tagForm.$setUntouched();
        }
        //#endregion

        //#region Add/Update/Delete tag
        vm.viewConfig = {
            ShowDialog: false,
            Action: null
        };

        vm.add = function () {
            vm.clearForm();
            vm.viewConfig.ShowDialog = true;
            vm.viewConfig.Action = 'new';
        }

        vm.edit = function (id) {
            vm.clearForm();

            TagService.Get(id).then(function (data) {
                vm.tag = data;
            });
            vm.viewConfig.ShowDialog = true;
            vm.viewConfig.Action = 'edit';
        }

        vm.save = function () {
            if (!$scope.tagForm.$valid) {
                angular.forEach($scope.tagForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                        $('#tagForm .ng-invalid')[0].focus();
                    })
                });
                return;
            }
            $timeout(function () {
                if (vm.viewConfig.Action == 'new') {
                    TagService.Create(vm.tag).then(function (data) {
                        vm.search();
                        vm.cancel();
                    });
                }
                else if (vm.viewConfig.Action == 'edit') {
                    TagService.Update(vm.tag).then(function (data) {
                        vm.search();
                        vm.cancel();
                    });
                }
            }, 500);
        }

        vm.cancel = function () {
            vm.viewConfig.Action = null;
            vm.viewConfig.ShowDialog = false;
        }

        vm.delete = function (id) {
            $translate("admin.tag.confirm_remove").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }

                TagService.Delete(id).then(function (data) {
                    vm.search();
                });
            });
        }
        //#endregion
        //#endregion

        //#region Brand
        //#region Search & paging
        vm.totalItemsBrand = 0;
        vm.currentPageBrand = 1;
        vm.maxSizeBrand = 5;

        vm.criteriaBrand = {
            keyword: null,
            Page: 1,
            Length: 10
        }

        vm.searchByKeywordBrand = function ($event) {
            if ($event.which == 13) {
                vm.searchBrand();
            }
        }

        vm.searchBrand = function () {
            var criteriaBrand = angular.copy(vm.criteriaBrand);
            criteriaBrand.Page = vm.currentPageBrand;
            TagService.SearchBrand(criteriaBrand).then(function (res) {
                vm.tagsBrand = res.Items;
                vm.totalItemsBrand = res.Total;
            });
        }

        vm.resetBrand = function () {
            vm.criteriaBrand = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPageBrand = 1;
            vm.searchBrand();
        }

        vm.searchBrand();
        //#endregion

        //#region Clear form
        vm.clearFormBrand = function () {
            vm.tagBrand = {
                Id: null,
                Name: null
            };
            $scope.tagFormBrand.$setPristine();
            $scope.tagFormBrand.$setUntouched();
        }
        //#endregion

        //#region Add/Update/Delete tag
        vm.viewConfigBrand = {
            ShowDialog: false,
            Action: null
        };

        vm.addBrand = function () {
            vm.clearFormBrand();
            vm.viewConfigBrand.ShowDialog = true;
            vm.viewConfigBrand.Action = 'new';
        }

        vm.editBrand = function (id) {
            vm.clearFormBrand();

            TagService.GetBrand(id).then(function (data) {
                vm.tagBrand = data;
            });
            vm.viewConfigBrand.ShowDialog = true;
            vm.viewConfigBrand.Action = 'edit';
        }

        vm.saveBrand = function () {
            if (!$scope.tagFormBrand.$valid) {
                angular.forEach($scope.tagFormBrand.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                        $('#tagFormBrand .ng-invalid')[0].focus();
                    })
                });
                return;
            }
            $timeout(function () {
                if (vm.viewConfigBrand.Action == 'new') {
                    TagService.CreateBrand(vm.tagBrand).then(function (data) {
                        vm.searchBrand();
                        vm.cancelBrand();
                    });
                }
                else if (vm.viewConfigBrand.Action == 'edit') {
                    TagService.UpdateBrand(vm.tagBrand).then(function (data) {
                        vm.searchBrand();
                        vm.cancelBrand();
                    });
                }
            }, 500);
        }

        vm.cancelBrand = function () {
            vm.viewConfigBrand.Action = null;
            vm.viewConfigBrand.ShowDialog = false;
        }

        vm.deleteBrand = function (id) {
            $translate("admin.tag.confirm_remove").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }

                TagService.DeleteBrand(id).then(function (data) {
                    vm.searchBrand();
                });
            });
        }
        //#endregion
        //#endregion

        vm.addTag = function () {
            alert("ab");
        }
        vm.popupCreateOrUpdateTagForm = function (entityId) {
            entityId = entityId || "";
            var tmpEntity = _.find(vm.tags, function (tag) {
                return _.isEqual(tag.Id, entityId);
            }) || {};

            var customModalOptions = {
                closeButtonText: 'Cancel',
                okButtonText: 'Sumbit',
                headerText: "Manage Prefund Account",
                bodyText: '',
                isCreateFlag: entityId ? true : false
            };

            var modalDefaults = {
                templateUrl: "app/admin/tag/tag.updatecreate.view.html",
                controller: "tagCreateOrUpdateCtrl",
                controllerAs: "vm",
                resolve: {
                    modalData: function () {
                        return {
                            options: customModalOptions,
                            entity: {
                                TagId: tmpEntity.Id || null,
                                TagName: tmpEntity.Name,
                                CategoryId: tmpEntity.CategoryId || '',
                                Channel: tmpEntity.Channel || ''
                            }
                        };
                    }
                }
            };

            popupService.showModal(modalDefaults, customModalOptions).then(function (result) {
                vm.search();
            }).catch(function (errorInfo) {

            });
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('SettlementTransactionService', SettlementTransactionService);

    /** @ngInject */
    function SettlementTransactionService(SVCS, $http, $q, CoreService) {
        var walletServer = SVCS.Wallet;

        var service = {
            Search: Search,
            Update: Update,
            Summary: Summary,
            UpdateSummary: UpdateSummary
        };

        return service;

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Get(walletServer + '/api/settlement/transactions/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(transaction) {
            var deferer = $q.defer();

            CoreService.Put(walletServer + '/api/settlement/transactions/update', transaction).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Summary(criteria) {

            var deferer = $q.defer();

            CoreService.Get(walletServer + '/api/settlement/transactions/summary', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function UpdateSummary(transaction) {
            var deferer = $q.defer();

           // console.log(transaction);
            CoreService.Put(walletServer + '/api/settlement/transactions/update', transaction).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
            // return true;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .filter('roundup', function () {
            return function (value) {
                return Math.ceil(value);
            };
        })
        .controller('SettlementTransactionController', SettlementTransactionController);

    /** @ngInject */
    function SettlementTransactionController(SVCS, SettlementTransactionService, MasterMerchantService, MerchantService, $scope, $state ) {
        var vm = this;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 4;
        vm.itemsPerPage = 10;
        vm.settlementTransactions = { TransactionIds: [], Date: null, Status: null };
        vm.criteria = { Keyword: null, MerchantId: null,  clientname: null, Date: null, EndDate: null, Page: 1, Length: 10 };
        vm.viewConfig = { ShowDialog: false };

        vm.criteria.Date = $state.params.sDate;
        vm.criteria.EndDate = $state.params.eDate;
        vm.criteria.MerchantId = $state.params.mId;

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search('search');
            }
        }

        vm.search = function (type) {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            SettlementTransactionService.Search(criteria).then(function (res) {
                vm.transactions = res.Items;
                vm.totalItems = res.Total;

                vm.isCheckAll = false;
                if (type == 'search') {
                    resetUpdate();
                }
                else {
                    var flag = true;
                    angular.forEach(vm.transactions, function (item) {
                        if (vm.settlementTransactions.TransactionIds.indexOf(item.Id) != -1) {
                            item.IsChecked = true;
                        }
                        else {
                            flag = false;
                        }
                    })
                    if (flag) vm.isCheckAll = true;
                }
            })
        }

        vm.checkAll = function () {
            if (vm.isCheckAll) {
                angular.forEach(vm.transactions, function (item) {
                    item.IsChecked = true;
                    vm.settlementTransactions.TransactionIds.push(item.Id);
                })

                vm.isShowCommitButton = true;
            }
            else {
                resetUpdate();
            }
        }

        vm.checkItem = function (transaction) {
            if (transaction.IsChecked) {
                vm.settlementTransactions.TransactionIds.push(transaction.Id);
            }
            else {
                vm.settlementTransactions.TransactionIds.removeItem(transaction.Id);
            }

            if (vm.settlementTransactions.TransactionIds.length > 0) {
                vm.isShowCommitButton = true;
            }
            else {
                vm.isShowCommitButton = false;
            }
        }

        vm.openDialog = function () {
            vm.viewConfig.ShowDialog = true;
        }

        vm.save = function () {
            if (!$scope.transactionForm.$valid) {
                angular.forEach($scope.transactionForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#transactionForm .ng-invalid')[0].focus();
                return;
            }

            SettlementTransactionService.Update(vm.settlementTransactions).then(function (res) {
                vm.cancel();
                vm.search('search');
            })
        }

        vm.cancel = function () {
            vm.viewConfig.ShowDialog = false;
            vm.settlementTransactions.Date = null;
            vm.settlementTransactions.Status = null;
            $scope.transactionForm.$setPristine();
            $scope.transactionForm.$setUntouched();
        }

        vm.loadMerchant = function (keyword) {
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = res.Items;
                });
            } else {
                vm.merchants = null;
            }
        }

        function resetUpdate() {
            angular.forEach(vm.transactions, function (item) {
                item.IsChecked = false;
            })
            vm.settlementTransactions = { TransactionIds: [], Date: null, Status: null };
            vm.isShowCommitButton = false;
        }

        vm.search();

        //get list master merchant
        MasterMerchantService.Search({ Keyword: null }).then(function (res) {
            vm.masterMerchants = res.Items;
        })
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('RefundService', RefundService);

    /** @ngInject */
    function RefundService(SVCS, $http, $q, CoreService) {
        var walletServer = SVCS.Wallet;

        var service = {
            Refund: Refund,
        };

        return service;

        function Refund(model) {
            var deferer = $q.defer();

            CoreService.Post(walletServer + '/api/refunds', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('RefundController', RefundController);

    /** @ngInject */
    function RefundController(SVCS, RefundService, AuthenticationService, $scope, $translate) {
        var vm = this;

        vm.loadUserName = function (keyword) {
            if (keyword.length == 0) {
                AuthenticationService.Search({ Page: 1, Length: 10 }).then(function (res) {
                    vm.accounts = res.Items;
                });
            }
            if (keyword.length >= 3) {
                AuthenticationService.Search({ Keyword: keyword }).then(function (res) {
                    vm.accounts = res.Items;
                });
            } else {
                vm.accounts = null;
            }
        }

        vm.reset = function () {
            vm.refund = {
                UserName: null,
                TransactionId: null,
                Remark: null
            };
            $scope.refundForm.$setPristine();
            $scope.refundForm.$setUntouched();
            vm.result = null;
        }

        vm.save = function () {
            vm.result = null;
            if (!$scope.refundForm.$valid) {
                angular.forEach($scope.refundForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#refundForm .ng-invalid')[0].focus();
                return;
            }

            RefundService.Refund(vm.refund).then(function (data) {
                vm.reset();
                vm.result = data;
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin').filter('cut', function () {
            return function (value, wordwise, max, tail) {
                if (!value) return '';

                max = parseInt(max, 10);
                if (!max) return value;
                if (value.length <= max) return value;

                value = value.substr(0, max);
                if (wordwise) {
                    var lastspace = value.lastIndexOf(' ');
                    if (lastspace !== -1) {
                        //Also remove . and , so its gives a cleaner result.
                        if (value.charAt(lastspace - 1) === '.' || value.charAt(lastspace - 1) === ',') {
                            lastspace = lastspace - 1;
                        }
                        value = value.substr(0, lastspace);
                    }
                }

                return value + (tail || ' …');
            };
        })
        .directive('exportToCsv', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var el = element[0];
                element.bind('click', function (e) {
                    var idName = e.target.name;
                    var fileName = idName.split("--")[0];  
                    var tableId = idName.split("--")[1];               
                    var table = document.getElementById(tableId);                      
                    var csvString = '';
                    for (var i = 0; i < table.rows.length; i++) {
                        var rowData = table.rows[i].cells;
                        if (!rowData) continue;
                        for (var j = 0; j < rowData.length; j++) {
                           csvString = csvString + rowData[j].innerHTML + ",";                           
                        }
                        csvString = csvString.substring(0, csvString.length - 1);
                        csvString = csvString + "\n";
                    }                  
                    csvString = csvString.substring(0, csvString.length - 1);

                    if (document.documentMode) {
                        var IEwindow = window.open();
                        IEwindow.document.write(csvString);   
                        IEwindow.document.close();
                        fileName = fileName + '.csv';
                        IEwindow.document.execCommand('SaveAs', true, fileName);
                        IEwindow.close();
                    } 
                    var isIE = /*@cc_on!@*/false || !!document.documentMode;
                    var isEdge = !isIE && !!window.StyleMedia;
                    if (isEdge) { alert("Edge Browser does not support download!!");}

                    var a = $('<a/>', {
                        style: 'display:none',
                        href: 'data:application/octet-stream;base64,' + btoa(csvString),
                        download: fileName + '.csv'
                    }).appendTo('body')
                    a[0].click()
                    a.remove();
                });
            }
        }
        })
        .controller('NotificationlistController', NotificationlistController)

    function NotificationlistController(NotificationService, $translate, $scope) {
        var vm = this;

        vm.criteria = {
            Keyword: null,
            Page: 1,
            Length: 10
        };

        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 3;
        vm.notification = {};
        vm.viewConfig = { ShowDialog: false, Action: null };

        var sdate = new Date();
        vm.notification.SendAt = new Date(vm.notification.SendAt);
     
     
           
        vm.criterialist = [
            { Id: "AllKiplepayUsers", Name: "admin.notification.notificationcriteria_list.allKiplepay" },
            { Id: "AllRedpayUsers", Name: "admin.notification.notificationcriteria_list.allRedpay" },
            { Id: "AllWomen", Name: "admin.notification.notificationcriteria_list.allwomen" },
            { Id: "AllMen", Name: "admin.notification.notificationcriteria_list.allmen" },
            { Id: "FileUpload", Name: "admin.notification.notificationcriteria_list.fileupload" },
            { Id: "UserHaveNoTransactionXMonths", Name: "admin.notification.notificationcriteria_list.userhavenotransactionxmonths" },
            { Id: "UserHaveBirthdayToday", Name: "admin.notification.notificationcriteria_list.userhavebirthdaytoday" },
            { Id: "UserWithXAmountofKipleKash", Name: "admin.notification.notificationcriteria_list.userwithxamountofkiplekash" },
            { Id: "UserWithXTransactionsInPastYmonths", Name: "admin.notification.notificationcriteria_list.userwithxtransactionsinpastymonths" },
            { Id: "UserSpentXAmountAt_Y_Merchant", Name: "admin.notification.notificationcriteria_list.userspentxamountat_y_merchant" },
            { Id: "UserSpentXTimesAt_Y_Merchant", Name: "admin.notification.notificationcriteria_list.userspentxtimesat_y_merchant" },
            { Id: "SingleUser", Name: "admin.notification.notificationcriteria_list.singleuser" },
        ];

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }
        
        vm.pushNotification = function () {


            if (!$scope.notificationForm.$valid) {
                angular.forEach($scope.notificationForm.$error,
                    function (field) {
                        angular.forEach(field,
                            function (errorField) {
                                errorField.$setTouched();
                            })
                    });
                return;
            }
            if (vm.notification.SendAt < sdate) {

                alert("Schedule Date/Time can only be schedule in future Date/Time.");
                retrun;
            }

            var confirm = window.confirm("Do you wish to Update Schedule Notification ");

            if (!confirm) {
                return;
            }

            if (vm.notification.Criteria == 'FileUpload') {
                vm.notification.UserNames = vm.fileContent.split("\n");
            }


            NotificationService.PushNotificationUpdate(vm.notification).then(function (data) {                
                vm.alertTitle = "Success!";
                vm.isSuccess = true;
                vm.showMessage = true;
                $translate('admin.configuration.saveSuccess').then(function (msg) {
                    alert(msg);
                    vm.cancel();                   
                     return;
                })
            }); 
        }
        vm.alertTitle = "Success!";
        vm.showMessage = false;
        vm.isSuccess = true;
        //vm.doFade = false;


        vm.showAlert = function (message) {
            //reset
            vm.showMessage = false;
            vm.doFade = false;

            vm.showMessage = true;

            vm.errorMessage = message;

            $timeout(function () {
                vm.doFade = true;
            }, 2500);
        };


        vm.cancel = function () {
            vm.viewConfig.ShowDialog = false;           
            vm.search();
            vm.Action = null;
        }

        vm.clearForm = function () {
            vm.notification = {
              
            }

            $scope.notificationForm.$setPristine();
            $scope.notificationForm.$setUntouched();
        }

        vm.openDialog = function (action, notification) {
            vm.viewConfig.Action = action;
            if (action == 'edit') {              
                notification.SendAt = new Date(notification.SendAt);
                vm.clearForm();
                vm.notification = angular.copy(notification);
            }
            vm.viewConfig.ShowDialog = true;
        }

        vm.save = function (not) {
            var filedoc = document.createElement('a');
            filedoc.target = '_blank';
            filedoc.download = 'people.csv';
            filedoc.click();           
            window.alert("Criteria" + vm.notification.NotificationCriteria + "<br>Receipient: " + vm.notification.Receipient + "<br>Message content: " + vm.notification.Message);
        }
        
        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            NotificationService.Search(criteria).then(function (data) {
                vm.notifications = data.Items;
                vm.totalItems = data.Total;
            });
        };

        vm.reset = function () {
            vm.criteria = {
                Keyword: null,
                Page: 1,
                Length: 10
            };
            vm.search();
        }

        vm.remove = function (notification) {
            $translate("admin.notificationlist.confirm_remove").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }
                NotificationService.Remove(notification.Id).then(function (res) { vm.search(); });
            }) 
    
        }

        vm.Update = function (notification) {
            $translate("admin.notificationlist.confirm_update").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }
                NotificationService.Update(vm.notification).then(function (res) { vm.cancel(); });
            })
        }

        vm.search();
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('NotificationService', NotificationService);

    /** @ngInject */
    function NotificationService(SVCS, $http, $q, CoreService) {
        var notiServer = SVCS.Notification;
        var profileServer = SVCS.Profile;

        var service = {
            PushNotification: PushNotification,
            PushNotificationUpdate: PushNotificationUpdate,
            GetUsers: GetUsers,
            Search: Search,
            Remove: Remove,
            GetCriteriaList: GetCriteriaList,
            GetUserTransaction: GetUserTransaction,
            Update: Update            
        };

        return service;

        function PushNotification(model) {
            var deferer = $q.defer();

            CoreService.Post(notiServer + '/api/notifications/notifcation-for-web', model)
                .then(function (response) {
                    deferer.resolve(response);
                }, function (responseError) {
                    deferer.reject(responseError);
                });

            return deferer.promise;
        };      

        function PushNotificationUpdate(model) {
            var deferer = $q.defer();

            CoreService.Post(notiServer + '/api/notifications/notifcation-for-web-update', model)
                .then(function (response) {
                    deferer.resolve(response);
                }, function (responseError) {
                    deferer.reject(responseError);
                });

            return deferer.promise;
        };      

        function GetUsers(criteria)
        {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/profiles/web/search', criteria)
                .then(function (response) {
                    deferer.resolve(response);
                }, function (responseError) {
                    deferer.reject(responseError);
                });

            return deferer.promise;
        };   

        function GetUserTransaction(criteria) {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/reports/web/search', criteria)
                .then(function (response) {
                    deferer.resolve(response);
                }, function (responseError) {
                    deferer.reject(responseError);
                });

            return deferer.promise;

        };

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Get(notiServer + '/api/notificationslist/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;            
            }

        function GetCriteriaList() {
            var deferer = $q.defer();
            CoreService.Get(notiServer + '/api/notifications/get-notifcation-criteria')
                .then(function (response) {
                    deferer.resolve(response);
                }, function (responseError) {
                    deferer.reject(responseError);
                });
            return deferer.promise;
        };  


        function Remove(Id) {
            var deferer = $q.defer();

            CoreService.Delete(notiServer + '/api/notificationslist/' + Id).then(function (response) {
                deferer.resolve(response);
            })
           
            return deferer.promise;
        };

        function Update(Id) {
            var deferer = $q.defer();

            CoreService.Update(notiServer + '/api/notificationslist/' + Id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        };

    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('NotificationController', NotificationController)          
        .directive('fileReader', function () {
            return {
                scope: {
                    fileReader: "="
                },
                link: function (scope, element) {
                    $(element).on('change', function (changeEvent) {
                        var files = changeEvent.target.files;
                        if (files.length) {
                            var r = new FileReader();
                            r.onload = function (e) {
                                var contents = e.target.result;
                                scope.$apply(function () {
                                    scope.fileReader = contents;
                                });
                            };
                            r.readAsText(files[0]);
                        }
                    });
                }
            };
        });

    /** @ngInject */

    function NotificationController(SVCS, NotificationService, $state, $translate, $scope, $timeout ) {

        var vm = this;
        vm.notification = {}       
        vm.isImportFromFile = false;
        vm.userIds = []
      
        vm.fileContent = null;
        vm.loading = false;
        vm.loading = {
            SaveConfiguration: false
        }
        vm.criteria = {
            KeyWord: null,
            Page: 1,
            Length: 10
        };    


        var sdate = new Date();
        vm.notification.SendAt = sdate;
        
        vm.criterialist = [
            { Id: "AllKiplepayUsers", Name: "admin.notification.notificationcriteria_list.allKiplepay" },
            { Id: "AllRedpayUsers", Name: "admin.notification.notificationcriteria_list.allRedpay" },
            { Id: "AllWomen", Name: "admin.notification.notificationcriteria_list.allwomen" },
            { Id: "AllMen", Name: "admin.notification.notificationcriteria_list.allmen" },
            { Id: "FileUpload", Name: "admin.notification.notificationcriteria_list.fileupload" },
            { Id: "UserHaveNoTransactionXMonths", Name: "admin.notification.notificationcriteria_list.userhavenotransactionxmonths" },
            { Id: "UserHaveBirthdayToday", Name: "admin.notification.notificationcriteria_list.userhavebirthdaytoday" },
            { Id: "UserWithXAmountofKipleKash", Name: "admin.notification.notificationcriteria_list.userwithxamountofkiplekash" },
            { Id: "UserWithXTransactionsInPastYmonths", Name: "admin.notification.notificationcriteria_list.userwithxtransactionsinpastymonths" },
            { Id: "UserSpentXAmountAt_Y_Merchant", Name: "admin.notification.notificationcriteria_list.userspentxamountat_y_merchant" },
            { Id: "UserSpentXTimesAt_Y_Merchant", Name: "admin.notification.notificationcriteria_list.userspentxtimesat_y_merchant" },
            { Id: "SingleUser", Name: "admin.notification.notificationcriteria_list.singleuser" },
        ];

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            NotificationService.GetUsers(criteria).then(function (data) {
                vm.userIds = data.Items;
                vm.totalItems = data.Total;
            });
        }

        //vm.search();

      

        vm.pushNotification = function () {
            
            if (!$scope.notificationForm.$valid) {
                angular.forEach($scope.notificationForm.$error,
                    function (field)
                    {
                        angular.forEach(field,
                            function (errorField)
                            {
                                errorField.$setTouched();
                            })
                    });
                return;
            }

            if (vm.notification.SendAt < sdate) {              
               
                alert("Schedule Date/Time can only be schedule in future Date/Time.");
                retrun;
            }
            var confirm = window.confirm("Do you wish to send Notification");
            if (!confirm) {
                return;
            }

            if (vm.notification.Criteria == 'FileUpload') {
                vm.notification.UserNames = vm.fileContent.split("\n");
            }            

            
            NotificationService.PushNotification(vm.notification).then(function (data) {
                $('.err-div').css({ display: "none" });
                if (data.status == "fail") {
                    $("#fileInput").empty();
                    $("#listAccount").empty();
                    $('.err-div').css({ display: "block" });
                    $.each(data.data, function (i, v) {
                        $("#listAccount").append('<label>' + v + '</label><br/><br/>');
                    })
                    return;
                }
            vm.alertTitle = "Success!";
                vm.isSuccess = true;
                vm.showMessage = true;
                $translate('admin.configuration.saveSuccess').then(function (msg) {
                    vm.showAlert(msg);
                    notificationForm.reset();
                })
            });
        }

        vm.importFromFile = function () {
            vm.isImportFromFile = !vm.isImportFromFile;
            if (vm.isImportFromFile) {
                vm.notification.UserIds = null;
            } else {
                vm.notification.UserNames = null;
                vm.fileContent = null;
            }
        }

        vm.alertTitle = "Success!";
        vm.showMessage = false;
        vm.isSuccess = true;
        vm.doFade = false;
       

        vm.showAlert = function (message) {
            //reset
            vm.showMessage = false;
            vm.doFade = false;

            vm.showMessage = true;

            vm.errorMessage = message;

            $timeout(function () {
                vm.doFade = true;
            }, 2500);
        };

        vm.loadUser = function (keyword) {
            if (keyword.length == 0) {
                NotificationService.GetUsers({ Page: 1, Length: 10 }).then(function (res) {
                    vm.userIds = res.Items;
                    vm.search();
                });
            }
            else if (keyword.length >= 3) {
                NotificationService.GetUsers({ KeyWord: keyword }).then(function (res) {
                    vm.userIds = res.Items;
                });
            } else {
                vm.userIds = null;
            }
        }

    }
   
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('ReferralBannerController', ReferralBannerController);

    /** @ngInject */
    function ReferralBannerController(SVCS, $translate, ReferralBannerService, UniversityService, $scope) {
        var vm = this;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;
        vm.banners = {};
        vm.disabledPosition = false;
        vm.banner = {
            Id:0,
            Link: null,
            Position: 1,
            Photos: []
        };
        vm.criteria = { Keyword: null , Page: 1, Length: 10};
        vm.viewConfig = { ShowDialog: false, Action: null };


        vm.BannerType = [
            { "Id": 1, "Name": "ReferralBanner" },
            { "Id": 2, "Name": "Sharing Image" }
        ];
        vm.banner.Type = 1;
        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }
        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            ReferralBannerService.Search(criteria).then(function (res) {
                vm.banners = res.Items;
                vm.totalItems = res.Total;
            })
        }

        vm.reset = function () {
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }
     
        vm.clearForm = function () {
            vm.banner = {
                Id: 0,
                Link: "",
                Position: 1,
                Photos: []
            }
            vm.banner.Type = 1;
            $scope.referralbannerForm.$setPristine();
            $scope.referralbannerForm.$setUntouched();
        }

        vm.openDialog = function (action, banner) {
            vm.viewConfig.Action = action;
            //vm.banner = {
            //    UniversityId: "NormalUser",
            //    Link: "",
            //    Position: 0,
            //    Photos: []
            //}
            vm.clearForm();
            //UniversityService.GetListOfUniveristies().then(function (res) {
            //    vm.universtyList = res.list;;

            //});
            if (action == 'edit') {

                //vm.banner = angular.copy(banner);
                ReferralBannerService.Get(banner.Id).then(function (res) {
                    if (res != null) {
                        vm.banner = {
                            Id: res.Id,
                            Link: res.Link,
                            Position: res.Position,
                            Photos: [],
                            Type: res.BannerType
                        
                        }
                        vm.banner.Photos.push(res.Photos);
                        vm.viewConfig.ShowDialog = true;
                    }

                });
            }
            else {
                vm.disabledPosition = false;
                vm.banner.Position = 1;
                vm.banner.Type = 1;
                vm.viewConfig.ShowDialog = true;
            }
        }

        vm.save = function () {

            if (!$scope.referralbannerForm.$valid) {
                angular.forEach($scope.referralbannerForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#referralbannerForm .ng-invalid')[0].focus();
                return;
            }
           
           
            if (vm.viewConfig.Action == 'new') {

               

                ReferralBannerService.Create(vm.banner).then(function (res) {
                        if (res != null) {
                            vm.search();
                            vm.cancel();
                            alert("Saved Successfully");
                        }
                    });
               
            }
            else {
                ReferralBannerService.Update(vm.banner).then(function (res) {
                    if (res != null) {
                        vm.search();
                        vm.cancel();
                        alert("Updated Successfully");
                    }
                });
            }
        }

        vm.cancel = function () {
            vm.viewConfig.ShowDialog = false;
            //vm.group = undefined;
            vm.Action = null;
        }

        vm.remove = function (banner) {
            $translate("admin.banner.confirm_remove").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }

                ReferralBannerService.Remove(banner.Id).then(function (res) { vm.banners.removeItem(banner) });
            })
        }

       vm.search();

        //#region Upload photos
        vm.temp = {};
        vm.uploadPhoto = function (files, invalidFiles) {
            
            if (invalidFiles.length) {
                $translate('banner.validate.photo.file_invalid', { name: invalidFiles[0].name }).then(function (msg) {
                    alert(msg);
                })
                return;
            }

            if (!files || !files.length) {
                return;
            }

            sequentialUpload(files, 0, [], sequentialUploadCompleted);


        };

        vm.removePhoto = function (idx) {
            vm.banner.Photos.splice(idx, 1);
        }

        function sequentialUpload(files, i, errorsFiles, callback) {
            ReferralBannerService.UploadPhoto(files[i]).then(function (photo) {
                vm.banner.Photos.push(photo.Result);
            }, function (error) {
                errorsFiles.push({ file: files[i], error: error });
            }).then(function () {
                if (files.length === i + 1) {
                    callback(errorsFiles);
                } else {
                    sequentialUpload(files, i + 1, errorsFiles, callback);
                }
            });
        }

        function sequentialUploadCompleted(errorsFiles) {
            var filesNames = [];
            if (errorsFiles && errorsFiles.length) {
                angular.forEach(errorsFiles, function (item) {
                    filesNames.push(errorsFiles.file.name);
                })
            }

            if (filesNames.length) {
                $translate('banner.validate.photo.upload_error', { names: filesNames.join(', ') }).then(function (msg) {
                    alert(msg);
                })
            }
        }
        //#endregion
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('ReferralBannerService', ReferralBannerService);

    /** @ngInject */
    function ReferralBannerService(SVCS, $http, $q, CoreService) {
        var profileServer = SVCS.Profile;
        var gatewayServer = SVCS.Gateway;

        var service = {
           
            Get: Get,
            Search: Search,
            Create: Create,
            Update: Update,
            Remove: Remove,
            UploadPhoto: UploadPhoto
        };

        return service;

      

        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/profiles/GetReferralBannerById/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/profiles/GetAllReferralBanner', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(banner) {
            var deferer = $q.defer();

            CoreService.Post(profileServer + '/api/profiles/CreateReferralBanner', banner).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(banner) {
            var deferer = $q.defer();
         
            CoreService.Post(profileServer + '/api/profiles/UpdateReferralBanner', banner).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Remove(id) {
            var deferer = $q.defer();

            CoreService.Delete(profileServer + '/api/profiles/DeleteReferralBanner/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        function UploadPhoto(img) {
            var deferer = $q.defer();

            var formData = new FormData();
            formData.append('file', img);

            $http.post(gatewayServer + '/api/photos/uploadReferralBanner', formData, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin').filter('roundup', function () {
            return function (value) {
                return Math.ceil(value);
            };
        })
        .controller('SettlementTransactionSummaryController', SettlementTransactionSummaryController);

    // settlement_transaction.summary.$inject = ['$location'];

    function SettlementTransactionSummaryController(SVCS, SettlementTransactionService, MasterMerchantService, MerchantService, $scope, $state, $window, $location, $translate, TagService) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'settlement_transaction_summary';

        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 4;
        vm.itemsPerPage = 100;
        vm.settlementTransactions = { TransactionIds: [], SummaryIds: [], Date: null, Status: null };
        vm.criteria = { ClientName: null, MerchantId: null, MasterMerchantId: null, Status: null, Date: null, EndDate: null, Page: 1, Length: 100 };
        vm.viewConfig = { ShowDialog: false };

        vm.transactionSummaryItems = [];
        //vm.transactionSummaryItems = [{ MerchantId: null, storeId: null, startDate: null, EndDate: null }];

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.summary('summary');
            }
        }

        vm.reset = function () {
            vm.criteria = { ClientName: null, MerchantId: null, MasterMerchantId: null, Status: null, Date: null, EndDate: null, Page: 1, Length: 100 };

            vm.currentPage = 1;
            vm.summary('summary');
        }

        vm.summary = function (type) {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            SettlementTransactionService.Summary(criteria).then(function (res) {
                vm.transactions = res.Items;
               // console.log(res);
                vm.totalItems = res.Total;

                vm.isCheckAll = false;
                if (type == 'summary') {

                    resetUpdate();
                }
                else {


                    var flag = true;
                    angular.forEach(vm.transactions, function (item) {
                        if (vm.settlementTransactions.TransactionIds.indexOf(item.Id) != -1) {
                            item.IsChecked = true;

                        }
                        else {
                            flag = false;

                        }
                    });
                    if (flag) vm.isCheckAll = true;
                }
            });
        };


        vm.checkAll = function () {
            if (vm.isCheckAll) {
                angular.forEach(vm.transactions, function (item) {
                    item.IsChecked = true;
                    vm.settlementTransactions.TransactionIds.push((item.TransactionIds).split(',').map(parseFloat));
                    vm.settlementTransactions.SummaryIds.push((item.Id));
                });

                vm.isShowCommitButton = true;
            }
            else {
                resetUpdate();
            }
        };

        vm.checkItem = function (transaction) {
            //console.log('transaction:');
            //console.log(transaction);
            if (transaction.IsChecked) {
                vm.settlementTransactions.TransactionIds.push((transaction.TransactionIds).split(',').map(parseFloat));
                vm.settlementTransactions.SummaryIds.push((transaction.Id));

            }
            else {

                var dataset = vm.settlementTransactions.TransactionIds;
                var indexs = [];
                dataset.filter(function (elem, index, array) {
                    if (elem == transaction.TransactionIds) {
                        indexs.push(index);
                    }
                });

                vm.settlementTransactions.TransactionIds.splice(indexs[0], 1);

                vm.settlementTransactions.SummaryIds.removeItem((transaction.Id));

            }

            if (vm.settlementTransactions.TransactionIds.length > 0) {

                vm.isShowCommitButton = true;
            }
            else {
                vm.isShowCommitButton = false;

            }
        };

        vm.openDialog = function () {
            vm.viewConfig.ShowDialog = true;
        };

        vm.save = function () {
            if (!$scope.transactionForm.$valid) {
                angular.forEach($scope.transactionForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    });
                });
                $('#transactionForm .ng-invalid')[0].focus();
                return;
            }


            vm.tempTransactionIds = vm.settlementTransactions.TransactionIds;
            vm.newvalue = [];
            vm.tempTransactionIds.forEach(function (item) {

                item.forEach(function (item1) {
                    vm.newvalue.push(item1);
                });
            });

            vm.settlementTransactions.TransactionIds = vm.newvalue;
            console.log(vm.settlementTransactions);
            SettlementTransactionService.UpdateSummary(vm.settlementTransactions).then(function (res) {
                vm.cancel();
                vm.summary('summary');
            });
        };

        vm.cancel = function () {
            vm.viewConfig.ShowDialog = false;
            vm.settlementTransactions.Date = null;
            vm.settlementTransactions.Status = null;
            $scope.transactionForm.$setPristine();
            $scope.transactionForm.$setUntouched();
        };

        vm.loadMerchant = function (keyword) {          
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = res.Items;
                });
            } else {
                vm.merchants = null;
            }
        }


        function resetUpdate() {
            angular.forEach(vm.transactions, function (item) {
                item.IsChecked = false;
            })
            vm.settlementTransactions = { TransactionIds: [], SummaryIds: [], Date: null, Status: null };
            vm.isShowCommitButton = false;
        }



        vm.summary();


        //get list master merchant
        MasterMerchantService.Search({ Keyword: null }).then(function (res) {
            vm.masterMerchants = res.Items;
            console.log(vm.masterMerchants);
        });




        $scope.getTotal = function () {
            vm.result = { totalamt: null, totalSettlementamt: null, totalMDR: null, totalCount: null };
            vm.result.totalamt = 0;
            vm.result.totalSettlementamt = 0;
            vm.result.totalMDR = 0;
            vm.result.totalCount = 0;
            if (vm.totalItems != null) { 
            for (var i = 0; i < vm.totalItems; i++) {
                var product = vm.transactions[i];
                if (product != null && product != undefined) {
                    vm.result.totalamt += (product.TotalAmount == null || product.TotalAmount == undefined)? 0 : (product.TotalAmount);
                    vm.result.totalSettlementamt += (product.SettlementAmount == null || product.SettlementAmount == undefined) ? 0 :(product.SettlementAmount);
                    vm.result.totalMDR += (product.MDRFee == null || product.MDRFee == undefined) ? 0 :(product.MDRFee);
                    vm.result.totalCount += (product.Count == null || product.Count == undefined) ? 0 :(product.Count);
                }
               
            }
        }
            return vm.result;
        };

        vm.redirectToTransactions = function (transaction) {
            //alert($location.path());
            //alert(window.location);
            //alert(window.location.host);
            //alert(window.location.hostname);
            //alert(window.location.href);

            //alert($location.url('/admin/settlemen-transaction'));
            // $window.open('https://www.google.com', '_blank');
            //  $window.open(window.location.hostname + '/admin/settlemen-transaction', '_blank');

             $state.go('app.admin.settlement-transaction-search', { sDate: transaction.StartDate, eDate: transaction.EndDate, mId: transaction.MerchantId});
            //var url = $state.href('app.admin.settlement-transaction-search', { sDate: transaction.StartDate, eDate: transaction.EndDate, mId: transaction.MerchantId, sId: transaction.StoreId });
            //window.open(url, '_blank');
        };

    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('LeastCostRoutingService', LeastCostRoutingService);

    /** @ngInject */
    function LeastCostRoutingService($q, $http, CoreService, SVCS) {
        var walletServer = SVCS.Wallet;
        var gatewayServer = SVCS.Gateway;
        var service = {
            GetBill: GetBill,
            LoadProductNameBill: LoadProductNameBill,
            SearchBill: SearchBill,
            CreateBill: CreateBill,
            UpdateBill: UpdateBill,
            DeleteBill: DeleteBill,
            ExprortCSVBill: ExprortCSVBill,
            ImportCSVBill: ImportCSVBill,
            GetMobile: GetMobile,
            LoadProductNameMobile: LoadProductNameMobile,
            LoadRequirementMobile: LoadRequirementMobile,
            SearchMobile: SearchMobile,
            CreateMobile: CreateMobile,
            UpdateMobile: UpdateMobile,
            DeleteMobile: DeleteMobile,
            ExprortCSVMobile: ExprortCSVMobile,
            ImportCSVMobile: ImportCSVMobile,
            UploadPhoto: UploadPhoto
        };

        return service;

        function GetBill(id) {
            var deferer = $q.defer();
            $http.get(walletServer + '/api/bills/' + id).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }
        function onselectClient(name) {
            vm.bill.OperatorCode = name;
        }
        function LoadProductNameBill(keyword) {
            var deferer = $q.defer();
            $http.get(walletServer + '/api/bills/billnames/' + keyword).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function SearchBill(criteria) {

            var deferer = $q.defer();
            $http.post(walletServer + '/api/bills/search', criteria).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function CreateBill(bill) {
            var deferer = $q.defer();
           
            CoreService.Post(walletServer + '/api/bills/create', bill).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function UpdateBill(bill) {
            var deferer = $q.defer();

            $http.put(walletServer + '/api/bills/update', bill).then(function (response) {
                deferer.resolve(response);
            })
            return deferer.promise;
        }

        function DeleteBill(id) {
            var deferer = $q.defer();

            $http.delete(walletServer + '/api/bills/' + id).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function ExprortCSVBill(criteria) {
            var deferer = $q.defer();

            $http.post(walletServer + '/api/bills/export-csv', criteria).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function ImportCSVBill(criteria) {
             
            var deferer = $q.defer();
          
            $http.post(walletServer + '/api/bills/import-csv', criteria).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }


        function GetMobile(id) {
          
            var deferer = $q.defer();
            $http.get(walletServer + '/api/mobiles/' + id).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function LoadProductNameMobile() {
            var deferer = $q.defer();
            $http.get(walletServer + '/api/mobiles/mobilenames').then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function LoadRequirementMobile() {
            var deferer = $q.defer();
            $http.get(walletServer + '/api/mobiles/requirement').then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function SearchMobile(criteria) {
             
            var deferer = $q.defer();
            $http.post(walletServer + '/api/mobiles/search', criteria).then(function (response) {
                deferer.resolve(response);
            });
            return deferer.promise;
        }

        function CreateMobile(mobile) {
            var deferer = $q.defer();

            CoreService.Post(walletServer + '/api/mobiles/create', mobile).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function UpdateMobile(mobile) {
            var deferer = $q.defer();
           
            $http.put(walletServer + '/api/mobiles/update', mobile).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function DeleteMobile(id) {
            var deferer = $q.defer();

            $http.delete(walletServer + '/api/mobiles/' + id).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function ExprortCSVMobile(criteria) {
            var deferer = $q.defer();

            $http.post(walletServer + '/api/mobiles/export-csv', criteria).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function ImportCSVMobile(criteria) {
            var deferer = $q.defer();

            $http.post(walletServer + '/api/mobiles/import-csv', criteria).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }
        function UploadPhoto(img) {
            var deferer = $q.defer();

            var formData = new FormData();
            formData.append('file', img);

            $http.post(gatewayServer + '/api/photos/partnerLogoUpload', formData, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .directive('isMobileOperatorAvailable', isMobileOperatorAvailable)
        .directive('isBillPaymentAvailable', isBillPaymentAvailable);

    /** @ngInject **/
    function isMobileOperatorAvailable($q, $http, $timeout, SVCS) {
        return {
            require: 'ngModel',

            link: function (scope, elm, attrs, ctrl) {

                var checkingTask = null;

                var baseUrl = SVCS.Wallet;

                ctrl.$asyncValidators.isMobileOperatorAvailable = function (modelValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return $q.when();
                    }

                    
                    var id = scope.$eval(attrs.isMobileOperatorAvailable);

                    var def = $q.defer();

                    if (checkingTask != null) {
                        $timeout.cancel(checkingTask);
                        checkingTask = null;
                    }

                    if (attrs.ngModel == "vm.mobile.Code") {
                        var code = modelValue;
                    }

                    checkingTask = $timeout(function () {
                        $http.post(baseUrl + '/api/mobiles/is-mobile-operator-available', { Id: id, Code: code}).then(function (response) {
                            if (response.data) {
                                def.resolve();
                            } else {
                                def.reject();
                            }
                        }, function (responseError) {
                            def.reject();
                        })
                    }, 500)

                    return def.promise;
                };
            }
        };
    }

    function isBillPaymentAvailable($q, $http, $timeout, SVCS) {
        return {
            require: 'ngModel',

            link: function (scope, elm, attrs, ctrl) {

                var checkingTask = null;

                var baseUrl = SVCS.Wallet;

                ctrl.$asyncValidators.isBillPaymentAvailable = function (modelValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return $q.when();
                    }

                    var id = scope.$eval(attrs.isBillPaymentAvailable);

                    var def = $q.defer();

                    if (checkingTask != null) {
                        $timeout.cancel(checkingTask);
                        checkingTask = null;
                    }

                    if (attrs.ngModel == "vm.bill.Code") {
                        var code = modelValue;
                    }

                    checkingTask = $timeout(function () {
                        $http.post(baseUrl + '/api/bills/is-bill-payment-available', { Id: id, Code: code}).then(function (response) {
                            if (response.data) {
                                def.resolve();
                            } else {
                                def.reject();
                            }
                        }, function (responseError) {
                            def.reject();
                        })
                    }, 500)

                    return def.promise;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('LeastCostRoutingController', LeastCostRoutingController);

    /** @ngInject */
    function LeastCostRoutingController(SVCS, $translate, $scope, $timeout, $window, LeastCostRoutingService) {
        var vm = this;


        vm.totalItemsBill = 0;
        vm.currentPageBill = 1;
        vm.maxSizeBill = 5;
        vm.itemsPerPageBill = 10;

        vm.totalItemsMobile = 0;
        vm.currentPageMobile = 1;
        vm.maxSizeMobile = 5;
        vm.itemsPerPageMobile = 10;
        vm.billlistView = false;
        vm.disabledUnit = false;
        vm.ChangePartner = function () {
            vm.disabledUnit = false;
            if (vm.bill.LCRPartner == "PTPTN") {
                vm.disabledUnit = true;
                vm.bill.Unit = "rm"
            };
        }
        vm.view = {
            AddOrEditBillPayment: false,
            ImportCSVBillPayment: false,
            AddOrEditMobileReload: false,
            ImportCSVMobileReload: false,
            ActionBillPayment: null,
            ActionMobileReload: null
        };

        vm.lcrpartner = [
            { Id: "payhub", Name: 'Pay Hub' },
            { Id: "mobilityone", Name: 'Mobility One' },
            { Id: "ptptn", Name: 'PTPTN' }
        ]

        vm.onselectClient = function (e, name) {
            vm.billlistView = false;
            vm.bill.OperatorCode = name;
            vm.billnames = null;
            e.preventDefault();
        };

        vm.disablelist = function () {
            vm.billnames = null;
        };
        //#region Bill Payment
        vm.loadBillInfo = function () {
            //if (vm.view.ActionBillPayment == "new") {

            var keyword = vm.bill.OperatorCode;
            if (keyword.length >= 2) {
                LeastCostRoutingService.LoadProductNameBill(keyword).then(function (res) {

                    if (res.data.length > 0) {
                        vm.billlistView = true;
                    }
                    else {
                        vm.billlistView = false;
                    }
                    vm.billnames = res.data;

                });
            } else {
                vm.billnames = null;
            }
            //}
            //if (vm.view.ActionBillPayment == "edit") {
            //    var keyword = null;
            //    vm.billlistView = false;
            //    vm.billnames = null;
            //    LeastCostRoutingService.LoadProductNameBill(keyword).then(function (res) {
            //        vm.bill.OperatorCode = res.data[0];
            //    });
            //}
        }
        //vm.loadBillInfo = function () {
        //    LeastCostRoutingService.LoadProductNameBill().then(function (res) {
        //        vm.billnames = res.data;
        //    });
        //};

        vm.loadBillRequirement = function () {
            LeastCostRoutingService.LoadRequirementMobile().then(function (res) {
                vm.billrequirements = res.data;
            });
        };

        vm.getTemplateCSVBillPayment = function () {
            var criteria = vm.criteriaBillPayment;
            criteria.Page = vm.currentPageBill;

            LeastCostRoutingService.ExprortCSVBill(criteria).then(function (res) {
                var anchor = angular.element('<a/>');
                anchor.attr({
                    href: 'data:attachment/csv;charset=utf-8,' + encodeURI(res.data),
                    target: '_blank',
                    download: 'bill-payment-template.csv'
                })[0].click();
            })
        }

        vm.criteriaBillPayment = {
            LCRPartner: null,
            Keyword: null,
            Page: 1,
            Length: 10
        }

        vm.addBillPayment = function () {
            vm.view.AddOrEditBillPayment = true;
            vm.view.ActionBillPayment = "new";
            vm.bill = {};
            vm.bill.Unit = "";
            vm.bill.LogoURL = [];
            //  vm.loadBillInfo();
            vm.billlistView = false;
            vm.billnames = null;
            vm.loadBillRequirement();
        }

        vm.editBillPayment = function (id) {
            vm.view.AddOrEditBillPayment = true;
            vm.view.ActionBillPayment = "edit";
            LeastCostRoutingService.GetBill(id).then(function (res) {
                vm.bill = res.data;

                vm.disabledUnit = false;
                vm.bill.Unit == "%" ? vm.bill.Unit = "" : vm.bill.Unit = "rm";
                if (vm.bill.LCRPartner == "PTPTN") {
                    vm.disabledUnit = true;
                    vm.bill.Unit = "rm"
                };
                vm.billlistView = false;
                vm.billnames = null;
                if (res.data.LogoURL == null && res.data.LogoURL.length <= 0) {
                    vm.bill.LogoURL = [];
                }
                let selectedValues = vm.bill.Requisite.split(',').map(function (item) {
                    return item.trim();
                });
                vm.bill.Requisite = selectedValues;
                vm.loadBillRequirement();
                //   vm.loadBillInfo();
            })
        }

        vm.deleteBillPayment = function (id) {

            var message = 'Are you sure you want to remove this bill payment ?';
            var confirm = window.confirm(message);
            if (!confirm) {
                return;
            }

            LeastCostRoutingService.DeleteBill(id).then(function (res) {
                vm.searchBillPayment();
            })
        }

        vm.importBillPayment = function () {
            vm.view.ImportCSVBillPayment = true;
        }

        var errorTypeBill = 0;
        vm.checkRowBill = function (data) {

            if (isNaN(parseInt(data[4]))) {
                errorTypeBill = 4;
                return false;
            }

            return true;
        }

        vm.saveimportBillPayment = function () {
            if (!vm.fileContentBillPayment && vm.view.ImportCSVBillPayment) {
                alert("Please choose a csv file.");
            }
            else {
                var invalid = false;

                var title = ["Id", "Requirement", "OperatorCode", "ProductCode", "ProductSubCode", "CommissionRate", "CommissionRateUnit", "LCRPartner"];

                angular.forEach(vm.fileContentBillPayment.split("\n"), function (row, index) {
                    var char = "";
                    if (row.indexOf(";") !== -1) {
                        char = ";";
                    }
                    else {
                        char = ",";
                    }

                    var data = row.split(char);


                    data.forEach(function (item, index) {
                        data[index] = item.trim();
                    })

                    if (index == 0) {
                        if (!angular.equals(title, data)) {
                            invalid = true;
                            alert("The title is invalid. (" + title + ")");
                        }
                    } else {
                        if (data.length == 8) {
                            if (!vm.checkRowBill(data)) {
                                invalid = true;
                                var base_message = "Data of row " + index + " is invalid.\n";
                                var message = base_message;

                                switch (errorTypeBill) {
                                    case 1:
                                        message = base_message + "Requirement (" + data[1] + ") is invalid.";
                                        break;
                                    case 2:
                                        message = base_message + "OperatorCode (" + data[2] + ") is invalid.";
                                        break;
                                    case 3:
                                        message = base_message + "ProductCode (" + data[3] + ") is invalid.";
                                        break;
                                    case 4:
                                        message = base_message + "ProductSubCode (" + data[4] + ") is invalid.";
                                        break;
                                    case 5:
                                        message = base_message + "CommissionRate (" + data[5] + ") is invalid.";
                                        break;
                                    case 6:
                                        message = base_message + "CommissionRateUnit (" + data[5] + ") is invalid.";
                                        break;
                                    case 7:
                                        message = base_message + "LCRPartner (" + data[6] + ") is invalid.";
                                        break;
                                }
                                alert(message);
                            }
                        }
                    }
                });

                if (!invalid) {
                    var model = [];

                    angular.forEach(vm.fileContentBillPayment.split("\n"), function (row, index) {
                        var char = "";
                        if (row.indexOf(";") !== -1) {
                            char = ";";
                        }
                        else {
                            char = ",";
                        }
                        var data = row.split(char);
                        if (index != 0 && data.length == 7) {
                            model.push({
                                "Id": data[0],
                                "OperatorCode": data[1],
                                "ProductCode": data[2],
                                "ProductSubCode": data[3],
                                "CommissionRate": data[4],
                                "CommissionRateUnit": data[5],
                                "LCRPartner": data[6]
                            });
                        }
                    });
                    debugger;
                    LeastCostRoutingService.ImportCSVBill(model).then(function (data) {

                        $timeout(function () {
                            vm.view.ImportCSVBillPayment = false;
                            vm.resetBillPayment();

                            $('input[type=file]').val(null);

                            alert("Successful");
                        }, 500);
                    });
                }

            }
        }

        vm.clearForm = function (billPaymentForm) {
            vm.bill = {};

            billPaymentForm.$setUntouched();
            billPaymentForm.$setPristine();
        }

        vm.saveBillPayment = function (billPaymentForm) {
            if (!billPaymentForm.$valid) {
                angular.forEach(billPaymentForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#billPaymentForm .ng-invalid')[0].focus();
                return;
            }

            if (vm.view.ActionBillPayment == 'new') {

                vm.bill.Unit == "" ? vm.bill.Unit = "%" : vm.bill.Unit = "RM";
                vm.bill.Requisite = vm.bill.Requisite.toString();
                LeastCostRoutingService.CreateBill(vm.bill).then(function (res) {

                    if (!res.Success) {
                        alert("Add new failed. The product already exists or code already exists !");
                    }
                    else {
                        vm.view.ActionBillPayment = null;
                        vm.view.AddOrEditBillPayment = false;
                        vm.searchBillPayment();
                        vm.loadBillRequirement();
                        vm.clearForm(billPaymentForm);
                    }
                })
            }
            else if (vm.view.ActionBillPayment == 'edit') {

                vm.bill.Unit == "" ? vm.bill.Unit = "%" : vm.bill.Unit = "RM";
                vm.bill.Requisite = vm.bill.Requisite.toString();
                LeastCostRoutingService.UpdateBill(vm.bill).then(function (res) {

                    if (!res.data.Success) {
                        alert("Edit failed. The product already exists or code already exists !");
                    }
                    else {
                        vm.view.ActionBillPayment = null;
                        vm.view.AddOrEditBillPayment = false;
                        vm.searchBillPayment();
                        vm.clearForm(billPaymentForm);
                    }
                })
            }
        }

        vm.searchByKeywordBillPayment = function ($event) {
            if ($event.which == 13) {
                vm.searchBillPayment();
            }
        }

        vm.searchBillPayment = function () {
            var criteria = vm.criteriaBillPayment;
            criteria.Page = vm.currentPageBill;

            LeastCostRoutingService.SearchBill(criteria).then(function (res) {
                vm.bills = res.data.Items;
                vm.totalItemsBill = res.data.Total;
            })
        }

        vm.resetBillPayment = function () {
            vm.criteriaBillPayment = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.searchBillPayment();
            vm.loadBillRequirement();
        }

        vm.searchBillPayment();

        //#endregion

        //#region Mobile Reload

        vm.productType = [
            { Id: "PINless", Name: 'PINless' },
            { Id: "PIN Code", Name: 'PIN Code' }
        ]

        vm.ProductTypeValue = function () {
            vm.ProductType = $("#ProductType").val();
            if (vm.ProductType == "string:PIN Code") {
                $("#divProductRequirement").show();
            }
            else {
                $("#divProductRequirement").hide();
            }
        };

        vm.loadRequirement = function () {
            LeastCostRoutingService.LoadRequirementMobile().then(function (res) {
                vm.requirements = res.data;
            });
        };
        //vm.reqTransform = function (newReq) {
        //    return {
        //        Id: null,
        //        Name: newReq
        //    };
        //};
        vm.loadMobileInfo = function () {
            LeastCostRoutingService.LoadProductNameMobile().then(function (res) {
                vm.mobilenames = res.data;
            });
        };

        vm.getTemplateCSVMobileReload = function () {
            var criteria = vm.criteriaMobileReload;
            criteria.Page = vm.currentPageMobile;

            LeastCostRoutingService.ExprortCSVMobile(criteria).then(function (res) {
                var anchor = angular.element('<a/>');
                anchor.attr({
                    href: 'data:attachment/csv;charset=utf-8,' + encodeURI(res.data),
                    target: '_blank',
                    download: 'mobile-reload-template.csv'
                })[0].click();
            })
        }

        vm.criteriaMobileReload = {
            LCRPartner: null,
            Keyword: null,
            Page: 1,
            Length: 10
        }

        vm.addMobileReload = function () {
            vm.view.AddOrEditMobileReload = true;
            vm.view.ActionMobileReload = "new";
            vm.mobile = {};
            vm.mobile.Unit = "";
            vm.loadMobileInfo();
            vm.loadRequirement();
        }

        vm.editMobileReload = function (id) {
            vm.view.AddOrEditMobileReload = true;
            vm.view.ActionMobileReload = "edit";
            LeastCostRoutingService.GetMobile(id).then(function (res) {
                vm.mobile = res.data;
                vm.ProductType = vm.mobile.ProductType;
                if (vm.ProductType == "PIN Code") {
                    $("#divProductRequirement").show();
                }
                else {
                    $("#divProductRequirement").hide();
                }
                vm.mobile.Unit == "%" ? vm.mobile.Unit = "" : vm.mobile.Unit = "rm";
                let selectedValues = vm.mobile.Requisite.split(',').map(function (item) {
                    return item.trim();
                });
                vm.mobile.Requisite = selectedValues;
                vm.loadMobileInfo();
                vm.loadRequirement();
            })
        }

        vm.deleteMobileReload = function (id) {

            var message = 'Are you sure you want to remove this mobile payment ?';
            var confirm = window.confirm(message);
            if (!confirm) {
                return;
            }

            LeastCostRoutingService.DeleteMobile(id).then(function (res) {
                vm.searchMobileReload();
            })
        }

        vm.importMobileReload = function () {
            vm.view.ImportCSVMobileReload = true;
        }

        var errorTypeMobile = 0;
        vm.checkRowMobile = function (data) {

            if (isNaN(parseInt(data[4]))) {
                errorTypeMobile = 4;
                return false;
            }

            if (isNaN(parseInt(data[5]))) {
                errorTypeMobile = 5;
                return false;
            }

            return true;
        }

        function CSVtoArray(text) {
            var re_valid = /^\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*(?:,\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*)*$/;
            var re_value = /(?!\s*$)\s*(?:'([^'\\]*(?:\\[\S\s][^'\\]*)*)'|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,'"\s\\]*(?:\s+[^,'"\s\\]+)*))\s*(?:,|$)/g;
            if (!re_valid.test(text)) return null;
            var a = [];
            text.replace(re_value,
                function (m0, m1, m2, m3) {
                    if (m1 !== undefined) a.push(m1.replace(/\\'/g, "'"));
                    else if (m2 !== undefined) a.push(m2.replace(/\\"/g, '"'));
                    else if (m3 !== undefined) a.push(m3);
                    return '';
                });
            if (/,\s*$/.test(text)) a.push('');
            return a;
        };

        vm.saveimportMobileReload = function () {
            if (!vm.fileContentMobileReload && vm.view.ImportCSVMobileReload) {
                alert("Please choose a csv file.");
            }
            else {
                var invalid = false;

                var title = ["Id", "OperatorCode", "ProductCode", "ProductSubCode", "CostPrice", "CommissionRate", "CommissionRateUnit", "LCRPartner"];

                angular.forEach(vm.fileContentMobileReload.split("\n"), function (row, index) {
                    var char = "";
                    if (row.indexOf(";") !== -1) {
                        char = ";";
                    }
                    else {
                        char = ",";
                    }

                    var data = row.split(char);

                    data.forEach(function (item, index) {
                        data[index] = item.trim();
                    })

                    if (index == 0) {
                        if (!angular.equals(title, data)) {
                            invalid = true;
                            alert("The title is invalid. (" + title + ")");
                        }
                    } else {
                        if (data.length == 8) {
                            if (!vm.checkRowMobile(data)) {
                                invalid = true;
                                var base_message = "Data of row " + index + " is invalid.\n";
                                var message = base_message;

                                switch (errorTypeMobile) {
                                    case 1:
                                        message = base_message + "OperatorCode (" + data[1] + ") is invalid.";
                                        break;
                                    case 2:
                                        message = base_message + "ProductCode (" + data[2] + ") is invalid.";
                                        break;
                                    case 3:
                                        message = base_message + "ProductSubCode (" + data[3] + ") is invalid.";
                                        break;
                                    case 4:
                                        message = base_message + "CostPrice (" + data[4] + ") is invalid.";
                                        break;
                                    case 5:
                                        message = base_message + "CommissionRate (" + data[5] + ") is invalid.";
                                        break;
                                    case 6:
                                        message = base_message + "CommissionRateUnit (" + data[4] + ") is invalid.";
                                        break;
                                    case 7:
                                        message = base_message + "LCRPartner (" + data[5] + ") is invalid.";
                                        break;
                                }
                                alert(message);
                            }
                        }
                    }
                });

                if (!invalid) {
                    var model = [];

                    angular.forEach(vm.fileContentMobileReload.split("\n"), function (row, index) {
                        var char = "";
                        if (row.indexOf(";") !== -1) {
                            char = ";";
                        }
                        else {
                            char = ",";
                        }

                        var data = CSVtoArray(row);

                        if (index != 0 && data.length == 8) {
                            model.push({
                                "Id": data[0],
                                "OperatorCode": data[1],
                                "ProductCode": data[2],
                                "ProductSubCode": data[3],
                                "CostPrice": data[4],
                                "CommissionRate": data[5],
                                "CommissionRateUnit": data[6],
                                "LCRPartner": data[7]
                            });
                        }
                    });

                    LeastCostRoutingService.ImportCSVMobile(model).then(function (data) {
                        $timeout(function () {
                            vm.view.ImportCSVMobileReload = false;
                            vm.resetMobileReload();

                            $('input[type=file]').val(null);

                            alert("Successful");
                        }, 500);
                    });
                }

            }
        }

        vm.clearForm = function (mobileReloadForm) {
            vm.mobile = {};

            mobileReloadForm.$setUntouched();
            mobileReloadForm.$setPristine();
        }

        vm.saveMobileReload = function (mobileReloadForm) {
            if (!mobileReloadForm.$valid) {
                angular.forEach(mobileReloadForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#mobileReloadForm .ng-invalid')[0].focus();
                return;
            }

            if (vm.view.ActionMobileReload == 'new') {
                vm.mobile.Unit == "" ? vm.mobile.Unit = "%" : vm.mobile.Unit = "RM";
                if (vm.ProductType == "PIN Code") {
                    vm.mobile.Requisite = vm.mobile.Requisite.toString();
                } else {
                    vm.mobile.Requisite = "";
                }
                LeastCostRoutingService.CreateMobile(vm.mobile).then(function (res) {

                    if (!res.Success) {

                        alert("Add new failed. The product already exists or code already exists !!!");
                    }
                    else {
                        vm.view.ActionMobileReload = null;
                        vm.view.AddOrEditMobileReload = false;
                        vm.searchMobileReload();
                        vm.clearForm(mobileReloadForm);
                    }

                })
            }
            else if (vm.view.ActionMobileReload == 'edit') {

                vm.mobile.Unit == "" ? vm.mobile.Unit = "%" : vm.mobile.Unit = "RM";
                if (vm.ProductType == "PIN Code") {
                    vm.mobile.Requisite = vm.mobile.Requisite.toString();
                } else {
                    vm.mobile.Requisite = "";
                }

                LeastCostRoutingService.UpdateMobile(vm.mobile).then(function (res) {
                    if (!res.data.Success) {

                        alert("Edit failed. The product already exists or code already exists !!!");
                    }
                    else {
                        vm.view.ActionMobileReload = null;
                        vm.view.AddOrEditMobileReload = false;
                        vm.searchMobileReload();
                        vm.clearForm(mobileReloadForm);
                    }
                })
            }
        }

        vm.searchByKeywordMobileReload = function ($event) {
            if ($event.which == 13) {
                vm.searchMobileReload();
            }
        }

        vm.searchMobileReload = function () {
            var criteria = vm.criteriaMobileReload;
            criteria.Page = vm.currentPageMobile;
            LeastCostRoutingService.SearchMobile(criteria).then(function (res) {
                vm.mobiles = res.data.Items;
                vm.totalItemsMobile = res.data.Total;
            })
        }

        vm.resetMobileReload = function () {
            vm.criteriaMobileReload = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.searchMobileReload();
        }

        vm.searchMobileReload();

        //#endregion
        //#region Upload photos
        vm.temp = {};
        vm.uploadPhoto = function (files, invalidFiles) {

            if (invalidFiles.length) {
                $translate('banner.validate.photo.file_invalid', { name: invalidFiles[0].name }).then(function (msg) {
                    alert(msg);
                })
                return;
            }

            if (!files || !files.length) {
                return;
            }

            sequentialUpload(files, 0, [], sequentialUploadCompleted);


        };

        vm.removePhoto = function (idx) {
            vm.bill.LogoURL.splice(idx, 1);
        }

        function sequentialUpload(files, i, errorsFiles, callback) {
            LeastCostRoutingService.UploadPhoto(files[i]).then(function (photo) {
                vm.bill.LogoURL.push(photo.Result);
            }, function (error) {
                errorsFiles.push({ file: files[i], error: error });
            }).then(function () {
                if (files.length === i + 1) {
                    callback(errorsFiles);
                } else {
                    sequentialUpload(files, i + 1, errorsFiles, callback);
                }
            });
        }

        function sequentialUploadCompleted(errorsFiles) {
            var filesNames = [];
            if (errorsFiles && errorsFiles.length) {
                angular.forEach(errorsFiles, function (item) {
                    filesNames.push(errorsFiles.file.name);
                })
            }

            if (filesNames.length) {
                $translate('banner.validate.photo.upload_error', { names: filesNames.join(', ') }).then(function (msg) {
                    alert(msg);
                })
            }
        }
        //#endregion

    }

})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('PromotionService', PromotionService);

    /** @ngInject */
    function PromotionService(SVCS, $http, $q, CoreService) {
        var promotionServer = SVCS.Promotion;

        var service = {
            All: All,
            Get: Get,
            Search: Search,
            Create: Create,
            Update: Update,
            Delete: Delete,
            Active: Active,
            InActive: InActive
        };

        return service;

        function All() {
            var deferer = $q.defer();

            CoreService.Get(promotionServer + '/api/referral-code').then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(promotionServer + '/api/referral-code/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Get(promotionServer + '/api/referral-code/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(referralCode) {
            var deferer = $q.defer();

            CoreService.Post(promotionServer + '/api/referral-code', referralCode).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(referralCode) {
            var deferer = $q.defer();

            CoreService.Put(promotionServer + '/api/referral-code', referralCode).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Delete(id) {
            var deferer = $q.defer();

            CoreService.Delete(promotionServer + '/api/referral-code/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Active(id) {
            var deferer = $q.defer();
            var model = { Id: id };
            CoreService.Put(promotionServer + '/api/referral-code/active', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function InActive(id) {
            var deferer = $q.defer();
            var model = { Id: id };
            CoreService.Put(promotionServer + '/api/referral-code/inactive', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .directive('referralCodeInvalid', referralCodeInvalid)
        .directive('ngMinOrZero', ngMinOrZero);

    /** @ngInject **/
    function referralCodeInvalid($q, $http, $timeout, SVCS) {
        return {
            require: 'ngModel',

            link: function (scope, elm, attrs, ctrl) {

                var checkingTask = null;

                var baseUrl = SVCS.Promotion;

                ctrl.$asyncValidators.referralCodeInvalid = function (modelValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return $q.when();
                    }

                    var def = $q.defer();

                    if (checkingTask != null) {
                        $timeout.cancel(checkingTask);
                        checkingTask = null;
                    }

                    var id = scope.$eval(attrs.referralCodeInvalid);

                    checkingTask = $timeout(function () {
                        $http.post(baseUrl + '/api/referral-code/duplicate-check', { Id: id, ReferralCode: modelValue}).then(function (response) {
                            if (response.data) {
                                def.reject();
                            } else {
                                def.resolve();
                            }
                        }, function (responseError) {
                            def.reject();
                        })
                    }, 500)

                    return def.promise;
                };
            }
        };
    }

    function isEmpty(value) {
        return angular.isUndefined(value) || value === '' || value === null || value !== value;
    }

    /** @ngInject **/
    function ngMinOrZero() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elem, attr, ctrl) {
                scope.$watch(attr.ngMinOrZero, function () {
                    ctrl.$setViewValue(ctrl.$viewValue);
                });
                var minValidator = function (value) {
                    var min = scope.$eval(attr.ngMinOrZero) || 0;
                    if ((!isEmpty(value) && value < min)) {
                        if (value == 0) {
                            ctrl.$setValidity('ngMinOrZero', true);
                            return value;
                        }
                        else {
                            ctrl.$setValidity('ngMinOrZero', false);
                            return undefined;
                        }
                    } else {
                        ctrl.$setValidity('ngMinOrZero', true);
                        return value;
                    }
                };

                ctrl.$parsers.push(minValidator);
                ctrl.$formatters.push(minValidator);
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('PromotionController', PromotionController);

    /** @ngInject */
    function PromotionController(SVCS, $translate, PromotionService, $scope, MerchantService, VoucherService) {
        var vm = this;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;
        vm.referralCode = {};
        vm.criteria = { Keyword: null, Page: 1, Length: 10 };
        vm.viewConfig = { ShowDialog: false, Action: null };

        vm.rewards = [
            { Id: "KipleKash", Name: "KipleKash" },
            { Id: "StoreCard", Name: "StoreCard" },
            { Id: "ReferralVoucher", Name: "ReferralVoucher" }
        ];

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            PromotionService.Search(criteria).then(function (res) {
                vm.referralCodes = res.Items;
                vm.totalItems = res.Total;

                // Get merchant name
                MerchantService.GetAllMerchantsPublicInfo().then(function (res) {
                    vm.merchants = res;
               
                    angular.forEach(vm.referralCodes, function (referralCode) {
                        for (var i = 0; i < vm.merchants.length; i++) {
                            if (referralCode.MerchantId == vm.merchants[i].Id) {
                                referralCode.MerchantName = vm.merchants[i].Name;
                            }
                        }
                    });
                })
            })
        }

        vm.reset = function () {
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }

        vm.clearForm = function () {
            vm.referralCode = {};

            $scope.registerCodeForm.$setPristine();
            $scope.registerCodeForm.$setUntouched();
        }

        vm.openDialog = function (action, referralCode) {
            vm.viewConfig.Action = action;
            vm.clearForm();
            vm.referralCode = {
                MerchantId: '',
                ValidityPeriod: null,
                MaxQuantity: 0,
                UsedQuantity: 0
            };

            if (action == 'edit') {
                vm.referralCode = angular.copy(referralCode);
                MerchantService.Search({ Keyword: vm.referralCode.MerchantName }).then(function (res) {
                    vm.merchants = res.Items;
                });
                if (vm.referralCode.MerchantId && vm.referralCode.Reward == 'ReferralVoucher') {
                    vm.getVoucherOfMerchant(vm.referralCode.MerchantId);
                    vm.isVoucher = true;
                }
                else {
                    vm.isVoucher = false;
                }

                if (vm.referralCode.MerchantId == null) {
                    vm.referralCode.MerchantId = '';
                }
               
                vm.referralCode.StartDate = new Date(vm.referralCode.StartDate);
                vm.referralCode.EndDate = new Date(vm.referralCode.EndDate);
            }
            vm.viewConfig.ShowDialog = true;
        }

        vm.save = function () {

            if (!$scope.registerCodeForm.$valid) {
                angular.forEach($scope.registerCodeForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#registerCodeForm .ng-invalid')[0].focus();
                return;
            }

            if (vm.viewConfig.Action == 'new') {
                PromotionService.Create(vm.referralCode).then(function (res) {
                    vm.search();
                    vm.cancel();
                })
            }
            else {
                if (vm.referralCode.Reward == 'ReferralVoucher') {
                    vm.referralCode.Amount = 0;
                }
                PromotionService.Update(vm.referralCode).then(function (res) {
                    vm.search();
                    vm.cancel();
                })
            }
        }

        vm.cancel = function () {
            vm.viewConfig.ShowDialog = false;
            //vm.referralCode = undefined;
            vm.Action = null;
        }

        vm.remove = function (referralCode) {
            $translate("admin.promotion.registration_code.confirm_remove").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }

                PromotionService.Delete(referralCode.Id).then(function (res) {
                    vm.referralCodes.removeItem(referralCode)
                });
            })
        }

        // Datepicker popup
        var maxDate = new Date();
        maxDate.setFullYear(maxDate.getFullYear() + 1);
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: maxDate,
            minDate: new Date(),
            startingDay: 1
        };

        vm.dateOptionsEndDate = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: maxDate,
            minDate: new Date(),
            startingDay: 1
        };

        vm.DateChanged = function () {
            vm.dateOptionsEndDate = {
                //dateDisabled: disabled,
                formatYear: 'yy',
                maxDate: maxDate,
                minDate: vm.referralCode.StartDate ? vm.referralCode.StartDate : new Date(),
                startingDay: 1
            };

            if (vm.referralCode.StartDate > vm.referralCode.EndDate) {
                vm.referralCode.EndDate = vm.referralCode.StartDate;
            }
        }

        // Disable weekend selection
        function disabled(data) {
            var date = data.date,
                mode = data.mode;
            return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
        }

        vm.openExpireDatePopup = function () {
            vm.expireDatePopup.opened = true;
        };
        vm.openStartDatePopup = function () {
            vm.StartDatePopup.opened = true;
        };
        vm.openEndDatePopup = function () {
            vm.EndDatePopup.opened = true;
        };

        vm.expireDatePopup = {
            opened: false
        };
        vm.StartDatePopup = {
            opened: false
        };
        vm.EndDatePopup = {
            opened: false
        };
        // Datepicker popup

        vm.rewardChange = function (reward) {
            if (reward == 'ReferralVoucher') {
                vm.isVoucher = true;
            } else {
                vm.isVoucher = false;
            }
        }

        vm.getVoucherOfMerchant = function (merchantId) {
            if (merchantId != '' && merchantId != null) {
                vm.criteriaVoucher = {
                    Keyword: null,
                    Category: null,
                    MerchantId: merchantId,
                    Page: null,
                    Length: null
                };

                VoucherService.Search(vm.criteriaVoucher).then(function (res) {
                    vm.vouchers = res.Items;
                });
            } else
            {
                vm.criteriaVoucher = {
                    Keyword: null,
                    Category: null,
                    MerchantId: null,
                    Page: null,
                    Length: null
                };

                VoucherService.Search(vm.criteriaVoucher).then(function (res) {
                    vm.vouchers = res.Items;
                });

                // check vm.referralCode.Reward = 'StoreCard'
                if (vm.referralCode.Reward == 'StoreCard') {
                    vm.referralCode.Reward = null;
                }
            }
        }

        vm.InActive = function (referralCode) {
            PromotionService.InActive(referralCode.Id).then(function (res) {
                referralCode.Status = 'InActive';
            })
        }

        vm.Active = function (referralCode) {
            PromotionService.Active(referralCode.Id).then(function (res) {
                referralCode.Status = 'Active';
            })
        }

        vm.search();

        vm.loadMerchant = function (keyword) {
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = res.Items;
                });
            } else {
                vm.merchants = null;
            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('MobileNumberChangeController', MobileNumberChangeController);

    /** @ngInject */
    function MobileNumberChangeController(UserService, $scope, UserStatusHashMap, DTOptionsBuilder, DTColumnBuilder, $filter, $q, $numUtils) {
        var vm = this;

        var loc = window.location;
        if (loc.pathname.indexOf('/admin/user/user/detail/') == -1) {
            if (loc.pathname.indexOf('/admin/user/user/wallet/') == -1) {
                if (loc.pathname.indexOf('/admin/user/user/storecard/') == -1) {
                    if (loc.pathname.indexOf('/admin/user/user/transaction/') == -1) {
                        if (loc.pathname.indexOf('/admin/user/user/mobile-number-change/') == -1) {
                            localStorage.setItem("UserMobileSearchCriteria", "");
                        }
                    }
                }
            }
        }

        //#region Search changed mobile number
        vm.criteria = {
            Name: null,
            EmailAddress: null,
            UserName: null,
            OldPhoneNumber: null,
            NewPhoneNumber: null,
            Partner: null,
            Page: 1,
            Length: 10,
            Csvfrom: 1,
            CsvTo: 10,
            StartDate: null,
            EndDate: null,
            Email: null

        };
        vm.EmailToSend = null;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 3;
        vm.ItemsCount = 0;
        vm.resetPage = function () {
            vm.criteria = {
                Name: null,
                EmailAddress: null,
                Status: null,
                Partner: null,
                UserName: null,
                OldPhoneNumber: null,
                NewPhoneNumber: null,
                Tag: null,
                Page: 1,
                Length: 10,
                Csvfrom: 1,
                CsvTo: 10,
                StartDate: null,
                EndDate: null,
                Email: null

            };
            localStorage.setItem("UserMobileSearchCriteria", "");
            vm.search();
        }

        vm.AppType = [
            { "Id": 0, "Name": "KiplePay" },
            { "Id": 1, "Name": "KiplePark" },
            { "Id": 5, "Name": "RedPay" },
            { "Id": 2, "Name": "TBFX" },
            { "Id": 4, "Name": "LineClear" }

        ];

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                localStorage.setItem("UserMobileSearchCriteria", "");
                vm.search();
            }
        };

        vm.searchPagination = function () {
            localStorage.setItem("UserMobileSearchCriteria", "");
            vm.search();
        }

        vm.search = function () {
            if (localStorage.getItem("UserMobileSearchCriteria") == "") {
                    var criteria = vm.criteria;
                criteria.Page = vm.currentPage;
                }
            else {
                var criteria = JSON.parse(localStorage.getItem('UserMobileSearchCriteria'));
            }
            var startdate = $("#startdate").val();
            var enddate = $("#enddate").val();
            if (startdate == null || startdate == "") {
                alert("Please select start date");
                return;
            }
            if (enddate == null || enddate == "") {
                alert("Please select end date");
                return;
            }
            UserService.SearchV1(criteria).then(function (data) {
                    vm.EmailToSend = null;
                    localStorage.setItem("UserMobileSearchCriteria", JSON.stringify(criteria));
                    vm.users = data.Items;
                    vm.totalItems = data.Total;
                    vm.ItemsCount = data.Total;
                    vm.criteria = criteria;
                    vm.currentPage = criteria.Page;
                    vm.StartDate = criteria.StartDate;
                    vm.EndDate = criteria.EndDate;
                });
        };

        vm.reset = function () {
            localStorage.setItem("UserMobileSearchCriteria", "");
                vm.search();
        }

        vm.export = function () {
                vm.exportdata();
        }

        vm.exportdata = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            if (criteria.StartDate != null && criteria.EndDate != null) {
                if (criteria.Csvfrom < criteria.CsvTo) {
                    if (criteria.Csvfrom == 0 || criteria.CsvTo == 0) {
                        alert("Csvfrom or CsvTo should not be zero");
                    }
                    else {
                        criteria.Csvfrom = criteria.Csvfrom - 1;
                        UserService.ExportUserMobileChange(criteria);
                    }
                }
                else {
                    alert("Csvfrom should not be greater than CsvTo");
                }
            }
            else {
                alert("Please select start and end date.");
            }

        };

        vm.cancel = function () {
            vm.viewConfig.ShowDialogTest = false;
            vm.EmailToSend = null;

        };

        vm.OpenMailModel = function () {
            var criteria = vm.criteria;
            if ((criteria.StartDate != null) && (criteria.EndDate != null)) {
                vm.viewConfig.ShowDialogTest = true;
                vm.EmailToSend = null;
            }
            else {
                alert("Please select start and end date.");
            }
        }

        vm.sendmail = function () {
            var criteria = vm.criteria;
            criteria.Email = vm.EmailToSend;
            criteria.Csvfrom = criteria.Csvfrom - 1;
                UserService.SendToEmailPhoneNumberChange(criteria).then(function (res) {
            });
            vm.viewConfig.ShowDialogTest = false;
            vm.criteria.Email = null;
        }

        //#endregion
    }

})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('ConfigurationService', ConfigurationService);

    /** @ngInject */
    function ConfigurationService(SVCS, $http, $q) {
        var walletServer = SVCS.Wallet;

        var service = {
            GetAll: GetAll,
            Update: Update
        };

        return service;

        function GetAll() {
            var deferer = $q.defer();

            $http.get(walletServer + '/api/configurations/me')
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function Update(configurations) {
            var deferer = $q.defer();

            $http.put(walletServer + '/api/configurations/me/update', configurations)
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('ConfigurationController', ConfigurationController)
        .directive('currencyInput', function ($filter, $browser) {
            return {
                require: 'ngModel',
                link: function ($scope, $element, $attrs, ngModelCtrl) {
                    var listener = function () {
                        var value = $element.val().replace(/,/g, '')
                        $element.val($filter('number')(value, false))
                    }


                    // This runs when we update the text field
                    ngModelCtrl.$parsers.push(function (viewValue) {
                        return viewValue.replace(/,/g, '');
                    })

                    // This runs when the model gets updated on the scope directly and keeps our view in sync
                    ngModelCtrl.$render = function () {
                        $element.val($filter('number')(ngModelCtrl.$viewValue, false))
                    }

                    $element.bind('change', listener)
                    $element.bind('keydown', function (event) {
                        var key = event.keyCode
                        // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
                        // This lets us support copy and paste too
                        if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40))
                            return
                        $browser.defer(listener) // Have to do this or changes don't get picked up properly
                    })

                    $element.bind('paste cut', function () {
                        $browser.defer(listener)
                    })
                }
            }
        });

    /** @ngInject */

    function ConfigurationController(SVCS, ConfigurationService, $state, $translate, $scope, $timeout) {
        var vm = this;
        vm.configurations = []

        vm.viewModel = {
            Configurations: []
        }

        vm.loading = false;
        vm.loading = {
            SaveConfiguration: false
        }

        vm.item = {
            Name: "",
            Value: "",
        }

        vm.topupOptions = []
        vm.option = {
            Key: null,
            Value: null,
        }

        vm.config = {
            lowBalanceMobilityOne: null,
            lowBalancePayHub: null,
            numberOfDayExpire: null,
            topupAmountMinimun: null,
            gst: null,
            voidableTime: null,
            maxCash: null,
            kipleKashExpired: null,
            storeCardsExpired: null,
            emails: [],
            webCashBaseProcessingFee: null,
            kipleWithdrawChargeFee: null,
            kiplekashMobileReload: false,
            kiplekashBillPayment: false,
            financeEmail: null,
            allowApp: true,
            allowOTS: true,
            PTPTNAmount: null,
            PTPTNFee: null,
            SSPNAmount: null,
            SSPNFee: null,
            SSPNPlusAmount: null,
            SSPNPlusFee: null,
            redPayCardFee: null,
            creditCardFee: null,
            debitCardFee: null,
            ccFeeRate: null,
            cashReloadFee: null,
            cashReloadServiceFee: null,
            minReloadAmount: null,
            maxReloadAmount: null,
            paymentValidity: null,
            show7Eleven: false,
            showKKMart: false,
            showRedPayOTC: false,
            duitNowMinAmount: 0,
            allowLDC: false,
            allowLCC: false,
            // dnPerTxnLimit: null,
            // dnDailyLimit: null,
            // dnMonthlyLimit: null,
        };

        vm.duitNowPartners = [];

        vm.alertTitle = "Success!";
        vm.showMessage = false;
        vm.isSuccess = true;
        vm.doFade = false;
        vm.showVoidableTime = null;

        ConfigurationService.GetAll().then(function (data) {
            vm.configurations = data;
            vm.fetchDuitNowPartners();
            angular.forEach(vm.configurations, function (item) {
                if (item.Name == "KIPLE_KASH_EXPIRED_NOTIFICATION") {
                    vm.config.numberOfDayExpire = parseInt(item.Value);
                }
                else if (item.Name == "MIN_PREPAID_ACCOUNT_BALANCE_MOBILITY_ONE") {
                    vm.config.lowBalanceMobilityOne = parseFloat(item.Value);
                }

                else if (item.Name == "MIN_PREPAID_ACCOUNT_BALANCE_PAY_HUB") {
                    vm.config.lowBalancePayHub = parseFloat(item.Value);
                }

                else if (item.Name == "TOPUP_OPTION_MIN") {
                    vm.config.topupAmountMinimun = parseInt(item.Value);
                }
                else if (item.Name == "GST") {
                    vm.config.gst = parseInt(item.Value);
                }
                else if (item.Name == "VOID_ABLE_TIME") {
                    vm.config.voidableTime = parseInt(item.Value);
                    if (item.Value == 0) {
                        $(".one").prop('checked', true);
                        vm.showVoidableTime = "SameDay";
                    } else {
                        $(".tow").prop('checked', true);
                        $(".hour_value").css("display", "block");
                        vm.config.voidableTime = parseInt(item.Value);
                        vm.showVoidableTime = "HourlyTimeFrame";
                    }
                }
                else if (item.Name == "TIME_AUTO_CANCEL_HOLD") {
                    vm.config.hold = parseInt(item.Value);
                }
                else if (item.Name == "TOPUP_OPTIONS") {
                    var options = item.Value.split(",");
                    angular.forEach(options, function (value) {
                        vm.option.Key = options.indexOf(value);
                        vm.option.Value = parseInt(value);
                        vm.topupOptions.push(vm.option)
                        vm.resetOption()
                    });
                }
                else if (item.Name == "MAX_CASH") {
                    vm.config.maxCash = parseInt(item.Value);
                }
                else if (item.Name == "KIPLE_KASH_EXPIRED") {
                    vm.config.kipleKashExpired = parseInt(item.Value);
                }
                else if (item.Name == "STORE_CARDS_EXPIRED") {
                    vm.config.storeCardsExpired = parseInt(item.Value);
                }
                else if (item.Name == "EMAILS") {
                    var emails = item.Value.split(",");
                    angular.forEach(emails, function (email) {
                        vm.config.emails.push({ Email: email.trim() });
                    });
                }
                else if (item.Name == "WEBCASH_BASE_PROCESSING_FEE") {
                    vm.config.webCashBaseProcessingFee = parseFloat(item.Value);
                }
                else if (item.Name == "KIPLE_WITHDRAW_CHARGE_FEE") {
                    vm.config.kipleWithdrawChargeFee = parseFloat(item.Value);
                } else if (item.Name == "FINANCE_EMAIL") {
                    vm.config.financeEmail = item.Value;
                }
                else if (item.Name == "KIPLEKASH_MOBILE_RELOAD") {
                    if (String(item.Value) == "true")
                        vm.config.kiplekashMobileReload = true;
                    else
                        vm.config.kiplekashMobileReload = false;
                }
                else if (item.Name == "KIPLEKASH_BILL_PAYMENT") {
                    if (String(item.Value) == "true")
                        vm.config.kiplekashBillPayment = true;
                    else
                        vm.config.kiplekashBillPayment = false;
                }
                else if (item.Name == "VISA_CONFIGURATION_APP") {
                    if (String(item.Value) == "true")
                        vm.config.allowApp = true;
                    else
                        vm.config.allowApp = false;
                }
                else if (item.Name == "VISA_CONFIGURATION_OTS") {
                    if (String(item.Value) == "true")
                        vm.config.allowOTS = true;
                    else
                        vm.config.allowOTS = false;
                }
                else if (item.Name == "PTPTN_AMOUNT") {
                    vm.config.PTPTNAmount = parseInt(item.Value);
                }
                else if (item.Name == "PTPTN_FEE") {
                    vm.config.PTPTNFee = parseInt(item.Value);
                }
                else if (item.Name == "SSPN_AMOUNT") {
                    vm.config.SSPNAmount = parseInt(item.Value);
                }
                else if (item.Name == "SSPN_FEE") {
                    vm.config.SSPNFee = parseInt(item.Value);
                }
                else if (item.Name == "SSPN_PLUS_AMOUNT") {
                    vm.config.SSPNPlusAmount = parseInt(item.Value);
                }
                else if (item.Name == "SSPN_PLUS_FEE") {
                    vm.config.SSPNPlusFee = parseInt(item.Value);
                }
                else if (item.Name == "CREDIT_CARD_FEE") {
                    vm.config.creditCardFee = parseInt(item.Value);
                }
                else if (item.Name == "DEBIT_CARD_FEE") {
                    vm.config.debitCardFee = parseInt(item.Value);
                }
                else if (item.Name == "CC_FEE_RATE") {
                    vm.config.ccFeeRate = parseInt(item.Value);
                }
                else if (item.Name == "CASH_RELOAD_FEE") {
                    vm.config.cashReloadFee = parseFloat(item.Value);
                }
                else if (item.Name == "CASH_RELOAD_SERVICE_FEE") {
                    vm.config.cashReloadServiceFee = parseFloat(item.Value);
                }
                else if (item.Name == "MIN_RELOAD_AMOUNT") {
                    vm.config.minReloadAmount = parseInt(item.Value);
                }
                else if (item.Name == "MAX_RELOAD_AMOUNT") {
                    vm.config.maxReloadAmount = parseInt(item.Value);
                }
                else if (item.Name == "PAYMENT_VALIDITY") {
                    vm.config.paymentValidity = parseInt(item.Value);
                }
                else if (item.Name == "SHOW_7ELEVEN_OPTION") {
                    if (String(item.Value) == "true")
                        vm.config.show7Eleven = true;
                    else
                        vm.config.show7Eleven = false;
                }
                else if (item.Name == "SHOW_REDPAYOTC_OPTION") {
                    if (String(item.Value) == "true")
                        vm.config.showRedPayOTC = true;
                    else
                        vm.config.showRedPayOTC = false;
                }
                else if (item.Name == "SHOW_LDC_OPTION") {
                    if (String(item.Value) == "true")
                        vm.config.allowLDC = true;
                    else
                        vm.config.allowLDC = false;
                }
                else if (item.Name == "SHOW_LCC_OPTION") {
                    if (String(item.Value) == "true")
                        vm.config.allowLCC = true;
                    else
                        vm.config.allowLCC = false;
                }
                else if (item.Name == "SHOW_KKMART_OPTION") {
                    if (String(item.Value) == "true") {
                        vm.config.showKKMart = true;
                    }
                    else {
                        vm.config.showKKMart = false;
                    }
                } else if (item.Name == "DUITNOW_MIN_TRANSACTION_AMOUNT") {
                    vm.config.duitNowMinAmount = parseInt(item.Value);
                } /* else if (item.Name == "DUITNOW_PER_TXN_LIMIT") {
                    vm.config.dnPerTxnLimit = parseInt(item.Value);
                  } else if (item.Name == "DUITNOW_DAILY_LIMIT") {
                    vm.config.dnDailyLimit = parseInt(item.Value);
                  } else if (item.Name == "DUITNOW_MONTHLY_LIMIT") {
                    vm.config.dnMonthlyLimit = parseInt(item.Value);
                  } */
            });
        });

        vm.resetOption = function () {
            vm.option = {
                Key: null,
                Value: null
            }
        }

        vm.test = function (v) {
            if (v == 1 && $(".one").is(':checked')) { $(".tow").prop('checked', false); $(".hour_value").css("display", "none"); $(".hour_value").val(0); }
            if (v == 2 && $(".tow").is(':checked')) { $(".one").prop('checked', false); $(".hour_value").css("display", "block"); }
            if ($(".one").is(':checked') == false && $(".tow").is(':checked') == false) { $(".one").prop('checked', true); $(".hour_value").css("display", "none"); $(".hour_value").val(0); }
        }
        vm.save = function () {
            vm.viewModel.Configurations = [];
            vm.loading.SaveConfiguration = true;
            if (vm.config.maxReloadAmount < vm.config.minReloadAmount) {
                alert("Max amount should be less than minimum amount");
                return;
            } else {
                var temp = 0;
                if ($('.one').is(':checked')) { temp = 0; $(".hour_value").val('0') };
                if ($('.tow').is(':checked')) { temp = $('.hour_value').val(); };
                var temp = $(".hour_value").val();
                if ($('.tow').is(':checked') == true && $(".hour_value").val() <= 0) { alert("Hourly Frame must be more than zero!"); return; }

                if (!$scope.configurationForm.$valid) {
                    angular.forEach($scope.configurationForm.$error, function (field) {
                        angular.forEach(field, function (errorField) {
                            errorField.$setTouched();
                        })
                    });

                    if ((vm.config.kiplekashMobileReload == null && vm.config.kiplekashBillPayment == null)) {
                        $('#configurationForm .ng-invalid')[0].focus();
                        return;
                    }
                }

                if (vm.config.lowBalanceMobilityOne == null)
                    vm.config.lowBalanceMobilityOne = "";

                if (vm.config.lowBalancePayHub == null)
                    vm.config.lowBalancePayHub = "";

                if (vm.verifyDuplicate()) {
                    vm.alertTitle = "Error!";
                    vm.isSuccess = false;
                    vm.showMessage = true;
                    $translate('admin.configuration.errors.duplicate_topup_option').then(function (msg) {
                        vm.showAlert(msg);
                    })
                    return;
                }

                vm.item = {
                    Name: "KIPLE_KASH_EXPIRED_NOTIFICATION",
                    Value: vm.config.numberOfDayExpire.toString()
                }

                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "MIN_PREPAID_ACCOUNT_BALANCE_MOBILITY_ONE",
                    Value: vm.config.lowBalanceMobilityOne.toString()
                }

                vm.viewModel.Configurations.push(vm.item);


                vm.item = {
                    Name: "MIN_PREPAID_ACCOUNT_BALANCE_PAY_HUB",
                    Value: vm.config.lowBalancePayHub.toString()
                }

                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "TOPUP_OPTION_MIN",
                    Value: vm.config.topupAmountMinimun.toString()
                }

                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "GST",
                    Value: vm.config.gst.toString()
                }

                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "VOID_ABLE_TIME",
                    Value: temp//vm.config.voidableTime.toString()
                }

                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "TIME_AUTO_CANCEL_HOLD",
                    Value: vm.config.hold.toString()
                }

                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "MAX_CASH",
                    Value: vm.config.maxCash.toString()
                }

                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "KIPLE_KASH_EXPIRED",
                    Value: vm.config.kipleKashExpired.toString()
                }

                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "STORE_CARDS_EXPIRED",
                    Value: vm.config.storeCardsExpired.toString()
                }
                vm.viewModel.Configurations.push(vm.item);
                vm.item = {
                    Name: "KIPLEKASH_MOBILE_RELOAD",
                    Value: vm.config.kiplekashMobileReload.toString()
                }
                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "KIPLEKASH_BILL_PAYMENT",
                    Value: vm.config.kiplekashBillPayment.toString()
                }
                vm.viewModel.Configurations.push(vm.item);
                vm.item = {
                    Name: "VISA_CONFIGURATION_APP",
                    Value: vm.config.allowApp.toString()
                }
                vm.viewModel.Configurations.push(vm.item);
                vm.item = {
                    Name: "VISA_CONFIGURATION_OTS",
                    Value: vm.config.allowOTS.toString()
                }
                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "PTPTN_AMOUNT",
                    Value: vm.config.PTPTNAmount.toString()
                }
                vm.viewModel.Configurations.push(vm.item);
                vm.item = {
                    Name: "PTPTN_FEE",
                    Value: vm.config.PTPTNFee.toString()
                }
                vm.viewModel.Configurations.push(vm.item);
                vm.item = {
                    Name: "SSPN_AMOUNT",
                    Value: vm.config.SSPNAmount.toString()
                }
                vm.viewModel.Configurations.push(vm.item);
                vm.item = {
                    Name: "SSPN_FEE",
                    Value: vm.config.SSPNFee.toString()
                }
                vm.viewModel.Configurations.push(vm.item);
                vm.item = {
                    Name: "SSPN_PLUS_AMOUNT",
                    Value: vm.config.SSPNPlusAmount.toString()
                }
                vm.viewModel.Configurations.push(vm.item);
                vm.item = {
                    Name: "SSPN_PLUS_FEE",
                    Value: vm.config.SSPNPlusFee.toString()
                }
                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "CREDIT_CARD_FEE",
                    Value: vm.config.creditCardFee.toString()
                }
                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "DEBIT_CARD_FEE",
                    Value: vm.config.debitCardFee.toString()
                }
                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "CC_FEE_RATE",
                    Value: vm.config.ccFeeRate.toString()
                }
                vm.viewModel.Configurations.push(vm.item);
                vm.item = {
                    Name: "CASH_RELOAD_FEE",
                    Value: vm.config.cashReloadFee.toString()
                }
                vm.viewModel.Configurations.push(vm.item);
                vm.item = {
                    Name: "CASH_RELOAD_SERVICE_FEE",
                    Value: vm.config.cashReloadServiceFee.toString()
                }
                vm.viewModel.Configurations.push(vm.item);
                vm.item = {
                    Name: "MIN_RELOAD_AMOUNT",
                    Value: vm.config.minReloadAmount.toString()
                }
                vm.viewModel.Configurations.push(vm.item);
                vm.item = {
                    Name: "MAX_RELOAD_AMOUNT",
                    Value: vm.config.maxReloadAmount.toString()
                }
                vm.viewModel.Configurations.push(vm.item);
                vm.item = {
                    Name: "PAYMENT_VALIDITY",
                    Value: vm.config.paymentValidity.toString()
                }
                vm.viewModel.Configurations.push(vm.item);
                vm.item = {
                    Name: "SHOW_7ELEVEN_OPTION",
                    Value: vm.config.show7Eleven.toString()
                }
                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "SHOW_LDC_OPTION",
                    Value: vm.config.allowLDC.toString()
                }
                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "SHOW_LCC_OPTION",
                    Value: vm.config.allowLCC.toString()
                }
                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "SHOW_REDPAYOTC_OPTION",
                    Value: vm.config.showRedPayOTC.toString()
                }
                vm.viewModel.Configurations.push(vm.item);
                vm.item = {
                    Name: "SHOW_KKMART_OPTION",
                    Value: vm.config.showKKMart.toString()
                }
                vm.viewModel.Configurations.push(vm.item);

                var strEmails = ""
                angular.forEach(vm.config.emails, function (item) {
                    if (item !== vm.config.emails[vm.config.emails.length - 1]) {
                        strEmails += item.Email + ",";
                    }
                    else {
                        strEmails += item.Email;
                    }
                });

                vm.item = {
                    Name: "EMAILS",
                    Value: strEmails
                }

                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "WEBCASH_BASE_PROCESSING_FEE",
                    Value: vm.config.webCashBaseProcessingFee.toString()
                }

                vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "KIPLE_WITHDRAW_CHARGE_FEE",
                    Value: vm.config.kipleWithdrawChargeFee.toString()
                }

                vm.viewModel.Configurations.push(vm.item);

                //vm.item = {
                //    Name: "KIPLEKASH_MOBILE_RELOAD",
                //    Value: vm.config.kiplekashMobileReload.toString()
                //}
                //vm.viewModel.Configurations.push(vm.item);

                //vm.item = {
                //    Name: "KIPLEKASH_BILL_PAYMENT",
                //    Value: vm.config.kiplekashBillPayment.toString()
                //}
                //vm.viewModel.Configurations.push(vm.item);

                vm.item = {
                    Name: "FINANCE_EMAIL",
                    Value: vm.config.financeEmail.toString()
                }
                vm.viewModel.Configurations.push(vm.item);

                var strTopupOptions = ""
                angular.forEach(vm.topupOptions, function (item) {

                    if (item !== vm.topupOptions[vm.topupOptions.length - 1]) {
                        strTopupOptions = strTopupOptions + item.Value + ",";
                    }
                    else {
                        strTopupOptions = strTopupOptions + item.Value;
                    }
                });

                vm.item = {
                    Name: "TOPUP_OPTIONS",
                    Value: strTopupOptions
                }

                vm.viewModel.Configurations.push(vm.item);

                vm.viewModel.Configurations.push({
                    Name: "DUITNOW_MIN_TRANSACTION_AMOUNT",
                    Value: vm.config.duitNowMinAmount.toString(),
                });
                /* vm.viewModel.Configurations.push({
                  Name: "DUITNOW_PER_TXN_LIMIT",
                  Value: (vm.config.dnPerTxnLimit || 0).toString(),
                });
                vm.viewModel.Configurations.push({
                  Name: "DUITNOW_DAILY_LIMIT",
                  Value: (vm.config.dnDailyLimit || 0).toString(),
                });
                vm.viewModel.Configurations.push({
                  Name: "DUITNOW_MONTHLY_LIMIT",
                  Value: (vm.config.dnMonthlyLimit || 0).toString(),
                }); */

                angular.forEach(vm.duitNowPartners, function (partner) {
                    var code = partner.name.toUpperCase();
                    vm.viewModel.Configurations.push({
                        Name: "DUIT_NOW_ENABLED_" + code,
                        Value: partner.allowDuitNow.toString(),
                    });
                    vm.viewModel.Configurations.push({
                        Name: "DUIT_NOW_P2P_ENABLED_" + code,
                        Value: partner.allowQR.toString(),
                    });
                    vm.viewModel.Configurations.push({
                        Name: "DUIT_NOW_MINIMUM_AMOUNT_" + code,
                        Value: (partner.minAmount || 0).toString(),
                    });
                    vm.viewModel.Configurations.push({
                        Name: "DUIT_NOW_MINIMUM_FEE_" + code,
                        Value: (partner.feeBelow || 0).toString(),
                    });
                    vm.viewModel.Configurations.push({
                        Name: "DUIT_NOW_MAXIMUM_FEE_" + code,
                        Value: (partner.feeAbove || 0).toString(),
                    });
                    vm.viewModel.Configurations.push({
                        Name: "DUIT_NOW_TRANSFER_ENABLED_" + code,
                        Value: partner.allowDNTransfer.toString(),
                    });
                    vm.viewModel.Configurations.push({
                        Name: "DUIT_NOW_TRANSFER_MINIMUM_AMOUNT_" + code,
                        Value: (partner.minAmountDNTransfer || 0).toString(),
                    });
                    vm.viewModel.Configurations.push({
                        Name: "DUIT_NOW_TRANSFER_MINIMUM_FEE_" + code,
                        Value: (partner.feeBelowDNTransfer || 0).toString(),
                    });
                    vm.viewModel.Configurations.push({
                        Name: "DUIT_NOW_TRANSFER_MAXIMUM_FEE_" + code,
                        Value: (partner.feeAboveDNTransfer || 0).toString(),
                    });
            });
            ConfigurationService.Update(vm.viewModel).then(function (data) {
                vm.alertTitle = "Success!";
                vm.isSuccess = true;
                vm.showMessage = true;
                $translate('admin.configuration.saveSuccess').then(function (msg) {
                    vm.showAlert(msg);
                })
            });
        }
    }

    vm.verifyDuplicate = function () {
        var sorted, i;

        vm.topupOptions = vm.topupOptions.concat().sort(function (a, b) {
            if (a.Value > b.Value) return 1;
            if (a.Value < b.Value) return -1;
            return 0;
        });

        for (var i = 1; i < vm.topupOptions.length - 1; i++) {
            if ((vm.topupOptions[i - 1].Value == vm.topupOptions[i].Value) || (vm.topupOptions[i + 1].Value == vm.topupOptions[i].Value)) {
                return true;
            }
        }
        return false;
    }

    vm.showAlert = function (message) {
        //reset
        vm.showMessage = false;

        vm.doFade = false;

        vm.showMessage = true;

        vm.errorMessage = message;

        $timeout(function () {
            vm.doFade = true;
        }, 2500);
    };

    vm.addTopupOption = function () {
        vm.option.Key = vm.topupOptions.length + 1;
        vm.option.Value = null;
        vm.topupOptions.push(vm.option);
        vm.resetOption()
    }

    vm.removeOption = function (index) {
        vm.topupOptions.splice(index, 1);
    }

    vm.addEmail = function () {
        vm.config.emails.push({ Email: null });
    }

    vm.removeEmail = function (index) {
        vm.config.emails.splice(index, 1);
    }

    vm.fetchDuitNowPartners = function () {
        vm.duitNowPartners = [
            {
                name: "KiplePay",
                allowDuitNow: false,
                allowQR: false,
                minAmount: 0,
                feeBelow: 0.0,
                feeAbove: 0.0,
                allowDNTransfer: false,
                feeBelowDNTransfer: 0.0,
                feeAboveDNTransfer: 0.0,
            },
            {
                name: "RedPay",
                allowDuitNow: false,
                allowQR: false,
                minAmount: 0,
                feeBelow: 0.0,
                feeAbove: 0.0,
                allowDNTransfer: false,
                minAmountDNTransfer: 0,
                feeBelowDNTransfer: 0.0,
                feeAboveDNTransfer: 0.0,
            },
        ];

        // Hydrate the static partners from existing configuration values
        angular.forEach(vm.duitNowPartners, function (partner) {
            var code = partner.name.toUpperCase();
            angular.forEach(vm.configurations, function (config) {
                if (config.Name === "DUIT_NOW_ENABLED_" + code) {
                    partner.allowDuitNow = config.Value === "true";
                } else if (config.Name === "DUIT_NOW_P2P_ENABLED_" + code) {
                    partner.allowQR = config.Value === "true";
                } else if (config.Name === "DUIT_NOW_MINIMUM_AMOUNT_" + code) {
                    partner.minAmount = parseInt(config.Value) || 0;
                } else if (config.Name === "DUIT_NOW_MINIMUM_FEE_" + code) {
                    partner.feeBelow = parseFloat(config.Value) || 0.0;
                } else if (config.Name === "DUIT_NOW_MAXIMUM_FEE_" + code) {
                    partner.feeAbove = parseFloat(config.Value) || 0.0;
                } else if (config.Name === "DUIT_NOW_TRANSFER_ENABLED_" + code) {
                    partner.allowDNTransfer = config.Value === "true";
                } else if (config.Name === "DUIT_NOW_TRANSFER_MINIMUM_AMOUNT_" + code) {
                    partner.minAmountDNTransfer = parseInt(config.Value) || 0;
                } else if (config.Name === "DUIT_NOW_TRANSFER_MINIMUM_FEE_" + code) {
                    partner.feeBelowDNTransfer = parseFloat(config.Value) || 0.0;
                } else if (config.Name === "DUIT_NOW_TRANSFER_MAXIMUM_FEE_" + code) {
                    partner.feeAboveDNTransfer = parseFloat(config.Value) || 0.0;
                }
            });
        });
    };
}
}) ();


(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('HomePageMainServiceInfoService', HomePageMainServiceInfoService);

    /** @ngInject */
    function HomePageMainServiceInfoService(SVCS, $http, $q, CoreService) {
        var profileServer = SVCS.Profile;
        var gatewayServer = SVCS.Gateway;

        var service = {

            Get: Get,
            Search: Search,
            Create: Create,
            Update: Update,
            Remove: Remove,
            UploadPhoto: UploadPhoto, 
            Publish: Publish
        };

        return service;
 
        function Publish(id,isPublish) {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/profiles/HomePageMainService/publish/' + id+"?isPublish="+isPublish).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        } 
        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/profiles/GetHomePageMainServiceInfoById/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/profiles/GetAllHomePageMainServiceInfo', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(mainService) {
            var deferer = $q.defer();

            CoreService.Post(profileServer + '/api/profiles/CreateHomePageMainServiceInfo', mainService).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(mainService) {
            var deferer = $q.defer();

            CoreService.Post(profileServer + '/api/profiles/UpdateHomePageMainServiceInfo', mainService).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Remove(id) {
            var deferer = $q.defer();

            CoreService.Delete(profileServer + '/api/profiles/DeleteHomePageMainServiceInfo/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        function UploadPhoto(img) {
            var deferer = $q.defer();

            var formData = new FormData();
            formData.append('file', img);

            $http.post(gatewayServer + '/api/photos/upload/v2/uploadHomePageMainServiceInfo', formData, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('HomePageMainServiceInfoController', HomePageMainServiceInfoController);

    /** @ngInject */
    function HomePageMainServiceInfoController(SVCS, $translate, HomePageMainServiceInfoService, UniversityService, $scope, $timeout) {
        var vm = this;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;
        vm.mainservices = {};
        vm.isDisableFunctionTypes = false;
        vm.mainService = {
            Id: 0,
            Name: null,
            Link: null,
            Position: 1,
            Photos: [],
            FunctionType: null
        };
        vm.criteria = { Keyword: null, Page: 1, Length: 10, criteria: null };
        vm.viewConfig = { ShowDialog: false, Action: null };

        vm.FunctionTypeOptions = [
            { Id: 0, Name: "Home Page Main Services Page" },
            { Id: 1, Name: "Investment Product Page" }];

        var timespan = 1000;
        var disbounceTask = $timeout(vm.search, timespan);
        vm.searchByKeyword = function ($event) {
            if (disbounceTask != null)
                $timeout.cancel(disbounceTask);
            disbounceTask = $timeout(vm.search, timespan);
        }

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            HomePageMainServiceInfoService.Search(criteria).then(function (res) {
                vm.mainservices = res.Items;
                vm.totalItems = res.Total;
            })
        }

        vm.reset = function () {
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }

        vm.clearForm = function () {
            vm.mainService = {
                Id: 0,
                Link: "",
                Position: 1,
                Photos: [],
                Name: "",
                FunctionType: 0,
            }
            $scope.HomePageMainServiceInfoForm.$setPristine();
            $scope.HomePageMainServiceInfoForm.$setUntouched();
        }
        vm.unpublish= function (mainService) { 
            HomePageMainServiceInfoService.Publish(mainService.Id, false).then(function (res) {
                mainService.Status = 'InActive';
            })
        }

        vm.publish = function (mainService) {
            HomePageMainServiceInfoService.Publish(mainService.Id, true).then(function (res) {
                mainService.Status = 'Active';
            })
        }
        vm.openDialog = function (action, mainService) {
            vm.viewConfig.Action = action;
            vm.clearForm();
            if (action == 'edit') {
                HomePageMainServiceInfoService.Get(mainService.Id).then(function (res) {
                    if (res != null) {
                        vm.mainService = {
                            FunctionType: res.FunctionType == "HomePageMainServicePage" ? 0 : 1,
                            Id: res.Id,
                            Link: res.Link,
                            Position: res.Position,
                            Photos: [],
                            Name: res.Name
                        }
                        vm.isDisableFunctionTypes = true;
                        vm.mainService.Photos.push(res.Photos);
                        vm.viewConfig.ShowDialog = true;
                    }

                });
            }
            else {
                vm.isDisableFunctionTypes = false;
                vm.mainService.Position = 1;
                vm.viewConfig.ShowDialog = true;
            }
        }

        vm.save = function (form) {
            if (!$scope.HomePageMainServiceInfoForm.$valid) {
                angular.forEach($scope.HomePageMainServiceInfoForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#HomePageMainServiceInfoForm .ng-invalid')[0].focus();
                return;
            }
            if (!vm.mainService.Photos || vm.mainService.Photos.length == 0) {
                alert("Must have a Photo.");
                return;
            }


            if (vm.viewConfig.Action == 'new') {
                HomePageMainServiceInfoService.Create(vm.mainService).then(function (res) {
                    if (res != null) {
                        vm.search();
                        vm.cancel();
                        alert("Saved Successfully");
                    }
                });

            }
            else {
                HomePageMainServiceInfoService.Update(vm.mainService).then(function (res) {
                    if (res != null) {
                        vm.search();
                        vm.cancel();
                        alert("Updated Successfully");
                    }
                });
            }
        }

        vm.cancel = function () {
            vm.viewConfig.ShowDialog = false;
            vm.Action = null;
        }

        vm.remove = function (mainService) {
            $translate("admin.HomePageMainServiceInfo.confirm_remove").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                } 

                HomePageMainServiceInfoService.Remove(mainService.Id).then(function (res) { vm.mainservices.removeItem(mainService) });
            })
        }

        vm.search();

        //#region Upload photos
        vm.temp = {};
        vm.uploadPhoto = function (files, invalidFiles) {

            if (invalidFiles.length) {
                $translate('admin.HomePageMainServiceInfo.validate.photo.file_invalid', { name: invalidFiles[0].name }).then(function (msg) {
                    alert(msg);
                })
                return;
            }
            if (!files || !files.length) {
                return;
            }

            sequentialUpload(files, 0, [], sequentialUploadCompleted);


        };
        vm.toMainServiceStatusBool = function toMainServiceStatusBool(status) {
            if (status == "Active") {
                return true;
            } else {
                return false;
            }
        }
        vm.toMainServiceStatus = function toMainServiceStatus(status) {
            if (status) {
                return "Active";
            } else {
                return "InActive";
            }
        }
        vm.removePhoto = function (idx) {
            vm.mainService.Photos.splice(idx, 1);
        }

        function sequentialUpload(files, i, errorsFiles, callback) {
            HomePageMainServiceInfoService.UploadPhoto(files[i]).then(function (photo) {
                vm.mainService.Photos.push(photo.Result);
            }, function (error) {
                errorsFiles.push({ file: files[i], error: error });
            }).then(function () {
                if (files.length === i + 1) {
                    callback(errorsFiles);
                } else {
                    sequentialUpload(files, i + 1, errorsFiles, callback);
                }
            });
        }

        function sequentialUploadCompleted(errorsFiles) {
            var filesNames = [];
            if (errorsFiles && errorsFiles.length) {
                angular.forEach(errorsFiles, function (item) {
                    if (!errorsFiles.file) {
                        alert("Failed to upload picture.");
                    }
                    filesNames.push(errorsFiles.file.name);
                })
            }

            if (filesNames.length) {
                $translate('admin.HomePageMainServiceInfo.validate.photo.upload_error', { names: filesNames.join(', ') }).then(function (msg) {
                    alert(msg);
                })
            }
        }

        //#endregion
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('FraudService', FraudService);

    /** @ngInject */
    function FraudService(SVCS, $http, $q) {
        var walletServer = SVCS.Wallet;

        var service = {
            GetAll: GetAll,
            Update: Update
        };

        return service;

        function GetAll() {
            var deferer = $q.defer();

            $http.get(walletServer + '/api/fraudManagements/me')
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function Update(bindingModel) {
            var deferer = $q.defer();

            $http.put(walletServer + '/api/fraudManagements/me/update', bindingModel)
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('FraudController', FraudController)
        .directive('currencyInput', function ($filter, $browser) {
            return {
                require: 'ngModel',
                link: function ($scope, $element, $attrs, ngModelCtrl) {
                    var listener = function () {
                        var value = $element.val().replace(/,/g, '')
                        $element.val($filter('number')(value, false))
                    }

                    // This runs when we update the text field
                    ngModelCtrl.$parsers.push(function (viewValue) {
                        return viewValue.replace(/,/g, '');
                    })

                    // This runs when the model gets updated on the scope directly and keeps our view in sync
                    ngModelCtrl.$render = function () {
                        $element.val($filter('number')(ngModelCtrl.$viewValue, false))
                    }

                    $element.bind('change', listener)
                    $element.bind('keydown', function (event) {
                        var key = event.keyCode
                        // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
                        // This lets us support copy and paste too
                        if (key == 91 || (15 < key && key < 19) || (37 <= key && key <= 40))
                            return
                        $browser.defer(listener) // Have to do this or changes don't get picked up properly
                    })

                    $element.bind('paste cut', function () {
                        $browser.defer(listener)
                    })
                }
            }
        });

    /** @ngInject */

    function FraudController(SVCS, FraudService, $state, $translate, $scope,$timeout) {
        var vm = this;     

        vm.fraudManagements = {}

        vm.loading = false;
        vm.loading = {
            SaveConfiguration: false
        }

        vm.alertTitle = "Success!";
        vm.showMessage = false;
        vm.isSuccess = true;
        vm.doFade = false;

        FraudService.GetAll().then(function (data) {
            vm.fraudManagements = data;
        });

        vm.save = function () {
            vm.loading.SaveConfiguration = true;

            if (!$scope.fraudForm.$valid) {
                angular.forEach($scope.fraudForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#fraudForm .ng-invalid')[0].focus();
                return;
            }

            FraudService.Update(vm.fraudManagements).then(function (data) {
                vm.alertTitle = "Success!";
                vm.isSuccess = true;
                vm.showMessage = true;
                $translate('admin.configuration.saveSuccess').then(function (msg) {
                    vm.showAlert(msg);
                })
            });

        }

        vm.showAlert = function (message) {
            //reset
            vm.showMessage = false;
            vm.doFade = false;

            vm.showMessage = true;

            vm.errorMessage = message;

            $timeout(function () {
                vm.doFade = true;
            }, 2500);
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('GroupService', GroupService);

    /** @ngInject */
    function GroupService(SVCS, $http, $q, CoreService) {
        var groupServer = SVCS.Merchant;

        var service = {
            All: All,
            Get: Get,
            Search: Search,
            Create: Create,
            Update: Update,
            Remove: Remove
        };

        return service;

        function All() {
            var deferer = $q.defer();

            CoreService.Get(groupServer + '/api/groups/all').then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(groupServer + '/api/groups/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Get(groupServer + '/api/groups/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(group) {
            var deferer = $q.defer();

            CoreService.Post(groupServer + '/api/groups', group).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(group) {
            var deferer = $q.defer();

            CoreService.Put(groupServer + '/api/groups', group).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Remove(groupId) {
            var deferer = $q.defer();

            CoreService.Delete(groupServer + '/api/groups/' + groupId).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .directive('isGroupNameAvailable', isGroupNameAvailable);

    /** @ngInject **/
    function isGroupNameAvailable($q, $http, $timeout, SVCS) {
        return {
            require: 'ngModel',

            link: function (scope, elm, attrs, ctrl) {

                var checkingTask = null;

                var baseUrl = SVCS.Merchant;

                ctrl.$asyncValidators.isGroupNameAvailable = function (modelValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return $q.when();
                    }

                    var def = $q.defer();

                    if (checkingTask != null) {
                        $timeout.cancel(checkingTask);
                        checkingTask = null;
                    }

                    var id = scope.$eval(attrs.isGroupNameAvailable);

                    checkingTask = $timeout(function () {
                        $http.post(baseUrl + '/api/groups/is-group-name-available', { Name: modelValue, Id: id }).then(function (response) {
                            if (response.data) {
                                def.resolve();
                            } else {
                                def.reject();
                            }
                        }, function (responseError) {
                            def.reject();
                        })
                    }, 500)

                    return def.promise;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('GroupController', GroupController);

    /** @ngInject */
    function GroupController(SVCS, $translate, GroupService, $scope) {
        var vm = this;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;
        vm.group = {};
        vm.criteria = { Keyword: null , Page: 1, Length: 10};
        vm.viewConfig = { ShowDialog: false, Action: null };

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }

        vm.channelList = [
            {
                Value: "",
                Text: "Select an option"
            },
            {
                Value: "Kiplepay",
                Text: "Kiplepay"
            }
        ];

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            GroupService.Search(criteria).then(function (res) {
                vm.groups = res.Items;
                vm.totalItems = res.Total;
            })
        }

        vm.reset = function () {
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }

        vm.clearForm = function () {
            vm.group = {
                Name: null,
                Description: null,
            }

            $scope.groupForm.$setPristine();
            $scope.groupForm.$setUntouched();
        }

        vm.openDialog = function (action, group) {
            vm.viewConfig.Action = action;
            vm.group = {};
            vm.clearForm();
            if (action == 'edit') {
                vm.group = angular.copy(group);
            }
            vm.viewConfig.ShowDialog = true;
        }

        vm.save = function () {

            if (!$scope.groupForm.$valid) {
                angular.forEach($scope.groupForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#groupForm .ng-invalid')[0].focus();
                return;
            }

            if (vm.viewConfig.Action == 'new') {
                GroupService.Create(vm.group).then(function (res) {
                    vm.search();
                    vm.cancel();
                })
            }
            else {
                GroupService.Update(vm.group).then(function (res) {
                    vm.search();
                    vm.cancel();
                })
            }
        }

        vm.cancel = function () {
            vm.viewConfig.ShowDialog = false;
            //vm.group = undefined;
            vm.Action = null;
        }

        vm.remove = function (group) {
            $translate("admin.group.confirm_remove").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }

                GroupService.Remove(group.Id).then(function (res) { vm.groups.removeItem(group) });
            })
        }

        vm.search();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('EduServService', EduServService);

    /** @ngInject */
    function EduServService(SVCS, $http, $q, CoreService) {
        
        var merchantServer = SVCS.Merchant;
        var service = {

            Get: Get,
            Search: Search,
            Create: Create,
            Update: Update,
            Remove: Remove,
            Publish: Publish,
            UnPublish: UnPublish,
            GetOrganizationCategory: GetOrganizationCategory
        };

        return service;
 
        function Publish(id) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/education-service/publish/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        } 
        function UnPublish(id) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/education-service/unpublish/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        } 
        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/education-service/dashboard/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/education-service/dashboard/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(bindingModel) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/education-service/Create', bindingModel).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(mainService) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/education-service/update/info', mainService).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Remove(id) {
            var deferer = $q.defer();

            CoreService.Delete(merchantServer + '/api/education-service/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function GetOrganizationCategory() {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/data/getOrganizationCategory').then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
       
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('educationServiceController', educationServiceController);

    /** @ngInject */
    function educationServiceController(SVCS, $translate, EduServService, $scope, $timeout, UniversityService) {
        var vm = this;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;
        vm.eduservice = {};
        vm.eduservice = {
            Id: 0,
            UniId: null,
            OrganizationCategory: null,
            Position: 1,
            DeepinkUrl: null,
            DeeplinkProvider: null
        };
        vm.criteria = { Keyword: null, Page: 1, Length: 10};
        vm.viewConfig = { ShowDialog: false, Action: null };

       

        var timespan = 1000;
        var disbounceTask = $timeout(vm.search, timespan);
        vm.searchByKeyword = function ($event) {
            if (disbounceTask != null)
                $timeout.cancel(disbounceTask);
            disbounceTask = $timeout(vm.search, timespan);
        }

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            EduServService.Search(criteria).then(function (res) {
                vm.educationservice = res.Items;
                vm.totalItems = res.Total;
            })
        }

        vm.reset = function () {
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }

        vm.clearForm = function () {
            vm.eduservice = {
                Id: 0,
                UniId: null,
                OrganizationCategory: null,
                Position: 1,
                DeepinkUrl: null,
                DeeplinkProvider: null
            };
            $scope.educationForm.$setPristine();
            $scope.educationForm.$setUntouched();
        }
        vm.publish = function (eduservice) { 
            EduServService.Publish(eduservice.Id).then(function (res) {
                eduservice.Status = "Publish";
            })
        }

        vm.unpublish = function (eduservice) {
            EduServService.UnPublish(eduservice.Id).then(function (res) {
                eduservice.Status = "Unpublish";
            })
        }
        vm.openDialog = function (action, eduservice) {
            vm.viewConfig.Action = action;
            vm.clearForm();
            UniversityService.GetPortalUniversity().then(function (data) {
                vm.universtyList = data.list;
            });
            if (action == 'edit') {
                EduServService.Get(eduservice.Id).then(function (res) {
                    if (res != null) {
                        vm.eduservice = {
                            Id: res.Id,
                            UniId: res.UniId,
                            OrganizationCategory: res.OrganizationCategory =="University"?"1":"2",
                            Position: res.OrganizationPosition,
                            DeepinkUrl: res.DeeplinkUrl,
                            DeeplinkProvider: res.DeeplinkProvider,
                            ServiceName: res.ServiceName
                        }
                        vm.viewConfig.ShowDialog = true;
                    };

                });
            }
            else {
                vm.eduservice.Position = 1;
                vm.viewConfig.ShowDialog = true;
            }
        }

        vm.save = function (form) {
            if (!$scope.educationForm.$valid) {
                angular.forEach($scope.educationForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#educationForm .ng-invalid')[0].focus();
                return;
            }
            if (vm.viewConfig.Action == 'new') {
                EduServService.Create(vm.eduservice).then(function (res) {
                    if (res != null) {
                        vm.search();
                        vm.cancel();
                        alert("Saved Successfully");
                    }
                });

            }
            else {
                EduServService.Update(vm.eduservice).then(function (res) {
                    if (res != null) {
                        vm.search();
                        vm.cancel();
                        alert("Updated Successfully");
                    }
                });
            }
        }

        vm.cancel = function () {
            vm.viewConfig.ShowDialog = false;
            vm.Action = null;
        }

        vm.remove = function (eduservice) {
            var message = "Do you want delete this Service";
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                } 

                EduServService.Remove(eduservice.Id).then(function (res) { vm.educationservice.removeItem(eduservice) });
            
        }

        vm.search();
        //vm.getUniversities();
        //vm.getUniversities = function () {
        //    UniversityService.GetPortalUniversity().then(function (data) {
        //        vm.universtyList = data.list;
        //    });
        //}
      //  vm.loadorganizationCategory();
        //vm.loadorganizationCategory = function () {
        //    EduServService.GetOrganizationCategory().then(function (res) {
        //        vm.OrganizationCategory = res
        //    });
        //}
        
        vm.OrganizationCategory = [
            { Id: "1", Name: "University" },
            { Id: "2", Name: "IPT Fees" }
        ];
      
        //vm.loadMerchant = function (keyword) {
        //    if (keyword.length >= 3) {
        //        MerchantService.Search({ Keyword: keyword }).then(function (res) {
        //            vm.merchants = res.Items;
        //        });
        //    } else {
        //        vm.merchants = null;
        //    }
        //}
        vm.toMainServiceStatusBool = function toMainServiceStatusBool(status) {
            if (status == "Publish") {
                return true;
            } else {
                return false;
            }
        }
        //#endregion
    }
})();




(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('CobrandArtWorkInfoService', CobrandArtWorkInfoService);

    /** @ngInject */
    function CobrandArtWorkInfoService(SVCS, $http, $q, CoreService) {
        var promotionServer = SVCS.Promotion;
        var gatewayServer = SVCS.Gateway;
        var service = {

            Get: Get,
            Search: Search,
            Create: Create,
            Update: Update,
            Remove: Remove,
            UploadPhoto: UploadPhoto, 
            Publish: Publish,
            UnPublish: UnPublish
        };

        return service;
 
        function Publish(Id) {
            var deferer = $q.defer();

            CoreService.Get(promotionServer + '/api/co-brand/publish/' + Id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        } 
        function UnPublish(Id) {
            var deferer = $q.defer();

            CoreService.Get(promotionServer + '/api/co-brand/unpublish/' + Id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        } 
        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(promotionServer + '/api/co-brand/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Get(promotionServer + '/api/co-brand/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(cobrand) {
            var deferer = $q.defer();

            CoreService.Post(promotionServer + '/api/co-brand/Create', cobrand).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(cobrand) {
            var deferer = $q.defer();

            CoreService.Post(promotionServer + '/api/co-brand/Update', cobrand).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Remove(id) {
            var deferer = $q.defer();

            CoreService.Delete(promotionServer + '/api/co-brand/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        function UploadPhoto(img) {
            var deferer = $q.defer();

            var formData = new FormData();
            formData.append('file', img);

            $http.post(gatewayServer + '/api/photos/CardLogoUpload', formData, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('CoBrandArtWorkController', CoBrandArtWorkController);

    /** @ngInject */
    function CoBrandArtWorkController(SVCS, $translate, CobrandArtWorkInfoService, UniversityService, CommunityService, $scope, $timeout) {
        var vm = this;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;
        vm.Cobrand = {};
        vm.Cobrand = {
            Id: 0,
            ChannelType: null,
            CampaignName: "",
            CampaignId: "",
            Photos: [],
            CommunityId: null,
            UniversityId: null,
            VisaCardType: null,
            Description:""
        };
        vm.disableDummy1 = true;
        vm.disableDummy2 = true;
        vm.criteria = { Keyword: null, Page: 1, Length: 10};
        vm.viewConfig = { ShowDialog: false, Action: null };

        vm.ChannelTypeOptions = [
            { Id: 1, Name: "BulkUserVisa" },
            { Id: 2, Name: "KiplepayVisaPage" }];

        vm.CardTypeOptions = [
            { Id: 1, Name: "Visa Physical Card" },
            { Id: 2, Name: "Visa Virtual Card" },
            { Id: 3, Name: "Digital First Card" }];

        var timespan = 1000;
        var disbounceTask = $timeout(vm.search, timespan);
        vm.searchByKeyword = function ($event) {
            if (disbounceTask != null)
                $timeout.cancel(disbounceTask);
            disbounceTask = $timeout(vm.search, timespan);
        }

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            CobrandArtWorkInfoService.Search(criteria).then(function (res) {
                vm.coBrandArtWork = res.Items;
                vm.totalItems = res.Total;
            })
        }

        vm.reset = function () {
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }

        vm.clearForm = function () {
            vm.Cobrand = {
                Id: 0,
                ChannelType: null,
                CampaignName: "",
                CampaignId: "",
                Photos: [],
                CommunityId: null,
                UniversityId: null,
                VisaCardType: null,
                Description: ""
            };
            $scope.CoBrandArtWorkInfoForm.$setPristine();
            $scope.CoBrandArtWorkInfoForm.$setUntouched();
        }
        vm.unpublish = function (Cobrand) { 
            CobrandArtWorkInfoService.UnPublish(Cobrand.Id).then(function (res) {
                Cobrand.State = 'UnPublish';
                vm.toMainServiceStatusBool("UnPublish");
            })
        }

        vm.publish = function (Cobrand) {
            CobrandArtWorkInfoService.Publish(Cobrand.Id).then(function (res) {
                Cobrand.State = 'Publish';
                vm.toMainServiceStatusBool("Publish");
            })
        };
       
        vm.openDialog = function (action, Cobrand) {
            vm.viewConfig.Action = action;
            vm.clearForm();
            if (action == 'edit') {
                CobrandArtWorkInfoService.Get(Cobrand.Id).then(function (res) {
                    if (res != null) {
                        vm.Cobrand = {
                            Id: res.Id,
                            ChannelType: res.ChannelType,
                            CampaignName: res.CampaignName,
                            CampaignId: res.CampaignId,
                            Photos: [],
                            VisaCardType: res.VisaCardType,
                            Description: res.Descriptions
                        };
                        vm.Cobrand.Photos.push(res.CardImage);
                        if (res.ChannelType == 1) {
                            vm.Cobrand.CommunityId = null;
                            vm.Cobrand.UniversityId = null;
                        } else {
                            vm.ChannelTypeChange();
                            vm.Cobrand.CommunityId = res.CommunityId;
                            vm.Cobrand.UniversityId = res.UniversityId;
                            //vm.Cobrand.CommunityId = res.CommunityId == null ? vm.disableCommunity = true : vm.disableCommunity = false;
                            //vm.Cobrand.UniversityId = res.UniversityId == null ? vm.disableUniversity = true : vm.disableUniversity = false;
                        };
                        
                        vm.viewConfig.ShowDialog = true;
                    }

                });
            }
            else {
                vm.viewConfig.ShowDialog = true;
            }
        }

        vm.save = function (form) {
            if (!$scope.CoBrandArtWorkInfoForm.$valid) {
                angular.forEach($scope.CoBrandArtWorkInfoForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#CoBrandArtWorkInfoForm .ng-invalid')[0].focus();
                return;
            }
            if (!vm.Cobrand.Photos || vm.Cobrand.Photos.length == 0) {
                alert("Must have a Photo.");
                return;
            }
            var stat = 0;
            if (vm.Cobrand.ChannelType == 2) {
                stat = vm.Cobrand.CommunityId == null ? 1 : 0;
                if (stat == 1) {
                    stat = vm.Cobrand.UniversityId == null ? 1 : 0;
                }
                stat = vm.Cobrand.Description == "" ? 2 : 0;
                stat = vm.Cobrand.Description.length > 100 ? 3 : 0;
            }
            else if (vm.Cobrand.ChannelType == 1){
                vm.Cobrand.UniversityId = null;
                vm.Cobrand.CommunityId = null;
                vm.Cobrand.Description = "";
            }
            if (stat == 0) {
                if (vm.viewConfig.Action == 'new') {
                    CobrandArtWorkInfoService.Create(vm.Cobrand).then(function (res) {
                        if (res != null) {
                            vm.search();
                            vm.cancel();
                            alert("Saved Successfully");
                        }
                    });

                }
                else {
                    CobrandArtWorkInfoService.Update(vm.Cobrand).then(function (res) {
                        if (res != null) {
                            vm.search();
                            vm.cancel();
                            alert("Updated Successfully");
                        }
                    });
                }
            }
            else if (stat == 1) {
                alert("Please select community or University");
            }
            else if (stat == 2) {
                alert("Please Enter Description");
            }
            else {
                alert("Please Enter Description less than 100 characters");
            }
        }

        vm.cancel = function () {
            vm.viewConfig.ShowDialog = false;
            vm.Action = null;
        }

        vm.remove = function (Cobrand) {
            $translate("admin.HomePageMainServiceInfo.confirm_remove").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                } 

                CobrandArtWorkInfoService.Remove(Cobrand.Id).then(function (res) {
                    vm.search();
                    vm.cancel();
                });
            })
        }

        vm.search();

        //#region Upload photos
        vm.temp = {};
        vm.uploadPhoto = function (files, invalidFiles) {

            if (invalidFiles.length) {
                $translate('admin.CoBrandArtWorkInfoForm.validate.photo.file_invalid', { name: invalidFiles[0].name }).then(function (msg) {
                    alert(msg);
                })
                return;
            }
            if (!files || !files.length) {
                return;
            }

            sequentialUpload(files, 0, [], sequentialUploadCompleted);


        };
        vm.toMainServiceStatusBool = function toMainServiceStatusBool(status) {
            if (status == "Publish") {
                return true;
            } else {
                return false;
            }
        }
        vm.ChannelTypeChange = function () {

            if (vm.Cobrand.ChannelType == 2) {
                UniversityService.GetListOfUniveristies().then(function (res) {
                    vm.UniversityList = res.list;
                });
                CommunityService.GetAllCommunity().then(function (res) {
                    vm.CommunityList = res.Result;
                });
            }
            else {
                vm.UniversityList = null;
                vm.CommunityList = null;
            }
        }
        vm.removePhoto = function (idx) {
            vm.Cobrand.Photos.splice(idx, 1);
        }

        function sequentialUpload(files, i, errorsFiles, callback) {
            CobrandArtWorkInfoService.UploadPhoto(files[i]).then(function (photo) {
                vm.Cobrand.Photos.push(photo.Result);
            }, function (error) {
                errorsFiles.push({ file: files[i], error: error });
            }).then(function () {
                if (files.length === i + 1) {
                    callback(errorsFiles);
                } else {
                    sequentialUpload(files, i + 1, errorsFiles, callback);
                }
            });
        }

        function sequentialUploadCompleted(errorsFiles) {
            var filesNames = [];
            if (errorsFiles && errorsFiles.length) {
                angular.forEach(errorsFiles, function (item) {
                    if (!errorsFiles.file) {
                        alert("Failed to upload picture.");
                    }
                    filesNames.push(errorsFiles.file.name);
                })
            }

            if (filesNames.length) {
                $translate('admin.HomePageMainServiceInfo.validate.photo.upload_error', { names: filesNames.join(', ') }).then(function (msg) {
                    alert(msg);
                })
            }
        }

        //#endregion
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('BrandService', BrandService);

    /** @ngInject */
    function BrandService(SVCS, $http, $q, CoreService) {
        var merchantServer = SVCS.Merchant;

        var service = {
            Get: Get,
            GetByStoreId: GetByStoreId,
            Search: Search,
            Create: Create,
            Update: Update,
            Remove: Remove
        };

        return service;

        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/brands/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function GetByStoreId(storeId) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/brands/by-store-id?storeId=' + storeId).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/brands/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(merchant) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/brands', merchant).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(merchant) {
            var deferer = $q.defer();

            CoreService.Put(merchantServer + '/api/brands', merchant).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Remove(brandId) {
            var deferer = $q.defer();

            CoreService.Delete(merchantServer + '/api/brands/' + brandId).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .directive('isBrandNameAvailable', isBrandNameAvailable);

    /** @ngInject **/
    function isBrandNameAvailable($q, $http, $timeout, SVCS) {
        return {
            require: 'ngModel',

            link: function (scope, elm, attrs, ctrl) {

                var checkingTask = null;

                var baseUrl = SVCS.Merchant;

                ctrl.$asyncValidators.isBrandNameAvailable = function (modelValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return $q.when();
                    }

                    var def = $q.defer();

                    if (checkingTask != null) {
                        $timeout.cancel(checkingTask);
                        checkingTask = null;
                    }

                    var id = scope.$eval(attrs.isBrandNameAvailable);

                    checkingTask = $timeout(function () {
                        $http.post(baseUrl + '/api/brands/is-brand-name-available', { Name: modelValue, Id: id }).then(function (response) {
                            if (response.data) {
                                def.resolve();
                            } else {
                                def.reject();
                            }
                        }, function (responseError) {
                            def.reject();
                        })
                    }, 500)

                    return def.promise;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('BrandController', BrandController);

    /** @ngInject */
    function BrandController(SVCS, BrandService, DataService, MerchantService, GroupService, $scope, $translate, TagService) {
        var vm = this;
        vm.merchantServer = SVCS.Merchant;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;
        vm.brand = {};
        vm.criteria = { Keyword: null, Page: 1, Length: 10 };
        vm.viewConfig = { ShowDialog: false, Action: null, UploadLogo: false };
        var uploadImgControl = null;
        vm.disabledDeleteLogo = true;

        // Get tag
        TagService.SearchBrand({}).then(function (res) {
            vm.tags = res.Items;
        });
        vm.tagTransform = function (newTag) {
            return {
                Id: null,
                Name: newTag
            };
        };

        vm.typeFoods = [
            {
                Id: 'Halal',
                Value: 'Halal'
            },
            {
                Id: 'NonHalal',
                Value: 'Non-Halal'
            },
            {
                Id: 'PorkFree',
                Value: 'Pork Free'
            },
            {
                Id: 'NA',
                Value: 'NA'
            }
        ];

        vm.temp = {};

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            BrandService.Search(criteria).then(function (res) {
                vm.brands = res.Items;
                vm.totalItems = res.Total;
            })
        }

        vm.reset = function () {
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }

        vm.clearForm = function () {
            $scope.brandForm.$setPristine();
            $scope.brandForm.$setUntouched();
        }

        vm.openDialog = function (action, brand) {
            vm.viewConfig.Action = action;
            //get categories
            if (!vm.categories) {
                DataService.AllMerchantCategories().then(function (res) {
                    vm.categories = res.Result;
                })
            }

            //get groups
            if (!vm.groups) {
                GroupService.All().then(function (res) {
                    vm.groups = res.Result;
                })
            }

           vm.clearForm();
            vm.brand = { Address: {} };
            if (action == 'edit') {
                angular.element("input[type='file']").val(null);
                BrandService.Get(brand.Id).then(function (res) {
                    vm.brand = res;
                    if (vm.brand.LogoUrl) {
                        vm.disabledDeleteLogo = false; 
                    }
                })

            }
            vm.temp.Photo = null;
            vm.viewConfig.ShowDialog = true;
        }

        vm.save = function () {

            if (!$scope.brandForm.$valid) {
                angular.forEach($scope.brandForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#brandForm .ng-invalid')[0].focus();
                return;
            }

            if (vm.viewConfig.Action == 'new') {
                BrandService.Create(vm.brand).then(function (res) {
                    vm.brands.unshift({ Id: res.Id, Name: res.Name, NumberOfMerchant: res.NumberOfMerchant, GroupName: res.GroupName });
                    vm.cancel();
                    vm.search()
                })
            }
            else {
                BrandService.Update(vm.brand).then(function (res) {
                    vm.cancel();
                    vm.search()
                })
            }
        }

        vm.cancel = function () {
            vm.viewConfig.ShowDialog = false;
            vm.brand = undefined;
            vm.Action = null;
        }

        vm.remove = function (brand) {
            $translate("admin.brand.confirm_remove").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }

                BrandService.Remove(brand.Id).then(function (res) { vm.brands.removeItem(brand) });
            })
        }

        vm.categorySelected = function () {
            if (!vm.brand.MainCategoryId) {
                return;
            }

            var category = vm.categories.findItem('Id', vm.brand.MainCategoryId);
            if (category) {
                vm.subcategories = category.ChildrenCategories;
            }
        }

        vm.onLogoSelected = function (files, controlGetter) {
            uploadImgControl = controlGetter();
            if (files != null && files.length) {
                vm.temp.Photo = files[0].name;
                vm.viewConfig.UploadLogo = true;
                MerchantService.UploadMerchantLogo(files[0]).then(function (path) {
                    vm.viewConfig.UploadLogo = false;
                    vm.disabledDeleteLogo = false;
                    if (path) {
                        vm.brand.LogoUrl = path.Result;
                    }
                }, function (error) {
                    vm.viewConfig.UploadLogo = false;
                })
            }
        }

        vm.deleteLogo = function () {
            if (vm.brand.LogoUrl) {
                vm.brand.LogoUrl = null;
                vm.disabledDeleteLogo = true;
                vm.temp.Logo = null;
                $scope.file = null;
                angular.element("input[type='file']").val(null);
            }
            else {
                return;
            }
        }

        vm.search();
    }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('DisbursementRequestApprovalController', DisbursementRequestApprovalController);


    DisbursementRequestApprovalController.$inject = ['DTOptionsBuilder', 'DTColumnBuilder', '$q', '$filter', '$numUtils', 'bonusService', 'UniversityService', 'AuthenticationService', '$scope', '$compile'];

    function DisbursementRequestApprovalController(DTOptionsBuilder, DTColumnBuilder, $q, $filter, $numUtils, bonusService, UniversityService, AuthenticationService, $scope, $compile) {
        var vm = this;

        vm.errorMsg = '';
        vm.isReadonly = true;
        vm.statusList = [
            { status: 0, displayText: 'Pending' }, 
            { status: 1, displayText: 'Fail' }, 
            { status: 2, displayText: 'Approved' }, 
            { status: 3, displayText: 'Successful' }, 
            { status: 4, displayText: 'Rejected' }
        ];
        vm.serachModel = {
            disbursementRequestStartDate: null,
            disbursementRequestEndDate: null,
            userName: '',
            idNo: '',
            universityId: '',
            universityCode: '',
            status: null,
        };
        vm.getUniversities = function () {
            UniversityService.GetPortalUniversity().then(function (data) {
                vm.UniversityItems = data.list;
            })

        }
        vm.UniversityIdClick = function () {
        }
        vm.dtInstance = {};
        vm.approve = approve;
        vm.reject = reject;

        vm.dataTable = {
            options: DTOptionsBuilder.fromFnPromise(function () {
                var deferer = $q.defer();
                deferer.resolve([]);
                return deferer.promise;

            }).withBootstrap()
                .withOption('searching', false)
                .withOption('lengthChange', false)
                .withOption('displayLength', 50)
                .withOption('createdRow', createdRow)
                .withButtons([
                    {
                        extend: 'print',
                        title: 'Kiple Admin Approve Zakat Disbursement Request'
                    },
                    {
                        extend: 'csv',
                        filename: 'Kiple Admin Approve Zakat Disbursement Request'
                    }
                ]),

            columns: [
                DTColumnBuilder.newColumn('DisbursementDateTime').withClass('center').withOption('type', 'date').withOption('render', function (data) { return $filter('date')(data, 'dd/MM/yyyy HH:mm:ss'); }),
                DTColumnBuilder.newColumn('University'),
                DTColumnBuilder.newColumn('TotalPrefund'),
                DTColumnBuilder.newColumn('TotalEntry'),
                DTColumnBuilder.newColumn('Status'),
                DTColumnBuilder.newColumn('action').withClass('action').renderWith(function (data, type, rowData) {
                    var isShow = false;
                    if (rowData.Status == "Pending") {
                        isShow = true;
                    }
                    var buttonStr = '<button type="button" class="btn btn-primary" ng-show="' + isShow + '" ng-click="vm.approve(\'' + rowData.Id + '\')" >Approve</button>';
                    buttonStr += '<button type="button" class="btn btn-danger"  ng-show="' + isShow + '"  ng-click="vm.reject(\'' + rowData.Id + '\')" >Reject</button>';
                    return buttonStr;
                }),
            ]
        };

        vm.searchReport = function () {
            vm.errorMsg = null;
            if (vm.serachModel.disbursementRequestApprovalStartDate && vm.serachModel.disbursementRequestApprovalEndDate) {
                var beginTime = moment(vm.serachModel.disbursementRequestApprovalStartDate);
                var endTime = moment(vm.serachModel.disbursementRequestApprovalEndDate);

                var diff = moment(endTime).diff(beginTime, 'minutes');

                if (diff < 0) {
                    vm.errorMsg = "begin time cannot be greater than end time";

                    return;
                }
            }

            vm.dtInstance.changeData(getReportPromise);
        }
        function approve(id) {
            bonusService.disbursementRequestApprove(id).then(function (response) {
                vm.dtInstance.changeData(getReportPromise);
            }, function (responseError) {
                alertError();
            });
        };
        function reject(id) {
            bonusService.disbursementRequestReject(id).then(function (response) {
                vm.dtInstance.changeData(getReportPromise);
            }, function (responseError) {
                alertError();
            });
        };
        function getReportPromise() {
            var jsonData = {
                DisbursementRequestStartDate: vm.serachModel.disbursementRequestStartDate,
                DisbursementRequestEndDate: vm.serachModel.disbursementRequestEndDate,
                University: vm.serachModel.universityCode,
                Status: vm.serachModel.status,
            };
            var defer = $q.defer();
            bonusService.searchDisbursementRequestApproval(jsonData).then(function (response) {
                defer.resolve(response.data);
            }, function (responseError) {
                dealErrorDefer(defer);
            });

            return defer.promise;
        }
        function dealErrorDefer(defer) {
            alertError();
            defer.resolve();
        }

        function alertError() {
            var message = "Failed! Something has gone wrong. Please contact a system administrator.";
            alert(message);
        }

        function createdRow(row, data, dataIndex) {
            // Recompiling so we can bind Angular directive to the DT  
            $compile(angular.element(row).contents())($scope);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('BonusKiplekashService', BonusKiplekashService);

    /** @ngInject */
    function BonusKiplekashService(SVCS, $http, $q, CoreService) {
        var walletServer = SVCS.Wallet;

        var service = {
            ImportCSV: ImportCSV,
        
        };

        return service;
       
        function ImportCSV(model) {
            var deferer = $q.defer();

            CoreService.Post(walletServer + '/api/bonus-kiplekash', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('BonusKiplekashController', BonusKiplekashController);

    /** @ngInject */
    function BonusKiplekashController(SVCS, BonusKiplekashService, $scope, $timeout) {
        var vm = this;
        vm.templateLink = SVCS.Merchant + "/Merchant/Content/bonus-kiplekash-template.csv";

        var errorType = 0;
        vm.checkRow = function (data) {
            if (isNaN(parseFloat(data[1]))) {
                errorType = 1;
                return false;
            }
            if (new Date(data[2]) == "Invalid Date") {
                errorType = 2;
                return false;
            }
            if (new Date(data[3]) == "Invalid Date") {
                errorType = 3;
                return false;
            }

            return true;
        }

        vm.save = function () {
            if (!vm.fileContent) {
                alert("Please choose a csv file.");
            }
            else {
                var invalid = false;

                var title = ["UserName", "Kiplekash Value", "Entitlement Date", "Expiry Date", "Merchant Name"];

                angular.forEach(vm.fileContent.split("\r\n"), function (row, index) {
                    var char = "";
                    if (row.indexOf(";") !== -1) {
                        char = ";";
                    }
                    else {
                        char = ",";
                    }
                    var data = row.split(char);
                    if (index == 0) {
                        if (!angular.equals(title, data)) {
                            invalid = true;
                            alert("The title is invalid. (" + title + ")");
                        }
                    } else {
                        if (data.length == 5) {
                            if (!vm.checkRow(data)) {
                                invalid = true;
                                var base_message = "Data of row " + index + " is invalid.\n";
                                var message = base_message;
                                
                                switch (errorType) {
                                    case 1:
                                        message = base_message + "Kiplekash Value (" + data[1] + ") is invalid.";
                                        break;
                                    case 2:
                                        message = base_message + "Entitlement Date (" + data[2] + ") is invalid.";
                                        break;
                                    case 3:
                                        message = base_message + "Expiry Date (" + data[3] + ") is invalid.";
                                        break;
                                }
                                alert(message);
                            }
                        }
                    }
                });

                if (!invalid) {
                    var model = [];

                    angular.forEach(vm.fileContent.split("\r\n"), function (row, index) {
                        var char = "";
                        if (row.indexOf(";") !== -1) {
                            char = ";";
                        }
                        else {
                            char = ",";
                        }
                        var data = row.split(char);
                        if (index != 0 && data.length == 5) {
                            model.push({
                                "UserName": data[0],
                                "Value": data[1],
                                "EntitlementDate": data[2],
                                "ExpiryDate": data[3],
                                "MerchantName": data[4]
                            });
                        }
                    });

                    BonusKiplekashService.ImportCSV(model).then(function (data) {
                        $timeout(function () {
                            alert("Successful");
                        }, 500);
                    });
                }

            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('BonusStorecardService', BonusStorecardService);

    /** @ngInject */
    function BonusStorecardService(SVCS, $http, $q, CoreService) {
        var walletServer = SVCS.Wallet;

        var service = {
            ImportCSV: ImportCSV,
        
        };

        return service;
       
        function ImportCSV(model) {
            var deferer = $q.defer();

            CoreService.Post(walletServer + '/api/bonus-storecard', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('BonusStorecardController', BonusStorecardController);

    /** @ngInject */
    function BonusStorecardController(SVCS, BonusStorecardService, $scope, $timeout) {
        var vm = this;
        vm.templateLink = SVCS.Merchant + "/Merchant/Content/bonus-storecard-template.csv";

        var errorType = 0;
        vm.checkRow = function (data) {
            if (isNaN(parseFloat(data[1]))) {
                errorType = 1;
                return false;
            }
            if (new Date(data[2]) == "Invalid Date") {
                errorType = 2;
                return false;
            }
            if (new Date(data[3]) == "Invalid Date") {
                errorType = 3;
                return false;
            }
            //if (new Date(data[2]) >= new Date(data[3])) {
            //    errorType = 4;
            //    return false;
            //}
            //var now = new Date();
            ////var day = now.getDate();
            ////var month = now.getMonth();
            ////var year = now.getFullYear();
            ////var now_date = new Date(year, month, day);

            //var checkDate = new Date(data[2]);
            ////var day1 = checkDate.getDate();
            ////var month1 = checkDate.getMonth();
            ////var year1 = checkDate.getFullYear();
            ////var checkDate1 = new Date(year1, month1, day1);

            //if (checkDate <= now) {
            //    errorType = 5;
            //    return false;
            //}
            return true;
        }

        vm.save = function () {
            if (!vm.fileContent) {
                alert("Please choose a csv file.");
            }
            else {
                var invalid = false;

                var title = ["UserName", "Store Card Value", "Entitlement Date", "Expiry Date", "Merchant Name"];

                angular.forEach(vm.fileContent.split("\r\n"), function (row, index) {
                    var char = "";
                    if (row.indexOf(";") !== -1) {
                        char = ";";
                    }
                    else {
                        char = ",";
                    }
                    var data = row.split(char);
                    if (index == 0) {
                        if (!angular.equals(title, data)) {
                            invalid = true;
                            alert("The title is invalid. (" + title + ")");
                        }
                    } else {
                        if (data.length == 5) {
                            if (!vm.checkRow(data)) {
                                invalid = true;
                                var base_message = "Data of row " + index + " is invalid.\n";
                                var message = base_message;
                                
                                switch (errorType) {
                                    case 1:
                                        message = base_message + "Store Card Value (" + data[1] + ") is invalid.";
                                        break;
                                    case 2:
                                        message = base_message + "Entitlement Date (" + data[2] + ") is invalid.";
                                        break;
                                    case 3:
                                        message = base_message + "Expiry Date (" + data[3] + ") is invalid.";
                                        break;
                                    //case 4:
                                    //    message = base_message + "\nExpiry Date must be after than Entitlement Day.";
                                    //    break;
                                    //case 5:
                                    //    message = base_message + "\nEntitlement Date must be in the future.";
                                    //    break;
                                }
                                alert(message);
                            }
                        }
                    }
                });

                if (!invalid) {
                    var model = [];

                    angular.forEach(vm.fileContent.split("\r\n"), function (row, index) {
                        var char = "";
                        if (row.indexOf(";") !== -1) {
                            char = ";";
                        }
                        else {
                            char = ",";
                        }
                        var data = row.split(char);
                        if (index != 0 && data.length == 5) {
                            model.push({
                                "UserName": data[0],
                                "Value": data[1],
                                "EntitlementDate": data[2],
                                "ExpiryDate": data[3],
                                "MerchantName": data[4]
                            });
                        }
                    });

                    BonusStorecardService.ImportCSV(model).then(function (data) {
                        $timeout(function () {
                            alert("Successful");
                        }, 500);
                    });
                }

            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .service('bonusService', bonusService);

    bonusService.$inject = ['SVCS', '$http'];

    function bonusService(SVCS, $http) {

        var importZakatCsvFn = function (jsonData) {
            var url = '{0}/api/bonus-kiplekash/v2'.format(SVCS.Wallet);
            return $http.post(url, jsonData, { headers: { 'Content-Type': 'application/json' } });
        };

        var importStoreCsvFn = function (jsonData) {
            var url = '{0}/api/bonus-storecard'.format(SVCS.Wallet);
            return $http.post(url, jsonData, { headers: { 'Content-Type': 'application/json' } });
        };

        var importCreditCsvFn = function (jsonData) {
            var url = '{0}/api/bonus/import-credit'.format(SVCS.Wallet);
            return $http.post(url, jsonData, { headers: { 'Content-Type': 'application/json' } });
        };

        var searchCreditReportFn = function (jsonData) {
            var url = '{0}/api/bonus/search-credit-report'.format(SVCS.Wallet);
            return $http.post(url, jsonData, { headers: { 'Content-Type': 'application/json' } });
        };
        var searchDisbursementReportFn = function (jsonData) {
            var url = '{0}/api/bonus-kiplekash/disbursements'.format(SVCS.Wallet);
            return $http.post(url, jsonData, { headers: { 'Content-Type': 'application/json' } });
        };
        var searchZakatTransactionReportFn = function (jsonData) {
            var url = '{0}/api/report/bonus-zakat-transanction-report'.format(SVCS.Wallet);
            return $http.post(url, jsonData, { headers: { 'Content-Type': 'application/json' } });
        };
        var searchDisbursementRequestApprovalFn = function (jsonData) {
            var url = '{0}/api/bonus-kiplekash/bonus-zakat-disbursement-request'.format(SVCS.Wallet);
            return $http.post(url, jsonData, { headers: { 'Content-Type': 'application/json' } });
        };
        var disbursementRequestApproveFn= function (id) {
            var url = '{0}/api/bonus-kiplekash/disbursement-request/approve/{1}'.format(SVCS.Wallet,id);
            return $http.put(url, null, { headers: { 'Content-Type': 'application/json' } });
        };
        var  disbursementRequestRejectFn= function (id ) {
            var url = '{0}/api/bonus-kiplekash/disbursement-request/reject/{1}'.format(SVCS.Wallet,id);
            return $http.put(url, null, { headers: { 'Content-Type': 'application/json' } });
        };
        return {
            importZakatCsv: importZakatCsvFn,
            importStoreCsv: importStoreCsvFn,
            importCreditCsv: importCreditCsvFn,
            searchCreditReport: searchCreditReportFn,
            searchZakatTransactionReport: searchZakatTransactionReportFn,
            searchDisbursementReport: searchDisbursementReportFn,
            searchDisbursementRequestApproval: searchDisbursementRequestApprovalFn,
            disbursementRequestApprove: disbursementRequestApproveFn,
            disbursementRequestReject: disbursementRequestRejectFn,
        };
    };
})();
(function () {
    'use strict';

    var maxSizeError = false;
    angular
        .module('app.admin')
        .directive('validFile', function () {
            return {
                require: 'ngModel',
                link: function (scope, el, attrs, ngModel) {
                    var maxSize = 1024 * 1024;// 1M
                    //change event is fired when file is selected
                    el.bind('change', function () {
                        scope.$apply(function () {
                            maxSizeError = false;
                            var fileSize = el[0].files[0].size;
                            if (fileSize > maxSize) {
                                maxSizeError = true;
                            }
                            ngModel.$setViewValue(el.val());
                            ngModel.$render();
                        });
                    });
                }
            }
        });

    angular
        .module('app.admin')
        .controller('bonusController', bonusController);


    bonusController.$inject = ['SVCS', 'bonusService', 'UniversityService', 'AuthenticationService'];

    function bonusController(SVCS, bonusService, UniversityService, AuthenticationService) {
        var vm = this;
        vm.zakatTmpLink = '{0}/Merchant/Content/bonus-kiplekash-template-v2.csv'.format(SVCS.Merchant);
        vm.storeTmpLink = '{0}/Merchant/Content/bonus-storecard-template.csv'.format(SVCS.Merchant);
        vm.creditTmpLink = '{0}/Merchant/Content/bonus-credit-template.csv'.format(SVCS.Merchant);

        vm.zakatModel = {
            csvFilePath: '',
            csvText: '',
            errorMsg: '',
            tipMsg: '',
            universityId: '',
        };


        vm.storeModel = {
            csvFilePath: '',
            csvText: '',
            errorMsg: '',
            tipMsg: ''
        };

        vm.creditModel = {
            csvFilePath: '',
            csvText: '',
            errorMsg: '',
            tipMsg: ''
        };

        vm.init = function () {
            vm.getUniversities();
        }
        vm.getUniversities = function () {
            UniversityService.GetPortalUniversity().then(function (data) {
                vm.isReadonly = false;
                vm.UniversityItems = data.list;
                var hasAdminPermission = AuthenticationService.hasPermissions(["ADMIN_USER"]);
                if (hasAdminPermission) {
                    vm.zakatModel.universityId = "";
                    vm.isReadonly = false;
                } else {
                    for (var i = 0; i < data.list.length; i++) {
                        var permission = data.list[i].UniversityId.trim() + "_ZAKAT_PIC";
                        var hasPermission = AuthenticationService.hasPermissions([permission]);
                        if (hasPermission) {
                            vm.zakatModel.universityId = data.list[i].UniversityId;
                            vm.isReadonly = true;
                            break;
                        }
                    }
                }

            })
        }

        vm.submitZakatForm = function (zakatForm) {
            if (!zakatForm.$valid) {
                vm.zakatModel.errorMsg = "Please choose a csv file.";
                return;
            }
            if (!vm.zakatModel.universityId) {
                vm.zakatModel.errorMsg = "File fail to upload. Please select the university category to proceed";
                return;
            }

            if (maxSizeError) {
                vm.zakatModel.errorMsg = "File fail to upload. File size exceed 1M";
                return;
            }
            var columns = ['UserName', 'IdNo', 'UniversityId', 'TotalPrefund'];
            var jsonData = vm.csvToJson(columns, vm.zakatModel.csvText);
            if (jsonData.length > 1000) {
                vm.zakatModel.errorMsg = "File fail to upload. Exceed maximum entry(1000).";
                return;
            }


            var errorMsg = vm.commonCheckZakatCSV(jsonData);
            if (errorMsg) {
                vm.zakatModel.errorMsg = errorMsg;
                return;
            }
            var requestItems = R.map(function (x) {
                return {
                    UserName: x.UserNameValue,
                    IdNo: x.IdNoValue,
                    UniversityId: x.UniversityIdValue,
                    TotalPrefund: x.TotalPrefundValue
                }
            }, jsonData);

            var dataRequest = { "UniversityCode": vm.zakatModel.universityId, "Items": requestItems }
            var errorMsg = "";


            bonusService.importZakatCsv(dataRequest)
                .then(function (responseData) {
                    vm.zakatModel.tipMsg = 'Successful';
                    vm.zakatModel.errorMsg = '';
                })
                .catch(function (responseError) {
                    vm.zakatModel.tipMsg = '';
                    if (responseError.status === 500) {
                        vm.zakatModel.errorMsg = 'Failed! Something has gone wrong. Please contact a system administrator.';
                        return;
                    }
                    vm.zakatModel.errorMsg = responseError.data.Message;
                });
        };

        vm.submitStoreForm = function (isValid) {
            if (!isValid) {
                vm.storeModel.errorMsg = "Please choose a csv file.";
                return;
            }
            var columns = ['UserName', 'Value', 'EntitlementDate', 'ExpiryDate', 'MerchantName'];
            var jsonData = vm.csvToJson(columns, vm.storeModel.csvText);

            var errorMsg = vm.commonCheckCSV(jsonData);

            if (errorMsg) {
                vm.storeModel.errorMsg = errorMsg;
                return;
            }

            bonusService.importStoreCsv(jsonData)
                .then(function (responseData) {
                    vm.storeModel.tipMsg = 'Successful';
                    vm.storeModel.errorMsg = '';
                })
                .catch(function (responseError) {
                    vm.storeModel.tipMsg = '';
                    if (responseError.status === 500) {
                        vm.storeModel.errorMsg = 'Failed! Something has gone wrong. Please contact a system administrator.';
                        return;
                    }
                    vm.storeModel.errorMsg = responseError.data.Message;
                });
        };

        vm.submitCreditForm = function (isValid) {
            if (!isValid) {
                vm.creditModel.errorMsg = "Please choose a csv file.";
                return;
            }
            //var columns = ['UserName', 'IDNumber', 'CampaignName', 'EntitlementDate', 'EWalletCredit'];
            var columns = ['UserName', 'CampaignName', 'EWalletCredit'];
            var jsonData = vm.csvToJson(columns, vm.creditModel.csvText);

            var mapIndexed = R.addIndex(R.map);
            var validJsonData = mapIndexed(function (val, idx) {
                return ({
                    index: idx + 1,
                    UserName: val.UserName,
                    CampaignName: val.CampaignName,
                    EWalletCredit: Number(val.EWalletCredit)
                });
            }, jsonData);

            var errorMsg = '';

            R.forEach(function (x) {

                var baseMsg = '<p>Data of row {0} is invalid.<p/>'.format(x.index);
                var innerMsg = '';
                if (!x.UserName) {
                    innerMsg += '<li>UserName cannot be empty</li>';
                }

                if (!x.CampaignName) {
                    innerMsg += '<li>CampaignName is mandatory</li>';
                }
                if (isNaN(x.EWalletCredit)) {
                    innerMsg += '<li>E-Wallet Credit ({0}) is invalid.</li>'.format(x.OldEWalletCredit);
                }
                if (innerMsg) {
                    errorMsg += '{0}<ul>{1}</ul>'.format(baseMsg, innerMsg);
                }

            }, validJsonData);

            if (errorMsg) {
                vm.creditModel.errorMsg = errorMsg;
                return;
            }

            bonusService.importCreditCsv(jsonData)
                .then(function (responseData) {
                    vm.creditModel.tipMsg = 'Successful';
                    vm.creditModel.errorMsg = '';
                })
                .catch(function (responseError) {
                    vm.creditModel.tipMsg = '';
                    if (responseError.status === 500) {
                        vm.creditModel.errorMsg = 'Failed! Something has gone wrong. Please contact a system administrator.';
                        return;
                    }
                    vm.creditModel.errorMsg = responseError.data.Message;

                });
        };
        vm.commonCheckZakatCSV = function (jsonData) {
            var errorMsg = '';
            for (var index = 0; index < jsonData.length; index++) {
                var oneData = jsonData[index];
                var baseMsg = '<p>Data of row {0} is invalid.<p/>'.format(index);
                var innerMsg = '';
                var userNameNumber = Number(oneData.UserName);
                if (isNaN(Number(userNameNumber))) {
                    innerMsg += '<li>Kiplekash user name ({0}) must include prefix 6 before the mobile number.</li>'.format(oneData.UserName);
                } else {
                    oneData.UserNameValue = userNameNumber.toString();
                    if (!oneData.UserNameValue.startsWith("6")) {
                        innerMsg += '<li>Kiplekash user name ({0}) must include prefix 6 before the mobile number.</li>'.format(oneData.UserNameValue);
                    }
                } 
                if (!oneData.UniversityId) {
                    innerMsg += '<li>University ID must have value.</li>';
                } else {
                    oneData.UniversityIdValue = oneData.UniversityId.toString();
                }
                var IdNoNumber = Number(oneData.IdNo);
                if (isNaN(Number(IdNoNumber))) {
                    innerMsg += '<li>ID Number({0}) Only numbers is allowed to input, no special characters.</li>'.format(oneData.IdNo);
                } else {
                    oneData.IdNoValue = IdNoNumber.toString();
                }
                var TotalPrefundNumber = Number(oneData.TotalPrefund);
                if (isNaN(Number(TotalPrefundNumber))) {
                    innerMsg += '<li>Total Prefund ({0}) must be integer.</li>'.format(oneData.TotalPrefund);
                } else {
                    oneData.TotalPrefundValue = TotalPrefundNumber.toString();
                    if (oneData.TotalPrefundValue.indexOf(".") > -1) {
                        innerMsg += '<li>Total Prefund ({0}) must be integer.</li>'.format(oneData.TotalPrefund);
                    }
                }
                if (innerMsg) {
                    errorMsg += '{0}<ul>{1}</ul>'.format(baseMsg, innerMsg);
                }
            }
            return errorMsg;
        };
        vm.commonCheckCSV = function (jsonData) {

            var mapIndexed = R.addIndex(R.map);
            var validJsonData = mapIndexed(function (val, idx) {
                return ({
                    index: idx + 1,
                    UserName: val.UserName,
                    OldValue: val.Value,
                    Value: Number(val.Value),
                    OldEntitlementDate: val.EntitlementDate,
                    EntitlementDate: new Date(val.EntitlementDate),
                    OldExpiryDate: val.ExpiryDate,
                    ExpiryDate: new Date(val.ExpiryDate),
                    MerchantName: val.MerchantName,
                });
            }, jsonData);

            var errorMsg = '';

            R.forEach(function (x) {
                var baseMsg = '<p>Data of row {0} is invalid.<p/>'.format(x.index);
                var innerMsg = '';
                if (isNaN(x.Value)) {
                    innerMsg += '<li>Kiplekash Value ({0}) is invalid.</li>'.format(x.OldValue);
                }
                if (!vm.isValidDate(x.EntitlementDate)) {
                    innerMsg += '<li>Entitlement Date ({0}) is invalid.</li>'.format(x.OldEntitlementDate);
                }
                if (!vm.isValidDate(x.ExpiryDate)) {
                    innerMsg += '<li>ExpiryDate Date ({0}) is invalid.</li>'.format(x.OldExpiryDate);
                }

                if (innerMsg) {
                    errorMsg += '{0}<ul>{1}</ul>'.format(baseMsg, innerMsg);
                }
            }, validJsonData);


            return errorMsg;
        };

        vm.resetForm = function (formModel) {
            formModel.csvFilePath = '';
            formModel.csvText = '';
            formModel.errorMsg = '';
            formModel.tipMsg = '';
            if (!!formModel.universityId)
                formModel.universityId = '';
        };

        vm.isValidDate = function (strDate) {
            return strDate instanceof Date && !isNaN(strDate);
        };

        vm.csvToJson = function (columns, csv) {

            var strJosn = R.compose(
                R.map(R.compose(
                    R.zipObj(columns),
                    R.split(',')
                )),
                R.filter(function (x) { return R.length(x) > 1 }),
                R.tail,
                R.split('\n')
            )(csv);

            return strJosn;
        };
    }
})();
(function () {
    angular
        .module('app.admin')
        .controller('annCreateOrUpdateCtrl', annCreateOrUpdateCtrl)

    annCreateOrUpdateCtrl.$inject = [
        '$scope',
        "$uibModalInstance",
        "modalData",
        "announcementService"];
    function annCreateOrUpdateCtrl($scope, $uibModalInstance, modalData, announcementService) {
        var vm = this;

        vm.currentDate = new Date();
        vm.modalData = modalData;
        vm.formData = vm.modalData.entity || {};


        vm.criterialist = [
            { Id: "AllKiplepayUsers", Name: "admin.notification.notificationcriteria_list.allKiplepay" },
            { Id: "AllRedpayUsers", Name: "admin.notification.notificationcriteria_list.allRedpay" },
        ];

        vm.entityId = vm.formData.Id || 0;

        vm.isCreateFlag = vm.entityId === 0 ? true : false;
        
        if (!vm.isCreateFlag) {
            vm.formData.expirationDate = new Date(vm.formData.expirationDate);
        }
        
        vm.formError = "";
        vm.modal = {
            ok: function (result) {
                $uibModalInstance.close(result);
            },
            cancel: function () {
                $uibModalInstance.dismiss('cancel');
            }
        };

        vm.onSubmit = function (isValid) {
            if (!isValid) {
                vm.formError = "Expiration Date is not valid";
                return;
            }
            

            var expirationDate = moment(vm.formData.expirationDate);
            var diff = moment(expirationDate).diff(vm.currentDate, 'minutes');
            if (diff < 0) {
                vm.formError = "Expiration Date cannot be less than currtime time.";
                return;
            }
            vm.formError = "";

            if (vm.isCreateFlag) {
                vm.doCreateAnnouncement(vm.formData);
            } else {
                vm.doUpdateAnnouncement(vm.formData);
            }
        };
        
        vm.doCreateAnnouncement = function (entityData) {
            announcementService.createAnnouncement(entityData)
                .then(function (response) {
                    vm.modal.ok(response.data);
                })
                .catch(function (errorInfo) {
                    vm.formError = errorInfo.data.Message;
                });
            return false;
        };

        vm.doUpdateAnnouncement = function (entityData) {
            announcementService.updateAnnouncement(entityData)
                .then(function (response) {
                    vm.modal.ok(response.data);
                })
                .catch(function (errorInfo) {
                    vm.formError = errorInfo.data.Message;
                });
            return false;
        };
    }
})();
(function () {
    angular
        .module('app.admin')
        .service('announcementService', announcementService)

    announcementService.$inject = [
        '$http',
        'SVCS'];

    function announcementService($http, SVCS) {
        var gatewayServer = SVCS.Gateway;
        var createAnnouncement = function (entity) {
            return $http.post(gatewayServer + '/api/announcement/create',
                entity,
                { headers: { 'Content-Type': 'application/json' } });
        }

        var updateAnnouncement = function (entity) {
            return $http.put(gatewayServer + '/api/announcement/update',
                entity,
                { headers: { 'Content-Type': 'application/json' } });
        }

        var deleteAnnouncement = function (entityId) {
            return $http.delete(gatewayServer + '/api/announcement/delete/' + entityId);
        }

        var searchAnnouncement = function (criteria) {
            return $http.get(gatewayServer + '/api/announcement/search',
                { params: criteria });
        }

        return {
            searchAnnouncement: searchAnnouncement,
            createAnnouncement: createAnnouncement,
            updateAnnouncement: updateAnnouncement,
            deleteAnnouncement: deleteAnnouncement
        };
    }
})();
(function () {
    angular
        .module('app.admin')
        .controller('announcementController', announcementController)     

    announcementController.$inject = [
        '$scope',
        '$timeout',
        "announcementService",
        "popupService"];
    function announcementController($scope, $timeout, announcementService, popupService) {
        var vm = this;

        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;

        vm.criteria = { Keyword: null, Page: 1, Length: 10 };
        vm.annListData = [];

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.initAnnouncementList();
            }
        }

        vm.reset = function () {
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.initAnnouncementList();
        }


        vm.initAnnouncementList = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            announcementService.searchAnnouncement(criteria)
                .then(function (response) {
                    vm.annListData = response.data.Items;
                    vm.totalItems = response.data.Total;
                });
        };


        vm.popupCreateOrUpdateForm = function (entityId) {
            entityId = entityId || "";
            var tmpEntity = _.find(vm.annListData, function (cat) {
                return _.isEqual(cat.Id, entityId);
            }) || {};
            var customModalOptions = {
                closeButtonText: 'Cancel',
                okButtonText: 'Sumbit',
                headerText: "Manage Announcement",
                bodyText: '',
                isCreateFlag: entityId ? true : false
            };

            var modalDefaults = {
                templateUrl: "app/admin/announcement/updatecreate.view.html",
                controller: "annCreateOrUpdateCtrl",
                controllerAs: "vm",
                resolve: {
                    modalData: function () {
                        return {
                            options: customModalOptions,
                            entity: {
                                Id: tmpEntity.Id,
                                title: tmpEntity.Title,
                                message: tmpEntity.Message,
                                expirationDate: tmpEntity.ExpirationDate,
                                criteria: tmpEntity.Criteria
                            }
                        };
                    }
                }
            };

            popupService.showModal(modalDefaults, customModalOptions).then(function (result) {
                vm.initAnnouncementList();
            }).catch(function (errorInfo) {
                
            });
        };

        vm.popupremoveForm = function (entityId) {
            var customModalOptions = {
                closeButtonText: 'Cancel',
                okButtonText: 'Confirm',
                headerText: "Delete Announcement",
                bodyText: "Are you sure you want to delete this Announcement?"
            };

            popupService.showModal({}, customModalOptions).then(function (result) {

                announcementService.deleteAnnouncement(entityId)
                    .then(function (response) {
                        $timeout(function () {
                            vm.initAnnouncementList();
                        }, 500);
                    })
                    .catch(function (errorInfo) {
                    });
            }).catch(function (errorInfo) {

            });
        }

        vm.initAnnouncementList();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('AdminUserService', AdminUserService);

    /** @ngInject */
    function AdminUserService(SVCS, $http, $q, CoreService) {
        var authServer = SVCS.Auth;
        var service = {
            Get: Get,
            Create: Create,
            Update: Update,
            Delete: Delete,
            Search: Search,
            GetRole: GetRole,
            CreateRole: CreateRole,
            UpdateRole: UpdateRole,
            DeleteRole: DeleteRole,
            SearchRole: SearchRole,
            GetPermissionList: GetPermissionList
        };

        return service;

        //#region Admin
        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(authServer + '/api/admin/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(model) {
            var deferer = $q.defer();

            CoreService.Post(authServer + '/api/admin', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(model) {
            var deferer = $q.defer();

            CoreService.Put(authServer + '/api/admin', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Delete(id) {
            var deferer = $q.defer();

            CoreService.Delete(authServer + '/api/admin/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Post(authServer + '/api/admin/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        //#endregion

        //#region Role
        function GetRole(id) {
            var deferer = $q.defer();

            CoreService.Get(authServer + '/api/admin/role/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function CreateRole(model) {
            var deferer = $q.defer();

            CoreService.Post(authServer + '/api/admin/role', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function UpdateRole(model) {
            var deferer = $q.defer();

            CoreService.Put(authServer + '/api/admin/role', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function DeleteRole(id) {
            var deferer = $q.defer();

            CoreService.Delete(authServer + '/api/admin/role/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function SearchRole(criteria) {
            var deferer = $q.defer();

            CoreService.Post(authServer + '/api/admin/role/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function GetPermissionList() {
            var deferer = $q.defer();

            CoreService.Get(authServer + '/api/admin/permission-list').then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        //#endregion
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('AdminUserController', AdminUserController);

    /** @ngInject */
    function AdminUserController(AdminUserService, $scope, $translate, $timeout, $window) {
        var vm = this;

        //#region Manage Admin User
        //#region Search user
        vm.criteria = {
            Keyword: null,
            Page: 1,
            Length: 10
        };

        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.itemsPerPage = 10;
        vm.maxSize = 10;  

        vm.getAllRoles = function () {
          AdminUserService.SearchRole({ Page: 1, Length: 1000 }).then(function (
            data
          ) {
            vm.allRoles = data.Items;
          });
        };

        vm.getAllRoles();

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        };

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            AdminUserService.Search(criteria).then(function (data) {
                vm.users = data.Items;
                vm.totalItems = data.Total;
            });
        }
        vm.search();

        vm.reset = function () {
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }
        //#endregion

        vm.clearAdminUserForm = function () {
            vm.adminUser = {
                UserName: null,
                Password: null,
                PasswordRetype: null
            };
            $scope.adminUserForm.$setPristine();
            $scope.adminUserForm.$setUntouched();
        }

        vm.viewConfig = {
            Action: null
        }

        vm.saveAdminUser = function () {
            if ($("#user-type").is(":checked")) {
                vm.adminUser.Type = true;
            } else {
                vm.adminUser.Type = false;
            }
            
            if ($("#redpayuser-type").is(":checked")) {
                vm.adminUser.UserType = true;
                vm.adminUser.Tag = "RedPay";
            } else {
                vm.adminUser.UserType = false;
                vm.adminUser.Tag = "Kiplepay";
            }
            if (!$scope.adminUserForm.$valid) {
                angular.forEach($scope.adminUserForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                        $('#adminUserForm .ng-invalid')[0].focus();
                    })
                });
                return;
            }

            if (vm.viewConfig.Action == 'new') {
                AdminUserService.Create(vm.adminUser).then(function (data) {
                     vm.search();
                     vm.cancelAdminUser();
                });
            }
            else if (vm.viewConfig.Action == 'edit') {
                AdminUserService.Update(vm.adminUser).then(function (data) {
                    vm.search();
                    vm.cancelAdminUser();
                });
            }

        }

        vm.addAdminUser = function () {
            vm.clearAdminUserForm();
            vm.viewConfig.Action = "new";
            vm.getAllRoles();
        }

        vm.editAdminUser = function (id) {
            $("#redpayuser-type").prop("checked", false);
            vm.clearAdminUserForm();

            vm.getAllRoles();

            AdminUserService.Get(id).then(function (data) {
                vm.adminUser = data;
                vm.adminUser.AccountRoles = vm.adminUser.AccountRoles[0];
                if (data.Tag == "RedPay") {
                    $("#redpayuser-type").prop("checked", true);
                    vm.adminUser.UserType = true;
                }
                else {
                    vm.adminUser.UserType = false;
                    $("#redpayuser-type").prop("checked", false);
                }
                if (data.AdminType == "NormaldAdmin") {
                    vm.adminUser.Type = true;
                    //$("#user-type").bootstrapToggle('on')
                } else {
                    vm.adminUser.Type = false;
                    //$("#user-type").bootstrapToggle('off')
                }
            });
            vm.viewConfig.Action = 'edit';
        }

        vm.cancelAdminUser = function () {
            vm.adminUser = null;
        }

        vm.deleteAdminUser = function (id) {
            $translate("admin.admin-user.confirm_remove").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }

                AdminUserService.Delete(id).then(function (data) {
                    vm.search();
                });
            });
        }
        //#endregion

        //#region Manage Role
        //#region Search Role
        vm.criteriaRole = {
            Keyword: null,
            Page: 1,
            Length: 10
        };

        vm.totalItemsRole = 0;
        vm.currentPageRole = 1;
        vm.itemsPerPageRole = 10;
        vm.maxSizeRole = 10;

        vm.searchByKeywordRole = function ($event) {
            if ($event.which == 13) {
                vm.searchRole();
            }
        };

        vm.searchRole = function () {
            var criteria = angular.copy(vm.criteriaRole);
            criteria.Page = vm.currentPageRole;
            AdminUserService.SearchRole(criteria).then(function (data) {
                vm.roles = data.Items;
                vm.totalItemsRole = data.Total;
            });
        }
        vm.searchRole();

        vm.resetRole = function () {
            vm.criteriaRole = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPageRole = 1;
            vm.searchRole();
        }
        //#endregion

        AdminUserService.GetPermissionList().then(function (data) {
            vm.groupsPermissions = data;
        });        

        vm.toggleAll = function () {
            var isSelectAll = vm.isSelectAll();
            angular.forEach(vm.groupsPermissions, function (group) {
                angular.forEach(group.Permissions, function (permission) {
                    var index = vm.role.RolePermissions.indexOf(permission.Id);
                    if (isSelectAll) {
                        if (index !== -1) {
                            vm.role.RolePermissions.splice(index, 1);
                        }
                    } else {
                        if (index === -1) {
                            vm.role.RolePermissions.push(permission.Id);
                        }
                    }
                });
            });
        }

        vm.isSelectAll = function () {
            var result = true;
            angular.forEach(vm.groupsPermissions, function (group) {
                angular.forEach(group.Permissions, function (permission) {
                    if (vm.role.RolePermissions.indexOf(permission.Id) === -1) {
                        result = false;
                    }
                });
            });
            return result;
        }

        vm.toggleGroup = function (group) {
            var isGroupChecked = vm.isGroupChecked(group);
            angular.forEach(group.Permissions, function (permission) {
                var index = vm.role.RolePermissions.indexOf(permission.Id);
                if (isGroupChecked) {
                    if (index !== -1) {
                        vm.role.RolePermissions.splice(index,1);
                    }
                } else {
                    if (index === -1) {
                        vm.role.RolePermissions.push(permission.Id);
                    }
                }
            });
        }

        vm.isGroupChecked = function (group) {
            var result = true;
            angular.forEach(group.Permissions, function (permission) {
                if (vm.role.RolePermissions.indexOf(permission.Id) === -1) {
                    result = false;
                }
            });
            return result;
        }

        vm.togglePermission = function (permission) {
            var index = vm.role.RolePermissions.indexOf(permission.Id);

            if (index === -1) {
                vm.role.RolePermissions.push(permission.Id);
            }
            else {
                vm.role.RolePermissions.splice(index,1);
            }
        }

        vm.isPermissionChecked = function (permission) {
            return (vm.role.RolePermissions.indexOf(permission.Id) !== -1);
        }
        //#endregion

        //#region Manage Role
        vm.clearRoleForm = function () {
            vm.role = {
                Name: null,
                RolePermissions: []
            };
            $scope.roleForm.$setPristine();
            $scope.roleForm.$setUntouched();
        }

        vm.viewConfigRole = {
            Action: null
        }

        vm.saveRole = function () {
            if (!$scope.roleForm.$valid) {
                angular.forEach($scope.roleForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                        $('#roleForm .ng-invalid')[0].focus();
                    })
                });
                return;
            }
            $timeout(function () {
                vm.role.RolePermissions = vm.role.RolePermissions;
                if (vm.viewConfigRole.Action == 'new') {
                    AdminUserService.CreateRole(vm.role).then(function (data) {
                        vm.searchRole();
                        vm.cancelRole();
                    });
                }
                else if (vm.viewConfigRole.Action == 'edit') {
                    AdminUserService.UpdateRole(vm.role).then(function (data) {
                        vm.searchRole();
                        vm.cancelRole();
                    });
                }
            }, 500);
        }

        vm.addRole = function () {
            vm.clearRoleForm();
            vm.viewConfigRole.Action = 'new';
            $timeout(function () {
                $('#group-permissions-scrollbar').height($window.outerHeight - 581);
            }, 100);
        }

        vm.editRole = function (id) {
            vm.clearRoleForm();
            AdminUserService.GetRole(id).then(function (data) {
                vm.role = data;
            });
            vm.viewConfigRole.Action = 'edit';
        }

        vm.cancelRole = function () {
            vm.viewConfigRole.Action = null;
            vm.role = null;
        }

        vm.deleteRole = function (id) {
            $translate("admin.admin-user.confirm_remove").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }

                AdminUserService.DeleteRole(id).then(function (data) {
                    vm.searchRole();
                });
            });
        }
        
        //#endregion
        //#endregion
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('BulkRegisterController', BulkRegisterController);

    /** @ngInject */
    function BulkRegisterController(SVCS, BulkRegisterService, $scope, $timeout) {
        var vm = this;
        vm.templateLink = SVCS.Merchant + "/Merchant/Content/BulkRegister-template.csv";

        var errorType = 0;
        vm.checkRow = function (data) {
            if (!isEmpty(data[0]) && !isEmpty(data[1]) && !isEmpty(data[2]) && !isEmpty(data[3]) && !isEmpty(data[4]) && !isEmpty(data[5]) && !isEmpty(data[6]) && !isEmpty(data[7]) && !isEmpty(data[8]) && !isEmpty(data[9])) {
                
                return true;
            }
            else {
                errorType = 1;
                
                return false;
            }
        }

        function isEmpty(val) {
            return (val === undefined || val == null || val.length <= 0) ? true : false;
        }

        vm.save = function () {
            if (!vm.fileContent) {
                alert("Please choose a csv file.");
            }
            else {
                var invalid = false;
                var title = ["LoginID", "University", "UniversityID", "Campus", "Nationality", "IDNo", "EmailId", "MobileNo", "FullName", "UserType"];
                angular.forEach(vm.fileContent.split("\r\n"), function (row, index) {
                    var char = "";
                    if (row.indexOf(";") !== -1) {
                        char = ";";
                    }
                    else {
                        char = ",";
                    }
                    var data = row.split(char);                  
                    if (index == 0) {                       
                        if (!angular.equals(title, data)) {
                            invalid = true;
                            alert("The title is invalid. (" + title + ")");
                        }
                    }
                    else {                      
                        if (data.length == 10) {                            
                            if (!vm.checkRow(data)) {
                                invalid = true;
                                var base_message = "Data of row " + index + " is invalid.\n";
                                var message = base_message;
                                
                                switch (errorType) {
                                    case 1:
                                        message = base_message + "(LoginID,University,UniversityID,Campus,Nationality,ID No,EmailId,Mobile No, Full Name, User Type) Mandatory.";
                                        break;
                                }
                                alert(message);
                            }
                        }
                    }
                });

                if (!invalid) {
                    var model = [];

                    angular.forEach(vm.fileContent.split("\r\n"), function (row, index) {
                        var char = "";
                        if (row.indexOf(";") !== -1) {
                            char = ";";
                        }
                        else {
                            char = ",";
                        }
                        var data = row.split(char);
                        if (index != 0 && data.length == 9) {
                            model.push({
                                "LoginID": data[0],
                                "University": data[1],
                                "UniversityID": data[2],
                                "Campus": data[3],
                                "Nationality": data[4],
                                "IDNo": data[5],
                                "EmailId": data[6],                                
                                "MobileNo": data[7],
                                "FullName": data[8]                               
                            });
                        }
                    });

                    var fileUpload = $('.input_file').get(0);
                    var files = fileUpload.files;
                    var data = new FormData();
                    for (var i = 0; i < files.length; i++) {
                        data.append(files[i].name, files[i]);
                    }

                    BulkRegisterService.ImportCSVIForm(data).then(function (res) {
                        if (res.status == 200) {
                            alert(res.data);
                        }
                    });

                }

            }
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('BulkRegisterService', BulkRegisterService);

    /** @ngInject */
    function BulkRegisterService(SVCS, $http, $q, CoreService) {
        var walletServer = SVCS.Wallet;

        var service = {
            ImportCSV: ImportCSV,
            ImportCSVIForm: ImportCSVIForm,
        };

        return service;
       
        function ImportCSV(model) {
            var deferer = $q.defer();
            CoreService.Post(walletServer + '/api/BulkRegister', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function ImportCSVIForm(file) {
            var deferer = $q.defer();
            $http.post(
                walletServer + '/api/BulkRegister/csv/upload/', file,
                {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                }
            ).then(function (response) {
                deferer.resolve(response);
            })
            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('BannerService', BannerService);

    /** @ngInject */
    function BannerService(SVCS, $http, $q, CoreService) {
        var profileServer = SVCS.Profile;
        var gatewayServer = SVCS.Gateway;

        var service = {
           
            Get: Get,
            Search: Search,
            Create: Create,
            Update: Update,
            Remove: Remove,
            UploadPhoto: UploadPhoto
        };

        return service;

      

        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/profiles/GetBannerById/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Get(profileServer + '/api/profiles/GetBanner', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(banner) {
            var deferer = $q.defer();

            CoreService.Post(profileServer + '/api/profiles/CreateBanner', banner).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(banner) {
            var deferer = $q.defer();
         
            CoreService.Post(profileServer + '/api/profiles/UpdateBanner', banner).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Remove(id) {
            var deferer = $q.defer();

            CoreService.Delete(profileServer + '/api/profiles/DeleteBanner/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        function UploadPhoto(img) {
            var deferer = $q.defer();

            var formData = new FormData();
            formData.append('file', img);

            $http.post(gatewayServer + '/api/photos/uploadHomepageBanner', formData, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .controller('BannerController', BannerController);

    /** @ngInject */
    function BannerController(SVCS, $translate, BannerService, UniversityService, $scope) {
        var vm = this;
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 10;
        vm.itemsPerPage = 10;
        vm.banners = {};
        vm.disabledPosition = false;
        vm.banner = {
            Id: 0,
            UniversityId: "NormalUser",
            Channel: "0",
            BannerFlag: "0",
            Link: "",
            Position: 1,
            Photos: [],
            IsPrimary: false,
            BannerLayers: 0,
            Name:""
        };


        vm.BanneLayerOptions = [
            { Id: 0, Name: "HappeningStuff" },
            { Id: 1, Name: "Our Fav Partner" },
            { Id: 2, Name: "Home Page" },
            { Id: 3, Name: "Store Page" },
            { Id: 4, Name: "Visa Page" }]

        vm.criteria = { Keyword: null, BannerLayer: null, BannerFlag: null, Page: 1, Length: 10 };

        vm.channelList = [
            {
                value: "0",
                text: "Kiplepay"
            },
            {
                value: "3",
                text: "RedPay"
            }
        ];
        vm.bannerTypeList = [
            {
                value: "0",
                text: "Home Page"
            },
            {
                value: "1",
                text: "Store Page"
            },
            {
                value: "2",
                text: "Visa Page"
            },
        ];

        vm.viewConfig = { ShowDialog: false, Action: null };

        vm.searchByKeyword = function ($event) {
            vm.search();
        }

        vm.search = function () {
            vm.criteria.BannerFlag = null;
            if (vm.criteria.BannerLayer == 2) {
                vm.criteria.BannerFlag = 0;
                vm.criteria.BannerLayer = null;
            }
            else if (vm.criteria.BannerLayer == 3) {
                vm.criteria.BannerFlag = 1;
                vm.criteria.BannerLayer = null;
            }
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            
            BannerService.Search(criteria).then(function (res) {
                vm.banners = res.Items;
                vm.totalItems = res.Total;
            })
        }

        vm.reset = function () {
            vm.criteria = { Keyword: null, BannerLayer: null, BannerFlag: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }
        vm.CheckPrimary = function () {
            if (vm.banner.IsPrimary == true) {
                vm.disabledPosition = true;
                vm.banner.Position = 1;
            }
            else {
                vm.disabledPosition = false;
                vm.banner.Position = 1;
            }
        }
        vm.clearForm = function () {
            vm.banner = {
                Id: 0,
                UniversityId: "NormalUser",
                Channel: "0",
                BannerFlag: "0",
                Link: "",
                Position: 1,
                Photos: [],
                IsPrimary: false,
                BannerLayers: 0,
                Name:""
            }

            $scope.bannerForm.$setPristine();
            $scope.bannerForm.$setUntouched();
        }

        vm.openDialog = function (action, banner) {
            vm.viewConfig.Action = action;
            //vm.banner = {
            //    UniversityId: "NormalUser",
            //    Link: "",
            //    Position: 0,
            //    Photos: []
            //}
            vm.clearForm();
            UniversityService.GetListOfUniveristies().then(function (res) {
                vm.universtyList = res.list;;

            });
            if (action == 'edit') {

                //vm.banner = angular.copy(banner);
                BannerService.Get(banner.Id).then(function (res) {
                    if (res != null) {
                        vm.banner = {
                            Id: res.Id,
                            UniversityId: res.UniversityId,
                            Channel: res.Channel === "RedPay" ? "3" : "0",
                            BannerFlag: res.BannerFlag === "StorePage" ? "1" : "0",
                            Link: res.Link,
                            Position: res.Position,
                            Photos: [],
                            IsPrimary: res.IsPrimary,
                            BannerLayers: res.BannerLayer == "MyFavourites" ? 1 : 0,
                            Name: res.Name
                        }
                        vm.banner.Photos.push(res.Photos);
                        vm.viewConfig.ShowDialog = true;
                        console.log("hello");
                        console.log(vm.banner);
                    }

                });
            }
            else {
                vm.disabledPosition = false;
                vm.banner.Position = 1;
                vm.viewConfig.ShowDialog = true;
            }
        }

        vm.save = function () {

            if (!$scope.bannerForm.$valid) {
                angular.forEach($scope.bannerForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#bannerForm .ng-invalid')[0].focus();
                return;
            }
            if (vm.banner.IsPrimary == true) {
                vm.banner.UniversityId = "";
            }

            if (vm.banner.Channel === "1") {
                vm.banner.UniversityId = "";
            }

            if (vm.banner.Photos.length === 0) {
                alert("Please upload banner photo");
                return;
            }

            if (vm.viewConfig.Action == 'new') {


                
                BannerService.Create(vm.banner).then(function (res) {
                    if (res != null) {
                        vm.search();
                        vm.cancel();
                        alert("Saved Successfully");
                    }
                }).catch(function (res) {
                    console.log("log:" + res);
                });

            }
            else {
                BannerService.Update(vm.banner).then(function (res) {
                    if (res != null) {
                        vm.search();
                        vm.cancel();
                        alert("Updated Successfully");
                    }
                });
            }
        }

        vm.cancel = function () {
            vm.viewConfig.ShowDialog = false;
            //vm.group = undefined;
            vm.Action = null;
        }

        vm.remove = function (banner) {
            $translate("admin.banner.confirm_remove").then(function (message) {
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }

                BannerService.Remove(banner.Id).then(function (res) { vm.banners.removeItem(banner) });
            })
        }

        vm.search();

        //#region Upload photos
        vm.temp = {};
        vm.uploadPhoto = function (files, invalidFiles) {

            if (invalidFiles.length) {
                $translate('banner.validate.photo.file_invalid', { name: invalidFiles[0].name }).then(function (msg) {
                    alert(msg);
                })
                return;
            }

            if (!files || !files.length) {
                return;
            }
            sequentialUpload(files, 0, [], sequentialUploadCompleted);
        };

        vm.removePhoto = function (idx) {
            vm.banner.Photos.splice(idx, 1);
        }

        function sequentialUpload(files, i, errorsFiles, callback) {
            BannerService.UploadPhoto(files[i]).then(function (photo) {
                vm.banner.Photos.push(photo.Result);
            }, function (error) {
                errorsFiles.push({ file: files[i], error: error });
            }).then(function () {
                if (files.length === i + 1) {
                    callback(errorsFiles);
                } else {
                    sequentialUpload(files, i + 1, errorsFiles, callback);
                }
            });
        }

        function sequentialUploadCompleted(errorsFiles) {
            var filesNames = [];
            if (errorsFiles && errorsFiles.length) {
                angular.forEach(errorsFiles, function (item) {
                    filesNames.push(errorsFiles.file.name);
                })
            }

            if (filesNames.length) {
                $translate('banner.validate.photo.upload_error', { names: filesNames.join(', ') }).then(function (msg) {
                    alert(msg);
                })
            }
        }
        //#endregion
    }
})();
(function () {
    'use strict';

    angular
        .module('app.admin')
        .factory('BulkRegisterPartnerService', BulkRegisterPartnerService);

    /** @ngInject */
    function BulkRegisterPartnerService(SVCS, $http, $q, CoreService) {
        var walletServer = SVCS.Wallet;

        var service = { 
            ImportCSVIForm: ImportCSVIForm,
            searchUserCreationReport: searchUserCreationReportFn,
            ImportUserProfileReportCSVIForm: ImportUserProfileReportCSVIForm,
            ImportWalletUpgradeCSVIForm: ImportWalletUpgradeCSVIForm
        };

        return service;
        
        function searchUserCreationReportFn(jsonData) {
            var url = '{0}/api/BulkRegister/upload-batch'.format(walletServer);
            return $http.post(url, jsonData, { headers: { 'Content-Type': 'application/json' } });
        };
        function ImportCSVIForm(file) {
            var deferer = $q.defer();
            $http.post(
                walletServer + '/api/BulkRegister/csv/upload/v1', file,
                {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                }
            ).then(function (response) {
                deferer.resolve(response);
            })
            return deferer.promise;
        }

        function ImportUserProfileReportCSVIForm(file) {
            var deferer = $q.defer();
            $http.post(
                walletServer + '/api/BulkRegister/csv/user-profile-report/v2', file,
                {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                }
            ).then(function (response) {
                const d = new Date();
                var day = d.getDate();
                var month = d.getMonth() + 1;
                var year = d.getFullYear();
                var file_name = 'KiplePay_User_Profile_' + year + '_' + month + '_' + day +'.csv';
                var csvData = new Blob([response.data], { type: 'text/csv' });
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                    window.navigator.msSaveOrOpenBlob(csvData, file_name);
                } else { // for Non-IE (chrome, firefox etc.)
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    var csvUrl = URL.createObjectURL(csvData);
                    a.href = csvUrl;
                    a.download = file_name;
                    a.click();
                    URL.revokeObjectURL(a.href)
                    a.remove();
                }
                deferer.resolve(response);
            })
            return deferer.promise;
        }
        function ImportWalletUpgradeCSVIForm(file) {
            var deferer = $q.defer();
            $http.post(
                walletServer + '/api/BulkRegister/csv/automate-wallet-upgradation', file,
                {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                }
            ).then(function (response) {
                deferer.resolve(response);
            })
            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.voucher', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.voucher', {
                url: '/voucher',
                templateUrl: 'app/voucher/voucher.html',
                controller: 'VoucherController',
                controllerAs: 'vm',
                protect: true,
                permissions: ['VIEW_PRODUCT']
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/voucher');
    }
})();
(function () {
    'use strict';

    angular
        .module('app.voucher')
        .factory('VoucherService', VoucherService);

    /** @ngInject */
    function VoucherService(SVCS, $http, $q) {
        var productServer = SVCS.Product;
        var gatewayServer = SVCS.Gateway;

        var service = {
            Get: Get,
            GetAll: GetAll,
            Create: Create,
            Update: Update,
            Delete: Delete,
            Search: Search,
            UploadVoucherImage: UploadVoucherImage,
            DeletePhoto: DeletePhoto,
            Publish: Publish,
            Unpublish: Unpublish,
        };

        return service;

        function Get(id) {
            var deferer = $q.defer();

            $http.get(productServer + '/api/vouchers/' + id + '/false')
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function GetAll() {
            var deferer = $q.defer();

            $http.get(productServer + '/api/vouchers/me')
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function Create(voucher) {
            var deferer = $q.defer();

            $http.post(productServer + '/api/vouchers', voucher)
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function Update(voucher) {
            var deferer = $q.defer();

            $http.put(productServer + '/api/vouchers', voucher)
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function Delete(id) {
            var deferer = $q.defer();

            $http.delete(productServer + '/api/vouchers/' + id)
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function Publish(id) {
            var deferer = $q.defer();    
            var model = { Id: id };
            $http.put(productServer + '/api/vouchers/publish', model)
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });
            return deferer.promise;
        }

        function Unpublish(id) {        
            var deferer = $q.defer();   
            var model = { Id: id };
            $http.put(productServer + '/api/vouchers/unpublish', model)
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });
            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            $http.post(productServer + '/api/vouchers/dashboard/search', criteria)
                .then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }

        function UploadVoucherImage(img) {
            var deferer = $q.defer();

            var formData = new FormData();
            formData.append('file', img);

            $http.post(gatewayServer + '/api/photos/upload', formData, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).then(function (response) {
                deferer.resolve(response.data);
                }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        function DeletePhoto(path) {
            var deferer = $q.defer();

            var model = {
                path: path
            };
    
            $http.post(productServer + '/api/vouchers/delete-photo', model).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseErrors) {
                deferer.reject(responseErrors.data);
            });

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.voucher')
        .controller('VoucherController', VoucherController);

    /** @ngInject */

    function VoucherController(SVCS, VoucherService, $state, $scope, $translate, MerchantService, DataService, $cookies) {
        var vm = this;
        vm.productServer = SVCS.Product + '/';
        var uploadImgControl = null;
        vm.isAdmin = $cookies.get('account_type') == 1 ? true : false;

        vm.loading = false;
        vm.loading = {
            UploadVoucherImage: false,
            SaveVoucher: false,
            Vouchers: false
        }

        vm.disabledDeletePhoto = true;
        vm.isDeletePhoto = false;
        vm.IsAlluniversity = true;
        vm.IsUserCatetory = true;
        vm.criteria = {
            Keyword: null,
            Category: null,
            MerchantId: null,
            VoucherID: null,
            UniversityId:null,
            Page: 1,
            Length: 10
        };

        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 5;

        vm.viewConfig = {
            ShowDialog: false,
            Action: null
        };

        

        vm.clearForm = function () {
            vm.voucher = {
                Name: null,
                Description: null,
                ExpireDate: null,
                OldPrice: null,
                Price: null,
                DiscountType: null,
                Amount: null,
                Photo: null,
                TermsAndConditions: null,
                Categories: [],
                Subsidy:null
            }

            if (uploadImgControl) {
                uploadImgControl.val('');
            }

            $scope.VoucherForm.$setPristine();
            $scope.VoucherForm.$setUntouched();
            delete ($scope.VoucherForm.ExpireDate.$error.checkError);

        }

        vm.discountType = [
            { "id": "FixedAmount", "name": "Fixed Amount" },
            { "id": "Percentage", "name": "Percentage" }
        ];

        vm.Subsidy = [
            { "id": "FixedAmount", "name": "Fixed Amount" }            
        ];
        
        DataService.AllMerchantCategories().then(function (data) {
            vm.categories = data.Result;
        });

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        };

        vm.UniversityIdClick = function () {              
            MerchantService.Search({ VoucherID: vm.voucher.Id, UniversityId: vm.voucher.UniversityId }).then(function (res) {
                vm.merchants = res.Items;
                vm.UniversityItems = res.OtherItems;             
            });
            if (vm.voucher.UniversityId != null && vm.voucher.UniversityId != '') {
                vm.voucher.MerchantId = null;
                vm.voucher.UserCategory = true;
                vm.IsUserCatetory = false;
                vm.IsAlluniversity = false;
            } else {
                    vm.IsUserCatetory = true;
                    vm.IsAlluniversity = true;
                    vm.voucher.UserCategory = false;
                    vm.UniversityItems = null;
                    vm.voucher.IsUniversity = false;

                }
            }
        

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            if (criteria.MerchantId == null) {
                criteria.MerchantId = 0;
            }
            criteria.Page = vm.currentPage;
            VoucherService.Search(criteria).then(function (data) {
                vm.vouchers = data.Items;
                vm.totalItems = data.Total;
            });
        }

        vm.reset = function () {
            vm.criteria = {
                Keyword: null,
                Category: null,
                MerchantId: null,
                VoucherID: null,
                UniversityId: null,
                SaleEndDate: null,
                SaleStartDate: null,
                Page: 1,
                Length: 10
            };
            vm.search();
           
           
        }

        vm.add = function () {
            vm.voucher = {};
            vm.viewConfig.ShowDialog = true;
            vm.viewConfig.Action = 'new';
            vm.isDeletePhoto = true;
            vm.disabledDeletePhoto = true;
            vm.clearForm();
            MerchantService.Search({ Page: 1}).then(function (res) {
               vm.merchants = null;
                vm.UniversityItems = res.OtherItems;
                vm.search();
            });

            var d = new Date();
            d.setHours(0);
            d.setMinutes(0);
            vm.SaleStartTime = d;
            vm.SaleEndTime = d;
            vm.ExpireDateTime = d;
       
        }

        vm.edit = function (voucherId) {
            MerchantService.Search({ Page: 1, Length: 10 }).then(function (res) {
                vm.merchants = res.Items;
                vm.UniversityItems = res.OtherItems;
                vm.search();
            });
            angular.element("input[type='file']").val(null);
            VoucherService.Get(voucherId).then(function (data) {
                vm.voucher = data;
                MerchantService.Search({ Keyword: vm.voucher.MerchantName, VoucherID: vm.voucher.Id, UniversityId: vm.voucher.UniversityId }).then(function (res) {
                    vm.merchants = res.Items;
                });
                vm.viewConfig.ShowDialog = true;
                vm.viewConfig.Action = 'edit';

                vm.voucher.ExpireDate = new Date(vm.voucher.ExpireDate);
                vm.voucher.SaleStartDate = new Date(vm.voucher.SaleStartDate);
                vm.voucher.SaleEnddate = new Date(vm.voucher.SaleEnddate);

                const ExpireDateTime = new Date(Date.parse(vm.voucher.ExpireDate));
                var TimeSet = new Date();
                TimeSet.setHours(ExpireDateTime.getHours());
                TimeSet.setMinutes(ExpireDateTime.getMinutes());
                vm.ExpireDateTime = TimeSet;

                const SaleEndTime = new Date(Date.parse(vm.voucher.SaleEnddate));
                var TimeSet = new Date();
                TimeSet.setHours(SaleEndTime.getHours());
                TimeSet.setMinutes(SaleEndTime.getMinutes());
                vm.SaleEndTime = TimeSet;


                const StartDate = new Date(Date.parse(vm.voucher.SaleStartDate));
                var TimeSet = new Date();
                TimeSet.setHours(StartDate.getHours());
                TimeSet.setMinutes(StartDate.getMinutes());
                vm.SaleStartTime = TimeSet;

                vm.isDeletePhoto = false;
                if (vm.voucher.Photo) {
                    vm.disabledDeletePhoto = false;
                } else {
                    vm.disabledDeletePhoto = true;
                }

                var categories = [];
                angular.forEach(vm.voucher.Categories, function (item) {
                    categories.push(item.CategoryId);
                })
                vm.voucher.Categories = categories;

            });
        }

        vm.save = function () {           
            vm.isDeletePhoto = false;
            vm.loading.saveVoucher = true;   
            if (vm.voucher.MerchantId == null || vm.voucher.MerchantId == '') { vm.voucher.MerchantId = 0; }
            if (vm.voucher.UniversityId == null || vm.voucher.UniversityId == '') { vm.voucher.UniversityId = 0; }

            if (vm.voucher.IsUniversity == true) {
                if (vm.voucher.UniversityId == 0) {
                    alert('Select University or Merchant');
                    return false;
                }
            }
            if (vm.voucher.UniversityId != 0 && vm.voucher.IsUniversity == false && vm.voucher.MerchantId == 0) {
                alert('Select University or Merchant');  
               // alert('Hai1');  
                return false;
            }
            else if (vm.voucher.UniversityId != 0 && vm.voucher.IsUniversity == true && vm.voucher.MerchantId != 0) {
                alert('Select University or Merchant');  
               // alert('Hai2');
                return false;
            }
            else if (vm.voucher.UniversityId == 0 && vm.voucher.IsUniversity == false && vm.voucher.MerchantId == 0) {
                alert('Select University or Merchant');    
               // alert('Hai3');
                return false;
            }
            else if (vm.voucher.UniversityId != 0 && vm.voucher.IsUniversity == true && vm.voucher.MerchantId != 0) {
                alert('Select University or Merchant'); 
               // alert('Hai4');
                return false;
            }

            if (!$scope.VoucherForm.$valid) {              
                angular.forEach($scope.VoucherForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#VoucherForm .ng-invalid')[0].focus();
                return;
            }

            if (!angular.equals({},$scope.VoucherForm.ExpireDate.$error)) {
                $('input[name=ExpireDate]')[0].focus();
                return;
            }

            var categories = [];
            angular.forEach(vm.voucher.Categories, function (item) {
                categories.push({ "CategoryId": item });
            })
            vm.voucher.Categories = categories;


            vm.voucher.ExpireDate = new Date(vm.voucher.ExpireDate);
            vm.voucher.SaleStartDate = new Date(vm.voucher.SaleStartDate);
            vm.voucher.SaleEnddate = new Date(vm.voucher.SaleEnddate);
            var Dateandtime = new Date();
            Dateandtime = new Date(vm.voucher.ExpireDate);
            Dateandtime.setHours(vm.ExpireDateTime.getHours());
            Dateandtime.setMinutes(vm.ExpireDateTime.getMinutes());
            vm.voucher.ExpireDate=Dateandtime;

            Dateandtime = new Date(vm.voucher.SaleStartDate);
            Dateandtime.setHours(vm.SaleStartTime.getHours());
            Dateandtime.setMinutes(vm.SaleStartTime.getMinutes());
            vm.voucher.SaleStartDate = Dateandtime;

            Dateandtime = new Date(vm.voucher.SaleEnddate);
            Dateandtime.setHours(vm.SaleEndTime.getHours());
            Dateandtime.setMinutes(vm.SaleEndTime.getMinutes());
            vm.voucher.SaleEnddate = Dateandtime;

            if (vm.viewConfig.Action == 'new') {
                VoucherService.Create(vm.voucher).then(function (data) {
                    vm.search();
                    //vm.vouchers.push(vm.voucher);
                });
                vm.viewConfig.ShowDialog = false;
                vm.viewConfig.Action = null;

            }
            else if (vm.viewConfig.Action == 'edit') {
                VoucherService.Update(vm.voucher).then(function (data) {
                    vm.search();
                });
                vm.viewConfig.ShowDialog = false;
                vm.viewConfig.Action = null;
            }
        }

        vm.cancel = function () {
            if (vm.viewConfig.Action == 'new' && vm.voucher.Photo != null) {
                vm.deletePhoto();
            };

            vm.viewConfig.Action = null;
            vm.viewConfig.ShowDialog = false;
        }

        if (vm.isAdmin) {
            vm.search();
            //MerchantService.Search({}).then(function (res) {
            //    vm.merchants = res.Items;
            //    vm.search();
            //});
        }
        else {
            vm.search();
        }

        vm.loadMerchant = function (keyword) {   

            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = res.Items;
                });
            } else {
                vm.merchants = null;
            }
        }
        vm.loadMerchant1 = function (keyword) {
          
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword, UniversityId: vm.voucher.UniversityId }).then(function (res) {
                    vm.merchants = res.Items;
                    vm.UniversityItems = res.OtherItems;
                });
            } else {
                vm.merchants = null;
            }
        }
        vm.loadUniversity = function (keyword) {
            if (keyword.length == 0) {
                MerchantService.Search({ Keyword: keyword, VoucherID: vm.voucher.Id, UniversityId: vm.voucher.UniversityId}).then(function (res) {
                    vm.merchants = res.Items;
                    vm.UniversityItems = res.OtherItems;
                });
            } else {
                vm.UniversityItems = null;
            }
        }

        vm.delete = function (id) {
            VoucherService.Delete(id).then(function (data) {
                vm.search();
            })
        }
        vm.Unpublish = function (id) {
            VoucherService.Unpublish(id).then(function (data) {
                vm.search();
            })
        }
        vm.Publish = function (id) {
            VoucherService.Publish(id).then(function (data) {
                vm.search();
            })
        }

        //UploadAvatar
        vm.onVoucherPhotoSelected = function (files, controlGetter) {
            uploadImgControl = controlGetter();
            if (files != null && files.length) {
                vm.loading.UploadVoucherImage = true;
                VoucherService.UploadVoucherImage(files[0]).then(function (path) {
                    vm.loading.UploadVoucherImage = false;
                    vm.disabledDeletePhoto = false;
                    if (path) {
                        vm.voucher.Photo = path.Result;
                        $scope.VoucherForm.Photo.$setTouched();

                    }
                }, function (error) {
                    vm.loading.UploadVoucherImage = false;              
                })
            }
        }

        vm.deletePhoto = function () {
            if (vm.voucher.Photo) {
                //VoucherService.DeletePhoto(vm.voucher.Photo).then(function () {
                    vm.voucher.Photo = null;
                    vm.disabledDeletePhoto = true;
                    angular.element("input[type='file']").val(null);
                //});
            }
            else {
                return;
            }
        }

        // Datepicker popup
        var maxDate = new Date();
        maxDate.setFullYear(maxDate.getFullYear() + 1);
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: maxDate,
            minDate: new Date(),
            startingDay: 1
        };

        vm.dateOptionsEndDate = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: maxDate,
            minDate: new Date(),
            startingDay: 1
        };
        vm.dateOptionsStartDate = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            maxDate: maxDate,
            minDate: new Date(),
            startingDay: 1
        };

        vm.IsUniversityChanged = function () {            
            if (vm.voucher.IsUniversity == true) {
                vm.voucher.MerchantId = 0;               
            }
        }

        vm.SaleDateChanged = function () {
            if (vm.voucher.SaleStartDate != null) {
                const VDate = new Date(Date.parse(vm.SaleStartTime));
                vm.voucher.SaleStartDate.setHours(VDate.getHours(), VDate.getMinutes(), 0);  
            }
            if (vm.voucher.SaleEndTime != null) {
                const VDate = new Date(Date.parse(vm.SaleEndTime));
                vm.voucher.SaleEnddate.setHours(VDate.getHours(), VDate.getMinutes(), 0);
            }
            if (vm.voucher.ExpireDate != null) {
                const VDate = new Date(Date.parse(vm.ExpireDateTime));
                vm.voucher.ExpireDate.setHours(VDate.getHours(), VDate.getMinutes(), 0);
            }
            

            vm.dateOptionsEndDate = {
                //dateDisabled: disabled,
                formatYear: 'yy',
                maxDate: maxDate,
                minDate: vm.voucher.SaleStartDate ? vm.voucher.SaleStartDate : new Date(),
                startingDay: 1
            };

            vm.dateOptionsStartDate = {
                //dateDisabled: disabled,
                formatYear: 'yy',
                maxDate: maxDate,
                minDate: new Date(),
                startingDay: 1
            };

            if (vm.voucher.SaleStartDate > vm.voucher.SaleEnddate) {
                vm.voucher.SaleEnddate = vm.voucher.SaleStartDate;
            }

            vm.dateOptions = {
                //dateDisabled: disabled,
                formatYear: 'yy',
                maxDate: maxDate,
                minDate: vm.voucher.SaleEnddate ? vm.voucher.SaleEnddate: new Date(),
                startingDay: 1
            };
            if (vm.voucher.ExpireDate && vm.voucher.ExpireDate < vm.voucher.SaleEnddate) {
                $scope.VoucherForm.ExpireDate.$error.checkError = true;
            } else {
                delete ($scope.VoucherForm.ExpireDate.$error.checkError);
                $scope.VoucherForm.ExpireDate.$invalid = false;
            }
        }

        // Disable weekend selection
        function disabled(data) {
            var date = data.date,
                mode = data.mode;
            return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
        }

        vm.openExpireDatePopup = function () {
            vm.expireDatePopup.opened = true;
        };
        vm.openSaleStartDatePopup = function () {
            vm.saleStartDatePopup.opened = true;
        };
        vm.openSaleEndDatePopup = function () {
            vm.saleEndDatePopup.opened = true;
        };

        vm.expireDatePopup = {
            opened: false
        };
        vm.saleStartDatePopup = {
            opened: false
        };
        vm.saleEndDatePopup = {
            opened: false
        };
        // Datepicker popup

        vm.summernoteOptions = {
            height: 300,
            toolbar: [
                ['headline', ['style']],
                ['style', ['bold', 'italic', 'underline']],
                ['fontface', ['fontname']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol', 'paragraph', 'lineheight']],
                ['height', ['height']],
                ['table', ['table']],
                ['view', ['codeview']]
            ]
        };

        vm.calculateAmount = function () {
            if (vm.voucher.DiscountType == 'Percentage') {

                vm.voucher.Amount = Math.round((100 - vm.voucher.Price * 100 / vm.voucher.OldPrice) * 100) / 100;
            }
            else if (vm.voucher.DiscountType == 'FixedAmount') {
                vm.voucher.Amount = Math.round((vm.voucher.OldPrice - vm.voucher.Price) * 100) / 100;
            }
            else {
                vm.voucher.Amount = 0;
            }           
        }
        vm.SubsidyAmount = function () {         
            vm.voucher.MerchantSubsidyAmount = 0;
         }
        //vm.calculateSubsidyAmount = function () {
        //    if (vm.voucher.Subsidy == 'Percentage') {
        //        if (vm.voucher.MerchantSubsidyAmount != 100) {
        //            if (parseInt(vm.voucher.MerchantSubsidyAmount) > 100) {
        //                alert("Enter only Percentage value,below 100");
        //                vm.voucher.MerchantSubsidyAmount = 0;
        //            }

        //        }                            
        //    }
        //    else if (vm.voucher.Subsidy == 'FixedAmount') {
        //        var voucheramount = parseInt(vm.voucher.OldPrice) - parseInt(vm.voucher.Price);
        //        if (parseInt(vm.voucher.MerchantSubsidyAmount) > voucheramount) {
        //            alert("Subsidy Amount " + voucheramount + " Enter below this amount");
        //            vm.voucher.MerchantSubsidyAmount = 0;

        //        }
        //        else {
        //            vm.voucher.KipleSubsidyAmount = parseInt(vm.voucher.OldPrice) - parseInt(vm.voucher.MerchantSubsidyAmount)
        //        }
        //    }
        //    else {
        //        vm.voucher.MerchantSubsidyAmount = 0;
        //    }
        //}

     
        vm.calculateSubsidyAmount = function () {
            if (vm.voucher.Subsidy == 'Percentage') {
                if (vm.voucher.MerchantSubsidyAmount != 100) {
                    if (parseInt(vm.voucher.MerchantSubsidyAmount) > 100) {
                        alert("Enter only Percentage value,below 100");
                        vm.voucher.MerchantSubsidyAmount = 0;
                    }

                }
            }
            else if (vm.voucher.Subsidy == 'FixedAmount') {
               // var voucheramount = parseInt(vm.voucher.OldPrice) - parseInt(vm.voucher.Price);
                if (parseFloat(vm.voucher.MerchantSubsidyAmount) > parseFloat (vm.voucher.OldPrice)) {
                    alert("Subsidy Amount should not be greater than original amount");
                    vm.voucher.MerchantSubsidyAmount = 0;
                    vm.voucher.KipleSubsidyAmount = 0;
                }
                else {
                    vm.voucher.KipleSubsidyAmount = Math.round((parseFloat(vm.voucher.OldPrice) - parseFloat(vm.voucher.MerchantSubsidyAmount)) *100)/100;
                }
            }
            else {
                vm.voucher.MerchantSubsidyAmount = 0;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.university')
        .factory('UniversityService', UniversityService);

    /** @ngInject */
    function UniversityService(SVCS, $http, $q, CoreService, $cookies) {
        var vm = this;
        vm.productServer = SVCS.Product + '/';
        vm.product = {
            Photos: [],
            Price: 0
        };
        vm.isAdmin = $cookies.get('account_type') == 1 ? true : false;
        var merchantServer = SVCS.Merchant;
        var authServer = SVCS.Auth;
        var report = SVCS.Report;
        var service = {

            UploadCSV: UploadCSV,
            GetAllMerchantsPublicInfo: GetAllMerchantsPublicInfo,
            GetAccountStatement: GetAccountStatement,
            GetAllUniversity: GetAllUniversity,
            GetAllUniversityWithMer: GetAllUniversityWithMer,
            GetUniversity: GetUniversity,
            AddUniversity: AddUniversity,
            UpdateUniversity: UpdateUniversity,
            RemoveUniversity: RemoveUniversity,

            GetAllCampus: GetAllCampus,
            GetCampus: GetCampus,
            AddCampus: AddCampus,
            UpdateCampus: UpdateCampus,
            RemoveCampus: RemoveCampus,
            GetListOfUniveristies: GetListOfUniveristies,

            PublishUniversity: PublishUniversity,
            PublishCampus: PublishCampus,
            ConvertNormalMerchant: ConvertNormalMerchant,
            GetCampusByUniversityId: GetCampusByUniversityId,
            ConvertNormalStore: ConvertNormalStore,
            PublishPortalUniversity: PublishPortalUniversity,
            GetPortalUniversity: GetPortalUniversity,
            GetReferralCodeSummaryReport: GetReferralCodeSummaryReport,
            GetReferralCodeSummaryReportBasedOnId: GetReferralCodeSummaryReportBasedOnId,
            getRoleUniversity: getRoleUniversity,
            getUniversityPaymentReport:getUniversityPaymentReport
        };

        return service;


        function GetReferralCodeSummaryReport(filter) {

            var deferer = $q.defer();

            $http.post(merchantServer + '/api/merchants/university/GetUserReferalCodeDetails', filter).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;

        }

        function GetReferralCodeSummaryReportBasedOnId(Id) {

            var deferer = $q.defer();
            $http.get(report + '/api/merchants/university/GetUserDetailsBasedOnRerrefernceId?Id=' + Id).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            })

            return deferer.promise;

        }

        function UploadCSV(file) {
            var deferer = $q.defer();

            $http.post(
                SVCS.Auth + '/api/university/csv/upload/', file,
                {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                }
            ).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function GetAllMerchantsPublicInfo(id) {

            var deferer = $q.defer();

            $http.post(merchantServer + '/api/merchants/university/list?id=' + id).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        //remove university from merchant once univeristy is unpublished
        function ConvertNormalMerchant(id) {

            var deferer = $q.defer();

            $http.post(merchantServer + '/api/merchants/university/changeMerchant?id=' + id).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        //remove store  from campus  once campus  is unpublished
        function ConvertNormalStore(id) {

            var deferer = $q.defer();

            $http.post(merchantServer + '/api/stores/changeStoreToNormal?id=' + id).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }


        function GetAccountStatement(sdate, edate, id, type, mId, sId, uni, cid, CName, pid) {
            var deferer = $q.defer();

            $http.get(report + '/api/merchants/university/statements?sdate=' + sdate + '&edate=' + edate + '&TransactionId=' + id + '&type=' + type + '&mId=' + mId + '&sId=' + sId + '&Id=' + uni + '&cid=' + cid + '&cName=' + CName + '&pid=' + pid).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            })

            return deferer.promise;
        }

        //get list of uni
        function GetAllUniversity(criteria) {

            var deferer = $q.defer();

            $http.post(authServer + '/api/university/search', criteria).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        function GetAllUniversityWithMer(criteria) {

            var deferer = $q.defer();

            $http.post(authServer + '/api/merchants/university/Searchlist', criteria).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        function GetListOfUniveristies() {

            var deferer = $q.defer();

            $http.get(authServer + '/api/university/get').then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        function GetPortalUniversity() {

            var deferer = $q.defer();
            $http.get(authServer + '/api/university/getMerchantUniversity').then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        function getRoleUniversity(universitys, allRoles) {
            var result = null;
            for (var i=0; i < allRoles.length; i++) {
                var oneRole = allRoles[i];
                if (!oneRole || !oneRole.Name) continue;
                var roleUniversityName = oneRole.Name.replace(" Admin", "");
                var universityIdArray=[];
                for(var y=0;y<universitys.length;y++){
                    universityIdArray= universityIdArray.concat(toRowLowerString(universitys[y].UniversityId));
                }
                var universityIndex = universityIdArray.indexOf(toRowLowerString(roleUniversityName));
                if (universityIndex != -1) {
                    result = universitys[universityIndex];
                    return result;
                }
            }
            // allRoles.forEach(x => { 

            // });
            return result;
        }
        function toRowLowerString(x) {
            if (!!x) {
                return x.toLocaleLowerCase();
            } else { return "" }
        }

        //get a single uni
        function GetUniversity(id) {

            var deferer = $q.defer();

            $http.post(authServer + '/api/university/Logo?id=' + id).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        //add uni
        function AddUniversity(university) {

            var deferer = $q.defer();

            $http.post(authServer + '/api/university/register', university).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                alert(responseError.data.Message);
                deferer.reject(responseError.data.Message);
            });

            return deferer.promise;
        }

        //update uni
        function UpdateUniversity(university, id) {

            var deferer = $q.defer();

            $http.post(authServer + '/api/university/update?id=' + id, university).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                alert(responseError.data.Message);
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        //publish /unpublish university 
        function PublishUniversity(id, val) {

            var deferer = $q.defer();

            $http.post(authServer + '/api/university/publish?id=' + id + '&val=' + val).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                alert(responseError.data.Message);
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        function PublishPortalUniversity(id, val) {

            var deferer = $q.defer();

            $http.post(authServer + '/api/university/publishportal?id=' + id + '&val=' + val).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                alert(responseError.data.Message);
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        //publish /unpublish university 
        function PublishCampus(id, val) {

            var deferer = $q.defer();

            $http.post(authServer + '/api/university/campus/publish?id=' + id + '&val=' + val).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                alert(responseError.data.Message);
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }


        function RemoveUniversity(id) {

            var deferer = $q.defer();

            $http.post(authServer + '/api/university/remove?id=' + id).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }


        // campus
        //get list of uni
        function GetAllCampus(criteria) {

            var deferer = $q.defer();

            $http.post(authServer + '/api/university/campus/search', criteria).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        function GetCampusByUniversityId(id) {

            var deferer = $q.defer();

            $http.get(authServer + '/api/university/campus/get?id=' + id).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        //get a single uni
        function GetCampus(tem) {

            var ob = { id: tem };
            var deferer = $q.defer();
            $http.post(authServer + '/api/university/campus/ById', ob).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        //add uni
        function AddCampus(campus) {

            var deferer = $q.defer();
            campus.CmapusId = "123";
            $http.post(authServer + '/api/university/campus/register', campus).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
                alert(responseError.data.Message);
            });

            return deferer.promise;
        }

        //update uni
        function UpdateCampus(campus, id) {

            var deferer = $q.defer();

            $http.post(authServer + '/api/university/campus/update?id=' + id, campus).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
                alert(responseError.data.Message);
            });

            return deferer.promise;
        }

        //remove uni
        function RemoveCampus(id) {

            var deferer = $q.defer();

            $http.post(authServer + '/api/university/campus/remove?id=' + id).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }
        //end campus
        //university payment report
        function getUniversityPaymentReport(sdate,edate,username,uId,sId) {

            var deferer = $q.defer();

            $http.get(report + '/api/merchants/university-payment-reports?sdate=' + sdate+'&edate='+edate+'&username='+username+'&uId='+uId+'&sId='+sId).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }
        //end university payment report
    }
})();
(function () {
    'use strict';

    angular
        .module('app.store')
        .factory('StoreService', StoreService);

    /** @ngInject */
    function StoreService(SVCS, $http, $q, uiGmapGoogleMapApi, CoreService) {
        var merchantServer = SVCS.Merchant;
        var gatewayServer = SVCS.Gateway;
        var authServer = SVCS.Auth;

        var service = {
            Get: Get,
            Search: Search,
            Update: Update,
            Delete: Delete,
            Create: Create,
            UploadPhoto: UploadPhoto,
            RemovePhoto: RemovePhoto,
            Publish: Publish,
            Unpublish: Unpublish,
            AddTerminal: AddTerminal,
            RemoveTerminal: RemoveTerminal,
            GetMerchantNameByUser: GetMerchantNameByUser,
            GetStoresPublicInfoGroupByMerchant: GetStoresPublicInfoGroupByMerchant,
            getCoordinateFromAddressAsync: getCoordinateFromAddressAsync,
            GetStoresByMerchantLogin: GetStoresByMerchantLogin,
            GetListDistrict: GetListDistrict,
            IsStoreBelongToPrimaryMerchant: IsStoreBelongToPrimaryMerchant,
            IsStoreBelongToUnifyQr: IsStoreBelongToUnifyQr
        };

        return service;

        function GetMerchantNameByUser() {
            var deferer = $q.defer();
            
            CoreService.Get(merchantServer + '/api/merchants/me').then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function Get(storeId) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/stores/dashboard/' + storeId).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();
           
            CoreService.Get(merchantServer + '/api/stores/dashboard/search', criteria).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function Create(storeModel) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/stores', storeModel).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function Update(storeModel) {
            var deferer = $q.defer();

            CoreService.Put(merchantServer + '/api/stores/update/info', storeModel).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function Delete(id) {
            var deferer = $q.defer();

            CoreService.Delete(merchantServer + '/api/stores/' + id).then(function (response) {
                deferer.resolve(response);
            }, function (responseError) {
            });
            return deferer.promise;
        }

        function UploadPhoto(img) {
            var deferer = $q.defer();

            var formData = new FormData();
            formData.append('file', img);

            $http.post(gatewayServer + '/api/photos/upload', formData, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        function RemovePhoto(photoId, storeId) {
            var deferer = $q.defer();

            CoreService.Delete(merchantServer + '/api/stores/photos/' + photoId + "/" + storeId).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function Publish(storeId) {
            var deferer = $q.defer();
            var model = { Id: storeId };
            CoreService.Put(merchantServer + '/api/stores/publish', model).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function Unpublish(storeId) {
            var deferer = $q.defer();
            var model = { Id: storeId };
            CoreService.Put(merchantServer + '/api/stores/unpublish', model).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function AddTerminal(terminal) {
            var deferer = $q.defer();

            CoreService.Post(authServer + '/api/account/internal/store/terminal', terminal).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function RemoveTerminal(posId) {
            var deferer = $q.defer();

            CoreService.Delete(authServer + '/api/account/internal/store/terminal/' + posId).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function GetStoresPublicInfoGroupByMerchant(filter) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/stores/public-info-group-by-merchant').then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function getCoordinateFromAddressAsync(addressParts, deferer) {
            var newDef = false;
            if (!deferer) {
                deferer = $q.defer();
                newDef = true;
            }

            // get coordination from address of store
            uiGmapGoogleMapApi.then(function () {
                var address = addressParts.join(', ');
                var geocoder = new google.maps.Geocoder;
                geocoder.geocode({ 'address': address }, function (results, status) {
                    if (status === google.maps.GeocoderStatus.OK) {
                        deferer.resolve({ lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() });
                    } else {
                        if (addressParts.length > 1) {
                            var cloneAddressParts = angular.copy(addressParts);
                            cloneAddressParts.shift();
                            getCoordinateFromAddressAsync(cloneAddressParts, deferer);
                        } else {
                            deferer.reject();
                        }
                    }
                });
            }, function () {
                deferer.reject();
            })

            if (newDef) {
                return deferer.promise;
            }
        }

        function GetStoresByMerchantLogin() {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/stores/get-stores-by-merchant-login').then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function GetListDistrict() {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/Merchant/Content/districts.json').then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function IsStoreBelongToPrimaryMerchant(storeId) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/stores/is-store-belong-to-primary-merchant/' + storeId).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function IsStoreBelongToUnifyQr(storeId) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/stores/check-unify-qr-store/' + storeId).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.store')
        .controller('StoreController', StoreController)

    /** @ngInject */
    function StoreController($state, SVCS, StoreService, MerchantService, ManagerService, $translate, $scope, $rootScope, $cookies, QRCodeService, UniversityService, GroupService) {
        var vm = this;
        var UniversityId = null;
        vm.merchantServer = SVCS.Merchant;
        vm.averagePrice = '$';
        vm.criteria = {
            Keyword: null,
            AveragePrice: null,
            Page: 1,
            Length: 10,
            MerchantId: null,
            SortName: '',
            OrderBy: '',
        }

        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        vm.onboardDateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        //#region day of week
        vm.daysOfWeek = [
            { Id: "Monday", Name: "store.off_days.mon" },
            { Id: "Tuesday", Name: "store.off_days.tue" },
            { Id: "Wednesday", Name: "store.off_days.wed" },
            { Id: "Thursday", Name: "store.off_days.thu" },
            { Id: "Friday", Name: "store.off_days.fri" },
            { Id: "Saturday", Name: "store.off_days.sat" },
            { Id: "Sunday", Name: "store.off_days.sun" },
        ];
        //#endregion

        vm.clearSearch = function () {
            vm.criteria = {
                Keyword: null,
                AveragePrice: null,
                Page: 1,
                Length: 10,
                MerchantId: null,
                SortName: '',
                OrderBy: '',
            }

            vm.search();
        }

        vm.openExpireDatePopup = function () {
            vm.expireDatePopup.opened = true;
        };

        vm.expireDatePopup = {
            opened: false
        };

        vm.openOnboardingDatePopup = function () {
            vm.onboardingDatePopup.opened = true;
        };

        vm.onboardingDatePopup = {
            opened: false
        };

        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.maxSize = 5;
        vm.itemsPerPage = 5;
        vm.IsChecked = false;
        vm.temp = {};
        vm.isAdmin = $cookies.get('account_type') == 1 ? true : false;
        vm.terminal = { POSId: null, ObjectId: null };

        StoreService.GetListDistrict().then(function (res) {
            res.splice(0, 1);
            vm.districts = res;
        })
        //get group
        GroupService.All().then(function (res) {
            vm.groups = res.Result;
        })

        //get all merchant
        MerchantService.GetAllMerchantsPublicInfo().then(function (res) {
            vm.merchants = res;
        })

        vm.removePhoto = function (photo, idx, store) {
            if (photo.Id) {
                StoreService.RemovePhoto(photo.Id, store.Id).then(function () {

                    vm.store.Photos.splice(idx, 1);
                }, function (error) {

                    if (error && error.Message) {
                        alert(error.Message);
                    } else {
                        $translate('store.edit.busy').then(function (msg) {
                            alert(msg);
                        })
                    }

                })
            }
            else {
                vm.store.Photos.splice(idx, 1);
            }

            vm.temp.Photo = null;
        }

        vm.uploadPhoto = function (files, invalidFiles) {
            if (invalidFiles.length) {
                $translate('store.validate.store.photo_dimensions', { name: invalidFiles[0].name }).then(function (msg) {
                    //alert(msg);
                    //vm.temp.Photo = null;
                })

                return;
            }

            if (!files || !files.length) {
                return;
            }

            sequentialUpload(files, 0, [], sequentialUploadCompleted);

        };

        function sequentialUpload(files, i, errorsFiles, callback) {
            StoreService.UploadPhoto(files[i]).then(function (photo) {
                var photoModel = {
                    Path: photo.Result,
                };

                if (vm.store.Photos == null) {
                    vm.store.Photos = [];
                }

                vm.store.Photos.push(photoModel);
            }, function (error) {
                errorsFiles.push({ file: files[i], error: error });

            }).then(function () {
                if (files.length === i + 1) {
                    callback(errorsFiles);
                } else {
                    sequentialUpload(files, i + 1, errorsFiles, callback);
                }
            });
        }

        function sequentialUploadCompleted(errorsFiles) {
            var filesNames = [];
            if (errorsFiles && errorsFiles.length) {
                angular.forEach(errorsFiles, function (item) {
                    filesNames.push(errorsFiles.file.name);
                })
            }

            if (filesNames.length) {
                $translate('store.edit.photo.upload_error', { names: filesNames.join(', ') }).then(function (msg) {
                    alert(msg);
                })
            }
        }

        vm.viewConfig = { ShowStoreDialog: false, StoreAction: null, ShowManagerDialog: false };

        // Get merchant name
        if ($rootScope.authenticationService.account) {
            vm.MerchantName = $rootScope.authenticationService.account.FullName;
        }

        vm.search = function () {
            vm.criteria.Page = vm.currentPage;
            StoreService.Search(vm.criteria).then(function (res) {
                vm.stores = res.Items;
                vm.totalItems = res.Total;
            })
        }

        vm.reset = function () {
            vm.criteria = {
                Keyword: null,
                AveragePrice: null,
                Page: 1,
                Length: 10,
                MerchantId: null,
                SortName: '',
                OrderBy: '',
            }
            vm.currentPage = 1;
            vm.search();
        }

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }

        vm.tempServiceCharge = 0;
        vm.edit = function (storeId) {
            //get apptype
            vm.Tag = localStorage.getItem('apptype');
            if (vm.Tag == 5) {
                $("#storeForm :input").attr("disabled", true);
            }
            else {
                $("#storeForm :input").attr("disabled", false);
            }
            $scope.storeForm.$setPristine();
            $scope.storeForm.$setUntouched();
            vm.temp.Photo = null;
            StoreService.Get(storeId).then(function (res) {
                vm.tempServiceCharge = res.ServiceCharge;
                angular.forEach(res.OperationHours_, function (value, key) {
                    var openHours_h = parseInt(value['OpenHours'] / 60);
                    var openHours_m = value['OpenHours'] - (openHours_h * 60);

                    var closeHours_h = parseInt(value['CloseHours'] / 60);
                    var closeHours_m = value['CloseHours'] - (closeHours_h * 60);

                    value['OpenHours'] = new Date(0, 0, 0, openHours_h, openHours_m);
                    value['CloseHours'] = new Date(0, 0, 0, closeHours_h, closeHours_m);
                });

                if (res.OperationHours_.length == 0) {
                    res.OperationHours_.push({
                        OpenHours: null,
                        CloseHours: null,
                        Day: null
                    });
                }
                vm.store = res;
                vm.loadMerchant(vm.store.MerchantName);
                //  vm.Change(res.MerchantId);
                vm.store.OperationHours = res.OperationHours_;
                if (vm.store.AveragePriceFrom == 0) {
                    vm.averagePrice = '$';
                }
                else if (vm.store.AveragePriceFrom > 0 && vm.store.AveragePriceTo > 0) {
                    vm.averagePrice = '$$';
                }
                else {
                    vm.averagePrice = '$$$';
                }
                if (vm.store.AveragePriceFrom == 0 && vm.store.AveragePriceTo == 0) {
                    vm.averagePrice = null;
                }
                if (vm.store.Photos.length > 0) {
                    vm.temp.Photo = vm.store.Photos[0];
                }

                if (vm.store.InstallationDate != null) {
                    vm.store.InstallationDate = new Date(vm.store.InstallationDate);
                }

                if (vm.store.OnboardingDate != null) {
                    vm.store.OnboardingDate = new Date(vm.store.OnboardingDate);
                }

                if (!vm.store.OffDays) {
                    vm.store.OffDays = [];
                }

                if (res.IsUniversityStore) {
                    vm.ShowCampus();
                    $("#IsUniversityStore").prop('checked', true);
                } else {
                    $("#IsUniversityStore").prop('checked', false);
                    $(".university").css("display", "none");
                }
                $(".university").css("display", "none");
                $("#IsUniversityStore").prop('checked', false);
                if (res.IsUniversityMerchant) {
                    vm.IsUniversityMerchant = res.IsUniversityMerchant;
                    if (res.UniversityId == null || res.IsUniversityMerchant == false) return;
                    $(".university").css("display", "block");
                    UniversityId = res.UniversityId;
                    $("#IsUniversityStore").prop('checked', true);
                    vm.ShowCampus();
                }
                else {
                    $(".university").css("display", "none");
                }
                vm.viewConfig.ShowStoreDialog = true;
                vm.viewConfig.StoreAction = 'edit';
            })
        }

        vm.delete = function (id) {
            StoreService.Delete(id).then(function (res) {
                vm.search();
            }, function (error) {
            });
        }

        vm.add = function () {

            $scope.storeForm.$setPristine();
            $scope.storeForm.$setUntouched();

            vm.averagePrice = null;

            vm.store = {
                Photos: [],
                OperationHours: [
                    {
                        OpenHours: null,
                        CloseHours: null,
                        Day: null
                    }
                ],
                UseBrandDescription: true
            };

            vm.temp.Photo = null;

            if (!vm.isAdmin) {
                StoreService.GetMerchantNameByUser().then(function (res) {
                    vm.store.BankName = res.Bank.Name;
                    vm.store.BankAccountNumber = res.Bank.AccountNumber;
                })
            }

            vm.viewConfig.ShowStoreDialog = true;
            vm.viewConfig.StoreAction = 'new';
        }

        vm.save = function () {

            if (!$scope.storeForm.$valid) {
                angular.forEach($scope.storeForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });

                $('#storeForm .ng-invalid')[0].focus();

                return;
            }

            if (vm.averagePrice == '$') {
                vm.store.AveragePriceFrom = 0;
                vm.store.AveragePriceTo = 20;
            }
            else if (vm.averagePrice == '$$') {
                vm.store.AveragePriceFrom = 20;
                vm.store.AveragePriceTo = 50;
            }
            else if (vm.averagePrice == '$$$') {
                vm.store.AveragePriceFrom = 50;
                vm.store.AveragePriceTo = 0;
            }

            StoreService.getCoordinateFromAddressAsync([vm.store.Address, vm.store.District, 'Malaysia']).then(function (coord) {
                if (!vm.store.Latitude && vm.store.Latitude == 0) {
                    vm.store.Latitude = coord.lat;
                }
                if (!vm.store.Longitude && vm.store.Longitude == 0) {
                    vm.store.Longitude = coord.lng;
                }

                pushToServer();
                vm.search();
            }, function () {
                $translate('store.locations.error.address_unrecognize').then(function (msg) {
                    alert(msg);
                })
                pushToServer();
                vm.search();
            })
        }

        vm.cancel = function () {
            vm.viewConfig.StoreAction = null;
            vm.viewConfig.ShowStoreDialog = false;
        }

        vm.unpublish = function (store) {
            StoreService.Unpublish(store.Id).then(function (res) {
                store.StoreState = 'Unpublished';
            })
        }

        vm.publish = function (store) {
            StoreService.Publish(store.Id).then(function (res) {
                store.StoreState = 'Published';
            })
        }

        // Add user to store
        vm.addTerminal = function (storeId) {
            vm.terminal.POSId = new Date().getTime();
            vm.terminal.ObjectId = storeId;
            vm.viewConfig.ShowAddUserDialog = true;
        }

        vm.saveTerminal = function () {

            StoreService.AddTerminal(vm.terminal).then(function (res) {
                vm.viewConfig.ShowAddUserDialog = false;
                vm.terminal = { POSId: null, ObjectId: null };
            })
        }

        vm.sort = function (opts) {

            var sortNames = [];
            var sortDirections = [];
            if (opts.name.constructor === Array) {
                angular.forEach(opts.name, function (val) {
                    sortNames.push(val);
                    sortDirections.push(opts.direction);
                })
            } else {
                sortNames.push(opts.name);
                sortDirections.push(opts.direction);
            }

            vm.criteria.SortName = sortNames[0];
            vm.criteria.OrderBy = sortDirections[0];

            vm.search();
        };

        vm.search();

        function pushToServer() {
            if (vm.store.ServiceCharge == null) {
                vm.store.ServiceCharge = 0;
            }

            if (vm.viewConfig.StoreAction == 'new') {

                if (vm.store.Photos == null) {
                    vm.store.Photos = null;
                }

                var store_copy = angular.copy(vm.store);
                angular.forEach(store_copy.OperationHours, function (value, index) {
                    if (value['OpenHours'] == null || value['CloseHours'] == null) {
                        store_copy.OperationHours.splice(index, 1);
                    } else {
                        var openTime = new Date(value['OpenHours']);
                        var closeTime = new Date(value['CloseHours']);

                        value['OpenHours'] = openTime.getHours() * 60 + openTime.getMinutes();
                        value['CloseHours'] = closeTime.getHours() * 60 + closeTime.getMinutes();
                    }
                });

                StoreService.Create(store_copy).then(function (res) {
                    store_copy.Id = res.Result;
                    store_copy.MerchantName = vm.MerchantName;
                    store_copy.StoreState = 'Approved';
                    vm.stores.push(store_copy);

                    vm.viewConfig.StoreAction = null;
                    vm.viewConfig.ShowStoreDialog = false;
                    vm.search();
                })
            }
            else if (vm.viewConfig.StoreAction == 'edit') {
                if (vm.store.Photos.length == 0) {
                    vm.store.Photos = null;
                }

                var store_copy = angular.copy(vm.store);
                angular.forEach(store_copy.OperationHours, function (value, index) {
                    if (value['OpenHours'] == null || value['CloseHours'] == null) {
                        store_copy.OperationHours.splice(index, 1);
                    } else {
                        var openTime = new Date(value['OpenHours']);
                        var closeTime = new Date(value['CloseHours']);

                        value['OpenHours'] = openTime.getHours() * 60 + openTime.getMinutes();
                        value['CloseHours'] = closeTime.getHours() * 60 + closeTime.getMinutes();
                    }
                });

                StoreService.Update(store_copy).then(function (res) {
                    if (vm.tempServiceCharge != store_copy.ServiceCharge) {
                        StoreService.IsStoreBelongToUnifyQr(store_copy.Id).then(function (result) {
                            if (result) {
                                alert("All stores under this Main merchant will update with same amount.");
                            }
                            vm.viewConfig.StoreAction = null;
                            vm.viewConfig.ShowStoreDialog = false;
                            vm.search();
                        });
                    }
                    else {
                        vm.viewConfig.StoreAction = null;
                        vm.viewConfig.ShowStoreDialog = false;
                        vm.search();
                    }
                })
            }
        }

        vm.POSTermialOwnershipList = [
            { Id: "Rental", Name: "store.pos_termial_ownership_list.rental" },
            { Id: "OutrightPurchase", Name: "store.pos_termial_ownership_list.outright_purchase" }
        ];

        vm.addNew = function () {
            vm.store.OperationHours.push(
                {
                    OpenHours: null,
                    CloseHours: null,
                    Day: null
                }
            );
        }

        vm.Change = function (id) {
            $(".university").css("display", "none");
            $("#IsUniversityStore").prop('checked', false);
            if (id == null || id == 'undefined') return;
            MerchantService.Get(id).then(function (res) {
                vm.IsUniversityMerchant = res.IsUniversityMerchant;
                if (res.UniversityId == null || res.IsUniversityMerchant == false) return;
                if (res.IsUniversityMerchant) {
                    $(".university").css("display", "block");
                    UniversityId = res.UniversityId;
                    $("#IsUniversityStore").prop('checked', true);
                    vm.ShowCampus();


                } else {
                    $(".university").css("display", "none");
                }

            });
        }

        vm.ShowCampus = function () {
            //$("#CampusId option").remove();

            if ($("#IsUniversityStore").prop("checked") == true) {
                //   $("#IsUniversityStore").attr('value', 'true');
                $("#IsUniversityStore").prop('checked', true);
                UniversityService.GetCampusByUniversityId(UniversityId).then(function (res) {
                    $("#CampusId option").remove();
                    vm.campusList = res.list;
                    if (res.list.length > 0) {
                        // $('#CampusId').val(vm.campusList[0].CmapusId);
                        vm.store.CampusId = vm.campusList[0].CmapusId;
                    }
                    //    $("#CampusId").val($("#CampusId option:first").val());
                })

            } else if ($("#IsUniversityStore").prop("checked") == true) {
                $("#CampusId option").remove();
                $("#IsUniversityStore").prop('checked', false);
                //  $("#IsUniversityStore").attr('value', 'false');
                //vm.store.IsUniversitysStore = false;
                //$(".university").css("display" , "none");
            }
        }

        vm.remove = function (index) {
            vm.store.OperationHours.splice(index, 1);
        }

        vm.removeLast = function () {
            vm.store.OperationHours = [
                {
                    OpenHours: null,
                    CloseHours: null,
                    Day: null
                }
            ];
        }

        /*********** Store manager ******************/
        vm.addManager = function (storeId) {
            vm.manager = { Pin: Math.round((Math.random() * 60000) * 10), StoreId: storeId };
            vm.viewConfig.ShowManagerDialog = true;
        }

        vm.saveManager = function () {
            ManagerService.Create(vm.manager).then(function () {
                vm.viewConfig.ShowManagerDialog = false;
                vm.manager = undefined;
            })
        }
        /*********** Store manager end ******************/

        //vm.getQRCode = function (store) {
        //    QRCodeService.GenerateStoreQRCode(store.Id).then(function (res) {
        //        vm.qrcode = "data:image/png;base64," + res.Result;
        //        vm.qrcodeDialog = true;
        //        vm.storeName = store.Name;
        //    })
        //}

        vm.print = function () {
            var divToPrint = document.getElementById('qrcodeBody');

            var newWin = window.open('', 'Print-Window');

            newWin.document.open();

            newWin.document.write('<html><body onload="window.print()">' + divToPrint.innerHTML + '</body></html>');

            newWin.document.close();

            setTimeout(function () { newWin.close(); }, 10);
        }

        vm.loadMerchant = function (keyword) {
            if (keyword.length >= 3) {
                MerchantService.Search({ Keyword: keyword }).then(function (res) {
                    vm.merchants = res.Items;
                });
            } else {
                vm.merchants = null;
            }
        }
    }
})();
(function () {
  "use strict";

  angular.module("app.rcbmara").config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    // Define the viewAsAdminResolver for the RCB-MARA module
    var viewAsAdminResolver = [
      "$q",
      "AuthenticationService",
      function ($q, AuthenticationService) {
        var deferer = $q.defer();

        AuthenticationService.getUserPermissionsAsync().then(
          function (permissions) {
            if (AuthenticationService.hasPermissions(["VIEW_REPORTS"])) {
              deferer.resolve(true);
            } else {
              deferer.resolve(false);
            }
          },
          function () {
            deferer.resolve(false);
          }
        );

        return deferer.promise;
      },
    ];

    $stateProvider
      .state("app.rcbmara", {
        url: "/rcbmara",
        templateUrl: "app/rcb-mara/rcb-mara.html",
        controller: "RcbMaraController",
        controllerAs: "vm",
        data: {
          permissions: {
            only: ["ADMIN_USER", "RCB_MARA_ADMIN"],
          },
        },
      })
      .state("app.rcbmara.easereport", {
        url: "/ease-report",
        templateUrl: "app/rcb-mara/ease-report/ease-withdrawal-report.html",
        controller: "EaseWithdrawalReportController",
        controllerAs: "vm",
        data: {
          permissions: {
            only: ["ADMIN_USER", "RCB_MARA_ADMIN"],
          },
        },
        resolve: {
          $$viewAsAdmin: viewAsAdminResolver,
        },
      });
  }
})();

(function () {
  "use strict";

  angular
    .module("app.rcbmara")
    .controller("RcbMaraController", RcbMaraController);

  /** @ngInject */
  function RcbMaraController() {
    var vm = this;

    // Controller initialization
    vm.init = function () {
      // Any initialization code for the parent controller
    };

    vm.init();
  }
})();

(function () {
    'use strict';

    angular
        .module('app.report')
        .controller('ReportsListController', ReportsListController);

    /** @ngInject */
    function ReportsListController() {
        var vm = this;

        //Initialize
        vm.init = function () {
            vm.Tag = localStorage.getItem('apptype');            
        }      
    }
})();

(function () {
    'use strict';

    angular
        .module('app.partner')
        .factory('PartnerCategoryService', PartnerCategoryService);

    /** @ngInject */
    function PartnerCategoryService(SVCS, $http, $q, CoreService) {
        var merchantServer = SVCS.Merchant;

        var service = {
            All: All,
            Get: Get,
            Create: Create,
            Update: Update,
            Remove: Remove,
            Search: Search
        };

        return service;

        function All() {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/partner-categories').then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/partner-categories/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(partnerCategory) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/partner-categories', partnerCategory).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(partnerCategory) {
            var deferer = $q.defer();

            CoreService.Put(merchantServer + '/api/partner-categories', partnerCategory).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Remove(id) {
            var deferer = $q.defer();

            CoreService.Delete(merchantServer + '/api/partner-categories/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/partner-categories/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.partner')
        .controller('PartnerCategoryController', PartnerCategoryController);

    /** @ngInject */
    function PartnerCategoryController(SVCS, $translate, PartnerCategoryService, MerchantService, AdminUserService, $scope) {
        var vm = this;
        vm.partnerCategories = [];
        vm.criteria = {
            Keyword: null,
            Page: 1,
            Length: 10
        };
        vm.totalItems = 0;
        vm.currentPage = 1;
        vm.itemsPerPage = 10;
        vm.maxSize = 10;

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        };

        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
          
            PartnerCategoryService.Search(criteria).then(function (data) {
                vm.partnerCategories = data.Items;
                vm.totalItems = data.Total;

                // Get merchant name
                MerchantService.GetAllMerchantsPublicInfo().then(function (merchants) {
                    vm.partnerCategories.forEach(function (partnerCategory) {
                        if (partnerCategory.MerchantId) {
                            partnerCategory.MerchantName = merchants.filter(function (merchant) {
                                return merchant.Id === partnerCategory.MerchantId
                            })[0].Name;
                        }
                        if (partnerCategory.PartnerType == 'Settlement') {
                            partnerCategory.PartnerType = 'With Settlement';
                        } else if (partnerCategory.PartnerType == 'NoSettlement') {
                            partnerCategory.PartnerType = 'Without Settlement';
                        } else if (partnerCategory.PartnerType == 'RevShare') {
                            partnerCategory.PartnerType = 'Project with Revenue Share';
                        }
                    })
                })

                // Get created name
                AdminUserService.Search({}).then(function (data) {
                    vm.partnerCategories.forEach(function (partnerCategory){
                        partnerCategory.CreatedBy = data.Items.filter(function (user) {
                            return user.Id === partnerCategory.CreatedBy
                        })[0].UserName;
                    })
                });
            })
        }
        vm.search();

        vm.reset = function () {
            vm.criteria = { Keyword: null, Page: 1, Length: 10 };
            vm.currentPage = 1;
            vm.search();
        }

        vm.remove = function (partnerCategory) {
            var message = 'Are you sure you want to remove ' + partnerCategory.Name + '? Merchants tagged under this partner will be remove too.';
            var confirm = window.confirm(message);
            if (!confirm) {
                return;
            }

            PartnerCategoryService.Remove(partnerCategory.Id).then(function () {
                vm.search();
            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.product')
        .factory('ProductService', ProductService);

    /** @ngInject */
    function ProductService(SVCS, $http, $q, CoreService) {
        var productServer = SVCS.Product;
        var gatewayServer = SVCS.Gateway;

        var service = {
            Get: Get,
            Create: Create,
            Update: Update,
            Delete: Delete,
            Search: Search,
            Publish: Publish,
            Unpublish: Unpublish,
            GetAllTag: GetAllTag,
            UploadPhoto: UploadPhoto
        };

        return service;

        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(productServer + '/api/products/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Get(productServer + '/api/products/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(product) {
            var deferer = $q.defer();

            CoreService.Post(productServer + '/api/products', product).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(product) {
            var deferer = $q.defer();

            CoreService.Put(productServer + '/api/products', product).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Delete(id) {
            var deferer = $q.defer();

            CoreService.Delete(productServer + '/api/products?id=' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Publish(id) {
            var deferer = $q.defer();
            var model = {Id: id}
            CoreService.Put(productServer + '/api/products/publish', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Unpublish(id) {
            var deferer = $q.defer();
            var model = { Id: id }
            CoreService.Put(productServer + '/api/products/unpublish', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function GetAllTag(){
            var deferer = $q.defer();

            CoreService.Get(productServer + '/api/tags/web/all').then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function UploadPhoto(img) {
            var deferer = $q.defer();

            var formData = new FormData();
            formData.append('file', img);

            $http.post(gatewayServer + '/api/photos/upload', formData, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.product')
        .directive('isSkuAvailable', isSkuAvailable);

    /** @ngInject **/
    function isSkuAvailable($q, $http, $timeout, SVCS) {
        return {
            require: 'ngModel',

            link: function (scope, elm, attrs, ctrl) {

                var checkingTask = null;

                var baseUrl = SVCS.Product;

                ctrl.$asyncValidators.isSkuAvailable = function (modelValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return $q.when();
                    }

                    var def = $q.defer();

                    if (checkingTask != null) {
                        $timeout.cancel(checkingTask);
                        checkingTask = null;
                    }

                    
                    var params = attrs.isSkuAvailable;
                    params = params.split(",");
                    var merchantId = scope.$eval(params[0]);
                    var productId = scope.$eval(params[1]);

                    checkingTask = $timeout(function () {
                    
                        $http.get(baseUrl + '/api/products/is-sku-available/' + modelValue + '/' + merchantId + '/' + productId).then(function (response) {
                            if (response.data) {
                                def.resolve();
                            } else {
                                def.reject();
                            }
                        }, function (responseError) {
                            def.reject();
                        })
                    }, 500)

                    return def.promise;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController(SVCS, $scope, $state, $rootScope, AuthenticationService, $cookies) {
        var vm = this;
        var university = $cookies.getObject('university');
        vm.Tag = localStorage.getItem('apptype');
        console.log(university);
        if (university[1] != 1 && university[3] != 1 && university[5]!=1) {
            $('.merchat_menue').remove();
        }
        var account = null;
        vm.closeNav = function () {
            if (window.innerWidth > 500) {
                return;
            }
            document.getElementById("mySidenav").style.padding = "0";
            document.getElementById("mySidenav").style.width = "0";
        }

        vm.search = function () {
            AuthenticationService.getUserInfoAsync().then(function (res) {
                vm.account = res;
            })
        }

        vm.hasPermission = function (permissionName) {
          if (!vm.account || !vm.account.permissions) return false;
          return vm.account.permissions.indexOf(permissionName) !== -1;
        };


        vm.signOut = function () {
            AuthenticationService.signOut();
           
         //   $state.go('auth.login');
        }

        vm.profile = function () {
            var accountType = $cookies.get('account_type');

            if (accountType == 2) {
                $state.go('app.merchant.info', { 'merchantId': null });
            }
        }

        vm.changePassword = function () {
            $state.go('app.account.change-password');
        }

        vm.openNav = function () {
            document.getElementById("mySidenav").style.width = "315px";
            document.getElementById("mySidenav").style.padding = "20px 20px 70px 20px";
        }

        vm.search();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.merchant')
        .factory('MerchantService', MerchantService)
        .factory('WebhookService', WebhookService);

    /** @ngInject */
    function MerchantService(SVCS, $http, $q, CoreService) {
        var merchantServer = SVCS.Merchant;
        var authServer = SVCS.Auth;
        var gatewayServer = SVCS.Gateway;

        var service = {
            Get: Get,
            GetAllMerchantsPublicInfo: GetAllMerchantsPublicInfo,
            GetAllMerchantsOfKiplePay: GetAllMerchantsOfKiplePay,
            Search: Search,
            Create: Create,
            Update: Update,
            Delete: Delete,
            ChangePassword: ChangePassword,
            UpdateMe: UpdateMe,
            Publish: Publish,
            Unpublish: Unpublish,
            AddUser: AddUser,
            RemoveUser: RemoveUser,
            UploadMerchantLogo: UploadMerchantLogo,
            DeleteLogo: DeleteLogo,
            GetProfile: GetProfile,
            GetWalletInfo: GetWalletInfo,
            UpdateStoreCardSetting: UpdateStoreCardSetting,
            GetTierSettings: GetTierSettings,
            AssignTierSettingToMerchant: AssignTierSettingToMerchant,
            CreateStoreCardSetting: CreateStoreCardSetting,
            GetBrands: GetBrands,
            IsMerchantHasProductNoPrice: IsMerchantHasProductNoPrice,
            GetPrefundHistories: GetPrefundHistories,
            UpdatePrefundAmount: UpdatePrefundAmount,
            ExportCSVPrefundHistory: ExportCSVPrefundHistory,
            SearchBrand: SearchBrand,
            GetCommunity: GetCommunity
        };

        return service;
        
        function GetAllMerchantsPublicInfo() {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/merchants/all').then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function GetAllMerchantsOfKiplePay() {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/merchants/kiplepay').then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/merchants/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/merchants/dashboard/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(merchant) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/merchants/admin/create', merchant).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(merchant) {
            var deferer = $q.defer();

            CoreService.Put(merchantServer + '/api/merchants/admin/update', merchant).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function UpdateMe(merchant) {
            var deferer = $q.defer();

            CoreService.Put(merchantServer + '/api/merchants/me', merchant).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function ChangePassword(model) {
            var deferer = $q.defer();

            CoreService.Put(authServer + '/api/account/internal/merchant/change-password', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Publish(merchantId) {
            var deferer = $q.defer();
            var model = { Id: merchantId};
            CoreService.Put(merchantServer + '/api/merchants/admin/publish', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Unpublish(merchantId) {
            var deferer = $q.defer();
            var model = { Id: merchantId };
            CoreService.Put(merchantServer + '/api/merchants/admin/unpublish', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function AddUser(user) {
            var deferer = $q.defer();

            CoreService.Post(authServer + '/api/account/internal/merchant', user).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function RemoveUser(userId) {
            var deferer = $q.defer();

            CoreService.Delete(authServer + '/api/account/internal/merchant/' + userId).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function UploadMerchantLogo(img) {
            var deferer = $q.defer();

            var formData = new FormData();
            formData.append('file', img);

            $http.post(gatewayServer + '/api/photos/upload', formData, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }

        function DeleteLogo(path) {
            var deferer = $q.defer();

            var model = {
                Path: path
            };

            $http.post(merchantServer + '/api/merchants/delete-logo', model).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseErrors) {
                deferer.reject(responseErrors.data);
            });

            return deferer.promise;
        }

        function GetProfile() {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/merchants/me').then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function GetWalletInfo(merchantId) {
            var deferer = $q.defer();

            CoreService.Get(gatewayServer + '/api/user-wallet-info/' + merchantId).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function UpdateStoreCardSetting(settingModel) {
            var deferer = $q.defer();

            CoreService.Put(merchantServer + '/api/storecard-setting/update', settingModel).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function GetTierSettings() {
            var deferer = $q.defer();
            CoreService.Get(merchantServer + '/api/merchant-tiers').then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function GetBrands() {
            var deferer = $q.defer();
            CoreService.Get(merchantServer + '/api/brands').then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function AssignTierSettingToMerchant(model) {
            var deferer = $q.defer();
            CoreService.Post(merchantServer + '/api/merchant-tiers/assign', model).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function CreateStoreCardSetting(settingModel) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/storecard-setting', settingModel).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Delete(id) {
            var deferer = $q.defer();

            CoreService.Delete(merchantServer + '/api/merchants/' + id).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }

        function IsMerchantHasProductNoPrice(id) {
            var deferer = $q.defer();
            CoreService.Get(merchantServer + '/api/merchants/is-merchant-has-product-no-price/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function GetPrefundHistories(criteria) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/merchants/prefund-histories-search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function UpdatePrefundAmount(prefundModel) {
            var deferer = $q.defer();

            CoreService.Put(merchantServer + '/api/merchants/update-prefund-amount', prefundModel).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        function SearchBrand(criteria) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/tags/dashboard/search', criteria).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }
        function ExportCSVPrefundHistory(criteria) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/merchants/export-csv-prefund-history', criteria).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }
        function GetCommunity() {
            var deferer = $q.defer();
            CoreService.Get(merchantServer + '/api/merchants/community-list').then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
    }

    function WebhookService(SVCS, $http, $q, CoreService) {
        var merchantServer = SVCS.Merchant;
        var authServer = SVCS.Auth;
        var gatewayServer = SVCS.Gateway;

        var service = {
            GetByMerchant: GetByMerchant,
            CreateOrUpdate: CreateOrUpdate,
            Delete: Delete
        };

        return service;

        function GetByMerchant(id) {
            var deferer = $q.defer();

            CoreService.Get(merchantServer + '/api/webhooks/merchant/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function CreateOrUpdate(webhook) {
            var deferer = $q.defer();

            CoreService.Post(merchantServer + '/api/webhooks', webhook).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Delete(merchantId) {
            var deferer = $q.defer();

            CoreService.Delete(merchantServer + '/api/webhooks/' + merchantId).then(function (response) {
                deferer.resolve(response);
            });

            return deferer.promise;
        }
        
        
    }
})();
(function () {
    'use strict';

    angular
        .module('app.merchant')
        .directive('isMerchantNameAvailable', isMerchantNameAvailable);

    /** @ngInject **/
    function isMerchantNameAvailable($q, $http, $timeout, SVCS) {
        return {
            require: 'ngModel',
            
            link: function (scope, elm, attrs, ctrl) {
                
                var checkingTask = null;

                var baseUrl = SVCS.Merchant;

                ctrl.$asyncValidators.isMerchantNameAvailable = function (modelValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return $q.when();
                    }

                    var def = $q.defer();

                    if (checkingTask != null) {
                        $timeout.cancel(checkingTask);
                        checkingTask = null;
                    }
                    var id = scope.$eval(attrs.isMerchantNameAvailable);

                    checkingTask = $timeout(function () {
                        $http.post(baseUrl + '/api/merchants/is-merchant-name-available', { Name: modelValue, Id: id }).then(function (response) {
                            if (response.data) {
                                def.resolve();
                            } else {
                                def.reject();
                            }
                        }, function (responseError) {
                            def.reject();
                        })
                    }, 500)

                    return def.promise;
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.merchant')
        .controller('MerchantController', MerchantController);

    /** @ngInject */
    function MerchantController(SVCS, CoreService, MerchantService, WebhookService, MasterMerchantService, $scope, $timeout, BrandService, SharedStoreCardService, PartnerCategoryService, $window, UniversityService, AuthenticationService) {
        var vm = this;
        var controllerName = "Merchant";
        vm.merchantServer = SVCS.Merchant;
        vm.merchant={};
        var uploadImgControl = null;
        vm.tierSettings = [];
        vm.types = [
            { Id: "-1", Name: "-- Select an option --" },
            { Id: "Own", Name: "Own" },
            { Id: "Franchise", Name: "Franchise" },
            { Id: "PTPTN", Name: "PTPTN" },
            { Id: "LineClear", Name: "LineClear" },
            { Id: "Mara", Name: "Mara" },
        ];

        vm.channelList = [
            {
                value: "",
                text: "Select an option"
            },
            {
                value: "Kiplepay",
                text: "Kiplepay"
            },
            {
                value: "RedPay",
                text: "RedPay"
            }
        ];
        vm.clearForm = function () {
            vm.merchant = {
                Company: {
                    Address: {}
                },
                Bank: {},
                StoreCardTopupOptions: [],
                SubscribedServices: [],
                WalletPaymentOption:[],
                UseSharedStoreCard: false,
                IsPartnerMerchant: false
            };

            $scope.merchantForm.$setPristine();
            $scope.merchantForm.$setUntouched();
        }
        MerchantService.SearchBrand({}).then(function (res) {
            vm.tags = res.Items;
        });
        vm.tagTransform = function (newTag) {
            return {
                Id: null,
                Name: newTag
            };
        };
      

        vm.permissions = [
            { Name: "common.permission.view", Value: "VIEW_MERCHANT" },
            { Name: "common.permission.edit", Value: "EDIT_MERCHANT" },
            //{ Name: "common.permission.merchant.add_new_user", Value: "ADD_USER_TO_MERCHANT" },
            //{ Name: "common.permission.merchant.remove_user", Value: "REMOVE_USER_FROM_MERCHANT" },
            { Name: "common.permission.merchant.change_password_user", Value: "CHANGE_PASSWORD_USER_MERCHANT" },
            { Name: "common.permission.merchant.commission_payout_configuration", Value: "COMMISSION_PAYOUT_CONFIGURATION" },
            { Name: "common.permission.merchant.commission_payout_bulk_upload", Value: "COMMISSION_PAYOUT_BULK_UPLOAD" },
            { Name: "common.permission.merchant.commission_payout_report", Value: "COMMISSION_PAYOUT_REPORT" },
            { Name: "common.permission.store.view_list_store", Value: "VIEW_LIST_STORE" },
            { Name: "common.permission.store.create", Value: "CREATE_STORE" },
            { Name: "common.permission.store.edit", Value: "EDIT_STORE" },
            { Name: "common.permission.store.publish", Value: "PUBLISH_STORE" },
            { Name: "common.permission.store.remove", Value: "DELETE_STORE" },
            { Name: "common.permission.store.add_new_manager", Value: "ADD_MANAGER_TO_STORE" },
            { Name: "common.permission.product.view", Value: "VIEW_PRODUCT" },
            { Name: "common.permission.product.edit", Value: "EDIT_PRODUCT" },
            { Name: "common.permission.product.delete", Value: "DELETE_PRODUCT" },
            { Name: "common.permission.product.create", Value: "CREATE_PRODUCT" },
            { Name: "common.permission.product.publish", Value: "PUBLISH_PRODUCT" },
            { Name: "common.permission.store.manage_table", Value: "MANAGE_TABLE" },
            { Name: "common.permission.store.manage_static_qr", Value: "MANAGE_STATIC_QR" },
            { Name: "common.permission.store.view_storecard_transactions_report", Value: "VIEW_STORECARD_TRANSACTION_REPORT" }
        ];

        if (AuthenticationService.hasPermissions('COMMISSION_PAYOUT_ADMIN')) {
            vm.permissions.push({ Name: "common.permission.merchant.commission_payout_admin", Value: "COMMISSION_PAYOUT_ADMIN" });
            vm.permissions.push({ Name: "common.permission.merchant.view_list_merchant", Value: "VIEW_LIST_MERCHANT" });
            vm.permissions.push({ Name: "common.permission.merchant.create_merchant", Value: "CREATE_MERCHANT" });
            vm.permissions.push({ Name: "common.permission.merchant.delete_merchant", Value: "DELETE_MERCHANT" });
            vm.permissions.push({ Name: "common.permission.merchant.publish_merchant", Value: "PUBLISH_MERCHANT" });
            vm.permissions.push({ Name: "common.permission.merchant.add_new_user", Value: "ADD_USER_TO_MERCHANT" });
            vm.permissions.push({ Name: "common.permission.merchant.remove_user", Value: "REMOVE_USER_FROM_MERCHANT" });
        }

        vm.user = { UserName: null, Password: null, ConfirmPassword: null, ObjectId: null, ObjectType: 'Merchant', AccountType: 'Merchant', Permissions: [] };
        vm.requiredServiceDate = false;
        //Initialize
        vm.init = function () {
            //Get list Merchant
            vm.getCommunity();
            vm.getListTierSetting();
            //Get list master merchant
            MasterMerchantService.Search({ Keyword: null }).then(function (res) {
                vm.masterMerchants = res.Items;
            });
            vm.getBrands();
            vm.getPartnerCategories();
            //get apptype
            vm.Tag = localStorage.getItem('apptype');
            var data = CoreService.getInfoSearch();
            if ((data.KeyWord || data.CurrentPage) && CoreService.checkSearchOfController(controllerName) == true) {
                vm.PageLoad(data.KeyWord.KeyWord, data.KeyWord.MasterMerchantName, data.CurrentPage);
            } else {
                CoreService.removeInfoSearch();
                vm.PageLoad("", "", 1);
            }
        }

        vm.PageLoad = function (keyWord, masterMerchantname, currentPage) {
            vm.criteria = {
                Keyword:keyWord,
                Name: null,
                MasterMerchantName: masterMerchantname,
                City: null,
                District: null,
                Province: null,
                Page: currentPage,
                Length:10
                
            }
            vm.totalItems = 0;
            vm.currentPage = currentPage || 1;
            vm.maxSize = 5;
            vm.itemsPerPage = 10;
            vm.viewConfig = { ShowMerchantDialog: false, MerchantAction: null, ShowAddUserDialog: false };
            vm.search();
        }

        vm.searchByKeyword = function ($event) {
            if ($event.which == 13) {
                vm.search();
            }
        }

        //#region Manage Merchant (PageLoad,reset,sort)
        vm.search = function () {
            var criteria = angular.copy(vm.criteria);
            criteria.Page = vm.currentPage;
            MerchantService.Search(criteria).then(function (res) {
                vm.merchants = res.Items;
                vm.totalItems = res.Total;
                if (CoreService.checkSearchOfController(controllerName) == true ||
                    CoreService.getInfoSearch().Controller == "") {
                    var data = {
                        KeyWord: criteria.Keyword,
                        MasterMerchantName: criteria.MasterMerchantName
                    };
                    CoreService.saveInfoSearch(data, criteria.Page, controllerName);
                }
            })
        }

        vm.reset = function () {
            vm.criteria = { Keyword: "", Page: 1, Length: 10, MasterMerchantName: "" };
            vm.currentPage = 1;
            CoreService.removeInfoSearch();
            vm.search();
        }

        vm.sort = function (opts) {

            var sortNames = [];
            var sortDirections = [];
            if (opts.name.constructor === Array) {
                angular.forEach(opts.name, function (val) {
                    sortNames.push(val);
                    sortDirections.push(opts.direction);
                })
            } else {
                sortNames.push(opts.name);
                sortDirections.push(opts.direction);
            }

            vm.criteria.SortNames = sortNames;
            vm.criteria.SortDirections = sortDirections;

            vm.search();
        };
        //#endregion

        vm.getListTierSetting = function () {
            MerchantService.GetTierSettings().then(function (data) {
                vm.tierSettings = data;
            })
        }

        vm.getBrands = function () {
            MerchantService.GetBrands().then(function (data) {
                vm.brands = data;
            })
        }
        vm.getCommunity = function () {
            MerchantService.GetCommunity().then(function (data) {
                vm.CommunitySetting = data;
            })
        }
        vm.getSharedStoreCardSetting = function (brandId) {
            SharedStoreCardService.GetByBrandId(brandId).then(function (data) {
                vm.sharedStoreCardSetting = data;
                if (vm.merchant.Id > 0) {
                    vm.sharedStoreCardSetting = $.grep(vm.sharedStoreCardSetting, function (b) {
                        return b.MerchantId != vm.merchant.Id;
                    });
                }
            })
        }

        vm.getPartnerCategories = function () {
            PartnerCategoryService.All().then(function (data) {
                vm.partnerCategories = data;
                if (vm.merchant.Id > 0) {
                    vm.partnerCategories = $.grep(vm.partnerCategories, function (b) {
                        return b.MerchantId != vm.merchant.Id;
                    });
                }
            })
        }

        vm.requiredWebcashId = true;

        vm.getPartnerType = function (partnerCategoryId) {
            angular.forEach(vm.partnerCategories, function (val) {
                if (val.Id == partnerCategoryId) {
                    if (val.PartnerType == "NoSettlement") {
                        vm.requiredWebcashId = false;
                    }
                    else {
                        vm.requiredWebcashId = true;
                    }
                }
            })
        }


        vm.checkRevenueShare = function () {
            angular.forEach(vm.tierSettings, function (val) {
                if (val.Id == vm.merchant.MerchantTierId) {
                    if (val.RevenueShare) {
                        vm.requiredServiceDate = true;
                    }
                    else {
                        vm.requiredServiceDate = false;
                    }
                }
            })
        }

        vm.getUniversities = function (check) {
            var checkbox = vm.merchant.IsUniversityMerchant;
            var IsChecked = $("#IsUniversityMerchant").is(':checked');
            if (IsChecked == true || check == true) {
                $(".university").css("display", "block");
                $("#IsUniversityMerchant").attr('value', 'true');


                UniversityService.GetPortalUniversity().then(function (data) {
                    vm.universtyList = data.list;
                })
            } else if (IsChecked == false) {
                $("#UniversityId option").remove();
                $("#IsUniversityMerchant").attr('value', 'false');
                vm.merchant.IsUniversityMerchant = false;
                //$(".university").css("display" , "none");
            }
        }

        vm.loadBrandInfo = function (brandId) {
            if (vm.viewConfig.MerchantAction != 'edit') {
                if (brandId != 0) {
                    BrandService.Get(brandId).then(function (res) {
                        vm.brand = res;
                        if (vm.brand) {
                            vm.merchant.Company = {
                                Email: res.Email,
                                RegistrationNumber: res.RegistrationNumber,
                                MainContactPerson: res.MainContactPerson,
                                MainContactNumber: res.MainContactNumber,
                                Website: res.Website,
                                Address: {
                                    Street: res.Address.Street,
                                    City: res.Address.City,
                                    State: res.Address.State,
                                    District: res.Address.District,
                                    PostCode: res.Address.PostCode
                                }
                            };

                            vm.merchant.Logo = res.LogoUrl;
                        }
                    });
                } else {

                    vm.merchant.Company = {
                        Email: null,
                        RegistrationNumber: null,
                        MainContactPerson: null,
                        MainContactNumber: null,
                        Website: null,
                        Address: null
                    };
                    vm.merchant.Logo = null;
                }
            }

            vm.getSharedStoreCardSetting(brandId); //update list shared storecard based on selected brand
        };

        //#region Get subscribed services list
        vm.subscribedServices = [
            { Id: "OrderAtTable", Name: "merchant.subscribed_services_type.order_at_table" },
            { Id: "PayAtTable", Name: "merchant.subscribed_services_type.pay_at_table" },
            { Id: "SalesOfVoucher", Name: "merchant.subscribed_services_type.sales_of_voucher" },
            { Id: "SalesOfStoreCard", Name: "merchant.subscribed_services_type.sales_of_store_card" },
            { Id: "TopUpOfStoreCard", Name: "merchant.subscribed_services_type.top_up_of_store_card" },
            { Id: "MarketingCampaign", Name: "merchant.subscribed_services_type.marketing_campaign" },
            { Id: "AcceptAlipay", Name: "merchant.subscribed_services_type.accept_alipay" },
            { Id: "StaticQR", Name: "merchant.subscribed_services_type.static_qr" },
            { Id: "PayAndGo", Name: "merchant.subscribed_services_type.PayAndGo" },
            { Id: "StorecardPaymentAPI", Name: "merchant.subscribed_services_type.StorecardPaymentAPI" },
            { Id: "DeeplinkPayment", Name: "merchant.subscribed_services_type.DeeplinkPayment" },
            { Id: "LaundryPayment", Name: "merchant.subscribed_services_type.LaundryPayment" },
            { Id: "BazaarService", Name: "Bazaar Service" },
            { Id: "LinkCardService", Name: "Link and Pay" },
{ Id: "DigitalPerakService", Name: "DigitalPerak Service" }

        ];


        //#endregion

        //#region Datetime picker
        vm.dateOptions = {
            //dateDisabled: disabled,
            formatYear: 'yy',
            startingDay: 1
        };

        // Disable weekend selection
        function disabled(data) {
            var date = data.date,
                mode = data.mode;
            return mode === 'day' && (date.getDay() === 0 || date.getDay() === 6);
        }

        vm.openServiceDatePopup = function () {
            vm.serviceDatePopup.opened = true;
        };

        vm.openContractDatePopup = function () {
            vm.contractDatePopup.opened = true;
        };

        vm.serviceDatePopup = {
            opened: false
        };
        vm.contractDatePopup = {
            opened: false
        };
        //#endregion

        //Manage merchant
        vm.add = function () {
            setDefaultWebhook();
            vm.viewConfig.MerchantAction = 'new';
            vm.clearForm();
            vm.merchant.GSTSetting = "Inclusive";
            $('a[href="#merchantDiv"]').tab('show');
            vm.viewConfig.ShowMerchantDialog = true;
        }

        vm.MerchantId = null;

        vm.edit = function (merchantId) {
            vm.temp = null;
            angular.element("input[type='file']").val(null);
            $('a[href="#merchantDiv"]').tab('show');
            vm.Tag = localStorage.getItem('apptype');
            if (vm.Tag == 5) {
                $("#merchantForm :input").attr("disabled", true);
            }
            else {
                $("#merchantForm :input").attr("disabled", false);
            }
            MerchantService.Get(merchantId).then(function (res) {
                vm.merchant = res;
              //  vm.merchant.Channel = res.Channel === "Kiplemart" ? "1" : "0";
                if (vm.merchant.CommunityId != null) {
                    vm.merchant.CommunityId = res.CommunityId;
                }
               
                vm.merchant.WalletPaymentOption=[];
                if (res.IsBoostEnabled) {
                    vm.merchant.WalletPaymentOption.push("Boost");
                }
                if (res.IsGrabEnabled) {
                    vm.merchant.WalletPaymentOption.push("GrabPay");
                }
                if (res.IsTnGEnabled) {
                    vm.merchant.WalletPaymentOption.push("TnG");
                }
                if (res.IsAliPayEnabled) {
                    vm.merchant.WalletPaymentOption.push("AliPay");
                }
                if (res.IsMayPayEnabled) {
                    vm.merchant.WalletPaymentOption.push("MayBankPay");
                }
                if (res.IsRazerPayEnabled) {
                    vm.merchant.WalletPaymentOption.push("RazerPay");
                }
                if (res.IsWeChatPayEnabled) {
                    vm.merchant.WalletPaymentOption.push("WeChatPay");
                }
                if (res.IsWeChatPayMyEnabled) {
                    vm.merchant.WalletPaymentOption.push("WeChatPayInt");
                }
                if (res.IAliPayIntEnabled) {
                    vm.merchant.WalletPaymentOption.push("AliPayInt");
                }
                if (res.IsSelangkahWalletEnabled) {
                    vm.merchant.WalletPaymentOption.push("SelangkahWallet");
                }
                if (res.IsCashPaymentEnabled) {
                    vm.merchant.WalletPaymentOption.push("Cash");
                }
                if (res.IsDuitNowEnabled) {
                    vm.merchant.WalletPaymentOption.push("DuitNow");
                }
                angular.forEach(vm.tierSettings, function (val) {
                    if (val.Id == vm.merchant.MerchantTierId) {
                        if (val.RevenueShare) {
                            vm.requiredServiceDate = true;
                        }
                        else {
                            vm.requiredServiceDate = false;
                        }
                    }
                })

                vm.getSharedStoreCardSetting(vm.merchant.BrandId);

                if (vm.merchant.SharedStoreCardSettingId == 0) {
                    vm.merchant.SharedStoreCardSettingId = null
                }

                if (vm.merchant.PartnerCategoryId) {
                    vm.getPartnerType(vm.merchant.PartnerCategoryId);
                }

                vm.viewConfig.ShowMerchantDialog = true;
                if (vm.merchant.Logo) {
                    vm.disabledDeleteLogo = false;
                } else {
                    vm.disabledDeleteLogo = true;
                }

                vm.viewConfig.MerchantAction = 'edit';
                if (vm.merchant.ServiceDate != null) {
                    vm.merchant.ServiceDate = new Date(vm.merchant.ServiceDate);
                }
                if (vm.merchant.ContractDate != null) {
                    vm.merchant.ContractDate = new Date(vm.merchant.ContractDate);
                }

                if (res.IsUniversityMerchant) {
                    vm.getUniversities(true);
                    $(".university").css("display", "block");
                    $("#IsUniversityMerchant").prop('checked', true);
                } else {
                    $("#UniversityId option").remove();
                    $("#IsUniversityMerchant").prop('checked', false);
                    $(".university").css("display", "block");
                }
               
            })
        }

        vm.changeIsPartnerMerchant = function () {
            if (vm.merchant.IsPartnerMerchant) {
                vm.getPartnerType(vm.merchant.PartnerCategoryId);
            } else {
                vm.requiredWebcashId = true;
            }
        }

        vm.WalletOption = [
            { Id: "Boost", Name: "Boost" },
            { Id: "GrabPay", Name: "GrabPay" },
            { Id: "TnG", Name: "TouchNGo" },
            { Id: "AliPay", Name: "AliPay" },
            { Id: "MayBankPay", Name: "MayBankPay" },
            { Id: "RazerPay", Name: "RazerPay" },
            { Id: "WeChatPay", Name: "WeChatPay" },
            { Id: "WeChatIntPay", Name: "WeChatPayInt" },
            { Id: "AliPayInt", Name: "AliPayInt" },
            { Id: "SelangkahWallet", Name: "SelangkahWallet" },
            { Id: "Cash", Name: "Cash" },
            { Id: "DuitNow", Name: "DuitNow" }
            ];

        vm.save = function () {
            vm.merchant.IsBoostEnabled = false;
            vm.merchant.IsGrabEnabled = false;
            vm.merchant.IsTnGEnabled = false;
            vm.merchant.IsAliPayEnabled = false;
            vm.merchant.IsMayPayEnabled = false;
            vm.merchant.IsRazerPayEnabled = false;
            vm.merchant.IsWeChatPayEnabled = false;
            vm.merchant.IsWeChatPayMyEnabled = false;
            vm.merchant.IAliPayIntEnabled = false;
            vm.merchant.IsSupportRazorPay = false;
            vm.merchant.IsSelangkahWalletEnabled = false;
            vm.merchant.IsCashPaymentEnabled = false;
            vm.merchant.IsCashPaymentEnabled = false;
            vm.merchant.IsDuitNowEnabled = false;
            var stat = 0;
            if (vm.merchant.WalletPaymentOption != null) {
                if (vm.merchant.WalletPaymentOption.length > 0) {
                    angular.forEach(vm.merchant.WalletPaymentOption, function (field) {
                        if (field == "Boost") {
                            vm.merchant.IsBoostEnabled = true;
                            stat = 1;
                        };
                        if (field == "GrabPay") {
                            vm.merchant.IsGrabEnabled = true;
                            stat = 1;
                        };
                        if (field == "TnG") {
                            vm.merchant.IsTnGEnabled = true;
                            stat = 1;
                        };
                        if (field == "AliPay") {
                            vm.merchant.IsAliPayEnabled = true;
                            stat = 1;
                        };
                        if (field == "MayBankPay") {
                            vm.merchant.IsMayPayEnabled = true;
                            stat = 1;
                        };
                        if (field == "RazerPay") {
                            vm.merchant.IsRazerPayEnabled = true;
                            stat = 1;
                        };
                        if (field == "WeChatPay") {
                            vm.merchant.IsWeChatPayEnabled = true;
                            stat = 1;
                        };
                        if (field == "WeChatPayInt") {
                            vm.merchant.IsWeChatPayMyEnabled = true;
                            stat = 1;
                        };
                        if (field == "AliPayInt") {
                            vm.merchant.IAliPayIntEnabled = true;
                            stat = 1;
                        };
                        if (field == "Cash") {
                            vm.merchant.IsCashPaymentEnabled = true;
                            stat = 1;
                        };
                        if (field == "SelangkahWallet") {
                            vm.merchant.IsSelangkahWalletEnabled = true;
                            stat = 1;
                        };
                        if (field == "DuitNow") {
                            vm.merchant.IsDuitNowEnabled = true;
                            stat = 1;
                        };
                    });
                }
            }
            if (stat == 1) {
                vm.merchant.IsSupportRazorPay = true;
            }
            if (!vm.merchant.UseSharedStoreCard) {
                vm.merchant.SharedStoreCardSettingId = 0;
            }

            if (!vm.merchant.IsPartnerMerchant) {
                vm.merchant.PartnerCategoryId = null;
            }

            if (!$scope.merchantForm.$valid) {
                angular.forEach($scope.merchantForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('a[href="#merchantTab"]').tab('show');
                $timeout(function () {
                    $('#merchantForm .ng-invalid')[0].focus();
                }, 200);
                return;
            }

            if (!$scope.storeCardTopupOptionsForm.$valid) {
                angular.forEach($scope.storeCardTopupOptionsForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('a[href="#storeCardTopupOptionsTab"]').tab('show');
                $timeout(function () {
                    $('#storeCardTopupOptionsForm .ng-invalid')[0].focus();
                }, 200);
                return;
            }

            if (vm.viewConfig.MerchantAction == 'new') {
                MerchantService.Create(vm.merchant).then(function (res) {
                    if (!vm.merchant) { vm.merchants = []; }
                    vm.merchants.push({
                        Id: res.Result,
                        Name: vm.merchant.Company.Name,
                        City: vm.merchant.Company.Address ? vm.merchant.Company.Address.City : null,
                        Province: vm.merchant.Company.Address ? vm.merchant.Company.Address.State : null,
                        District: vm.merchant.Company.Address ? vm.merchant.Company.Address.District : null,
                        State: "Approved",
                        NumberOfStore: 0,
                    });
                    vm.viewConfig.MerchantAction = null;
                    vm.viewConfig.ShowMerchantDialog = false;
                    if (vm.merchant.MerchantTierId !== undefined && vm.merchant.MerchantTierId !== 0) {
                        var model = {
                            MerchantId: res.Result,
                            MerchantTierId: vm.merchant.MerchantTierId
                        }
                    }

                    vm.search();
                })
            }
            else if (vm.viewConfig.MerchantAction == 'edit') {
                MerchantService.Update(vm.merchant).then(function () {
                    vm.viewConfig.MerchantAction = null;
                    vm.viewConfig.ShowMerchantDialog = false;

                    if (vm.merchant.MerchantTierId !== undefined && vm.merchant.MerchantTierId !== 0) {
                        var model = {
                            MerchantId: vm.merchant.Id,
                            MerchantTierId: vm.merchant.MerchantTierId
                        }
                    }
                    vm.search();
                    vm.cancel();
                    MerchantService.IsMerchantHasProductNoPrice(vm.merchant.Id).then(function (res) {
                        if (res) {
                            vm.error = "There are some products have no price, please update them";
                        }
                        else {
                            vm.error = null;
                        }
                    });
                })
                //add webhook for merchant
                saveWebhook(vm.merchant.Id);

                vm.MerchantId = vm.merchant.Id;
            }

        }

        vm.unpublish = function (merchant) {
            MerchantService.Unpublish(merchant.Id).then(function (res) {
                merchant.State = 'Unpublished';
            })
        }

        vm.publish = function (merchant) {
            MerchantService.Publish(merchant.Id).then(function (res) {
                merchant.State = 'Published';
            })
        }

        vm.cancel = function () {
            vm.viewConfig.MerchantAction = null;
            vm.viewConfig.ShowMerchantDialog = false;
        }
        //Manage merchant end

        //Add or remove user
        vm.addUser = function (merchantId) {
            vm.user.ObjectId = merchantId;
            vm.viewConfig.ShowAddUserDialog = true;
            vm.user.UserName = null;
            vm.user.Password = null;
            vm.user.ConfirmPassword = null;
            vm.user.Permissions = []
            $scope.merchantUserForm.$setPristine();
            $scope.merchantUserForm.$setUntouched();
        }

        vm.saveUser = function () {
            if (!$scope.merchantUserForm.$valid) {
                angular.forEach($scope.merchantUserForm.$error, function (field) {
                    angular.forEach(field, function (errorField) {
                        errorField.$setTouched();
                    })
                });
                $('#merchantUserForm .ng-invalid')[0].focus();
                return;
            }

            MerchantService.AddUser(vm.user).then(function (res) {
                vm.viewConfig.ShowAddUserDialog = false;
                vm.user = { UserName: null, Password: null, ComfirmPassword: null, ObjectId: null, ObjectType: 'Merchant', AccountType: 'Merchant', Permissions: [] };
            })
        }

        vm.addPermission = function (permission) {
            if (vm.user.Permissions.indexOf(permission) != -1) {
                vm.user.Permissions.removeItem(permission);
            }
            else {
                vm.user.Permissions.push(permission);
            }
        }

        vm.permissionSelected = function (value) {
            if (vm.user == undefined) {
                return;
            }

            if (vm.user.Permissions.indexOf(value) != -1) {
                return true;
            }
            else {
                return false;
            }
        }

        vm.SelectedAll = true;

        vm.selectAll = function () {
            if (vm.SelectedAll) {
                vm.user.Permissions = [];
                angular.forEach(vm.permissions, function (item) {
                    vm.user.Permissions.push(item.Value);
                    //vm.permissionSelected(item.Value);
                });
                vm.SelectedAll = false;
            }
            else {
                vm.user.Permissions = [];
                vm.SelectedAll = true;
            }
        }
        //Add or remove user end

        // Upload logo
        vm.disabledDeleteLogo = true;
        vm.loading = { UploadMerchantLogo: false }
        vm.onMerchantLogoSelected = function (files, controlGetter) {
            uploadImgControl = controlGetter();
            if (files != null && files.length) {
                vm.temp = files[0].name;
                vm.loading.UploadMerchantLogo = true;
                MerchantService.UploadMerchantLogo(files[0]).then(function (path) {
                    vm.loading.UploadMerchantLogo = false;
                    vm.disabledDeleteLogo = false;
                    if (path) {
                        vm.merchant.Logo = path.Result;
                        //$scope.merchantForm.Logo.$setTouched();
                    }
                }, function (error) {
                    vm.loading.UploadMerchantLogo = false;
                })
            }
        }

        vm.deleteLogo = function () {
            if (vm.merchant.Logo) {
                vm.merchant.Logo = null;
                vm.disabledDeleteLogo = true;
                $scope.file = null;
                vm.temp = null;
                angular.element("input[type='file']").val(null);
            }
            else {
                return;
            }
        }
        // End upload logo

        vm.delete = function (id) {
            var isMasterPartnerMerchant = false;

            angular.forEach(vm.partnerCategories, function (item) {
                if (item.MerchantId == id) {
                    isMasterPartnerMerchant = true;
                }
            });

            if (isMasterPartnerMerchant) {
                var message = 'Are you sure you want to remove this merchant? Merchant in partner page will be remove too.';
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }
            }
            else {
                var message = 'Are you sure you want to remove this merchant?';
                var confirm = window.confirm(message);
                if (!confirm) {
                    return;
                }
            }


            MerchantService.Delete(id).then(function (res) {
                vm.search();
            })
        }

        vm.addStoreCardTopupOption = function () {
            vm.merchant.StoreCardTopupOptions.push({
                Name: null,
                Amount: null,
                Bonus: null
            });
        }

        vm.removeStoreCardTopupOption = function (index) {
            vm.merchant.StoreCardTopupOptions.splice(index, 1);
        }

        /*************************WEBHOOK********************************/
        vm.getWebhook = function (merchantId) {
            //clear validation
            $scope.webhookForm.$setPristine();
            $scope.webhookForm.$setUntouched();

            WebhookService.GetByMerchant(merchantId).then(function (res) {
                setDefaultWebhook(merchantId);

                setDeeplinkWebhook(merchantId);

                angular.forEach(vm.webhooks, function (item) {
                    var webhook = res.findItem('Type', item.Type);
                    if (webhook) {
                        item.CallBackUrl = webhook.CallBackUrl;
                    }
                })

                angular.forEach(vm.deeplinks, function (item) {
                    var webhook = res.findItem('Type', item.Type);
                    if (webhook) {
                        item.CallBackUrl = webhook.CallBackUrl;
                    }
                })
            })
        }

        function setDefaultWebhook(merchantId) {
            vm.webhooks = [
                { CallBackUrl: null, Type: 'SignUp', TypeName: 'Account registration', MerchantId: merchantId, Rank: 0 },
                { CallBackUrl: null, Type: 'Topup', TypeName: 'Topup', MerchantId: merchantId, Rank: 1 },
                { CallBackUrl: null, Type: 'Payment', TypeName: 'Payment', MerchantId: merchantId, Rank: 2 },
                { CallBackUrl: null, Type: 'Hold', TypeName: 'Hold', MerchantId: merchantId, Rank: 3 },
                { CallBackUrl: null, Type: 'CompleteHold', TypeName: 'Commit hold', MerchantId: merchantId, Rank: 4 },
                { CallBackUrl: null, Type: 'Void', TypeName: 'Void transaction', MerchantId: merchantId, Rank: 5 }
            ]
        }

        function setDeeplinkWebhook(merchantId) {
            vm.deeplinks = [
                { CallBackUrl: null, Type: 'Deeplink', TypeName: 'Deeplink', MerchantId: merchantId, Rank: 6 }
            ]
        }

        function saveWebhook(merchantId) {
            var webhooks = [];
            angular.forEach(vm.webhooks, function (item) {
                if (!utils.isNullOrEmpty(item.CallBackUrl)) {
                    item.MerchantId = merchantId;
                    webhooks.push(item);
                }
            })

            angular.forEach(vm.deeplinks, function (item) {
                if (!utils.isNullOrEmpty(item.CallBackUrl)) {
                    item.MerchantId = merchantId;
                    webhooks.push(item);
                }
            })

            if (webhooks.length == 0) {
                WebhookService.Delete(merchantId);
            }
            else {
                WebhookService.CreateOrUpdate(webhooks).then(function (res) { })
            }
        }

        vm.createHashKey = function () {
            vm.merchant.HashKey = Math.random().toString(36).substring(2);
        }

        vm.init();
    }
})();
(function () {
    'use strict';

    angular
        .module('app.dashboard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.dashboard', {
                url: '/',
                templateUrl: 'app/dashboard/dashboard.html',
                controller: 'DashboardController',
                controllerAs: 'vm',
                protect: true
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/dashboard');

    }
})();
(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    /** @ngInject */
    function DashboardController(SVCS, $scope, $rootScope) {
        var vm = this;
        $("div").removeClass("modal-backdrop");
        $('body').removeClass('modal-open');
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth')
        .controller('HeaderController', HeaderController);

    /** @ngInject */
    function HeaderController(SVCS, $state, $rootScope, AuthenticationService, $cookies) {
        var vm = this;

       

        vm.signOut = function () {
            AuthenticationService.signOut();
            $state.go('auth.login');
        }

        vm.profile = function () {
            var accountType = $cookies.get('account_type');

            if (accountType == 2) {
                $state.go('app.merchant.info', { 'merchantId': null });
            }
        }

        vm.changePassword = function () {
            $state.go('app.account.change-password');
        }

        vm.openNav = function () {
            document.getElementById("mySidenav").style.width = "315px";
            document.getElementById("mySidenav").style.padding = "20px 20px 70px 20px";
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.data',[]);
})();
(function () {
    'use strict';

    angular
        .module('app.data')
        .factory('DataService', DataService);

    /** @ngInject */
    function DataService(SVCS, $http, $q, CoreService) {

        var service = {
            AllMerchantCategories: AllMerchantCategories,
            UploadPhoto: UploadPhoto
        };

        return service;

        function AllMerchantCategories() {
            var deferer = $q.defer();

            CoreService.Get(SVCS.Merchant + '/api/categories/all').then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function UploadPhoto(img) {
            var deferer = $q.defer();

            var formData = new FormData();
            formData.append('file', img);

            $http.post(SVCS.Gateway + '/api/photos/upload', formData, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }
    }
})();
(function () {

    if (typeof utils === 'undefined') { utils = {}; }

    Array.prototype.findItem = function (prop, value) {
        if (this == null || this === undefined)
            return undefined;
        for (var i = 0, len = this.length; i < len; i++)
            if (this[i][prop] == value) return this[i];
        return undefined;
    }

    Array.prototype.removeItem = function (item) {
        if (this == null || this === undefined)
            return;
        for (var i = 0; i < this.length; i++) {
            if (this[i] === item) {
                this.splice(i, 1);
                return;
            }
        }
    }

    String.prototype.format = function () {
        var formatted = this;
        for (var i = 0; i < arguments.length; i++) {
            var regexp = new RegExp('\\{' + i + '\\}', 'gi');
            formatted = formatted.replace(regexp, arguments[i]);
        }
        return formatted;
    };


    utils.isNullOrEmpty = function(value){
        return typeof value == 'string' && !value.trim() || typeof value == 'undefined' || value === null;
    }
    
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('QRCodeService', QRCodeService);

    /** @ngInject */
    function QRCodeService(SVCS, $http, $q, CoreService) {

        var service = {
            Generate: Generate,
            GenerateStoreQRCode: GenerateStoreQRCode,
            Active: Active,
            InActive: InActive,
            Create: Create
        };

        return service;

        function Generate(qrcode) {
            var deferer = $q.defer();

            CoreService.Post(SVCS.QRCode + '/api/qrcodes/generate', qrcode).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function GenerateStoreQRCode(storeId) {
            var deferer = $q.defer();
            CoreService.Get(SVCS.QRCode + '/api/qrcodes/generate/store?storeId=' + storeId).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Active(id) {
            var deferer = $q.defer();

            CoreService.Put(SVCS.QRCode + '/api/qrcodes/active/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function InActive(id) {
            var deferer = $q.defer();

            CoreService.Put(SVCS.QRCode + '/api/qrcodes/inactive/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Create(id) {
            var deferer = $q.defer();

            CoreService.Get(SVCS.QRCode + '/api/qrcodes/create/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
    }
})();
(function () {

    angular
        .module('app.core')
        .service('popupService', ["$uibModal", function ($uibModal) {

            var modalDefaults = {
                animation: true,
                backdrop: true,
                keyboard: true,
                templateUrl: 'app/common/modal.view.html'
            };

            var modalOptions = {
                closeButtonText: 'Close',
                actionButtonText: 'OK',
                headerText: 'Proceed?',
                bodyText: 'Perform this action?'
            };

            this.showModal = function (customModalDefaults, customModalOptions) {
                customModalDefaults = customModalDefaults || {};


                customModalDefaults.backdrop = 'static';

                return this.show(customModalDefaults, customModalOptions);
            };

            this.showDialog = function (customModalDefaults) {
                customModalDefaults = customModalDefaults || {};

                customModalDefaults.backdrop = 'static';
                customModalDefaults.size = "sm";

                customModalDefaults.templateUrl = "/tmp/common/views/dialog.view.html";

                //Create temp objects to work with since we're in a singleton service
                var tempModalDefaults = {};

                //Map angular-ui modal custom defaults to modal defaults defined in service
                angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);
                this.dialogInstance = $uibModal.open(tempModalDefaults);
                return this.dialogInstance;
            };

            this.closeDialog = function () {
                this.dialogInstance.dismiss('cancel');
            }

            this.show = function (customModalDefaults, customModalOptions) {
                //Create temp objects to work with since we're in a singleton service
                var tempModalDefaults = {};
                var tempModalOptions = {};

                //Map angular-ui modal custom defaults to modal defaults defined in service
                angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);
                //Map modal.html $scope custom properties to defaults defined in service
                angular.extend(tempModalOptions, modalOptions, customModalOptions);

                if (!tempModalDefaults.controller) {
                    tmpCtrl.$inject = ['$scope', "$uibModalInstance"];
                    function tmpCtrl($scope, $uibModalInstance) {
                        $scope.modalOptions = tempModalOptions;
                        $scope.modalOptions.ok = function (result) {
                            $uibModalInstance.close(result);
                        };
                        $scope.modalOptions.close = function () {
                            $uibModalInstance.dismiss('cancel');
                        };
                    }
                    tempModalDefaults.controller = tmpCtrl;
                }

                return $uibModal.open(tempModalDefaults).result;
            };

        }]);
})();
(function () {
    'use strict';

    angular
        .module('app.report')
        .factory('$numUtils', $numUtils);

    /** @ngInject */
    function $numUtils($filter) {

        var service = {
            toFixed: toFixed
        };

        return service;

        function toFixed(number, decimalPlaces) {
            return $filter('number')(number, isNaN(decimalPlaces) ? 2 : decimalPlaces);
        }
    }
})();
//import { tmpdir } from "os"
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('CoreService', CoreService);

    /** @ngInject */
    function CoreService($http, $q) {
        var service = {
            Get: Get,
            Post: Post,
            Put: Put,
            Delete: Delete,
            saveInfoSearch: saveInfoSearch,
            removeInfoSearch: removeInfoSearch,
            getInfoSearch: getInfoSearch,
            checkSearchOfController: checkSearchOfController
        };
        return service;

        function getInfoSearch() {
            var data = JSON.parse(localStorage.getItem("InfoUserSearch"));
            if(data==null){
                data={
                    KeyWord:"",
                    CurrentPage: 1,
                    Controller:"",
                }
            }
            if (data.KeyWord==null) {
                data.KeyWord="";
            }
            return data;
        }

        function saveInfoSearch(keyWord, currentPage, controller) {
            var data = {
                KeyWord: keyWord,
                CurrentPage: currentPage,
                Controller: controller
            }
            localStorage.setItem("InfoUserSearch", JSON.stringify(data));
        }

        function removeInfoSearch() {
            localStorage.removeItem("InfoUserSearch");
            this.saveInfoSearch("",1,"");
        }

        function checkSearchOfController(controllerName) {
            var data = this.getInfoSearch();
            if (data.Controller == controllerName) {
                return true;
            }
            return false;
        }
        function Get(url, data) {
            var deferer = $q.defer();

            if (data != undefined && data != null) {
                $http.get(url, { params: data }).then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    showError(responseError.data);
                    deferer.reject(responseError.data);
                })
            }
            else {
                $http.get(url).then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    showError(responseError.data);
                    deferer.reject(responseError.data);
                })
            }

            return deferer.promise;
        }

        function Post(url, data) {
            var deferer = $q.defer();

            if (data != undefined && data != null) {
                $http.post(url, data).then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    showError(responseError.data);
                    deferer.reject(responseError.data);
                })
            }
            else {
                $http.post(url).then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    showError(responseError.data);
                    deferer.reject(responseError.data);
                })
            }

            return deferer.promise;
        }

        function Put(url, data) {
            var deferer = $q.defer();

            if (data != undefined && data != null) {
                $http.put(url, data).then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    showError(responseError.data);
                    deferer.reject(responseError.data);
                })
            }
            else {
                $http.put(url).then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    showError(responseError.data);
                    deferer.reject(responseError.data);
                })
            }

            return deferer.promise;
        }

        function Delete(url, data) {
            var deferer = $q.defer();

            if (data != undefined && data != null) {
                $http.delete(url, data).then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    showError(responseError.data);
                    deferer.reject(responseError.data);
                })
            }
            else {
                $http.delete(url).then(function (response) {
                    deferer.resolve(response.data);
                }, function (responseError) {
                    showError(responseError.data);
                    deferer.reject(responseError.data);
                })
            }

            return deferer.promise;
        }

        function showError(data) {
            if (!data) {
                return;
            }

            alert(data.Message);
        }

    }
})();
(function () {
    angular
        .module('app.commissionpayout')
        .service('commissionService', commissionService)

    commissionService.$inject = [
        '$http',
        'SVCS'];

    function commissionService($http, SVCS) {
        var gatewayServer = SVCS.Gateway;
        var searchPrefundAccount = function (criteria) {
            return $http.get(gatewayServer + '/api/commission/v1/prefundaccount/search',
                { params: criteria });
        }

        var createPrefundAccount = function (entity) {
            return $http.post(gatewayServer + '/api/commission/prefundaccount/create',
                entity,
                { headers: { 'Content-Type': 'application/json' } });
        }

        var updatePrefundAccount = function (entity) {
            return $http.post(gatewayServer + '/api/commission/prefundaccount/update',
                entity,
                { headers: { 'Content-Type': 'application/json' } });
        }

        var deletePrefundAccount = function (entityId) {
            return $http.delete(gatewayServer + '/api/commission/prefundaccount/delete/' + entityId);
        }

        var searchMerchant = function (entity) {
            return $http.post(gatewayServer + '/api/commission/merchant/search',
                entity,
                { headers: { 'Content-Type': 'application/json' } });
        }

        var uploadCommissionCsv = function (entity) {
            return $http.post(gatewayServer + '/api/commission/bulkupload/import-credit',
                entity,
                { headers: { 'Content-Type': 'application/json' } });
        }

        var searchBatch = function (criteria) {
            return $http.get(gatewayServer + '/api/commission/v2/bulkupload/search',
                { params: criteria });
        }

        var downloadBatchCSV = function (batchNo) {
            return $http.get(gatewayServer + '/api/commission/bulkupload/download/' + batchNo);
        }

        var approveBatch = function (batchNo) {
            return $http.put(gatewayServer + '/api/commission/bulkupload/Approve/' + batchNo);
        }

        var rejectBatch = function (batchNo) {
            return $http.put(gatewayServer + '/api/commission/bulkupload/Reject/' + batchNo);
        }

        var deleteBatch = function (entityId) {
            return $http.delete(gatewayServer + '/api/commission/bulkupload/delete/' + entityId);
        }

        var getMerchantBalance = function () {
            return $http.get(gatewayServer + '/api/commission/bulkupload/Balance');
        }

        var searchBatchReport = function (criteria) {
            return $http.get(gatewayServer + '/api/commission/v1/report/search',
                { params: criteria });
        }

        var downloadBatchReport = function (criteria) {
            return $http.get(gatewayServer + '/api/commission/v1/report/download',
                { params: criteria });
        }
        var searchMerchantTopupBatchReport = function (criteria) {
            return $http.get(gatewayServer + '/api/commission/merchant/wallet/report/search',
                { params: criteria });
        }
        var downloadReportCSV = function (batchNo) {
            return $http.get(gatewayServer + '/api/commission/report/download/' + batchNo);
        }

        var searchPrefundEmail = function (criteria) {
            return $http.get(gatewayServer + '/api/commission/v1/prefundemail/search',
                { params: criteria });
        }

        var createPrefundEmail = function (entity) {
            return $http.post(gatewayServer + '/api/commission/prefundemail/create',
                entity,
                { headers: { 'Content-Type': 'application/json' } });
        }

        var updatePrefundEmail = function (entity) {
            return $http.post(gatewayServer + '/api/commission/prefundemail/update',
                entity,
                { headers: { 'Content-Type': 'application/json' } });
        }

        var deletePrefundEmail = function (entityId) {
            return $http.delete(gatewayServer + '/api/commission/prefundemail/delete/' + entityId);
        }
        var getMerchantTopupLink = function (amount) { 
            return $http.get(gatewayServer + '/api/commission/merchant/wallet/topup?amount=' + amount);
        }
        var getMerchantInfo = function (entity) {
            return $http.post(gatewayServer + '/api/commission/merchant/v1/details',
                entity,
                { headers: { 'Content-Type': 'application/json' } });
        };
        var getMerchantInfolnkPrefundAcct = function (entity) { //not in use
            return $http.post(gatewayServer + '/api/commission/merchant/v2/details',
                entity,
                { headers: { 'Content-Type': 'application/json' } });
        };
        var ViewBatch = function (criteria) {
            return $http.post(gatewayServer + '/api/commission/bulkupload/View',
                criteria,
                { headers: { 'Content-Type': 'application/json' } });
        };
        
        var ViewReport = function (criteria) {
            return $http.post(gatewayServer + '/api/commission/report/view',
                criteria,
                { headers: { 'Content-Type': 'application/json' } });
        };

        // Get users/Approvers for Action By filter
        var getUsers = function () {
            return $http.get(gatewayServer + '/api/commission/users');
        }

        // Get merchants for MID filter
        var getMerchants = function () {
            return $http.get(gatewayServer + '/api/commission/merchants');
        }

        // Get campaigns for Campaign Name filter
        var getCampaigns = function () {
            return $http.get(gatewayServer + '/api/commission/campaigns');
        }

        // Get topup usersApprovers for Topup User filter
        var getTopupUsers = function () {
            return $http.get(gatewayServer + '/api/commission/getTopupUsers');
        }

        // Get topup merchants for Topup Merchant filter
        var getTopupMerchants = function () {
            return $http.get(gatewayServer + '/api/commission/getTopupMerchants');
        }

        return {
            searchMerchant: searchMerchant,
            searchPrefundAccount: searchPrefundAccount,
            createPrefundAccount: createPrefundAccount,
            updatePrefundAccount: updatePrefundAccount,
            deletePrefundAccount: deletePrefundAccount,
            uploadCommissionCsv: uploadCommissionCsv,
            searchBatch: searchBatch,
            downloadBatchCSV: downloadBatchCSV,
            downloadReportCSV: downloadReportCSV,
            approveBatch: approveBatch,
            rejectBatch: rejectBatch,
            deleteBatch: deleteBatch,
            getMerchantBalance: getMerchantBalance,
            searchBatchReport: searchBatchReport,
            searchPrefundEmail: searchPrefundEmail,
            createPrefundEmail: createPrefundEmail,
            updatePrefundEmail: updatePrefundEmail,
            deletePrefundEmail: deletePrefundEmail,
            getMerchantTopupLink: getMerchantTopupLink,
            searchMerchantTopupBatchReport: searchMerchantTopupBatchReport,
            getMerchantInfo: getMerchantInfo,
            getMerchantInfolnkPrefundAcct: getMerchantInfolnkPrefundAcct,
            ViewBatch: ViewBatch,
            ViewReport: ViewReport,
            getUsers: getUsers,
            getMerchants: getMerchants,
            getCampaigns: getCampaigns,
            getTopupUsers: getTopupUsers,
            getTopupMerchants: getTopupMerchants,
            downloadBatchReport: downloadBatchReport
        };
    }
})();
(function () {
    angular
        .module('app.community')
        .service('CommunityService', CommunityService);

   

    function CommunityService($http, $q, SVCS, CoreService) {
        var authServer = SVCS.Auth;
        var gatewayServer = SVCS.Gateway;

        var service = {

            Get: Get,
            Search: Search,
            Create: Create,
            Update: Update,
            PublishCommunity: PublishCommunity,
            UploadPhoto: UploadPhoto,
            GetAllCommunity:GetAllCommunity
        };

        return service;
        function GetAllCommunity(criteria) {
            var deferer = $q.defer();

            CoreService.Get(authServer + '/api/community/community-list').then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Get(authServer + '/api/community/GetCommunity', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Get(id) {
            var deferer = $q.defer();

            CoreService.Get(authServer + '/api/community/GetCommunityById/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        

        function Create(CommunityModel) {
            var deferer = $q.defer();

            CoreService.Post(authServer + '/api/community/CreateCommunity', CommunityModel).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function Update(CommunityModel) {
            var deferer = $q.defer();

            CoreService.Post(authServer + '/api/community/UpdateCommunity', CommunityModel).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function PublishCommunity(id, val) {

            var deferer = $q.defer();

            $http.post(authServer + '/api/community/publish?id=' + id + '&val=' + val).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                alert(responseError.data.Message);
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }
        function UploadPhoto(img) {
            var deferer = $q.defer();

            var formData = new FormData();
            formData.append('file', img);

            $http.post(gatewayServer + '/api/photos/communityLogoUpload', formData, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }).then(function (response) {
                deferer.resolve(response.data);
            }, function (responseError) {
                deferer.reject(responseError.data);
            });

            return deferer.promise;
        }
    }
})();
(function () {

    angular
        .module('app.core')
        .service('popupService', ["$uibModal", function ($uibModal) {

            var modalDefaults = {
                animation: true,
                backdrop: true,
                keyboard: true,
                templateUrl: 'app/common/modal.view.html'
            };

            var modalOptions = {
                closeButtonText: 'Close',
                actionButtonText: 'OK',
                headerText: 'Proceed?',
                bodyText: 'Perform this action?'
            };

            this.showModal = function (customModalDefaults, customModalOptions) {
                customModalDefaults = customModalDefaults || {};


                customModalDefaults.backdrop = 'static';

                return this.show(customModalDefaults, customModalOptions);
            };

            this.showDialog = function (customModalDefaults) {
                customModalDefaults = customModalDefaults || {};

                customModalDefaults.backdrop = 'static';
                customModalDefaults.size = "sm";

                customModalDefaults.templateUrl = "/tmp/common/views/dialog.view.html";

                //Create temp objects to work with since we're in a singleton service
                var tempModalDefaults = {};

                //Map angular-ui modal custom defaults to modal defaults defined in service
                angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);
                this.dialogInstance = $uibModal.open(tempModalDefaults);
                return this.dialogInstance;
            };

            this.closeDialog = function () {
                this.dialogInstance.dismiss('cancel');
            }

            this.show = function (customModalDefaults, customModalOptions) {
                //Create temp objects to work with since we're in a singleton service
                var tempModalDefaults = {};
                var tempModalOptions = {};

                //Map angular-ui modal custom defaults to modal defaults defined in service
                angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);
                //Map modal.html $scope custom properties to defaults defined in service
                angular.extend(tempModalOptions, modalOptions, customModalOptions);

                if (!tempModalDefaults.controller) {
                    tmpCtrl.$inject = ['$scope', "$uibModalInstance"];
                    function tmpCtrl($scope, $uibModalInstance) {
                        $scope.modalOptions = tempModalOptions;
                        $scope.modalOptions.ok = function (result) {
                            $uibModalInstance.close(result);
                        };
                        $scope.modalOptions.close = function () {
                            $uibModalInstance.dismiss('cancel');
                        };
                    }
                    tempModalDefaults.controller = tmpCtrl;
                }

                return $uibModal.open(tempModalDefaults).result;
            };

        }]);
})();
(function () {
    'use strict';

    angular
        .module('app.auth')
        .factory('AuthenticationService', AuthenticationService)
        .factory('HttpBearerTokenAuthorizationInterceptor', ['$cookies', '$rootScope', '$q', function ($cookies, $rootScope, $q) {
            return {
                'request': function (config) {
                    var accessToken = localStorage.getItem('access_token');

                    if (config.params && config.params.isExternalRequest) {
                        delete (config.params.isExternalRequest)
                    } else if (accessToken) {
                        config.headers.Authorization = 'bearer ' + accessToken;
                    }

                    return config;
                },
                'responseError': function (responseError) {
                    if (responseError.status === 401) {
                        if (localStorage.getItem('access_token')) {
                            $rootScope.$emit('AUTH_TOKEN_EXPIRED');
                        }
                    }

                    return $q.reject(responseError);
                }
            }
        }])
        .factory('myHttpInterceptor', function ($q, $window, $rootScope, $document) {
            $rootScope.ActiveAjaxConectionsWithouthNotifications = 0;
            var checker = function (parameters, status) {
                //YOU CAN USE parameters.url TO IGNORE SOME URL
                if (status == "request") {
                    $rootScope.ActiveAjaxConectionsWithouthNotifications += 1;
                    $('#loading_view').addClass("show");
                }
                if (status == "response") {
                    $rootScope.ActiveAjaxConectionsWithouthNotifications -= 1;

                }
                if ($rootScope.ActiveAjaxConectionsWithouthNotifications <= 0) {
                    $rootScope.ActiveAjaxConectionsWithouthNotifications = 0;
                    $('#loading_view').removeClass("show");
                }


            };
            return {
                'request': function (config) {
                    checker(config, "request");
                    return config;
                },
                'requestError': function (rejection) {
                    checker(rejection.config, "request");
                    return $q.reject(rejection);
                },
                'response': function (response) {
                    checker(response.config, "response");
                    return response;
                },
                'responseError': function (rejection) {
                    checker(rejection.config, "response");
                    return $q.reject(rejection);
                }
            };
        })//loading screen
        .config(['$httpProvider', function ($httpProvider) {
            $httpProvider.interceptors.push('HttpBearerTokenAuthorizationInterceptor');
            $httpProvider.interceptors.push('myHttpInterceptor');
        }]);


    /** @ngInject */
    function AuthenticationService(SVCS, $cookies, $http, $q, $state, $rootScope, $stateParams, CoreService) {

        // permissions of current user
        var userPermissions = [];
        // public interfaces of service
        var service = {
            isLoggedIn: false,
            currentUserId: null,
            account: null,
            setRedirectAfterLogin: setRedirectAfterLogin,
            getUserPermissionsAsync: getUserPermissionsAsync,
            getUserInfoAsync: getUserInfoAsync,
            hasPermissions: hasPermissions,
            signInAsync: signInAsync,
            signOut: signOut,
            requestResetPassword: requestResetPassword,
            changeMyPassword: changeMyPassword,
            Search: Search,
            GetPermission: GetPermission,
            hasRolesByRoleName: hasRolesByRoleName,
            clearSession: clearSession,
            sendVerifyCode: sendVerifyCode,
            verifyCode: verifyCode,
            UpdatePhoneNumber: UpdatePhoneNumber
        }

        // first check authentication
        if (localStorage.getItem('access_token')) {
            service.isLoggedIn = true;

            getUserPermissionsAsync(); 
        }

        // private state to tracking redirect uri after login
        var redirectAfterAuth = {
            state: null,
            params: null
        };

        $rootScope.authenticationService = service;

        return service;

        // store next redirect to state
        function setRedirectAfterLogin(state, params) {
            redirectAfterAuth.state = state;
            redirectAfterAuth.params = params;
        }

        // do sign in process async and return promise that resolve redirectAfterAuth when signed in

        function signInAsync(userName, password, remember, os, manufacturer, devicemodel, product, appversion,SessionId, IsProcee) {
            var deferer = $q.defer();

            $http.post(SVCS.Auth + '/token', { UserName: userName, Password: password, Agent: 'Web', OSSVersion: os, AppVersion: appversion, Device_model: devicemodel, Brand: product, Manufacturer: manufacturer,SessionId: SessionId, IsProceed: IsProcee }, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                transformRequest: function (obj) {
                    var str = [];
                    for (var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                }
            }).then(function (response) {

                var data = response.data;
                service.currentUserId = data["Account"]["Id"];

                var cookieOptions = {
                    path: '/',
                    samesite: 'lax',
                    secure: true
                };

                if (remember) {
                    cookieOptions.expires = new Date(data.Expires);
                }

                localStorage.setItem('access_token', data.AccessToken);
                localStorage.setItem('user_type', data.Account.Type);
                localStorage.setItem('user_name', data.Account.UserName);
                localStorage.setItem('sessionId', data.Account.SessionId);
                localStorage.setItem('apptype', data.Account.Tag);
                $cookies.put('account_type', data.Account.Type, cookieOptions);
                $cookies.put('account_id', data["Account"]["Id"], cookieOptions);

                service.isLoggedIn = true;

                //get account profile
               getUserInfoAsync();

                $rootScope.$emit('AUTH_SIGNED_IN');

                var redirectTo = angular.copy(redirectAfterAuth);

                redirectAfterAuth = {
                    state: null,
                    params: null
                };

                getUserPermissionsAsync().then(function () {
                    deferer.resolve(angular.copy(redirectTo));
                }, function () {
                    deferer.resolve(angular.copy(redirectTo));
                })
            }, function (error) {
                deferer.reject(error.data);
            })

            return deferer.promise;
        }
        function clearSession() {
            userPermissions = [];
            service.account = null;
            service.isLoggedIn = false;
            localStorage.removeItem('access_token');
            localStorage.removeItem('user_name');
            localStorage.removeItem('sessionId');
            localStorage.clear();
            $cookies.remove('account_type');
            $cookies.remove('account_id');
            $cookies.remove('university');
            $cookies.remove('account_tag');
        }
        function signOut() {
            var deferer = $q.defer();
            clearSession();
            if (!(localStorage.hasOwnProperty('access_token'))) {
                var url = SVCS.Auth + "/api/account/updateUserSession";
                $http.get(url).then(function (res) {
                    userPermissions = [];
                    service.account = null;
                    service.isLoggedIn = false;
                    localStorage.removeItem('access_token');
                    localStorage.removeItem('user_name');
                    localStorage.removeItem('sessionId');
                    localStorage.clear();
                    $cookies.remove('account_type');
                    $cookies.remove('account_tag');
                    $rootScope.$emit('AUTH_SIGNED_OUT');
                }, function (error) {
                    deferer.reject();
                });
                return deferer.promise;

            }
        }

        function hasRolesByRoleName(rolesPara) {
            if (!service.isLoggedIn) {
                return false;
            } else if (rolesPara) {
                if (rolesPara.constructor !== Array) {
                   return (userRoles.map(function(x){return toRowLowerString(x.Name)}).indexOf(rolesPara.tolower()) > -1);
                } else if (rolesPara.length) {
                    if (!userRoles.length) {
                        return false;
                    }
                    for (var i = 0; i < rolesPara.length; i++) {
                        if (userRoles.map(function(x){return toRowLowerString(x.Name)}).indexOf(toRowLowerString(rolesPara[i])) != -1) {
                            return true;
                        }
                    }
                    return false;
                } else {
                 
                    return true;
                }
            } else {
                return true;
            }
        }
        function hasPermissions(permissions) {
            if (!service.isLoggedIn) {
                return false;
            } else if (permissions) {
                if (permissions.constructor !== Array) {
                    return userPermissions.indexOf(permissions) > -1;
                } else if (permissions.length) {
                    if (!userPermissions.length) {
                        return false;
                    }
                    for (var i = 0; i < permissions.length; i++) {
                        if (userPermissions.indexOf(permissions[i]) != -1) {
                            return true;
                        }
                    }
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        }

        function getUserPermissionsAsync() {           
            var deferer = $q.defer();
            if (!service.isLoggedIn) {
                deferer.reject();
            } else if (userPermissions && userPermissions.length) {
                deferer.resolve(angular.copy(userPermissions));
            } else {
                $http.get(SVCS.Auth + '/api/account/me/permissions').then(function (permissions) {

                    userPermissions = permissions.data.Result;

                    $rootScope.$emit('AUTH_PERMISSIONS_LOADED');

                    deferer.resolve(angular.copy(userPermissions));

                }, function () {

                    deferer.reject();

                })
            } return deferer.promise;
        }
        
        function toRowLowerString(x) {
            if (!!x) {
                return x.toLocaleLowerCase();
            } else { return "" }
        }
        function sesionvalidation() {
            var deferer = $q.defer();
            var sessionId = "";
            if (localStorage.getItem('sessionId')) {
                sessionId = localStorage.getItem('sessionId')
            }
            var url = SVCS.Profile + "/api/profiles/portal/me?sessionId="+sessionId;
            $http.get(url).then(function (res) {
                service.account = res.data;
                deferer.resolve(angular.copy(service.account));
            }, function (error) {
                if (error.data != null) {
                    if (error.data.Code == "SESSION_EXPIRED") {
                        $rootScope.$emit('SESSION_EXPIRED');
                    }
                }
                deferer.reject();
            });
            return deferer.promise;
        }
       
        function getUserInfoAsync() {
            var deferer = $q.defer();
          
            if (!service.isLoggedIn) {
                deferer.reject();
            }
            else if (service.account && service.account != null) {
                deferer.resolve(angular.copy(service.account));
            }
            else {
             //   sesionvalidation();
                var sessionId = "";
                if (localStorage.getItem('sessionId')) {
                    sessionId = localStorage.getItem('sessionId')
                }
                var accountType = $cookies.get('account_type');
                var url;
                if (accountType == 2) {
                    url = SVCS.Merchant + '/api/merchants/me?sessionId='+sessionId;
                }
                else if (accountType == 3) {
                    url = SVCS.Merchant + '/api/stores/me?sessionId='+sessionId;
                }
                else {
                    url = SVCS.Profile + '/api/profiles/profileInfo/me?sessionId='+sessionId;
                }

                $http.get(url).then(function (res) {
                    service.account = res.data;
                    deferer.resolve(angular.copy(service.account));
                }, function (error) {
                    if (error.data != null) {
                        if (error.data.Code == "SESSION_EXPIRED") {
                            $rootScope.$emit('SESSION_EXPIRED');
                        }
                    }
                    deferer.reject();
                });
            }

            return deferer.promise;
        }

        function requestResetPassword(userName) {
            var deferer = $q.defer();
            var model = {}; 
            model.UserName = userName;
            $http.post(SVCS.Auth + '/api/account/internal/merchant/v1/reset-password/request', model).then(function (res) {
                deferer.resolve();
            },
                function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        } 

        function changeMyPassword(model) {
            var deferer = $q.defer();

            $http.put(SVCS.Auth + '/api/account/me/portal/change-password', model).then(function (res) { deferer.resolve(res.data) }, function (error) { deferer.reject(error.data) })

            return deferer.promise;
        }

        function Search(criteria) {
            var deferer = $q.defer();

            CoreService.Post(SVCS.Auth + '/api/account/search', criteria).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }

        function GetPermission(id) {
            var deferer = $q.defer();

            CoreService.Get(SVCS.Auth + '/api/account/internal/permission/' + id).then(function (response) {
                deferer.resolve(response);
            })

            return deferer.promise;
        }
        function sendVerifyCode(userName) {
            var deferer = $q.defer();

            $http.get(SVCS.Auth + '/api/verification/v1/resend-otp?userName=' + userName).then(function (res) { deferer.resolve(res.data) }, function (error) { deferer.reject(error.data) })

            return deferer.promise;
        }
        function verifyCode(model) {
            var deferer = $q.defer();
            $http.post(SVCS.Auth + '/api/verification/v1/verify/email', model).then(function (res) {
                deferer.resolve(res.data);
            }, function (responseError) {
                    deferer.reject(responseError.data);
                });
            return deferer.promise;
        }

        function UpdatePhoneNumber(model) {
            var deferer = $q.defer();
            //var model = {};
            //model.AccountId = AccountId;
            //mode.
            $http.post(SVCS.Auth + '/api/account/v3/Change-mobile-number-portal', model).then(function (res) {
                deferer.resolve();
            },
                function (responseError) {
                    deferer.reject(responseError.data);
                });

            return deferer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.auth')
        .run(['AuthenticationService', '$rootScope', '$state', '$stateParams', '$transitions', function (_authService, $rootScope, $state, $stateParams, $transitions) {

            $transitions.onBefore({}, function (transition) {
                var stateService = transition.router.stateService;
                var toState = transition.to();

                if (toState.protect === true) {
                    if (!_authService.isLoggedIn) {

                        _authService.setRedirectAfterLogin(toState.name, angular.copy(transition.params()));

                        return transition.router.stateService.target('auth.login');

                    } else {
                        _authService.getUserInfoAsync();
                        if (toState.permissions && toState.permissions.length) {
                            return _authService.getUserPermissionsAsync().then(function () {

                                var authorized = _authService.hasPermissions(toState.permissions);

                                if (authorized) {
                                    return authorized;
                                } else {
                                    var from = transition.from();

                                    if (from.name === '' && from.url === '^' && from.abstract === true) {
                                        return transition.router.stateService.target('app.dashboard');
                                    }

                                    return false;

                                }

                            }, function () {
                                return false;
                            })
                        }
                    }
                }
            })

            $rootScope.$on('AUTH_TOKEN_EXPIRED', function () {

                alert('Your logged in session has been expired, please sign in again!');
                _authService.clearSession();
                _authService.signOut();

                _authService.setRedirectAfterLogin($state.current.name, angular.copy($stateParams));
                $state.go('auth.login');

            })
            $rootScope.$on('SESSION_EXPIRED', function () {

                alert('Your logged in session has been expired, please sign in again!');

                _authService.clearSession();

                _authService.setRedirectAfterLogin($state.current.name, angular.copy($stateParams));
                $state.go('auth.login');

            })
        }]);
})();
(function () {
    'use strict';

    angular
        .module('app.auth')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {

        // State definitions
        $stateProvider
            .state('auth', {
                abstract: true
            })
            .state('auth.login', {
                url: '/login',
                templateUrl: 'app/auth/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm'
            })
            .state('auth.forgot-password', {
                url: '/forgot-password',
                templateUrl: 'app/auth/forgot-password/forgot.password.html',
                controller: 'ForgotPasswordController',
                controllerAs: 'vm'
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('app.auth')
        .directive('showRoute', ['AuthenticationService', '$rootScope', '$state', function (_authService, $rootScope, $state) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {
                    handler();
                    $rootScope.$on('AUTH_PERMISSIONS_LOADED', function () {
                        handler();
                    })
                    function handler() {
                        if (!attrs.uiSref && !attrs.showForRoute) {
                            element.hide();
                        } else {
                            var permissions = [];
                            if (attrs.uiSref) {
                                var uiSrefState = $state.get(attrs.uiSref);
                                if (uiSrefState) {
                                    if (uiSrefState.permissions) {
                                        permissions = uiSrefState.permissions;
                                    }
                                }
                            }
                            if (attrs.showForRoute) {
                                var state = $state.get(attrs.showForRoute);
                                if (state) {
                                    if (state.permissions) {
                                        permissions = permissions.concat(state.permissions);
                                    }
                                }
                            }

                            if (permissions.length) {
                                if (!_authService.hasPermissions(permissions)) {
                                    element.hide();
                                } else {
                                    element.show();
                                }
                            } else {
                                element.show();
                            }
                        }
                    }
                }
            }
        }])
        .directive('showPermissions', ['AuthenticationService', '$rootScope', '$state', function (_authService, $rootScope, $state) {
            return {
                restrict: 'A',
                scope: {
                    $$permissions: '=showPermissions'
                },
                link: function (scope, element, attrs) {
                    handler();
                    $rootScope.$on('AUTH_PERMISSIONS_LOADED', function () {
                        handler();
                    })
                    function handler() {
                        if (scope.$$permissions.length) {
                            if (!_authService.hasPermissions(scope.$$permissions)) {
                                element.hide();
                            } else {
                                element.show();
                            }
                        } else {
                            element.show();
                        }
                    }
                }
            }
        }]);
})();
(function () {
    'use strict';

    /**
     * Main module of the kiple
     */
    angular
        .module('kiple', [
            //all libs will be injected
            'app.core',
            'datatables',
            'datatables.bootstrap',
            'datatables.buttons',


            //my modules
            'app.admin',
            'app.account',
            'app.auth',
            'app.dashboard',
            'app.merchant',
            'app.store',
            'app.voucher',
            'app.data',
            'app.product',
            'app.report',
            'app.university',
            'app.commissionpayout',
            'app.partner',
            'app.community',
            'app.rcbmara'
        ]);
})();
(function () {
    'use strict';

    angular
        .module('kiple')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider, $translatePartialLoaderProvider) {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    '@': {
                        templateUrl: 'app/layout/app.layout.html',
                    },
                    'header@app': {
                        templateUrl: 'app/header/header.html',
                        controller: 'HeaderController as vm'
                    },
                    'main@app': {
                        template: '<div ui-view></div>'
                    },
                    'navigation@app': {
                        templateUrl: 'app/navigation/navigation.html',
                        controller: 'NavigationController as vm'
                    }
                }
            });

        $translatePartialLoaderProvider.addPart('app/navigation');
        $translatePartialLoaderProvider.addPart('app/header');
    }

})();

(function () {
    'use strict';

    angular
        .module('kiple').constant('SVCS', {
            Auth: 'https://portal.kiplepay.com:2087',
            Profile: 'https://portal.kiplepay.com:2087',
            Wallet: 'https://portal.kiplepay.com:2087',
            Merchant: 'https://portal.kiplepay.com:2087',
            Product: 'https://portal.kiplepay.com:2087',
            Gateway: 'https://portal.kiplepay.com:2087',
            QRCode: 'https://portal.kiplepay.com:2087',
            Report: 'https://portal.kiplepay.com:2087',
            Notification: 'https://portal.kiplepay.com:2087',            
            Promotion: 'https://portal.kiplepay.com:2087'
        });
})();

(function () {
    'use strict';

    angular
        .module('kiple')
        .config(config);

    /** @ngInject */
    function config($translateProvider, $translatePartialLoaderProvider, uiGmapGoogleMapApiProvider, KipleCfg) {
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/lang/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy(null);

        uiGmapGoogleMapApiProvider.configure({
            key: KipleCfg.GOOGLE_MAP.API_KEY,
            v: '3.28', //defaults to latest 3.X anyhow
            libraries: 'geometry,places'
        });

        $translatePartialLoaderProvider.addPart('app');
    }

})();
(function () {
    'use strict';

    /* transaction actions enum */

    var transactionActions = [
        'OnlineTopup',
        'CreditDebitCardTopup',
        'Withdraw',
        'Transfer',
        'Payment',
        'PayBill',
        'ReloadMobile',
        'TransactionVoid',
        'GetFreeVoucher',
        'PurchaseVoucher',
        'PayAtTable',
        'RedeemVoucher',
        'OrderAndPay',
        'ReceivedMoney',
        'TopupStoreCard',
        'PayAtCounter',
        'UserMakePayment',
        'TopupFPX',
        'TopupOTC',
        'Reward',
        'TopupBonus',
        'Refund',
        'StaticQRPayment',
        'OnlinePayment',
        'HoldPayment',
        'CommitHold',
        'CancelHold',
        'TimeoutHold',
        'TopupByCreditCard',
        'PaymentByCreditCard',
        'StoreCardExpired',
        'KiplekashExpired',
        'DeeplinkPayment',
        'MergeBalance',
        'PrefundReload',
        'StorecardBonus',
        'OfflineWalletTopup',
        'Payout',
        'BonusCredit',
        'ZakatReward',
    ];

    var transactionActionsHashMap = {};

    for (var i = 0; i < transactionActions.length; i++) {
        transactionActionsHashMap[transactionActions[i]] = {
            value: transactionActions[i],
            display: 'transaction_action.' + transactionActions[i]
        };
    }

    angular
        .module('kiple').constant('TransactionActionHashMap', transactionActionsHashMap);

    /* end transaction actions enum */

    /* voucher status enum */

    var voucherStatus = [
        'Available',
        'Deleted',
        'Expired'
    ]

    var voucherStatusHashMap = {};

    for (var i = 0; i < voucherStatus.length; i++) {
        voucherStatusHashMap[voucherStatus[i]] = {
            value: voucherStatus[i],
            display: 'voucher_status.' + voucherStatus[i]
        };
    }

    angular
        .module('kiple').constant('VoucherStatusHashMap', voucherStatusHashMap);

    /* end voucher status enum */

    /* brand food type enum */

    var brandFoodTypes = [
        'Halal',
        'NonHalal',
        'PorkFree',
        'NA'
    ]

    var brandFoodTypeHashMap = {};

    for (var i = 0; i < brandFoodTypes.length; i++) {
        brandFoodTypeHashMap[brandFoodTypes[i]] = {
            value: brandFoodTypes[i],
            display: 'brand_food_type.' + brandFoodTypes[i]
        };
    }

    angular
        .module('kiple').constant('BrandFoodTypeHashMap', brandFoodTypeHashMap);

    /* end brand food type enum */

    /* merchant state enum */

    var merchantStates = [
        'Approved', 'Published', 'Unpublished', 'Deleted'
    ]

    var merchantStateHashMap = {};

    for (var i = 0; i < merchantStates.length; i++) {
        merchantStateHashMap[merchantStates[i]] = {
            value: merchantStates[i],
            display: 'merchant_state.' + merchantStates[i]
        };
    }

    angular
        .module('kiple').constant('MerchantStateHashMap', merchantStateHashMap);

    /* end merchant state enum */

    /* promotions enum */

    // promotion type

    var promotionTypes = [
        'GiftVoucher',
        'ECoupon',
        'ReferralMerchantVoucher'
    ]
    var promotionTypeHashMap = {};

    for (var i = 0; i < promotionTypes.length; i++) {
        promotionTypeHashMap[promotionTypes[i]] = {
            value: promotionTypes[i],
            display: 'promotion_type.' + promotionTypes[i]
        };
    }


    angular
        .module('kiple').constant('PromotionTypeHashMap', promotionTypeHashMap);

    // end promotion type

    //User Status
    var UserStatus = [
        'InActive',
        'Active',
        'Suspended',
        'Closed',
        'Locked'
        
    ]

    var UserStatusHashMap = {};

    for (var i = 0; i < UserStatus.length; i++) {
        UserStatusHashMap[UserStatus[i]] = {
            value: UserStatus[i],
            display: 'user_status.' + UserStatus[i]
        };
    }

    angular
        .module('app.admin').constant('UserStatusHashMap', UserStatusHashMap);
     // end Transaction Status 
    


    // promotion status

    var promotionStatus = [
        'Available',
        'Deleted',
        'Expired'
    ]

    var promotionStatusHashMap = {};

    for (var i = 0; i < promotionStatus.length; i++) {
        promotionStatusHashMap[promotionStatus[i]] = {
            value: promotionStatus[i],
            display: 'promotion_status.' + promotionStatus[i]
        };
    }

    angular
        .module('kiple').constant('PromotionStatusHashMap', promotionStatusHashMap);

     // end promotion status

    // Payment Channel
   

    var PaymentChannel = [
        'Boost',
        'AliPay',
        'Grab',
        'MayPay',
        'RazorPay',
        'TnG',
        'WeChatPay',
        'WeChatPayInt',
        'AliPayInt',
        'SelangkahWallet',
        'RedPay'
    ]

    var PaymentChannelHashMap = {};

    for (var i = 0; i < PaymentChannel.length; i++) {
        PaymentChannelHashMap[PaymentChannel[i]] = {
            value: PaymentChannel[i],
            display: PaymentChannel[i]
        };
    }
    angular
        .module('app.admin').constant('PaymentChannelHashMap', PaymentChannelHashMap);

  
    // end Payment Channel
   

    // e-coupon lifecycle
    
    var ecoupons = [
        'Once',
        'MultipleTimes'
    ]

    var eCouponLifecycleHashMap = {};

    for (var i = 0; i < ecoupons.length; i++) {
        eCouponLifecycleHashMap[ecoupons[i]] = {
            value: ecoupons[i],
            display: 'promotion_ecoupon_lifecycle.' + ecoupons[i]
        };
    }

    angular
        .module('kiple').constant('ECouponLifecycleHashMap', eCouponLifecycleHashMap);
    
    // end e-coupon lifecycle

    /* end promotion enum  */

})();

(function () {
    'use strict';

    angular
        .module('kiple').constant('KipleCfg', {
            GOOGLE_MAP: {
                API_KEY: 'AIzaSyB_Z5MvWqjU8nGFcgzGc4NHIIObflKqpvA'
            },
        });
})();

//(function () {
//    'use strict';

//    angular
//        .module('app.core.elementLoading', [])
//        .directive('elementLoading', function () {
//            return {
//                restrict: 'A',
//                link: function (scope, element, attrs) {
//                    if (attrs.elementLoading) {
//                        element.append('<div class="element-loading"><div class="loader"></div></div>');

//                        var loader = element.find('>.element-loading');

//                        element.click(function (e) {
//                            if (element.hasClass('loading')) {
//                                e.preventDefault();
//                                e.stopPropagation();
//                            }
//                        })

//                        function correctContainerSize(count) {
//                            loader.width(element.outerWidth());
//                            loader.height(element.outerHeight());
//                            if (count < 5) {
//                                setTimeout(function () {
//                                    correctContainerSize(count + 1)
//                                }, 200);
//                            }
//                        }

//                        if (scope.$eval(attrs.elementLoading)) {
//                            loader.width(element.outerWidth());
//                            loader.height(element.outerHeight());
//                            loader.addClass('loading');
//                            element.addClass('loading');
//                            correctContainerSize(0);
//                        }

//                        scope.$watch(function () {
//                            return scope.$eval(attrs.elementLoading);
//                        }, function (val, old) {
//                            if (val != old) {
//                                if (val) {
//                                    correctContainerSize(0);
//                                    loader.addClass('loading');
//                                    element.addClass('loading');
//                                } else {
//                                    loader.removeClass('loading');
//                                    element.removeClass('loading');
//                                }
//                            }
//                        })
//                    }
//                }
//            }
//        })
//})();

(function () {
    'use strict';

    angular
        .module('app.account', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.account', {
                url: '/account',
                abstract: true
            })
            .state('app.account.change-password', {
                url: '/change-password',
                views: {
                    'main@app': {
                        templateUrl: 'app/account/change-password/change.password.html',
                        controller: 'ChangePasswordController',
                        controllerAs: 'vm'
                    }
                },
                protect: true
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/account');

    }
})();
angular.module("kiple").run(["$templateCache", function($templateCache) {$templateCache.put("app/common/modal.view.html","<div class=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"modalOptions.close()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 \nclass=\"modal-title center\" id=\"modal-title\">{{modalOptions.headerText}}</h3></div><div class=\"modal-body\"><p>\n{{modalOptions.bodyText}}</p></div><div class=\"alert alert-danger\" ng-if=\"vm.formError\">{{vm.formError}}</div><div \nclass=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-ng-click=\"modalOptions.close()\">\n{{modalOptions.closeButtonText}}</button> <button type=\"button\" class=\"btn btn-primary\" \ndata-ng-click=\"modalOptions.ok(true);\">{{modalOptions.actionButtonText}}</button></div></div>");
$templateCache.put("app/dashboard/dashboard.html","");
$templateCache.put("app/header/header.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top\" role=\"navigation\" style=\"margin-bottom: 0\"><div \nclass=\"navbar-header\"><span minimaliza-sidebar></span></div><ul class=\"nav navbar-top-links navbar-right\"><li><span \nclass=\"m-r-sm text-muted welcome-message\">Welcome to Kiple Pay Dashboard</span></li><li><a tabindex=\"-1\" \nng-click=\"vm.signOut()\"><i class=\"fa fa-sign-out\"></i>Sign out</a></li></ul></nav></div>");
$templateCache.put("app/layout/app.layout.html","<div id=\"wrapper\"><nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div ui-view=\"navigation\"></div>\n</nav><div id=\"page-wrapper\" class=\"gray-bg dashbard-1 tables.static_table\" style=\"display:flow-root\"><div \nui-view=\"header\"></div><div style=\"padding-bottom:30px\" ui-view=\"main\"></div></div></div>");
$templateCache.put("app/navigation/navigation.html","<div class=\"sidebar-collapse\" id=\"mySidenav\" show-permissions=\"[\'NOREDIRECT_CHANGEPASSWORD\']\"><ul side-navigation \nclass=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown><a \nuib-dropdown-toggle><span class=\"clear\"><span class=\"block m-t-xs\"><strong class=\"font-bold\">Hi <span>\n{{vm.account.FullName}}</span><span \nng-if=\"authenticationService.account.Name && !authenticationService.account.FullName\">\n{{authenticationService.account.Name}}</span> </strong></span><span class=\"text-muted text-xs block margin-tb\">\n{{vm.account.UserName}}<b class=\"caret margin-l\"></b></span></span></a><ul uib-dropdown-menu \nclass=\"animated fadeInRight m-t-xs\"><li style=\"display:none\"><a tabindex=\"-1\" ng-click=\"vm.profile()\">My profile</a>\n</li><li><a tabindex=\"-1\" ng-click=\"vm.changePassword()\">Change password</a></li><li><a tabindex=\"-1\" \nng-click=\"vm.signOut()\">Sign out</a></li></ul></div><div class=\"logo-element\"><img class=\"img-responsive\" \nstyle=\"padding:0px 5px\" src=\"../../assets/images/kiplePay-logotype-blue.png\"></div></li><li \nshow-permissions=\"[\'ADMIN_USER\',\'USER\']\"><a href=\"#\"><i class=\"fa fa-user-circle\"></i><span class=\"nav-label\" \ntranslate=\"navigation.title.admin\">ADMINSTRATOR</span> <span class=\"fa arrow\"></span></a><ul \nclass=\"nav nav-second-level\"><li show-permissions=\"[\'ADMIN_USER\']\" show-route show-for-route=\"app.admin.group\" \nui-sref-active=\"active\"><a ui-sref=\"app.admin.group\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-users\"></i><span \ntranslate=\"navigation.group\"></span></a></li><li show-permissions=\"[\'ADMIN_USER\']\" show-route \nshow-for-route=\"app.admin.brand\" ui-sref-active=\"active\"><a ui-sref=\"app.admin.brand\" ng-click=\"vm.closeNav()\"><i \nclass=\"fa fa-bandcamp\"></i><span translate=\"navigation.brand\"></span></a></li><li show-permissions=\"[\'ADMIN_USER\']\" \nshow-route show-for-route=\"app.admin.configuration\" ui-sref-active=\"active\"><a ui-sref=\"app.admin.configuration\" \nng-click=\"vm.closeNav()\"><i class=\"fa fa-cogs\"></i><span translate=\"navigation.configuration\"></span></a></li><li \nshow-permissions=\"[\'ADMIN_USER\']\" show-route show-for-route=\"app.admin.tierSetting\" ui-sref-active=\"active\"><a \nui-sref=\"app.admin.tierSetting\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-wrench\"></i><span \ntranslate=\"navigation.tierSetting\"></span></a></li><li show-permissions=\"[\'ADMIN_USER\']\" show-route \nshow-for-route=\"app.partner\" ui-sref-active=\"active\"><a ui-sref=\"app.partner\" ng-click=\"vm.closeNav()\"><i \nclass=\"fa fa-handshake-o\"></i><span translate=\"navigation.partner\"></span></a></li><li \nshow-permissions=\"[\'ADMIN_USER\']\" show-permissions=\"[\'ADMIN_USER\']\" show-route \nshow-for-route=\"app.admin.sharedStoreCard\" ui-sref-active=\"active\"><a ui-sref=\"app.admin.sharedStoreCard\" \nng-click=\"vm.closeNav()\"><i class=\"fa fa-credit-card-alt\"></i><span translate=\"navigation.sharedStoreCard\"></span></a>\n</li><li show-permissions=\"[\'ADMIN_USER\']\" show-route show-for-route=\"app.admin.fraudManagement\" \nui-sref-active=\"active\"><a ui-sref=\"app.admin.fraudManagement\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-shield\"></i>\n<span translate=\"navigation.fraudManagement\"></span></a></li><li show-permissions=\"[\'USER\']\" show-route \nshow-for-route=\"app.admin.user\" ui-sref-active=\"active\"><a ui-sref=\"app.admin.user\" ng-click=\"vm.closeNav()\"><i \nclass=\"fa fa-user\"></i><span translate=\"navigation.user_management\"></span></a><ul class=\"nav nav-third-level\"><li \nshow-permissions=\"[\'USER\']\" show-route show-for-route=\"app.admin.user\" ui-sref-active=\"active\"><a \nui-sref=\"app.admin.user\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-user\"></i><span translate=\"navigation.user\"></span>\n</a></li><li show-permissions=\"[\'ADMIN_USER\']\" show-route show-for-route=\"app.admin.mobile-number-change\" \nui-sref-active=\"active\"><a ui-sref=\"app.admin.mobile-number-change\" ng-click=\"vm.closeNav()\"><i \nclass=\"glyphicon glyphicon-list-alt\"></i><span translate=\"navigation.mobile-number-change\"></span></a></li></ul></li>\n<li show-permissions=\"[\'ADMIN_USER\']\" show-route show-for-route=\"app.admin.admin-user\" ui-sref-active=\"active\"><a \nui-sref=\"app.admin.admin-user\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-user-circle\"></i><span \ntranslate=\"navigation.admin-user\"></span></a></li><li show-permissions=\"[\'ADMIN_USER\']\" show-route \nshow-for-route=\"app.admin.tag\" ui-sref-active=\"active\"><a ui-sref=\"app.admin.tag\" ng-click=\"vm.closeNav()\"><i \nclass=\"fa fa-tag\"></i><span translate=\"navigation.tag\"></span></a></li><li show-permissions=\"[\'ADMIN_USER\']\" \nshow-route show-for-route=\"app.admin.category.merchant\" ui-sref-active=\"active\"><a \nui-sref=\"app.admin.category.merchant\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-th-large\"></i><span \ntranslate=\"navigation.category_merchant\"></span></a></li><li show-permissions=\"[\'ADMIN_USER\']\" show-route \nshow-for-route=\"app.admin.promotion\" ui-sref-active=\"active\"><a ui-sref=\"app.admin.promotion\" ng-click=\"vm.closeNav()\">\n<i class=\"glyphicon glyphicon-list-alt\"></i><span translate=\"navigation.promotions\"></span></a></li><li \nshow-permissions=\"[\'ADMIN_USER\']\" show-route show-for-route=\"app.admin.refund\" ui-sref-active=\"active\"><a \nui-sref=\"app.admin.refund\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-retweet\"></i><span translate=\"navigation.refund\">\n</span></a></li><li show-permissions=\"[\'ADMIN_USER\']\" show-route show-for-route=\"app.admin.bonus\" \nui-sref-active=\"active\"><a ui-sref=\"app.admin.bonus\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-star\"></i><span \ntranslate=\"navigation.bonus\"></span></a></li><li show-permissions=\"[\'ADMIN_USER\']\" show-permissions=\"[\'ADMIN_USER\']\" \nshow-route show-for-route=\"app.admin.BulkRegister-kiplekash\" ui-sref-active=\"active\"><a \nui-sref=\"app.admin.BulkRegister-kiplekash\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-star\"></i><span \ntranslate=\"Student Creation\"></span></a></li><li show-permissions=\"[\'ADMIN_USER\']\" show-route \nshow-for-route=\"app.admin.settlement-transaction\" ui-sref-active=\"active\"><a \nui-sref=\"app.admin.settlement-transaction\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-dollar\"></i><span \ntranslate=\"navigation.settlement_transaction\"></span></a></li><li show-permissions=\"[\'ADMIN_USER\']\" show-route \nshow-for-route=\"app.admin.settlement-summary\" ui-sref-active=\"active\"><a ui-sref=\"app.admin.settlement-summary\" \nng-click=\"vm.closeNav()\"><i class=\"fa fa-dollar\"></i><span translate=\"navigation.settlement_transaction_summary\">\n</span></a></li><li show-permissions=\"[\'ADMIN_USER\']\" show-route show-for-route=\"app.admin.least-cost-routing\" \nui-sref-active=\"active\"><a ui-sref=\"app.admin.least-cost-routing\" ng-click=\"vm.closeNav()\"><i \nclass=\"glyphicon glyphicon-list-alt\"></i><span translate=\"navigation.least_cost_routing\"></span></a></li><li \nclass=\"active\" show-permissions=\"[\'SEND_NOTIFICATION\', \'ADMIN_USER\']\"><a href=\"#\"><i class=\"fa fa-cog\"></i><span \nclass=\"nav-label\" translate=\"navigation.title.kipleAppManagement\"></span> <span class=\"fa arrow\"></span></a><ul \nclass=\"nav nav-third-level\"><li show-permissions=\"[\'SEND_NOTIFICATION\']\" show-route \nshow-for-route=\"app.admin.notificationlist\" ui-sref-active=\"active\"><a ui-sref=\"app.admin.notificationlist\" \nng-click=\"vm.closeNav()\"><i class=\"fa fa-exclamation-triangle\"></i><span translate=\"navigation.notificationlist\">\n</span></a></li><li show-permissions=\"[\'SEND_ANNOUNCEMENT\']\" show-route show-for-route=\"app.admin.announcement\" \nui-sref-active=\"active\"><a ui-sref=\"app.admin.announcement\" ng-click=\"vm.closeNav()\"><i \nclass=\"glyphicon glyphicon-list-alt\"></i><span translate=\"navigation.announcement\"></span></a></li><li show-route \nshow-for-route=\"app.admin.banner\" ui-sref-active=\"active\"><a ui-sref=\"app.admin.banner\" ng-click=\"vm.closeNav()\"><i \nclass=\"glyphicon glyphicon-list-alt\"></i><span translate=\"navigation.banner\"></span></a></li><li show-route \nshow-for-route=\"app.admin.referralbanner\" ui-sref-active=\"active\"><a ui-sref=\"app.admin.referralbanner\" \nng-click=\"vm.closeNav()\"><i class=\"glyphicon glyphicon-list-alt\"></i><span translate=\"Referral Banner\"></span></a></li>\n<li show-permissions=\"[\'ADMIN_USER\']\" show-route show-for-route=\"app.admin.home-page-main-services\" \nui-sref-active=\"active\"><a ui-sref=\"app.admin.home-page-main-services\" ng-click=\"vm.closeNav()\"><i \nclass=\"glyphicon glyphicon-list-alt\"></i><span translate=\"Home Page Main services\"></span></a></li><li \nshow-permissions=\"[\'ADMIN_USER\']\" show-route show-for-route=\"app.admin.education-service\" ui-sref-active=\"active\"><a \nui-sref=\"app.admin.education-service\" ng-click=\"vm.closeNav()\"><i class=\"glyphicon glyphicon-list-alt\"></i><span \ntranslate=\"Education Services\"></span></a></li><li show-permissions=\"[\'SEND_ANNOUNCEMENT\']\" show-route \nshow-for-route=\"app.admin.co-brand-artwork-configuration\" ui-sref-active=\"active\"><a \nui-sref=\"app.admin.co-brand-artwork-configuration\" ng-click=\"vm.closeNav()\"><i class=\"glyphicon glyphicon-list-alt\">\n</i><span translate=\"Co-Brand Visa Card\"></span></a></li></ul></li></ul></li><li \nshow-permissions=\"[\'VIEW_LIST_MERCHANT\', \'ADD_USER_TO_MERCHANT\', \'REMOVE_USER_FROM_MERCHANT\', \'VIEW_LIST_MASTER_MERCHANT\', \'CREATE_MASTER_MERCHANT\', \'EDIT_MASTER_MERCHANT\', \'DELETE_MASTER_MERCHANT\']\" \nclass=\"title\"><a href=\"#\"><i class=\"fa fa-server\"></i><span class=\"nav-label\" translate=\"navigation.title.merchant\">\nMECHANT</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\"><li show-route \nshow-for-route=\"app.merchant.master\" ui-sref-active=\"active\"><a ui-sref=\"app.merchant.master\" ng-click=\"vm.closeNav()\">\n<i class=\"fa fa-bars\"></i><span translate=\"navigation.master_merchant\"></span></a></li><li show-route \nshow-for-route=\"app.merchant.list\" ui-sref-active=\"active\"><a ui-sref=\"app.merchant.list\" ng-click=\"vm.closeNav()\"><i \nclass=\"glyphicon glyphicon-list-alt\"></i><span translate=\"navigation.list\"></span></a></li><li show-route \nshow-for-route=\"app.merchant.user\" ui-sref-active=\"active\"><a ui-sref=\"app.merchant.user\" ng-click=\"vm.closeNav()\"><i \nclass=\"fa fa-user\"></i><span translate=\"navigation.user\"></span></a></li></ul></li><li \nshow-permissions=\"[\'VIEW_STORE\']\"><a href=\"#\"><i class=\"fa fa-archive\"></i><span class=\"nav-label\" \ntranslate=\"navigation.title.store\">STORE</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\"><li \nshow-route show-for-route=\"app.store.list\" ui-sref-active=\"active\"><a ui-sref=\"app.store.list\" \nng-click=\"vm.closeNav()\"><i class=\"glyphicon glyphicon-list-alt\"></i><span translate=\"navigation.list\"></span></a></li>\n<li show-route show-for-route=\"app.store.manager\" ui-sref-active=\"active\"><a ui-sref=\"app.store.manager\" \nng-click=\"vm.closeNav()\"><i class=\"fa fa-user\"></i><span translate=\"navigation.manager\"></span></a></li><li show-route \nshow-for-route=\"app.store.terminal\" ui-sref-active=\"active\"><a ui-sref=\"app.store.terminal\" ng-click=\"vm.closeNav()\"><i\n class=\"glyphicon glyphicon-inbox\"></i><span translate=\"navigation.terminal\"></span></a></li><li show-route \nshow-for-route=\"app.store.table\" ui-sref-active=\"active\"><a ui-sref=\"app.store.table\" ng-click=\"vm.closeNav()\"><i \nclass=\"fa fa-table\"></i><span translate=\"navigation.table\"></span></a></li></ul></li><li \nshow-permissions=\"[\'VIEW_PRODUCT\']\"><a href=\"#\"><i class=\"fa fa-cubes\"></i><span class=\"nav-label\" \ntranslate=\"navigation.title.product\">PRODUCT</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\">\n<li show-route show-for-route=\"app.product\" ui-sref-active=\"active\"><a ui-sref=\"app.product.list\" \nng-click=\"vm.closeNav()\"><i class=\"fa fa-cube\"></i><span translate=\"navigation.product\"></span></a></li><li show-route \nshow-for-route=\"app.voucher\" ui-sref-active=\"active\"><a ui-sref=\"app.voucher\" ng-click=\"vm.closeNav()\"><i \nclass=\"fa fa-credit-card\"></i><span translate=\"navigation.voucher\"></span></a></li></ul></li><li><a href=\"#\"><i \nclass=\"fa fa-bar-chart\"></i><span class=\"nav-label\" translate=\"navigation.title.reports\">REPORTS</span><span \nclass=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\"><li ui-sref-active=\"active\"><a ui-sref=\"app.reports.list\" \nng-click=\"vm.closeNav()\"><i class=\"glyphicon glyphicon-list-alt\"></i><span translate=\"navigation.list\"></span></a></li>\n<li show-permissions=\"[\'VIEW_STORECARD_TRANSACTION_REPORT\']\" ui-sref-active=\"active\"><a \nui-sref=\"app.reports.storecardtransactions\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-file-text\"></i><span \ntranslate=\"navigation.storecardtransactions\"></span></a></li><li \nshow-permissions=\"[\'VIEW_EXTERNAL_TRANSACTION_REPORT\']\" ui-sref-active=\"active\"><a \nui-sref=\"app.reports.externaltransactions\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-file-text-o\"></i><span \ntranslate=\"navigation.externaltransactions\"></span></a></li><li show-permissions=\"[\'VIEW_GENERIC_AUTOMATION_REPORT\']\" \nui-sref-active=\"active\"><a ui-sref=\"app.reports.genericautomation\" ng-click=\"vm.closeNav()\"><i \nclass=\"glyphicon glyphicon-list-alt\"></i><span translate=\"navigation.genericautomation\"></span></a></li></ul></li><li \nshow-permissions=\"[\'UNIVERSITY_CONFIGURATION\']\" ui-sref-active=\"active\"><a href=\"#\"><i class=\"fa fa-university\"></i>\n<span class=\"nav-label\">UNIVERSITY MERCHANTS</span><span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\">\n<li show-permissions=\"[\'UNIVERSITY_CONFIGURATION\']\" ui-sref-active=\"active\"><a \nui-sref=\"app.university.university-portal\" ng-click=\"vm.closeNav()\"><i class=\"glyphicon glyphicon-list-alt\"></i><span \ntranslate=\"navigation.university_portal\"></span></a></li><li show-permissions=\"[\'UNIVERSITY_CONFIGURATION\']\" \nui-sref-active=\"active\"><a ui-sref=\"app.university.campus-portal\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-file-text\">\n</i><span translate=\"navigation.campus_portal\"></span></a></li><li \nshow-permissions=\"[\'VIEW_UUM_LIST_MERCHANT\',\'VIEW_UiTM_LIST_MERCHANT\',\'VIEW_UPM_LIST_MERCHANT\' ]\" \nui-sref-active=\"active\"><a ui-sref=\"app.university.university-merchant\" ng-click=\"vm.closeNav()\"><i \nclass=\"fa fa-file-text-o\"></i><span translate=\"navigation.university_merchant_list\"></span></a></li></ul></li><li \nshow-permissions=\"[\'VIEW_EASE_REPORT\', \'ADMIN_USER\']\" ng-if=\"vm.Tag!=5\"><a href=\"#\"><i class=\"fa fa-star\"></i><span \nclass=\"nav-label\" translate=\"rcb_mara.title\">RCB - MARA</span><span class=\"fa arrow\"></span></a><ul \nclass=\"nav nav-second-level\"><li show-route show-for-route=\"app.rcbmara.easereport\" ui-sref-active=\"active\"><a \nui-sref=\"app.rcbmara.easereport\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-file-text-o\"></i><span \ntranslate=\"rcb_mara.ease_report\">EASE Report</span></a></li></ul></li><li \nshow-permissions=\"[ \'UUM_ZAKAT_PIC\',\'UiTM_ZAKAT_PIC\',\'UPM_ZAKAT_PIC\',\'ZAKAT_PRODUCT_FINANCE_OPERATION\',\'ADMIN_USER\']\">\n<a href=\"#\"><i class=\"fa fa-star\"></i><span class=\"nav-label\">Bonus Zakat Fund</span><span class=\"fa arrow\"></span></a>\n<ul class=\"nav nav-second-level\"><li ui-sref-active=\"active\" \nshow-permissions=\"[ \'ZAKAT_PRODUCT_FINANCE_OPERATION\',\'ADMIN_USER\']\"><a \nui-sref=\"app.admin.bonus-disbursement-request-approve\" ng-click=\"vm.closeNav()\"><i \nclass=\"glyphicon glyphicon-list-alt\"></i><span translate=\"navigation.bonus_disbursement_request_approve\"></span></a>\n</li><li ui-sref-active=\"active\"><a ui-sref=\"app.reports.bonus-disbursement-report\" ng-click=\"vm.closeNav()\"><i \nclass=\"glyphicon glyphicon-list-alt\"></i><span translate=\"report.names.bonus_disbursement_report\"></span></a></li><li \nui-sref-active=\"active\"><a ui-sref=\"app.reports.zakat-transaction-report\" ng-click=\"vm.closeNav()\"><i \nclass=\"glyphicon glyphicon-list-alt\"></i><span translate=\"report.names.bonus_zakat_transaction_report\"></span></a></li>\n</ul></li><li show-permissions=\"[\'COMMISSION_PAYOUT_BULK_UPLOAD\']\" ui-sref-active=\"active\"><a href=\"#\"><i \nclass=\"fa fa-server\"></i><span class=\"nav-label\">BULK PAYOUT</span><span class=\"fa arrow\"></span></a><ul \nclass=\"nav nav-second-level\"><li show-permissions=\"[\'COMMISSION_PAYOUT_CONFIGURATION\']\" ui-sref-active=\"active\"><a \nui-sref=\"app.commissionpayout.configuration\" ng-click=\"vm.closeNav()\"><i class=\"glyphicon glyphicon-list-alt\"></i><span\n translate=\"navigation.commission_payout_configuration\"></span></a></li><li \nshow-permissions=\"[\'COMMISSION_PAYOUT_BULK_UPLOAD\']\" ui-sref-active=\"active\"><a \nui-sref=\"app.commissionpayout.bulkupload({id:0})\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-file-text\"></i><span \ntranslate=\"navigation.commission_payout_bulk_upload\"></span></a></li><li \nshow-permissions=\"[\'COMMISSION_PAYOUT_REPORT\']\" ui-sref-active=\"active\"><a \nui-sref=\"app.commissionpayout.report({id:0})\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-file-text-o\"></i><span \ntranslate=\"navigation.commission_payout_report\"></span></a></li></ul></li><li show-permissions=\"[\'ADMIN_USER\']\"><a \nhref=\"#\"><i class=\"fa fa-users\"></i><span class=\"nav-label\" translate=\"Community\">COMMUNITY</span><span \nclass=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\"><li ui-sref-active=\"active\"><a \nui-sref=\"app.community.configuration\" ng-click=\"vm.closeNav()\"><i class=\"fa fa-cogs\"></i><span \ntranslate=\"Configuration\"></span></a></li></ul></li><li class=\"active\" show-permissions=\"[\'ADMIN_USER\']\"><a href=\"#\"><i\n class=\"fa fa-address-book\"></i><span class=\"nav-label\" translate=\"navigation.title.bulkUserCreation\"></span> <span \nclass=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li show-permissions=\"[\'ADMIN_USER\']\" show-route \nshow-for-route=\"app.admin.BulkRegister-partner\" ui-sref-active=\"active\"><a ui-sref=\"app.admin.BulkRegister-partner\" \nng-click=\"vm.closeNav()\"><i class=\"fa fa-file-text\"></i><span translate=\"navigation.title.bulkUpload\"></span></a></li>\n<li show-permissions=\"[\'ADMIN_USER\']\" show-route show-for-route=\"app.admin.user-creation-report\" \nui-sref-active=\"active\"><a ui-sref=\"app.admin.user-creation-report\" ng-click=\"vm.closeNav()\"><i \nclass=\"glyphicon glyphicon-list-alt\"></i><span translate=\"navigation.title.bulkReport\"></span></a></li><li \nshow-permissions=\"[\'ADMIN_USER\']\" show-route show-for-route=\"app.admin.user-profile-report\" ui-sref-active=\"active\"><a \nui-sref=\"app.admin.user-profile-report\" ng-click=\"vm.closeNav()\"><i class=\"glyphicon glyphicon-list-alt\"></i><span \ntranslate=\"navigation.title.userProfileReport\"></span></a></li><li show-permissions=\"[\'ADMIN_USER\']\" show-route \nshow-for-route=\"app.admin.user-wallet-upgrade\" ui-sref-active=\"active\"><a ui-sref=\"app.admin.user-wallet-upgrade\" \nng-click=\"vm.closeNav()\"><i class=\"glyphicon glyphicon-list-alt\"></i><span \ntranslate=\"navigation.title.userWalletUpgrade\"></span></a></li></ul></li></ul></div>");
$templateCache.put("app/partner/partnerCategory.html","<h1 class=\"page-header\" translate=\"partner.title\"></h1><div id=\"group\" class=\"col-md-12\"><div class=\"form-horizontal\">\n<div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><input \nng-keypress=\"vm.searchByKeyword($event)\" ng-model=\"vm.criteria.Keyword\" type=\"text\" placeholder=\"Enter partner name\" \nclass=\"form-control\"></div><div class=\"col-md-1 col-sm-10\"><a class=\"btn btn-primary pull-right margin-tl\" \nng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a>\n</div><div class=\"col-md-2 col-md-offset-6 col-sm-2\"><a class=\"btn btn-primary pull-right margin-tl\" \nui-sref=\"app.partner.new\"><i class=\"glyphicon glyphicon-plus\"></i> <span translate=\"common.action.add\"></span></a>\n</div></div></div><div class=\"form-group\"><div class=\"table-responsive\"><table \nclass=\"table table-striped table-bordered\"><thead><tr><th>#</th><th translate=\"partner.name\"></th><th \ntranslate=\"partner.merchant_name\"></th><th translate=\"partner.partner_type\"></th><th \ntranslate=\"partner.count_of_merchant\"></th><th translate=\"partner.created_at\"></th><th translate=\"partner.created_by\">\n</th><th translate=\"common.action.title\"></th></tr></thead><tbody><tr \nng-repeat=\"partnerCategory in vm.partnerCategories\"><td class=\"center\">{{$index + 1}}</td><td>{{partnerCategory.Name}}\n</td><td>{{partnerCategory.MerchantName}}</td><td>{{partnerCategory.PartnerType}}</td><td class=\"right\">\n{{partnerCategory.NumberOfMerchant}}</td><td>{{partnerCategory.CreatedAt | date: \'yyyy-MM-dd\'}}</td><td>\n{{partnerCategory.CreatedBy}}</td><td class=\"center\"><a title=\"Edit\" class=\"btn btn-default margin-tl\" \nui-sref=\"app.partner.edit({id:partnerCategory.Id})\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a title=\"Remove\" \nclass=\"btn btn-danger margin-tl\" ng-click=\"vm.remove(partnerCategory)\"><i class=\"glyphicon glyphicon-remove\"></i></a>\n</td></tr></tbody></table></div><ul uib-pagination total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" \nng-change=\"vm.search()\" ng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" \nboundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div>");
$templateCache.put("app/rcb-mara/rcb-mara.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-12\"><div ui-view></div></div></div></div>");
$templateCache.put("app/merchant/merchant.html","<div class=\"alert alert-warning alert-dismissable\" ng-if=\"vm.error\"><a href=\"#\" class=\"close\" data-dismiss=\"alert\" \naria-label=\"close\">&times;</a> <strong>Warning!</strong> {{vm.error}}</div><h1 class=\"page-header\" \ntranslate=\"merchant.title\"></h1><div id=\"merchant\" class=\"col-md-12\"><div class=\"form-horizontal\"><div \nclass=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><input type=\"text\" class=\"form-control\" \nng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"{{\'merchant.placeholder.company_name\' | translate}}\"></div><div class=\"col-md-3 col-xs-12 margin-tb\">\n<input type=\"text\" class=\"form-control\" ng-model=\"vm.criteria.MasterMerchantName\" \nng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Master merchant name\"></div><div class=\"col-md-1 col-sm-10\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span \ntranslate=\"common.action.reset\"></span></a></div><div class=\"col-md-5 col-sm-2\"><a \nclass=\"btn btn-primary pull-right margin-tl\" show-permissions=\"[\'EDIT_MERCHANT\']\" ng-click=\"vm.add()\"><i \nclass=\"glyphicon glyphicon-plus\"></i> <span translate=\"common.action.add\"></span></a></div></div></div><div \nclass=\"form-group\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered\"><thead \nthead-order=\"vm.sort($sortOpts)\"><tr><th>#</th><th translate=\"merchant.name\"></th><th translate=\"common.address.city\">\n</th><th translate=\"common.address.state\"></th><th translate=\"common.address.district\"></th><th \ntranslate=\"merchant.number_of_store\"></th><th th-order=\"\'CreatedAt\'\"><span translate=\"common.created_date\"></span></th>\n<th translate=\"common.status\"></th><th translate=\"common.action.title\"></th></tr></thead><tbody><tr \nng-repeat=\"merchant in vm.merchants\"><td class=\"center\">{{$index + 1}}</td><td><a \nui-sref=\"app.merchant.info({merchantId: merchant.Id})\">{{merchant.Name}}</a></td><td>{{merchant.City}}</td><td>\n{{merchant.Province}}</td><td>{{merchant.District}}</td><td>{{merchant.NumberOfStore}}</td><td>\n{{merchant.CreatedAt | date:\'yyyy-MM-dd\'}}</td><td>{{merchant.State}}</td><td class=\"center\"><a title=\"Edit merchant\" \nclass=\"btn btn-default margin-tl\" ng-click=\"vm.edit(merchant.Id)\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a \ntitle=\"Add user to merchant\" class=\"btn btn-info margin-tl\" ng-if=\"vm.Tag == 0\" ng-click=\"vm.addUser(merchant.Id)\"><i \nclass=\"glyphicon glyphicon-user\"></i></a> <a title=\"Unpublish\" ng-if=\"merchant.State == \'Published\'\" \nng-disabled=\"vm.Tag == 5\" class=\"btn btn-danger margin-tl\" ng-click=\"vm.unpublish(merchant)\"><i \nclass=\"glyphicon glyphicon-cloud-download\"></i></a> <a title=\"Publish\" \nng-if=\"merchant.State == \'Approved\' || merchant.State == \'Unpublished\'\" ng-disabled=\"vm.Tag == 5\" \nclass=\"btn btn-primary margin-tl\" ng-click=\"vm.publish(merchant)\"><i class=\"glyphicon glyphicon-cloud-upload\"></i></a>\n<a title=\"Remove\" class=\"btn btn-danger margin-tl\" ng-if=\"vm.Tag == 0\" ng-click=\"vm.delete(merchant.Id)\"><i \nclass=\"glyphicon glyphicon-remove\"></i></a></td></tr></tbody></table></div><ul uib-pagination \ntotal-items=\"vm.totalItems\" ng-click=\"vm.search()\" ng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" \nitems-per-page=\"vm.itemsPerPage\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div>\n<div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowMerchantDialog\" class=\"modal fade\" \ntabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowMerchantDialog = false\"><span \naria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" \nid=\"modal-title\" translate=\"merchant.merchant_detail\"></h3></div><div class=\"modal-body\"><ul class=\"nav nav-tabs\"><li \nclass=\"active\"><a data-toggle=\"tab\" href=\"#merchantDiv\" id=\"merchantTab\">Information</a></li><li ng-if=\"vm.Tag==0\"><a \ndata-toggle=\"tab\" href=\"#storeCardTopupOptionsDiv\" id=\"storeCardTopupOptionsTab\">StoreCard Topup Options</a></li><li \nng-if=\"vm.Tag==0\"><a data-toggle=\"tab\" href=\"#webhookDiv\" id=\"webhookTab\" ng-click=\"vm.getWebhook(vm.merchant.Id)\">\nWebhook setting</a></li><li ng-if=\"vm.Tag==0\"><a data-toggle=\"tab\" href=\"#qrPaymentPartnerAPIDiv\" \nid=\"qrPaymentPartnerAPITab\">QR Payment Partner API</a></li></ul><div class=\"tab-content\"><div id=\"merchantDiv\" \nclass=\"tab-pane fade in active\"><form name=\"merchantForm\" class=\"form-horizontal\" novalidate id=\"merchantForm\"><br><div\n class=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" translate=\"merchant.company.title\"></h4></div></div>\n<div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"common.brand\"></label><div \nclass=\"col-md-8\"><ui-select name=\"BrandId\" ng-model=\"vm.merchant.BrandId\" \nng-change=\"vm.loadBrandInfo(vm.merchant.BrandId)\" ng-disabled=\"vm.Tag == 5\"><ui-select-match \nplaceholder=\"-- Select an option --\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"brand.Id as brand in vm.brands | filter: $select.search\" refresh=\"vm.loadBrands($select.search)\" \nrefresh-delay=\"0\" minimum-input-length=\"0\"><div ng-bind-html=\"brand.Name | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The brand cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb required\">Channel</label><div class=\"col-md-8\"><select class=\"form-control\" \nid=\"Channel\" name=\"Channel\" ng-model=\"vm.merchant.Channel\"><option ng-repeat=\"chl in vm.channelList\" \nvalue=\"{{chl.value}}\">{{chl.text}}</option></select></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.CompanyEmail.$invalid && merchantForm.CompanyEmail.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"merchant.company.email\"></label><div class=\"col-md-8\">\n<input type=\"text\" name=\"CompanyEmail\" class=\"form-control\" required ng-model=\"vm.merchant.Company.Email\"><div \nng-messages=\"merchantForm.CompanyEmail.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.CompanyEmail.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.company.email_required\"></span></div><div ng-message=\"email\" \nng-if=\"merchantForm.CompanyEmail.$touched\" class=\"help-block\" translate=\"merchant.validate.company.email_invalid\">\n</div></div></div></div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"merchant.company.registration_number\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"RegistrationNumber\" class=\"form-control\" ng-model=\"vm.merchant.Company.RegistrationNumber\"></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.MainContactPerson.$invalid && merchantForm.MainContactPerson.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"merchant.main_contact_person\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"MainContactPerson\" class=\"form-control\" ng-model=\"vm.merchant.Company.MainContactPerson\"><div \nng-messages=\"merchantForm.MainContactPerson.$error\"><div ng-message=\"required\" \nng-if=\"merchantForm.MainContactPerson.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.company.main_contact_person\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.MainContactNumber.$invalid && merchantForm.MainContactNumber.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"merchant.main_contact_number\"></label><div class=\"col-md-8\"><input \ntype=\"text\" class=\"form-control\" name=\"MainContactNumber\" ng-pattern=\"/^\\d+$/\" \nng-model=\"vm.merchant.Company.MainContactNumber\"><div ng-messages=\"merchantForm.MainContactNumber.$error\"><div \nng-message=\"required\" ng-if=\"merchantForm.MainContactNumber.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.company.main_contact_number\"></span></div><div ng-message=\"pattern\" \nng-if=\"merchantForm.MainContactNumber.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.company.main_contact_number_format\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"merchant.web_url\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"CompanyWebsite\" class=\"form-control\" ng-model=\"vm.merchant.Company.Website\">\n</div></div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"common.address.address\">\n</label><div class=\"col-md-8\"><input type=\"text\" name=\"AddressStreet\" class=\"form-control\" \nng-model=\"vm.merchant.Company.Address.Street\"></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"common.address.city\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"AddressCity\" class=\"form-control\" ng-model=\"vm.merchant.Company.Address.City\"></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"common.address.district\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"AddressDistrict\" class=\"form-control\" \nng-model=\"vm.merchant.Company.Address.District\"></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"common.address.state\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"AddressState\" class=\"form-control\" ng-model=\"vm.merchant.Company.Address.State\"></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': merchantForm.PostCode.$invalid && merchantForm.PostCode.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"common.address.postcode\"></label><div class=\"col-md-8\"><input \ntype=\"text\" class=\"form-control\" name=\"PostCode\" ng-pattern=\"/^\\d+$/\" ng-model=\"vm.merchant.Company.Address.PostCode\">\n<div ng-messages=\"merchantForm.PostCode.$error\"><div ng-message=\"pattern\" ng-if=\"merchantForm.PostCode.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.company.postcode_format\"></span></div></div></div></div><div \nclass=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" translate=\"merchant.bank_information\"></h4></div></div>\n<div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"merchant.bank.name\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"BankName\" class=\"form-control\" ng-model=\"vm.merchant.Bank.Name\"></div></div>\n<div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.AccountNumber.$invalid && merchantForm.AccountNumber.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"merchant.bank.account_number\"></label><div class=\"col-md-8\"><input \ntype=\"text\" ng-pattern=\"/^\\d+$/\" name=\"AccountNumber\" class=\"form-control\" ng-model=\"vm.merchant.Bank.AccountNumber\">\n<div ng-messages=\"merchantForm.AccountNumber.$error\"><div ng-message=\"pattern\" \nng-if=\"merchantForm.AccountNumber.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.bank.account_number_format\"></span></div></div></div></div><div class=\"form-group\"><div \nclass=\"col-md-12\"><h4 class=\"sub-title\" translate=\"merchant.information\"></h4></div></div><div class=\"form-group\">\n<label class=\"control-label col-md-3\" translate=\"merchant.is_main\"></label><div class=\"col-md-8\" \nstyle=\"padding-top: 7px\"><input type=\"checkbox\" name=\"IsMain\" ng-model=\"vm.merchant.IsMain\"></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': merchantForm.CompanyName.$invalid && merchantForm.CompanyName.$touched}\">\n<label class=\"control-label col-md-3 required margin-tb\" translate=\"merchant.company.name\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"CompanyName\" class=\"form-control\" ng-model=\"vm.merchant.Company.Name\" \nrequired is-merchant-name-available=\"vm.merchant.Company.Id\"><div ng-messages=\"merchantForm.CompanyName.$error\"><div \nng-message=\"required\" ng-if=\"merchantForm.CompanyName.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.company.name\"></span></div><div ng-message=\"isMerchantNameAvailable\" \nng-if=\"merchantForm.CompanyName.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.company.name_duplicate\"></span></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\">University Merchant</label><div class=\"col-md-1\"><input type=\"checkbox\" \nid=\"IsUniversityMerchant\" ng-click=\"vm.getUniversities()\" name=\"IsUniversityMerchant\" \nng-model=\"vm.merchant.IsUniversityMerchant\"></div></div><div class=\"form-group university\" \nng-class=\"{\'has-error\': merchantForm.UniversityId.$invalid && merchantForm.UniversityId.$touched && vm.merchant.IsUniversityMerchant == 1}\">\n<label class=\"control-label col-md-3 required\">University</label><div class=\"col-md-8\"><select class=\"form-control\" \nid=\"UniversityId\" name=\"UniversityId\" ng-model=\"vm.merchant.UniversityId\" \nng-required=\"vm.merchant.IsUniversityMerchant\"><option ng-repeat=\"university in vm.universtyList\" \nvalue=\"{{university.UniversityId}}\">{{university.Name}}</option></select><div \nng-messages=\"merchantForm.UniversityId.$error\"><div ng-message=\"\" ng-if=\"merchantForm.UniversityId.$touched\" \nclass=\"help-block\"><span>University is required</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.Type.$invalid && merchantForm.Type.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"master_merchant.title\"></label><div class=\"col-md-8\"><select \nclass=\"form-control\" ng-model=\"vm.merchant.MasterMerchantId\" name=\"MasterMerchantId\" required><option \nng-repeat=\"masterMerchant in vm.masterMerchants\" ng-value=\"masterMerchant.Id\">{{masterMerchant.Name}}</option></select>\n<div ng-messages=\"merchantForm.MasterMerchantId.$error\"><div ng-message=\"required\" \nng-if=\"merchantForm.MasterMerchantId.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.merchant.master_merchant_required\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.Type.$invalid && merchantForm.Type.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"common.type\"></label><div class=\"col-md-8\"><select \nclass=\"form-control\" ng-model=\"vm.merchant.Type\" name=\"Type\"><option ng-repeat=\"type in vm.types\" ng-value=\"type.Id\">\n{{type.Name}}</option></select><div ng-messages=\"merchantForm.Type.$error\"><div ng-message=\"required\" \nng-if=\"merchantForm.Type.$touched\" class=\"help-block\"><span translate=\"merchant.validate.merchant.type\"></span></div>\n</div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.TierSetting.$invalid && merchantForm.TierSetting.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"merchant.tier_setting\"></label><div class=\"col-md-8\">\n<select class=\"form-control\" name=\"TierSetting\" ng-model=\"vm.merchant.MerchantTierId\" \nng-change=\"vm.checkRevenueShare()\" required><option ng-repeat=\"tier in vm.tierSettings\" ng-value=\"tier.Id\">\n{{tier.Name}}</option></select><div ng-messages=\"merchantForm.TierSetting.$error\"><div ng-message=\"required\" \nng-if=\"merchantForm.TierSetting.$touched\" class=\"help-block\"><span translate=\"merchant.validate.merchant.tier_setting\">\n</span></div></div></div></div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"merchant.partners_merchant\"></label><div class=\"btn-group col-md-8\"><label class=\"btn btn-default\" \nng-model=\"vm.merchant.IsPartnerMerchant\" ng-click=\"vm.changeIsPartnerMerchant()\" uib-btn-radio=\"true\">Yes</label><label\n class=\"btn btn-default\" ng-model=\"vm.merchant.IsPartnerMerchant\" ng-click=\"vm.changeIsPartnerMerchant()\" \nuib-btn-radio=\"false\">No</label></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.PartnerCategoryId.$invalid && merchantForm.PartnerCategoryId.$touched}\" \nng-if=\"vm.merchant.IsPartnerMerchant\"><label class=\"control-label col-md-3 required margin-tb\" \ntranslate=\"merchant.partner_merchant\"></label><div class=\"col-md-8\"><select class=\"form-control\" \nname=\"PartnerCategoryId\" ng-model=\"vm.merchant.PartnerCategoryId\" \nng-change=\"vm.getPartnerType(vm.merchant.PartnerCategoryId)\" required ng-disabled=\"vm.Tag == 5\"><option \nng-repeat=\"partnerCategory in vm.partnerCategories\" ng-value=\"partnerCategory.Id\">{{partnerCategory.Name}}</option>\n</select><div ng-messages=\"merchantForm.PartnerCategoryId.$error\"><div ng-message=\"required\" \nng-if=\"merchantForm.PartnerCategoryId.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.merchant.partners_name\"></span></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"merchant.use_shared_store_card\"></label><div \nclass=\"btn-group col-md-8\"><label class=\"btn btn-default\" ng-model=\"vm.merchant.UseSharedStoreCard\" \nuib-btn-radio=\"true\" ng-disabled=\"vm.Tag == 5\">Yes</label><label class=\"btn btn-default\" \nng-model=\"vm.merchant.UseSharedStoreCard\" uib-btn-radio=\"false\" ng-disabled=\"vm.Tag == 5\">No</label></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"admin.brand.tag\"></label><div \nclass=\"col-md-8\"><ui-select multiple=\"multiple\" ng-model=\"vm.merchant.Tags\" theme=\"bootstrap\" close-on-select=\"true\" \ntagging=\"vm.tagTransform\" tagging-tokens=\"\"><ui-select-match placeholder=\"Select tags...\">{{$item.Name}}\n</ui-select-match><ui-select-choices repeat=\"tag in vm.tags | filter:$select.search\"><div ng-bind=\"tag.Name\"></div>\n</ui-select-choices></ui-select></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.SharedStoreCardSettingId.$invalid && merchantForm.SharedStoreCardSettingId.$touched}\" \nng-if=\"vm.merchant.UseSharedStoreCard\"><label class=\"control-label col-md-3 required margin-tb\" \ntranslate=\"merchant.shared_store_card_setting_id\"></label><div class=\"col-md-8\"><select class=\"form-control\" \nname=\"SharedStoreCardSettingId\" ng-model=\"vm.merchant.SharedStoreCardSettingId\" required><option \nng-repeat=\"sharedStoreCardSetting in vm.sharedStoreCardSetting\" ng-value=\"sharedStoreCardSetting.Id\">\n{{sharedStoreCardSetting.Name}}</option></select><div ng-messages=\"merchantForm.SharedStoreCardSettingId.$error\"><div \nng-message=\"required\" ng-if=\"merchantForm.SharedStoreCardSettingId.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.merchant.shared_store_card_setting\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': merchantForm.Logo.$invalid && merchantForm.Logo.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"merchant.logo\"></label><div class=\"col-md-8\"><div \nclass=\"logoForm-image\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.merchant.Logo\" ng-hide=\"true\" name=\"Logo\">\n<div upload-control class=\"upload-control image-uploader merchant-logo\" \non-file-selected=\"vm.onMerchantLogoSelected($files, $control)\"><input name=\"file\" type=\"file\" \naccept=\".jpeg, .jpg, .png\" ng-show=\"false\" ng-model=\"file\"> <a class=\"btn btn-default\" \ntranslate=\"common.action.select_photo\"></a><label>{{vm.temp}}</label><div class=\"image-wrapper\"><img id=\"photo\" \nng-src=\"{{vm.merchant.Logo ? vm.merchant.Logo + \'?w=300&h=300\': \'../../assets/images/placeholder.png\'}}\"></div></div>\n<button type=\"button\" class=\"btn-delete-photo\" ng-click=\"vm.deleteLogo()\" ng-hide=\"vm.disabledDeleteLogo\"><span \nclass=\"glyphicon glyphicon-trash\"></span></button></div><div><label class=\"note\" translate=\"merchant.note\"></label>\n</div><div ng-messages=\"merchantForm.Logo.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.Logo.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.merchant.logo\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': merchantForm.WebcashId.$invalid && merchantForm.WebcashId.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"common.webcash_id\"></label><div class=\"col-md-8\"><input \ntype=\"text\" class=\"form-control\" name=\"WebcashId\" ng-model=\"vm.merchant.WebCashId\" ng-required=\"vm.requiredWebcashId\">\n<div ng-messages=\"merchantForm.WebcashId.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.WebcashId.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.merchant.webcash_id\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"common.access_id\"></label><div \nclass=\"col-md-8\"><input type=\"text\" class=\"form-control\" name=\"AccessId\" ng-model=\"vm.merchant.AccessId\"></div></div>\n<div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"merchant.hash_key\"></label><div \nclass=\"col-md-8\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"HashKey\" \nng-model=\"vm.merchant.HashKey\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary\" \nng-click=\"vm.createHashKey()\">Generate Hash</button></span></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"merchant.subscribed_services\"></label><div class=\"col-md-8\">\n<ui-select multiple=\"multiple\" ng-model=\"vm.merchant.SubscribedServices\" theme=\"bootstrap\" close-on-select=\"true\" \nng-disabled=\"vm.Tag == 5\"><ui-select-match placeholder=\"Select subscribed service...\">{{$item.Name | translate}}\n</ui-select-match><ui-select-choices \nrepeat=\"subscribedService.Id as subscribedService in vm.subscribedServices | filter:$select.search\"><div \nstyle=\"width:100%\" ng-bind=\"subscribedService.Name | translate\"></div></ui-select-choices></ui-select></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': merchantForm.ServiceDate.$invalid && merchantForm.ServiceDate.$touched}\">\n<label class=\"control-label col-md-3 margin-tb\" translate=\"merchant.service_date\"></label><div class=\"col-md-8\"><div \nclass=\"input-group\"><input type=\"text\" name=\"ServiceDate\" class=\"form-control\" uib-datepicker-popup \nng-model=\"vm.merchant.ServiceDate\" is-open=\"vm.serviceDatePopup.opened\" datepicker-options=\"vm.dateOptions\" \nclose-text=\"Close\" autocomplete=\"off\" ng-click=\"vm.openServiceDatePopup()\" ng-required=\"vm.requiredServiceDate\"> <span \nclass=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openServiceDatePopup()\"><i \nclass=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"merchantForm.ServiceDate.$error\"><div \nng-message=\"date\" ng-if=\"merchantForm.ServiceDate.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.merchant.service_date_valid\"></span></div><div ng-message=\"required\" \nng-if=\"merchantForm.ServiceDate.$touched\" class=\"help-block\"><span translate=\"merchant.validate.merchant.service_date\">\n</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.ContractDate.$invalid && merchantForm.ContractDate.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"merchant.contract_date\"></label><div class=\"col-md-8\"><div \nclass=\"input-group\"><input type=\"text\" name=\"ContractDate\" class=\"form-control\" uib-datepicker-popup \nng-model=\"vm.merchant.ContractDate\" is-open=\"vm.contractDatePopup.opened\" datepicker-options=\"vm.dateOptions\" \nclose-text=\"Close\" autocomplete=\"off\" ng-click=\"vm.openContractDatePopup()\"> <span class=\"input-group-btn\"><button \ntype=\"button\" class=\"btn btn-default\" ng-click=\"vm.openContractDatePopup()\"><i class=\"glyphicon glyphicon-calendar\">\n</i></button></span></div><div ng-messages=\"merchantForm.ContractDate.$error\"><div ng-message=\"date\" \nng-if=\"merchantForm.ContractDate.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.merchant.contract_date_valid\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.GSTSetting.$invalid && merchantForm.GSTSetting.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"merchant.gst_setting\"></label><div class=\"col-md-8\"><select \nclass=\"form-control\" ng-model=\"vm.merchant.GSTSetting\" name=\"GSTSetting\" required><option value=\"Inclusive\">Inclusive\n</option><option value=\"Exclusive\">Exclusive</option><option value=\"GSTFree\">GST Free</option></select><div \nng-messages=\"merchantForm.GSTSetting.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.GSTSetting.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.merchant.gst_setting\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"common.partner_merchantId\"></label><div \nclass=\"col-md-8\"><input type=\"text\" class=\"form-control\" name=\"PartnerMerchantId\" \nng-model=\"vm.merchant.PartnerMerchantId\"></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"Payment Options\"></label><div class=\"col-md-8\"><ui-select \nmultiple=\"multiple\" ng-model=\"vm.merchant.WalletPaymentOption\" theme=\"bootstrap\" close-on-select=\"true\" \nng-disabled=\"vm.Tag == 5\"><ui-select-match placeholder=\"Select Payment Options...\">{{$item.Name | translate}}\n</ui-select-match><ui-select-choices \nrepeat=\"WalletOption.Id as WalletOption in vm.WalletOption | filter:$select.search\"><div style=\"width:100%\" \nng-bind=\"WalletOption.Name | translate\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\">\n<label class=\"control-label col-md-3 margin-tb\" translate=\"White Label Partner\'s Merchant\"></label><div \nclass=\"col-md-8\"><select class=\"form-control\" name=\"CommunitySetting\" ng-model=\"vm.merchant.CommunityId\"><option \nng-value=\"\">-- Select Partner Merchant --</option><option ng-repeat=\"com in vm.CommunitySetting\" ng-value=\"com.Id\">\n{{com.Name}}</option></select></div></div></form></div><div id=\"storeCardTopupOptionsDiv\" class=\"tab-pane fade\"><form \nname=\"storeCardTopupOptionsForm\" class=\"form-horizontal\" novalidate id=\"storeCardTopupOptionsForm\"><br><div \nclass=\"row\" ng-repeat=\"storeCardTopupOption in vm.merchant.StoreCardTopupOptions track by $index\"><div \nclass=\"form-group col-md-4\" \nng-class=\"{\'has-error\': storeCardTopupOptionsForm[\'storeCardTopupOptionName\'+$index].$invalid && storeCardTopupOptionsForm[\'storeCardTopupOptionName\'+$index].$touched}\">\n<div class=\"row\"><label class=\"control-label col-md-4 required margin-tb\" \ntranslate=\"merchant.store_card_topup_option.name\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"storeCardTopupOptionName{{$index}}\" class=\"form-control\" ng-model=\"storeCardTopupOption.Name\" required></div>\n</div><div class=\"row\"><div class=\"form-group col-md-12\"><div \nng-messages=\"storeCardTopupOptionsForm[\'storeCardTopupOptionName\'+$index].$error\" style=\"margin-left:33px\"><div \nng-message=\"required\" ng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionName\'+$index].$touched\" class=\"help-block\">\n<span translate=\"merchant.validate.store_card_topup_option.name\"></span></div></div></div></div></div><div \nclass=\"form-group col-md-3\" \nng-class=\"{\'has-error\': storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$invalid && storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$touched}\">\n<div class=\"row\"><label class=\"control-label col-md-6 required margin-tb\" \ntranslate=\"merchant.store_card_topup_option.amount\"></label><div class=\"col-md-6\"><input type=\"number\" \nname=\"storeCardTopupOptionAmount{{$index}}\" class=\"form-control\" ng-model=\"storeCardTopupOption.Amount\" \nng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\" required></div></div><div class=\"row\"><div \nclass=\"form-group col-md-12\"><div ng-messages=\"storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$error\" \nstyle=\"margin-left:30px\"><div ng-message=\"required\" \nng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.store_card_topup_option.amount\"></span></div><div ng-message=\"number\" \nng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.store_card_topup_option.amount_number\"></span></div><div ng-message=\"pattern\" \nng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.store_card_topup_option.amount_number\"></span></div></div></div></div></div><div \nclass=\"form-group col-md-3\" \nng-class=\"{\'has-error\': storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$invalid && storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$touched}\">\n<div class=\"row\"><label class=\"control-label col-md-6 required margin-tb\" \ntranslate=\"merchant.store_card_topup_option.bonus\"></label><div class=\"col-md-6\"><input type=\"number\" \nname=\"storeCardTopupOptionBonus{{$index}}\" class=\"form-control\" ng-model=\"storeCardTopupOption.Bonus\" \nng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\" required></div></div><div class=\"row\"><div \nclass=\"form-group col-md-12\"><div ng-messages=\"storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$error\" \nstyle=\"margin-left:40px\"><div ng-message=\"required\" \nng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.store_card_topup_option.bonus\"></span></div><div ng-message=\"number\" \nng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.store_card_topup_option.bonus_number\"></span></div><div ng-message=\"pattern\" \nng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.store_card_topup_option.bonus_number\"></span></div></div></div></div></div><div \nclass=\"form-group col-md-2\"><a style=\"margin-left:5px\" class=\"btn btn-danger\" \nng-click=\"vm.removeStoreCardTopupOption($index)\">Remove</a></div></div><div class=\"row\"><div \nclass=\"form-group col-md-12 text-right\"><a class=\"btn btn-primary\" ng-click=\"vm.addStoreCardTopupOption()\">Add</a>\n</div></div></form></div><div id=\"webhookDiv\" class=\"tab-pane fade\"><form name=\"webhookForm\" class=\"form-horizontal\" \nnovalidate id=\"webhookForm\"><br><div class=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" \ntranslate=\"merchant.webhook.store_card\"></h4></div></div><br><div ng-repeat=\"webhook in vm.webhooks | orderBy: \'Rank\'\">\n<div class=\"form-group\"><label class=\"control-label col-md-3\">{{webhook.TypeName}} - Url</label><div class=\"col-md-8\">\n<input type=\"url\" class=\"form-control\" ng-model=\"webhook.CallBackUrl\"></div></div></div><br><div class=\"form-group\">\n<div class=\"col-md-12\"><h4 class=\"sub-title\" translate=\"merchant.webhook.deeplink\"></h4></div></div><br><div \nng-repeat=\"webhook in vm.deeplinks | orderBy: \'Rank\'\"><div class=\"form-group\"><label class=\"control-label col-md-3\">\n{{webhook.TypeName}} - Url</label><div class=\"col-md-8\"><input type=\"url\" class=\"form-control\" \nng-model=\"webhook.CallBackUrl\"></div></div></div></form></div><div id=\"qrPaymentPartnerAPIDiv\" class=\"tab-pane fade\">\n<form name=\"qrPaymentPartnerAPIForm\" class=\"form-horizontal\" novalidate id=\"qrPaymentPartnerAPIForm\"><br><div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"Api Url\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"ApiUrl\" class=\"form-control\" ng-model=\"vm.merchant.ApiUrl\" required \nis-merchant-name-available=\"vm.merchant.Api.Url\"><div ng-messages=\"qrPaymentPartnerAPIForm.ApiUrl.$error\"><div \nng-message=\"required\" ng-if=\"merchantForm.ApiUrl.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.api.url\"></span></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"Api Key\"></label><div class=\"col-md-8\"><input type=\"text\" name=\"ApiKey\" \nclass=\"form-control\" ng-model=\"vm.merchant.ApiKey\" required is-merchant-name-available=\"vm.merchant.Api.Key\"><div \nng-messages=\"qrPaymentPartnerAPIForm.ApiKey.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.ApiUrl.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.api.key\"></span></div></div></div></div><div class=\"form-group\">\n<label class=\"control-label col-md-3\" translate=\"Api Secret\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"ApiSecret\" class=\"form-control\" ng-model=\"vm.merchant.ApiSecret\" required \nis-merchant-name-available=\"vm.merchant.Api.Secret\"><div ng-messages=\"qrPaymentPartnerAPIForm.ApiSecret.$error\"><div \nng-message=\"required\" ng-if=\"qrPaymentPartnerAPIForm.ApiSecret.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.api.secret\"></span></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"Api Sign Template\"></label><div class=\"col-md-8\"><textarea type=\"text\" \nname=\"ApiSignTemplate\" class=\"form-control\" ng-model=\"vm.merchant.ApiSignTemplate\"></textarea><div \nng-messages=\"qrPaymentPartnerAPIForm.ApiSignTemplate.$error\"><div ng-message=\"required\" \nng-if=\"qrPaymentPartnerAPIForm.ApiSignTemplate.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.api.signtemplate\"></span></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"Notify Payment Template\"></label><div class=\"col-md-8\"><textarea type=\"text\" \nname=\"ApiNotifyPaymentTemplate\" class=\"form-control\" ng-model=\"vm.merchant.ApiNotifyPaymentTemplate\"></textarea><div \nng-messages=\"qrPaymentPartnerAPIForm.ApiNotifyPaymentTemplate.$error\"><div ng-message=\"required\" \nng-if=\"qrPaymentPartnerAPIForm.ApiNotifyPaymentTemplate.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.api.notifypaymenttemplate\"></span></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"Content Type\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"ApiContentType\" class=\"form-control\" ng-model=\"vm.merchant.ApiContentType\"><div \nng-messages=\"qrPaymentPartnerAPIForm.ApiContentType.$error\"><div ng-message=\"required\" \nng-if=\"qrPaymentPartnerAPIForm.ApiContentType.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.api.contenttype\"></span></div></div></div></div></div></form></div></div></div><div \nclass=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button \ntype=\"button\" class=\"btn btn-primary\" ng-click=\"vm.save()\" translate=\"common.action.save\" ng-disabled=\"vm.Tag == 5\">\n</button></div></div></div></div></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowAddUserDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" \nclass=\"close\" ng-click=\"vm.viewConfig.ShowAddUserDialog = false\"><span aria-hidden=\"true\">&times;</span><span \nclass=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\">Add user to merchant</h3></div>\n<form name=\"merchantUserForm\" class=\"form-horizontal\" ng-submit=\"vm.saveUser()\" novalidate id=\"merchantUserForm\"><div \nclass=\"modal-body\"><div class=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" translate=\"merchant.user_info\">\n</h4></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantUserForm.UserName.$invalid && merchantUserForm.UserName.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"common.username\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"UserName\" class=\"form-control\" ng-model=\"vm.user.UserName\" required><div \nng-messages=\"merchantUserForm.UserName.$error\"><div ng-message=\"required\" ng-if=\"merchantUserForm.UserName.$touched\" \nclass=\"help-block\"><span translate=\"merchant.user.validate.user_name\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': merchantUserForm.Password.$invalid && merchantUserForm.Password.$touched}\">\n<label class=\"control-label col-md-3 required\" translate=\"common.password\"></label><div class=\"col-md-8\"><input \ntype=\"password\" name=\"Password\" class=\"form-control\" ng-model=\"vm.user.Password\" required><div \nng-messages=\"merchantUserForm.Password.$error\"><div ng-message=\"required\" ng-if=\"merchantUserForm.Password.$touched\" \nclass=\"help-block\"><span translate=\"merchant.user.validate.password\"></span></div></div></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': merchantUserForm.ConfirmPassword.$invalid && merchantUserForm.ConfirmPassword.$touched}\"><label\n class=\"control-label col-md-3 required\" translate=\"common.confirm_password\"></label><div class=\"col-md-8\"><input \ntype=\"password\" name=\"ConfirmPassword\" class=\"form-control\" ng-model=\"vm.user.ConfirmPassword\" \nng-pattern=\"{{vm.user.Password}}\" required><div ng-messages=\"merchantUserForm.ConfirmPassword.$error\"><div \nng-message=\"required\" ng-if=\"merchantUserForm.ConfirmPassword.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.user.validate.password_confirm\"></span></div><div ng-message=\"pattern\" class=\"help-block\"><span \ntranslate=\"merchant.user.validate.password_confirm_not_match\"></span></div></div></div></div><div class=\"form-group\">\n<div class=\"col-md-12\"><h4 class=\"sub-title\" translate=\"common.permission.title\"></h4></div></div><div \nclass=\"form-group\"><div class=\"col-md-3\"></div><div ng-repeat=\"permission in vm.permissions\" class=\"checkbox col-md-4\" \nng-class=\"{\'col-md-offset-3\':$index%2==0&&$index!=0}\"><label><input type=\"checkbox\" \nng-click=\"vm.addPermission(permission.Value)\" ng-checked=\"vm.permissionSelected(permission.Value)\">\n{{permission.Name | translate}}</label></div></div></div><div class=\"modal-footer\"><a class=\"btn btn-warning\" \nng-click=\"vm.selectAll()\" translate=\"common.action.select_all\"></a> <a class=\"btn btn-danger\" \nng-click=\"vm.viewConfig.ShowAddUserDialog = false\" translate=\"common.action.cancel\"></a> <button type=\"submit\" \nclass=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div></div></div>");
$templateCache.put("app/report/reports.html","<h1 class=\"page-header\" translate=\"report.list_title\"></h1><div class=\"reports-list-wrapper\" ng-init=\"vm.init()\"><div \nclass=\"reports-list\" show-permissions=\"[\'MERCHANT\']\"><div class=\"report-item-wrapper\" show-route \nshow-for-route=\"app.reports.statement-of-account\" ng-if=\"vm.Tag!=5\"><div class=\"report-item\" \nui-sref=\"app.reports.statement-of-account\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" \ntranslate=\"report.names.statement_of_account\"></a></div></div><div class=\"report-item-wrapper\" show-route \nshow-for-route=\"app.reports.statement-of-account-redpay\"><div class=\"report-item\" \nui-sref=\"app.reports.statement-of-account-redpay\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" \ntranslate=\"report.names.statement_of_account_redpay\"></a></div></div><div class=\"report-item-wrapper\" show-route \nshow-for-route=\"app.reports.outlet-transactions\" ng-if=\"vm.Tag!=5\"><div class=\"report-item\" \nui-sref=\"app.reports.outlet-transactions\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" \ntranslate=\"report.names.outlet_transactions\"></a></div></div><div class=\"report-item-wrapper\" show-route \nshow-for-route=\"app.reports.voucher-summary\" ng-if=\"vm.Tag!=5\"><div class=\"report-item\" \nui-sref=\"app.reports.voucher-summary\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" translate=\"report.names.voucher_summary\">\n</a></div></div><div class=\"report-item-wrapper\" show-route show-for-route=\"app.reports.confirmed-users-daily\"><div \nclass=\"report-item\" ui-sref=\"app.reports.confirmed-users-daily\"><div class=\"report-icon-wrapper\"><img \nclass=\"report-icon\" src=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" \ntranslate=\"report.names.confirmed_user\"></a></div></div></div><div class=\"reports-list\" \nshow-permissions=\"[\'ADMIN_USER\']\"><div class=\"report-item-wrapper\" show-route \nshow-for-route=\"app.reports.user-registration-report\"><div class=\"report-item\" \nui-sref=\"app.reports.user-registration-report\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" \ntranslate=\"report.names.user_registration_report\"></a></div></div></div><div class=\"reports-list\" \nshow-permissions=\"[\'VIEW_UUM_STUDENT_TRANSACTION_REPORT\', \'VIEW_UiTM_STUDENT_TRANSACTION_REPORT\', \'VIEW_UPM_STUDENT_TRANSACTION_REPORT\']\">\n<div class=\"report-item-wrapper\" \nshow-permissions=\"[\'VIEW_UUM_STUDENT_TRANSACTION_REPORT\', \'VIEW_UiTM_STUDENT_TRANSACTION_REPORT\', \'VIEW_UPM_STUDENT_TRANSACTION_REPORT\']\" \nshow-route show-for-route=\"app.university.university-report\"><div class=\"report-item\" \nui-sref=\"app.university.university-report\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" \ntranslate=\"navigation.student_transaction\"></a></div></div><div class=\"report-item-wrapper\" \nshow-permissions=\"[\'VIEW_UUM_STUDENT_TRANSACTION_REPORT\', \'VIEW_UiTM_STUDENT_TRANSACTION_REPORT\', \'VIEW_UPM_STUDENT_TRANSACTION_REPORT\']\" \nshow-route show-for-route=\"app.university.university-report\"><div class=\"report-item\" \nui-sref=\"app.university.university-outlet-report\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" \ntranslate=\"navigation.student_outlet_transaction\"></a></div></div><div class=\"report-item-wrapper\" \nshow-permissions=\"[\'CREATE_GENERIC_REPORT\']\" show-route show-for-route=\"app.university.university-payment-report\"><div \nclass=\"report-item\" ui-sref=\"app.university.university-payment-report\"><div class=\"report-icon-wrapper\"><img \nclass=\"report-icon\" src=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" \ntranslate=\"report.names.university_payment_report\"></a></div></div></div><div class=\"reports-list\"><div \nclass=\"report-item-wrapper\" show-permissions=\"[\'CREATE_GENERIC_REPORT\']\" show-route \nshow-for-route=\"app.university.university-report\"><div class=\"report-item\" \nui-sref=\"app.university.referral-code-summary-report\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" translate=\"Referral Code Summary Report\">\n</a></div></div></div><div class=\"reports-list\"><div class=\"report-item-wrapper\" show-route \nshow-for-route=\"app.reports.webcash-settlement\"><div class=\"report-item\" ui-sref=\"app.reports.webcash-settlement\"><div \nclass=\"report-icon-wrapper\"><img class=\"report-icon\" src=\"/assets/images/report.png\"></div><a ui-sref=\"report\" \nclass=\"report-name\" translate=\"report.names.webcash_settlement\"></a></div></div><div class=\"report-item-wrapper\" \nshow-route show-for-route=\"app.reports.mobilityone-settlement\"><div class=\"report-item\" \nui-sref=\"app.reports.mobilityone-settlement\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" \ntranslate=\"report.names.mobilityone_settlement\"></a></div></div></div><div class=\"reports-list\"><div \nclass=\"report-item-wrapper\" show-route show-for-route=\"app.reports.merchants-list\" ng-if=\"vm.Tag!=5\"><div \nclass=\"report-item\" ui-sref=\"app.reports.merchants-list\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" translate=\"report.names.merchants_list\">\n</a></div></div><div class=\"report-item-wrapper\" show-route show-for-route=\"app.reports.store-list\"><div \nclass=\"report-item\" ui-sref=\"app.reports.store-list\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" translate=\"report.names.store_list\"></a>\n</div></div><div class=\"report-item-wrapper\" show-route show-for-route=\"app.reports.merchant-gap\"><div \nclass=\"report-item\" ui-sref=\"app.reports.merchant-gap\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" translate=\"report.names.merchant_gap\">\n</a></div></div><div class=\"report-item-wrapper\" show-route show-for-route=\"app.reports.merchant-terminals\"><div \nclass=\"report-item\" ui-sref=\"app.reports.merchant-terminals\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" \ntranslate=\"report.names.merchant_terminal\"></a></div></div></div><div class=\"reports-list\"><div \nclass=\"report-item-wrapper\" show-permissions=\"[\'VIEW_EXCEPTION_REPORT\']\" show-route \nshow-for-route=\"app.reports.exception-transactions\"><div class=\"report-item\" \nui-sref=\"app.reports.exception-transactions\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" \ntranslate=\"report.names.exception_transactions_report\"></a></div></div></div><div class=\"reports-list\"><div \nclass=\"report-item-wrapper\" show-route show-for-route=\"app.reports.bonus-credit\" show-permissions=\"[\'ADMIN_USER\']\"><div\n class=\"report-item\" ui-sref=\"app.reports.bonus-credit\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" \ntranslate=\"report.names.bonus_credit_report\"></a></div></div><div class=\"report-item-wrapper\" show-route \nshow-for-route=\"app.reports.peer-credit\" show-permissions=\"[\'ADMIN_USER\']\"><div class=\"report-item\" \nui-sref=\"app.reports.peer-to-peer\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" \ntranslate=\"report.names.peer_to_peer_report\"></a></div></div></div><div class=\"reports-list\" \nshow-permissions=\"[\'ADMIN_USER\']\"><div class=\"report-item-wrapper\" show-route \nshow-for-route=\"app.reports.remittance-report\"><div class=\"report-item\" ui-sref=\"app.reports.remittance-report\"><div \nclass=\"report-icon-wrapper\"><img class=\"report-icon\" src=\"/assets/images/report.png\"></div><a ui-sref=\"report\" \nclass=\"report-name\" translate=\"report.names.remittance_report\"></a></div></div></div><div class=\"reports-list\"><div \nclass=\"report-item-wrapper\" show-route show-for-route=\"app.reports.monthly-wallet-utilization\" ng-if=\"vm.Tag!=5\"><div \nclass=\"report-item\" ui-sref=\"app.reports.monthly-wallet-utilization\"><div class=\"report-icon-wrapper\"><img \nclass=\"report-icon\" src=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" \ntranslate=\"report.names.monthly_wallet_utilization\"></a></div></div></div><div class=\"reports-list\"><div \nclass=\"report-item-wrapper\" show-route show-for-route=\"app.reports.redpay-transaction\"><div class=\"report-item\" \nui-sref=\"app.reports.redpay-transaction\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" \ntranslate=\"report.names.redpay_transaction_report\"></a></div></div></div><div class=\"reports-list\" \nshow-permissions=\"[\'ADMIN_USER\']\"><div class=\"report-item-wrapper\" show-route \nshow-for-route=\"app.reports.community-report\"><div class=\"report-item\" ui-sref=\"app.reports.community-report\"><div \nclass=\"report-icon-wrapper\"><img class=\"report-icon\" src=\"/assets/images/report.png\"></div><a ui-sref=\"report\" \nclass=\"report-name\" translate=\"report.names.community_report\"></a></div></div></div><div class=\"reports-list\" \nshow-permissions=\"[\'ADMIN_USER\']\"><div class=\"report-item-wrapper\" show-route \nshow-for-route=\"app.reports.wallet-source-of-fund-report\"><div class=\"report-item\" \nui-sref=\"app.reports.wallet-source-of-fund-report\"><div class=\"report-icon-wrapper\"><img class=\"report-icon\" \nsrc=\"/assets/images/report.png\"></div><a ui-sref=\"report\" class=\"report-name\" \ntranslate=\"report.names.wallet_source_of_fund_report\"></a></div></div></div><div class=\"reports-list\" \nshow-permissions=\"[\'ADMIN_USER\']\"><div class=\"report-item-wrapper\" show-route \nshow-for-route=\"app.reports.insurance-report\"><div class=\"report-item\" ui-sref=\"app.reports.insurance-report\"><div \nclass=\"report-icon-wrapper\"><img class=\"report-icon\" src=\"/assets/images/report.png\"></div><a ui-sref=\"report\" \nclass=\"report-name\" translate=\"report.names.Insurance_Report\"></a></div></div></div></div>");
$templateCache.put("app/store/store.html","<h1 class=\"page-header\" translate=\"store.title\"></h1><div id=\"store\" class=\"col-md-12\"><div class=\"form-horizontal\">\n<div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 margin-tb col-xs-12\"><input type=\"text\" \nclass=\"form-control\" ng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"{{ \'store.placeholder.search_store\' | translate}}\"></div><div class=\"col-md-3 margin-tb col-xs-12\" \nng-if=\"vm.isAdmin\"><ui-select ng-model=\"vm.criteria.MerchantId\" theme=\"bootstrap\" ng-change=\"vm.search()\">\n<ui-select-match placeholder=\"Enter the merchant\'s name\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh=\"vm.loadMerchant($select.search)\" \nrefresh-delay=\"0\" minimum-input-length=\"0\"><div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div><div class=\"col-md-1 col-sm-10\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span \ntranslate=\"common.action.reset\"></span></a></div><div class=\"col-md-5 col-sm-2\"><a show-permissions=\"[\'CREATE_STORE\']\" \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.add()\"><i class=\"glyphicon glyphicon-plus\"></i> <span \ntranslate=\"common.action.add\"></span></a></div></div></div><div class=\"form-group\"><div class=\"table-responsive\"><table\n class=\"table table-striped table-bordered\"><thead thead-order=\"vm.sort($sortOpts)\"><tr><th width=\"\">#</th><th \nth-order=\"\'Name\'\"><span translate=\"store.name\"></span></th><th width=\"20%\" translate=\"store.address\"></th><th \nng-if=\"vm.isAdmin\" translate=\"store.merchant_name\"></th><th translate=\"store.average_price.title\"></th><th \nth-order=\"\'CreateDate\'\"><span translate=\"store.created_date\"></span></th><th translate=\"common.state\"></th><th \ntranslate=\"store.action\"></th><th translate=\"Outletcode\"></th></tr></thead><tbody><tr ng-repeat=\"store in vm.stores\">\n<td class=\"text-center\">{{$index + 1}}</td><td>{{store.Name}}</td><td>{{store.Address}}</td><td ng-if=\"vm.isAdmin\">\n{{store.MerchantName}}</td><td ng-if=\"store.AveragePriceFrom == 0 && store.AveragePriceTo == 0\" class=\"text-center\">\n</td><td ng-if=\"store.AveragePriceFrom == 0 && store.AveragePriceTo > 0\" class=\"text-center\">\n{{\'store.average_price.less_than_20\' | translate}}</td><td \nng-if=\"store.AveragePriceFrom > 0 && store.AveragePriceTo > 0\" class=\"text-center\">\n{{\'store.average_price.between_20_and_50\' | translate}}</td><td \nng-if=\"store.AveragePriceTo == 0 && store.AveragePriceFrom > 0\" class=\"text-center\">\n{{\'store.average_price.greater_than_50\' | translate}}</td><td>{{store.CreatedDate | date:\'MM/dd/yyyy h:mma\'}}</td><td>\n{{store.StoreState}}</td><td class=\"text-center\"><a show-permissions=\"[\'EDIT_STORE\']\" title=\"Edit store\" \nclass=\"btn btn-default margin-tl\" ng-click=\"vm.edit(store.Id)\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a \nng-if=\"store.StaticQREnabled\" show-permissions=\"[\'MANAGE_STATIC_QR\']\" title=\"Manage static QR\" \nclass=\"btn btn-default margin-tl\" ui-sref=\"app.store.static_qr({storeId:store.Id})\"><i \nclass=\"glyphicon glyphicon-qrcode\"></i></a> <a show-permissions=\"[\'ADD_TERMINAL_TO_STORE\']\" \ntitle=\"Add terminal to store\" class=\"btn btn-info margin-tl\" ng-click=\"vm.addTerminal(store.Id)\"><i \nclass=\"glyphicon glyphicon-phone\"></i></a> <a show-permissions=\"[\'ADD_MANAGER_TO_STORE\']\" title=\"Add manager to store\" \nclass=\"btn btn-info margin-tl\" ng-click=\"vm.addManager(store.Id)\"><i class=\"glyphicon glyphicon-user\"></i></a> <a \nshow-permissions=\"[\'PUBLISH_STORE\']\" title=\"Unpublish\" ng-if=\"store.StoreState == \'Published\'\" \nclass=\"btn btn-danger margin-tl\" ng-click=\"vm.unpublish(store)\"><i class=\"glyphicon glyphicon-cloud-download\"></i></a> \n<a show-permissions=\"[\'PUBLISH_STORE\']\" title=\"Publish\" \nng-if=\"store.StoreState == \'Approved\' || store.StoreState == \'Unpublished\'\" class=\"btn btn-primary margin-tl\" \nng-click=\"vm.publish(store)\"><i class=\"glyphicon glyphicon-cloud-upload\"></i></a> <a \nshow-permissions=\"[\'DELETE_STORE\']\" class=\"btn btn-danger margin-tl\" mwl-confirm title=\"Delete store\" \nmessage=\"Are you really <b>sure</b> you want to delete this store?\" confirm-text=\"OK\" cancel-text=\"Cancel\" \non-confirm=\"vm.delete(store.Id)\" on-cancel=\"\" confirm-button-type=\"danger\" cancel-button-type=\"default\"><i \nclass=\"glyphicon glyphicon-remove\"></i></a></td><td>{{store.OutletCode}}</td></tr></tbody></table></div><ul \nuib-pagination total-items=\"vm.totalItems\" ng-model=\"vm.currentPage\" itemsperpage=\"vm.itemsPerPage\" \nmax-size=\"vm.maxSize\" ng-change=\"vm.search()\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul>\n</div></div><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowStoreDialog\" \nclass=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-lg\"><div \nclass=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.viewConfig.ShowStoreDialog = false\" ng-show=\"vm.Tag == 5 || vm.Tag == 0\"><span aria-hidden=\"true\">&times;\n</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\" \ntranslate=\"store.store_detail\"></h3></div><form name=\"storeForm\" class=\"form-horizontal\" ng-submit=\"vm.save()\" \nnovalidate id=\"storeForm\"><div class=\"modal-body\"><div class=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" \ntranslate=\"store.bank_information\"></h4></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"store.bank.name\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"BankName\" class=\"form-control\" ng-model=\"vm.store.BankName\"></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.BankAccountNumber.$invalid && storeForm.BankAccountNumber.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"store.bank.account_number\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"BankAccountNumber\" ng-pattern=\"/^\\d+$/\" class=\"form-control\" ng-model=\"vm.store.BankAccountNumber\">\n<div ng-messages=\"storeForm.BankAccountNumber.$error\"><div ng-message=\"pattern\" \nng-if=\"storeForm.BankAccountNumber.$touched\" class=\"help-block\"><span \ntranslate=\"store.validate.bank.bank_account_number\"></span></div></div></div></div><div class=\"form-group\"><div \nclass=\"col-md-12\"><h4 class=\"sub-title\" translate=\"store.information\"></h4></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.MerChantName.$invalid && storeForm.MerChantName.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"store.merchant_name\"></label><div class=\"col-md-8\" \nng-if=\"!vm.isAdmin\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.MerchantName\" readonly=\"readonly\"></div><div \nclass=\"col-md-8\" ng-if=\"vm.isAdmin\"><ui-select ng-model=\"vm.store.MerchantId\" theme=\"bootstrap\" \nng-change=\"vm.search()\" name=\"MerchantId\" on-select=\"vm.Change(vm.store.MerchantId)\" required><ui-select-match \nplaceholder=\"Enter the merchant\'s name\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh=\"vm.loadMerchant($select.search)\" \nrefresh-delay=\"0\" minimum-input-length=\"0\"><div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select><div ng-messages=\"storeForm.MerChantName.$error\"><div ng-message=\"required\" \nng-if=\"storeForm.MerChantName.$touched\" class=\"help-block\"><span translate=\"store.validate.merchant.name\"></span></div>\n</div></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': storeForm.Name.$invalid && storeForm.Name.$touched}\">\n<label class=\"control-label col-md-3 required margin-tb\" translate=\"store.name\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"Name\" class=\"form-control\" ng-model=\"vm.store.Name\" required><div \nng-messages=\"storeForm.Name.$error\"><div ng-message=\"required\" ng-if=\"storeForm.Name.$touched\" class=\"help-block\"><span\n translate=\"store.validate.store.name\"></span></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"common.group\"></label><div class=\"col-md-8\"><select name=\"Group\" \nclass=\"form-control\" ng-model=\"vm.store.GroupId\"><option value=\"0\">--- Select an option ---</option><option \nng-repeat=\"group in vm.groups\" ng-value=\"group.Id\">{{group.Name}}</option></select></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.Address.$invalid && storeForm.Address.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"store.address\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"Address\" class=\"form-control\" ng-model=\"vm.store.Address\"><div ng-messages=\"storeForm.Address.$error\"><div \nng-message=\"required\" ng-if=\"storeForm.Address.$touched\" class=\"help-block\"><span \ntranslate=\"store.validate.store.address\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.OutletCode.$invalid && storeForm.OutletCode.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"OutletCode\"></label><div class=\"col-md-8\"><input type=\"text\" name=\"Address\" \nclass=\"form-control\" ng-model=\"vm.store.OutletCode\"><div ng-messages=\"storeForm.OutletCode.$error\"><div \nng-message=\"required\" ng-if=\"storeForm.OutletCode.$touched\" class=\"help-block\"><span \ntranslate=\"store.validate.store.address\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.District.$invalid && storeForm.District.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"store.district\"></label><div class=\"col-md-8\"><ui-select \nng-model=\"vm.store.District\" theme=\"bootstrap\" ng-change=\"vm.search()\" name=\"District\" required \nng-disabled=\"vm.Tag == 5\"><ui-select-match placeholder=\"Please select a district...\">{{$select.selected.Name}}\n</ui-select-match><ui-select-choices repeat=\"district.Id as district in vm.districts | filter: $select.search\" \nrefresh-delay=\"0\" minimum-input-length=\"0\"><div ng-bind-html=\"district.Name | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.State.$invalid && storeForm.State.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"store.state\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"State\" class=\"form-control\" ng-model=\"vm.store.State\"><div ng-messages=\"storeForm.State.$error\"><div \nng-message=\"required\" ng-if=\"storeForm.State.$touched\" class=\"help-block\"><span translate=\"store.validate.store.state\">\n</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.PostCode.$invalid && storeForm.PostCode.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"store.postcode\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"PostCode\" class=\"form-control\" ng-pattern=\"/^\\d+$/\" ng-model=\"vm.store.PostCode\"><div \nng-messages=\"storeForm.PostCode.$error\"><div ng-message=\"required\" ng-if=\"storeForm.PostCode.$touched\" \nclass=\"help-block\"><span translate=\"store.validate.store.postcode\"></span></div><div ng-message=\"pattern\" \nng-if=\"storeForm.PostCode.$touched\" class=\"help-block\"><span translate=\"store.validate.store.postcode_format\"></span>\n</div></div></div></div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"store.location\"></label><div class=\"col-md-4 margin-tb\"><input type=\"number\" class=\"form-control\" \nplaceholder=\"Longitude\" ng-model=\"vm.store.Longitude\"></div><div class=\"col-md-4 margin-tb\"><input type=\"number\" \nclass=\"form-control\" placeholder=\"Latitude\" ng-model=\"vm.store.Latitude\"></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.ContactNumber.$invalid && storeForm.ContactNumber.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"store.contact_number\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"ContactNumber\" ng-pattern=\"/^\\d+$/\" class=\"form-control\" ng-model=\"vm.store.ContactNumber\"><div \nng-messages=\"storeForm.ContactNumber.$error\"><div ng-message=\"required\" ng-if=\"storeForm.ContactNumber.$touched\" \nclass=\"help-block\"><span translate=\"store.validate.store.contact_number\"></span></div><div ng-message=\"pattern\" \nng-if=\"storeForm.ContactNumber.$touched\" class=\"help-block\"><span \ntranslate=\"store.validate.store.contact_number_format\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.MobileNumber.$invalid && storeForm.MobileNumber.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"store.mobile_number\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"MobileNumber\" ng-pattern=\"/^\\d+$/\" class=\"form-control\" ng-model=\"vm.store.MobileNumber\"><div \nng-messages=\"storeForm.MobileNumber.$error\"><div ng-message=\"pattern\" ng-if=\"storeForm.MobileNumber.$touched\" \nclass=\"help-block\"><span translate=\"store.validate.store.mobile_number_format\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': storeForm.Email.$invalid && storeForm.Email.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"store.email\"></label><div class=\"col-md-8\"><input type=\"email\" \nname=\"Email\" class=\"form-control\" ng-model=\"vm.store.Email\"><div ng-messages=\"storeForm.Email.$error\"><div \nng-message=\"email\" ng-if=\"storeForm.Email.$touched\" class=\"help-block\" translate=\"store.validate.store.email_invalid\">\n</div></div></div></div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\"></label><div \nclass=\"col-md-8\"><input type=\"checkbox\" name=\"UserBranchDescription\" ng-model=\"vm.store.UseBrandDescription\" \nng-checked=\"vm.store.UseBrandDescription\" ng-disabled=\"vm.store.BrandDescriptionIsEmpty\"><lable \ntranslate=\"store.use_brand_description\"></lable></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"common.description\"></label><div class=\"col-md-8\"><textarea \nname=\"Description\" rows=\"4\" class=\"form-control\" ng-model=\"vm.store.Description\" \nng-disabled=\"vm.store.UseBrandDescription\" maxlength=\"5000\"></textarea></div></div><div class=\"form-group university\" \nstyle=\"display:none\"><label class=\"control-label col-md-3\">Campuse Store</label><div class=\"col-md-1\"><input \ntype=\"checkbox\" id=\"IsUniversityStore\" ng-click=\"vm.ShowCampus()\" name=\"IsUniversityStore\" \nng-model=\"vm.store.IsUniversityStore\"></div></div><div class=\"form-group university\" style=\"display:none\" \nng-class=\"{\'has-error\': storeForm.CampusId.$invalid && storeForm.CampusId.$touched && vm.store.IsUniversityStore== 1}\">\n<label class=\"control-label col-md-3 required\">Campus</label><div class=\"col-md-8\"><select class=\"form-control\" \nid=\"CampusId\" name=\"CampusId\" ng-model=\"vm.store.CampusId\" \nng-options=\"value.CmapusId as value.Name for (key, value) in vm.campusList\" ng-required=\"vm.store.IsUniversityStore\">\n<option style=\"display:none\" value=\"\">select a type</option></select><div ng-messages=\"storeForm.CampusId.$error\"><div \nng-message=\"\" ng-if=\"storeForm.CampusId.$touched\" class=\"help-block\"><span>Campus is required</span></div></div></div>\n</div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.AveragePrice.$invalid && storeForm.AveragePrice.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"store.subscribed_service\"></label><div class=\"col-md-8\"><select \nname=\"AveragePrice\" class=\"form-control\" ng-model=\"vm.averagePrice\"><option value=\"\" disabled=\"disabled\">\nPlease select average price...</option><option value=\"$\">{{\'store.average_price.less_than_20\' | translate}}</option>\n<option value=\"$$\">{{\'store.average_price.between_20_and_50\' | translate}}</option><option value=\"$$$\">\n{{\'store.average_price.greater_than_50\' | translate}}</option></select><div \nng-messages=\"storeForm.AveragePrice.$error\"><div ng-message=\"required\" ng-if=\"storeForm.AveragePrice.$touched\" \nclass=\"help-block\"><span translate=\"store.validate.store.average_price\"></span></div></div></div></div><div \nng-repeat=\"operationHour in vm.store.OperationHours track by $index\" class=\"form-group\" \nng-class=\"{\'has-error\': (storeForm[\'operationHourOpenTime\'+$index].$invalid && storeForm[\'operationHourOpenTime\'+$index].$touched) ||\r\n                                                         (storeForm[\'operationHourCloseTime\'+$index].$invalid && storeForm[\'operationHourCloseTime\'+$index].$touched) ||\r\n                                                         (storeForm[\'operationOpenDay\'+$index].$invalid && storeForm[\'operationOpenDay\'+$index].$touched)}\">\n<label ng-if=\"$index == 0\" class=\"control-label col-md-3 margin-tb\" translate=\"store.operating_hours\"></label><label \nng-if=\"$index != 0\" class=\"control-label col-md-3\"></label><div class=\"col-md-2 margin-tb\"><input type=\"time\" \nname=\"operationHourOpenTime{{$index}}\" placeholder=\"Open hour (HH:MM)\" class=\"form-control\" \nng-model=\"operationHour.OpenHours\" ng-required=\"vm.store.OperationHours.length != 1\" ng-disabled=\"vm.Tag == 5\"><div \nng-messages=\"storeForm[\'operationHourOpenTime\'+$index].$error\"><div ng-message=\"required\" \nng-if=\"storeForm[\'operationHourOpenTime\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"store.validate.store.operating_hours\"></span></div><div ng-message=\"time\" \nng-if=\"storeForm[\'operationHourOpenTime\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"store.validate.store.operating_hours_valid\"></span></div></div></div><div class=\"col-md-2 margin-tb\"><input \ntype=\"time\" name=\"operationHourCloseTime{{$index}}\" placeholder=\"Close hour (HH:MM)\" class=\"form-control\" \nng-model=\"operationHour.CloseHours\" ng-required=\"operationHour.OpenHours || vm.store.OperationHours.length != 1\" \nng-disabled=\"vm.Tag == 5\"><div ng-messages=\"storeForm[\'operationHourCloseTime\'+$index].$error\"><div \nng-message=\"required\" ng-if=\"storeForm[\'operationHourCloseTime\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"store.validate.store.operating_hours\"></span></div><div ng-message=\"time\" \nng-if=\"storeForm[\'operationHourCloseTime\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"store.validate.store.closeting_hours_valid\"></span></div></div></div><div class=\"col-md-2 margin-tb\"><select\n class=\"form-control\" name=\"operationOpenDay{{$index}}\" ng-model=\"operationHour.Day\" \nng-options=\"value.Id as value.Name | translate for (key,value) in vm.daysOfWeek\" \nng-required=\"operationHour.OpenHours || vm.store.OperationHours.length != 1\" ng-disabled=\"vm.Tag == 5\"><option \nvalue=\"\" disabled=\"disabled\">Open day</option></select><div ng-messages=\"storeForm[\'operationOpenDay\'+$index].$error\">\n<div ng-message=\"required\" ng-if=\"storeForm[\'operationOpenDay\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"store.validate.store.operating_hours\"></span></div></div></div><div class=\"col-md-3\"><a \nclass=\"btn btn-danger margin-tl pull-right\" ng-if=\"vm.store.OperationHours.length != 1\" ng-click=\"vm.remove($index)\" \nng-disabled=\"vm.Tag == 5\">Remove</a> <a class=\"btn btn-danger margin-tl pull-right\" \nng-if=\"vm.store.OperationHours.length == 1\" ng-click=\"vm.removeLast()\" ng-disabled=\"vm.Tag == 5\">Remove</a> <a \nclass=\"btn btn-primary margin-tl pull-right\" ng-if=\"vm.store.OperationHours.length == $index+1\" ng-click=\"vm.addNew()\" \nng-disabled=\"vm.Tag == 5\">Add</a></div></div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"store.post_termial_ownership\"></label><div class=\"col-md-7\"><select class=\"form-control\" \nname=\"POSTermialOwnership\" ng-model=\"vm.store.POSTermialOwnership\" \nng-options=\"value.Id as value.Name | translate for (key,value) in vm.POSTermialOwnershipList\"></select></div></div><div\n class=\"form-group\" ng-class=\"{\'has-error\': storeForm.ManagerNumber.$invalid && storeForm.ManagerNumber.$touched}\">\n<label class=\"control-label col-md-3 margin-tb\" translate=\"store.manager_number\"></label><div class=\"col-md-8\"><input \ntype=\"number\" name=\"ManagerNumber\" class=\"form-control\" ng-model=\"vm.store.ManagerNumber\"><div \nng-messages=\"storeForm.ManagerNumber.$error\"><div ng-message=\"required\" ng-if=\"storeForm.ManagerNumber.$touched\" \nclass=\"help-block\" translate=\"store.validate.store.manager_number_required\"></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': storeForm.StaffNumber.$invalid && storeForm.StaffNumber.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"store.staff_number\"></label><div class=\"col-md-8\"><input \ntype=\"number\" name=\"StaffNumber\" class=\"form-control\" ng-model=\"vm.store.StaffNumber\"><div \nng-messages=\"storeForm.StaffNumber.$error\"><div ng-message=\"required\" ng-if=\"storeForm.StaffNumber.$touched\" \nclass=\"help-block\" translate=\"store.validate.store.staff_number_required\"></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': storeForm.Image.$invalid}\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"store.photo\"></label><div class=\"photos-form col-md-8\"><div class=\"upload-controls\"><input type=\"file\" \nclass=\"button\" ngf-select=\"vm.uploadPhoto($files, $invalidFiles)\" name=\"Image\" ngf-pattern=\"\'image/*\'\" \nngf-accept=\"\'image/*\'\" ngf-multiple=\"true\" ngf-allow-dir=\"true\" \nngf-dimensions=\"($width >= 400) && ($height >= 230) && (($width / $height) >= 1.5)\" ng-model=\"vm.temp.Photo\"></div>\n<div><label class=\"note\" translate=\"store.note\"></label></div><div class=\"file-list\"><div \nng-messages=\"storeForm.Image.$error\"><div ng-message=\"dimensions\" ng-if=\"storeForm.Image.$dirty\" class=\"help-block\"><p \ntranslate=\"store.validate.store.photo_dimensions\"></p></div><div ng-message=\"required\" \nng-if=\"storeForm.Image.$touched\" class=\"help-block\" translate=\"store.validate.store.photos\"></div></div><ul \ndnd-list=\"vm.store.Photos\"><li ng-repeat=\"photo in vm.store.Photos\" style=\"font:smaller\"><div class=\"preview-photos\">\n<span class=\"dnd\"></span> <img ng-src=\"{{photo.Path}}\" class=\"thumb\"> <a \nng-click=\"vm.removePhoto(photo, $index, vm.store)\" class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-remove\"></i> \n<span translate=\"Remove\"></span></a></div></li></ul></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.WebCashId.$invalid}\"><label class=\"control-label col-md-3 required margin-tb\" \ntranslate=\"store.web_cash_id\"></label><div class=\"col-md-8\"><input type=\"text\" name=\"WebCashId\" ng-pattern=\"/^\\d+$/\" \nclass=\"form-control\" ng-model=\"vm.store.WebCashId\"><div ng-messages=\"storeForm.WebCashId.$error\"><div \nng-message=\"pattern\" ng-if=\"storeForm.WebCashId.$invalid\" class=\"help-block\"><span \ntranslate=\"store.validate.store.webcash_id\"></span></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"common.NG_MemberId\"></label><div class=\"col-md-8\"><input \ntype=\"text\" class=\"form-control\" name=\"NGMemberId\" ng-model=\"vm.store.NGMemberId\"></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.InstallationDate.$invalid && storeForm.InstallationDate.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"store.installation_date\"></label><div class=\"col-md-8\"><div \nclass=\"input-group\"><input type=\"text\" name=\"InstallationDate\" class=\"form-control\" uib-datepicker-popup \nng-model=\"vm.store.InstallationDate\" is-open=\"vm.expireDatePopup.opened\" datepicker-options=\"vm.dateOptions\" \nng-click=\"vm.openExpireDatePopup()\" close-text=\"Close\" autocomplete=\"off\" ng-disabled=\"vm.Tag == 5\"> <span \nclass=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\" \nng-click=\"vm.openExpireDatePopup()\"></i></button></span></div><div ng-messages=\"storeForm.InstallationDate.$error\"><div\n ng-message=\"date\" ng-if=\"storeForm.InstallationDate.$touched\" class=\"help-block\"><span \ntranslate=\"store.validate.store.install_date\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.ServiceCharge.$invalid && storeForm.ServiceCharge.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"store.service_charge\"></label><div class=\"col-md-8\"><input \ntype=\"number\" name=\"ServiceCharge\" class=\"form-control\" ng-model=\"vm.store.ServiceCharge\" step=\"0.01\"><div \nng-messages=\"storeForm.ServiceCharge.$error\"><div ng-message=\"number\" ng-if=\"storeForm.ServiceCharge.$touched\" \nclass=\"help-block\"><span translate=\"store.validate.store.service_charge_number\"></span></div></div></div></div><div \nng-if=\"vm.isAdmin\"><div class=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" translate=\"store.ali_pay\"></h4>\n</div></div><div class=\"form-group\"><label class=\"control-label col-md-4 margin-tb\" translate=\"store.support_ali_pay\">\n</label><div class=\"col-md-8 margin-tb\"><input type=\"checkbox\" name=\"SupportAliPay\" ng-model=\"vm.store.SupportAliPay\">\n</div></div><div ng-if=\"vm.store.SupportAliPay\" class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.AliPayMDR.$invalid && storeForm.AliPayMDR.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"store.ali_pay_mdr\"></label><div class=\"col-md-8\"><div \nclass=\"input-group\"><input type=\"number\" name=\"AliPayMDR\" class=\"form-control\" ng-model=\"vm.store.AliPayMDR\" min=\"0\" \nmax=\"100\" required> <span class=\"input-group-addon\" id=\"basic-addon1\">%</span></div><div \nng-messages=\"storeForm.AliPayMDR.$error\"><div ng-message=\"required\" ng-if=\"storeForm.AliPayMDR.$touched\" \nclass=\"help-block\"><span translate=\"store.validate.store.ali_pay_mdr\"></span></div><div ng-message=\"number\" \nng-if=\"storeForm.AliPayMDR.$touched\" class=\"help-block\"><span translate=\"store.validate.store.ali_pay_mdr_number\">\n</span></div><div ng-message=\"min\" ng-if=\"storeForm.AliPayMDR.$touched\" class=\"help-block\"><span \ntranslate=\"store.validate.store.ali_pay_mdr_number\"></span></div><div ng-message=\"max\" \nng-if=\"storeForm.AliPayMDR.$touched\" class=\"help-block\"><span translate=\"store.validate.store.ali_pay_mdr_number\">\n</span></div></div></div></div><div ng-if=\"vm.store.SupportAliPay\" class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.AliPayCode.$invalid && storeForm.AliPayCode.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"store.ali_pay_code\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"AliPayCode\" class=\"form-control\" ng-model=\"vm.store.AliPayCode\" required><div \nng-messages=\"storeForm.AliPayCode.$error\"><div ng-message=\"required\" ng-if=\"storeForm.AliPayCode.$touched\" \nclass=\"help-block\"><span translate=\"store.validate.store.ali_pay_code\"></span></div></div></div></div><div \nng-if=\"vm.store.SupportAliPay\" class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.AliPayKey.$invalid && storeForm.AliPayKey.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"store.ali_pay_key\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"AliPayKey\" class=\"form-control\" ng-model=\"vm.store.AliPayKey\" required><div \nng-messages=\"storeForm.AliPayKey.$error\"><div ng-message=\"required\" ng-if=\"storeForm.AliPayKey.$touched\" \nclass=\"help-block\"><span translate=\"store.validate.store.ali_pay_key\"></span></div></div></div></div><div \nng-if=\"vm.store.SupportAliPay\" class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.OnboardingDate.$invalid && storeForm.OnboardingDate.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"store.onboarding_date\"></label><div class=\"col-md-8\"><div \nclass=\"input-group\"><input type=\"text\" name=\"OnboardingDate\" class=\"form-control\" uib-datepicker-popup \nng-model=\"vm.store.OnboardingDate\" is-open=\"vm.onboardingDatePopup.opened\" datepicker-options=\"vm.onboardDateOptions\" \nng-click=\"vm.openOnboardingDatePopup()\" close-text=\"Close\" autocomplete=\"off\"> <span class=\"input-group-btn\"><button \ntype=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\" ng-click=\"vm.openOnboardingDatePopup()\">\n</i></button></span></div><div ng-messages=\"storeForm.OnboardingDate.$error\"><div ng-message=\"required\" \nng-if=\"storeForm.OnboardingDate.$touched\" class=\"help-block\"><span translate=\"store.validate.store.onboarding_date\">\n</span></div><div ng-message=\"date\" ng-if=\"storeForm.OnboardingDate.$touched\" class=\"help-block\"><span \ntranslate=\"store.validate.store.onboarding_date_validate\"></span></div></div></div></div><div \nng-if=\"vm.store.SupportAliPay\" class=\"form-group\" \nng-class=\"{\'has-error\': storeForm.OnboardingAllowance.$invalid && storeForm.OnboardingAllowance.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"store.onboarding_allowance\"></label><div class=\"col-md-8\"><input \ntype=\"number\" name=\"OnboardingAllowance\" class=\"form-control\" ng-model=\"vm.store.OnboardingAllowance\" min=\"0\"><div \nng-messages=\"storeForm.OnboardingAllowance.$error\"><div ng-message=\"required\" \nng-if=\"storeForm.OnboardingAllowance.$touched\" class=\"help-block\"><span \ntranslate=\"store.validate.store.onboarding_allowance\"></span></div><div ng-message=\"min\" \nng-if=\"storeForm.OnboardingAllowance.$touched\" class=\"help-block\"><span \ntranslate=\"store.validate.store.onboarding_allowance_min\"></span></div><div ng-message=\"number\" \nng-if=\"storeForm.OnboardingAllowance.$touched\" class=\"help-block\"><span \ntranslate=\"store.validate.store.onboarding_allowance_validate\"></span></div></div></div></div></div></div><div \nclass=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button \nclass=\"btn btn-primary\" type=\"submit\" translate=\"common.action.save\"></button></div></form></div></div></div></div><div\n class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowAddUserDialog\" class=\"modal fade\" \ntabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowAddUserDialog = false\"><span \naria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" \nid=\"modal-title\" translate=\"store.terminal.title\"></h3></div><form name=\"storeUserForm\" class=\"form-horizontal\" \nng-submit=\"vm.saveTerminal()\"><div class=\"modal-body\"><div class=\"form-group\"><label class=\"control-label col-md-3\" \ntranslate=\"common.terminal\"></label><div class=\"col-md-8\"><input type=\"text\" class=\"form-control\" \nng-model=\"vm.terminal.POSId\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"common.terminal_type\"></label><div class=\"col-md-8\"><select \nclass=\"form-control\" ng-model=\"vm.terminal.Type\"><option value=\"\" hidden>Select device type</option><option \nvalue=\"KiplePOS\">Kiple POS</option><option value=\"MerchantPhone\">Merchant Phone</option></select></div></div></div><div\n class=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.viewConfig.ShowAddUserDialog = false\" \ntranslate=\"common.action.cancel\"></a> <button type=\"submit\" class=\"btn btn-primary\" translate=\"common.action.save\">\n</button></div></form></div></div></div></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowManagerDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" \nclass=\"close\" ng-click=\"vm.viewConfig.ShowManagerDialog = false\"><span aria-hidden=\"true\">&times;</span><span \nclass=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\" translate=\"store.manager.add_new\">\n</h3></div><form name=\"storeUserForm\" class=\"form-horizontal\" ng-submit=\"vm.saveManager()\"><div class=\"modal-body\"><div\n class=\"form-group\"><label class=\"control-label col-md-3\" translate=\"store.manager.pin\"></label><div class=\"col-md-8\">\n<input type=\"text\" class=\"form-control\" ng-model=\"vm.manager.Pin\" readonly=\"readonly\"></div></div></div><div \nclass=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.viewConfig.ShowManagerDialog = false\" \ntranslate=\"common.action.cancel\"></a> <button type=\"submit\" class=\"btn btn-primary\" translate=\"common.action.save\">\n</button></div></form></div></div></div></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.qrcodeDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-md\"><div \nclass=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.qrcodeDialog = false\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button>\n<h3 class=\"modal-title center\" id=\"modal-title\">QRCode</h3></div><div id=\"qrcodeBody\" class=\"modal-body center\"><div \nclass=\"form-group\"><img src=\"{{vm.qrcode}}\"></div><div class=\"form-group\"><label translate=\"store.table.store_name_qr\">\n</label><label>{{vm.storeName}}</label></div></div><div class=\"modal-footer\"><a class=\"btn btn-primary\" \nng-click=\"vm.print()\"><i class=\"glyphicon glyphicon-print\"></i> <span translate=\"common.action.print\"></span></a></div>\n</div></div></div></div></div>");
$templateCache.put("app/voucher/voucher.html","<h1 class=\"page-header\" translate=\"voucher.title\"></h1><style>.mt-35 {\r\n        margin-top: 35px !important;\r\n    }\n</style><div id=\"vouchers\" class=\"col-md-12\"><div class=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div\n class=\"col-md-3 margin-tb\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.criteria.Keyword\" \nng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter the voucher\'s name\"></div><div class=\"col-md-3 margin-tb\">\n<input type=\"text\" class=\"form-control\" ng-model=\"vm.criteria.KeywordCampaignName\" \nng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter the Campaign\'s name\"></div><div class=\"col-md-3 margin-tb\">\n<select ng-model=\"vm.criteria.Category\" ng-change=\"vm.search()\" class=\"form-control\" \nng-options=\"value.Id as value.Name for (key, value) in vm.categories\"><option value=\"\">All Category</option></select>\n</div><div class=\"col-md-3 margin-tb\" ng-if=\"vm.isAdmin\"><ui-select ng-model=\"vm.criteria.MerchantId\" \ntheme=\"bootstrap\" ng-change=\"vm.search()\" ng-keyup=\"vm.loadMerchant($select.search)\"><ui-select-match \nplaceholder=\"Enter the merchant\'s name\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh=\"vm.loadMerchant($select.search)\" \nrefresh-delay=\"0\" minimum-input-length=\"3\"><div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div><div class=\"col-md-3 col-xs-12 dropdown dropdown-date margin-tb\"><label \nclass=\"control-label\">Sale Start Date</label><a class=\"dropdown-toggle\" id=\"dropdownSaleStartDate\" role=\"button\" \ndata-toggle=\"dropdown\" data-target=\".dropdown-Startdate\" href=\"#\"><div class=\"input-group date\"><input type=\"text\" \nclass=\"form-control\" readonly=\"readonly\" data-date-time-input=\"YYYY-MM-DD\" placeholder=\"YYYY-MM-DD\" \ndata-ng-model=\"vm.criteria.SaleStartDate\"> <span class=\"input-group-addon\"><i class=\"glyphicon glyphicon-calendar\"></i>\n</span></div></a><ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\"><datetimepicker \ndata-ng-model=\"vm.criteria.SaleStartDate\" data-on-set-time=\"vm.search()\" \ndata-datetimepicker-config=\"{ dropdownSelector: \'#dropdownSaleStartDate\', modelType: \'YYYY-MM-DD\', minView: \'day\' }\">\n</datetimepicker></ul></div><div class=\"col-md-3 col-xs-12 dropdown dropdown-date margin-tb\"><label \nclass=\"control-label\">Sale End Date</label><a class=\"dropdown-toggle\" id=\"dropdownSaleEndDate\" role=\"button\" \ndata-toggle=\"dropdown\" data-target=\".dropdown-Enddate\" href=\"#\"><div class=\"input-group date\"><input type=\"text\" \nclass=\"form-control\" readonly=\"readonly\" data-date-time-input=\"YYYY-MM-DD\" placeholder=\"YYYY-MM-DD\" \ndata-ng-model=\"vm.criteria.SaleEndDate\"> <span class=\"input-group-addon\"><i class=\"glyphicon glyphicon-calendar\"></i>\n</span></div></a><ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\"><datetimepicker \ndata-ng-model=\"vm.criteria.SaleEndDate\" data-on-set-time=\"vm.search()\" \ndata-datetimepicker-config=\"{ dropdownSelector: \'#dropdownSaleEndDate\', modelType: \'YYYY-MM-DD\', minView: \'day\' }\">\n</datetimepicker></ul></div><div class=\"col-md-2\" style=\"padding-top:2%\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span \ntranslate=\"common.action.reset\"></span></a></div><div ng-class=\"{\'col-md-3\': !vm.isAdmin, \'col-md-2 \': vm.isAdmin}\" \nstyle=\"padding-top:2%\"><a show-permissions=\"[\'CREATE_PRODUCT\']\" class=\"btn btn-primary pull-right margin-tl\" \nng-click=\"vm.add()\"><i class=\"glyphicon glyphicon-plus\"></i> <span translate=\"common.action.add\"></span></a></div>\n</div></div><div class=\"form-group\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered\">\n<thead><tr><th>#</th><th translate=\"voucher.photo\"></th><th translate=\"voucher.name\"></th><th translate=\"Voucher ID\">\n</th><th translate=\"Campaign Name\"></th><th translate=\"Targeted Merchant\"></th><th translate=\"Targeted User\"></th><th \ntranslate=\"Kiple Subsidy\"></th><th translate=\"Merchant Subsidy\"></th><th translate=\"Sale Start Date\"></th><th \ntranslate=\"Sale End Date\"></th><th translate=\"voucher.price\"></th><th translate=\"voucher.amount\"></th><th \ntranslate=\"voucher.expire_date\"></th><th translate=\"common.action.title\"></th></tr></thead><tbody><tr \nng-repeat=\"voucher in vm.vouchers\"><td class=\"center\">{{$index + 1}}</td><td><img class=\"voucher_photo\" \nng-if=\"voucher.Photo\" ng-src=\"{{voucher.Photo}}\"></td><td>{{voucher.Name}}</td><td>{{voucher.Id}}</td><td>\n{{voucher.CampaignName}}</td><td>{{voucher.MerchantNameList}}</td><td>{{voucher.UniversityId}}</td><td class=\"number\">\n{{voucher.KipleSubsidyAmount}}<span ng-if=\"voucher.Subsidy == \'Percentage\'\">%</span></td><td class=\"number\">\n{{voucher.MerchantSubsidyAmount}}<span ng-if=\"voucher.Subsidy == \'Percentage\'\">%</span></td><td>\n{{voucher.SaleStartDate|date: \'yyyy-MM-dd h:mm:ss a\' | lowercase}}</td><td>\n{{voucher.SaleEnddate|date: \'yyyy-MM-dd h:mm:ss a\' | lowercase}}</td><td ng-if=\"voucher.Price == 0\" class=\"number\">\nFREE VOUCHER</td><td ng-if=\"voucher.Price > 0\" class=\"number\">{{voucher.Price}}<p><del>({{voucher.OldPrice}})</del></p>\n</td><td class=\"number\">{{voucher.Amount}}<span ng-if=\"voucher.DiscountType == \'Percentage\'\">%</span></td><td>\n{{voucher.ExpireDate | date: \'yyyy/MM/dd\'}}</td><td class=\"center\"><a show-permissions=\"[\'EDIT_PRODUCT\']\" \nclass=\"btn btn-default margin-tl\" title=\"Edit\" ng-click=\"vm.edit(voucher.Id)\"><i class=\"glyphicon glyphicon-edit\"></i> \n</a><a show-permissions=\"[\'DELETE_PRODUCT\']\" class=\"btn btn-danger margin-tl\" mwl-confirm title=\"Delete voucher\" \nmessage=\"Are you really <b>sure</b> you want to delete <b>{{voucher.Name}}</b> voucher?\" confirm-text=\"OK\" \ncancel-text=\"Cancel\" on-confirm=\"vm.delete(voucher.Id)\" on-cancel=\"\" confirm-button-type=\"danger\" \ncancel-button-type=\"default\"><i class=\"glyphicon glyphicon-remove\"></i> </a><a show-permissions=\"[\'PUBLISH_PRODUCT\']\" \ntitle=\"Unpublish\" ng-if=\"voucher.IsPublish == 1\" class=\"btn btn-danger margin-tl\" ng-click=\"vm.Unpublish(voucher.Id)\">\n<i class=\"glyphicon glyphicon-cloud-download\"></i> </a><a show-permissions=\"[\'PUBLISH_PRODUCT\']\" title=\"Publish\" \nng-if=\"voucher.IsPublish == 0\" class=\"btn btn-primary margin-tl\" ng-click=\"vm.Publish(voucher.Id)\"><i \nclass=\"glyphicon glyphicon-cloud-upload\"></i></a></td></tr></tbody></table></div><ul uib-pagination \ntotal-items=\"vm.totalItems\" ng-change=\"vm.search()\" ng-model=\"vm.currentPage\" items-per-page=\"vm.criteria.Length\" \nmax-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div><div \nclass=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" tabindex=\"-1\" \nrole=\"dialog\"><div class=\"modal-dialog modal-lg\"><form name=\"VoucherForm\" class=\"form-horizontal\" \nng-submit=\"vm.save()\" novalidate id=\"VoucherForm\"><div class=\"modal-content my-content\"><div class=\"modal-header\">\n<button type=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowDialog = false\"><span aria-hidden=\"true\">&times;</span>\n<span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\">Voucher Detail</h3></div>\n<div class=\"modal-body\"><div class=\"form-group\" ng-if=\"vm.isAdmin\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"University\"></label><div class=\"col-md-8\"><select class=\"form-control\" id=\"UniversityId\" \nname=\"UniversityId\" ng-model=\"vm.voucher.UniversityId\" ng-change=\"vm.UniversityIdClick()\"><option value=\"\">\n--Select University--</option><option ng-repeat=\"university in vm.UniversityItems\" value=\"{{university.UniversityId}}\">\n{{university.UniversityId}}</option></select></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"Under University all merchant\"></label><div class=\"col-md-8\" \nstyle=\"padding-top: 7px\"><input type=\"checkbox\" name=\"IsUniversity\" ng-model=\"vm.voucher.IsUniversity\" \nng-change=\"vm.IsUniversityChanged()\" ng-disabled=\"vm.IsAlluniversity\"></div></div><div class=\"form-group\" \nng-if=\"vm.isAdmin\"><label class=\"control-label col-md-3 margin-tb\" translate=\"common.merchant\"></label><div \nclass=\"col-md-8\"><ui-select ng-model=\"vm.voucher.MerchantId\" theme=\"bootstrap\" ng-change=\"vm.search()\" \nng-keyup=\"vm.loadMerchant1($select.search)\" ng-disabled=\"vm.voucher.IsUniversity\" name=\"MerchantId\"><ui-select-match \nplaceholder=\"Enter the merchant\'s name\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh-delay=\"0\" minimum-input-length=\"0\">\n<div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><div \nstyle=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div></div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"University User or Normal User\"></label><div class=\"col-md-8\" style=\"padding-top: 7px\"><input \ntype=\"checkbox\" name=\"UniversityUser\" ng-model=\"vm.voucher.UserCategory\" ng-disabled=\"vm.IsUserCatetory\"></div></div>\n<div class=\"form-group\" ng-class=\"{\'has-error\': VoucherForm.Name.$invalid && VoucherForm.Name.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"voucher.name\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"Name\" class=\"form-control\" ng-model=\"vm.voucher.Name\" required><div \nng-messages=\"VoucherForm.Name.$error\"><div ng-message=\"required\" ng-if=\"VoucherForm.Name.$touched\" class=\"help-block\">\n<span translate=\"voucher.errors.name_required\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': VoucherForm.Description.$invalid && VoucherForm.Description.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"voucher.description\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"Description\" class=\"form-control\" ng-model=\"vm.voucher.Description\" required><div \nng-messages=\"VoucherForm.Description.$error\"><div ng-message=\"required\" ng-if=\"VoucherForm.Description.$touched\" \nclass=\"help-block\"><span translate=\"voucher.errors.description_required\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"Campaign Name\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"CampaignName\" class=\"form-control\" ng-model=\"vm.voucher.CampaignName\"><div \nng-messages=\"VoucherForm.Name.$error\"><div ng-message=\"required\" ng-if=\"VoucherForm.CampaignName.$touched\" \nclass=\"help-block\"></div></div></div></div><div class=\"row form-group\"><div class=\"col-lg-3 text-right\"><label \nclass=\"control-label required margin-tb mt-35\" translate=\"voucher.sale_start_date\"></label></div><div class=\"col-lg-3\">\n<div class=\"input-group mt-35\"><input type=\"text\" name=\"SaleStartDate\" class=\"form-control\" uib-datepicker-popup \nng-model=\"vm.voucher.SaleStartDate\" is-open=\"vm.saleStartDatePopup.opened\" \ndatepicker-options=\"vm.dateOptionsStartDate\" close-text=\"Close\" required autocomplete=\"off\" \nng-click=\"vm.openSaleStartDatePopup()\" ng-change=\"vm.SaleDateChanged()\"> <span class=\"input-group-btn\"><button \ntype=\"button\" class=\"btn btn-default\" ng-click=\"vm.openSaleStartDatePopup()\"><i class=\"glyphicon glyphicon-calendar\">\n</i></button></span></div><div ng-messages=\"VoucherForm.SaleStartDate.$error\"><div ng-message=\"required\" \nng-if=\"VoucherForm.SaleStartDate.$touched\" class=\"help-block\"><span \ntranslate=\"voucher.errors.sale_start_date_required\"></span></div><div ng-message=\"date\" \nng-if=\"VoucherForm.SaleStartDate.$touched\" class=\"help-block\"><span translate=\"voucher.errors.sale_start_date_valid\">\n</span></div></div></div><div class=\"col-lg-2 text-right\"><label class=\"control-label required margin-tb mt-35\" \ntranslate=\"Start Time\"></label></div><div class=\"col-lg-3\"><div class=\"input-group\"><div name=\"SaleStartTime\" \nuib-timepicker ng-model=\"vm.SaleStartTime\" show-meridian=\"false\"></div></div></div></div><div class=\"row form-group\" \nng-class=\"{\'has-error\': VoucherForm.SaleEnddate.$invalid && VoucherForm.SaleEnddate.$touched}\"><div \nclass=\"col-lg-3 text-right\"><label class=\"control-label required margin-tb mt-35\" translate=\"voucher.sale_end_date\">\n</label></div><div class=\"col-lg-3\"><div class=\"input-group mt-35\"><input type=\"text\" name=\"SaleEnddate\" \nclass=\"form-control\" uib-datepicker-popup ng-model=\"vm.voucher.SaleEnddate\" is-open=\"vm.saleEndDatePopup.opened\" \ndatepicker-options=\"vm.dateOptionsEndDate\" close-text=\"Close\" required autocomplete=\"off\" \nng-click=\"vm.openSaleEndDatePopup()\" ng-change=\"vm.SaleDateChanged()\"> <span class=\"input-group-btn\"><button \ntype=\"button\" class=\"btn btn-default\" ng-click=\"vm.openSaleEndDatePopup()\"><i class=\"glyphicon glyphicon-calendar\"></i>\n</button></span></div><div ng-messages=\"VoucherForm.SaleEnddate.$error\"><div ng-message=\"required\" \nng-if=\"VoucherForm.SaleEnddate.$touched\" class=\"help-block\"><span translate=\"voucher.errors.sale_end_date_required\">\n</span></div><div ng-message=\"date\" ng-if=\"VoucherForm.SaleEnddate.$touched\" class=\"help-block\"><span \ntranslate=\"voucher.errors.sale_end_date_valid\"></span></div></div></div><div class=\"col-lg-2 text-right\"><label \nclass=\"control-label required margin-tb mt-35\" translate=\"End Time\"></label></div><div class=\"col-lg-3\"><div \nclass=\"input-group\"><div name=\"SaleEndTime\" uib-timepicker ng-model=\"vm.SaleEndTime\" show-meridian=\"false\"></div></div>\n</div></div><div class=\"row form-group\"><div class=\"col-lg-3 text-right\"><label \nclass=\"control-label required margin-tb mt-35\" translate=\"Expire Date\"></label></div><div class=\"col-lg-3\"><div \nclass=\"input-group mt-35\"><input type=\"text\" name=\"ExpireDate\" class=\"form-control\" uib-datepicker-popup \nng-model=\"vm.voucher.ExpireDate\" is-open=\"vm.expireDatePopup.opened\" datepicker-options=\"vm.dateOptions\" \nclose-text=\"Close\" required autocomplete=\"off\" ng-click=\"vm.openExpireDatePopup()\" ng-change=\"vm.SaleDateChanged()\"> \n<span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openExpireDatePopup()\"><i \nclass=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"VoucherForm.ExpireDate.$error\"><div \nng-message=\"required\" ng-if=\"VoucherForm.ExpireDate.$touched\" class=\"help-block\"><span \ntranslate=\"voucher.errors.expire_date_required\"></span></div><div ng-message=\"date\" \nng-if=\"VoucherForm.ExpireDate.$touched\" class=\"help-block\"><span translate=\"voucher.errors.expire_date_valid\"></span>\n</div><div ng-message=\"checkError\" ng-if=\"VoucherForm.ExpireDate.$touched\" class=\"help-block\"><span \ntranslate=\"voucher.errors.expire_date_check_error\"></span></div></div></div><div class=\"col-lg-2 text-right\"><label \nclass=\"control-label required margin-tb mt-35\" translate=\"Expire Time\"></label></div><div class=\"col-lg-3\"><div \nclass=\"input-group\"><div name=\"ExpireDateTime\" uib-timepicker ng-model=\"vm.ExpireDateTime\" show-meridian=\"false\"></div>\n</div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': VoucherForm.OldPrice.$invalid && VoucherForm.OldPrice.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"voucher.old_price\"></label><div class=\"col-md-8\"><input \ntype=\"number\" name=\"OldPrice\" class=\"form-control\" ng-model=\"vm.voucher.OldPrice\" step=\"0.01\" required \nng-change=\"vm.calculateAmount()\"><div ng-messages=\"VoucherForm.OldPrice.$error\"><div ng-message=\"required\" \nng-if=\"VoucherForm.OldPrice.$touched\" class=\"help-block\"><span translate=\"voucher.errors.old_price_required\"></span>\n</div><div ng-message=\"number\" ng-if=\"VoucherForm.OldPrice.$touched\" class=\"help-block\"><span \ntranslate=\"voucher.errors.old_price_number\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': VoucherForm.Price.$invalid && VoucherForm.Price.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"voucher.price\"></label><div class=\"col-md-8\"><input \ntype=\"number\" name=\"Price\" class=\"form-control\" ng-model=\"vm.voucher.Price\" step=\"0.01\" required \nng-change=\"vm.calculateAmount()\"><div ng-messages=\"VoucherForm.Price.$error\"><div ng-message=\"required\" \nng-if=\"VoucherForm.Price.$touched\" class=\"help-block\"><span translate=\"voucher.errors.price_required\"></span></div><div\n ng-message=\"number\" ng-if=\"VoucherForm.Price.$touched\" class=\"help-block\"><span \ntranslate=\"voucher.errors.price_number\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': VoucherForm.Subsidy.$invalid && VoucherForm.Subsidy.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"Subsidy\"></label><div class=\"col-md-8\"><select \nng-model=\"vm.voucher.Subsidy\" class=\"form-control\" name=\"Subsidy\" required ng-click=\"vm.SubsidyAmount()\" \nng-options=\"value.id as value.name for (key, value) in vm.Subsidy\"></select><div \nng-messages=\"VoucherForm.Subsidy.$error\"><div ng-message=\"required\" ng-if=\"VoucherForm.Subsidy.$touched\" \nclass=\"help-block\"><span translate=\"Please Select voucher Subsidy type\"></span></div></div></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': VoucherForm.MerchantSubsidyAmount.$invalid && VoucherForm.MerchantSubsidyAmount.$touched}\">\n<label class=\"control-label col-md-3 required margin-tb\" translate=\"Merchant Subsidy Amount\"></label><div \nclass=\"col-md-8\"><div ng-class=\"{\'input-group\': vm.voucher.Subsidy == \'Percentage\'}\"><input type=\"number\" \nname=\"MerchantSubsidyAmount\" class=\"form-control\" ng-model=\"vm.voucher.MerchantSubsidyAmount\" required \nng-keyup=\"vm.calculateSubsidyAmount()\"> <span class=\"input-group-addon\" ng-if=\"vm.voucher.Subsidy == \'Percentage\'\">%\n</span></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': VoucherForm.KipleSubsidyAmount.$invalid && VoucherForm.KipleSubsidyAmount.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"Kiple Subsidy Amount\"></label><div class=\"col-md-8\"><div \nng-class=\"{\'input-group\': vm.voucher.Subsidy == \'Percentage\'}\"><input type=\"number\" name=\"KipleSubsidyAmount\" \nclass=\"form-control\" ng-model=\"vm.voucher.KipleSubsidyAmount\" disabled=\"disabled\"> <span class=\"input-group-addon\" \nng-if=\"vm.voucher.Subsidy == \'Percentage\'\">%</span></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': VoucherForm.DiscountType.$invalid && VoucherForm.DiscountType.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"Discount Type (Display)\"></label><div class=\"col-md-8\">\n<select ng-model=\"vm.voucher.DiscountType\" class=\"form-control\" name=\"DiscountType\" required \nng-change=\"vm.calculateAmount()\" ng-options=\"value.id as value.name for (key, value) in vm.discountType\"></select><div \nng-messages=\"VoucherForm.DiscountType.$error\"><div ng-message=\"required\" ng-if=\"VoucherForm.DiscountType.$touched\" \nclass=\"help-block\"><span translate=\"voucher.errors.discount_type_required\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': VoucherForm.Amount.$invalid && VoucherForm.Amount.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"Discount Value/Price (Display)\"></label><div \nclass=\"col-md-8\"><div ng-class=\"{\'input-group\': vm.voucher.DiscountType == \'Percentage\'}\"><input type=\"number\" \nname=\"Amount\" class=\"form-control\" ng-value=\"vm.voucher.Amount\" disabled=\"disabled\"> <span class=\"input-group-addon\" \nng-if=\"vm.voucher.DiscountType == \'Percentage\'\">%</span></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"voucher.photo\"></label><div class=\"col-md-8\"><div \nclass=\"voucherForm-image\" ng-class=\"{\'has-error\': VoucherForm.Photo.$invalid && VoucherForm.Photo.$touched}\"><input \ntype=\"text\" class=\"form-control\" ng-model=\"vm.voucher.Photo\" ng-hide=\"true\" name=\"Photo\"><div upload-control \nclass=\"upload-control image-uploader voucher-image\" on-file-selected=\"vm.onVoucherPhotoSelected($files, $control)\" \nelement-loading=\"vm.loading.UploadVoucherImage\"><input type=\"file\" accept=\".jpeg, .jpg, .png\"><div \nclass=\"image-wrapper\"><img id=\"photo\" ng-if=\"vm.voucher.Photo\" ng-src=\"{{vm.voucher.Photo}}\"> <img id=\"photo\" \nng-if=\"!vm.voucher.Photo\" src=\"https://s3-ap-southeast-1.amazonaws.com/kiple-files/voucher/placeholder.png\"></div>\n</div><div><label class=\"note\" translate=\"voucher.note\"></label></div><button type=\"button\" class=\"btn-delete-photo\" \nng-click=\"vm.deletePhoto()\" ng-hide=\"vm.disabledDeletePhoto\"><span class=\"glyphicon glyphicon-trash\"></span></button>\n</div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': VoucherForm.TermsAndConditions.$invalid && VoucherForm.TermsAndConditions.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"voucher.terms_and_conditions\"></label><div class=\"col-md-8\">\n<summernote class=\"form-control\" ng-model=\"vm.voucher.TermsAndConditions\" config=\"vm.summernoteOptions\"></summernote>\n</div></div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"voucher.categories\">\n</label><div class=\"col-md-8\"><ui-select multiple=\"multiple\" ng-model=\"vm.voucher.Categories\" theme=\"bootstrap\" \nclose-on-select=\"false\"><ui-select-match placeholder=\"Select categories ...\">{{$item.Name}}</ui-select-match>\n<ui-select-choices repeat=\"category.Id as category in vm.categories\"><div ng-bind=\"category.Name\"></div>\n</ui-select-choices></ui-select></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': VoucherForm.MaxQuantity.$invalid && VoucherForm.MaxQuantity.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"voucher.max_quantity\"></label><div class=\"col-md-8\"><div \nclass=\"input-group\"><input type=\"number\" name=\"MaxQuantity\" class=\"form-control\" ng-model=\"vm.voucher.MaxQuantity\"> \n<span class=\"input-group-addon\">(Unlimited = 0)</span></div><div ng-messages=\"VoucherForm.MaxQuantity.$error\"><div \nng-message=\"number\" ng-if=\"VoucherForm.MaxQuantity.$touched\" class=\"help-block\"><span \ntranslate=\"voucher.errors.max_quantity_number\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': VoucherForm.MaxQuantityUserCanBuy.$invalid && VoucherForm.MaxQuantityUserCanBuy.$touched}\">\n<label class=\"control-label col-md-3 margin-tb\" translate=\"voucher.max_quantity_user_can_buy\"></label><div \nclass=\"col-md-8\"><div class=\"input-group\"><input type=\"number\" name=\"MaxQuantityUserCanBuy\" class=\"form-control\" \nng-model=\"vm.voucher.MaxQuantityUserCanBuy\"> <span class=\"input-group-addon\">(Unlimited = 0)</span></div><div \nng-messages=\"VoucherForm.MaxQuantityUserCanBuy.$error\"><div ng-message=\"number\" \nng-if=\"VoucherForm.MaxQuantityUserCanBuy.$touched\" class=\"help-block\"><span \ntranslate=\"voucher.errors.max_quantity_user_can_buy_number\"></span></div></div></div></div><div class=\"form-group\">\n<label class=\"control-label col-md-3 margin-tb\" translate=\"voucher.is_exclude_from_app\"></label><div class=\"col-md-8\" \nstyle=\"padding-top: 7px\"><input type=\"checkbox\" name=\"IsExcludeFromApp\" ng-model=\"vm.voucher.IsExcludeFromApp\"></div>\n</div></div><div class=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.cancel()\" \ntranslate=\"common.action.cancel\"></a> <button type=\"submit\" class=\"btn btn-primary\" translate=\"common.action.save\">\n</button></div></div></form></div></div></div></div>");
$templateCache.put("app/product/product.detail.html","<h1 class=\"page-header\"><span>{{vm.pageHeader | translate}}</span></h1><div id=\"product\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><ul class=\"nav nav-tabs\"><li class=\"active\"><a data-toggle=\"tab\" href=\"#information\" \nid=\"informationTab\">Information</a></li><li><a data-toggle=\"tab\" href=\"#options\" id=\"optionsTab\">Options</a></li></ul>\n<div class=\"tab-content\"><div id=\"information\" class=\"tab-pane fade in active\"><form name=\"productForm\" \nclass=\"form-horizontal\" novalidate id=\"productForm\"><br><div class=\"row\"><div class=\"form-group col-md-6\" \nng-class=\"{\'has-error\': productForm.OwnerId.$invalid && productForm.OwnerId.$touched}\" ng-if=\"vm.isAdmin\"><label \nclass=\"control-label col-md-4 required\" translate=\"common.merchant\"></label><div class=\"col-md-8\"><ui-select \nng-model=\"vm.product.OwnerId\" theme=\"bootstrap\" ng-change=\"vm.merchantChanged()\" required name=\"OwnerId\">\n<ui-select-match placeholder=\"Enter the merchant\'s name\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh=\"vm.loadMerchant($select.search)\" \nrefresh-delay=\"0\" minimum-input-length=\"0\"><div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select><div ng-messages=\"productForm.OwnerId.$error\"><div ng-message=\"required\" \nng-if=\"productForm.OwnerId.$touched\" class=\"help-block\"><span translate=\"product.validate.owner_id\"></span></div></div>\n</div></div><div class=\"form-group col-md-6\" ng-if=\"!vm.isAdmin\"><label class=\"control-label col-md-4\" \ntranslate=\"common.merchant\"></label><div class=\"col-md-8\"><input type=\"text\" class=\"form-control\" \nvalue=\"{{vm.merchantName}}\" disabled=\"disabled\"></div></div><div class=\"form-group col-md-6\"><label \nclass=\"control-label col-md-4\" translate=\"product.stores\"></label><div class=\"col-md-8\"><ui-select multiple=\"multiple\" \nng-model=\"vm.product.StoreIds\" theme=\"bootstrap\" close-on-select=\"true\"><ui-select-match \nplaceholder=\"Select stores...\">{{$item.FullName}}</ui-select-match><ui-select-choices \nrepeat=\"store.Id as store in vm.stores | filter:$select.search\"><div ng-bind=\"store.FullName\"></div>\n</ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"form-group col-md-6\" \nng-class=\"{\'has-error\': productForm.Name.$invalid && productForm.Name.$touched}\"><label \nclass=\"control-label col-md-4 required\" translate=\"product.name\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"Name\" class=\"form-control\" ng-model=\"vm.product.Name\" required><div ng-messages=\"productForm.Name.$error\"><div \nng-message=\"required\" ng-if=\"productForm.Name.$touched\" class=\"help-block\"><span translate=\"product.validate.name\">\n</span></div></div></div></div><div class=\"form-group col-md-6\" ng-if=\"vm.product.OwnerId\" \nng-class=\"{\'has-error\': productForm.Sku.$invalid && productForm.Sku.$touched}\"><label class=\"control-label col-md-4\" \ntranslate=\"product.sku\"></label><div class=\"col-md-8\"><input type=\"text\" name=\"Sku\" class=\"form-control\" \nng-model=\"vm.product.Sku\" is-sku-available=\"vm.product.OwnerId,vm.product.Id\"><div \nng-messages=\"productForm.Sku.$error\"><div ng-message=\"isSkuAvailable\" ng-if=\"productForm.Sku.$touched\" \nclass=\"help-block\"><span translate=\"product.validate.sku_existed\"></span></div></div></div></div></div><div \nclass=\"row\"><div class=\"form-group col-md-6\"><label class=\"control-label col-md-4\" translate=\"product.description\">\n</label><div class=\"col-md-8\"><textarea name=\"Description\" class=\"form-control\" ng-model=\"vm.product.Description\">\n</textarea></div></div><div class=\"form-group col-md-6\"><div class=\"row\"><label class=\"control-label col-md-4\" \ntranslate=\"product.tags\"></label><div class=\"col-md-8\"><ui-select multiple=\"multiple\" ng-model=\"vm.product.Tags\" \ntheme=\"bootstrap\" close-on-select=\"true\"><ui-select-match placeholder=\"Select tags...\">{{$item.Name}}</ui-select-match>\n<ui-select-choices repeat=\"tag in vm.tags | filter:$select.search\"><div ng-bind=\"tag.Name\"></div></ui-select-choices>\n</ui-select></div></div><br><div class=\"row\"><label class=\"control-label col-md-4\" translate=\"product.is_exclude_gst\">\n</label><div class=\"col-md-8\" style=\"padding-top: 7px\"><input type=\"checkbox\" name=\"IsExcludeGST\" \nng-model=\"vm.product.IsExcludeGST\"></div></div></div></div><div class=\"row\"><div class=\"form-group col-md-6\" \nng-class=\"{\'has-error\': productForm.OldPrice.$invalid && productForm.OldPrice.$touched}\"><label \nclass=\"control-label col-md-4\" translate=\"product.old_price\"></label><div class=\"col-md-8\"><input type=\"number\" \nname=\"OldPrice\" class=\"form-control\" ng-model=\"vm.product.OldPrice\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\">\n<div ng-messages=\"productForm.OldPrice.$error\"><div ng-message=\"number\" ng-if=\"productForm.OldPrice.$touched\" \nclass=\"help-block\"><span translate=\"product.validate.old_price_number\"></span></div><div ng-message=\"pattern\" \nng-if=\"productForm.OldPrice.$touched\" class=\"help-block\"><span translate=\"product.validate.old_price_number\"></span>\n</div></div></div></div><div class=\"form-group col-md-6\" \nng-class=\"{\'has-error\': productForm.Price.$invalid && productForm.Price.$touched}\"><label \nclass=\"control-label col-md-4 required\" translate=\"product.price\"></label><div class=\"col-md-8\"><input type=\"number\" \nname=\"Price\" class=\"form-control\" ng-model=\"vm.product.Price\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\" \nrequired><div ng-messages=\"productForm.Price.$error\"><div ng-message=\"required\" ng-if=\"productForm.Price.$touched\" \nclass=\"help-block\"><span translate=\"product.validate.price\"></span></div><div ng-message=\"number\" \nng-if=\"productForm.Price.$touched\" class=\"help-block\"><span translate=\"product.validate.price_number\"></span></div><div\n ng-message=\"pattern\" ng-if=\"productForm.Price.$touched\" class=\"help-block\"><span \ntranslate=\"product.validate.price_number\"></span></div></div></div></div></div><div class=\"row\"></div><div class=\"row\">\n<div class=\"form-group col-md-6\" ng-class=\"{\'has-error\': productForm.file.$invalid && productForm.file.$touched}\">\n<label class=\"control-label col-md-4\" translate=\"product.photos\"></label><div class=\"photos-form col-md-8\"><div \nclass=\"upload-controls\"><input type=\"file\" class=\"button\" ngf-select=\"vm.uploadPhoto($files, $invalidFiles)\" \nname=\"file\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" \nngf-dimensions=\"($width >= 400) && ($height >= 230) && (($width / $height) >= 1)\" ng-model=\"vm.temp.Photo\" \nngf-multiple=\"true\"></div><div><label class=\"note\" translate=\"product.validate.photo.note\"></label></div><div \nclass=\"file-list\"><div ng-messages=\"productForm.file.$error\"><div ng-message=\"dimensions\" \nng-if=\"productForm.file.$dirty\" class=\"help-block\"><p translate=\"product.validate.photo.dimension\"></p></div></div><ul \ndnd-list=\"vm.product.Photos\"><li ng-repeat=\"photo in vm.product.Photos\" style=\"font:smaller\"><div \nclass=\"preview-photos\"><span class=\"dnd\"></span> <img ng-src=\"{{photo}}\" class=\"thumb\"> <a \nng-click=\"vm.removePhoto($index)\" class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-remove\"></i> <span \ntranslate=\"Remove\"></span></a></div></li></ul></div></div></div></div></form></div><div id=\"options\" \nclass=\"tab-pane fade\"><form name=\"productOptionForm\" class=\"form-horizontal\" novalidate id=\"productOptionForm\"><br><div\n class=\"row\" ng-repeat=\"option in vm.product.Options track by $index\" ng-init=\"sectionIndex = $index\"><div \nclass=\"offer-options\"><div class=\"breadcrumb\"><div class=\"breadcrumb-item active\"><b>Option {{$index+1}}</b> <button \ntype=\"button\" class=\"btn btn-danger text-right\" ng-click=\"vm.removeOption($index)\">Remove</button></div></div><div \nclass=\"row\"><div class=\"form-group col-md-5\" \nng-class=\"{\'has-error\': productOptionForm[\'Text\'+$index].$invalid && productOptionForm[\'Text\'+$index].$touched}\"><label\n class=\"control-label col-md-2 required\" translate=\"product.options.text\"></label><div class=\"col-md-10\"><input \ntype=\"text\" name=\"Text{{$index}}\" class=\"form-control\" ng-model=\"option.Text\" required><div \nng-messages=\"productOptionForm[\'Text\'+$index].$error\"><div ng-message=\"required\" \nng-if=\"productOptionForm[\'Text\'+$index].$touched\" class=\"help-block\"><span translate=\"product.validate.options.text\">\n</span></div></div></div></div><div class=\"form-group col-md-5\" \nng-class=\"{\'has-error\': productOptionForm[\'Type\'+$index].$invalid && productOptionForm[\'Type\'+$index].$touched}\"><label\n class=\"control-label col-md-2 required\" translate=\"product.options.type\"></label><div class=\"col-md-10\"><select \nname=\"Type{{$index}}\" ng-model=\"option.Type\" class=\"form-control\" ng-change=\"vm.typeChanged($index)\" \nng-options=\"value.Id as value.Name | translate for (key, value) in vm.optionTypes\" required><option value=\"\" \ndisabled=\"disabled\">Please select type...</option></select><div ng-messages=\"productOptionForm[\'Type\'+$index].$error\">\n<div ng-message=\"required\" ng-if=\"productOptionForm[\'Type\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"product.validate.options.type\"></span></div></div></div></div><div class=\"form-group col-md-2\"><input \nstyle=\"margin-left:15px\" type=\"checkbox\" name=\"IsRequired\" ng-model=\"option.IsRequired\"><label class=\"control-label\" \ntranslate=\"product.options.is_required\"></label></div></div><div class=\"offer-options-margin\"><div \nclass=\"offer-options\" ng-if=\"option.Type\"><ol class=\"breadcrumb\"><li class=\"breadcrumb-item active\">Offer Options</li>\n</ol><div class=\"row\" ng-repeat=\"offerOption in option.OfferOptions track by $index\"><div class=\"form-group col-md-5\" \nng-class=\"{\'has-error\': productOptionForm[\'OfferOptionText\'+$index].$invalid && productOptionForm[\'OfferOptionText\'+$index].$touched}\">\n<label class=\"control-label col-md-2 required\" translate=\"product.options.offer_options.text\"></label><div \nclass=\"col-md-10\"><input type=\"text\" name=\"OfferOptionText{{$index}}\" class=\"form-control\" ng-model=\"offerOption.Text\" \nrequired><div ng-messages=\"productOptionForm[\'OfferOptionText\'+$index].$error\"><div ng-message=\"required\" \nng-if=\"productOptionForm[\'OfferOptionText\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"product.validate.options.offer_options.text\"></span></div></div></div></div><div \nng-if=\"option.Type == \'MultichoiceWithValue\' || option.Type == \'OneChoiceWithValue\'\" class=\"form-group col-md-5\" \nng-class=\"{\'has-error\': productOptionForm[\'OfferOptionValue\'+$index].$invalid && productOptionForm[\'OfferOptionValue\'+$index].$touched}\">\n<label class=\"control-label col-md-2\" translate=\"product.options.offer_options.value\"></label><div class=\"col-md-10\">\n<input type=\"number\" name=\"OfferOptionValue{{$index}}\" class=\"form-control\" ng-model=\"offerOption.Value\" \nng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\" required><div \nng-messages=\"productOptionForm[\'OfferOptionValue\'+$index].$error\"><div ng-message=\"required\" \nng-if=\"productOptionForm[\'OfferOptionValue\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"product.validate.options.offer_options.value\"></span></div><div ng-message=\"number\" \nng-if=\"productOptionForm[\'OfferOptionValue\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"product.validate.options.offer_options.value_number\"></span></div><div ng-message=\"pattern\" \nng-if=\"productOptionForm[\'OfferOptionValue\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"product.validate.options.offer_options.value_number\"></span></div></div></div></div><div \nclass=\"form-group col-md-2\"><a class=\"btn btn-danger\" ng-if=\"option.OfferOptions.length != 1\" \nng-click=\"vm.removeOfferOption(sectionIndex,$index)\">Remove</a> <a class=\"btn btn-primary\" \nng-if=\"option.OfferOptions.length == $index+1\" ng-click=\"vm.addNewOfferOption(sectionIndex)\">Add</a></div></div></div>\n</div></div><hr></div><div class=\"form-group text-right\"><a class=\"btn btn-primary\" ng-click=\"vm.addNewOption()\">\nAdd option</a></div></form></div></div><div class=\"text-right\"><a ui-sref=\"app.product.list\" class=\"btn btn-danger\" \ntranslate=\"common.action.cancel\"></a> <button type=\"button\" ng-click=\"vm.save()\" class=\"btn btn-primary\" \ntranslate=\"common.action.save\"></button></div></div></div>");
$templateCache.put("app/product/product.html","<h1 class=\"page-header\" translate=\"product.title\"></h1><div id=\"product\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-2 margin-tb\"><input type=\"text\" \nclass=\"form-control\" ng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"Enter the product\'s name\"></div><div class=\"col-md-2 margin-tb\"><select ng-model=\"vm.criteria.Category\" \nng-change=\"vm.search()\" class=\"form-control\" ng-options=\"value.Id as value.Name for (key, value) in vm.categories\">\n<option value=\"\">All Category</option></select></div><div class=\"col-md-2 margin-tb\"><select \nng-model=\"vm.criteria.State\" ng-change=\"vm.search()\" class=\"form-control\" \nng-options=\"value.Id as value.Name | translate for (key, value) in vm.states\"><option value=\"\">All State</option>\n</select></div><div class=\"col-md-3 margin-tb\" ng-if=\"vm.isAdmin\"><ui-select ng-model=\"vm.criteria.OwnerId\" \ntheme=\"bootstrap\" ng-change=\"vm.search()\" ng-keyup=\"vm.loadMerchant($select.search)\"><ui-select-match \nplaceholder=\"Enter the merchant\'s name\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh-delay=\"0\" minimum-input-length=\"3\">\n<div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><div \nstyle=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div><div class=\"col-md-1\"><a class=\"btn btn-primary pull-right margin-tl\" \nng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a>\n</div><div ng-class=\"{\'col-md-4\': !vm.isAdmin, \'col-md-2\': vm.isAdmin}\"><a show-permissions=\"[\'CREATE_PRODUCT\']\" \nclass=\"btn btn-primary pull-right margin-tl\" ui-sref=\"app.product.create\"><i class=\"glyphicon glyphicon-plus\"></i> \n<span translate=\"common.action.add\"></span></a></div></div></div><div class=\"form-group\"><div class=\"table-responsive\">\n<table class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th width=\"10%\" translate=\"product.photo\"></th>\n<th translate=\"product.name\"></th><th ng-if=\"vm.isAdmin\" translate=\"common.merchant\"></th><th \ntranslate=\"product.price\"></th><th translate=\"common.action.title\"></th></tr></thead><tbody><tr \nng-repeat=\"product in vm.products\"><td class=\"center\">{{$index + 1}}</td><td><img class=\"photo\" ng-if=\"product.Photos\" \nng-src=\"{{product.Photos[0]}}\"></td><td>{{product.Name}}</td><td ng-if=\"vm.isAdmin\">{{product.OwnerName}}</td><td \nclass=\"number text-right\">{{product.Price}}<p ng-if=\"product.OldPrice > 0\"><del>({{product.OldPrice}})</del></p></td>\n<td class=\"center\"><a show-permissions=\"[\'EDIT_PRODUCT\']\" class=\"btn btn-default margin-tl\" title=\"Edit\" \nui-sref=\"app.product.edit({id:product.Id})\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a \nshow-permissions=\"[\'DELETE_PRODUCT\']\" class=\"btn btn-danger margin-tl\" mwl-confirm title=\"Delete product\" \nmessage=\"Are you really <b>sure</b> you want to delete <b>{{product.Name}}</b> product?\" confirm-text=\"OK\" \ncancel-text=\"Cancel\" on-confirm=\"vm.delete(product.Id)\" on-cancel=\"\" confirm-button-type=\"danger\" \ncancel-button-type=\"default\"><i class=\"glyphicon glyphicon-remove\"></i> </a><a show-permissions=\"[\'PUBLISH_PRODUCT\']\" \ntitle=\"Unpublish\" ng-if=\"product.State == \'Publish\'\" class=\"btn btn-danger margin-tl\" ng-click=\"vm.unpublish(product)\">\n<i class=\"glyphicon glyphicon-cloud-download\"></i></a> <a show-permissions=\"[\'PUBLISH_PRODUCT\']\" title=\"Publish\" \nng-if=\"product.State == \'Unpublish\'\" class=\"btn btn-primary margin-tl\" ng-click=\"vm.publish(product)\"><i \nclass=\"glyphicon glyphicon-cloud-upload\"></i></a></td></tr></tbody></table></div><ul uib-pagination \ntotal-items=\"vm.totalItems\" ng-change=\"vm.search()\" ng-model=\"vm.currentPage\" items-per-page=\"vm.criteria.Length\" \nmax-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div>");
$templateCache.put("app/account/change-password/change.password.html","<h1 class=\"page-header\" translate=\"AUTH.CHANGE_PASSWORD.TITLE\"></h1><div id=\"changePassword\"><div class=\"container\">\n<form class=\"form-signin form-horizontal\" name=\"changePasswordForm\" ng-submit=\"vm.changePassword()\" novalidate \nng-form-touched-on-submit><div class=\"form-group\" \nng-class=\"{\'has-error\': changePasswordForm.OldPassword.$invalid && changePasswordForm.OldPassword.$touched}\"><label \nclass=\"control-label col-md-4 required\" translate=\"common.old_password\"></label><div class=\"col-md-8\"><input \ntype=\"password\" name=\"OldPassword\" class=\"form-control\" ng-model=\"vm.model.OldPassword\" required><div \nng-messages=\"changePasswordForm.OldPassword.$error\"><div ng-message=\"required\" \nng-if=\"changePasswordForm.OldPassword.$touched\" class=\"help-block\"><span translate=\"common.validate.password_required\">\n</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': changePasswordForm.NewPassword.$invalid && changePasswordForm.NewPassword.$touched}\"><label \nclass=\"control-label col-md-4 required\" translate=\"common.new_password\"></label><div class=\"col-md-8\"><input \ntype=\"password\" name=\"NewPassword\" class=\"form-control\" ng-model=\"vm.model.NewPassword\" required><div \nng-messages=\"changePasswordForm.NewPassword.$error\"><div ng-message=\"required\" \nng-if=\"changePasswordForm.NewPassword.$touched\" class=\"help-block\"><span translate=\"common.validate.password_required\">\n</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': changePasswordForm.ConfirmPassword.$invalid && changePasswordForm.ConfirmPassword.$touched}\">\n<label class=\"control-label col-md-4 required\" translate=\"common.confirm_password\"></label><div class=\"col-md-8\"><input\n type=\"password\" name=\"ConfirmPassword\" class=\"form-control\" ng-model=\"vm.model.ConfirmPassword\" \nng-pattern=\"{{vm.model.NewPassword}}\" required><div><label class=\"note\" translate=\"common.validate.password_criteria\">\n</label></div><div ng-messages=\"changePasswordForm.ConfirmPassword.$error\"><div ng-message=\"required\" \nng-if=\"changePasswordForm.ConfirmPassword.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.user.validate.password_confirm\"></span></div><div ng-message=\"pattern\" class=\"help-block\"><span \ntranslate=\"merchant.user.validate.password_confirm_not_match\"></span></div></div></div></div><div class=\"text-right\">\n<button class=\"btn btn-lg btn-primary\" type=\"submit\" translate=\"AUTH.CHANGE_PASSWORD.CHANGE\"></button></div></form>\n</div></div>");
$templateCache.put("app/admin/BulkRegister-kiplekash/BulkRegister-kiplekash.html","<h1 class=\"page-header\" translate=\"admin.BulkRegister_kiplekash.title\"></h1><div id=\"bonus-BulkRegister\" \nclass=\"col-md-12\"><div class=\"col-md-6\"><form name=\"BulkRegisterkiplekashForm\" class=\"form-horizontal\" \nng-submit=\"vm.save()\" novalidate id=\"BulkRegisterkiplekashForm\"><div class=\"form-group\" \nng-class=\"{\'has-error\': BulkRegisterkiplekashForm.file.$invalid && BulkRegisterkiplekashForm.file.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.BulkRegister_kiplekash.import_csv\"></label><div \nclass=\"col-md-9\"><input type=\"file\" name=\"file\" class=\"input_file\" file-reader=\"vm.fileContent\" accept=\".csv\"></div>\n</div><div class=\"modal-footer\"><a href=\"{{vm.templateLink}}\" target=\"_blank\" \ntranslate=\"common.action.download_template\"></a> | <button type=\"reset\" class=\"btn btn-danger\" \ntranslate=\"common.action.reset\"></button> <button type=\"submit\" class=\"btn btn-primary\" \ntranslate=\"common.action.import\"></button></div></form></div></div>");
$templateCache.put("app/admin/admin-user/admin-user.html","<head><link href=\"https://gitcdn.github.io/bootstrap-toggle/2.2.2/css/bootstrap-toggle.min.css\" rel=\"stylesheet\">\n<script src=\"https://gitcdn.github.io/bootstrap-toggle/2.2.2/js/bootstrap-toggle.min.js\"></script></head><h1 \nclass=\"page-header\" translate=\"admin.admin-user.title\"></h1><div id=\"admin-user\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><ul class=\"nav nav-tabs\"><li class=\"active\"><a data-toggle=\"tab\" data-target=\"#userDiv\" \nid=\"userTab\">User</a></li><li><a data-toggle=\"tab\" data-target=\"#roleDiv\" id=\"roleTab\">Role</a></li></ul><br><div \nclass=\"tab-content\"><div id=\"userDiv\" class=\"tab-pane fade in active\"><div class=\"row\"><div class=\"col-md-6\"><div \nclass=\"form-group\"><div class=\"row\"><div class=\"col-md-6 col-xs-12 margin-tb\"><input \nng-keypress=\"vm.searchByKeyword($event)\" ng-model=\"vm.criteria.Keyword\" type=\"text\" \nplaceholder=\"Enter the user\'s name\" class=\"form-control\"></div><div class=\"col-md-2 col-sm-10\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span \ntranslate=\"common.action.reset\"></span></a></div><div class=\"col-md-4 col-sm-2\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.addAdminUser()\"><i class=\"glyphicon glyphicon-plus\"></i> \n<span translate=\"common.action.add\"></span></a></div></div></div><div class=\"form-group\"><div class=\"table-responsive\">\n<table class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th translate=\"common.username\"></th><th \ntranslate=\"common.action.title\"></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users\"><td class=\"center\">\n{{$index + 1}}</td><td>{{user.UserName}}</td><td class=\"center\"><a title=\"Edit\" class=\"btn btn-default margin-tl\" \nng-click=\"vm.editAdminUser(user.Id)\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a title=\"Remove\" \nclass=\"btn btn-danger margin-tl\" ng-click=\"vm.deleteAdminUser(user.Id)\"><i class=\"glyphicon glyphicon-remove\"></i></a>\n</td></tr></tbody></table></div></div><ul uib-pagination total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" \nng-change=\"vm.search()\" ng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" \nboundary-link-numbers=\"true\" rotate=\"false\"></ul></div><div class=\"col-md-6\"><form name=\"adminUserForm\" \nclass=\"form-horizontal\" ng-submit=\"vm.saveAdminUser()\" novalidate id=\"adminUserForm\" ng-hide=\"!vm.adminUser\"><div \nclass=\"modal-header\"><h3 class=\"modal-title center\" id=\"modal-title\" translate=\"admin.admin-user.detail\"></h3></div>\n<div class=\"modal-body\"><div class=\"form-group\" \nng-class=\"{\'has-error\': adminUserForm.UserName.$invalid && adminUserForm.UserName.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"admin.admin-user.username\"></label><div class=\"col-md-8\">\n<input name=\"UserName\" type=\"email\" class=\"form-control\" ng-model=\"vm.adminUser.UserName\" required \nng-disabled=\"vm.viewConfig.Action == \'edit\'\"><div ng-messages=\"adminUserForm.UserName.$error\"><div \nng-message=\"required\" ng-if=\"adminUserForm.UserName.$touched\" class=\"help-block\"><span \ntranslate=\"admin.admin-user.validate.username\"></span></div><div ng-message=\"email\" \nng-if=\"adminUserForm.UserName.$touched\" class=\"help-block\"><span translate=\"admin.admin-user.validate.username_format\">\n</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': adminUserForm.AccountRoles.$invalid && adminUserForm.AccountRoles.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"admin.admin-user.role.role\"></label><div class=\"col-md-8\">\n<select name=\"AccountRoles\" ng-model=\"vm.adminUser.AccountRoles\" class=\"form-control\" \nng-options=\"value.Id as value.Name for (key, value) in vm.allRoles\" required><option value=\"\" disabled=\"disabled\">\nPlease select a role</option></select><div ng-messages=\"adminUserForm.AccountRoles.$error\"><div ng-message=\"required\" \nng-if=\"adminUserForm.AccountRoles.$touched\" class=\"help-block\"><span \ntranslate=\"admin.admin-user.validate.role_required\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': adminUserForm.Password.$invalid && adminUserForm.Password.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" ng-class=\"{\'required\' : vm.viewConfig.Action == \'new\'}\" \ntranslate=\"admin.admin-user.password\"></label><div class=\"col-md-8\"><input name=\"Password\" type=\"password\" \nclass=\"form-control\" ng-model=\"vm.adminUser.Password\" ng-required=\"vm.viewConfig.Action == \'new\'\"><div \nng-messages=\"adminUserForm.Password.$error\"><div ng-message=\"required\" ng-if=\"adminUserForm.Password.$touched\" \nclass=\"help-block\"><span translate=\"admin.admin-user.validate.password\"></span></div></div></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': adminUserForm.PasswordRetype.$invalid && adminUserForm.PasswordRetype.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" ng-class=\"{\'required\' : vm.viewConfig.Action == \'new\'}\" \ntranslate=\"admin.admin-user.password_retype\"></label><div class=\"col-md-8\"><input name=\"PasswordRetype\" \ntype=\"password\" class=\"form-control\" ng-model=\"vm.adminUser.PasswordRetype\" \nng-required=\"vm.viewConfig.Action == \'new\'\" ng-pattern=\"{{vm.adminUser.Password}}\"><div \nng-messages=\"adminUserForm.PasswordRetype.$error\"><div ng-message=\"required\" \nng-if=\"adminUserForm.PasswordRetype.$touched\" class=\"help-block\"><span \ntranslate=\"admin.admin-user.validate.password_retype\"></span></div><div ng-message=\"pattern\" \nng-if=\"adminUserForm.PasswordRetype.$touched\" class=\"help-block\"><span \ntranslate=\"admin.admin-user.validate.password_retype_not_match\"></span></div></div></div></div><div class=\"form-group\">\n<label class=\"control-label col-md-3\">University Admin</label><div class=\"col-md-8\"><div class=\"input-group\"><input \nid=\"user-type\" type=\"checkbox\" ng-model=\"vm.adminUser.Type\"></div></div></div><div class=\"form-group\"><label \nid=\"lblRedpay\" class=\"control-label col-md-3\">RedPay Admin</label><div class=\"col-md-8\"><div class=\"input-group\"><input\n id=\"redpayuser-type\" type=\"checkbox\" ng-model=\"vm.adminUser.UserType\"></div></div></div></div><div \nclass=\"modal-footer\"><a class=\"btn btn-danger margin-tl\" ng-click=\"vm.cancelAdminUser()\" \ntranslate=\"common.action.cancel\"></a> <button type=\"submit\" class=\"btn btn-primary margin-tl\" \ntranslate=\"common.action.save\"></button></div></form></div></div></div><div id=\"roleDiv\" class=\"tab-pane fade in\"><div \nclass=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-6 col-xs-12 margin-tb\">\n<input ng-keypress=\"vm.searchByKeywordRole($event)\" ng-model=\"vm.criteriaRole.Keyword\" type=\"text\" \nplaceholder=\"Enter the role\'s name\" class=\"form-control\"></div><div class=\"col-md-2 col-sm-10\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.resetRole()\"><i class=\"glyphicon glyphicon-refresh\"></i> \n<span translate=\"common.action.reset\"></span></a></div><div class=\"col-md-4 col-sm-2\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.addRole()\"><i class=\"glyphicon glyphicon-plus\"></i> <span \ntranslate=\"common.action.add\"></span></a></div></div></div><div class=\"form-group\"><div class=\"table-responsive\"><table\n class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th translate=\"common.name\"></th><th \ntranslate=\"common.action.title\"></th></tr></thead><tbody><tr ng-repeat=\"role in vm.roles\"><td class=\"center\">\n{{$index + 1}}</td><td>{{role.Name}}</td><td class=\"center\"><a title=\"Edit\" class=\"btn btn-default\" \nng-click=\"vm.editRole(role.Id)\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a title=\"Remove\" class=\"btn btn-danger\" \nng-click=\"vm.deleteRole(role.Id)\"><i class=\"glyphicon glyphicon-remove\"></i></a></td></tr></tbody></table></div></div>\n<ul uib-pagination total-items=\"vm.totalItemsRole\" items-per-page=\"vm.itemsPerPageRole\" ng-change=\"vm.searchRole()\" \nng-model=\"vm.currentPageRole\" max-size=\"vm.maxSizeRole\" class=\"pagination-sm\" boundary-link-numbers=\"true\" \nrotate=\"false\"></ul></div><div class=\"col-md-6\"><form name=\"roleForm\" class=\"form-horizontal\" \nng-submit=\"vm.saveRole()\" novalidate id=\"roleForm\" ng-hide=\"!vm.role\"><div class=\"modal-header\"><h3 \nclass=\"modal-title center\" id=\"modal-title\" translate=\"admin.admin-user.role.detail\"></h3></div><div \nclass=\"modal-body\"><div class=\"form-group\" ng-class=\"{\'has-error\': roleForm.Name.$invalid && roleForm.Name.$touched}\">\n<label class=\"control-label col-md-3 required margin-tb\" translate=\"admin.admin-user.role.name\"></label><div \nclass=\"col-md-8\"><input name=\"Name\" type=\"text\" class=\"form-control\" ng-model=\"vm.role.Name\" required><div \nng-messages=\"roleForm.Name.$error\"><div ng-message=\"required\" ng-if=\"roleForm.Name.$touched\" class=\"help-block\"><span \ntranslate=\"admin.admin-user.validate.role.name\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': roleForm.Name.$invalid && roleForm.Name.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.admin-user.role.permission\"></label><div class=\"col-md-8\">\n<div class=\"groups-permissions\" ng-if=\"vm.groupsPermissions\"><div class=\"checkbox\"><label><input type=\"checkbox\" \nng-if=\"vm.role\" ng-checked=\"vm.isSelectAll()\" ng-click=\"vm.toggleAll()\"> <span>Select all</span></label></div><div \nid=\"group-permissions-scrollbar\"><div class=\"group-permissions\" ng-repeat=\"group in vm.groupsPermissions\"><div \nclass=\"checkbox\"><label class=\"ng-binding\"><input type=\"checkbox\" ng-if=\"vm.role\" \nng-checked=\"vm.isGroupChecked(group)\" ng-click=\"vm.toggleGroup(group)\"> {{group.Name}}</label></div><div \nclass=\"permissions\"><div class=\"permission checkbox\" ng-repeat=\"permission in group.Permissions\"><label><input \ntype=\"checkbox\" ng-if=\"vm.role\" ng-checked=\"vm.isPermissionChecked(permission)\" \nng-click=\"vm.togglePermission(permission)\"> {{permission.Display}}</label></div></div></div></div></div></div></div>\n</div><div class=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.cancelRole()\" translate=\"common.action.cancel\">\n</a> <button type=\"submit\" class=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div>\n</div></div></div></div>");
$templateCache.put("app/admin/announcement/announcement.html","<h1 class=\"page-header\" translate=\"admin.announcement.header\"></h1><div id=\"group\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><input \ntype=\"text\" class=\"form-control\" ng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"Enter the announcement\'s title\"></div><div class=\"col-md-1 col-sm-10\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span \ntranslate=\"common.action.reset\"></span></a></div><div class=\"col-md-2 col-md-offset-6 col-sm-2\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.popupCreateOrUpdateForm()\"><i \nclass=\"glyphicon glyphicon-plus\"></i> <span translate=\"common.action.add\"></span></a></div></div></div><div \nclass=\"form-group\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered\"><thead><tr><th>#\n</th><th style=\"width:20%\" translate=\"admin.announcement.title\"></th><th style=\"width:30%\" \ntranslate=\"admin.announcement.message\"></th><td>Client</td><th translate=\"admin.announcement.expirationDate\"></th><th \ntranslate=\"common.action.title\"></th></tr></thead><tbody><tr ng-repeat=\"ann in vm.annListData\"><td class=\"center\">\n{{$index + 1}}</td><td>{{ann.Title}}</td><td>{{ann.Message}}</td><td>{{ann.Client}}</td><td class=\"right\">\n{{ann.ExpirationDate | date:\'yyyy-MM-dd HH:mm:ss\'}}</td><td class=\"center\"><a title=\"Edit\" \nclass=\"btn btn-default margin-tl\" ng-click=\"vm.popupCreateOrUpdateForm(ann.Id)\"><i class=\"glyphicon glyphicon-edit\">\n</i></a> <a title=\"Remove\" class=\"btn btn-danger margin-tl\" ng-click=\"vm.popupremoveForm(ann.Id)\"><i \nclass=\"glyphicon glyphicon-remove\"></i></a></td></tr></tbody></table></div></div><ul uib-pagination \ntotal-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-change=\"vm.initAnnouncementList()\" \nng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul>\n</div></div>");
$templateCache.put("app/admin/announcement/updatecreate.view.html","<div class=\"modal-content my-content\"><form id=\"annForm\" name=\"annForm\" class=\"form-horizontal\" \nng-submit=\"vm.onSubmit(annForm.$valid)\" novalidate><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.modal.cancel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 \nclass=\"modal-title center\" id=\"modal-title\" translate=\"admin.announcement.header\"></h3></div><div class=\"modal-body\">\n<div class=\"form-group\" ng-class=\"{\'has-error\': annForm.Criteria.$invalid && annForm.Criteria.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.notification.select_criteria\"></label><div class=\"col-md-8\">\n<select name=\"Criteria\" class=\"form-control\" required ng-model=\"vm.formData.criteria\" \nng-options=\"value.Id as value.Name | translate for (key,value) in vm.criterialist\"></select><div \nng-messages=\"annForm.Criteria.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.Criteria.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.criteria_required\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{ \'has-error\' : annForm.title.$invalid && !annForm.title.$pristine }\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.announcement.title\"></label><div class=\"col-md-8\"><input \nname=\"title\" type=\"text\" class=\"form-control margin-tb\" ng-model=\"vm.formData.title\" required><p \nng-show=\"annForm.title.$invalid && !annForm.title.$pristine\" class=\"help-block\">Title is required.</p></div></div><div \nclass=\"form-group\" ng-class=\"{ \'has-error\' : annForm.message.$invalid && !annForm.message.$pristine }\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.announcement.message\"></label><div class=\"col-md-8\"><input \nname=\"message\" type=\"text\" class=\"form-control margin-tb\" ng-model=\"vm.formData.message\" required><p \nng-show=\"annForm.message.$invalid && !annForm.message.$pristine\" class=\"help-block\">Message is required.</p></div>\n</div><div class=\"form-group\" \nng-class=\"{\'has-error\': annForm.expirationDate.$invalid && annForm.expirationDate.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.announcement.expirationDate\"></label><div class=\"col-md-8\">\n<input type=\"datetime-local\" id=\"expirationDate\" name=\"expirationDate\" class=\"form-control\" \nvalue=\"{{vm.formData.expirationDate}}\" ng-model=\"vm.formData.expirationDate\" required><p \nng-show=\"annForm.expirationDate.$invalid && !annForm.expirationDate.$pristine\" class=\"help-block\">\nExpiration Date is required.</p></div></div></div><div class=\"alert alert-danger\" ng-if=\"vm.formError\">{{vm.formError}}\n</div><div class=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.modal.cancel()\" \ntranslate=\"common.action.cancel\"></a> <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"annForm.$invalid\" \ntranslate=\"common.action.save\"></button></div></form></div>");
$templateCache.put("app/admin/banner/banner.html","<h1 class=\"page-header\" translate=\"admin.banner.title\"></h1><div id=\"banner\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><input \ntype=\"text\" class=\"form-control\" ng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"Enter the User Type\"></div><div class=\"col-md-3 col-xs-12 margin-tb\"><select class=\"form-control\" \nid=\"searchBannerLayers\" name=\"searchBannerLayers\" ng-model=\"vm.criteria.BannerLayer\" \nng-change=\"vm.searchByKeyword($event)\"><option ng-value=\"null\">Select Banner Type</option><option \nng-repeat=\"BLOptions in vm.BanneLayerOptions\" ng-value=\"BLOptions.Id\">{{BLOptions.Name}}</option></select></div><div \nclass=\"col-md-1 col-sm-10\"><a class=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.reset()\"><i \nclass=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a></div><div \nclass=\"col-md-2 col-sm-2\"><a class=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.openDialog(\'new\')\"><i \nclass=\"glyphicon glyphicon-plus\"></i> <span translate=\"common.action.add\"></span></a></div></div></div><div \nclass=\"form-group\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered\"><thead><tr><th>#\n</th><th width=\"20%\" translate=\"photo\"></th><th translate=\"Banner Name\"></th><th translate=\"admin.banner.IsPrimary\">\n</th><th translate=\"admin.banner.Type\"></th><th translate=\"BannerType\"></th><th translate=\"admin.banner.Link_URL\"></th>\n<th translate=\"admin.banner.Position\"></th><th translate=\"common.action.title\"></th></tr></thead><tbody><tr \nng-repeat=\"banner in vm.banners\"><td class=\"center\">{{$index + 1}}</td><td width=\"20%\"><img style=\"width:100%\" \nclass=\"photo\" ng-if=\"banner.Photos\" ng-src=\"{{banner.Photos}}\"></td><td>{{banner.Name}}</td><td>{{banner.IsPrimary}}\n</td><td>{{banner.UniversityId}}</td><td>{{banner.Channel==\"Kiplemart\" ? banner.BannerFlag: banner.BannerLayer }}</td>\n<td>{{banner.Link}}</td><td>{{banner.Position}}</td><td class=\"center\"><a title=\"Edit\" \nclass=\"btn btn-default margin-tl\" ng-click=\"vm.openDialog(\'edit\', banner)\"><i class=\"glyphicon glyphicon-edit\"></i></a>\n <a title=\"Remove\" class=\"btn btn-danger margin-tl\" ng-click=\"vm.remove(banner)\"><i class=\"glyphicon glyphicon-remove\">\n</i></a></td></tr></tbody></table></div><ul uib-pagination total-items=\"vm.totalItems\" ng-change=\"vm.search()\" \nng-model=\"vm.currentPage\" items-per-page=\"vm.criteria.Length\" max-size=\"vm.maxSize\" class=\"pagination-sm\" \nboundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><form name=\"bannerForm\" class=\"form-horizontal\" \nng-submit=\"vm.save()\" novalidate id=\"bannerForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.viewConfig.ShowDialog = false\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span>\n</button><h3 class=\"modal-title center\" id=\"modal-title\" translate=\"admin.banner.banner_model_title\"></h3></div><div \nclass=\"modal-body\"><div class=\"form-group\" ng-hide=\"vm.banner.IsPrimary\"><label \nclass=\"control-label col-md-3 required\">Channel</label><div class=\"col-md-8\"><select class=\"form-control\" id=\"Channel\" \nname=\"Channel\" ng-model=\"vm.banner.Channel\"><option ng-repeat=\"chl in vm.channelList\" value=\"{{chl.value}}\">\n{{chl.text}}</option></select></div></div><div class=\"form-group university\" \nng-hide=\"vm.banner.IsPrimary || vm.banner.Channel ===\'1\'\"><label class=\"control-label col-md-3 required\">User Type\n</label><div class=\"col-md-8\"><select class=\"form-control\" id=\"UniversityId\" name=\"UniversityId\" \nng-model=\"vm.banner.UniversityId\"><option value=\"NormalUser\">NormalUser</option><option \nng-repeat=\"university in vm.universtyList\" value=\"{{university.UniversityId}}\">{{university.Name}}</option></select>\n</div></div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"admin.banner.Link_URL\">\n</label><div class=\"col-md-8\"><input type=\"text\" name=\"Link\" class=\"form-control\" ng-model=\"vm.banner.Link\"></div>\n</div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb required\" translate=\"Banner Name\"></label>\n<div class=\"col-md-8\"><input type=\"text\" name=\"Name\" class=\"form-control\" ng-model=\"vm.banner.Name\"></div></div><div \nclass=\"form-group\" ng-hide=\"vm.banner.Channel ===\'0\' || vm.banner.IsPrimary\"><label class=\"control-label col-md-3\">Type\n</label><div class=\"col-md-8\"><select class=\"form-control\" id=\"BannerType\" name=\"BannerType\" \nng-model=\"vm.banner.BannerFlag\"><option ng-repeat=\"chl in vm.bannerTypeList\" value=\"{{chl.value}}\">{{chl.text}}\n</option></select></div></div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"admin.banner.Position\"></label><div class=\"col-md-8\"><input type=\"number\" name=\"number\" min=\"1\" max=\"5\" \nclass=\"form-control\" ng-disabled=\"vm.disabledPosition\" ng-model=\"vm.banner.Position\"></div></div><div \nclass=\"form-group\" ng-hide=\"vm.banner.Channel ===\'1\' || vm.banner.UniversityId != \'NormalUser\'\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.banner.IsPrimary\"></label><div class=\"col-md-8\"><input \ntype=\"checkbox\" ng-model=\"vm.banner.IsPrimary\" ng-change=\"vm.CheckPrimary()\"></div></div><div class=\"form-group\" \nng-hide=\"vm.banner.Channel ===\'1\'\"><label class=\"control-label col-md-3 required\">BannerLevels</label><div \nclass=\"col-md-8\"><select class=\"form-control\" id=\"BannerLayers\" name=\"BannerLayers\" ng-model=\"vm.banner.BannerLayers\" \nng-change=\"vm.bannerlayerChange()\"><option ng-repeat=\"BLOptions in vm.BanneLayerOptions\" ng-value=\"BLOptions.Id\">\n{{BLOptions.Name}}</option></select></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': bannerForm.file.$invalid && bannerForm.file.$touched}\"><label class=\"control-label col-md-3\" \ntranslate=\"admin.banner.Image\"></label><div class=\"photos-form col-md-8\"><div class=\"upload-controls\" \nng-if=\"vm.banner.Photos.length == 0 && (vm.banner.BannerLayers == 0 || vm.banner.BannerLayers == 4 || vm.banner.BannerLayers == 2)\">\n> <input type=\"file\" class=\"button\" ngf-select=\"vm.uploadPhoto($files, $invalidFiles)\" name=\"file\" \nngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" \nngf-dimensions=\"($width == 948) && ($height == 408) && (($width / $height) >= 1)\" ng-model=\"vm.temp.Photo\" \nngf-multiple=\"false\"></div><div class=\"upload-controls\" \nng-if=\"vm.banner.Photos.length==0 && vm.banner.BannerLayers==1\"><input type=\"file\" class=\"button\" \nngf-select=\"vm.uploadPhoto($files, $invalidFiles)\" name=\"file\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" \nngf-dimensions=\"($width == 460) && ($height == 460) && (($width / $height) >= 1)\" ng-model=\"vm.temp.Photo\" \nngf-multiple=\"false\"></div><div \nng-if=\"vm.banner.Photos.length==0 && (vm.banner.BannerLayers==0 || vm.banner.BannerLayers == 4 || vm.banner.BannerLayers == 2)\">\n<label class=\"note\" translate=\"admin.banner.validate.photo.note\"></label></div><div \nng-if=\"vm.banner.Photos.length==0 && vm.banner.BannerLayers==1\"><label class=\"note\" \ntranslate=\"Note: Image resolution must be exactly 460x460px.\"></label></div><div class=\"file-list\" style=\"width:100%\">\n<div ng-messages=\"bannerForm.file.$error\"><div ng-message=\"dimensions\" \nng-if=\"bannerForm.file.$dirty && (vm.banner.BannerLayers==0 || vm.banner.BannerLayers == 4 || vm.banner.BannerLayers == 2)\" \nclass=\"help-block\"><p translate=\"Image size must have at least 948x408 px or image has invalid ratio.\"></p></div><div \nng-message=\"dimensions\" ng-if=\"bannerForm.file.$dirty && vm.banner.BannerLayers==1\" class=\"help-block\"><p \ntranslate=\"Image size must have at least 460x460 px or image has invalid ratio.\"></p></div></div><ul \ndnd-list=\"vm.banner.Photos\"><li ng-repeat=\"photo in vm.banner.Photos\" style=\"font:smaller\"><div class=\"preview-photos\">\n<span class=\"dnd\"></span> <img style=\"width:100%;padding-bottom:1%\" src=\"{{photo}}\" class=\"thumb\"> <a \nng-click=\"vm.removePhoto($index)\" class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-remove\"></i> <span \ntranslate=\"Remove\"></span></a></div></li></ul></div></div></div></div><div class=\"modal-footer\"><a \nclass=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button type=\"submit\" \nclass=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div></div></div>");
$templateCache.put("app/admin/bonus/bonus.html","<h1 class=\"page-header\" translate=\"admin.bonus.title\" ng-init=\"vm.init()\"></h1><uib-tabset><uib-tab index=\"0\" \nheading=\"Bonus Zakat\"><br><div id=\"divZakat\" class=\"col-md-12\"><div role=\"alert\" ng-show=\"vm.zakatModel.tipMsg\" \nclass=\"alert alert-success\">{{vm.zakatModel.tipMsg}}</div><div role=\"alert\" ng-show=\"vm.zakatModel.errorMsg\" \nclass=\"alert alert-danger\" ng-bind-html=\"vm.zakatModel.errorMsg\"></div><form name=\"zakatForm\" \nng-submit=\"vm.submitZakatForm(zakatForm)\" novalidate><select class=\"form-control\" style=\"width: 20em\" \nid=\"UniversityId\" name=\"UniversityId\" ng-disabled=\"vm.isReadonly\" ng-model=\"vm.zakatModel.universityId\" \nng-change=\"vm.UniversityIdClick()\" readonly=\"readonly\"><option value=\"\">--Select University--</option><option \nng-repeat=\"university in vm.UniversityItems\" value=\"{{university.UniversityId}}\">{{university.UniversityId}}</option>\n</select><div class=\"form-group\"><label translate=\"admin.bonus_kiplekash.import_csv\"></label><input id=\"zakatFile\" \nname=\"zakatFile\" type=\"file\" accept=\".csv\" file-reader=\"vm.zakatModel.csvText\" valid-file \nng-model=\"vm.zakatModel.csvFilePath\" required></div><a href=\"{{vm.zakatTmpLink}}\" \ntranslate=\"common.action.download_template\"></a><hr><button type=\"reset\" class=\"btn btn-danger\" \nng-click=\"vm.resetForm(vm.zakatModel)\" translate=\"common.action.reset\"></button> <button type=\"submit\" \nclass=\"btn btn-primary\" ng-disabled=\"zakatForm.$invalid\">Submit</button></form></div><div class=\"col-md-12\"><div \nstyle=\"border-style: ridge;padding: 1em 3em 3em 3em;margin: 1em 1em 1em 0\"><h2><em><strong><u>Education Tips</u>\n</strong></em></h2><p><u><strong style=\"font-size: 15px\">File Upload Tips</strong></u></p><ol class=\"ak-ol\" \ndata-indent-level=\"1\"><li class=\"\"><p>Maximum upload data is 1000 per entry</p></li><li class=\"\"><p>\nMaximum file size is 1M</p></li><li class=\"\"><p>File format is .csv files</p></li><li class=\"\"><p>\nData upload must be consistent, if fail please check:</p><ol class=\"ak-ol\" data-indent-level=\"2\" type=\"a\"><li class=\"\">\n<p>No extra spacing before or after entering the details is each column</p></li><li class=\"\"><p>\nData entered is according to the format</p><ol class=\"ak-ol\" data-indent-level=\"3\" type=\"i\"><li class=\"\"><p>\nUsername must include prefix 6 before the mobile number</p></li><li class=\"\"><p>\nOnly numbers when enter under ID column, no special characters</p></li><li class=\"\"><p>\nUniversity ID is according to the university format</p></li><li class=\"\"><p>Prefund amount is without decimal</p></li>\n</ol></li></ol></li></ol><p><u><strong style=\"font-size: 15px\">Disbursement Steps/Tips</strong></u></p><ol \nclass=\"ak-ol pm-table-last-item-in-cell\" data-indent-level=\"1\"><li class=\"\"><p>\nPartner/University pre-Selected before upload disbursement file</p></li><li class=\"\"><p>\nUpload file consist of data (according to the file format)</p><ol class=\"ak-ol\" data-indent-level=\"2\" type=\"a\"><li \nclass=\"\"><p>Fund recipients <strong>MUST</strong>\n complete eKYC (verified) and successfully register in KipleUNi community in kiplePay app.</p></li><li class=\"\"><p>\nUsername (mobile number) <strong>MUST</strong> be registered under recipients identity card (NRIC/Passport)</p></li>\n</ol></li><li class=\"\"><p>\nSuccessful fund will be awarded on the same date upon file uploaded (Subject to eKYC status is Verified and KipleUNi successfully registered)\n</p></li><li class=\"\"><p>Disbursement status can be viewed in Bonus Zakat Disbursement Report</p></li><li><p>\nRemark reference in report:</p><ol class=\"ak-ol\" data-indent-level=\"2\" type=\"a\"><li class=\"\"><p><strong>Pending\n</strong> - Wallet PIN not created</p></li><li class=\"\"><p><strong>Successful</strong> - Fund credited</p></li><li \nclass=\"\"><p><strong>Fail</strong> - ID does not exist</p></li><li class=\"\"><p><strong>Fail </strong>\n- Duplicate username</p></li><li class=\"\"><p><strong>Fail</strong> -Username does not exist</p></li><li class=\"\"><p>\n<strong>Fail</strong> - Duplicate ID</p></li><li class=\"\"><p><strong>Fail</strong> - Duplicate university ID</p></li>\n<li><p><strong>Fail</strong> - University ID does not exist</p></li></ol></li></ol></div></div></uib-tab><uib-tab \nindex=\"1\" heading=\"Bonus Storecard\"><br><div id=\"divStore\" class=\"col-md-12\"><div role=\"alert\" \nng-show=\"vm.storeModel.tipMsg\" class=\"alert alert-success\">{{vm.storeModel.tipMsg}}</div><div role=\"alert\" \nng-show=\"vm.storeModel.errorMsg\" class=\"alert alert-danger\" ng-bind-html=\"vm.storeModel.errorMsg\"></div><form \nname=\"storeForm\" ng-submit=\"vm.submitStoreForm(storeForm.$valid)\" novalidate><div class=\"form-group\"><label \ntranslate=\"admin.bonus_storecard.import_csv\"></label><input id=\"storeFile\" name=\"storeFile\" type=\"file\" accept=\".csv\" \nfile-reader=\"vm.storeModel.csvText\" valid-file ng-model=\"vm.storeModel.csvFilePath\" required></div><a \nhref=\"{{vm.storeTmpLink}}\" translate=\"common.action.download_template\"></a><hr><button type=\"reset\" \nclass=\"btn btn-danger\" ng-click=\"vm.resetForm(vm.storeModel)\" translate=\"common.action.reset\"></button> <button \ntype=\"submit\" class=\"btn btn-primary\" ng-disabled=\"storeForm.$invalid\">Submit</button></form></div></uib-tab><uib-tab \nindex=\"2\" heading=\"Bonus Credits\"><br><div id=\"divCredit\" class=\"col-md-12\"><div role=\"alert\" \nng-show=\"vm.creditModel.tipMsg\" class=\"alert alert-success\">{{vm.creditModel.tipMsg}}</div><div role=\"alert\" \nng-show=\"vm.creditModel.errorMsg\" class=\"alert alert-danger\" ng-bind-html=\"vm.creditModel.errorMsg\"></div><form \nname=\"creditForm\" ng-submit=\"vm.submitCreditForm(creditForm.$valid)\" novalidate><div class=\"form-group\"><label \ntranslate=\"admin.bonus_storecard.import_csv\"></label><input id=\"creditFile\" name=\"creditFile\" type=\"file\" \naccept=\".csv\" file-reader=\"vm.creditModel.csvText\" valid-file ng-model=\"vm.creditModel.csvFilePath\" required></div><a \nhref=\"{{vm.creditTmpLink}}\" target=\"_blank\" translate=\"common.action.download_template\"></a><hr><button type=\"reset\" \nclass=\"btn btn-danger\" ng-click=\"vm.resetForm(vm.creditModel)\" translate=\"common.action.reset\"></button> <button \ntype=\"submit\" class=\"btn btn-primary\" ng-disabled=\"creditForm.$invalid\">Submit</button><hr><div role=\"alert\" \nclass=\"alert alert-danger\">REMARKS : Credits money will be awarded on the same date upon file uploaded</div></form>\n</div></uib-tab></uib-tabset>");
$templateCache.put("app/admin/bonus-disbursement-request-approve/bonus-disbursement-request-approve.html","<div id=\"divDisbursementRequestApproval\" ng-init=\"vm.getUniversities()\"><h1 class=\"page-header\" \ntranslate=\"admin.bonusDisbursementRequest.ZakatDisbursementRequest\"></h1><div class=\"report-filter\"><div \nclass=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" data-target=\"#collapse_panel\"><span \nclass=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\"><i \nclass=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\">\n{{ \'report.disbursement_report.start_disbursement_dateTime\' | translate}}</label><input \nid=\"disbursementRequestStartDate\" type=\"text\" name=\"disbursementRequestStartDate\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpenDisbursement\" \nng-click=\"vm.datePopup.StartOpenDisbursement = true\" ng-model=\"vm.serachModel.disbursementRequestStartDate\"></div>\n</div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\">\n{{ \'report.disbursement_report.end_disbursement_dateTime\' | translate}}</label><input id=\"disbursementRequestEndDate\" \ntype=\"text\" name=\"disbursementRequestEndDate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" \nis-open=\"vm.datePopup.EndOpenDisbursement\" ng-click=\"vm.datePopup.EndOpenDisbursement = true\" \nng-model=\"vm.serachModel.disbursementRequestEndDate\"></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\"><div \nclass=\"form-group\"><label class=\"control-label\">{{ \'report.disbursement_report.university\' | translate}}</label><select\n class=\"form-control\" id=\"UniversityCode\" name=\"UniversityCode\" ng-model=\"vm.serachModel.universityCode\" \nng-change=\"vm.UniversityIdClick()\"><option value=\"\">--Select University--</option><option \nng-repeat=\"university in vm.UniversityItems\" value=\"{{university.UniversityId}}\">{{university.UniversityId}}</option>\n</select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\">\n{{ \'report.disbursement_report.status\' | translate}}</label><select class=\"form-control\" \nng-model=\"vm.serachModel.status\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option><option \nng-repeat=\"v in vm.statusList\" ng-value=\"v.status\">{{v.displayText}}</option></select></div></div></div><hr><div \nclass=\"row\"><div class=\"col-xs-12\"><button type=\"button\" class=\"btn btn-primary pull-right\" \nng-click=\"vm.searchReport()\" translate=\"report.summarize\"></button></div></div><div role=\"alert\" ng-show=\"vm.errorMsg\" \nclass=\"alert alert-danger\">{{vm.errorMsg}}</div></div></div></div></div><div class=\"table-responsive form-group\"></div>\n<div class=\"table-responsive\"><table datatable dt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.dtInstance\"><thead><tr><th>\n{{ \'report.disbursement_report.disbursement_dateTime\' | translate}}</th><th>\n{{ \'report.disbursement_report.university\' | translate }}</th><th>\n{{ \'report.disbursement_report.totalPrefund\' | translate }}</th><th>\n{{ \'report.disbursement_report.totalEntry\' | translate }}</th><th>{{ \'report.disbursement_report.status\' | translate }}\n</th><th>{{ \'report.disbursement_report.action\' | translate }}</th></tr></thead></table></div></div>");
$templateCache.put("app/admin/bonus-kiplekash/bonus-kiplekash.html","<h1 class=\"page-header\" translate=\"admin.bonus_kiplekash.title\"></h1><div id=\"bonus-kiplekash\" class=\"col-md-12\"><div \nclass=\"col-md-6\"><form name=\"bonusKiplekashForm\" class=\"form-horizontal\" ng-submit=\"vm.save()\" novalidate \nid=\"bonusKiplekashForm\"><div class=\"form-group\" \nng-class=\"{\'has-error\': bonusKiplekashForm.file.$invalid && bonusKiplekashForm.file.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.bonus_kiplekash.import_csv\"></label><div class=\"col-md-9\">\n<input type=\"file\" name=\"file\" file-reader=\"vm.fileContent\" accept=\".csv\"></div></div><div class=\"modal-footer\"><a \nhref=\"{{vm.templateLink}}\" target=\"_blank\" translate=\"common.action.download_template\"></a> | <button type=\"reset\" \nclass=\"btn btn-danger\" translate=\"common.action.reset\"></button> <button type=\"submit\" class=\"btn btn-primary\" \ntranslate=\"common.action.import\"></button></div></form></div></div>");
$templateCache.put("app/admin/bonus-storecard/bonus-storecard.html","<h1 class=\"page-header\" translate=\"admin.bonus_storecard.title\"></h1><div id=\"bonus-storecard\" class=\"col-md-12\"><div \nclass=\"col-md-6\"><form name=\"bonusStorecardForm\" class=\"form-horizontal\" ng-submit=\"vm.save()\" novalidate \nid=\"bonusStorecardForm\"><div class=\"form-group\" \nng-class=\"{\'has-error\': bonusStorecardForm.file.$invalid && bonusStorecardForm.file.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.bonus_storecard.import_csv\"></label><div class=\"col-md-9\">\n<input type=\"file\" name=\"file\" file-reader=\"vm.fileContent\" accept=\".csv\"></div></div><div class=\"modal-footer\"><a \nhref=\"{{vm.templateLink}}\" target=\"_blank\" translate=\"common.action.download_template\"></a> | <button type=\"reset\" \nclass=\"btn btn-danger\" translate=\"common.action.reset\"></button> <button type=\"submit\" class=\"btn btn-primary\" \ntranslate=\"common.action.import\"></button></div></form></div></div>");
$templateCache.put("app/admin/brand/brand.html","<h1 class=\"page-header\" translate=\"admin.brand.title\"></h1><div id=\"brand\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><input \ntype=\"text\" class=\"form-control\" ng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"Enter the brand\'s name\"></div><div class=\"col-md-1 col-sm-10\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span \ntranslate=\"common.action.reset\"></span></a></div><div class=\"col-md-2 col-md-offset-6 col-sm-2\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.openDialog(\'new\')\"><i class=\"glyphicon glyphicon-plus\"></i> \n<span translate=\"common.action.add\"></span></a></div></div></div><div class=\"form-group\"><div class=\"table-responsive\">\n<table class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th translate=\"common.name\"></th><th \ntranslate=\"common.group\"></th><th translate=\"admin.brand.number_of_merchant\"></th><th translate=\"common.action.title\">\n</th></tr></thead><tbody><tr ng-repeat=\"brand in vm.brands\"><td class=\"center\">{{$index + 1}}</td><td>{{brand.Name}}\n</td><td>{{brand.GroupName}}</td><td class=\"right\">{{brand.NumberOfMerchant}}</td><td class=\"center\"><a title=\"Edit\" \nclass=\"btn btn-default margin-tl\" ng-click=\"vm.openDialog(\'edit\', brand)\"><i class=\"glyphicon glyphicon-edit\"></i></a> \n<a title=\"Remove\" class=\"btn btn-danger margin-tl\" ng-click=\"vm.remove(brand)\"><i class=\"glyphicon glyphicon-remove\">\n</i></a></td></tr></tbody></table></div></div><ul uib-pagination total-items=\"vm.totalItems\" \nitems-per-page=\"vm.itemsPerPage\" ng-change=\"vm.search()\" ng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" \nclass=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div><div class=\"header-modal\"><div \ncommon-bs-modal bs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><form name=\"brandForm\" class=\"form-horizontal\" \nng-submit=\"vm.save()\" novalidate id=\"brandForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.viewConfig.ShowDialog = false\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span>\n</button><h3 class=\"modal-title center\" id=\"modal-title\" translate=\"admin.brand.brand_detail\"></h3></div><div \nclass=\"modal-body\"><div class=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" \ntranslate=\"merchant.company.title\"></h4></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"merchant.company.name\"></label><div class=\"col-md-8\"><input \nname=\"CompanyName\" type=\"text\" class=\"form-control\" ng-model=\"vm.brand.CompanyName\"></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"merchant.company.registration_number\">\n</label><div class=\"col-md-8\"><input name=\"RegistrationNumber\" type=\"text\" class=\"form-control\" \nng-model=\"vm.brand.RegistrationNumber\"></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"common.address.address\"></label><div class=\"col-md-8\"><input \nname=\"AddressStreet\" type=\"text\" class=\"form-control\" ng-model=\"vm.brand.Address.Street\"><div \nng-messages=\"brandForm.AddressStreet.$error\"><div ng-message=\"required\" ng-if=\"brandForm.AddressStreet.$touched\" \nclass=\"help-block\"><span translate=\"admin.brand.validate.address_street\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"common.address.city\"></label><div \nclass=\"col-md-8\"><input name=\"AddressCity\" type=\"text\" class=\"form-control\" ng-model=\"vm.brand.Address.City\"><div \nng-messages=\"brandForm.AddressCity.$error\"><div ng-message=\"required\" ng-if=\"brandForm.AddressCity.$touched\" \nclass=\"help-block\"><span translate=\"admin.brand.validate.address_city\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"common.address.state\"></label><div \nclass=\"col-md-8\"><input name=\"AddressState\" type=\"text\" class=\"form-control\" ng-model=\"vm.brand.Address.State\"><div \nng-messages=\"brandForm.AddressState.$error\"><div ng-message=\"required\" ng-if=\"brandForm.AddressState.$touched\" \nclass=\"help-block\"><span translate=\"admin.brand.validate.address_state\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': brandForm.AddressPostCode.$invalid}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"common.address.postcode\"></label><div class=\"col-md-8\"><input \nname=\"AddressPostCode\" type=\"text\" ng-pattern=\"/^[0-9]*$/\" class=\"form-control\" ng-model=\"vm.brand.Address.PostCode\">\n<div ng-messages=\"brandForm.AddressPostCode.$error\"><div ng-message=\"pattern\" \nng-if=\"brandForm.AddressPostCode.$touched\" class=\"help-block\"><span \ntranslate=\"admin.brand.validate.address_postcode_number\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': brandForm.MainContactPerson.$invalid && brandForm.MainContactPerson.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.brand.main_contact_person\"></label><div class=\"col-md-8\">\n<input name=\"MainContactPerson\" type=\"text\" class=\"form-control\" ng-model=\"vm.brand.MainContactPerson\"><div \nng-messages=\"brandForm.MainContactPerson.$error\"><div ng-message=\"required\" \nng-if=\"brandForm.MainContactPerson.$touched\" class=\"help-block\"><span \ntranslate=\"admin.brand.validate.main_contact_person\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': brandForm.MainContactPhone.$invalid && brandForm.MainContactPhone.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.brand.main_contact_phone\"></label><div class=\"col-md-8\">\n<input name=\"MainContactPhone\" type=\"tel\" ng-pattern=\"/^[0-9]*$/\" class=\"form-control\" \nng-model=\"vm.brand.MainContactNumber\"><div ng-messages=\"brandForm.MainContactPhone.$error\"><div ng-message=\"required\" \nng-if=\"brandForm.MainContactPhone.$touched\" class=\"help-block\"><span \ntranslate=\"admin.brand.validate.main_contact_phone\"></span></div><div ng-message=\"pattern\" \nng-if=\"brandForm.MainContactPhone.$touched\" class=\"help-block\"><span \ntranslate=\"admin.brand.validate.main_contact_phone_number\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': brandForm.MainContactEmail.$invalid && brandForm.MainContactEmail.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.brand.email\"></label><div class=\"col-md-8\"><input \nname=\"MainContactEmail\" type=\"email\" class=\"form-control\" ng-model=\"vm.brand.Email\"><div \nng-messages=\"brandForm.MainContactEmail.$error\"><div ng-message=\"required\" ng-if=\"brandForm.MainContactEmail.$touched\" \nclass=\"help-block\"><span translate=\"admin.brand.validate.contact_email\"></span></div><div ng-message=\"email\" \nng-if=\"brandForm.MainContactEmail.$touched\" class=\"help-block\"><span \ntranslate=\"admin.brand.validate.contact_email_invalid\"></span></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.brand.website_url\"></label><div class=\"col-md-8\"><input \nname=\"MainContactWebsite\" type=\"text\" class=\"form-control\" ng-model=\"vm.brand.Website\"></div></div><div \nclass=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" translate=\"admin.brand.info\"></h4></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': brandForm.Name.$invalid && brandForm.Name.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"common.name\"></label><div class=\"col-md-8\"><input \nname=\"Name\" type=\"text\" class=\"form-control\" ng-model=\"vm.brand.Name\" required is-brand-name-available=\"vm.brand.Id\">\n<div ng-messages=\"brandForm.Name.$error\"><div ng-message=\"required\" ng-if=\"brandForm.Name.$touched\" class=\"help-block\">\n<span translate=\"admin.brand.validate.name\"></span></div><div ng-message=\"isBrandNameAvailable\" \nng-if=\"brandForm.Name.$touched\" class=\"help-block\"><span translate=\"admin.brand.validate.name_duplicate\"></span></div>\n</div></div></div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"common.description\"></label><div class=\"col-md-8\"><textarea name=\"Description\" rows=\"4\" \nclass=\"form-control\" ng-model=\"vm.brand.Description\" maxlength=\"5000\"></textarea></div></div><div class=\"form-group\">\n<label class=\"control-label col-md-3 margin-tb\" translate=\"common.group\"></label><div class=\"col-md-8\"><select \nname=\"Group\" class=\"form-control\" ng-model=\"vm.brand.GroupId\"><option value=\"0\">--- Select an option ---</option>\n<option ng-repeat=\"group in vm.groups\" ng-value=\"group.Id\">{{group.Name}}</option></select></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': brandForm.MainCategory.$invalid && brandForm.MainCategory.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"common.main_category\"></label><div class=\"col-md-8\">\n<select name=\"MainCategory\" class=\"form-control\" ng-model=\"vm.brand.MainCategoryId\" ng-change=\"vm.categorySelected()\" \nrequired><option ng-if=\"category.ParentCategoryId == null\" ng-repeat=\"category in vm.categories\" \nng-value=\"category.Id\">{{category.Name}}</option></select><div ng-messages=\"brandForm.MainCategory.$error\"><div \nng-message=\"required\" ng-if=\"brandForm.MainCategory.$touched\" class=\"help-block\"><span \ntranslate=\"admin.brand.validate.main_category\"></span></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"common.sub_category\"></label><div class=\"col-md-8\"><select \nname=\"SubCategory\" class=\"form-control\" ng-model=\"vm.brand.SubCategoryId\"><option \nng-repeat=\"subcategory in vm.subcategories\" ng-value=\"subcategory.Id\">{{subcategory.Name}}</option></select></div>\n</div><div class=\"form-group\" ng-show=\"false\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"admin.brand.tag\"></label><div class=\"col-md-8\"><ui-select multiple=\"multiple\" ng-model=\"vm.brand.Tags\" \ntheme=\"bootstrap\" close-on-select=\"true\" tagging=\"vm.tagTransform\" tagging-tokens=\"\"><ui-select-match \nplaceholder=\"Select tags...\">{{$item.Name}}</ui-select-match><ui-select-choices \nrepeat=\"tag in vm.tags | filter:$select.search\"><div ng-bind=\"tag.Name\"></div></ui-select-choices></ui-select></div>\n</div><div class=\"form-group\" ng-class=\"{\'has-error\': brandForm.Logo.$invalid && brandForm.Logo.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"common.logo\"></label><div class=\"col-md-8\"><div \nclass=\"logoForm-image\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.brand.LogoUrl\" ng-hide=\"true\" name=\"Logo\">\n<div upload-control class=\"upload-control image-uploader brand-logo\" \non-file-selected=\"vm.onLogoSelected($files, $control)\"><input type=\"file\" class=\"hidden\" accept=\".jpeg, .jpg, .png\"> <a\n translate=\"common.action.select_photo\" class=\"btn btn-default\"></a><label>{{vm.temp.Logo}}</label><div \nclass=\"image-wrapper\"><img id=\"photo\" \nng-src=\"{{vm.brand.LogoUrl ? vm.brand.LogoUrl + \'?w=300&h=300\': \'../../assets/images/placeholder.png\'}}\"></div></div>\n<button type=\"button\" class=\"btn-delete-photo\" ng-click=\"vm.deleteLogo()\" ng-hide=\"vm.disabledDeleteLogo\"><span \nclass=\"glyphicon glyphicon-trash\"></span></button></div><div><label class=\"note\" translate=\"voucher.note\"></label>\n</div><div ng-messages=\"brandForm.Logo.$error\"><div ng-message=\"dimensions\" class=\"help-block\"><p \ntranslate=\"admin.brand.validate.dimension\"></p></div><div ng-message=\"required\" ng-if=\"brandForm.Logo.$touched\" \nclass=\"help-block\"><span translate=\"admin.brand.validate.logo\"></span></div></div></div></div></div><div \nclass=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button \ntype=\"submit\" class=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div></div>\n</div>");
$templateCache.put("app/admin/configuration/configuration.html","<h1 class=\"page-header\"><span translate=\"admin.configuration.title\"></span> <a ng-click=\"vm.save()\" \nclass=\"btn btn-primary pull-right\" translate=\"common.action.save\"></a></h1><form name=\"configurationForm\" \nclass=\"tab-form-demo\" novalidate id=\"configurationForm\"><uib-tabset active=\"activeForm\"><uib-tab index=\"0\" \nheading=\"Topup Options\"><div class=\"form-horizontal\" id=\"topup-form\"><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.TopupAmountMinimun.$invalid && configurationForm.TopupAmountMinimun.$touched}\">\n<label class=\"control-label col-md-3 required\" translate=\"admin.configuration.topup_amount_minimun\"></label><div \nclass=\"col-md-2\"><input type=\"number\" name=\"TopupAmountMinimun\" class=\"form-control\" min=\"0\" \nng-model=\"vm.config.topupAmountMinimun\" required><div ng-messages=\"configurationForm.TopupAmountMinimun.$error\"><div \nng-message=\"required\" ng-if=\"configurationForm.TopupAmountMinimun.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.topup_amount_minimun_required\"></span></div><div ng-message=\"min\" \nclass=\"help-block\"><span translate=\"admin.configuration.errors.topup_amount_minimum_not_negative\"></span></div></div>\n</div></div><div class=\"form-group\"><label class=\"control-label col-md-3 required\" translate=\"Topup Options\"></label>\n<div class=\"col-md-8\" ng-repeat=\"option in vm.topupOptions\" ng-class=\"{\'col-md-offset-3\': $index > 0}\"><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': configurationForm[\'option\'+$index].$invalid && configurationForm[\'option\'+$index].$touched}\">\n<div class=\"col-md-3 col-xs-9\"><input type=\"number\" name=\"option{{$index}}\" class=\"form-control\" min=\"0\" \nng-model=\"option.Value\" required><div ng-messages=\"configurationForm[\'option\'+$index].$error\"><div \nng-message=\"required\" ng-if=\"configurationForm[\'option\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.option_required\"></span></div><div ng-message=\"min\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.option_not_negative\"></span></div></div></div><div class=\"col-md-3 col-xs-3\">\n<button type=\"button\" class=\"btn btn-danger\" ng-click=\"vm.removeOption($index)\"><i class=\"glyphicon glyphicon-remove\">\n</i></button></div></div></div><div class=\"col-md-3 col-md-offset-5\"><button type=\"button\" class=\"btn btn-primary\" \nng-click=\"vm.addTopupOption()\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.creditCardFeeRate.$invalid && configurationForm.creditCardFeeRate.$touched}\">\n<label class=\"control-label col-md-3 required\" translate=\"admin.configuration.credit_card_fee_rate\"></label><div \nclass=\"col-md-3 col-xs-9\"><input type=\"number\" name=\"creditCardFeeRate\" class=\"form-control\" min=\"0\" max=\"99\" \nstep=\"0.01\" ng-model=\"vm.config.ccFeeRate\" required><div ng-messages=\"configurationForm.creditCardFeeRate.$error\"><div \nng-message=\"required\" ng-if=\"configurationForm.creditCardFeeRate.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.credit_card_fee_rate_required\"></span></div><div ng-message=\"min\" \nclass=\"help-block\"><span translate=\"admin.configuration.errors.credit_card_fee_rate_not_negative\"></span></div><div \nng-message=\"max\" class=\"help-block\"><span translate=\"admin.configuration.errors.credit_card_fee_rate_not_exceed\">\n</span></div><div ng-message=\"step\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.credit_card_fee_rate_not_exceed_decimal\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 required\" translate=\"admin.configuration.allowLDC\"></label><div\n class=\"col-md-2\"><div class=\"input-group\"><label class=\"btn btn-default\" name=\"allowLDC\" \nng-model=\"vm.config.allowLDC\" uib-btn-radio=\"true\">YES</label><label class=\"btn btn-default\" name=\"allowLDC\" \nng-model=\"vm.config.allowLDC\" uib-btn-radio=\"false\">NO</label></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.configuration.allowLCC\"></label><div class=\"col-md-2\"><div \nclass=\"input-group\"><label class=\"btn btn-default\" name=\"allowLCC\" ng-model=\"vm.config.allowLCC\" uib-btn-radio=\"true\">\nYES</label><label class=\"btn btn-default\" name=\"allowLCC\" ng-model=\"vm.config.allowLCC\" uib-btn-radio=\"false\">NO\n</label></div></div></div><hr class=\"hr\"><div class=\"form-group\" style=\"font-size: larger\"><label \nclass=\"control-label col-md-3\" translate=\"admin.configuration.redpay_card_fee\"></label></div><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.CreditCardFee.$invalid && configurationForm.CreditCardFee.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.configuration.credit_card_fee\"></label><div \nclass=\"col-md-3 col-xs-9\"><input type=\"number\" name=\"CreditCardFee\" class=\"form-control\" min=\"0\" max=\"99\" \nng-model=\"vm.config.creditCardFee\" required><div ng-messages=\"configurationForm.CreditCardFee.$error\"><div \nng-message=\"required\" ng-if=\"configurationForm.CreditCardFee.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.credit_card_fee_required\"></span></div><div ng-message=\"min\" class=\"help-block\">\n<span translate=\"admin.configuration.errors.credit_card_fee_not_negative\"></span></div><div ng-message=\"max\" \nclass=\"help-block\"><span translate=\"admin.configuration.errors.credit_card_fee_not_exceed\"></span></div></div></div>\n</div><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.DebitCardFee.$invalid && configurationForm.DebitCardFee.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.configuration.debit_card_fee\"></label><div \nclass=\"col-md-3 col-xs-9\"><input type=\"number\" name=\"DebitCardFee\" class=\"form-control\" min=\"0\" max=\"99\" \nng-model=\"vm.config.debitCardFee\" required><div ng-messages=\"configurationForm.DebitCardFee.$error\"><div \nng-message=\"required\" ng-if=\"configurationForm.DebitCardFee.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.debit_card_fee_required\"></span></div><div ng-message=\"min\" class=\"help-block\">\n<span translate=\"admin.configuration.errors.debit_card_fee_not_negative\"></span></div><div ng-message=\"max\" \nclass=\"help-block\"><span translate=\"admin.configuration.errors.debit_card_fee_not_exceed\"></span></div></div></div>\n</div></div></uib-tab><uib-tab index=\"1\" heading=\"Least Cost Routing\"><div class=\"form-horizontal\" id=\"topup-form\"><div\n class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.LowBalanceMobilityOne.$invalid && configurationForm.LowBalanceMobilityOne.$touched}\">\n<label class=\"control-label col-md-3 required letter-spacing\" translate=\"admin.configuration.low_balance_mobility_one\">\n</label><div class=\"col-md-2\"><input type=\"number\" min=\"0\" name=\"LowBalanceMobilityOne\" class=\"form-control\" \nng-model=\"vm.config.lowBalanceMobilityOne\"><div ng-messages=\"configurationForm.LowBalanceMobilityOne.$error\"><div \nng-message=\"min\" ng-if=\"configurationForm.LowBalanceMobilityOne.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.low_balance_mobility_one_min\"></span></div></div></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.LowBalancePayHub.$invalid && configurationForm.LowBalancePayHub.$touched}\">\n<label class=\"control-label col-md-3 required letter-spacing\" translate=\"admin.configuration.low_balance_pay_hub\">\n</label><div class=\"col-md-2\"><input type=\"number\" min=\"0\" name=\"LowBalancePayHub\" class=\"form-control\" \nng-model=\"vm.config.lowBalancePayHub\"><div ng-messages=\"configurationForm.LowBalancePayHub.$error\"><div \nng-message=\"min\" ng-if=\"configurationForm.LowBalancePayHub.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.low_balance_pay_hub_min\"></span></div></div></div></div><div class=\"form-group\">\n<label class=\"control-label col-md-3 required\" translate=\"admin.configuration.email\"></label><div \nclass=\"col-md-8 col-xs-12\" ng-repeat=\"email in vm.config.emails\" ng-class=\"{\'col-md-offset-3\': $index > 0}\"><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': configurationForm[\'email\'+$index].$invalid && configurationForm[\'email\'+$index].$touched}\"><div\n class=\"col-md-3 col-xs-9\"><input type=\"email\" name=\"email{{$index}}\" class=\"form-control\" ng-model=\"email.Email\" \nrequired><div ng-messages=\"configurationForm[\'email\'+$index].$error\"><div ng-message=\"required\" \nng-if=\"configurationForm[\'email\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.email_required\"></span></div><div ng-message=\"email\" \nng-if=\"configurationForm[\'email\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.email_format\"></span></div></div></div><div class=\"col-md-3 col-xs-3\"><button \ntype=\"button\" class=\"btn btn-danger\" ng-click=\"vm.removeEmail($index)\"><i class=\"glyphicon glyphicon-remove\"></i>\n</button></div></div></div><div class=\"col-md-3 col-md-offset-5 col-xs-12\"><button type=\"button\" \nclass=\"btn btn-primary\" ng-click=\"vm.addEmail()\"><i class=\"glyphicon glyphicon-plus\"></i></button></div></div></div>\n</uib-tab><uib-tab index=\"2\" heading=\"Notifications\"><div class=\"form-horizontal\" id=\"topup-form\"><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.NumberOfDays.$invalid && configurationForm.NumberOfDays.$touched}\"><label \nclass=\"control-label col-md-3 required letter-spacing\" translate=\"admin.configuration.number_of_day_notification\">\n</label><div class=\"col-md-2\"><input type=\"number\" name=\"NumberOfDays\" class=\"form-control\" min=\"0\" \nng-model=\"vm.config.numberOfDayExpire\" required><div ng-messages=\"configurationForm.NumberOfDays.$error\"><div \nng-message=\"required\" ng-if=\"configurationForm.NumberOfDays.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.number_of_days_required\"></span></div><div ng-message=\"min\" class=\"help-block\">\n<span translate=\"admin.configuration.errors.number_of_day_not_negative\"></span></div></div></div></div></div></uib-tab>\n<uib-tab index=\"3\" heading=\"GST\"><div class=\"form-horizontal\" id=\"topup-form\"><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.GST.$invalid && configurationForm.GST.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.configuration.gst\"></label><div class=\"col-md-2\"><input \ntype=\"number\" name=\"GST\" disabled=\"disabled\" class=\"form-control\" min=\"0\" ng-model=\"vm.config.gst\" required><div \nng-messages=\"configurationForm.GST.$error\"><div ng-message=\"required\" ng-if=\"configurationForm.GST.$touched\" \nclass=\"help-block\"><span translate=\"admin.configuration.errors.gst_required\"></span></div><div ng-message=\"min\" \nclass=\"help-block\"><span translate=\"admin.configuration.errors.gst_not_negative\"></span></div></div></div></div></div>\n</uib-tab><uib-tab index=\"4\" heading=\"Void Option\"><div class=\"form-horizontal\" id=\"topup-form\"><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.VoidableTime.$invalid && configurationForm.VoidableTime.$touched}\"><label \nclass=\"control-label col-md-3\"></label><div class=\"col-md-6\"><ul class=\"col-md-12 list-group\"><li \nclass=\"list-group-item\"><input class=\"one\" type=\"radio\" ng-model=\"vm.showVoidableTime\" value=\"SameDay\"> Same Day</li>\n<li class=\"list-group-item\"><input class=\"tow\" type=\"radio\" ng-model=\"vm.showVoidableTime\" value=\"HourlyTimeFrame\">\n Hourly Time Frame</li></ul><div ng-show=\"vm.showVoidableTime == \'HourlyTimeFrame\'\"><input type=\"number\" \nname=\"VoidableTime\" class=\"form-control hour_value\" min=\"0\" max=\"48\" ng-model=\"vm.config.voidableTime\" required><div \nng-messages=\"configurationForm.VoidableTime.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.VoidableTime.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.voidable_time_required\"></span></div><div ng-message=\"min\" class=\"help-block\">\n<span translate=\"admin.configuration.errors.voidable_time_not_negative\"></span></div><div ng-message=\"max\" \nclass=\"help-block\"><span translate=\"admin.configuration.errors.voidable_time_max_value\"></span></div></div></div></div>\n</div></div></uib-tab><uib-tab index=\"5\" heading=\"Cash Option\"><div class=\"form-horizontal\" id=\"topup-form\"><div \nclass=\"form-group\" ng-class=\"{\'has-error\': configurationForm.MaxCash.$invalid && configurationForm.MaxCash.$touched}\">\n<label class=\"control-label col-md-3 required\" translate=\"admin.configuration.max_cash\"></label><div class=\"col-md-2\">\n<input type=\"number\" name=\"MaxCash\" class=\"form-control\" min=\"0\" ng-model=\"vm.config.maxCash\" required \nng-pattern=\"/^[0-9]+$/\"><div ng-messages=\"configurationForm.MaxCash.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.MaxCash.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.max_cash_required\"></span></div><div ng-message=\"min, number, pattern\" \nng-if=\"configurationForm.MaxCash.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.max_cash_invalid\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.KipleKashExpired.$invalid && configurationForm.KipleKashExpired.$touched}\">\n<label class=\"control-label col-md-3 required\" translate=\"admin.configuration.kiple_kash_expired\"></label><div \nclass=\"col-md-2\"><input type=\"number\" name=\"KipleKashExpired\" class=\"form-control\" min=\"0\" \nng-model=\"vm.config.kipleKashExpired\" required ng-pattern=\"/^[0-9]+$/\"><div \nng-messages=\"configurationForm.KipleKashExpired.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.KipleKashExpired.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.kiple_kash_expired_required\"></span></div><div ng-message=\"min, number, pattern\" \nng-if=\"configurationForm.KipleKashExpired.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.kiple_kash_expired_invalid\"></span></div></div></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.StoreCardsExpired.$invalid && configurationForm.StoreCardsExpired.$touched}\">\n<label class=\"control-label col-md-3 required\" translate=\"admin.configuration.store_cards_expired\"></label><div \nclass=\"col-md-2\"><input type=\"number\" name=\"StoreCardsExpired\" class=\"form-control\" min=\"0\" \nng-model=\"vm.config.storeCardsExpired\" required ng-pattern=\"/^[0-9]+$/\"><div \nng-messages=\"configurationForm.StoreCardsExpired.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.StoreCardsExpired.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.store_cards_expired_required\"></span></div><div \nng-message=\"min, number, pattern\" ng-if=\"configurationForm.StoreCardsExpired.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.store_cards_expired_invalid\"></span></div></div></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.WebCashBaseProcessingFee.$invalid && configurationForm.WebCashBaseProcessingFee.$touched}\">\n<label class=\"control-label col-md-3 required\" translate=\"admin.configuration.web_cash_base_processing_fee\"></label>\n<div class=\"col-md-2\"><input type=\"number\" name=\"WebCashBaseProcessingFee\" class=\"form-control\" min=\"0\" \nng-model=\"vm.config.webCashBaseProcessingFee\" required step=\"0.01\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\"><div \nng-messages=\"configurationForm.WebCashBaseProcessingFee.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.WebCashBaseProcessingFee.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.web_cash_base_processing_fee_required\"></span></div><div \nng-message=\"min, number, pattern\" ng-if=\"configurationForm.WebCashBaseProcessingFee.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.web_cash_base_processing_fee_invalid\"></span></div></div></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.KipleWithdrawChargeFee.$invalid && configurationForm.KipleWithdrawChargeFee.$touched}\">\n<label class=\"control-label col-md-3 required\" translate=\"admin.configuration.kiple_withdraw_charge_fee\"></label><div \nclass=\"col-md-2\"><input type=\"number\" name=\"KipleWithdrawChargeFee\" class=\"form-control\" min=\"0\" \nng-model=\"vm.config.kipleWithdrawChargeFee\" required step=\"0.01\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\"><div \nng-messages=\"configurationForm.KipleWithdrawChargeFee.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.KipleWithdrawChargeFee.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.kiple_withdraw_charge_fee_required\"></span></div><div \nng-message=\"min, number, pattern\" ng-if=\"configurationForm.KipleWithdrawChargeFee.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.kiple_withdraw_charge_fee_invalid\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"admin.configuration.kiplekash_mobile_reload\">\n</label><div class=\"col-md-3\"><div class=\"input-group\"><label class=\"btn btn-default\" name=\"KiplekashMobileReload\" \nng-model=\"vm.config.kiplekashMobileReload\" uib-btn-radio=\"true\">YES</label><label class=\"btn btn-default\" \nname=\"KiplekashMobileReload\" ng-model=\"vm.config.kiplekashMobileReload\" uib-btn-radio=\"false\">NO</label></div></div>\n</div><div class=\"form-group\"><label class=\"control-label col-md-3\" \ntranslate=\"admin.configuration.kiplekash_bill_payment\"></label><div class=\"col-md-3\"><div class=\"input-group\"><label \nclass=\"btn btn-default\" name=\"KiplekashBillPayment\" ng-model=\"vm.config.kiplekashBillPayment\" uib-btn-radio=\"true\">YES\n</label><label class=\"btn btn-default\" name=\"KiplekashBillPayment\" ng-model=\"vm.config.kiplekashBillPayment\" \nuib-btn-radio=\"false\">NO</label></div></div></div></div></uib-tab><uib-tab index=\"6\" heading=\"Hold\"><div \nclass=\"form-horizontal\" id=\"topup-form\"><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.HoldSetting.$invalid && configurationForm.HoldSetting.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.configuration.hold_name\"></label><div class=\"col-md-2\"><input \ntype=\"number\" name=\"HoldSetting\" class=\"form-control\" min=\"0\" ng-model=\"vm.config.hold\" required><div \nng-messages=\"configurationForm.HoldSetting.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.HoldSetting.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.hold_required\"></span></div><div ng-message=\"min\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.hold_not_negative\"></span></div></div></div></div></div></uib-tab><uib-tab \nindex=\"7\" heading=\"Email\"><div class=\"form-horizontal\" id=\"topup-form\"><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.FinanceEmail.$invalid && configurationForm.FinanceEmail.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.configuration.finance_email\"></label><div class=\"col-md-2\">\n<input type=\"text\" name=\"FinanceEmail\" class=\"form-control\" ng-model=\"vm.config.financeEmail\" \nng-pattern=\"/^(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+\\s?,)*(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+)$/\" required><div \nng-messages=\"configurationForm.FinanceEmail.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.HoldSetting.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.hold_required\"></span></div><div ng-message=\"pattern\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.email_invalid\"></span></div></div></div></div></div></uib-tab><uib-tab index=\"8\" \nheading=\"Visa Card\"><div class=\"form-horizontal\" id=\"topup-form\"><div class=\"form-group\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.configuration.allow_order_app\"></label><div class=\"col-md-2\">\n<div class=\"input-group\"><label class=\"btn btn-default\" name=\"allowApp\" ng-model=\"vm.config.allowApp\" \nuib-btn-radio=\"true\">YES</label><label class=\"btn btn-default\" name=\"allowApp\" ng-model=\"vm.config.allowApp\" \nuib-btn-radio=\"false\">NO</label></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.configuration.allow_order_OTS\"></label><div class=\"col-md-2\">\n<div class=\"input-group\"><label class=\"btn btn-default\" name=\"allowOTS\" ng-model=\"vm.config.allowOTS\" \nuib-btn-radio=\"true\">YES</label><label class=\"btn btn-default\" name=\"allowOTS\" ng-model=\"vm.config.allowOTS\" \nuib-btn-radio=\"false\">NO</label></div></div></div></div></uib-tab><uib-tab index=\"9\" heading=\"PTPTN/SSPN\"><div \nclass=\"form-horizontal\" id=\"topup-form\"><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.PTPTNAmount.$invalid && configurationForm.PTPTNAmount.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.configuration.ptptn_amount\"></label><div class=\"col-md-2\">\n<input type=\"number\" name=\"PTPTNAmount\" class=\"form-control\" min=\"0\" ng-model=\"vm.config.PTPTNAmount\" required \nng-pattern=\"/^[0-9]+$/\"><div ng-messages=\"configurationForm.PTPTNAmount.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.PTPTNAmount.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.ptptn_amount_required\"></span></div><div ng-message=\"min, number, pattern\" \nng-if=\"configurationForm.PTPTNAmount.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.ptptn_amount_invalid\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.PTPTNFee.$invalid && configurationForm.PTPTNFee.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.configuration.ptptn_fee\"></label><div class=\"col-md-2\"><input \ntype=\"number\" name=\"PTPTNFee\" class=\"form-control\" min=\"0\" ng-model=\"vm.config.PTPTNFee\" required \nng-pattern=\"/^[0-9]+$/\"><div ng-messages=\"configurationForm.PTPTNFee.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.PTPTNFee.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.ptptn_fee_required\"></span></div><div ng-message=\"min, number, pattern\" \nng-if=\"configurationForm.PTPTNFee.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.ptptn_fee_invalid\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.SSPNAmount.$invalid && configurationForm.SSPNAmount.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.configuration.sspn_amount\"></label><div class=\"col-md-2\">\n<input type=\"number\" name=\"SSPNAmount\" class=\"form-control\" min=\"0\" ng-model=\"vm.config.SSPNAmount\" required \nng-pattern=\"/^[0-9]+$/\"><div ng-messages=\"configurationForm.SSPNAmount.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.SSPNAmount.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.sspn_amount_required\"></span></div><div ng-message=\"min, number, pattern\" \nng-if=\"configurationForm.SSPNAmount.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.sspn_amount_invalid\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.SSPNFee.$invalid && configurationForm.SSPNFee.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.configuration.sspn_fee\"></label><div class=\"col-md-2\"><input \ntype=\"number\" name=\"SSPNFee\" class=\"form-control\" min=\"0\" ng-model=\"vm.config.SSPNFee\" required \nng-pattern=\"/^[0-9]+$/\"><div ng-messages=\"configurationForm.SSPNFee.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.SSPNFee.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.sspn_fee_required\"></span></div><div ng-message=\"min, number, pattern\" \nng-if=\"configurationForm.SSPNFee.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.sspn_fee_invalid\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.SSPNPlusAmount.$invalid && configurationForm.SSPNPlusAmount.$touched}\"><label\n class=\"control-label col-md-3 required\" translate=\"admin.configuration.sspn_plus_amount\"></label><div \nclass=\"col-md-2\"><input type=\"number\" name=\"SSPNPlusAmount\" class=\"form-control\" min=\"0\" \nng-model=\"vm.config.SSPNPlusAmount\" required ng-pattern=\"/^[0-9]+$/\"><div \nng-messages=\"configurationForm.SSPNPlusAmount.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.SSPNPlusAmount.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.sspn_plus_amount_required\"></span></div><div ng-message=\"min, number, pattern\" \nng-if=\"configurationForm.SSPNPlusAmount.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.sspn_plus_amount_invalid\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.SSPNPlusFee.$invalid && configurationForm.SSPNPlusFee.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.configuration.sspn_plus_fee\"></label><div class=\"col-md-2\">\n<input type=\"number\" name=\"SSPNPlusFee\" class=\"form-control\" min=\"0\" ng-model=\"vm.config.SSPNPlusFee\" required \nng-pattern=\"/^[0-9]+$/\"><div ng-messages=\"configurationForm.SSPNPlusFee.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.SSPNPlusFee.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.sspn_plus_fee_required\"></span></div><div ng-message=\"min, number, pattern\" \nng-if=\"configurationForm.SSPNPlusFee.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.sspn_plus_fee_invalid\"></span></div></div></div></div></div></uib-tab><uib-tab \nindex=\"10\" heading=\"OTC Cash Reload\" ng-hide=\"vm.isOTCTabHidden\"><div class=\"form-horizontal\" id=\"topup-form\"><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.cashReloadFee.$invalid && configurationForm.cashReloadFee.$touched}\"><label \nclass=\"control-label col-md-4 required\" translate=\"admin.configuration.cash_reload_fee\"></label><div class=\"col-md-2\">\n<div class=\"input-group\"><input type=\"number\" name=\"cashReloadFee\" class=\"form-control\" min=\"0\" step=\"0.01\" \nng-model=\"vm.config.cashReloadFee\" required> <span class=\"input-group-addon\" id=\"basic-addon1\">%</span><div \nng-messages=\"configurationForm.cashReloadFee.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.cashReloadFee.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.cash_reload_fee_required\"></span></div><div ng-message=\"min, number, pattern\" \nng-if=\"configurationForm.cashReloadFee.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.cash_reload_fee_invalid\"></span></div><div ng-message=\"step\" class=\"help-block\">\n<span translate=\"admin.configuration.errors.cash_reload_fee_not_exceed_decimal\"></span></div></div></div></div><div \nclass=\"col-md-1\"><label class=\"col-md-2\" translate=\"admin.configuration.or_min\"></label></div><div \nng-class=\"{\'has-error\': configurationForm.cashReloadServiceFee.$invalid && configurationForm.cashReloadServiceFee.$touched}\">\n<div class=\"col-md-2\"><input type=\"number\" name=\"cashReloadServiceFee\" class=\"form-control\" min=\"0\" step=\"0.01\" \nng-model=\"vm.config.cashReloadServiceFee\" required><div ng-messages=\"configurationForm.cashReloadServiceFee.$error\">\n<div ng-message=\"required\" ng-if=\"configurationForm.cashReloadServiceFee.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.cash_reload_service_fee_required\"></span></div><div \nng-message=\"min, number, pattern\" ng-if=\"configurationForm.cashReloadFee.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.cash_reload_service_fee_invalid\"></span></div><div ng-message=\"step\" \nclass=\"help-block\"><span translate=\"admin.configuration.errors.cash_reload_service_fee_not_exceed_decimal\"></span>\n</div></div></div></div><div class=\"col-md-1\"><span>per transaction</span></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.minReloadAmount.$invalid && configurationForm.minReloadAmount.$touched}\">\n<label class=\"control-label col-md-4 required\" translate=\"admin.configuration.min_reload_amount\"></label><div \nclass=\"col-md-2\"><input type=\"number\" name=\"minReloadAmount\" class=\"form-control\" min=\"0\" \nng-model=\"vm.config.minReloadAmount\" required ng-pattern=\"/^[0-9]+$/\"><div \nng-messages=\"configurationForm.minReloadAmount.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.minReloadAmount.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.min_reload_amount_required\"></span></div><div ng-message=\"min, number, pattern\" \nng-if=\"configurationForm.minReloadAmount.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.min_reload_amount_invalid\"></span></div></div></div><div class=\"col-md-3\"><span>\nper transaction</span></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.maxReloadAmount.$invalid && configurationForm.maxReloadAmount.$touched}\">\n<label class=\"control-label col-md-4 required\" translate=\"admin.configuration.max_reload_amount\"></label><div \nclass=\"col-md-2\"><input type=\"number\" name=\"maxReloadAmount\" class=\"form-control\" min=\"0\" \nng-model=\"vm.config.maxReloadAmount\" required ng-pattern=\"/^[0-9]+$/\"><div \nng-messages=\"configurationForm.maxReloadAmount.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.maxReloadAmount.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.max_reload_amount_required\"></span></div><div ng-message=\"min, number, pattern\" \nng-if=\"configurationForm.maxReloadAmount.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.max_reload_amount_invalid\"></span></div></div></div><div class=\"col-md-3\"><span>\nper transaction</span></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.paymentValidity.$invalid && configurationForm.paymentValidity.$touched}\">\n<label class=\"control-label col-md-4 required\" translate=\"admin.configuration.payment_validity\"></label><div \nclass=\"col-md-2\"><input type=\"number\" name=\"paymentValidity\" class=\"form-control\" min=\"0\" \nng-model=\"vm.config.paymentValidity\" required ng-pattern=\"/^[0-9]+$/\"><div \nng-messages=\"configurationForm.paymentValidity.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.paymentValidity.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.payment_validity_required\"></span></div><div ng-message=\"min, number, pattern\" \nng-if=\"configurationForm.paymentValidity.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.payment_validity_invalid\"></span></div></div></div><div class=\"col-md-3\"><span>\nhour(s)</span></div></div><div class=\"form-group\"><label class=\"control-label col-md-4 required\" \ntranslate=\"admin.configuration.show_7eleven_option\"></label><div class=\"col-md-2\"><div class=\"input-group\"><label \nclass=\"btn btn-default\" name=\"show7Eleven\" ng-model=\"vm.config.show7Eleven\" uib-btn-radio=\"true\">YES</label><label \nclass=\"btn btn-default\" name=\"show7Eleven\" ng-model=\"vm.config.show7Eleven\" uib-btn-radio=\"false\">NO</label></div>\n</div></div><div class=\"form-group\"><label class=\"control-label col-md-4 required\" \ntranslate=\"admin.configuration.show_kkmart_option\"></label><div class=\"col-md-2\"><div class=\"input-group\"><label \nclass=\"btn btn-default\" name=\"showKKMart\" ng-model=\"vm.config.showKKMart\" uib-btn-radio=\"true\">YES</label><label \nclass=\"btn btn-default\" name=\"showKKMart\" ng-model=\"vm.config.showKKMart\" uib-btn-radio=\"false\">NO</label></div></div>\n</div><div class=\"form-group\"><label class=\"control-label col-md-4 required\" \ntranslate=\"admin.configuration.show_redpay_option\"></label><div class=\"col-md-2\"><div class=\"input-group\"><label \nclass=\"btn btn-default\" name=\"showRedPayOTC\" ng-model=\"vm.config.showRedPayOTC\" uib-btn-radio=\"true\">YES</label><label \nclass=\"btn btn-default\" name=\"showRedPayOTC\" ng-model=\"vm.config.showRedPayOTC\" uib-btn-radio=\"false\">NO</label></div>\n</div></div></div></uib-tab><uib-tab index=\"11\" heading=\"DuitNow\"><div class=\"form-horizontal\" id=\"duitnow-form\"><h3>\nPartner Settings</h3><table class=\"table table-bordered\"><thead><tr><th>Partner</th><th class=\"text-center\">\nAllow DuitNow</th><th class=\"text-center\">Allow DN QR P2P</th><th class=\"text-center\">Min Amt<br>DN QR P2P</th><th \nclass=\"text-center\">Fee (&lt;RM5k/txn)<br>DN QR P2P</th><th class=\"text-center\">Fee (&ge;RM5k/txn)<br>DN QR P2P</th><th\n class=\"text-center\">Allow DN Transfer</th><th class=\"text-center\">Min Amt<br>DN Transfer</th><th class=\"text-center\">\nFee (&lt;RM5k/txn)<br>DN Transfer P2P</th><th class=\"text-center\">Fee (&ge;RM5k/txn)<br>DN Transfer P2P</th></tr>\n</thead><tbody><tr ng-repeat=\"partner in vm.duitNowPartners\"><td>{{partner.name}}</td><td><div class=\"input-group\">\n<label class=\"btn btn-default\" ng-model=\"partner.allowDuitNow\" uib-btn-radio=\"true\">Yes</label><label \nclass=\"btn btn-default\" ng-model=\"partner.allowDuitNow\" uib-btn-radio=\"false\">No</label></div></td><td><div \nclass=\"input-group\"><label class=\"btn btn-default\" ng-model=\"partner.allowQR\" uib-btn-radio=\"true\">Yes</label><label \nclass=\"btn btn-default\" ng-model=\"partner.allowQR\" uib-btn-radio=\"false\">No</label></div></td><td><input type=\"text\" \nclass=\"form-control\" min=\"0\" ng-model=\"partner.minAmount\" required ng-pattern=\"/^[0-9]+$/\" \nonkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" \noninput=\"this.value = this.value.replace(/[^0-9]/g, \'\')\" placeholder=\"Integer only\"></td><td><input type=\"number\" \nstep=\"0.01\" class=\"form-control\" min=\"0\" ng-model=\"partner.feeBelow\" required></td><td><input type=\"number\" \nstep=\"0.01\" class=\"form-control\" min=\"0\" ng-model=\"partner.feeAbove\" required></td><td><div class=\"input-group\"><label \nclass=\"btn btn-default\" ng-model=\"partner.allowDNTransfer\" uib-btn-radio=\"true\">Yes</label><label \nclass=\"btn btn-default\" ng-model=\"partner.allowDNTransfer\" uib-btn-radio=\"false\">No</label></div></td><td><input \ntype=\"text\" class=\"form-control\" min=\"0\" ng-model=\"partner.minAmountDNTransfer\" required ng-pattern=\"/^[0-9]+$/\" \nonkeypress=\"return event.charCode >= 48 && event.charCode <= 57\" \noninput=\"this.value = this.value.replace(/[^0-9]/g, \'\')\" placeholder=\"Integer only\"></td><td><input type=\"number\" \nstep=\"0.01\" class=\"form-control\" min=\"0\" ng-model=\"partner.feeBelowDNTransfer\" required></td><td><input type=\"number\" \nstep=\"0.01\" class=\"form-control\" min=\"0\" ng-model=\"partner.feeAboveDNTransfer\" required></td></tr></tbody></table>\n</div></uib-tab></uib-tabset><div id=\"message\" class=\"form-group\"><div data-ng-show=\"vm.showMessage\" \nng-class=\"{fade:vm.doFade,\'alert alert-danger\': !vm.isSuccess,\'alert alert-success\': vm.isSuccess}\"><strong>\n{{vm.alertTitle}}</strong> {{vm.errorMessage}}</div></div></form>");
$templateCache.put("app/admin/co-brand-artwork-configuration/co-brand-artwork-configuration.html","<h1 class=\"page-header\" translate=\"Kiple Visa Card Artwork Configuration\"></h1><div \nid=\"co-brand-artwork-configuration\" class=\"col-md-12\"><div class=\"form-horizontal\"><div class=\"row\"><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.criteria.Keyword\" \nng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter the Name\"></div><div class=\"col-md-1 col-sm-10\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span \ntranslate=\"common.action.reset\"></span></a></div><div class=\"col-md-2 col-sm-2\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.openDialog(\'new\')\"><i class=\"glyphicon glyphicon-plus\"></i> \n<span translate=\"common.action.add\"></span></a></div></div><div class=\"form-group\"><div class=\"table-responsive\"><table\n class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th width=\"20%\" translate=\"ArtWork\"></th><th \ntranslate=\"Campaign Name\"></th><th translate=\"Campaign ID\"></th><th translate=\"Channel Type\"></th><th \ntranslate=\"Card Type\"></th><th translate=\"Description\"></th><th translate=\"ArtWorkFile\"></th><th translate=\"Community\">\n</th><th translate=\"University\"></th><th translate=\"common.action.title\"></th></tr></thead><tbody><tr \nng-repeat=\"coBrandArt in vm.coBrandArtWork\"><td class=\"center\">{{$index + 1}}</td><td width=\"20%\"><img \nstyle=\"width:100%\" class=\"photo\" ng-src=\"{{coBrandArt.CardImage}}\"></td><td>{{coBrandArt.CampaignName}}</td><td>\n{{coBrandArt.CampaignId}}</td><td>{{coBrandArt.ChannelType}}</td><td>{{coBrandArt.VisaCardType}}</td><td>\n{{coBrandArt.Description}}</td><td class=\"center\"><a title=\"Download\" class=\"btn btn-default margin-tl\" \nhref=\"{{coBrandArt.CardImage}}\">Download</a></td><td>{{coBrandArt.CommunityName}}</td><td>{{coBrandArt.UniversityName}}\n</td><td class=\"center\"><a title=\"Edit\" class=\"btn btn-default margin-tl\" ng-click=\"vm.openDialog(\'edit\', coBrandArt)\">\n<i class=\"glyphicon glyphicon-edit\"></i> </a><a title=\"Unpublish\" ng-if=\"vm.toMainServiceStatusBool(coBrandArt.State)\" \nclass=\"btn btn-danger margin-tl\" ng-click=\"vm.unpublish(coBrandArt)\"><i class=\"glyphicon glyphicon-cloud-download\"></i>\n </a><a title=\"Publish\" ng-if=\"!vm.toMainServiceStatusBool(coBrandArt.State)\" class=\"btn btn-primary margin-tl\" \nng-click=\"vm.publish(coBrandArt)\"><i class=\"glyphicon glyphicon-cloud-upload\"></i> </a><a title=\"Remove\" \nclass=\"btn btn-danger margin-tl\" ng-click=\"vm.remove(coBrandArt)\"><i class=\"glyphicon glyphicon-remove\"></i></a></td>\n</tr></tbody></table></div><ul uib-pagination total-items=\"vm.totalItems\" ng-change=\"vm.search()\" \nng-model=\"vm.currentPage\" items-per-page=\"vm.criteria.Length\" max-size=\"vm.maxSize\" class=\"pagination-sm\" \nboundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><form name=\"CoBrandArtWorkInfoForm\" \nclass=\"form-horizontal\" ng-submit=\"vm.save(CoBrandArtWorkInfoForm)\" novalidate id=\"CoBrandArtWorkInfoForm\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowDialog = false\"><span \naria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" \nid=\"modal-title\" translate=\"Add Co-Brand Art Work\"></h3></div><div class=\"modal-body\"><div class=\"form-group\"><label \nclass=\"control-label col-md-3 required\">Channel Type</label><div class=\"col-md-8\"><select class=\"form-control\" \nid=\"ChannelType\" name=\"ChannelType\" ng-model=\"vm.Cobrand.ChannelType\" required ng-change=\"vm.ChannelTypeChange()\">\n<option ng-repeat=\"CTOptions in vm.ChannelTypeOptions\" ng-value=\"CTOptions.Id\">{{CTOptions.Name}}</option></select>\n</div><div ng-messages=\"CoBrandArtWorkInfoForm.ChannelType.$error\"><div ng-message=\"required\" \nng-if=\"CoBrandArtWorkInfoForm.ChannelType.$touched\" class=\"help-block\"><span>Channel Type is required field</span>\n</div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': CoBrandArtWorkInfoForm.CampaignName.$invalid && CoBrandArtWorkInfoForm.CampaignName.$touched}\">\n<label class=\"control-label col-md-3 margin-tb required\" translate=\"Campaign Name\"></label><div class=\"col-md-8\"><input\n type=\"text\" name=\"CampaignName\" class=\"form-control\" ng-model=\"vm.Cobrand.CampaignName\" required><div \nng-messages=\"CoBrandArtWorkInfoForm.CampaignName.$error\"><div ng-message=\"required\" \nng-if=\"CoBrandArtWorkInfoForm.CampaignName.$touched\" class=\"help-block\"><span>Campaign Name is required field</span>\n</div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': CoBrandArtWorkInfoForm.CampaignId.$invalid && CoBrandArtWorkInfoForm.CampaignId.$touched}\">\n<label class=\"control-label col-md-3 margin-tb required\" translate=\"Campaign Id\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"CampaignId\" class=\"form-control\" ng-model=\"vm.Cobrand.CampaignId\" required><div \nng-messages=\"CoBrandArtWorkInfoForm.CampaignId.$error\"><div ng-message=\"required\" \nng-if=\"CoBrandArtWorkInfoForm.CampaignId.$touched\" class=\"help-block\"><span>Campaign Id is required field</span></div>\n</div></div></div><div class=\"form-group\" ng-if=\"vm.Cobrand.ChannelType==2\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"Description\"></label><div class=\"col-md-8\"><input type=\"text\" \nmaxlength=\"100\" name=\"CampaignId\" class=\"form-control\" ng-model=\"vm.Cobrand.Description\"></div></div><div \nclass=\"form-group\" ng-if=\"vm.Cobrand.ChannelType==2\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"Community\"></label><div class=\"col-md-8\"><select class=\"form-control\" id=\"Community\" name=\"Community\" \nng-model=\"vm.Cobrand.CommunityId\" ng-disabled=\"vm.disableCommunity\"><option ng-value=\"null\">Select Community</option>\n<option ng-repeat=\"CTOptions in vm.CommunityList\" ng-value=\"CTOptions.Id\">{{CTOptions.Name}}</option></select></div>\n</div><div class=\"form-group\" ng-if=\"vm.Cobrand.ChannelType==2\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"University\"></label><div class=\"col-md-8\"><select class=\"form-control\" id=\"University\" name=\"Community\" \nng-model=\"vm.Cobrand.UniversityId\" ng-disabled=\"vm.disableUniversity\"><option ng-value=\"null\">Select University\n</option><option ng-repeat=\"CTOptions in vm.UniversityList\" ng-value=\"CTOptions.UniversityId\">{{CTOptions.Name}}\n</option></select></div></div><div class=\"form-group\"><label class=\"control-label col-md-3 required\">\nKiple Visa Card Type</label><div class=\"col-md-8\"><select class=\"form-control\" id=\"CardType\" name=\"CardType\" \nng-model=\"vm.Cobrand.VisaCardType\" required><option ng-repeat=\"CTOptions in vm.CardTypeOptions\" \nng-value=\"CTOptions.Id\">{{CTOptions.Name}}</option></select></div><div \nng-messages=\"CoBrandArtWorkInfoForm.CardType.$error\"><div ng-message=\"required\" \nng-if=\"CoBrandArtWorkInfoForm.CardType.$touched\" class=\"help-block\"><span>Card Type is required field</span></div>\n</div></div><div class=\"form-group\" ng-if=\"vm.Cobrand.VisaCardType==2||vm.Cobrand.VisaCardType==3\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"Select Fields 1\"></label><div class=\"col-md-8\"><select \nclass=\"form-control\" id=\"CardDummy1\" name=\"CardDummy1\" ng-model=\"vm.Cobrand.CardDummy1\" ng-disabled=\"vm.disableDummy1\">\n<option ng-value=\"null\">Select Community</option></select></div></div><div class=\"form-group\" \nng-if=\"vm.Cobrand.VisaCardType==2||vm.Cobrand.VisaCardType==3\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"Select Fields 2\"></label><div class=\"col-md-8\"><select class=\"form-control\" id=\"CardDummy2\" \nname=\"CardDummy2\" ng-model=\"vm.Cobrand.CardDummy2\" ng-disabled=\"vm.disableDummy2\"><option ng-value=\"null\">\nSelect University</option></select></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': CoBrandArtWorkInfoForm.file.$invalid && CoBrandArtWorkInfoForm.file.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"Card Image\"></label><div class=\"photos-form col-md-8\"><div \nclass=\"upload-controls\" ng-if=\"vm.Cobrand.Photos.length==0\"><input type=\"file\" class=\"button\" \nngf-select=\"vm.uploadPhoto($files, $invalidFiles)\" name=\"file\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" \nng-model=\"vm.temp.Photo\" ngf-multiple=\"false\"></div><div ng-if=\"vm.Cobrand.Photos.length==0\"><label class=\"note\" \ntranslate=\"admin.HomePageMainServiceInfo.validate.photo.note\"></label></div><div class=\"file-list\" style=\"width:100%\">\n<div ng-messages=\"CoBrandArtWorkInfoForm.file.$error\"><div ng-message=\"dimensions\" \nng-if=\"CoBrandArtWorkInfoForm.file.$dirty\" class=\"help-block\"><p \ntranslate=\"admin.HomePageMainServiceInfo.validate.photo.dimension\"></p></div></div><ul \ndnd-list=\"vm.mainService.Photos\"><li ng-repeat=\"photo in vm.Cobrand.Photos\" style=\"font:smaller\"><div \nclass=\"preview-photos\"><span class=\"dnd\"></span> <img style=\"width:100%;padding-bottom:1%\" src=\"{{photo}}\" \nclass=\"thumb\"> <a ng-click=\"vm.removePhoto($index)\" class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-remove\"></i> \n<span translate=\"Remove\"></span></a></div></li></ul></div></div></div></div><div class=\"modal-footer\"><a \nclass=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button type=\"submit\" \nclass=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div></div></div>");
$templateCache.put("app/admin/education-service/education-service.html","<h1 class=\"page-header\" translate=\"Education Service\"></h1><div id=\"education-service\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><input type=\"text\" \nclass=\"form-control\" ng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"Enter the Name\"></div><div class=\"col-md-1 col-sm-10\"><a class=\"btn btn-primary pull-right margin-tl\" \nng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a>\n</div><div class=\"col-md-2 col-sm-2\"><a class=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.openDialog(\'new\')\"><i\n class=\"glyphicon glyphicon-plus\"></i> <span translate=\"common.action.add\"></span></a></div></div><div \nclass=\"form-group\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered\"><thead><tr><th>#\n</th><th hidden>Id</th><th translate=\"University Name\"></th><th translate=\"University Logo\"></th><th \ntranslate=\"Organization Category\"></th><th translate=\"Position\"></th><th translate=\"Display Name\"></th><th \ntranslate=\"Deeplink URL\"></th><th translate=\"Provider\"></th><th translate=\"common.action.title\"></th></tr></thead>\n<tbody><tr ng-repeat=\"eduservice in vm.educationservice\"><td class=\"center\">{{$index + 1}}</td><td hidden>\n{{eduservice.Id}}</td><td>{{eduservice.UniversityName}}</td><td width=\"20%\"><img style=\"width:100%\" class=\"photo\" \nng-src=\"{{eduservice.UniversityLogo}}\"></td><td>{{eduservice.OrganizationCategory}}</td><td>\n{{eduservice.OrganizationPosition}}</td><td>{{eduservice.ServiceName}}</td><td>{{eduservice.DeeplinkUrl}}</td><td>\n{{eduservice.DeeplinkProvider}}</td><td class=\"center\"><a title=\"Edit\" class=\"btn btn-default margin-tl\" \nng-click=\"vm.openDialog(\'edit\', eduservice)\"><i class=\"glyphicon glyphicon-edit\"></i> </a><a title=\"Unpublish\" \nng-if=\"vm.toMainServiceStatusBool(eduservice.Status)\" class=\"btn btn-danger margin-tl\" \nng-click=\"vm.unpublish(eduservice)\"><i class=\"glyphicon glyphicon-cloud-download\"></i> </a><a title=\"Publish\" \nng-if=\"!vm.toMainServiceStatusBool(eduservice.Status)\" class=\"btn btn-primary margin-tl\" \nng-click=\"vm.publish(eduservice)\"><i class=\"glyphicon glyphicon-cloud-upload\"></i> </a><a title=\"Remove\" \nclass=\"btn btn-danger margin-tl\" ng-click=\"vm.remove(eduservice)\"><i class=\"glyphicon glyphicon-remove\"></i></a></td>\n</tr></tbody></table></div><ul uib-pagination total-items=\"vm.totalItems\" ng-change=\"vm.search()\" \nng-model=\"vm.currentPage\" items-per-page=\"vm.criteria.Length\" max-size=\"vm.maxSize\" class=\"pagination-sm\" \nboundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><form name=\"educationForm\" class=\"form-horizontal\" \nng-submit=\"vm.save(educationForm)\" novalidate id=\"educationForm\"><div class=\"modal-header\"><button type=\"button\" \nclass=\"close\" ng-click=\"vm.viewConfig.ShowDialog = false\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">\nClose</span></button><h3 class=\"modal-title center\" id=\"modal-title\" translate=\"Add Service\"></h3></div><div \nclass=\"modal-body\"><div class=\"form-group university\" \nng-class=\"{\'has-error\': educationForm.UniversityId.$invalid && educationForm.UniversityId.$touched && vm.merchant.IsUniversityMerchant == 1}\">\n<label class=\"control-label col-md-3 required\">University</label><div class=\"col-md-8\"><select class=\"form-control\" \nid=\"UniversityId\" name=\"UniversityId\" ng-model=\"vm.eduservice.UniId\"><option \nng-repeat=\"university in vm.universtyList\" value=\"{{university.UniversityId}}\">{{university.Name}}</option></select>\n<div ng-messages=\"educationForm.UniversityId.$error\"><div ng-message=\"\" ng-if=\"educationForm.UniversityId.$touched\" \nclass=\"help-block\"><span>University is required</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': educationForm.ServiceName.$invalid && educationForm.ServiceName.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb required\" translate=\"admin.educationForm.name\"></label><div class=\"col-md-8\">\n<input type=\"text\" name=\"ServiceName\" class=\"form-control\" ng-model=\"vm.eduservice.ServiceName\" required><div \nng-messages=\"educationForm.ServiceName.$error\"><div ng-message=\"required\" ng-if=\"educationForm.ServiceName.$touched\" \nclass=\"help-block\"><span>Name is required field</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': educationForm.OrganizationCategory.$invalid && educationForm.OrganizationCategory.$touched}\">\n<label class=\"control-label col-md-3 margin-tb required\" translate=\"admin.educationForm.organizationCategory\"></label>\n<div class=\"col-md-8\"><select name=\"channel\" class=\"form-control\" ng-model=\"vm.eduservice.OrganizationCategory\" \nrequired><option ng-value=\"null\"></option><option ng-repeat=\"option in vm.OrganizationCategory\" value=\"{{option.Id}}\">\n{{option.Name}}</option></select><div ng-messages=\"educationForm.OrganizationCategory.$error\"><div \nng-message=\"required\" ng-if=\"educationForm.OrganizationCategory.$touched\" class=\"help-block\"><span>\nOrganization Category is required field</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': educationForm.Position.$invalid && educationForm.Position.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb required\" translate=\"admin.educationForm.position\"></label><div \nclass=\"col-md-8\"><input type=\"number\" name=\"Position\" min=\"1\" class=\"form-control\" ng-model=\"vm.eduservice.Position\" \nrequired><div ng-messages=\"educationForm.Position.$error\"><div ng-message=\"required\" \nng-if=\"educationForm.Position.$touched\" class=\"help-block\"><span>Position is required field</span></div></div></div>\n</div><div class=\"form-group\" \nng-class=\"{\'has-error\': educationForm.DeepinkUrl.$invalid && educationForm.DeepinkUrl.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.educationForm.deeplinkURL\"></label><div class=\"col-md-8\">\n<input type=\"text\" name=\"DeepinkUrl\" class=\"form-control\" ng-model=\"vm.eduservice.DeepinkUrl\"></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': educationForm.DeeplinkProvider.$invalid && educationForm.DeeplinkProvider.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.educationForm.DeeplinkProvider\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"DeeplinkProvider\" class=\"form-control\" \nng-model=\"vm.eduservice.DeeplinkProvider\"></div></div></div><div class=\"modal-footer\"><a class=\"btn btn-danger\" \nng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button type=\"submit\" class=\"btn btn-primary\" \ntranslate=\"common.action.save\"></button></div></form></div></div></div></div></div>");
$templateCache.put("app/admin/fraudManagement/fraudManagement.html","<h1 class=\"page-header\"><span translate=\"admin.fraudManagement.title\"></span> <a ng-click=\"vm.save()\" \nclass=\"btn btn-primary pull-right\" translate=\"common.action.save\"></a></h1><form name=\"fraudForm\" \nng-submit=\"vm.save()\" novalidate id=\"fraudForm\"><div class=\"form-horizontal\"><div class=\"form-group\"><label \nclass=\"control-label col-md-4 required\" translate=\"admin.fraudManagement.purchase_topup_more_than\"></label><div \nclass=\"col-md-3 margin-tb\" \nng-class=\"{\'has-error\': fraudForm.DayPurchaseTopup.$invalid && fraudForm.DayPurchaseTopup.$touched}\"><div \nclass=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">RM</span> <input type=\"number\" \nname=\"DayPurchaseTopup\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.fraudManagements.DayPurchaseOrTopupOfMoreThan\" required></div><div \nng-messages=\"fraudForm.DayPurchaseTopup.$error\"><div ng-message=\"required\" ng-if=\"fraudForm.DayPurchaseTopup.$touched\" \nclass=\"help-block\"><span translate=\"admin.fraudManagement.errors.require\"></span></div></div></div><div \nclass=\"col-md-3 margin-tb\" \nng-class=\"{\'has-error\': fraudForm.DayPurchaseTopupPerDay.$invalid && fraudForm.DayPurchaseTopupPerDay.$touched}\"><div \nclass=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">in</span> <input type=\"number\" \nname=\"DayPurchaseTopupPerDay\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.fraudManagements.DayPurchaseOrTopupOfMoreThanPerDay\" required> <span class=\"input-group-addon\" \nid=\"basic-addon1\">day</span></div><div ng-messages=\"fraudForm.DayPurchaseTopupPerDay.$error\"><div \nng-message=\"required\" ng-if=\"fraudForm.DayPurchaseTopupPerDay.$touched\" class=\"help-block\"><span \ntranslate=\"admin.fraudManagement.errors.require\"></span></div></div></div><label class=\"control-label col-md-2\" \nstyle=\"text-align:left\" translate=\"admin.fraudManagement.day_by_single\"></label></div><div class=\"form-group\"><label \nclass=\"control-label col-md-4 required\" translate=\"admin.fraudManagement.purchase_topup_more_than\"></label><div \nclass=\"col-md-3 margin-tb\" \nng-class=\"{\'has-error\': fraudForm.CalendarDayPurchaseTopup.$invalid && fraudForm.CalendarDayPurchaseTopup.$touched}\">\n<div class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">RM</span> <input type=\"number\" \nname=\"CalendarDayPurchaseTopup\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.fraudManagements.CalendarDayPurchaseOrTopupOfMoreThan\" required></div><div \nng-messages=\"fraudForm.CalendarDayPurchaseTopup.$error\"><div ng-message=\"required\" \nng-if=\"fraudForm.CalendarDayPurchaseTopup.$touched\" class=\"help-block\"><span \ntranslate=\"admin.fraudManagement.errors.require\"></span></div></div></div><div class=\"col-md-3 margin-tb\" \nng-class=\"{\'has-error\': fraudForm.CalendarDayPurchaseTopupPerDay.$invalid && fraudForm.CalendarDayPurchaseTopupPerDay.$touched}\">\n<div class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">in last</span> <input type=\"number\" \nname=\"CalendarDayPurchaseTopupPerDay\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.fraudManagements.CalendarPurchaseOrTopupOfMoreThanPerDay\" required> <span class=\"input-group-addon\" \nid=\"basic-addon1\">calendar days</span></div><div ng-messages=\"fraudForm.CalendarDayPurchaseTopupPerDay.$error\"><div \nng-message=\"required\" ng-if=\"fraudForm.CalendarDayPurchaseTopupPerDay.$touched\" class=\"help-block\"><span \ntranslate=\"admin.fraudManagement.errors.require\"></span></div></div></div><label class=\"control-label col-md-2\" \nstyle=\"text-align:left\" translate=\"admin.fraudManagement.day_by_single\"></label></div><div class=\"form-group\"><label \nclass=\"control-label col-md-4 required\" translate=\"admin.fraudManagement.purchase_topup_more_than\"></label><div \nclass=\"col-md-3 margin-tb\" \nng-class=\"{\'has-error\': fraudForm.DayPeriodPurchaseTopup.$invalid && fraudForm.DayPeriodPurchaseTopup.$touched}\"><div \nclass=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">RM</span> <input type=\"number\" \nname=\"DayPeriodPurchaseTopup\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.fraudManagements.DayPeriodPurchaseOrTopupOfMoreThan\" required></div><div \nng-messages=\"fraudForm.DayPeriodPurchaseTopup.$error\"><div ng-message=\"required\" \nng-if=\"fraudForm.DayPeriodPurchaseTopup.$touched\" class=\"help-block\"><span \ntranslate=\"admin.fraudManagement.errors.require\"></span></div></div></div><div class=\"col-md-3 margin-tb\" \nng-class=\"{\'has-error\': fraudForm.DayPeriodPurchaseTopupPerDay.$invalid && fraudForm.DayPeriodPurchaseTopupPerDay.$touched}\">\n<div class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">per</span> <input type=\"number\" \nname=\"DayPeriodPurchaseTopupPerDay\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.fraudManagements.DayPeriodPurchaseOrTopupOfMoreThanPerDay\" required> <span class=\"input-group-addon\" \nid=\"basic-addon1\">day period</span></div><div ng-messages=\"fraudForm.DayPeriodPurchaseTopupPerDay.$error\"><div \nng-message=\"required\" ng-if=\"fraudForm.DayPeriodPurchaseTopupPerDay.$touched\" class=\"help-block\"><span \ntranslate=\"admin.fraudManagement.errors.require\"></span></div></div></div><label class=\"control-label col-md-2\" \nstyle=\"text-align:left\" translate=\"admin.fraudManagement.day_by_single\"></label></div><div class=\"form-group\"><label \nclass=\"control-label col-md-4 required\" translate=\"admin.fraudManagement.total_transfer\"></label><div \nclass=\"col-md-3 margin-tb\" \nng-class=\"{\'has-error\': fraudForm.DaysTotalTransfer.$invalid && fraudForm.DaysTotalTransfer.$touched}\"><div \nclass=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">RM</span> <input type=\"number\" \nname=\"DaysTotalTransfer\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.fraudManagements.DaysTotalTransfer\" required></div><div ng-messages=\"fraudForm.DaysTotalTransfer.$error\">\n<div ng-message=\"required\" ng-if=\"fraudForm.DaysTotalTransfer.$touched\" class=\"help-block\"><span \ntranslate=\"admin.fraudManagement.errors.require\"></span></div></div></div><div class=\"col-md-3 margin-tb\" \nng-class=\"{\'has-error\': fraudForm.DaysTotalTransferPerDay.$invalid && fraudForm.DaysTotalTransferPerDay.$touched}\"><div\n class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">per</span> <input type=\"number\" \nname=\"DaysTotalTransferPerDay\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.fraudManagements.DayTotalTransferPerDay\" required> <span class=\"input-group-addon\" id=\"basic-addon1\">days\n</span></div><div ng-messages=\"fraudForm.DaysTotalTransferPerDay.$error\"><div ng-message=\"required\" \nng-if=\"fraudForm.DaysTotalTransferPerDay.$touched\" class=\"help-block\"><span \ntranslate=\"admin.fraudManagement.errors.require\"></span></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-4 required\" translate=\"admin.fraudManagement.total_transfer\"></label><div \nclass=\"col-md-3 margin-tb\" \nng-class=\"{\'has-error\': fraudForm.WeeksTotalTransfer.$invalid && fraudForm.WeeksTotalTransfer.$touched}\"><div \nclass=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">RM</span> <input type=\"number\" \nname=\"WeeksTotalTransfer\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.fraudManagements.WeeksTotalTransfer\" required></div><div \nng-messages=\"fraudForm.WeeksTotalTransfer.$error\"><div ng-message=\"required\" \nng-if=\"fraudForm.WeeksTotalTransfer.$touched\" class=\"help-block\"><span \ntranslate=\"admin.fraudManagement.errors.require\"></span></div></div></div><div class=\"col-md-3 margin-tb\" \nng-class=\"{\'has-error\': fraudForm.WeeksTotalTransferPerWeek.$invalid && fraudForm.WeeksTotalTransferPerWeek.$touched}\">\n<div class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">within</span> <input type=\"number\" \nname=\"WeeksTotalTransferPerWeek\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.fraudManagements.WeeksTotalTransferPerWeek\" required> <span class=\"input-group-addon\" id=\"basic-addon1\">\nweeks</span></div><div ng-messages=\"fraudForm.WeeksTotalTransferPerWeek.$error\"><div ng-message=\"required\" \nng-if=\"fraudForm.WeeksTotalTransferPerWeek.$touched\" class=\"help-block\"><span \ntranslate=\"admin.fraudManagement.errors.require\"></span></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-4 required\" translate=\"admin.fraudManagement.total_transfer\"></label><div \nclass=\"col-md-3 margin-tb\" \nng-class=\"{\'has-error\': fraudForm.MonthsTotalTransfer.$invalid && fraudForm.MonthsTotalTransfer.$touched}\"><div \nclass=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">RM</span> <input type=\"number\" \nname=\"MonthsTotalTransfer\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.fraudManagements.MonthsTotalTransfer\" required></div><div \nng-messages=\"fraudForm.MonthsTotalTransfer.$error\"><div ng-message=\"required\" \nng-if=\"fraudForm.MonthsTotalTransfer.$touched\" class=\"help-block\"><span \ntranslate=\"admin.fraudManagement.errors.require\"></span></div></div></div><div class=\"col-md-3 margin-tb\" \nng-class=\"{\'has-error\': fraudForm.MonthsTotalTransferPerMonth.$invalid && fraudForm.MonthsTotalTransferPerMonth.$touched}\">\n<div class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">per</span> <input type=\"number\" \nname=\"MonthsTotalTransferPerMonth\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.fraudManagements.MonthsTotalTransferPerMonth\" required> <span class=\"input-group-addon\" id=\"basic-addon1\">\nmonths</span></div><div ng-messages=\"fraudForm.MonthsTotalTransferPerMonth.$error\"><div ng-message=\"required\" \nng-if=\"fraudForm.MonthsTotalTransferPerMonth.$touched\" class=\"help-block\"><span \ntranslate=\"admin.fraudManagement.errors.require\"></span></div></div></div></div><div id=\"message\" class=\"form-group\">\n<div data-ng-show=\"vm.showMessage\" \nng-class=\"{fade:vm.doFade,\'alert alert-danger\': !vm.isSuccess,\'alert alert-success\': vm.isSuccess}\"><strong>\n{{vm.alertTitle}}</strong> {{vm.errorMessage}}</div></div></div></form>");
$templateCache.put("app/admin/group/group.html","<h1 class=\"page-header\" translate=\"admin.group.title\"></h1><div id=\"group\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><input \ntype=\"text\" class=\"form-control\" ng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"Enter the group\'s name\"></div><div class=\"col-md-1 col-sm-10\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span \ntranslate=\"common.action.reset\"></span></a></div><div class=\"col-md-2 col-md-offset-6 col-sm-2\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.openDialog(\'new\')\"><i class=\"glyphicon glyphicon-plus\"></i> \n<span translate=\"common.action.add\"></span></a></div></div></div><div class=\"form-group\"><div class=\"table-responsive\">\n<table class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th translate=\"common.name\"></th><th \ntranslate=\"common.description\"></th><th translate=\"admin.group.number_of_brand\"></th><th \ntranslate=\"common.action.title\"></th></tr></thead><tbody><tr ng-repeat=\"group in vm.groups\"><td class=\"center\">\n{{$index + 1}}</td><td>{{group.Name}}</td><td>{{group.Description}}</td><td class=\"right\">{{group.NumberOfBrand}}</td>\n<td class=\"center\"><a title=\"Edit\" class=\"btn btn-default margin-tl\" ng-click=\"vm.openDialog(\'edit\', group)\"><i \nclass=\"glyphicon glyphicon-edit\"></i></a> <a title=\"Remove\" class=\"btn btn-danger margin-tl\" \nng-click=\"vm.remove(group)\"><i class=\"glyphicon glyphicon-remove\"></i></a></td></tr></tbody></table></div></div><ul \nuib-pagination total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-change=\"vm.search()\" \nng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul>\n</div><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" \ntabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><form \nname=\"groupForm\" class=\"form-horizontal\" ng-submit=\"vm.save()\" novalidate id=\"groupForm\"><div class=\"modal-header\">\n<button type=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowDialog = false\"><span aria-hidden=\"true\">&times;</span>\n<span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\" \ntranslate=\"admin.group.group_detail\"></h3></div><div class=\"modal-body\"><div class=\"form-group\" \nng-class=\"{\'has-error\': groupForm.Name.$invalid && groupForm.Name.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"common.name\"></label><div class=\"col-md-8\"><input name=\"Name\" \ntype=\"text\" class=\"form-control margin-tb\" ng-model=\"vm.group.Name\" required is-group-name-available=\"vm.group.Id\"><div\n ng-messages=\"groupForm.Name.$error\"><div ng-message=\"required\" ng-if=\"groupForm.Name.$touched\" class=\"help-block\">\n<span translate=\"admin.group.validate.name\"></span></div><div ng-message=\"isGroupNameAvailable\" \nng-if=\"groupForm.Name.$touched\" class=\"help-block\"><span translate=\"admin.group.validate.name_duplicate\"></span></div>\n</div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': groupForm.channel.$invalid && groupForm.channel.$touched}\"><label \nclass=\"control-label col-md-3 required\">Channel</label><div class=\"col-md-8\"><select name=\"channel\" \nclass=\"form-control\" ng-model=\"vm.group.Channel\" required><option ng-repeat=\"option in vm.channelList\" \nvalue=\"{{option.Value}}\">{{option.Text}}</option></select><p \nng-show=\"groupForm.channel.$invalid && groupForm.channel.$touched\" class=\"help-block\">The channel is required.</p>\n</div></div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"common.description\">\n</label><div class=\"col-md-8\"><textarea name=\"Description\" rows=\"4\" class=\"form-control\" \nng-model=\"vm.group.Description\"></textarea></div></div></div><div class=\"modal-footer\"><a class=\"btn btn-danger\" \nng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button type=\"submit\" class=\"btn btn-primary\" \ntranslate=\"common.action.save\"></button></div></form></div></div></div></div></div>");
$templateCache.put("app/admin/home-page-main-services/home-page-main-services.html","<h1 class=\"page-header\" translate=\"Home Page Main services\"></h1><div id=\"home-page-main-services\" class=\"col-md-12\">\n<div class=\"form-horizontal\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><input type=\"text\" \nclass=\"form-control\" ng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"Enter the Name\"></div><div class=\"col-md-3 col-xs-12 margin-tb\"><select class=\"form-control\" \nid=\"searchFunctionTypes\" name=\"searchFunctionTypes\" ng-model=\"vm.criteria.FunctionType\" \nng-change=\"vm.searchByKeyword($event)\"><option ng-value=\"null\">Select Function Type</option><option \nng-repeat=\"FTOptions in vm.FunctionTypeOptions\" ng-value=\"FTOptions.Id\">{{FTOptions.Name}}</option></select></div><div \nclass=\"col-md-1 col-sm-10\"><a class=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.reset()\"><i \nclass=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a></div><div \nclass=\"col-md-2 col-sm-2\"><a class=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.openDialog(\'new\')\"><i \nclass=\"glyphicon glyphicon-plus\"></i> <span translate=\"common.action.add\"></span></a></div></div><div \nclass=\"form-group\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered\"><thead><tr><th>#\n</th><th width=\"20%\" translate=\"photo\"></th><th translate=\"Function Type\"></th><th translate=\"Name\"></th><th \ntranslate=\"Position\"></th><th translate=\"Link\"></th><th translate=\"common.action.title\"></th></tr></thead><tbody><tr \nng-repeat=\"mainService in vm.mainservices\"><td class=\"center\">{{$index + 1}}</td><td width=\"20%\"><img \nstyle=\"width:100%\" class=\"photo\" ng-if=\"mainService.Photos\" ng-src=\"{{mainService.Photos}}\"></td><td>\n{{mainService.FunctionType}}</td><td>{{mainService.Name}}</td><td>{{mainService.Position}}</td><td>{{mainService.Link}}\n</td><td class=\"center\"><a title=\"Edit\" class=\"btn btn-default margin-tl\" \nng-click=\"vm.openDialog(\'edit\', mainService)\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a title=\"Unpublish\" \nng-if=\"vm.toMainServiceStatusBool(mainService.Status)\" class=\"btn btn-danger margin-tl\" \nng-click=\"vm.unpublish(mainService)\"><i class=\"glyphicon glyphicon-cloud-download\"></i></a> <a title=\"Publish\" \nng-if=\"!vm.toMainServiceStatusBool(mainService.Status)\" class=\"btn btn-primary margin-tl\" \nng-click=\"vm.publish(mainService)\"><i class=\"glyphicon glyphicon-cloud-upload\"></i></a> <a title=\"Remove\" \nclass=\"btn btn-danger margin-tl\" ng-click=\"vm.remove(mainService)\"><i class=\"glyphicon glyphicon-remove\"></i></a></td>\n</tr></tbody></table></div><ul uib-pagination total-items=\"vm.totalItems\" ng-change=\"vm.search()\" \nng-model=\"vm.currentPage\" items-per-page=\"vm.criteria.Length\" max-size=\"vm.maxSize\" class=\"pagination-sm\" \nboundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><form name=\"HomePageMainServiceInfoForm\" \nclass=\"form-horizontal\" ng-submit=\"vm.save(HomePageMainServiceInfoForm)\" novalidate id=\"HomePageMainServiceInfoForm\">\n<div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowDialog = false\"><span \naria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" \nid=\"modal-title\" translate=\"admin.HomePageMainServiceInfo.service_model_title\"></h3></div><div class=\"modal-body\"><div \nclass=\"form-group\"><label class=\"control-label col-md-3 required\">Function Type</label><div class=\"col-md-8\"><select \nclass=\"form-control\" id=\"FunctionTypes\" ng-disabled=\"vm.isDisableFunctionTypes\" name=\"FunctionTypes\" \nng-model=\"vm.mainService.FunctionType\" required ng-change=\"vm.FunctionTypeChange()\"><option \nng-repeat=\"FTOptions in vm.FunctionTypeOptions\" ng-value=\"FTOptions.Id\">{{FTOptions.Name}}</option></select></div><div \nng-messages=\"HomePageMainServiceInfoForm.FunctionTypes.$error\"><div ng-message=\"required\" \nng-if=\"HomePageMainServiceInfoForm.FunctionTypes.$touched\" class=\"help-block\"><span>Function Type is required field\n</span></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': HomePageMainServiceInfoForm.Name.$invalid && HomePageMainServiceInfoForm.Name.$touched}\"><label\n class=\"control-label col-md-3 margin-tb\" translate=\"admin.HomePageMainServiceInfo.name\"></label><div class=\"col-md-8\">\n<input type=\"text\" name=\"Name\" class=\"form-control\" ng-model=\"vm.mainService.Name\" required><div \nng-messages=\"HomePageMainServiceInfoForm.Name.$error\"><div ng-message=\"required\" \nng-if=\"HomePageMainServiceInfoForm.Name.$touched\" class=\"help-block\"><span>Name is required field</span></div></div>\n</div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': HomePageMainServiceInfoForm.Link.$invalid && HomePageMainServiceInfoForm.Link.$touched}\"><label\n class=\"control-label col-md-3 margin-tb\" translate=\"admin.HomePageMainServiceInfo.Link_URL\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"Link\" class=\"form-control\" ng-model=\"vm.mainService.Link\" required><div \nng-messages=\"HomePageMainServiceInfoForm.Link.$error\"><div ng-message=\"required\" \nng-if=\"HomePageMainServiceInfoForm.Link.$touched\" class=\"help-block\"><span>Link is required field</span></div></div>\n</div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': HomePageMainServiceInfoForm.Position.$invalid && HomePageMainServiceInfoForm.Position.$touched}\">\n<label class=\"control-label col-md-3 margin-tb\" translate=\"admin.HomePageMainServiceInfo.Position\"></label><div \nclass=\"col-md-8\"><input type=\"number\" name=\"Position\" min=\"1\" class=\"form-control\" ng-model=\"vm.mainService.Position\" \nrequired><div ng-messages=\"HomePageMainServiceInfoForm.Position.$error\"><div ng-message=\"required\" \nng-if=\"HomePageMainServiceInfoForm.Position.$touched\" class=\"help-block\"><span>Position is required field</span></div>\n</div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': HomePageMainServiceInfoForm.file.$invalid && HomePageMainServiceInfoForm.file.$touched}\"><label\n class=\"control-label col-md-3\" translate=\"admin.HomePageMainServiceInfo.Image\"></label><div \nclass=\"photos-form col-md-8\"><div class=\"upload-controls\" ng-if=\"vm.mainService.Photos.length==0\"><input type=\"file\" \nclass=\"button\" ngf-select=\"vm.uploadPhoto($files, $invalidFiles)\" name=\"file\" ngf-pattern=\"\'image/*\'\" \nngf-accept=\"\'image/*\'\" ngf-dimensions=\"($width >= 74) && ($height >= 90)\" ng-model=\"vm.temp.Photo\" \nngf-multiple=\"false\"></div><div ng-if=\"vm.mainService.Photos.length==0\"><label class=\"note\" \ntranslate=\"admin.HomePageMainServiceInfo.validate.photo.note\"></label></div><div class=\"file-list\" style=\"width:100%\">\n<div ng-messages=\"HomePageMainServiceInfoForm.file.$error\"><div ng-message=\"dimensions\" \nng-if=\"HomePageMainServiceInfoForm.file.$dirty\" class=\"help-block\"><p \ntranslate=\"admin.HomePageMainServiceInfo.validate.photo.dimension\"></p></div></div><ul \ndnd-list=\"vm.mainService.Photos\"><li ng-repeat=\"photo in vm.mainService.Photos\" style=\"font:smaller\"><div \nclass=\"preview-photos\"><span class=\"dnd\"></span> <img style=\"width:100%;padding-bottom:1%\" src=\"{{photo}}\" \nclass=\"thumb\"> <a ng-click=\"vm.removePhoto($index)\" class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-remove\"></i> \n<span translate=\"Remove\"></span></a></div></li></ul></div></div></div></div><div class=\"modal-footer\"><a \nclass=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button type=\"submit\" \nclass=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div></div></div>");
$templateCache.put("app/admin/mobile-number-change/mobile-number-change.html","<h1 class=\"page-header\" translate=\"Mobile Number Change\"></h1><div id=\"user\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><label \nclass=\"control-label\" translate=\"Name\"></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.criteria.Name\" \nng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter the name\"></div><div class=\"col-md-3 col-xs-12 margin-tb\">\n<label class=\"control-label\" translate=\"Email\"></label><input type=\"text\" class=\"form-control\" \nng-model=\"vm.criteria.EmailAddress\" ng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter the user\'s email\">\n</div><div class=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\" translate=\"New Mobile Number\"></label>\n<input type=\"number\" class=\"form-control\" ng-model=\"vm.criteria.NewPhoneNumber\" \nng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter the user\'s new phone #\"></div><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\" translate=\"Old Mobile Number\"></label><input \ntype=\"number\" class=\"form-control\" ng-model=\"vm.criteria.OldPhoneNumber\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"Enter the user\'s old phone #\"></div><div class=\"col-md-3 col-xs-12 margin-tb\"><label \nclass=\"control-label required\" translate=\"Change Start Date\"></label><input type=\"text\" id=\"startdate\" \nclass=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" \nng-click=\"vm.datePopup.StartOpen = true\" ng-model=\"vm.criteria.StartDate\"></div><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label required\" translate=\"Change End Date\"></label><input \ntype=\"text\" id=\"enddate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" \nng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.criteria.EndDate\"></div><div class=\"col-md-3 col-xs-12 margin-tb\">\n<label class=\"control-label\" translate=\"Partner\"></label><select class=\"form-control\" ng-model=\"vm.criteria.Partner\" \nng-change=\"vm.searchByKeyword($event)\"><option ng-value=\"null\">All</option><option ng-repeat=\"v in vm.AppType\" \nng-value=\"v.Id\">{{v.Name| translate}}</option></select></div><div class=\"col-md-1 col-xs-12 margin-tb\"><label \nclass=\"control-label\"></label><a style=\"margin-top:6px\" class=\"btn btn-primary pull-right\" ng-click=\"vm.reset()\"><span>\nSearch</span></a></div><div class=\"col-md-1 col-xs-12 margin-tb\"><label class=\"control-label\"></label><a \nstyle=\"margin-top:6px\" class=\"btn btn-primary pull-right\" ng-click=\"vm.resetPage()\"><i \nclass=\"glyphicon glyphicon-refresh\"></i><span>Reset</span></a></div></div></div><div class=\"form-group\"><div \nclass=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\" translate=\"Generate Report from \">\n</label><input type=\"number\" class=\"form-control\" ng-model=\"vm.criteria.Csvfrom\" \nplaceholder=\"Enter the starting record\"></div><div class=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\" \ntranslate=\"Generate Report To\"></label><input type=\"number\" class=\"form-control\" ng-model=\"vm.criteria.CsvTo\" \nplaceholder=\"Enter the end records\"></div><div class=\"col-md-3 col-xs-12 margin-tb\"><a style=\"margin-top:22px\" \nclass=\"btn btn-primary pull-right\" ng-click=\"vm.export()\"><span>Export</span></a></div><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><a style=\"margin-top:22px\" class=\"btn btn-primary pull-right\" \nng-click=\"vm.OpenMailModel()\"><span>Send Mail</span></a></div></div></div><div class=\"form-group\"><div \nclass=\"table-responsive\"><table class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th translate=\"Date\">\n</th><th translate=\"common.name\"></th><th translate=\"common.email\"></th><th translate=\"admin.user.phone_number\"></th>\n<th translate=\"Old Mobile Number\"></th><th translate=\"common.tag\"></th></tr></thead><tbody><tr \nng-repeat=\"user in vm.users\"><td class=\"center\">{{$index + 1}}</td><td>{{user.ModifiedAt| date:\'yyyy-MM-dd HH:mm:ss\'}}\n</td><td>{{user.FullName}}</td><td>{{user.Email}}</td><td>{{user.MobileNumber}}</td><td>{{user.OldPhoneNumber}}</td>\n<td>{{user.Tag}}</td></tr></tbody></table></div></div><div><div style=\"float:left;width:50%\">\nTotal Items:{{vm.ItemsCount}}</div><div style=\"float:right;width:50%\"><ul uib-pagination total-items=\"vm.totalItems\" \nng-change=\"vm.searchPagination()\" ng-model=\"vm.currentPage\" items-per-page=\"vm.criteria.Length\" max-size=\"vm.maxSize\" \nclass=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div><div class=\"header-modal\"><div\n common-bs-modal bs-modal-show=\"vm.viewConfig.ShowDialogTest\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><form name=\"testsendmailForm\" \nclass=\"form-horizontal\" novalidate><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.viewConfig.ShowDialogTest = false\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close\n</span></button><h3 class=\"modal-title center\" id=\"modal-title\">Test Send Mail</h3></div><div class=\"modal-body\"><div \nclass=\"form-group\" ng-class=\"{\'has-error\': testsendmailForm.Email.$invalid && testsendmailForm.Email.$touched}\"><label \nclass=\"control-label col-md-3 required\">Email</label><div class=\"col-md-8\"><input name=\"Email\" type=\"text\" \nclass=\"form-control\" ng-model=\"vm.EmailToSend\" required><div ng-messages=\"testsendmailForm.Email.$error\"><div \nng-message=\"required\" ng-if=\"testsendmailForm.Email.$touched\" class=\"help-block\"><span>Email is required field.</span>\n</div></div></div></div></div><div class=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.cancel()\" \ntranslate=\"common.action.cancel\"></a> <button type=\"button\" ng-click=\"vm.sendmail()\" \nclass=\"btn btn-primary pull-right\">Send</button></div></form></div></div></div></div></div>");
$templateCache.put("app/admin/least-cost-routing/least-cost-routing.html","<h1 class=\"page-header\" translate=\"admin.least_cost_routing.title\"></h1><uib-tabset><uib-tab index=\"0\" \nheading=\"Bill Payment\"><br><div id=\"bill-payment\" class=\"col-md-12\"><div class=\"form-horizontal\"><div \nclass=\"form-group\"><div class=\"row\"><div class=\"col-md-2\"><input type=\"text\" class=\"form-control\" \nng-model=\"vm.criteriaBillPayment.Keyword\" ng-keypress=\"vm.searchByKeywordBillPayment($event)\" \nplaceholder=\"{{\'admin.least_cost_routing.bill_payment.search_payee_name \' | translate}}\"></div><div class=\"col-md-2\">\n<select ng-model=\"vm.criteriaBillPayment.LCRPartner\" ng-change=\"vm.searchBillPayment()\" class=\"form-control\" \nng-options=\"value.Id as value.Name | translate for (key, value) in vm.lcrpartner\"><option value=\"\">All</option>\n</select></div><div class=\"col-md-1\"><a class=\"btn btn-primary pull-right\" ng-click=\"vm.resetBillPayment()\"><i \nclass=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a></div><div class=\"col-md-7\">\n<a class=\"btn btn-primary pull-left\" ng-click=\"vm.importBillPayment()\"><i class=\"glyphicon glyphicon-plus\"></i> <span \ntranslate=\"admin.least_cost_routing.bill_payment.import_csv\"></span></a> <a ng-click=\"vm.getTemplateCSVBillPayment()\" \nclass=\"template-csv\">Download Template</a> <a class=\"btn btn-primary pull-right\" ng-click=\"vm.addBillPayment()\"><i \nclass=\"glyphicon glyphicon-plus\"></i> <span translate=\"common.action.add\"></span></a></div></div></div><div \nclass=\"table-responsive form-group\"><table class=\"table table-striped table-bordered\"><thead \nthead-order=\"vm.sort($sortOpts)\"><tr><th>#</th><th translate=\"admin.least_cost_routing.bill_payment.requisite\"></th><th\n translate=\"admin.least_cost_routing.bill_payment.payee_name\"></th><th \ntranslate=\"admin.least_cost_routing.bill_payment.payee_code\"></th><th \ntranslate=\"admin.least_cost_routing.bill_payment.payee_sub_code\"></th><th \ntranslate=\"admin.least_cost_routing.bill_payment.volume_price\"></th><th \ntranslate=\"admin.least_cost_routing.bill_payment.lcr_partner\"></th><th translate=\"common.action.title\"></th></tr>\n</thead><tbody><tr ng-repeat=\"bill in  vm.bills\"><td class=\"center\">{{$index + 1}}</td><td>{{bill.Requisite}}</td><td>\n{{bill.OperatorCode}}</td><td>{{bill.ProductCode}}</td><td>{{bill.ProductSubCode}}</td><td>\n{{bill.CommissionRate}} ({{bill.Unit}})</td><td>{{bill.LCRPartner}}</td><td class=\"center\"><a title=\"Edit merchant\" \nclass=\"btn btn-default\" ng-click=\"vm.editBillPayment(bill.Id)\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a \ntitle=\"Remove\" class=\"btn btn-danger\" ng-click=\"vm.deleteBillPayment(bill.Id)\"><i class=\"glyphicon glyphicon-remove\">\n</i></a></td></tr></tbody></table><ul uib-pagination total-items=\"vm.totalItemsBill\" \nng-change=\"vm.searchBillPayment()\" ng-model=\"vm.currentPageBill\" max-size=\"vm.maxSizeBill\" \nitems-per-page=\"vm.itemsPerPageBill\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div>\n</div><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.view.AddOrEditBillPayment\" class=\"modal fade\" \ntabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><form \nname=\"billPaymentForm\" class=\"form-horizontal\" novalidate id=\"billPaymentForm\"><div class=\"modal-header\"><button \ntype=\"button\" class=\"close\" ng-click=\"vm.view.AddOrEditBillPayment = false\"><span aria-hidden=\"true\">&times;</span>\n<span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\" \ntranslate=\"admin.least_cost_routing.bill_payment.bill_payment\"></h3></div><div class=\"modal-body form-horizontal\"><div \nclass=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" \ntranslate=\"admin.least_cost_routing.bill_payment.information\"></h4></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.least_cost_routing.mobile_reload.requisite\"></label><div \nclass=\"col-md-8\"><ui-select multiple=\"multiple\" ng-model=\"vm.bill.Requisite\" theme=\"bootstrap\" close-on-select=\"true\" \ntagging-tokens=\"\"><ui-select-match placeholder=\"Select requirements...\">{{$item}}</ui-select-match><ui-select-choices \nrepeat=\"name in vm.billrequirements | filter:$select.search\"><div style=\"width:100%\" ng-bind=\"name\"></div>\n</ui-select-choices></ui-select></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': billPaymentForm.OperatorCode.$invalid && billPaymentForm.OperatorCode.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"admin.least_cost_routing.bill_payment.payee_name\"></label><div \nclass=\"col-md-8\"><input type=\"text\" autocomplete=\"off\" name=\"OperatorCode\" ng-blur=\"vm.disablelist()\" \nclass=\"form-control\" ng-model=\"vm.bill.OperatorCode\" ng-keyup=\"vm.loadBillInfo()\" required><div class=\"search-result\" \nng-if=\"vm.billlistView\"><ul class=\"search-result col-md-12\"><li class=\"list-group-item\" \nng-repeat=\"name in vm.billnames\" ng-mousedown=\"vm.onselectClient($event,name)\">{{name}}</li></ul></div><div \nng-messages=\"billPaymentForm.OperatorCode.$error\"><div ng-message=\"required\" \nng-if=\"billPaymentForm.OperatorCode.$touched\" class=\"help-block\"><span \ntranslate=\"admin.least_cost_routing.validate.payee_name\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': billPaymentForm.ProductCode.$invalid && billPaymentForm.ProductCode.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"admin.least_cost_routing.bill_payment.payee_code\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"ProductCode\" class=\"form-control\" ng-model=\"vm.bill.ProductCode\" required>\n<div ng-messages=\"billPaymentForm.ProductCode.$error\"><div ng-message=\"required\" \nng-if=\"billPaymentForm.ProductCode.$touched\" class=\"help-block\"><span \ntranslate=\"admin.least_cost_routing.validate.payee_code\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': billPaymentForm.ProductSubCode.$invalid && billPaymentForm.ProductSubCode.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"admin.least_cost_routing.bill_payment.payee_sub_code\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"ProductSubCode\" class=\"form-control\" ng-model=\"vm.bill.ProductSubCode\" \nrequired><div ng-messages=\"billPaymentForm.ProductSubCode.$error\"><div ng-message=\"required\" \nng-if=\"billPaymentForm.ProductSubCode.$touched\" class=\"help-block\"><span \ntranslate=\"admin.least_cost_routing.validate.payee_sub_code\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': billPaymentForm.CommissionRate.$invalid && billPaymentForm.CommissionRate.$touched }\"><label \nclass=\"control-label col-md-3\" translate=\"admin.least_cost_routing.bill_payment.volume_price\"></label><div \nclass=\"col-md-6\"><input type=\"number\" name=\"CommissionRate\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.bill.CommissionRate\" required><div ng-messages=\"billPaymentForm.CommissionRate.$error\"><div \nng-message=\"required\" ng-if=\"billPaymentForm.CommissionRate.$touched\" class=\"help-block\"><span \ntranslate=\"admin.least_cost_routing.validate.volume_price\"></span></div><div ng-message=\"pattern\" \nng-if=\"billPaymentForm.CommissionRate.$touched\" class=\"help-block\"><span \ntranslate=\"admin.least_cost_routing.validate.volume_price_duplicate\"></span></div></div></div><div class=\"col-md-2\">\n<select class=\"form-control\" ng-model=\"vm.bill.Unit\" name=\"unitBP\" ng-disabled=\"vm.disabledUnit\"><option value=\"\">%\n</option><option value=\"rm\">RM</option></select></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': billPaymentForm.LCRPartner.$invalid && billPaymentForm.LCRPartner.$touched }\"><label \nclass=\"control-label col-md-3\" translate=\"admin.least_cost_routing.bill_payment.lcr_partner\"></label><div \nclass=\"col-md-8\"><select class=\"form-control\" ng-model=\"vm.bill.LCRPartner\" name=\"LCRPartner\" \nng-change=\"vm.ChangePartner()\" required><option value=\"PayHub\">Pay Hub</option><option value=\"MobilityOne\">Mobility One\n</option><option value=\"PTPTN\">PTPTN</option></select><div ng-messages=\"billPaymentForm.LCRPartner.$error\"><div \nng-message=\"required\" ng-if=\"billPaymentForm.LCRPartner.$touched\" class=\"help-block\"><span \ntranslate=\"admin.least_cost_routing.validate.lcr_partner\"></span></div></div></div></div><div class=\"form-group\" \nng-if=\"vm.bill.LCRPartner==\'PTPTN\'\" \nng-class=\"{\'has-error\': billPaymentForm.file.$invalid && billPaymentForm.file.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"Logo\"></label><div class=\"photos-form col-md-8\"><div class=\"upload-controls\" \nng-if=\"vm.bill.LogoURL.length==0\"><input type=\"file\" class=\"button\" ngf-select=\"vm.uploadPhoto($files, $invalidFiles)\" \nname=\"file\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" \nngf-dimensions=\"($width >= 948) && ($height >= 408) && (($width / $height) >= 1)\" ng-model=\"vm.temp.Photo\" \nngf-multiple=\"false\"></div><div ng-if=\"vm.bill.LogoURL.length==0\"><label class=\"note\" \ntranslate=\"admin.referralbanner.validate.photo.note\"></label></div><div class=\"file-list\" style=\"width:100%\"><div \nng-messages=\"billPaymentForm.file.$error\"><div ng-message=\"dimensions\" ng-if=\"referralbannerForm.file.$dirty\" \nclass=\"help-block\"><p translate=\"admin.referralbanner.validate.photo.dimension\"></p></div></div><ul \ndnd-list=\"vm.banner.Photos\"><li ng-repeat=\"photo in vm.bill.LogoURL\" style=\"font:smaller\"><div class=\"preview-photos\">\n<span class=\"dnd\"></span> <img style=\"width:100%;padding-bottom:1%\" src=\"{{photo}}\" class=\"thumb\"> <a \nng-click=\"vm.removePhoto($index)\" class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-remove\"></i> <span \ntranslate=\"Remove\"></span></a></div></li></ul></div></div></div></div><div class=\"modal-footer\"><a \nclass=\"btn btn-danger\" ng-click=\"vm.view.AddOrEditBillPayment=false\" translate=\"common.action.cancel\"></a> <button \ntype=\"button\" ng-click=\"vm.saveBillPayment(billPaymentForm)\" class=\"btn btn-primary\" translate=\"common.action.save\">\n</button></div></form></div></div></div></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.view.ImportCSVBillPayment\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><form name=\"importForm\" class=\"form-horizontal\" \nnovalidate id=\"importForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.view.ImportCSVBillPayment = false\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close\n</span></button><h3 class=\"modal-title center\" id=\"modal-title\" \ntranslate=\"admin.least_cost_routing.bill_payment.import_csv\"></h3></div><div class=\"modal-body\"><div \nclass=\"form-group\" ng-class=\"{\'has-error\': importForm.file.$invalid && importForm.file.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.least_cost_routing.bill_payment.import_file\"></label><div \nclass=\"col-md-8\"><input class=\"form-control\" type=\"file\" name=\"file\" file-reader=\"vm.fileContentBillPayment\" \naccept=\".csv\"></div></div></div><div class=\"modal-footer\"><a class=\"btn btn-danger\" \nng-click=\"vm.view.ImportCSVBillPayment = false\" translate=\"common.action.cancel\"></a> <button \nng-click=\"vm.saveimportBillPayment()\" class=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form>\n</div></div></div></div></div></uib-tab><uib-tab index=\"1\" heading=\"Mobile Reload\"><br><div id=\"mobile-reload\" \nclass=\"col-md-12\"><div class=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-2\"><input \ntype=\"text\" class=\"form-control\" ng-model=\"vm.criteriaMobileReload.Keyword\" \nng-keypress=\"vm.searchByKeywordMobileReload($event)\" \nplaceholder=\"{{\'admin.least_cost_routing.mobile_reload.search_product_name \' | translate}}\"></div><div \nclass=\"col-md-2\"><select ng-model=\"vm.criteriaMobileReload.LCRPartner\" ng-change=\"vm.searchMobileReload()\" \nclass=\"form-control\" ng-options=\"value.Id as value.Name | translate for (key, value) in vm.lcrpartner\"><option \nvalue=\"\">All</option></select></div><div class=\"col-md-1\"><a class=\"btn btn-primary pull-right\" \nng-click=\"vm.resetMobileReload()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\">\n</span></a></div><div class=\"col-md-7\"><a class=\"btn btn-primary pull-left\" ng-click=\"vm.importMobileReload()\"><i \nclass=\"glyphicon glyphicon-plus\"></i> <span translate=\"admin.least_cost_routing.mobile_reload.import_csv\"></span></a> \n<a ng-click=\"vm.getTemplateCSVMobileReload()\" class=\"template-csv\">Download Template</a> <a \nclass=\"btn btn-primary pull-right\" ng-click=\"vm.addMobileReload()\"><i class=\"glyphicon glyphicon-plus\"></i> <span \ntranslate=\"common.action.add\"></span></a></div></div></div><div class=\"table-responsive form-group\"><table \nclass=\"table table-striped table-bordered\"><thead thead-order=\"vm.sort($sortOpts)\"><tr><th>#</th><th \ntranslate=\"admin.least_cost_routing.mobile_reload.product_type\"></th><th \ntranslate=\"admin.least_cost_routing.mobile_reload.requisite\"></th><th \ntranslate=\"admin.least_cost_routing.mobile_reload.product_name\"></th><th \ntranslate=\"admin.least_cost_routing.mobile_reload.product_code\"></th><th \ntranslate=\"admin.least_cost_routing.mobile_reload.product_sub_code\"></th><th \ntranslate=\"admin.least_cost_routing.mobile_reload.cost_price\"></th><th \ntranslate=\"admin.least_cost_routing.mobile_reload.discount\"></th><th \ntranslate=\"admin.least_cost_routing.mobile_reload.lcr_partner\"></th><th translate=\"common.action.title\"></th></tr>\n</thead><tbody><tr ng-repeat=\"mobile in  vm.mobiles\"><td class=\"center\">{{$index + 1}}</td><td>{{mobile.ProductType}}\n</td><td>{{mobile.Requisite}}</td><td>{{mobile.OperatorCode}}</td><td>{{mobile.ProductCode}}</td><td>\n{{mobile.ProductSubCode}}</td><td>{{mobile.CostPrice}}</td><td>{{mobile.CommissionRate}} ({{mobile.Unit}})</td><td>\n{{mobile.LCRPartner}}</td><td class=\"center\"><a title=\"Edit merchant\" class=\"btn btn-default\" \nng-click=\"vm.editMobileReload(mobile.Id)\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a title=\"Remove\" \nclass=\"btn btn-danger\" ng-click=\"vm.deleteMobileReload(mobile.Id)\"><i class=\"glyphicon glyphicon-remove\"></i></a></td>\n</tr></tbody></table><ul uib-pagination total-items=\"vm.totalItemsMobile\" ng-change=\"vm.searchMobileReload()\" \nng-model=\"vm.currentPageMobile\" max-size=\"vm.maxSizeMobile\" items-per-page=\"vm.itemsPerPageMobile\" \nclass=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div><div class=\"header-modal\"><div \ncommon-bs-modal bs-modal-show=\"vm.view.AddOrEditMobileReload\" id=\"{{vm.view.ActionMobileReload}}\" class=\"modal fade\" \ntabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><form \nname=\"mobileReloadForm\" class=\"form-horizontal\" ng-submit=\"vm.saves()\" novalidate id=\"mobileReloadForm\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.view.AddOrEditMobileReload = false\"><span \naria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" \nid=\"modal-title\" translate=\"admin.least_cost_routing.mobile_reload.mobile_reload\"></h3></div><div \nclass=\"modal-body form-horizontal\"><div class=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" \ntranslate=\"admin.least_cost_routing.mobile_reload.information\"></h4></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"admin.least_cost_routing.mobile_reload.product_type\"></label><div \nclass=\"col-md-8\"><select class=\"form-control\" id=\"ProductType\" name=\"ProductType\" ng-model=\"vm.mobile.ProductType\" \nng-change=\"vm.ProductTypeValue()\" required><option ng-repeat=\"v in vm.productType\" ng-value=\"v.Id\">\n{{v.Name| translate}}</option></select></div></div><div class=\"form-group\" id=\"divProductRequirement\" hidden><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.least_cost_routing.mobile_reload.requisite\"></label><div \nclass=\"col-md-8\"><ui-select multiple=\"multiple\" ng-model=\"vm.mobile.Requisite\" theme=\"bootstrap\" \nclose-on-select=\"true\" tagging-tokens=\"\"><ui-select-match placeholder=\"Select requirements...\">{{$item}}\n</ui-select-match><ui-select-choices repeat=\"name in vm.requirements | filter:$select.search\"><div style=\"width:100%\" \nng-bind=\"name\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': mobileReloadForm.OperatorCode.$invalid && mobileReloadForm.OperatorCode.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"admin.least_cost_routing.mobile_reload.product_name\"></label><div \nclass=\"col-md-8\"><select class=\"form-control\" name=\"OperatorCode\" ng-model=\"vm.mobile.OperatorCode\" \nng-change=\"vm.loadMobileInfo()\" required><option ng-repeat=\"name in vm.mobilenames\" ng-value=\"name\">{{name}}</option>\n</select><div ng-messages=\"mobileReloadForm.OperatorCode.$error\"><div ng-message=\"required\" \nng-if=\"mobileReloadForm.OperatorCode.$touched\" class=\"help-block\"><span \ntranslate=\"admin.least_cost_routing.validate.product_name\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': mobileReloadForm.ProductCode.$invalid && mobileReloadForm.ProductCode.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"admin.least_cost_routing.mobile_reload.product_code\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"ProductCode\" class=\"form-control\" ng-model=\"vm.mobile.ProductCode\"><div \nng-messages=\"mobileReloadForm.ProductCode.$error\"><div ng-message=\"required\" \nng-if=\"mobileReloadForm.ProductCode.$touched\" class=\"help-block\"><span \ntranslate=\"admin.least_cost_routing.validate.product_code\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': mobileReloadForm.ProductSubCode.$invalid && mobileReloadForm.ProductSubCode.$touched }\"><label \nclass=\"control-label col-md-3\" translate=\"admin.least_cost_routing.mobile_reload.product_sub_code\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"ProductSubCode\" class=\"form-control\" ng-model=\"vm.mobile.ProductSubCode\" \nrequired><div ng-messages=\"mobileReloadForm.ProductSubCode.$error\"><div ng-message=\"required\" \nng-if=\"mobileReloadForm.ProductSubCode.$touched\" class=\"help-block\"><span \ntranslate=\"admin.least_cost_routing.validate.product_sub_code\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': mobileReloadForm.CostPrice.$invalid && mobileReloadForm.CostPrice.$touched }\"><label \nclass=\"control-label col-md-3\" translate=\"admin.least_cost_routing.mobile_reload.cost_price\"></label><div \nclass=\"col-md-8\"><div class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">RM</span> <input \ntype=\"number\" name=\"CostPrice\" class=\"form-control\" min=\"0\" ng-model=\"vm.mobile.CostPrice\" required></div><div \nng-messages=\"mobileReloadForm.CostPrice.$error\"><div ng-message=\"required\" ng-if=\"mobileReloadForm.CostPrice.$touched\" \nclass=\"help-block\"><span translate=\"admin.least_cost_routing.validate.cost_price\"></span></div></div></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': mobileReloadForm.CommissionRate.$invalid && mobileReloadForm.CommissionRate.$touched }\"><label \nclass=\"control-label col-md-3\" translate=\"admin.least_cost_routing.mobile_reload.discount\"></label><div \nclass=\"col-md-6\"><input type=\"number\" name=\"CommissionRate\" class=\"form-control\" required min=\"0\" \nng-model=\"vm.mobile.CommissionRate\"><div ng-messages=\"mobileReloadForm.CommissionRate.$error\"><div \nng-message=\"required\" ng-if=\"mobileReloadForm.CommissionRate.$touched\" class=\"help-block\"><span \ntranslate=\"admin.least_cost_routing.validate.discount\"></span></div><div ng-message=\"pattern\" \nng-if=\"mobileReloadForm.CommissionRate.$touched\" class=\"help-block\"><span \ntranslate=\"admin.least_cost_routing.validate.discount_duplicate\"></span></div></div></div><div class=\"col-md-2\"><select\n class=\"form-control\" ng-model=\"vm.mobile.Unit\" name=\"unitMR\"><option value=\"\">%</option><option value=\"rm\">RM</option>\n</select></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': mobileReloadForm.LCRPartner.$invalid && mobileReloadForm.LCRPartner.$touched }\"><label \nclass=\"control-label col-md-3\" translate=\"admin.least_cost_routing.mobile_reload.lcr_partner\"></label><div \nclass=\"col-md-8\"><select class=\"form-control\" ng-model=\"vm.mobile.LCRPartner\" name=\"LCRPartner\" required><option \nvalue=\"PayHub\">Pay Hub</option><option value=\"MobilityOne\">Mobility One</option></select><div \nng-messages=\"mobileReloadForm.LCRPartner.$error\"><div ng-message=\"required\" \nng-if=\"mobileReloadForm.LCRPartner.$touched\" class=\"help-block\"><span \ntranslate=\"admin.least_cost_routing.validate.lcr_partner\"></span></div></div></div></div></div><div \nclass=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.view.AddOrEditMobileReload=false\" \ntranslate=\"common.action.cancel\"></a> <button class=\"btn btn-primary\" type=\"button\" \nng-click=\"vm.saveMobileReload(mobileReloadForm)\" translate=\"common.action.save\"></button></div></form></div></div>\n</div></div><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.view.ImportCSVMobileReload\" \nclass=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-md\"><div \nclass=\"modal-content my-content\"><form name=\"importForm\" class=\"form-horizontal\" novalidate id=\"importForm\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.view.ImportCSVMobileReload = false\"><span \naria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" \nid=\"modal-title\" translate=\"admin.least_cost_routing.mobile_reload.import_csv\"></h3></div><div class=\"modal-body\"><div \nclass=\"form-group\" ng-class=\"{\'has-error\': importForm.file.$invalid && importForm.file.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.least_cost_routing.mobile_reload.import_file\"></label><div \nclass=\"col-md-8\"><input class=\"form-control\" type=\"file\" id=\"file\" name=\"file\" \nfile-reader=\"vm.fileContentMobileReload\" accept=\".csv\"></div></div></div><div class=\"modal-footer\"><a \nclass=\"btn btn-danger\" ng-click=\"vm.view.ImportCSVMobileReload = false\" translate=\"common.action.cancel\"></a> <button \nng-click=\"vm.saveimportMobileReload()\" class=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form>\n</div></div></div></div></div></uib-tab></uib-tabset>");
$templateCache.put("app/admin/notification/notification.html","<div class=\"form-group\"><div class=\"form-group col-md-12\"><ul class=\"nav nav-tabs\"><li><a data-toggle=\"tab\" \nui-sref=\"app.admin.notificationlist\" data-target=\"#notificationlist\" ng-click=\"vm.closeNav()\"><i class=\"glyphicon\"></i>\n<span translate=\"navigation.notificationlist\"></span></a></li><li class=\"active\"><a data-toggle=\"tab\" \nui-sref=\"app.admin.notification\" data-target=\"#notification\" ng-click=\"vm.closeNav()\"><i class=\"glyphicon\"></i><span \ntranslate=\"navigation.notification\"></span></a></li></ul></div><h1 class=\"page-header\" \ntranslate=\"admin.notification.title\"></h1><div id=\"notification\" class=\"col-md-12\"><form name=\"notificationForm\" \nclass=\"form-horizontal\" ng-submit=\"vm.pushNotification()\" novalidate><div class=\"form-group\"><div \nng-class=\"{\'has-error\': notificationForm.Criteria.$invalid && notificationForm.Criteria.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.select_criteria\"></label><div class=\"col-md-8\" \nng-class=\"{\'has-error\': notificationForm.Criteria.$invalid && notificationForm.Criteria.$touched}\"><select \nname=\"Criteria\" class=\"form-control\" required ng-model=\"vm.notification.Criteria\" \nng-options=\"value.Id as value.Name | translate for (key,value) in vm.criterialist\"></select><div \nng-messages=\"notificationForm.Criteria.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.Criteria.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.criteria_required\"></span></div></div></div></div></div>\n<div class=\"form-group\" ng-show=\"vm.notification.Criteria == \'SingleUser\'\" \nng-class=\"{\'has-error\': notificationForm.singleuser.$invalid && notificationForm.singleuser.$touched}\"><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"admin.notification.select_user\"></label><div class=\"col-md-8\">\n<input class=\"form-control\" name=\"singleuser\" ng-required=\"vm.notification.Criteria == \'SingleUser\'\" type=\"text\" \nng-model=\"vm.notification.UserName\"><div ng-messages=\"notificationForm.singleuser.$error\"><div ng-message=\"required\" \nng-if=\"notificationForm.singleuser.$touched\" class=\"help-block\"><span \ntranslate=\"admin.notification.errors.user_username_required\"></span></div></div></div></div><div class=\"form-group\" \nng-show=\"vm.notification.Criteria == \'FileUpload\'\" \nng-class=\"{\'has-error\': notificationForm.userlist.$invalid && notificationForm.userlist.$touched}\"><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"admin.notification.import_csv\"></label><div class=\"col-md-4\"><input\n name=\"userlist\" id=\"fileInput\" class=\"form-control\" type=\"file\" file-reader=\"vm.fileContent\"><div \nng-messages=\"notificationForm.singleuser.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.userlist.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_username_required\"></span></div></div><a \nhref=\"list.csv\" target=\"_self\">Download</a></div></div><div class=\"form-group err-div\" style=\"display:none\"><div \nclass=\"row col-md-offset-2\"><h4>The following accounts are not exist, please remove them and resubmit again</h4></div>\n<div class=\"row col-md-4 col-md-offset-2\" style=\"color:red\" id=\"listAccount\"></div></div><div class=\"form-group\" \nng-show=\"vm.notification.Criteria == \'UserWithXAmountofKipleKash\'\" \nng-class=\"{\'has-error\': notificationForm.KipleKash.$invalid && notificationForm.KipleKash.$touched}\"><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"admin.notification.xkiplekash\"></label><div class=\"col-md-3\"><input\n type=\"text\" name=\"KipleKash\" class=\"form-control\" \nng-required=\"vm.notification.Criteria == \'UserWithXAmountofKipleKash\'\" ng-model=\"vm.notification.XKiplekash\"><div \nng-messages=\"notificationForm.KipleKash.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.KipleKash.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_kiplekash_required\"></span></div></div></div></div>\n<div class=\"form-group\" ng-show=\"vm.notification.Criteria == \'UserHaveNoTransactionXMonths\'\" \nng-class=\"{\'has-error\': notificationForm.notransaction.$invalid && notificationForm.notransaction.$touched}\"><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"admin.notification.ymonths\"></label><div class=\"col-md-3\"><input \nclass=\"form-control\" name=\"notransaction\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserHaveNoTransactionXMonths\'\" ng-model=\"vm.notification.ZMonths\"><div \nng-messages=\"notificationForm.notransaction.$error\"><div ng-message=\"required\" \nng-if=\"notificationForm.notransaction.$touched\" class=\"help-block\"><span \ntranslate=\"admin.notification.errors.user_ymonths_required\"></span></div></div></div></div><div \nng-show=\"vm.notification.Criteria == \'UserWithXTransactionsInPastYmonths\'\"><div class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.xtransactions.$invalid && notificationForm.xtransactions.$touched}\"><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"admin.notification.xtransactions\"></label><div class=\"col-md-3\">\n<input class=\"form-control\" name=\"xtransactions\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserWithXTransactionsInPastYmonths\'\" \nng-model=\"vm.notification.XTransactions\"><div ng-messages=\"notificationForm.xtransactions.$error\"><div \nng-message=\"required\" ng-if=\"notificationForm.xtransactions.$touched\" class=\"help-block\"><span \ntranslate=\"admin.notification.errors.user_xtransactions_required\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': notificationForm.ymonths.$invalid && notificationForm.ymonths.$touched}\">\n<label class=\"control-label col-md-2 margin-tb\" translate=\"admin.notification.ymonths\"></label><div class=\"col-md-3\">\n<input class=\"form-control\" name=\"ymonths\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserWithXTransactionsInPastYmonths\'\" ng-model=\"vm.notification.YMonths\"><div \nng-messages=\"notificationForm.ymonths.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.ymonths.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_ymonths_required\"></span></div></div></div></div>\n</div><div ng-show=\"vm.notification.Criteria == \'UserSpentXAmountAt_Y_Merchant\'\"><div class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.xamount.$invalid && notificationForm.xamount.$touched}\"><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"admin.notification.xamount\"></label><div class=\"col-md-3\"><input \nclass=\"form-control\" name=\"xamount\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserSpentXAmountAt_Y_Merchant\'\" ng-model=\"vm.notification.XAmount\"><div \nng-messages=\"notificationForm.xamount.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.xamount.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_xamount_required\"></span></div></div></div></div>\n<div class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.ymerchant.$invalid && notificationForm.ymerchant.$touched}\"><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"admin.notification.ymerchant\"></label><div class=\"col-md-3\"><input \nclass=\"form-control col-md-1\" name=\"ymerchant\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserSpentXAmountAt_Y_Merchant\'\" ng-model=\"vm.notification.YMerchant\"><div \nng-messages=\"notificationForm.ymerchant.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.ymerchant.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_ymerchant_required\"></span></div></div></div></div>\n</div><div ng-show=\"vm.notification.Criteria == \'UserSpentXTimesAt_Y_Merchant\'\"><div class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.xtimes.$invalid && notificationForm.xtimes.$touched}\"><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"admin.notification.xtimes\"></label><div class=\"col-md-3\"><input \nclass=\"form-control\" name=\"xtimes\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserSpentXTimesAt_Y_Merchant\'\" ng-model=\"vm.notification.XTimes\"><div \nng-messages=\"notificationForm.xtimes.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.xtimes.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_xtimes_required\"></span></div></div></div></div><div\n class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.ymerchant2.$invalid && notificationForm.ymerchant2.$touched}\"><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"admin.notification.ymerchant\"></label><div class=\"col-md-3\"><input \nclass=\"form-control\" type=\"text\" name=\"ymerchant2\" \nng-required=\"vm.notification.Criteria == \'UserSpentXTimesAt_Y_Merchant\'\" ng-model=\"vm.notification.YMerchant\"><div \nng-messages=\"notificationForm.ymerchant2.$error\"><div ng-message=\"required\" \nng-if=\"notificationForm.ymerchant2.$touched\" class=\"help-block\"><span \ntranslate=\"admin.notification.errors.user_ymerchant_required\"></span></div></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': notificationForm.Title.$invalid && notificationForm.Title.$touched}\"><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"admin.notification.title_message\"></label><div class=\"col-md-8\">\n<input type=\"text\" class=\"form-control\" name=\"Title\" ng-model=\"vm.notification.title\" required><div \nng-messages=\"notificationForm.Title.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.Title.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.title_required\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': notificationForm.Message.$invalid && notificationForm.Message.$touched}\">\n<label class=\"control-label col-md-2 margin-tb\" translate=\"admin.notification.message\"></label><div class=\"col-md-8\">\n<textarea name=\"Message\" class=\"form-control\" ng-model=\"vm.notification.message\" required \nplaceholder=\"Input message here...\"></textarea><div ng-messages=\"notificationForm.Message.$error\"><div \nng-message=\"required\" ng-if=\"notificationForm.Message.$touched\" class=\"help-block\"><span \ntranslate=\"admin.notification.errors.message_required\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.scheduledate.$invalid && notificationForm.scheduledate.$touched}\"><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"admin.notification.Notification_send_date\"></label><div \nclass=\"col-md-8\"><input type=\"datetime-local\" required name=\"scheduledate\" \nmin=\"{{vm.notification.SendAt| date : \'yyyy-MM-ddThh:mm:ss\'}}\" ng-model=\"vm.notification.SendAt\" class=\"form-control\">\n<div ng-messages=\"notificationForm.scheduledate.$error\"><div ng-message=\"required\" \nng-if=\"notificationForm.scheduledate.$touched\" class=\"help-block\"><span \ntranslate=\"admin.notification.errors.scheduledatetime_required\"></span></div></div></div></div><div \nclass=\"modal-footer\"><button type=\"submit\" class=\"btn btn-primary\" translate=\"admin.notification.send\"></button></div>\n<div id=\"message\" class=\"form-group\"><div data-ng-show=\"vm.showMessage\" \nng-class=\"{fade:vm.doFade,\'alert alert-danger\': !vm.isSuccess,\'alert alert-success\': vm.isSuccess}\"><strong>\n{{vm.alertTitle}}</strong> {{vm.errorMessage}}</div></div></form></div></div>");
$templateCache.put("app/admin/notification/notificationlist.html","<div class=\"form-group\"><div class=\"form-group col-md-12\"><ul class=\"nav nav-tabs\"><li class=\"active\"><a \ndata-toggle=\"tab\" ui-sref=\"app.admin.notificationlist\" data-target=\"#notificationlist\" ng-click=\"vm.closeNav()\"><i \nclass=\"glyphicon\"></i><span translate=\"navigation.notificationlist\"></span></a></li><li><a data-toggle=\"tab\" \nui-sref=\"app.admin.notification\" data-target=\"#notification\" ng-click=\"vm.closeNav()\"><i class=\"glyphicon\"></i><span \ntranslate=\"navigation.notification\"></span></a></li></ul></div><h1 class=\"page-header\" \ntranslate=\"admin.notificationlist.title\"></h1><div id=\"notificationlist\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><input \ntype=\"text\" class=\"form-control\" ng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"Enter the Notification content \"></div><div class=\"col-md-1 col-md-10\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span \ntranslate=\"common.action.reset\"></span></a></div></div></div><div class=\"form-group\"><div id=\"myApp\" \nclass=\"table-responsive\"><table id=\"demo_table\" class=\"table table-striped table-bordered\"><thead><tr><th>ID</th><th \ntranslate=\"admin.notificationlist.sent_date\"></th><th translate=\"admin.notificationlist.title_message\"></th><th \ntranslate=\"admin.notificationlist.receipient\"></th><th translate=\"Client\"></th><th \ntranslate=\"admin.notificationlist.status\"></th><th translate=\"admin.notificationlist.moreinfo\"></th><th \ntranslate=\"common.action.title\"></th></tr></thead><tbody><tr ng-repeat=\"notification in vm.notifications\"><td \nclass=\"center\">{{$index + 1}}</td><td align=\"center\">{{notification.SendAt | date:\'yyyy-MM-dd h:mm:ss a\' | lowercase}}\n</td><td>{{notification.Title | cut:true:35:\'...\'}}</td><td>{{notification.Receipient | cut:true:40:\'....\'}}</td><td>\n{{notification.AppType}}</td><td>{{notification.DeliveryStatus}}</td><td><a title=\"Edit\" class=\"btn-link btn-default\" \nng-click=\"vm.openDialog(\'edit\', notification)\"><i><u>View Details</u></i></a></td><td class=\"center\"><a title=\"Remove\" \nng-show=\"notification.DeliveryStatus == \'Schedule\'\" class=\"btn btn-danger\" ng-click=\"vm.remove(notification)\"><i \nclass=\"glyphicon glyphicon-remove\"></i></a></td></tr></tbody></table><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"document\"><div \nclass=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><form name=\"notificationForm\" \nclass=\"form-horizontal\" ng-submit=\"vm.pushNotification()\" novalidate id=\"notification\"><div class=\"modal-header\">\n<button type=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowDialog = false\"><span aria-hidden=\"true\">&times;</span>\n<span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\" \ntranslate=\"admin.notification.notification_detail\"></h3></div><div class=\"modal-body\"><div \nng-show=\"vm.notification.DeliveryStatus == \'Schedule\'\"><div class=\"form-group\"><div class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.notificationcriteria.$invalid && notificationForm.notificationcriteria.$touched}\">\n<label class=\"control-label col-md-2\" translate=\"admin.notification.select_criteria\"></label><div class=\"col-md-7\" \nng-class=\"{\'has-error\': notificationForm.notificationcriteria.$invalid && notificationForm.notificationcriteria.$touched}\">\n<select name=\"notificationcriteria\" class=\"form-control\" required ng-model=\"vm.notification.Criteria\" \nng-options=\"value.Id as value.Name | translate for (key,value) in vm.criterialist\"><option \nng-repeat=\"criteria in vm.notification.Criteria\" ng-value=\"notification.Criteria\">{{Notification.Criteria}}</option>\n</select><div ng-messages=\"notificationForm.notificationcriteria.$error\"><div ng-message=\"required\" \nng-if=\"notificationForm.notificationcriteria.$touched\" class=\"help-block\"><span \ntranslate=\"admin.notification.errors.criteria_required\"></span></div></div></div></div></div><div class=\"form-group\" \nng-show=\"vm.notification.Criteria == \'SingleUser\'\" \nng-class=\"{\'has-error\': notificationForm.singleuser.$invalid && notificationForm.singleuser.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.select_user\"></label><div class=\"col-md-8\"><input \nclass=\"form-control\" name=\"singleuser\" ng-required=\"vm.notification.Criteria == \'SingleUser\'\" type=\"text\" \nng-model=\"vm.notification.UserName\"><div ng-messages=\"notificationForm.singleuser.$error\"><div ng-message=\"required\" \nng-if=\"notificationForm.singleuser.$touched\" class=\"help-block\"><span \ntranslate=\"admin.notification.errors.user_username_required\"></span></div></div></div></div><div class=\"form-group\" \nng-show=\"vm.notification.Criteria == \'FileUpload\'\" \nng-class=\"{\'has-error\': notificationForm.userlist.$invalid && notificationForm.userlist.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.import_csv\"></label><div class=\"col-md-8\"><input \nname=\"userlist\" class=\"form-control\" type=\"file\" file-reader=\"vm.fileContent\"><div \nng-messages=\"notificationForm.singleuser.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.userlist.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_username_required\"></span></div></div></div></div>\n<div class=\"form-group\" ng-show=\"vm.notification.Criteria == \'UserWithXAmountofKipleKash\'\" \nng-class=\"{\'has-error\': notificationForm.KipleKash.$invalid && notificationForm.KipleKash.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.xkiplekash\"></label><div class=\"col-md-3\"><input \ntype=\"text\" name=\"KipleKash\" class=\"form-control\" \nng-required=\"vm.notification.Criteria == \'UserWithXAmountofKipleKash\'\" ng-model=\"vm.notification.XKiplekash\"><div \nng-messages=\"notificationForm.KipleKash.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.KipleKash.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_kiplekash_required\"></span></div></div></div></div>\n<div class=\"form-group\" ng-show=\"vm.notification.Criteria == \'UserHaveNoTransactionXMonths\'\" \nng-class=\"{\'has-error\': notificationForm.notransaction.$invalid && notificationForm.notransaction.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.ymonths\"></label><div class=\"col-md-3\"><input \nclass=\"form-control\" name=\"notransaction\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserHaveNoTransactionXMonths\'\" ng-model=\"vm.notification.ZMonths\"><div \nng-messages=\"notificationForm.notransaction.$error\"><div ng-message=\"required\" \nng-if=\"notificationForm.notransaction.$touched\" class=\"help-block\"><span \ntranslate=\"admin.notification.errors.user_ymonths_required\"></span></div></div></div></div><div \nng-show=\"vm.notification.Criteria == \'UserWithXTransactionsInPastYmonths\'\"><div class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.xtransactions.$invalid && notificationForm.xtransactions.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.xtransactions\"></label><div class=\"col-md-3\"><input \nclass=\"form-control\" name=\"xtransactions\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserWithXTransactionsInPastYmonths\'\" \nng-model=\"vm.notification.XTransactions\"><div ng-messages=\"notificationForm.xtransactions.$error\"><div \nng-message=\"required\" ng-if=\"notificationForm.xtransactions.$touched\" class=\"help-block\"><span \ntranslate=\"admin.notification.errors.user_xtransactions_required\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': notificationForm.ymonths.$invalid && notificationForm.ymonths.$touched}\">\n<label class=\"control-label col-md-2\" translate=\"admin.notification.ymonths\"></label><div class=\"col-md-3\"><input \nclass=\"form-control\" name=\"ymonths\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserWithXTransactionsInPastYmonths\'\" ng-model=\"vm.notification.YMonths\"><div \nng-messages=\"notificationForm.ymonths.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.ymonths.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_ymonths_required\"></span></div></div></div></div>\n</div><div ng-show=\"vm.notification.Criteria == \'UserSpentXAmountAt_Y_Merchant\'\"><div class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.xamount.$invalid && notificationForm.xamount.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.xamount\"></label><div class=\"col-md-3\"><input \nclass=\"form-control\" name=\"xamount\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserSpentXAmountAt_Y_Merchant\'\" ng-model=\"vm.notification.XAmount\"><div \nng-messages=\"notificationForm.xamount.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.xamount.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_xamount_required\"></span></div></div></div></div>\n<div class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.ymerchant.$invalid && notificationForm.ymerchant.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.ymerchant\"></label><div class=\"col-md-3\"><input \nclass=\"form-control col-md-1\" name=\"ymerchant\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserSpentXAmountAt_Y_Merchant\'\" ng-model=\"vm.notification.YMerchant\"><div \nng-messages=\"notificationForm.ymerchant.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.ymerchant.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_ymerchant_required\"></span></div></div></div></div>\n</div><div ng-show=\"vm.notification.Criteria == \'UserSpentXTimesAt_Y_Merchant\'\"><div class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.xtimes.$invalid && notificationForm.xtimes.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.xtimes\"></label><div class=\"col-md-3\"><input \nclass=\"form-control\" name=\"xtimes\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserSpentXTimesAt_Y_Merchant\'\" ng-model=\"vm.notification.XTimes\"><div \nng-messages=\"notificationForm.xtimes.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.xtimes.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_xtimes_required\"></span></div></div></div></div><div\n class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.ymerchant2.$invalid && notificationForm.ymerchant2.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.ymerchant\"></label><div class=\"col-md-3\"><input \nclass=\"form-control\" type=\"text\" name=\"ymerchant2\" \nng-required=\"vm.notification.Criteria == \'UserSpentXTimesAt_Y_Merchant\'\" ng-model=\"vm.notification.YMerchant\"><div \nng-messages=\"notificationForm.ymerchant2.$error\"><div ng-message=\"required\" \nng-if=\"notificationForm.ymerchant2.$touched\" class=\"help-block\"><span \ntranslate=\"admin.notification.errors.user_ymerchant_required\"></span></div></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': notificationForm.Title.$invalid && notificationForm.Title.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.title_message\"></label><div class=\"col-md-8\"><input \ntype=\"text\" class=\"form-control\" name=\"Title\" ng-model=\"vm.notification.Title\" required><div \nng-messages=\"notificationForm.Title.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.Title.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.title_required\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': notificationForm.Message.$invalid && notificationForm.Message.$touched}\">\n<label class=\"control-label col-md-2\" translate=\"admin.notification.message\"></label><div class=\"col-md-8\"><textarea \nname=\"Message\" class=\"form-control\" ng-model=\"vm.notification.Message\" required></textarea><div \nng-messages=\"notificationForm.Message.$error\">.<div ng-message=\"required\" ng-if=\"notificationForm.Message.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.message_required\"></span></div></div></div></div><div \nclass=\"form-group\" ng-show=\"vm.notification.DeliveryStatus == \'Schedule\'\" \nng-class=\"{\'has-error\': notificationForm.scheduledate.$invalid && notificationForm.scheduledate.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.Notification_send_date\"></label><div class=\"col-md-8\">\n<input type=\"datetime-local\" required name=\"scheduledate\" ng-model=\"vm.notification.SendAt\" dateformat \nclass=\"form-control\"><div ng-messages=\"notificationForm.scheduledate.$error\"><div ng-message=\"required\" \nng-if=\"notificationForm.scheduledate.$touched\" class=\"help-block\"><span \ntranslate=\"admin.notification.errors.scheduledatetime_required\"></span></div></div></div></div><div><table id=\"list1\" \nstyle=\"visibility:hidden\"><tr><th>Id</th><th>Criteria</th><th>Title</th><th>SendAt</th><th>Receipient</th></tr><tr><td>\n{{$index + 1}}</td><td>{{vm.notification.Criteria}}</td><td>{{vm.notification.Title}}</td><td>\n{{vm.notification.SendAt | date: \'yyyy-MM-dd h:mm:ss a\' | lowercase}}</td><td>{{vm.notification.Receipient}}</td></tr>\n</table></div><div class=\"modal-footer\"><button type=\"submit\" ng-show=\"vm.notification.DeliveryStatus == \'Schedule\'\" \nclass=\"btn btn-primary\">Update</button> <button type=\"button\" ng-show=\"vm.notification.DeliveryStatus == \'Sent\'\" \nclass=\"btn btn-primary\" translate=\"admin.notification.import\" name=\"list--list1\" export-to-csv></button> <a \nclass=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a></div></div><div \nclass=\"form-horizontal\" ng-show=\"vm.notification.DeliveryStatus == \'Sent\'\"><div class=\"form-group\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.select_criteria\"></label><div class=\"col-md-8\"><input \ntype=\"datetime\" readonly=\"readonly\" ng-model=\"vm.notification.Criteria\" class=\"form-control\"></div></div><div \nclass=\"form-group\" ng-show=\"vm.notification.Criteria == \'FileUpload\'\" \nng-class=\"{\'has-error\': notificationForm.userlist.$invalid && notificationForm.userlist.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.import_csv\"></label><div class=\"col-md-8\"><input \nname=\"userlist\" class=\"form-control\" type=\"file\" file-reader=\"vm.fileContent\"><div \nng-messages=\"notificationForm.singleuser.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.userlist.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_username_required\"></span></div></div></div></div>\n<div class=\"form-group\" ng-show=\"vm.notification.Criteria == \'UserWithXAmountofKipleKash\'\" \nng-class=\"{\'has-error\': notificationForm.KipleKash.$invalid && notificationForm.KipleKash.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.xkiplekash\"></label><div class=\"col-md-3\"><input \ntype=\"text\" name=\"KipleKash\" class=\"form-control\" \nng-required=\"vm.notification.Criteria == \'UserWithXAmountofKipleKash\'\" ng-model=\"vm.notification.XKiplekash\"><div \nng-messages=\"notificationForm.KipleKash.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.KipleKash.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_kiplekash_required\"></span></div></div></div></div>\n<div class=\"form-group\" ng-show=\"vm.notification.Criteria == \'UserHaveNoTransactionXMonths\'\" \nng-class=\"{\'has-error\': notificationForm.notransaction.$invalid && notificationForm.notransaction.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.ymonths\"></label><div class=\"col-md-3\"><input \nclass=\"form-control\" name=\"notransaction\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserHaveNoTransactionXMonths\'\" ng-model=\"vm.notification.ZMonths\"><div \nng-messages=\"notificationForm.notransaction.$error\"><div ng-message=\"required\" \nng-if=\"notificationForm.notransaction.$touched\" class=\"help-block\"><span \ntranslate=\"admin.notification.errors.user_ymonths_required\"></span></div></div></div></div><div \nng-show=\"vm.notification.Criteria == \'UserWithXTransactionsInPastYmonths\'\"><div class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.xtransactions.$invalid && notificationForm.xtransactions.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.xtransactions\"></label><div class=\"col-md-3\"><input \nclass=\"form-control\" name=\"xtransactions\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserWithXTransactionsInPastYmonths\'\" \nng-model=\"vm.notification.XTransactions\"><div ng-messages=\"notificationForm.xtransactions.$error\"><div \nng-message=\"required\" ng-if=\"notificationForm.xtransactions.$touched\" class=\"help-block\"><span \ntranslate=\"admin.notification.errors.user_xtransactions_required\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': notificationForm.ymonths.$invalid && notificationForm.ymonths.$touched}\">\n<label class=\"control-label col-md-2\" translate=\"admin.notification.ymonths\"></label><div class=\"col-md-3\"><input \nclass=\"form-control\" name=\"ymonths\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserWithXTransactionsInPastYmonths\'\" ng-model=\"vm.notification.YMonths\"><div \nng-messages=\"notificationForm.ymonths.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.ymonths.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_ymonths_required\"></span></div></div></div></div>\n</div><div ng-show=\"vm.notification.Criteria == \'UserSpentXAmountAt_Y_Merchant\'\"><div class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.xamount.$invalid && notificationForm.xamount.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.xamount\"></label><div class=\"col-md-3\"><input \nclass=\"form-control\" name=\"xamount\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserSpentXAmountAt_Y_Merchant\'\" ng-model=\"vm.notification.XAmount\"><div \nng-messages=\"notificationForm.xamount.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.xamount.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_xamount_required\"></span></div></div></div></div>\n<div class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.ymerchant.$invalid && notificationForm.ymerchant.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.ymerchant\"></label><div class=\"col-md-3\"><input \nclass=\"form-control col-md-1\" name=\"ymerchant\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserSpentXAmountAt_Y_Merchant\'\" ng-model=\"vm.notification.YMerchant\"><div \nng-messages=\"notificationForm.ymerchant.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.ymerchant.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_ymerchant_required\"></span></div></div></div></div>\n</div><div ng-show=\"vm.notification.Criteria == \'UserSpentXTimesAt_Y_Merchant\'\"><div class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.xtimes.$invalid && notificationForm.xtimes.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.xtimes\"></label><div class=\"col-md-3\"><input \nclass=\"form-control\" name=\"xtimes\" type=\"text\" \nng-required=\"vm.notification.Criteria == \'UserSpentXTimesAt_Y_Merchant\'\" ng-model=\"vm.notification.XTimes\"><div \nng-messages=\"notificationForm.xtimes.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.xtimes.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.user_xtimes_required\"></span></div></div></div></div><div\n class=\"form-group\" \nng-class=\"{\'has-error\': notificationForm.ymerchant2.$invalid && notificationForm.ymerchant2.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.ymerchant\"></label><div class=\"col-md-3\"><input \nclass=\"form-control\" type=\"text\" name=\"ymerchant2\" \nng-required=\"vm.notification.Criteria == \'UserSpentXTimesAt_Y_Merchant\'\" ng-model=\"vm.notification.YMerchant\"><div \nng-messages=\"notificationForm.ymerchant2.$error\"><div ng-message=\"required\" \nng-if=\"notificationForm.ymerchant2.$touched\" class=\"help-block\"><span \ntranslate=\"admin.notification.errors.user_ymerchant_required\"></span></div></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': notificationForm.Title.$invalid && notificationForm.Title.$touched}\"><label \nclass=\"control-label col-md-2\" translate=\"admin.notification.title_message\"></label><div class=\"col-md-8\"><input \ntype=\"text\" class=\"form-control\" name=\"Title\" ng-model=\"vm.notification.Title\" required><div \nng-messages=\"notificationForm.Title.$error\"><div ng-message=\"required\" ng-if=\"notificationForm.Title.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.title_required\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': notificationForm.Message.$invalid && notificationForm.Message.$touched}\">\n<label class=\"control-label col-md-2\" translate=\"admin.notification.message\"></label><div class=\"col-md-8\"><textarea \nname=\"Message\" class=\"form-control\" ng-model=\"vm.notification.Message\" required></textarea><div \nng-messages=\"notificationForm.Message.$error\">.<div ng-message=\"required\" ng-if=\"notificationForm.Message.$touched\" \nclass=\"help-block\"><span translate=\"admin.notification.errors.message_required\"></span></div></div></div></div><div \nclass=\"form-group\" ng-show=\"vm.notification.DeliveryStatus == \'Sent\'\" \nng-class=\"{\'has-error\': groupForm.To.$invalid && groupForm.To.$touched}\"><label class=\"control-label col-md-2\" \ntranslate=\"admin.notificationlist.receipient\"></label><div class=\"col-md-8\"><textarea id=\"ulist\" name=\"To\" \nreadonly=\"readonly\" type=\"text\" class=\"form-control\" ng-model=\"vm.notification.Receipient\"></textarea></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-2\" translate=\"admin.notification.Notification_send_date\"></label>\n<div class=\"col-md-8\"><input type=\"datetime-local\" name=\"sdate\" ng-model=\"vm.notification.SendAt\" class=\"form-control\">\n</div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" \ntranslate=\"admin.notification.import\" name=\"NotificationHistoryDetails--list1\" export-to-csv></button> <a \nclass=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a></div></form></div></div></div>\n</div></div><ul uib-pagination total-items=\"vm.totalItems\" ng-change=\"vm.search()\" ng-model=\"vm.currentPage\" \nitems-per-page=\"vm.criteria.Length\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" \nrotate=\"false\"></ul></div></div></div></div>");
$templateCache.put("app/admin/promotion/promotion.view.layout.html","<div id=\"promotion-info\"><div id=\"exTab2\" class=\"container-fluid\"><ul class=\"nav nav-tabs\"><li class=\"active\"><a \ndata-target=\"#registration\" data-toggle=\"tab\">Registration Code</a></li></ul><div class=\"tab-content\"><div \nclass=\"tab-pane active\" id=\"registration\"><div ui-view=\"registrationCode\"></div></div></div></div></div>");
$templateCache.put("app/admin/promotion/promotion.view.registrationcode.html","<h1 class=\"page-header\" translate=\"admin.promotion.registration_code.title\"></h1><div id=\"registerCode\" \nclass=\"col-md-12\"><div class=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.criteria.Keyword\" \nng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter the registration code\"></div><div \nclass=\"col-md-1 col-sm-10\"><a class=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.reset()\"><i \nclass=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a></div><div \nclass=\"col-md-2 col-md-offset-6 col-sm-2\"><a class=\"btn btn-primary pull-right margin-tl\" \nng-click=\"vm.openDialog(\'new\')\"><i class=\"glyphicon glyphicon-plus\"></i> <span translate=\"common.action.add\"></span>\n</a></div></div></div><div class=\"form-group\"><div class=\"table-responsive\"><table \nclass=\"table table-striped table-bordered\"><thead><tr><th>#</th><th \ntranslate=\"admin.promotion.registration_code.merchant_name\"></th><th \ntranslate=\"admin.promotion.registration_code.registraion_code\"></th><th \ntranslate=\"admin.promotion.registration_code.amount\"></th><th translate=\"admin.promotion.registration_code.from_date\">\n</th><th translate=\"admin.promotion.registration_code.to_date\"></th><th \ntranslate=\"admin.promotion.registration_code.reward\"></th><th \ntranslate=\"admin.promotion.registration_code.validity_days\"></th><th translate=\"common.state\"></th><th \ntranslate=\"common.action.title\"></th></tr></thead><tbody><tr ng-repeat=\"referralCode in vm.referralCodes\"><td \nclass=\"center\">{{$index + 1}}</td><td>{{referralCode.MerchantName}}</td><td>{{referralCode.RegistrationCode}}</td><td>\n{{referralCode.Amount}}</td><td>{{referralCode.StartDate | date:\'yyyy-MM-dd\'}}</td><td>\n{{referralCode.EndDate | date:\'yyyy-MM-dd\'}}</td><td>{{referralCode.Reward}}</td><td>{{referralCode.ValidityPeriod}}\n</td><td>{{referralCode.Status}}</td><td class=\"center\"><a title=\"Edit\" class=\"btn btn-default margin-tl\" \nng-click=\"vm.openDialog(\'edit\', referralCode)\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a title=\"InActive\" \nng-if=\"referralCode.Status == \'Active\'\" class=\"btn btn-danger margin-tl\" ng-click=\"vm.InActive(referralCode)\"><i \nclass=\"glyphicon glyphicon-cloud-download\"></i></a> <a title=\"Active\" ng-if=\"referralCode.Status == \'InActive\'\" \nclass=\"btn btn-primary margin-tl\" ng-click=\"vm.Active(referralCode)\"><i class=\"glyphicon glyphicon-cloud-upload\"></i>\n</a> <a title=\"Remove\" class=\"btn btn-danger margin-tl\" ng-click=\"vm.remove(referralCode)\"><i \nclass=\"glyphicon glyphicon-remove\"></i></a></td></tr></tbody></table></div><ul uib-pagination \ntotal-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-change=\"vm.search()\" ng-model=\"vm.currentPage\" \nmax-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div><div \nclass=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" tabindex=\"-1\" \nrole=\"dialog\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><form name=\"registerCodeForm\" \nclass=\"form-horizontal\" ng-submit=\"vm.save()\" novalidate id=\"registerCodeForm\"><div class=\"modal-header\"><button \ntype=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowDialog = false\"><span aria-hidden=\"true\">&times;</span><span \nclass=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\" \ntranslate=\"admin.promotion.registration_code.create\"></h3></div><div class=\"modal-body\"><div class=\"form-group\"><div \nclass=\"col-md-12\"><h4 class=\"sub-title\" translate=\"admin.promotion.registration_code.promo_info\"></h4></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"admin.promotion.registration_code.merchant\"></label><div class=\"col-md-8\"><ui-select \nng-model=\"vm.referralCode.MerchantId\" name=\"MerChantName\" theme=\"bootstrap\" \nng-change=\"vm.getVoucherOfMerchant(vm.referralCode.MerchantId); vm.search()\"><ui-select-match allow-clear=\"true\" \nplaceholder=\"Enter the merchant\'s name\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh=\"vm.loadMerchant($select.search)\" \nrefresh-delay=\"0\" minimum-input-length=\"0\"><div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': registerCodeForm.Reward.$invalid && registerCodeForm.Reward.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.promotion.registration_code.reward\"></label><div \nclass=\"col-md-8\"><select class=\"form-control\" ng-model=\"vm.referralCode.Reward\" name=\"Reward\" \nng-change=\"vm.rewardChange(vm.referralCode.Reward)\" required><option value=\"\">Please select reward...</option><option \nng-repeat=\"reward in vm.rewards\" \nng-disabled=\"reward.Name == \'StoreCard\' && (vm.referralCode.MerchantId == \'\' || vm.referralCode.MerchantId == null)\" \nvalue=\"{{reward.Id}}\">{{reward.Name}}</option></select><div ng-messages=\"registerCodeForm.Reward.$error\"><div \nng-message=\"required\" ng-if=\"registerCodeForm.Reward.$touched\" class=\"help-block\"><span \ntranslate=\"admin.promotion.registration_code.validate.reward\"></span></div></div></div></div><div class=\"form-group\" \nng-if=\"vm.isVoucher\" ng-class=\"{\'has-error\': registerCodeForm.Voucher.$invalid && registerCodeForm.Voucher.$touched}\">\n<label class=\"control-label col-md-3 margin-tb\" translate=\"admin.promotion.registration_code.voucher\"></label><div \nclass=\"col-md-8\"><select class=\"form-control\" ng-model=\"vm.referralCode.VoucherId\" name=\"Voucher\" required><option \nvalue=\"\">Please select a Voucher...</option><option ng-repeat=\"voucher in vm.vouchers\" value=\"{{voucher.Id}}\">\n{{voucher.Name}}</option></select><div ng-messages=\"registerCodeForm.Voucher.$error\"><div ng-message=\"required\" \nng-if=\"registerCodeForm.Voucher.$touched\" class=\"help-block\"><span \ntranslate=\"admin.promotion.registration_code.validate.voucher\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': registerCodeForm.PromotionCode.$invalid && registerCodeForm.PromotionCode.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.promotion.registration_code.promotion_code\"></label><div \nclass=\"col-md-8\"><input name=\"PromotionCode\" type=\"text\" class=\"form-control\" \nng-model=\"vm.referralCode.RegistrationCode\" placeholder=\"Registration code\" required \nreferral-code-invalid=\"vm.referralCode.Id\"><div ng-messages=\"registerCodeForm.PromotionCode.$error\"><div \nng-message=\"required\" ng-if=\"registerCodeForm.PromotionCode.$touched\" class=\"help-block\"><span \ntranslate=\"admin.promotion.registration_code.validate.promotion_code\"></span></div><div \nng-message=\"referralCodeInvalid\" ng-if=\"registerCodeForm.PromotionCode.$touched\" class=\"help-block\"><span \ntranslate=\"admin.promotion.registration_code.validate.promotion_code_duplicate\"></span></div></div></div></div><div \nng-if=\"!vm.isVoucher\" class=\"form-group\" \nng-class=\"{\'has-error\': registerCodeForm.Amount.$invalid && registerCodeForm.Amount.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.promotion.registration_code.amount\"></label><div \nclass=\"col-md-8\"><input name=\"Amount\" type=\"number\" class=\"form-control\" ng-model=\"vm.referralCode.Amount\" required>\n<div ng-messages=\"registerCodeForm.Amount.$error\"><div ng-message=\"required\" ng-if=\"registerCodeForm.Amount.$touched\" \nclass=\"help-block\"><span translate=\"admin.promotion.registration_code.validate.amount\"></span></div></div></div></div>\n<div class=\"form-group\" \nng-class=\"{\'has-error\': registerCodeForm.StartDate.$invalid && registerCodeForm.StartDate.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"admin.promotion.registration_code.from_date\"></label><div \nclass=\"col-md-8\"><div class=\"input-group\"><input type=\"text\" name=\"StartDate\" class=\"form-control\" \nuib-datepicker-popup ng-model=\"vm.referralCode.StartDate\" is-open=\"vm.StartDatePopup.opened\" \ndatepicker-options=\"vm.dateOptions\" close-text=\"Close\" required autocomplete=\"off\" ng-click=\"vm.openStartDatePopup()\" \nng-change=\"vm.DateChanged()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" \nng-click=\"vm.openStartDatePopup()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div \nng-messages=\"registerCodeForm.StartDate.$error\"><div ng-message=\"required\" ng-if=\"registerCodeForm.StartDate.$touched\" \nclass=\"help-block\"><span translate=\"admin.promotion.registration_code.validate.start_date_required\"></span></div><div \nng-message=\"date\" ng-if=\"registerCodeForm.StartDate.$touched\" class=\"help-block\"><span \ntranslate=\"admin.promotion.registration_code.validate.start_date_valid\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': registerCodeForm.EndDate.$invalid && registerCodeForm.EndDate.$touched}\">\n<label class=\"control-label col-md-3 required margin-tb\" translate=\"admin.promotion.registration_code.to_date\"></label>\n<div class=\"col-md-8\"><div class=\"input-group\"><input type=\"text\" name=\"EndDate\" class=\"form-control\" \nuib-datepicker-popup ng-model=\"vm.referralCode.EndDate\" is-open=\"vm.EndDatePopup.opened\" \ndatepicker-options=\"vm.dateOptionsEndDate\" close-text=\"Close\" required autocomplete=\"off\" \nng-click=\"vm.openEndDatePopup()\" ng-change=\"vm.DateChanged()\"> <span class=\"input-group-btn\"><button type=\"button\" \nclass=\"btn btn-default\" ng-click=\"vm.openEndDatePopup()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span>\n</div><div ng-messages=\"registerCodeForm.EndDate.$error\"><div ng-message=\"required\" \nng-if=\"registerCodeForm.EndDate.$touched\" class=\"help-block\"><span \ntranslate=\"admin.promotion.registration_code.validate.end_date_required\"></span></div><div ng-message=\"date\" \nng-if=\"registerCodeForm.EndDate.$touched\" class=\"help-block\"><span \ntranslate=\"admin.promotion.registration_code.validate.end_date_valid\"></span></div></div></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': registerCodeForm.ValidityPeriod.$invalid && registerCodeForm.ValidityPeriod.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.promotion.registration_code.validity_days_add\"></label><div \nclass=\"col-md-8\"><input name=\"ValidityPeriod\" type=\"number\" class=\"form-control\" \nng-model=\"vm.referralCode.ValidityPeriod\" ng-pattern=\"/^[0-9]{1,7}$/\" required><div \nng-messages=\"registerCodeForm.ValidityPeriod.$error\"><div ng-message=\"required\" \nng-if=\"registerCodeForm.ValidityPeriod.$touched\" class=\"help-block\"><span \ntranslate=\"admin.promotion.registration_code.validate.validity_period\"></span></div><div ng-message=\"pattern\" \nng-if=\"registerCodeForm.ValidityPeriod.$touched\" class=\"help-block\"><span \ntranslate=\"admin.promotion.registration_code.validate.validity_period_number\"></span></div></div></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': registerCodeForm.MaxQuantity.$invalid && registerCodeForm.MaxQuantity.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"admin.promotion.registration_code.max_quantity\"></label>\n<div class=\"col-md-8\"><input name=\"MaxQuantity\" type=\"number\" class=\"form-control\" \nng-model=\"vm.referralCode.MaxQuantity\" ng-pattern=\"/^[0-9]{1,7}$/\" required \nng-min-or-zero=\"vm.referralCode.UsedQuantity\"><div ng-messages=\"registerCodeForm.MaxQuantity.$error\"><div \nng-message=\"required\" ng-if=\"registerCodeForm.MaxQuantity.$touched\" class=\"help-block\"><span \ntranslate=\"admin.promotion.registration_code.validate.max_quantity\"></span></div><div ng-message=\"ngMinOrZero\" \nng-if=\"registerCodeForm.MaxQuantity.$touched\" class=\"help-block\"><span \ntranslate=\"admin.promotion.registration_code.validate.max_quantity_min\"></span></div><div ng-message=\"pattern number\" \nng-if=\"registerCodeForm.MaxQuantity.$touched\" class=\"help-block\"><span \ntranslate=\"admin.promotion.registration_code.validate.max_quantity_number\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"admin.promotion.registration_code.used_quantity\"></label><div class=\"col-md-8\"><input name=\"UsedQuantity\" \ntype=\"number\" class=\"form-control\" ng-model=\"vm.referralCode.UsedQuantity\" disabled=\"disabled\"></div></div></div><div \nclass=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button \ntype=\"submit\" class=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div></div>\n</div>");
$templateCache.put("app/admin/referral-banner/referral-banner.html","<h1 class=\"page-header\" translate=\"Manage Referral Banner\"></h1><div id=\"referral-banner\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-6 col-md-offset-6 col-sm-6\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.openDialog(\'new\')\"><i class=\"glyphicon glyphicon-plus\"></i> \n<span translate=\"common.action.add\"></span></a></div></div></div><div class=\"form-group\"><div class=\"table-responsive\">\n<table class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th width=\"20%\" translate=\"photo\"></th><th \ntranslate=\"Link\"></th><th translate=\"Position\"></th><th translate=\"BannerType\"></th><th \ntranslate=\"common.action.title\"></th></tr></thead><tbody><tr ng-repeat=\"banner in vm.banners\"><td class=\"center\">\n{{$index + 1}}</td><td width=\"20%\"><img style=\"width:100%\" class=\"photo\" ng-if=\"banner.Photos\" \nng-src=\"{{banner.Photos}}\"></td><td>{{banner.Link}}</td><td>{{banner.Position}}</td><td>{{banner.BannerType}}</td><td \nclass=\"center\"><a title=\"Edit\" class=\"btn btn-default margin-tl\" ng-click=\"vm.openDialog(\'edit\', banner)\"><i \nclass=\"glyphicon glyphicon-edit\"></i></a> <a title=\"Remove\" class=\"btn btn-danger margin-tl\" \nng-click=\"vm.remove(banner)\"><i class=\"glyphicon glyphicon-remove\"></i></a></td></tr></tbody></table></div><ul \nuib-pagination total-items=\"vm.totalItems\" ng-change=\"vm.search()\" ng-model=\"vm.currentPage\" \nitems-per-page=\"vm.criteria.Length\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" \nrotate=\"false\"></ul></div></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><form name=\"referralbannerForm\" \nclass=\"form-horizontal\" ng-submit=\"vm.save()\" novalidate id=\"referralbannerForm\"><div class=\"modal-header\"><button \ntype=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowDialog = false\"><span aria-hidden=\"true\">&times;</span><span \nclass=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\" \ntranslate=\"admin.referralbanner.banner_model_title\"></h3></div><div class=\"modal-body\"><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"Banner Type\"></label><div class=\"col-md-8\"><select \nclass=\"form-control\" ng-model=\"vm.banner.Type\"><option ng-repeat=\"v in vm.BannerType\" ng-value=\"v.Id\">\n{{v.Name| translate}}</option></select></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.referralbanner.Link_URL\"></label><div class=\"col-md-8\"><input\n type=\"text\" name=\"Link\" class=\"form-control\" ng-model=\"vm.banner.Link\"></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.referralbanner.Position\"></label><div class=\"col-md-8\"><input\n type=\"number\" name=\"number\" min=\"1\" max=\"3\" class=\"form-control\" ng-disabled=\"vm.disabledPosition\" \nng-model=\"vm.banner.Position\"></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': referralbannerForm.file.$invalid && referralbannerForm.file.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"admin.referralbanner.Image\"></label><div class=\"photos-form col-md-8\"><div \nclass=\"upload-controls\" ng-if=\"vm.banner.Photos.length==0\"><input type=\"file\" class=\"button\" \nngf-select=\"vm.uploadPhoto($files, $invalidFiles)\" name=\"file\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" \nngf-dimensions=\"($width >= 948) && ($height >= 408) && (($width / $height) >= 1)\" ng-model=\"vm.temp.Photo\" \nngf-multiple=\"false\"></div><div ng-if=\"vm.banner.Photos.length==0\"><label class=\"note\" \ntranslate=\"admin.referralbanner.validate.photo.note\"></label></div><div class=\"file-list\" style=\"width:100%\"><div \nng-messages=\"referralbannerForm.file.$error\"><div ng-message=\"dimensions\" ng-if=\"referralbannerForm.file.$dirty\" \nclass=\"help-block\"><p translate=\"admin.referralbanner.validate.photo.dimension\"></p></div></div><ul \ndnd-list=\"vm.banner.Photos\"><li ng-repeat=\"photo in vm.banner.Photos\" style=\"font:smaller\"><div class=\"preview-photos\">\n<span class=\"dnd\"></span> <img style=\"width:100%;padding-bottom:1%\" src=\"{{photo}}\" class=\"thumb\"> <a \nng-click=\"vm.removePhoto($index)\" class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-remove\"></i> <span \ntranslate=\"Remove\"></span></a></div></li></ul></div></div></div></div><div class=\"modal-footer\"><a \nclass=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button type=\"submit\" \nclass=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div></div></div>");
$templateCache.put("app/admin/refund/refund.html","<h1 class=\"page-header\" translate=\"admin.refund.title\"></h1><div id=\"brand\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"row\"><div class=\"col-md-6\"><form name=\"refundForm\" class=\"form-horizontal\" \nng-submit=\"vm.save()\" novalidate id=\"refundForm\"><div class=\"form-group\" \nng-class=\"{\'has-error\': refundForm.UserName.$invalid && refundForm.UserName.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"common.username\"></label><div class=\"col-md-9\"><ui-select \nng-model=\"vm.refund.UserName\" theme=\"bootstrap\" required name=\"UserName\"><ui-select-match placeholder=\"Enter username\">\n{{$select.selected.UserName}}</ui-select-match><ui-select-choices \nrepeat=\"account.Id as account in vm.accounts | filter: $select.search\" refresh=\"vm.loadUserName($select.search)\" \nrefresh-delay=\"0\" minimum-input-length=\"0\"><div ng-bind-html=\"account.UserName | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The username cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select><div ng-messages=\"refundForm.UserName.$error\"><div ng-message=\"required\" \nng-if=\"refundForm.UserName.$touched\" class=\"help-block\"><span translate=\"admin.refund.validate.username\"></span></div>\n</div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': refundForm.TransactionId.$invalid && refundForm.TransactionId.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"admin.refund.transaction_id\"></label><div \nclass=\"col-md-9\"><input name=\"TransactionId\" type=\"number\" class=\"form-control\" ng-model=\"vm.refund.TransactionId\" \nrequired autocomplete=\"off\" ng-pattern=\"/^[0-9]*$/\" step=\"1\" maxlength=\"10\" placeholder=\"Enter transaction id\"><div \nng-messages=\"refundForm.TransactionId.$error\"><div ng-message=\"required\" ng-if=\"refundForm.TransactionId.$touched\" \nclass=\"help-block\"><span translate=\"admin.refund.validate.transaction_id\"></span></div><div \nng-message=\"number, pattern, maxlength\" ng-if=\"refundForm.TransactionId.$touched\" class=\"help-block\"><span \ntranslate=\"admin.refund.validate.transaction_id_invalid\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': refundForm.Remark.$invalid && refundForm.Remark.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.refund.remark\"></label><div class=\"col-md-9\"><input \nname=\"Remark\" type=\"text\" class=\"form-control\" ng-model=\"vm.refund.Remark\" autocomplete=\"off\" \nplaceholder=\"Enter the remark\"></div></div><div class=\"form-group\"><div class=\"col-md-12\"><a \nclass=\"btn btn-danger pull-right margin-tl\" ng-click=\"vm.reset()\" translate=\"common.action.reset\"></a> <button \ntype=\"submit\" class=\"btn btn-primary pull-right margin-tl\" translate=\"admin.refund.action.refund\"></button></div></div>\n</form><div class=\"alert alert-success\" ng-if=\"vm.result\"><strong>Refund successful!</strong><br><br><strong>KipleKash:\n</strong>{{vm.result.KipleKash}}<br><strong>StoreCard:</strong>{{vm.result.StoreCard}}<br><strong>Remark:</strong>\n{{vm.result.Remark}}<br></div></div></div></div></div>");
$templateCache.put("app/admin/settlement-summary/settlement-summary.html","<h1 class=\"page-header\" translate=\"admin.settlement_transaction.summary\"></h1><div id=\"settlement_transaction\" \nclass=\"col-md-12\"><div class=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\">Start Date</label></div><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\">End Date</label></div></div><div class=\"row\"><div \nclass=\"col-md-3 col-xs-12 dropdown dropdown-date margin-tb\"><a class=\"dropdown-toggle\" id=\"dropdownStart\" \nrole=\"button\" data-toggle=\"dropdown\" data-target=\".dropdown-Startdate\" href=\"#\"><div class=\"input-group date\"><input \ntype=\"text\" class=\"form-control\" readonly=\"readonly\" data-date-time-input=\"YYYY-MM-DD\" placeholder=\"YYYY-MM-DD\" \ndata-ng-model=\"vm.criteria.Date\"> <span class=\"input-group-addon\"><i class=\"glyphicon glyphicon-calendar\"></i></span>\n</div></a><ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\"><datetimepicker \ndata-ng-model=\"vm.criteria.Date\" \ndata-datetimepicker-config=\"{ dropdownSelector: \'#dropdownStart\', modelType: \'YYYY-MM-DD\', minView: \'day\' }\">\n</datetimepicker></ul></div><div class=\"col-md-3 col-xs-12 dropdown dropdown-date margin-tb\"><a \nclass=\"dropdown-toggle\" id=\"dropdownEnd\" role=\"button\" data-toggle=\"dropdown\" data-target=\".dropdown-Enddate\" href=\"#\">\n<div class=\"input-group date\"><input type=\"text\" class=\"form-control\" readonly=\"readonly\" \ndata-date-time-input=\"YYYY-MM-DD\" placeholder=\"YYYY-MM-DD\" data-ng-model=\"vm.criteria.EndDate\"> <span \nclass=\"input-group-addon\"><i class=\"glyphicon glyphicon-calendar\"></i></span></div></a><ul class=\"dropdown-menu\" \nrole=\"menu\" aria-labelledby=\"dLabel\"><datetimepicker data-ng-model=\"vm.criteria.EndDate\" \ndata-on-set-time=\"vm.summary(\'summary\')\" \ndata-datetimepicker-config=\"{ dropdownSelector: \'#dropdownEnd\', modelType: \'YYYY-MM-DD\', minView: \'day\' }\">\n</datetimepicker></ul></div><div class=\"col-md-1 col-sm-10\"><a class=\"btn btn-primary pull-right margin-tl\" \nng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a>\n</div><div class=\"col-md-6 col-xs-2\"><a class=\"btn btn-primary pull-right\" ng-show=\"vm.isShowCommitButton\" \nng-click=\"vm.openDialog()\"><i class=\"glyphicon glyphicon-plus\"></i> <span translate=\"common.action.commit\"></span></a>\n</div></div><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><select class=\"form-control\" \nng-model=\"vm.criteria.MasterMerchantId\" ng-change=\"vm.summary(\'summary\')\" name=\"MasterMerchantId\" required><option \nvalue=\"\" selected=\"selected\">-- Select Master Merchant --</option><option \nng-repeat=\"masterMerchant in vm.masterMerchants\" ng-value=\"masterMerchant.Id\">{{masterMerchant.Name}}</option></select>\n</div><div class=\"col-md-3 col-xs-12 margin-tb\"><ui-select ng-model=\"vm.criteria.MerchantId\" theme=\"bootstrap\" \nng-change=\"vm.summary(\'summary\')\"><ui-select-match placeholder=\"Merchant name\" allow-clear=\"true\">\n{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh=\"vm.loadMerchant($select.search)\" \nrefresh-delay=\"0\" minimum-input-length=\"3\"><div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div><div class=\"col-md-3 col-xs-12 margin-tb\"><select class=\"form-control\" \nng-model=\"vm.criteria.Status\" ng-change=\"vm.summary(\'summary\')\" name=\"SettlementStatus\" required><option value=\"\" \nselected=\"selected\">-- Select Status --</option><option value=\"0\">Processing</option><option value=\"1\">Settled</option>\n</select></div><div class=\"col-md-3 col-xs-12 margin-tb\"><select class=\"form-control\" \nng-model=\"vm.criteria.Clientname\" ng-change=\"vm.summary(\'summary\')\" name=\"clientname\" required><option value=\"\" \nselected=\"selected\">-- Select Client --</option><option value=\"0\">All</option><option value=\"petronas\">petronas\n</option></select></div></div></div><div class=\"form-group\"><div class=\"table-responsive\"><table \nclass=\"table table-striped table-bordered\"><thead><tr><th><input type=\"checkbox\" ng-model=\"vm.isCheckAll\" \nng-change=\"vm.checkAll()\"></th><th translate=\"admin.settlement_transaction.merchant_id\"></th><th \ntranslate=\"admin.settlement_transaction.merchant_name\"></th><th>Start Date</th><th>End Date</th><th>Total Transactions\n</th><th translate=\"admin.settlement_transaction.value\">Total Amount</th><th>MDRFee</th><th \ntranslate=\"admin.settlement_transaction.amount\"></th><th translate=\"admin.settlement_transaction.status\"></th><th \ntranslate=\"admin.settlement_transaction.settlement_date\"></th></tr></thead><tbody><tr \nng-repeat=\"transaction in vm.transactions\"><td class=\"text-center\"><input type=\"checkbox\" \nng-model=\"transaction.IsChecked\" ng-change=\"vm.checkItem(transaction)\" ng-show=\"transaction.Status != \'Settled\'\"></td>\n<td>{{transaction.MerchantId}}</td><td>{{transaction.MerchantName}}</td><td>\n{{transaction.StartDate| date: \'yyyy-MM-dd\'}}</td><td>{{transaction.EndDate | date: \'yyyy-MM-dd\'}}</td><td \nclass=\"center\"><a ng-click=\"vm.redirectToTransactions(transaction)\">{{transaction.Count}}</a></td><td class=\"right\">\n{{transaction.TotalAmount | currency :\"\"}}</td><td class=\"right\">{{transaction.MDRFee | currency :\"\"}}</td><td \nclass=\"right\">{{transaction.SettlementAmount | currency :\"\"}}</td><td class=\"center\">{{transaction.Status}}</td><td>\n{{transaction.SettlementDate | date: \'yyyy-MM-dd\'}}</td></tr><tr><td></td><td></td><td></td><td></td><td>Total :</td>\n<td class=\"center\">{{getTotal().totalCount }}</td><td class=\"right\">{{getTotal().totalamt | currency :\"\"}}</td><td \nclass=\"right\">{{getTotal().totalMDR | currency :\"\"}}</td><td class=\"right\">\n{{getTotal().totalSettlementamt | currency :\"\"}}</td><td></td><td></td></tr></tbody></table></div>\nPage {{vm.currentPage}} of {{(vm.totalItems / vm.itemsPerPage) | roundup }} , showing {{(vm.currentPage * vm.itemsPerPage) > vm.totalItems ? vm.totalItems : (vm.currentPage * vm.itemsPerPage)}} records out of {{vm.totalItems}} Records\n<ul uib-pagination total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-change=\"vm.summary()\" \nng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul>\n</div></div><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" \ntabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><form \nname=\"transactionForm\" class=\"form-horizontal\" ng-submit=\"vm.save()\" novalidate id=\"transactionForm\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowDialog = false\"><span \naria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" \nid=\"modal-title\" translate=\"admin.settlement_transaction.title\"></h3></div><div class=\"modal-body\" \nstyle=\"min-height: 300px\"><div class=\"form-group\" \nng-class=\"{\'has-error\': transactionForm.SettlementDate.$invalid && transactionForm.SettlementDate.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"common.date\"></label><div class=\"col-md-8\"><div \nclass=\"dropdown dropdown-settlement-date\"><a class=\"dropdown-toggle\" id=\"settlement-date\" role=\"button\" \ndata-toggle=\"dropdown\" data-target=\".dropdown-settlement-date\" href=\"#\"><div class=\"input-group date\"><input \ntype=\"text\" class=\"form-control\" name=\"SettlementDate\" required readonly=\"readonly\" data-date-time-input=\"YYYY-MM-DD\" \nplaceholder=\"YYYY-MM-DD\" data-ng-model=\"vm.settlementTransactions.Date\"> <span class=\"input-group-addon\"><i \nclass=\"glyphicon glyphicon-calendar\"></i></span></div></a><ul class=\"dropdown-menu\" role=\"menu\" \naria-labelledby=\"dLabel\"><datetimepicker data-ng-model=\"vm.settlementTransactions.Date\" \ndata-datetimepicker-config=\"{ dropdownSelector: \'#settlement-date\', modelType: \'YYYY-MM-DD\', minView: \'day\' }\">\n</datetimepicker></ul></div><div ng-messages=\"transactionForm.SettlementDate.$error\"><div ng-message=\"required\" \nng-if=\"transactionForm.SettlementDate.$touched\" class=\"help-block\"><span \ntranslate=\"admin.settlement_transaction.validate.date_required\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': transactionForm.SettlementStatus.$invalid && transactionForm.SettlementStatus.$touched}\"><label\n class=\"control-label col-md-3 required\" translate=\"common.status\"></label><div class=\"col-md-8\"><select \nclass=\"form-control\" name=\"SettlementStatus\" ng-model=\"vm.settlementTransactions.Status\" required><option value=\"\">\nPlease select status</option><option value=\"Processing\">Processing</option><option value=\"Settled\">Settled</option>\n</select><div ng-messages=\"transactionForm.SettlementStatus.$error\"><div ng-message=\"required\" \nng-if=\"transactionForm.SettlementStatus.$touched\" class=\"help-block\"><span \ntranslate=\"admin.settlement_transaction.validate.status_required\"></span></div></div></div></div></div><div \nclass=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button \ntype=\"submit\" class=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div></div>\n</div>");
$templateCache.put("app/admin/sharedStoreCard/sharedStoreCard.html","<h1 class=\"page-header\" translate=\"admin.sharedStoreCard.title\"></h1><div id=\"group\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><input \nng-keypress=\"vm.searchByKeyword($event)\" ng-model=\"vm.criteria.Keyword\" type=\"text\" \nplaceholder=\"Enter Shared Store Card\" class=\"form-control\"></div><div class=\"col-md-1 col-sm-10\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span \ntranslate=\"common.action.reset\"></span></a></div><div class=\"col-md-2 col-md-offset-6 col-sm-2\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ui-sref=\"app.admin.sharedStoreCard.new\"><i \nclass=\"glyphicon glyphicon-plus\"></i> <span translate=\"common.action.add\"></span></a></div></div></div><div \nclass=\"form-group\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered\"><thead><tr><th>#\n</th><th translate=\"admin.sharedStoreCard.name\"></th><th translate=\"admin.sharedStoreCard.merchant_name\"></th><th \ntranslate=\"admin.sharedStoreCard.created_at\"></th><th translate=\"admin.sharedStoreCard.created_by\"></th><th \ntranslate=\"common.action.title\"></th></tr></thead><tbody><tr ng-repeat=\"sharedStoreCard in vm.sharedStoreCard\"><td \nclass=\"center\">{{$index + 1}}</td><td>{{sharedStoreCard.Name}}</td><td>{{sharedStoreCard.MerchantName}}</td><td>\n{{sharedStoreCard.CreatedAt | date: \'yyyy-MM-dd\'}}</td><td>{{sharedStoreCard.CreatedBy}}</td><td class=\"center\"><a \ntitle=\"Edit\" class=\"btn btn-default margin-tl\" ui-sref=\"app.admin.sharedStoreCard.edit({id:sharedStoreCard.Id})\"><i \nclass=\"glyphicon glyphicon-edit\"></i></a> <a title=\"Remove\" class=\"btn btn-danger margin-tl\" \nng-click=\"vm.remove(sharedStoreCard)\"><i class=\"glyphicon glyphicon-remove\"></i></a></td></tr></tbody></table></div>\n</div><ul uib-pagination total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-change=\"vm.search()\" \nng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul>\n</div></div>");
$templateCache.put("app/admin/settlement-transaction/settlement-transaction.html","<h1 class=\"page-header\" translate=\"admin.settlement_transaction.title\"></h1><div id=\"settlement_transaction\" \nclass=\"col-md-12\"><div class=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\">Start Date</label></div><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\">End Date</label></div><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\">Merchant Type</label></div><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\">Merchant Name</label></div></div><div class=\"row\">\n<div class=\"col-md-3 col-xs-12 dropdown dropdown-date margin-tb\"><a class=\"dropdown-toggle\" id=\"dropdownStart\" \nrole=\"button\" data-toggle=\"dropdown\" data-target=\".dropdown-Startdate\" href=\"#\"><div class=\"input-group date\"><input \ntype=\"text\" class=\"form-control\" readonly=\"readonly\" data-date-time-input=\"YYYY-MM-DD\" placeholder=\"YYYY-MM-DD\" \ndata-ng-model=\"vm.criteria.Date\"> <span class=\"input-group-addon\"><i class=\"glyphicon glyphicon-calendar\"></i></span>\n</div></a><ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\"><datetimepicker \ndata-ng-model=\"vm.criteria.Date\" \ndata-datetimepicker-config=\"{ dropdownSelector: \'#dropdownStart\', modelType: \'YYYY-MM-DD\', minView: \'day\' }\">\n</datetimepicker></ul></div><div class=\"col-md-3 col-xs-12 dropdown dropdown-date margin-tb\"><a \nclass=\"dropdown-toggle\" id=\"dropdownEnd\" role=\"button\" data-toggle=\"dropdown\" data-target=\".dropdown-Endate\" href=\"#\">\n<div class=\"input-group date\"><input type=\"text\" class=\"form-control\" readonly=\"readonly\" \ndata-date-time-input=\"YYYY-MM-DD\" placeholder=\"YYYY-MM-DD\" data-ng-model=\"vm.criteria.EndDate\"> <span \nclass=\"input-group-addon\"><i class=\"glyphicon glyphicon-calendar\"></i></span></div></a><ul class=\"dropdown-menu\" \nrole=\"menu\" aria-labelledby=\"dLabel\"><datetimepicker data-ng-model=\"vm.criteria.EndDate\" \ndata-on-set-time=\"vm.search(\'search\')\" \ndata-datetimepicker-config=\"{ dropdownSelector: \'#dropdownEnd\', modelType: \'YYYY-MM-DD\', minView: \'day\' }\">\n</datetimepicker></ul></div><div class=\"col-md-3 col-xs-12 margin-tb\"><select class=\"form-control\" \nng-model=\"vm.criteria.clientname\" ng-change=\"vm.search(\'search\')\" name=\"clientname\" required><option value=\"\">All\n</option><option value=\"petronas\">petronas</option></select></div><div class=\"col-md-3 col-xs-12 margin-tb\"><ui-select \nng-model=\"vm.criteria.MerchantId\" theme=\"bootstrap\" ng-change=\"vm.search(\'search\')\"><ui-select-match \nplaceholder=\"Merchant name\" allow-clear=\"true\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh=\"vm.loadMerchant($select.search)\" \nrefresh-delay=\"0\" minimum-input-length=\"3\"><div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div><div class=\"col-md-6 col-xs-2\"><a class=\"btn btn-primary pull-right\" \nng-show=\"vm.isShowCommitButton\" ng-click=\"vm.openDialog()\"><i class=\"glyphicon glyphicon-plus\"></i> <span \ntranslate=\"common.action.commit\"></span></a></div></div></div><div class=\"form-group\"><div class=\"table-responsive\">\n<table class=\"table table-striped table-bordered\"><thead><tr><th><input type=\"checkbox\" ng-model=\"vm.isCheckAll\" \nng-change=\"vm.checkAll()\"></th><th translate=\"admin.settlement_transaction.id\"></th><th \ntranslate=\"admin.settlement_transaction.date\"></th><th translate=\"admin.settlement_transaction.merchant_id\"></th><th \ntranslate=\"admin.settlement_transaction.merchant_name\"></th><th>Transaction Action</th><th \ntranslate=\"admin.settlement_transaction.value\"></th><th>MDRFee</th><th translate=\"admin.settlement_transaction.amount\">\n</th><th translate=\"admin.settlement_transaction.status\"></th><th \ntranslate=\"admin.settlement_transaction.settlement_date\"></th></tr></thead><tbody><tr \nng-repeat=\"transaction in vm.transactions\"><td class=\"text-center\"><input type=\"checkbox\" \nng-model=\"transaction.IsChecked\" ng-change=\"vm.checkItem(transaction)\"></td><td>{{transaction.Id}}</td><td>\n{{transaction.Date | date: \'yyyy-MM-dd HH:mm:ss\'}}</td><td>{{transaction.MerchantId}}</td><td>\n{{transaction.MerchantName}}</td><td>{{transaction.Action}}</td><td class=\"right\">\n{{transaction.Action == \"TransactionVoid\" ? \"-\":\"\"}} {{transaction.Amount | currency :\"\"}}</td><td class=\"right\">\n{{transaction.MDRFee | currency :\"\"}}</td><td class=\"right\">\n{{transaction.Action == \"TransactionVoid\" ? \"-\":\"\"}} {{transaction.SettlementAmount | currency :\"\"}}</td><td \nclass=\"center\">{{transaction.SettlementStatus}}</td><td>{{transaction.SettlementDate | date: \'yyyy-MM-dd\'}}</td></tr>\n</tbody></table></div><span class=\"pagination-info itemCount\">\nPage {{vm.currentPage}} of {{(vm.totalItems / vm.itemsPerPage) | roundup }} , showing {{(vm.currentPage * vm.itemsPerPage) > vm.totalItems ? vm.totalItems : (vm.currentPage * vm.itemsPerPage)}} records out of {{vm.totalItems}} Records\n</span><ul uib-pagination total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-change=\"vm.search()\" \nng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul>\n</div></div><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" \ntabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><form \nname=\"transactionForm\" class=\"form-horizontal\" ng-submit=\"vm.save()\" novalidate id=\"transactionForm\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowDialog = false\"><span \naria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" \nid=\"modal-title\" translate=\"admin.settlement_transaction.title\"></h3></div><div class=\"modal-body\" \nstyle=\"min-height: 300px\"><div class=\"form-group\" \nng-class=\"{\'has-error\': transactionForm.SettlementDate.$invalid && transactionForm.SettlementDate.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"common.date\"></label><div class=\"col-md-8\"><div \nclass=\"dropdown dropdown-settlement-date\"><a class=\"dropdown-toggle\" id=\"settlement-date\" role=\"button\" \ndata-toggle=\"dropdown\" data-target=\".dropdown-settlement-date\" href=\"#\"><div class=\"input-group date\"><input \ntype=\"text\" class=\"form-control\" name=\"SettlementDate\" required readonly=\"readonly\" data-date-time-input=\"YYYY-MM-DD\" \nplaceholder=\"YYYY-MM-DD\" data-ng-model=\"vm.settlementTransactions.Date\"> <span class=\"input-group-addon\"><i \nclass=\"glyphicon glyphicon-calendar\"></i></span></div></a><ul class=\"dropdown-menu\" role=\"menu\" \naria-labelledby=\"dLabel\"><datetimepicker data-ng-model=\"vm.settlementTransactions.Date\" \ndata-datetimepicker-config=\"{ dropdownSelector: \'#settlement-date\', modelType: \'YYYY-MM-DD\', minView: \'day\' }\">\n</datetimepicker></ul></div><div ng-messages=\"transactionForm.SettlementDate.$error\"><div ng-message=\"required\" \nng-if=\"transactionForm.SettlementDate.$touched\" class=\"help-block\"><span \ntranslate=\"admin.settlement_transaction.validate.date_required\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': transactionForm.SettlementStatus.$invalid && transactionForm.SettlementStatus.$touched}\"><label\n class=\"control-label col-md-3 required\" translate=\"common.status\"></label><div class=\"col-md-8\"><select \nclass=\"form-control\" name=\"SettlementStatus\" ng-model=\"vm.settlementTransactions.Status\" required><option value=\"\">\nPlease select status</option><option value=\"Processing\">Processing</option><option value=\"Settled\">Settled</option>\n</select><div ng-messages=\"transactionForm.SettlementStatus.$error\"><div ng-message=\"required\" \nng-if=\"transactionForm.SettlementStatus.$touched\" class=\"help-block\"><span \ntranslate=\"admin.settlement_transaction.validate.status_required\"></span></div></div></div></div></div><div \nclass=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button \ntype=\"submit\" class=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div></div>\n</div>");
$templateCache.put("app/admin/tag/tag.html","<h1 class=\"page-header\" translate=\"admin.tag.title\"></h1><div id=\"tag\" class=\"col-md-12\"><div class=\"form-horizontal\">\n<ul class=\"nav nav-tabs\"><li class=\"active\"><a data-toggle=\"tab\" href=\"#productDiv\" id=\"productTab\">Product</a></li>\n<li><a data-toggle=\"tab\" href=\"#brandDiv\" id=\"brandTab\">Brand</a></li></ul><br><div class=\"tab-content\"><div \nid=\"productDiv\" class=\"tab-pane fade in active\"><div class=\"form-group\"><div class=\"row\"><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.criteria.Keyword\" \nng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter the tag\'s name\"></div><div class=\"col-md-1 col-sm-10\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span \ntranslate=\"common.action.reset\"></span></a></div><div class=\"col-md-2 col-md-offset-6 col-sm-2\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.popupCreateOrUpdateTagForm()\"><i \nclass=\"glyphicon glyphicon-plus\"></i> <span translate=\"common.action.add\"></span></a></div></div></div><div \nclass=\"form-group\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered\"><thead><tr><th>#\n</th><th translate=\"common.name\"></th><th translate=\"common.action.title\"></th></tr></thead><tbody><tr \nng-repeat=\"tag in vm.tags\"><td class=\"center\">{{$index + 1}}</td><td>{{tag.Name}}</td><td class=\"center\"><a \ntitle=\"Edit\" class=\"btn btn-default margin-tl\" ng-click=\"vm.popupCreateOrUpdateTagForm(tag.Id)\"><i \nclass=\"glyphicon glyphicon-edit\"></i></a> <a title=\"Remove\" class=\"btn btn-danger margin-tl\" \nng-click=\"vm.delete(tag.Id)\"><i class=\"glyphicon glyphicon-remove\"></i></a></td></tr></tbody></table></div><ul \nuib-pagination total-items=\"vm.totalItems\" items-per-page=\"vm.criteria.Length\" ng-change=\"vm.search()\" \nng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul>\n</div></div><div id=\"brandDiv\" class=\"tab-pane fade\"><div class=\"form-group\"><div class=\"row\"><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><input type=\"text\" class=\"form-control\" ng-model=\"vm.criteriaBrand.Keyword\" \nng-keypress=\"vm.searchByKeywordBrand($event)\" placeholder=\"Enter the tag\'s name\"></div><div class=\"col-md-1 col-sm-10\">\n<a class=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.resetBrand()\"><i class=\"glyphicon glyphicon-refresh\"></i> \n<span translate=\"common.action.reset\"></span></a></div><div class=\"col-md-2 col-md-offset-6 col-sm-2\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.addBrand()\"><i class=\"glyphicon glyphicon-plus\"></i> <span \ntranslate=\"common.action.add\"></span></a></div></div></div><div class=\"form-group\"><div class=\"table-responsive\"><table\n class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th translate=\"common.name\"></th><th \ntranslate=\"common.action.title\"></th></tr></thead><tbody><tr ng-repeat=\"tag in vm.tagsBrand\"><td class=\"center\">\n{{$index + 1}}</td><td>{{tag.Name}}</td><td class=\"center\"><a title=\"Edit\" class=\"btn btn-default margin-tl\" \nng-click=\"vm.editBrand(tag.Id)\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a title=\"Remove\" \nclass=\"btn btn-danger margin-tl\" ng-click=\"vm.deleteBrand(tag.Id)\"><i class=\"glyphicon glyphicon-remove\"></i></a></td>\n</tr></tbody></table></div><ul uib-pagination total-items=\"vm.totalItemsBrand\" \nitems-per-page=\"vm.criteriaBrand.Length\" ng-change=\"vm.searchBrand()\" ng-model=\"vm.currentPageBrand\" \nmax-size=\"vm.maxSizeBrand\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div>\n</div><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" \ntabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><form \nname=\"tagForm\" class=\"form-horizontal\" ng-submit=\"vm.save()\" novalidate id=\"tagForm\"><div class=\"modal-header\"><button \ntype=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowDialog = false\"><span aria-hidden=\"true\">&times;</span><span \nclass=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\" translate=\"admin.tag.tag_detail\">\n</h3></div><div class=\"modal-body\"><div class=\"form-group\" \nng-class=\"{\'has-error\': tagForm.Name.$invalid && tagForm.Name.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"common.name\"></label><div class=\"col-md-8\"><input \nname=\"Name\" type=\"text\" class=\"form-control\" ng-model=\"vm.tag.Name\" required autocomplete=\"off\" \nis-tag-name-available=\"vm.tag.Id\"><div ng-messages=\"tagForm.Name.$error\"><div ng-message=\"required\" \nng-if=\"tagForm.Name.$touched\" class=\"help-block\"><span translate=\"admin.tag.validate.name\"></span></div><div \nng-message=\"isTagNameAvailable\" ng-if=\"tagForm.Name.$touched\" class=\"help-block\"><span \ntranslate=\"admin.tag.validate.name_duplicate\"></span></div></div></div></div></div><div class=\"modal-footer\"><a \nclass=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button type=\"submit\" \nclass=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div></div><div \nclass=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfigBrand.ShowDialog\" class=\"modal fade\" \ntabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><form \nname=\"tagFormBrand\" class=\"form-horizontal\" ng-submit=\"vm.saveBrand()\" novalidate id=\"tagForm\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.viewConfigBrand.ShowDialog = false\"><span \naria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" \nid=\"modal-title\" translate=\"admin.tag.tag_detail\"></h3></div><div class=\"modal-body\"><div class=\"form-group\" \nng-class=\"{\'has-error\': tagFormBrand.Name.$invalid && tagFormBrand.Name.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"common.name\"></label><div class=\"col-md-8\"><input \nname=\"Name\" type=\"text\" class=\"form-control\" ng-model=\"vm.tagBrand.Name\" required autocomplete=\"off\" \nis-tag-name-available-brand=\"vm.tagBrand.Id\"><div ng-messages=\"tagFormBrand.Name.$error\"><div ng-message=\"required\" \nng-if=\"tagFormBrand.Name.$touched\" class=\"help-block\"><span translate=\"admin.tag.validate.name\"></span></div><div \nng-message=\"isTagNameAvailableBrand\" ng-if=\"tagFormBrand.Name.$touched\" class=\"help-block\"><span \ntranslate=\"admin.tag.validate.name_duplicate\"></span></div></div></div></div></div><div class=\"modal-footer\"><a \nclass=\"btn btn-danger\" ng-click=\"vm.cancelBrand()\" translate=\"common.action.cancel\"></a> <button type=\"submit\" \nclass=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div></div></div>");
$templateCache.put("app/admin/tag/tag.updatecreate.view.html","<div class=\"modal-content my-content\"><form id=\"tagForm\" name=\"tagForm\" class=\"form-horizontal\" \nng-submit=\"vm.onSubmit(tagForm.$valid)\" novalidate><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.modal.cancel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 \nclass=\"modal-title center\" id=\"modal-title\" translate=\"admin.tag.title\"></h3></div><div class=\"modal-body\"><div \nclass=\"form-group\" ng-class=\"{\'has-error\': tagForm.TagName.$invalid && tagForm.TagName.$touched}\"><label \nclass=\"control-label col-md-3 required\">Name</label><div class=\"col-md-8\"><input name=\"TagName\" type=\"text\" \nclass=\"form-control margin-tb\" ng-model=\"vm.formData.TagName\" maxlength=\"30\" required><p \nng-show=\"tagForm.TagName.$invalid && tagForm.TagName.$touched\" class=\"help-block\">The name is required.</p></div></div>\n<div class=\"form-group\" ng-class=\"{\'has-error\': tagForm.category.$invalid && tagForm.category.$touched}\"><label \nclass=\"control-label col-md-3 required\">Category</label><div class=\"col-md-8\"><select name=\"category\" \nclass=\"form-control\" ng-model=\"vm.formData.CategoryId\" required><option value=\"\">All Category</option><option \nng-repeat=\"option in vm.categoryList\" value=\"{{option.Value}}\">{{option.Text}}</option></select><p \nng-show=\"tagForm.category.$invalid && tagForm.category.$touched\" class=\"help-block\">The category is required.</p></div>\n</div><div class=\"form-group\" ng-class=\"{\'has-error\': tagForm.channel.$invalid && tagForm.channel.$touched}\"><label \nclass=\"control-label col-md-3 required\">Channel</label><div class=\"col-md-8\"><select name=\"channel\" \nclass=\"form-control\" ng-model=\"vm.formData.Channel\" required><option ng-repeat=\"option in vm.channelList\" \nvalue=\"{{option.Value}}\">{{option.Text}}</option></select><p \nng-show=\"tagForm.channel.$invalid && tagForm.channel.$touched\" class=\"help-block\">The channel is required.</p></div>\n</div></div><div class=\"alert alert-danger\" ng-if=\"vm.formError\">{{vm.formError}}</div><div class=\"modal-footer\"><a \nclass=\"btn btn-danger\" ng-click=\"vm.modal.cancel()\" translate=\"common.action.cancel\"></a> <button type=\"submit\" \nclass=\"btn btn-primary\" ng-disabled=\"tagForm.$invalid\" translate=\"common.action.save\"></button></div></form></div>");
$templateCache.put("app/admin/tierSetting/tierSetting.html","<h1 class=\"page-header\" translate=\"admin.tierSetting.title\"></h1><div id=\"group\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-2 col-md-offset-10\"><a \nclass=\"btn btn-primary pull-right\" ui-sref=\"app.admin.tierSetting.new\"><i class=\"glyphicon glyphicon-plus\"></i> <span \ntranslate=\"common.action.add\"></span></a></div></div></div><div class=\"form-group\"><div class=\"table-responsive\"><table\n class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th translate=\"admin.tierSetting.tier_name\"></th><th \ntranslate=\"admin.tierSetting.annual_fee\"></th><th translate=\"admin.tierSetting.minimum_cash_back\"></th><th \ntranslate=\"common.action.title\"></th></tr></thead><tbody><tr ng-repeat=\"tier in vm.tierSetting\"><td class=\"center\">\n{{$index + 1}}</td><td>{{tier.Name}}</td><td>{{tier.AnnualFee}} RM</td><td class=\"right\">\n{{tier.MinimumCashBackRequired}} %</td><td class=\"center\"><a title=\"Edit\" class=\"btn btn-default margin-tl\" \nui-sref=\"app.admin.tierSetting.edit({id:tier.Id})\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a title=\"Remove\" \nclass=\"btn btn-danger margin-tl\" ng-click=\"vm.remove(tier)\"><i class=\"glyphicon glyphicon-remove\"></i></a></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/admin/user/user.detail.html","<div id=\"UserDetailBack\"><a class=\"btn btn-danger\" ui-sref=\"app.admin.user\" translate=\"common.action.back\"></a></div>\n<h1 class=\"page-header\" translate=\"admin.user.detail.title\"></h1><div id=\"user\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"tab-content\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"image-wrapper\"><img\n id=\"photo\" ng-src=\"{{vm.user.Avatar ? vm.user.Avatar: \'../../assets/images/placeholder.png\'}}\"></div></div><div \nclass=\"col-md-9\"><div class=\"form-group\"><label class=\"col-md-3\" translate=\"admin.user.full_name\"></label><div \nclass=\"col-md-9\"><span>{{vm.user.FullName}}</span></div></div><div class=\"form-group\"><label class=\"col-md-3\" \ntranslate=\"common.email\"></label><div class=\"col-md-9\"><span>{{vm.user.Email}}</span> <a ng-if=\"vm.Tag!=5\" \ntitle=\"Edit/Update\" style=\"align-items:center\" class=\"btn btn-default\" ng-click=\"vm.editEmail()\"><i \nclass=\"glyphicon glyphicon-edit\"></i></a></div></div><div class=\"form-group\"><label class=\"col-md-3\" \ntranslate=\"common.username\"></label><div class=\"col-md-9\"><span>{{vm.user.UserName}}</span></div></div><div \nclass=\"form-group\"><label class=\"col-md-3\" translate=\"admin.user.country\"></label><div class=\"col-md-9\"><span>\n{{vm.user.Country}}</span></div></div><div class=\"form-group\"><label class=\"col-md-3\" \ntranslate=\"admin.user.phone_number\"></label><div class=\"col-md-9\"><span>{{vm.user.MobileNumber}}</span> <a \nng-if=\"vm.Tag!=5\" title=\"Edit/Update\" style=\"align-items:center\" class=\"btn btn-default\" \nng-click=\"vm.editPhoneNumber()\"><i class=\"glyphicon glyphicon-edit\"></i></a></div></div><div class=\"form-group\"><label \nclass=\"col-md-3\" translate=\"EKYC Status\"></label></div><div class=\"form-group\"><label class=\"col-md-1\"></label><label \nclass=\"col-md-2\" translate=\"Tencent:\"></label><div class=\"col-md-9\"><span>{{vm.user.TencentStatus}}</span></div></div>\n<div class=\"form-group\"><label class=\"col-md-1\"></label><label class=\"col-md-2\" translate=\"Xendity:\"></label><div \nclass=\"col-md-9\"><span>{{vm.user.XendityStatus}}</span></div></div><div class=\"form-group\"><label class=\"col-md-1\">\n</label><label class=\"col-md-2\" translate=\"Zoloz:\"></label><div class=\"col-md-9\"><span>{{vm.user.ZolozStatus}}</span>\n</div></div><div class=\"form-group\"><label class=\"col-md-1\"></label><label class=\"col-md-2\" translate=\"EDD Status:\">\n</label><div class=\"col-md-9\"><span>\n{{vm.user.IsEDDUser ? \'Approved\' : vm.user.IsEDDRejected ? \'Rejected\' : (vm.user.IsEDDSubDocUploaded ? \'Under Review\' : \'N/A\')}}\n</span></div></div><div class=\"form-group\" ng-if=\"vm.Tag == 5\"><label class=\"col-md-1\"></label><label class=\"col-md-2\" \ntranslate=\"VIP Status:\"></label><div class=\"col-md-9\"><span>{{ vm.user.IsVIPUser ? \'Yes\' : \'No\' }}</span></div></div>\n<div class=\"form-group\"><label class=\"col-md-3\" translate=\"admin.user.gender\"></label><div class=\"col-md-9\"><span>\n{{vm.user.Gender}}</span></div></div><div class=\"form-group\"><label class=\"col-md-3\" \ntranslate=\"admin.user.date_of_birth\"></label><div class=\"col-md-9\"><span>{{vm.user.DateOfBirth}}</span></div></div><div\n class=\"form-group\"><label class=\"col-md-3\" translate=\"admin.user.ic_or_passport_number\"></label><div class=\"col-md-9\">\n<span>{{vm.user.IcOrPassportNumber}}</span></div></div><div class=\"form-group\"><label class=\"col-md-3\" \ntranslate=\"admin.user.referral_code\"></label><div class=\"col-md-9\"><span>{{vm.user.ReferralCode}}</span></div></div>\n<div class=\"form-group\"><label class=\"col-md-3\" translate=\"Registration Referral Code\"></label><div class=\"col-md-9\">\n<span>{{vm.user.RegistrationReferralCode}}</span></div></div><div class=\"form-group\"><label class=\"col-md-3\" \ntranslate=\"admin.user.status\"></label><div class=\"col-md-9\"><span>{{vm.user.Status}}</span></div></div><div \nclass=\"form-group\"><label class=\"col-md-3\" translate=\"admin.user.register_date\"></label><div class=\"col-md-9\"><span>\n{{vm.user.CreatedAt | date: \'longDate\' }}</span></div></div><div class=\"form-group\"><label class=\"col-md-3\" \ntranslate=\"Wallet ID\"></label><div class=\"col-md-9\"><span>{{vm.user.WalletId }}</span></div></div><div \nclass=\"form-group\"><label class=\"col-md-3\" translate=\"Wallet Creation Date\"></label><div class=\"col-md-9\"><span>\n{{vm.user.CreatedDateTime | date: \'longDate\' }}</span></div></div><div class=\"form-group\"><label class=\"col-md-3\" \ntranslate=\"Wallet Type\"></label><div class=\"col-md-9\"><span>{{vm.user.WalletPlan }}</span></div></div><div \nclass=\"form-group\"><label class=\"col-md-3\" translate=\"Wallet Type Changed On\"></label><div class=\"col-md-9\"><span>\n{{vm.user.WalletTypeChangedDateTime | date: \'longDate\' }}</span></div></div><div class=\"form-group\"><label \nclass=\"col-md-3\" translate=\"KiplePay Visa Card Member ID\"></label><div class=\"col-md-9\"><span>{{vm.user.VisaMemberID }}\n</span></div></div><div class=\"form-group\"><label class=\"col-md-3\" translate=\"KiplePay Visa Card Status\"></label><div \nclass=\"col-md-9\"><span>{{vm.user.VisaCardStatus }}</span></div></div><div class=\"form-group\"><label class=\"col-md-3\" \ntranslate=\"KiplePay Visa Created Date \"></label><div class=\"col-md-9\"><span>\n{{vm.user.VisaCardDatetime | date: \'longDate\' }}</span></div></div><div class=\"form-group\"><label class=\"col-md-3\" \ntranslate=\"KiplePay Visa Created Time \"></label><div class=\"col-md-9\"><span>\n{{vm.user.VisaCardDatetime | date: \'shortTime\' }}</span></div></div><div class=\"form-group\"><label class=\"col-md-3\" \ntranslate=\"Visa Prepaid Card Number\"></label><div class=\"col-md-9\"><span>{{vm.user.VisaCardNumber }}</span></div></div>\n<div class=\"form-group\" ng-show=\"vm.user.Tag == \'RedPay\'\"><label class=\"col-md-3\" translate=\"RewardLink\"></label><div \nid=\"idRewardLinkStatus\" class=\"col-md-9\"><span>{{vm.user.RewardLinkStatus }}</span> <button \nng-if=\"vm.user.RewardLinkStatus == \'Active\'\" title=\"Unbind RewardLink Account\" class=\"btn btn-success margin-tl\" \nng-click=\"vm.unBind(vm.user.Id)\"><i class=\"glyphicon glyphicon-remove\"></i></button></div></div><div \nclass=\"form-group\"><label class=\"col-md-3\" translate=\"Verified By University\"></label><div class=\"col-md-9\"><span>\n{{vm.user.UniversityIdVerificationByApi }}</span></div></div><div class=\"form-group\"><label class=\"col-md-3\" \ntranslate=\"University ID Status\"></label><div class=\"col-md-9\"><span>{{vm.user.UniversityIdVerification }}</span></div>\n</div><div class=\"form-group\"><label class=\"col-md-3\" translate=\"University ID\"></label><div class=\"col-md-9\"><span>\n{{vm.user.UniversityId }}</span></div></div><div class=\"form-group\"><label class=\"col-md-3\" translate=\"Campus ID\">\n</label><div class=\"col-md-9\"><span>{{vm.user.Campus }}</span></div></div><div class=\"form-group\"><label \nclass=\"col-md-3\" translate=\"Student ID\"></label><div class=\"col-md-9\"><span>{{vm.user.StudentId }}</span></div></div>\n<div class=\"form-group\"><label class=\"col-md-3\" translate=\"WebCash ID\"></label><div class=\"col-md-9\"><span>\n{{vm.user.WebCashId }}</span></div></div><div class=\"form-group\"><label class=\"col-md-3\" \ntranslate=\"Residential Address\"></label><div class=\"col-md-9\"><span>{{vm.user.ResidentalAddress }}</span> <a \ntitle=\"Edit/Update\" style=\"align-items:center\" class=\"btn btn-default\" ng-click=\"vm.editAddress()\"><i \nclass=\"glyphicon glyphicon-edit\"></i></a></div></div><div class=\"form-group\"><label class=\"col-md-3\" \ntranslate=\"eWages Employer\"></label><div class=\"col-md-9\"><span>{{vm.user.EWagesEmployer }}</span> <a \ntitle=\"Edit/Update\" style=\"align-items:center\" class=\"btn btn-default\" ng-click=\"vm.edit()\"><i \nclass=\"glyphicon glyphicon-edit\"></i></a></div></div></div></div></div></div><div class=\"header-modal\"><div \nid=\"divEWagesEmployer\" name=\"divEWagesEmployer\" common-bs-modal bs-modal-show=\"vm.viewConfig.ShowEmployerDialog\" \nclass=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog\"><div class=\"modal-content my-content\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span>\n<span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\" translate=\"eWages Employer\">\n</h3></div><div class=\"modal-body\"><div id=\"eWagesEmployer\" name=\"eWagesEmployer\" class=\"form-group\" \nng-class=\"{\'has-error\': user.EWagesEmployer.$invalid && user.EWagesEmployer.$touched}\"><div \nclass=\"col-xs-12 margin-tb\"><label class=\"col-xs-6 control-label\" translate=\"Employer Name\"></label><input \nid=\"eWagesEmployer1\" type=\"text\" class=\"col-xs-6 form-control\" value=\"{{vm.user.EWagesEmployer}}\" \nng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter Employer Name\"></div></div></div><div class=\"\" \nstyle=\"text-align: center; padding: 5px\"><button type=\"button\" style=\"text-align: center\" class=\"btn btn-primary\" \nng-click=\"vm.save()\" translate=\"common.action.update\"></button> <button type=\"button\" style=\"text-align: center\" \nclass=\"btn btn-primary\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></button></div></div></div></div></div>\n<div class=\"header-modal\"><div id=\"divResidentialAddress\" name=\"divResidentialAddress\" common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowResidentialDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog\"><div class=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" \nclass=\"close\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button>\n<h3 class=\"modal-title center\" id=\"modal-title\" translate=\"Residential Address\"></h3></div><div class=\"modal-body\"><div\n id=\"ResidentialAddress\" name=\"ResidentialAddress\" class=\"form-group\" \nng-class=\"{\'has-error\': user.ResidentalAddress.$invalid && user.ResidentalAddress.$touched}\"><div \nclass=\"col-xs-12 margin-tb\"><label class=\"col-xs-6 control-label\" translate=\"Residential Address\"></label><input \nid=\"ResidentialAddress1\" type=\"text\" class=\"col-xs-6 form-control\" value=\"{{vm.user.ResidentalAddress}}\" \nng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter Residential Address\"></div></div></div><div class=\"\" \nstyle=\"text-align: center; padding: 5px\"><button type=\"button\" style=\"text-align: center\" class=\"btn btn-primary\" \nng-click=\"vm.saveResidentialAddress()\" translate=\"common.action.update\"></button> <button type=\"button\" \nstyle=\"text-align: center\" class=\"btn btn-primary\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></button>\n</div></div></div></div></div><div class=\"header-modal\"><div id=\"divEWagesEmployer\" name=\"divEWagesEmployer\" \ncommon-bs-modal bs-modal-show=\"vm.viewConfig.ShowPhoneNumberDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div\n class=\"modal-dialog\"><div class=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" \nclass=\"close\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button>\n<h3 class=\"modal-title center\" id=\"modal-title\" translate=\"Mobile Number Change\"></h3></div><div class=\"modal-body\" \nng-if=\"vm.Tag!=5\"><div id=\"divPhoneNumberUpdate\" name=\"divPhoneNumberUpdate\" class=\"form-group\" \nng-class=\"{\'has-error\': user.MobileNumber.$invalid && user.MobileNumber.$touched}\"><div class=\"col-xs-12 margin-tb\">\n<label class=\"col-xs-6 control-label\" translate=\"New Mobile Number\"></label><input id=\"PhoneNumberUpdate\" \ntype=\"number\" class=\"col-xs-6 form-control\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"Enter New Mobile Number\"></div></div></div><div class=\"\" style=\"text-align: center; padding: 5px\"><button \ntype=\"button\" style=\"text-align: center\" class=\"btn btn-primary\" ng-click=\"vm.savePhoneNumber()\" \ntranslate=\"common.action.update\"></button> <button type=\"button\" style=\"text-align: center\" class=\"btn btn-primary\" \nng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></button></div></div></div></div></div><div \nclass=\"header-modal\"><div id=\"divEWagesEmployer\" name=\"divEWagesEmployer\" common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowEmailDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog\">\n<div class=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 \nclass=\"modal-title center\" id=\"modal-title\" translate=\"Email Change\"></h3></div><div class=\"modal-body\" \nng-if=\"vm.Tag!=5\"><div id=\"divEmailUpdate\" name=\"divEmailUpdate\" class=\"form-group\" \nng-class=\"{\'has-error\': user.Email.$invalid && user.Email.$touched}\"><div class=\"col-xs-12 margin-tb\"><label \nclass=\"col-xs-6 control-label\" translate=\"New Email\"></label><input id=\"EmailUpdate\" type=\"email\" \nclass=\"col-xs-6 form-control\" ng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter New Email\"></div></div></div>\n<div class=\"\" style=\"text-align: center; padding: 5px\"><button type=\"button\" style=\"text-align: center\" \nclass=\"btn btn-primary\" ng-click=\"vm.saveEmail()\" translate=\"common.action.update\"></button> <button type=\"button\" \nstyle=\"text-align: center\" class=\"btn btn-primary\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></button>\n</div></div></div></div></div></div>");
$templateCache.put("app/admin/user/user.html","<h1 class=\"page-header\" translate=\"admin.user.title\"></h1><div id=\"user\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><label \nclass=\"control-label\" translate=\"Name\"></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.criteria.Name\" \nng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter the name\"></div><div class=\"col-md-3 col-xs-12 margin-tb\">\n<label class=\"control-label\" translate=\"Email\"></label><input type=\"text\" class=\"form-control\" \nng-model=\"vm.criteria.EmailAddress\" ng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter the user\'s email\">\n</div><div class=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\" translate=\"UserName\"></label><input \ntype=\"text\" class=\"form-control\" ng-model=\"vm.criteria.UserName\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"Enter the user\'s name\"></div><div class=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\" \ntranslate=\"PhoneNumber\"></label><input type=\"number\" class=\"form-control\" ng-model=\"vm.criteria.PhoneNumber\" \nng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter the user\'s phonenumber\"></div><div \nclass=\"col-md-3 col-xs-12 margin-tb\" ng-if=\"vm.Tag != 5\"><label class=\"control-label\" translate=\"University Id\">\n</label><input type=\"text\" class=\"form-control\" ng-model=\"vm.criteria.StudentId\" \nng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter the UniversityId\"></div><div \nclass=\"col-md-3 col-xs-12 margin-tb\" ng-if=\"vm.Tag != 5\"><label class=\"control-label\" translate=\"University\"></label>\n<input type=\"text\" class=\"form-control\" ng-model=\"vm.criteria.University\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"Enter the University\"></div><div class=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\" \ntranslate=\"IC/Passport\"></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.criteria.ICPassport\" \nng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter the IC/Passport\"></div><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\" translate=\"Tag\"></label><select class=\"form-control\" \nng-model=\"vm.criteria.Tag\" ng-change=\"vm.searchByKeyword($event)\"><option ng-value=\"null\">All</option><option \nng-repeat=\"v in vm.AppType\" ng-value=\"v.Id\">{{v.Name| translate}}</option></select></div><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\" translate=\"Status\"></label><select \nclass=\"form-control\" ng-model=\"vm.criteria.Status\" ng-change=\"vm.searchByKeyword($event)\"><option ng-value=\"null\">All\n</option><option ng-repeat=\"v in vm.TransactionStatus\" ng-value=\"v.Id\">{{v.Name| translate}}</option></select></div>\n<div class=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\" translate=\"EDD Status\"></label><select \nclass=\"form-control\" ng-model=\"vm.criteria.EDDStatus\" ng-change=\"vm.searchByKeyword($event)\"><option ng-value=\"null\">\nAll</option><option ng-repeat=\"v in vm.EDDStatus\" ng-value=\"v.Id\">{{v.Name| translate}}</option></select></div><div \nclass=\"col-md-3 col-xs-12 margin-tb\" ng-if=\"vm.Tag == 5\"><label class=\"control-label\" translate=\"VIP Status\"></label>\n<select class=\"form-control\" ng-model=\"vm.criteria.VIPStatus\" ng-change=\"vm.searchByKeyword($event)\"><option \nng-value=\"null\">All</option><option ng-repeat=\"v in vm.VIPStatus\" ng-value=\"v.Id\">{{v.Name| translate}}</option>\n</select></div><div class=\"col-md-1 col-xs-12 margin-tb\"><label class=\"control-label\"></label><a \nstyle=\"margin-top:6px\" class=\"btn btn-primary pull-right\" ng-click=\"vm.reset()\"><span>Search</span></a></div><div \nclass=\"col-md-1 col-xs-12 margin-tb\"><label class=\"control-label\"></label><a style=\"margin-top:6px\" \nclass=\"btn btn-primary pull-right\" ng-click=\"vm.resetPage()\"><i class=\"glyphicon glyphicon-refresh\"></i><span>Reset\n</span></a></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><label \nclass=\"control-label\" translate=\"Generate Report from \"></label><input type=\"number\" class=\"form-control\" \nng-model=\"vm.criteria.Csvfrom\" placeholder=\"Enter the starting record\"></div><div class=\"col-md-3 col-xs-12 margin-tb\">\n<label class=\"control-label\" translate=\"Generate Report To\"></label><input type=\"number\" class=\"form-control\" \nng-model=\"vm.criteria.CsvTo\" placeholder=\"Enter the end records\"></div><div class=\"col-md-3 col-xs-12 margin-tb\"><a \nstyle=\"margin-top:22px\" class=\"btn btn-primary pull-right\" ng-click=\"vm.export()\"><span>Export</span></a></div><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><a style=\"margin-top:22px\" class=\"btn btn-primary pull-right\" \nng-click=\"vm.OpenMailModel()\"><span>Send Mail</span></a></div></div></div><div class=\"form-group\"><div \nclass=\"table-responsive\"><table class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th \ntranslate=\"common.name\"></th><th translate=\"common.email\"></th><th translate=\"admin.user.phone_number\"></th><th \ntranslate=\"admin.user.gender\"></th><th translate=\"admin.user.date_of_birth\"></th><th translate=\"common.status\"></th><th\n ng-if=\"vm.Tag != 5\" translate=\"common.tag\"></th><th ng-if=\"vm.Tag != 5\" translate=\"WebCashId\"></th><th \nng-if=\"vm.Tag != 5\" translate=\"University\"></th><th ng-if=\"vm.Tag != 5\" translate=\"StudentId\"></th><th \ntranslate=\"Wallet\"></th><th ng-if=\"vm.Tag != 5\" translate=\"Zakat\"></th><th ng-if=\"vm.Tag != 5\" translate=\"eWages\"></th>\n<th translate=\"common.edd_status\"></th><th ng-if=\"vm.Tag == 5\" translate=\"common.vip_status\"></th><th \ntranslate=\"common.action.title\"></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users\"><td class=\"center\">\n{{$index + 1}}</td><td>{{user.FullName}}</td><td>{{user.Email}}</td><td>{{user.MobileNumber}}</td><td>{{user.Gender}}\n</td><td>{{user.DateOfBirth}}</td><td>{{user.Status}}</td><td ng-if=\"vm.Tag != 5\">{{user.Tag}}</td><td \nng-if=\"vm.Tag != 5\">{{user.WebCashId}}</td><td ng-if=\"vm.Tag != 5\">{{user.UniversityId}}</td><td ng-if=\"vm.Tag != 5\">\n{{user.StudentId}}</td><td ng-if=\"user.Cashbalance==0\">{{user.Cashbalance}}</td><td ng-if=\"user.Cashbalance>0\"><a \nui-sref=\"app.admin.user.wallet({id:user.Id,balance:user.Cashbalance})\" title=\"Cashbalance\">{{user.Cashbalance}}</a>\n</td><td ng-if=\"vm.Tag != 5 && user.KipleKash==0\">{{user.KipleKash}}</td><td ng-if=\"vm.Tag != 5 && user.KipleKash>0\"><a\n ui-sref=\"app.admin.user.kiplekash({id:user.Id,balance:user.KipleKash})\" title=\"Cashbalance\">{{user.KipleKash}}</a>\n</td><td ng-if=\"vm.Tag != 5\">{{user.EWagesEmployer}}</td><td>\n{{user.IsEDDUser ? \'Approved\' : user.IsEDDRejected ? \'Rejected\' : (user.IsEDDSubDocUploaded ? \'Under Review\' : \'N/A\')}}\n</td><td ng-if=\"vm.Tag == 5\">{{ user.IsVIPUser ? \'Yes\' : \'No\' }}</td><td class=\"center\"><a title=\"Detail\" \nclass=\"btn btn-default margin-tl\" ui-sref=\"app.admin.user.detail({id:user.Id})\"><i class=\"glyphicon glyphicon-user\">\n</i></a> <button ng-if=\"user.Status == \'Locked\'\" title=\"Unlock Account\" class=\"btn btn-success margin-tl\" \nng-click=\"vm.unBlock(user)\"><i class=\"glyphicon glyphicon-upload\"></i></button> <button title=\"Reset Password\" \nclass=\"btn btn-success margin-tl\" ng-click=\"vm.resetPassword(user)\"><i class=\"glyphicon glyphicon-repeat\"></i></button>\n <a title=\"Transaction History\" class=\"btn btn-default margin-tl\" ui-sref=\"app.admin.user.transaction({id:user.Id})\"><i\n class=\"glyphicon glyphicon-list-alt\"></i></a></td></tr></tbody></table></div></div><div><div \nstyle=\"float:left;width:50%\">Total Items:{{vm.ItemsCount}}</div><div style=\"float:right;width:50%\"><ul uib-pagination \ntotal-items=\"vm.totalItems\" ng-change=\"vm.searchPagination()\" ng-model=\"vm.currentPage\" \nitems-per-page=\"vm.criteria.Length\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" \nrotate=\"false\"></ul></div></div></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowDialogTest\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><form name=\"testsendmailForm\" \nclass=\"form-horizontal\" novalidate><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.viewConfig.ShowDialogTest = false\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close\n</span></button><h3 class=\"modal-title center\" id=\"modal-title\">Test Send Mail</h3></div><div class=\"modal-body\"><div \nclass=\"form-group\" ng-class=\"{\'has-error\': testsendmailForm.Email.$invalid && testsendmailForm.Email.$touched}\"><label \nclass=\"control-label col-md-3 required\">Email</label><div class=\"col-md-8\"><input name=\"Email\" type=\"text\" \nclass=\"form-control\" ng-model=\"vm.EmailToSend\" required><div ng-messages=\"testsendmailForm.Email.$error\"><div \nng-message=\"required\" ng-if=\"testsendmailForm.Email.$touched\" class=\"help-block\"><span>Email is required field.</span>\n</div></div></div></div></div><div class=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.cancel()\" \ntranslate=\"common.action.cancel\"></a> <button type=\"button\" ng-click=\"vm.sendmail()\" \nclass=\"btn btn-primary pull-right\">Send</button></div></form></div></div></div></div></div>");
$templateCache.put("app/admin/user/user.kiplekash.html","<h1 class=\"page-header\" translate=\"Zakat Transaction\"></h1><div id=\"user\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-4 col-xs-12 margin-tb\"><label \nclass=\"control-label\" translate=\"Start Date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" \nng-model=\"vm.criteria.StartDate\"></div><div class=\"col-md-4 col-xs-12 margin-tb\"><label class=\"control-label\" \ntranslate=\"End Date\"></label><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" \nis-open=\"vm.datePopup.EndOpen\" ng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.criteria.EndDate\"></div><div \nclass=\"col-md-2 col-xs-12 margin-tb\"><label class=\"control-label\"></label><a style=\"margin-top:22px\" \nclass=\"btn btn-primary pull-right\" ng-click=\"vm.reset()\"><span>Search</span></a></div><div \nclass=\"col-md-2 col-xs-12 margin-tb\"><label class=\"control-label\"></label><a style=\"margin-top:22px\" \nclass=\"btn btn-primary pull-right\" ng-click=\"vm.resetPage()\"><i class=\"glyphicon glyphicon-refresh\"></i><span>Reset\n</span></a></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><label \nclass=\"col-md-4\" translate=\"admin.user.kiplekash.User_Name\"></label><div class=\"col-md-8\"><span>{{vm.user.UserName}}\n</span></div></div><div class=\"col-md-5 col-xs-12 margin-tb\"><label class=\"col-md-4\" \ntranslate=\"admin.user.kiplekash.Wallet_Id\"></label><div class=\"col-md-8\"><span>{{vm.user.WalletId}}</span></div></div>\n<div class=\"col-md-4 col-xs-12 margin-tb\"><label class=\"col-md-6\" translate=\"Zakat balance\"></label><div \nclass=\"col-md-6\"><span>{{vm.user.KiplekashBalance}}</span></div></div></div></div><div class=\"form-group\"><div \nclass=\"row\"><div class=\"col-md-2 col-xs-12 margin-tb\"><label class=\"control-label\" translate=\"Generate Report from \">\n</label></div><div class=\"col-md-2 col-xs-12 margin-tb\"><input type=\"number\" class=\"form-control\" \nng-model=\"vm.criteria.Csvfrom\" placeholder=\"Enter the starting record\"></div><div class=\"col-md-2 col-xs-12 margin-tb\">\n<label class=\"control-label\" translate=\"Generate Report To\"></label></div><div class=\"col-md-2 col-xs-12 margin-tb\">\n<input type=\"number\" class=\"form-control\" ng-model=\"vm.criteria.CsvTo\" placeholder=\"Enter the end records\"></div><div \nclass=\"col-md-2 col-xs-12 margin-tb\"><a class=\"btn btn-primary pull-right\" ng-click=\"vm.export()\"><span>Export</span>\n</a> <a class=\"btn btn-danger\" ui-sref=\"app.admin.user\" translate=\"common.action.back\"></a></div></div></div><div \nclass=\"table-responsive form-group\"><table class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th \ntranslate=\"admin.user.transaction.created_date\"></th><th translate=\"admin.user.transaction.created_time\"></th><th \ntranslate=\"admin.user.transaction.id\"></th><th translate=\"WebCashId\"></th><th \ntranslate=\"admin.user.transaction.action\"></th><th translate=\"admin.user.transaction.amount\"></th><th \ntranslate=\"admin.user.transaction.merchant_id\"></th><th translate=\"admin.user.transaction.status\"></th><th \ntranslate=\"admin.user.transaction.In\"></th><th translate=\"admin.user.transaction.Out\"></th><th \ntranslate=\"admin.user.transaction.Fee\"></th><th translate=\"admin.user.transaction.Balance\"></th></tr></thead><tbody><tr\n ng-repeat=\"transaction in vm.transactions\"><td class=\"center\">{{$index + 1}}</td><td>\n{{transaction.TransactionDate | date: \'mediumDate\'}}</td><td>{{transaction.TransactionDate | date: \'shortTime\'}}</td>\n<td>{{transaction.TransactionId}}</td><td>{{transaction.WebCashId}}</td><td>{{transaction.TXType}}</td><td>\n{{transaction.Amount}}</td><td>{{transaction.MerchantName}}</td><td>{{transaction.Status}}</td><td>{{transaction.In}}\n</td><td>{{transaction.Out}}</td><td>{{transaction.Fee }}</td><td>{{transaction.Balance }}</td></tr></tbody></table>\n</div><div><div style=\"float:left;width:50%\">Total Items:{{vm.ItemsCount}}</div><div style=\"float:right;width:50%\"><ul \nuib-pagination total-items=\"vm.totalItems\" ng-change=\"vm.searchPagination()\" ng-model=\"vm.currentPage\" \nitems-per-page=\"vm.criteria.Length\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" \nrotate=\"false\"></ul></div></div></div></div>");
$templateCache.put("app/admin/user/user.storecard.html","<h1 class=\"page-header\" translate=\"admin.user.storecard.title\"></h1><div id=\"user\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-4 col-xs-12 margin-tb\"><label \nclass=\"control-label\" translate=\"Start Date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" \nng-model=\"vm.criteria.StartDate\"></div><div class=\"col-md-4 col-xs-12 margin-tb\"><label class=\"control-label\" \ntranslate=\"End Date\"></label><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" \nis-open=\"vm.datePopup.EndOpen\" ng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.criteria.EndDate\"></div><div \nclass=\"col-md-2 col-xs-12 margin-tb\"><label class=\"control-label\"></label><a style=\"margin-top:22px\" \nclass=\"btn btn-primary pull-right\" ng-click=\"vm.reset()\"><span>Search</span></a></div><div \nclass=\"col-md-2 col-xs-12 margin-tb\"><label class=\"control-label\"></label><a style=\"margin-top:22px\" \nclass=\"btn btn-primary pull-right\" ng-click=\"vm.resetPage()\"><i class=\"glyphicon glyphicon-refresh\"></i><span>Reset\n</span></a></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><label \nclass=\"col-md-4\" translate=\"admin.user.storecard.User_Name\"></label><div class=\"col-md-8\"><span>{{vm.user.UserName}}\n</span></div></div><div class=\"col-md-5 col-xs-12 margin-tb\"><label class=\"col-md-4\" \ntranslate=\"admin.user.storecard.Wallet_Id\"></label><div class=\"col-md-8\"><span>{{vm.user.WalletId}}</span></div></div>\n<div class=\"col-md-4 col-xs-12 margin-tb\"><label class=\"col-md-6\" translate=\"admin.user.storecard.Store_Card\"></label>\n<div class=\"col-md-6\"><span>{{vm.user.StoreCardBalance}}</span></div></div></div></div><div class=\"form-group\"><div \nclass=\"row\"><div class=\"col-md-2 col-xs-12 margin-tb\"><label class=\"control-label\" translate=\"Generate Report from \">\n</label></div><div class=\"col-md-2 col-xs-12 margin-tb\"><input type=\"number\" class=\"form-control\" \nng-model=\"vm.criteria.Csvfrom\" placeholder=\"Enter the starting record\"></div><div class=\"col-md-2 col-xs-12 margin-tb\">\n<label class=\"control-label\" translate=\"Generate Report To\"></label></div><div class=\"col-md-2 col-xs-12 margin-tb\">\n<input type=\"number\" class=\"form-control\" ng-model=\"vm.criteria.CsvTo\" placeholder=\"Enter the end records\"></div><div \nclass=\"col-md-2 col-xs-12 margin-tb\"><a class=\"btn btn-primary pull-right\" ng-click=\"vm.export()\"><span>Export</span>\n</a> <a class=\"btn btn-danger\" ui-sref=\"app.admin.user\" translate=\"common.action.back\"></a></div></div></div><div \nclass=\"table-responsive form-group\"><table class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th \ntranslate=\"admin.user.transaction.created_date\"></th><th translate=\"admin.user.transaction.created_time\"></th><th \ntranslate=\"admin.user.transaction.id\"></th><th translate=\"WebCashId\"></th><th \ntranslate=\"admin.user.transaction.action\"></th><th translate=\"admin.user.transaction.amount\"></th><th \ntranslate=\"admin.user.transaction.merchant_id\"></th><th translate=\"admin.user.transaction.status\"></th><th \ntranslate=\"admin.user.transaction.In\"></th><th translate=\"admin.user.transaction.Out\"></th><th \ntranslate=\"admin.user.transaction.Fee\"></th><th translate=\"admin.user.transaction.Balance\"></th></tr></thead><tbody><tr\n ng-repeat=\"transaction in vm.transactions\"><td class=\"center\">{{$index + 1}}</td><td>\n{{transaction.TransactionDate | date: \'mediumDate\'}}</td><td>{{transaction.TransactionDate | date: \'shortTime\'}}</td>\n<td>{{transaction.TransactionId}}</td><td>{{transaction.WebCashId}}</td><td>{{transaction.TXType}}</td><td>\n{{transaction.Amount}}</td><td>{{transaction.MerchantName}}</td><td>{{transaction.Status}}</td><td>{{transaction.In}}\n</td><td>{{transaction.Out}}</td><td>{{transaction.Fee }}</td><td>{{transaction.Balance }}</td></tr></tbody></table>\n</div><div><div style=\"float:left;width:50%\">Total Items:{{vm.ItemsCount}}</div><div style=\"float:right;width:50%\"><ul \nuib-pagination total-items=\"vm.totalItems\" ng-change=\"vm.searchPagination()\" ng-model=\"vm.currentPage\" \nitems-per-page=\"vm.criteria.Length\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" \nrotate=\"false\"></ul></div></div></div></div>");
$templateCache.put("app/admin/user/user.transaction.html","<div id=\"UserDetailBack\"><a class=\"btn btn-danger\" ui-sref=\"app.admin.user\" translate=\"common.action.back\"></a></div>\n<h1 class=\"page-header\" translate=\"admin.user.transaction.title\"></h1><div id=\"user\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"col-md-2 col-xs-12 margin-tb\"><label class=\"control-label\">\n</label><a style=\"margin-top:6px\" class=\"btn btn-primary pull-right\" ng-click=\"vm.Download()\"><span>Download</span></a>\n</div></div><div class=\"table-responsive form-group\"><table class=\"table table-striped table-bordered\"><thead><tr><th>#\n</th><th translate=\"admin.user.transaction.created_date\"></th><th translate=\"admin.user.transaction.created_time\"></th>\n<th translate=\"admin.user.transaction.id\"></th><th ng-click=\"vm.sort(\'Action\')\" \ntranslate=\"admin.user.transaction.action\"></th><th translate=\"admin.user.transaction.amount\"></th><th \ntranslate=\"admin.user.transaction.wallet\"></th><th translate=\"admin.user.transaction.cashback\"></th><th \ntranslate=\"admin.user.transaction.merchant_id\"></th><th translate=\"admin.user.transaction.is_voided\"></th><th \nng-click=\"vm.sort(\'Status\')\" translate=\"admin.user.transaction.status\"></th><th translate=\"Remarks\"></th></tr></thead>\n<tbody><tr ng-repeat=\"transaction in vm.transactions| orderBy:vm.sortParam:vm.IsReverse\"><td class=\"center\">\n{{$index + 1}}</td><td>{{transaction.CreatedAt | date: \'mediumDate\'}}</td><td>\n{{transaction.CreatedAt | date: \'shortTime\'}}</td><td>{{transaction.Id}}</td><td>\n{{transaction.Action==\"Payout\"?\"Credit Reward\":transaction.Action==\"BonusCredit\"?\"Credit Reward\": transaction.Action==\"DuitNowQR\"? transaction.PaymentMethod : transaction.ActionName}}\n</td><td>{{transaction.Amount}}</td><td>Z:{{transaction.Kiplekash}}<br>M:{{transaction.StoreCard}}<br>\nC:{{transaction.Cash}}<br>V:{{transaction.Visa}}</td><td>Z:{{transaction.KiplekashCashback}}<br>\nM:{{transaction.StoreCardCashback}}</td><td>{{transaction.MerchantName}}</td><td>{{transaction.IsVoided ? \"Yes\": \"\"}}\n</td><td>{{transaction.Status}}</td><td \nng-show=\"transaction.Action==\'OnlineTopup\' || transaction.Action==\'CreditDebitCardTopup\'\">\n{{ transaction.Status!=\'Successful\'?transaction.Remarks:transaction.Action==\"OnlineTopup\"? transaction.BankName : transaction.Action==\"CreditDebitCardTopup\" ? transaction.CardLastFourDigit : transaction.Remarks}}\n</td><td ng-show=\"transaction.Action==\'ReceivedMoney\' || transaction.Action==\'Transfer\'\">\n{{transaction.Status!=\'Successful\'?transaction.Remarks:transaction.ParticipantName}}<br>\n{{transaction.Status!=\'Successful\'?\"\":transaction.ParticipantFullName}}<br>\n{{transaction.Status!=\'Successful\'?\"\":transaction.Remarks}}</td><td \nng-show=\"transaction.Action==\'VisaPayment\' || transaction.Action==\'VisaPaymentReversal\'\"><span \nng-if=\"transaction.Status != \'Successful\'\">{{ transaction.Remarks }}<br>{{ transaction.ExternalMerchantName }}<br>\n{{transaction.ExternalReferenceId}} &nbsp; {{transaction.PaymentMethod}} &nbsp; {{transaction.MerchantCategoryCode}} \n</span><span ng-if=\"transaction.Status == \'Successful\'\">{{ transaction.ExternalMerchantName }}<br>\n{{transaction.ExternalReferenceId}} &nbsp; {{transaction.PaymentMethod}} &nbsp; {{transaction.MerchantCategoryCode}}\n</span></td><td \nng-hide=\"transaction.Action==\'OnlineTopup\' || transaction.Action==\'CreditDebitCardTopup\' || transaction.Action==\'ReceivedMoney\' || transaction.Action==\'Transfer\' || transaction.Action==\'VisaPayment\' || transaction.Action==\'VisaPaymentReversal\'\">\n{{transaction.Remarks}}</td></tr></tbody></table></div><ul uib-pagination total-items=\"vm.totalItems\" \nng-change=\"vm.search()\" ng-model=\"vm.currentPage\" items-per-page=\"vm.criteria.Length\" max-size=\"vm.maxSize\" \nclass=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div>");
$templateCache.put("app/admin/user/user.wallet.html","<h1 class=\"page-header\" translate=\"admin.user.wallet.title\"></h1><div id=\"user\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-4 col-xs-12 margin-tb\"><label \nclass=\"control-label\" translate=\"Start Date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" \nng-model=\"vm.criteria.StartDate\"></div><div class=\"col-md-4 col-xs-12 margin-tb\"><label class=\"control-label\" \ntranslate=\"End Date\"></label><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" \nis-open=\"vm.datePopup.EndOpen\" ng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.criteria.EndDate\"></div><div \nclass=\"col-md-2 col-xs-12 margin-tb\"><label class=\"control-label\"></label><a style=\"margin-top:22px\" \nclass=\"btn btn-primary pull-right\" ng-click=\"vm.reset()\"><span>Search</span></a></div><div \nclass=\"col-md-2 col-xs-12 margin-tb\"><label class=\"control-label\"></label><a style=\"margin-top:22px\" \nclass=\"btn btn-primary pull-right\" ng-click=\"vm.resetPage()\"><i class=\"glyphicon glyphicon-refresh\"></i><span>Reset\n</span></a></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><label \nclass=\"col-md-4\" translate=\"admin.user.wallet.User_Name\"></label><div class=\"col-md-8\"><span>{{vm.user.UserName}}\n</span></div></div><div class=\"col-md-5 col-xs-12 margin-tb\"><label class=\"col-md-4\" \ntranslate=\"admin.user.wallet.Wallet_Id\"></label><div class=\"col-md-8\"><span>{{vm.user.WalletId}}</span></div></div><div\n class=\"col-md-4 col-xs-12 margin-tb\"><label class=\"col-md-6\" translate=\"admin.user.wallet.Wallet_Balance\"></label><div\n class=\"col-md-6\"><span>{{vm.user.WalletBalance}}</span></div></div></div></div><div class=\"form-group\"><div \nclass=\"row\"><div class=\"col-md-2 col-xs-12 margin-tb\"><label class=\"control-label\" translate=\"Generate Report from \">\n</label></div><div class=\"col-md-2 col-xs-12 margin-tb\"><input type=\"number\" class=\"form-control\" \nng-model=\"vm.criteria.Csvfrom\" placeholder=\"Enter the starting record\"></div><div class=\"col-md-2 col-xs-12 margin-tb\">\n<label class=\"control-label\" translate=\"Generate Report To\"></label></div><div class=\"col-md-2 col-xs-12 margin-tb\">\n<input type=\"number\" class=\"form-control\" ng-model=\"vm.criteria.CsvTo\" placeholder=\"Enter the end records\"></div><div \nclass=\"col-md-2 col-xs-12 margin-tb\"><a class=\"btn btn-primary pull-right\" ng-click=\"vm.export()\"><span>Export</span>\n</a> <a class=\"btn btn-danger\" ui-sref=\"app.admin.user\" translate=\"common.action.back\"></a></div></div></div><div \nclass=\"table-responsive form-group\"><table class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th \ntranslate=\"admin.user.transaction.created_date\"></th><th translate=\"admin.user.transaction.created_time\"></th><th \ntranslate=\"admin.user.transaction.id\"></th><th translate=\"WebCashId\"></th><th \ntranslate=\"admin.user.transaction.action\"></th><th translate=\"admin.user.transaction.amount\"></th><th \ntranslate=\"admin.user.transaction.merchant_id\"></th><th translate=\"admin.user.transaction.status\"></th><th \ntranslate=\"admin.user.transaction.In\"></th><th translate=\"admin.user.transaction.Out\"></th><th \ntranslate=\"admin.user.transaction.Fee\"></th><th translate=\"admin.user.transaction.Balance\"></th></tr></thead><tbody><tr\n ng-repeat=\"transaction in vm.transactions\"><td class=\"center\">{{$index + 1}}</td><td>\n{{transaction.TransactionDate | date: \'mediumDate\'}}</td><td>{{transaction.TransactionDate | date: \'shortTime\'}}</td>\n<td>{{transaction.TransactionId}}</td><td>{{transaction.WebCashId}}</td><td>{{transaction.TXType}}</td><td>\n{{transaction.Amount}}</td><td>{{transaction.MerchantName}}</td><td>{{transaction.Status}}</td><td>{{transaction.In}}\n</td><td>{{transaction.Out}}</td><td>{{transaction.Fee }}</td><td>{{transaction.Balance }}</td></tr></tbody></table>\n</div><div><div style=\"float:left;width:50%\">Total Items:{{vm.ItemsCount}}</div><div style=\"float:right;width:50%\"><ul \nuib-pagination total-items=\"vm.totalItems\" ng-change=\"vm.searchPagination()\" ng-model=\"vm.currentPage\" \nitems-per-page=\"vm.criteria.Length\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" \nrotate=\"false\"></ul></div></div></div></div>");
$templateCache.put("app/commissionpayout/bulkupload/bulkupload.html","<h1 class=\"page-header\" translate=\"commissionpayout.title.bulkupload\"></h1><uib-tabset active=\"vm.activeTabIndex\">\n<uib-tab index=\"0\" heading=\"Upload\"><br><div id=\"divBulk\" class=\"col-md-12\"><div role=\"alert\" \nng-show=\"vm.bulkUploadModel.tipMsg\" class=\"alert alert-success\">{{vm.bulkUploadModel.tipMsg}}</div><div role=\"alert\" \nng-show=\"vm.bulkUploadModel.errorMsg\" class=\"alert alert-danger\" ng-bind-html=\"vm.bulkUploadModel.errorMsg\"></div><form\n name=\"bulkForm\" ng-submit=\"vm.submitBulkForm(bulkForm.$valid)\" novalidate><div class=\"form-group col-md-12\"><div \nclass=\"col-md-6\"><label class=\"control-label col-md-7 margin-tb\">\nMerchant Balance: RM {{vm.merchantBalance.toLocaleString()}}</label><button type=\"button\" class=\"btn btn-primary\" \nng-click=\"vm.getMerchantBalance()\">Refresh Balance</button></div><div class=\"col-md-2\"><button type=\"button\" \nclass=\"btn btn-default wallet-topup\" ng-click=\"vm.openDialog()\">Prefund Topup</button></div><div class=\"col-md-4\">\n<input type=\"text\" name=\"MerchantId\" id=\"MerchantId\" ng-model=\"vm.MerchantId\"><label class=\"control-label margin-tb\">\nMerchant ID</label></div></div><hr><div class=\"form-group\" style=\"margin-top:50px\"><label \ntranslate=\"admin.bonus_kiplekash.import_csv\"></label><input id=\"bulkFile\" name=\"bulkFile\" type=\"file\" accept=\".csv\" \nfile-reader=\"vm.bulkUploadModel.csvText\" valid-file ng-model=\"vm.bulkUploadModel.csvFilePath\" required></div><a \nhref=\"{{vm.creditTmpLink}}\" target=\"_blank\" translate=\"common.action.download_template\"></a><hr><button type=\"reset\" \nclass=\"btn btn-danger\" ng-click=\"vm.resetForm(vm.bulkUploadModel)\" translate=\"common.action.reset\"></button> <button \ntype=\"submit\" class=\"btn btn-primary\" ng-disabled=\"bulkForm.$invalid\">Submit</button> <button type=\"button\" \nng-if=\"vm.bulkUploadModel.showErrorCsvButton\" class=\"btn btn-primary\" ng-click=\"vm.downloadErrorCSV()\">\nDownload Error CSV</button></form></div></uib-tab><uib-tab index=\"1\" heading=\"Review\" ng-click=\"vm.initBatchList()\">\n<br><div id=\"divStore\" class=\"col-md-12\"><div class=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div \nclass=\"col-md-3 margin-tb\"><label class=\"control-label\" translate=\"Batch No\"></label><input type=\"text\" \nclass=\"form-control\" id=\"searchtxt\" ng-model=\"vm.criteria.Keyword\" placeholder=\"Enter the batch no\"></div><div \nclass=\"col-md-3 margin-tb\"><label class=\"control-label\" translate=\"commissionpayout.bulkupload.uploadStartDate\">\n</label><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" \nng-click=\"vm.datePopup.StartOpen = true\" ng-model=\"vm.criteria.beginTime\"></div><div class=\"col-md-3 margin-tb\"><label \nclass=\"control-label\" translate=\"commissionpayout.bulkupload.uploadEndDate\"></label><input type=\"text\" \nclass=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" \nng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.criteria.endTime\"></div><div class=\"col-md-3 margin-tb\"><label \nclass=\"control-label\" translate=\"commissionpayout.report.transactionStatus\"></label><select \nng-model=\"vm.criteria.commissionCreditStatus\" class=\"form-control\"><option value=\"\">All</option><option \nng-repeat=\"option in vm.listStatus\" ng-value=\"option.value\">{{option.name}}</option></select></div></div><div \nclass=\"row\"><div class=\"col-md-3 margin-tb\"><label class=\"control-label\">Action By</label><ui-select \nng-model=\"vm.criteria.ActionBy\" theme=\"bootstrap\" title=\"Select Action By\"><ui-select-match \nplaceholder=\"Search for Action By...\">{{$select.selected.email}}</ui-select-match><ui-select-choices \nrepeat=\"user.email as user in vm.userList | filter:{ email: $select.search }\"><div ng-bind=\"user.email\"></div>\n</ui-select-choices></ui-select></div><div class=\"col-md-3 margin-tb\"><label class=\"control-label\">MID</label>\n<ui-select ng-model=\"vm.criteria.MID\" theme=\"bootstrap\" title=\"Select a MID\"><ui-select-match \nplaceholder=\"Search for MID...\">{{$select.selected.id}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.id as merchant in vm.merchantList | filter:{ id: $select.search }\"><div ng-bind=\"merchant.id\"></div>\n</ui-select-choices></ui-select></div></div><div class=\"row\"><div class=\"col-md-3 margin-tb\"><button type=\"button\" \nclass=\"btn btn-primary\" ng-click=\"vm.initBatchList()\">Search</button> <a class=\"btn btn-primary\" ng-click=\"vm.reset()\">\n<i class=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a></div></div><div \nrole=\"alert\" ng-show=\"vm.errorMsg\" class=\"alert alert-danger\">{{vm.errorMsg}}</div><div \nclass=\"table-responsive form-group\"><table class=\"table table-striped table-bordered\"><thead><tr><th \ntranslate=\"commissionpayout.bulkupload.merchantId\"></th><th translate=\"commissionpayout.bulkupload.batchNo\"></th><th \ntranslate=\"commissionpayout.bulkupload.uploadDate\"></th><th translate=\"commissionpayout.bulkupload.UploadCount\"></th>\n<th translate=\"commissionpayout.bulkupload.uploadAmount\"></th><th \ntranslate=\"commissionpayout.bulkupload.ProcessedCount\"></th><th \ntranslate=\"commissionpayout.bulkupload.ProcessedAmount\"></th><th translate=\"commissionpayout.bulkupload.status\"></th>\n<th translate=\"commissionpayout.bulkupload.statusChangeDate\"></th><th translate=\"commissionpayout.bulkupload.uploadBy\">\n</th><th translate=\"commissionpayout.bulkupload.updatedBy\"></th><th translate=\"commissionpayout.bulkupload.list\"></th>\n<th translate=\"commissionpayout.bulkupload.action\"></th></tr></thead><tbody><tr ng-repeat=\"batch in vm.batchListData\">\n<td>{{batch.WebCashId}}</td><td>{{batch.BatchNo}}</td><td>{{batch.CreateTime | date:\'yyyy-MM-dd\'}}</td><td>\n{{batch.UploadCount}}</td><td>{{batch.TotalAmount}}</td><td>{{batch.ProcessedCount}}</td><td>{{batch.ProcessedAmount}}\n</td><td>{{batch.CommissionCreditStatus}}</td><td>{{batch.TransactionDate | date:\'yyyy-MM-dd\'}}</td><td>\n{{batch.CreateBy}}</td><td>{{batch.UpdateBy}}</td><td class=\"center\"><button type=\"button\" class=\"btn btn-primary\" \nui-sref=\"app.commissionpayout.detail({id:batch.BatchNo})\">View</button><br><br><button type=\"button\" \nclass=\"fa-cloud-download\" ng-click=\"vm.downloadCSV(batch)\">Download</button></td><td class=\"center\"><button \ntype=\"button\" ng-disabled=\"!vm.hasMerchantAdmin(batch)\" class=\"btn btn-info\" \nng-click=\"vm.popupApproveBatch(batch.BatchNo)\">Approve</button><br><br><button type=\"button\" \nng-disabled=\"!vm.hasMerchantAdmin(batch)\" class=\"btn btn-danger\" ng-click=\"vm.popupRejectBatch(batch.BatchNo)\">Reject\n</button><br><br><button type=\"button\" ng-disabled=\"!vm.hasMerchantAdmin(batch)\" class=\"btn btn-danger\" \nng-click=\"vm.popupDeleteBatch(batch.BatchNo)\">Delete</button></td></tr></tbody></table></div><ul uib-pagination \ntotal-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-change=\"vm.initBatchList()\" ng-model=\"vm.currentPage\" \nmax-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div>\n</uib-tab></uib-tabset><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowDialog\" \nclass=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-md\"><div \nclass=\"modal-content my-content\"><form name=\"MerchantWebcashTopupForm\" class=\"form-horizontal\" \nng-submit=\"vm.save(MerchantWebcashTopupForm)\" novalidate id=\"MerchantWebcashTopupForm\"><div class=\"modal-header\">\n<button type=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowDialog = false\"><span aria-hidden=\"true\">&times;</span>\n<span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\" \ntranslate=\"commissionpayout.title.merchantWalletTopupAmount\"></h3></div><div class=\"modal-body\"><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': MerchantWebcashTopupForm.TopupAmount.$invalid && MerchantWebcashTopupForm.TopupAmount.$touched}\">\n<label class=\"control-label col-md-3 margin-tb\" translate=\"commissionpayout.MerchantWebcashTopup.TopupAmount\"></label>\n<div class=\"col-md-8\"><input type=\"number\" name=\"TopupAmount\" min=\"1\" class=\"form-control\" \nng-model=\"vm.mainService.TopupAmount\" required><div ng-messages=\"MerchantWebcashTopupForm.TopupAmount.$error\"><div \nng-message=\"required\" ng-if=\"MerchantWebcashTopupForm.TopupAmount.$touched\" class=\"help-block\"><span>\nTopupAmount is required field</span></div></div></div></div></div><div class=\"modal-footer\"><a class=\"btn btn-danger\" \nng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button type=\"submit\" class=\"btn btn-primary\" \ntranslate=\"common.action.save\"></button></div></form><form name=\"RequestWebcashForm\" method=\"post\" \nclass=\"form-horizontal\" novalidate id=\"RequestWebcashForm\" style=\"display: none\"><input name=\"ord_date\" type=\"hidden\"> \n<input name=\"ord_totalamt\" type=\"hidden\"> <input name=\"ord_mercID\" type=\"hidden\"> <input name=\"ord_mercref\" \ntype=\"hidden\"> <input name=\"ord_returnURL\" type=\"hidden\"> <input name=\"merchant_hashvalue\" type=\"hidden\"> <input \nname=\"topup_merchant_id\" type=\"hidden\"></form></div></div></div></div><style>\n/* Hide cloud download icon so only text is visible on the Download button */\r\n    .fa-cloud-download:before {\r\n        display: none !important;\r\n    }\n</style>");
$templateCache.put("app/commissionpayout/configuration/configuration.html","<h1 class=\"page-header\" ng-init=\"vm.initMerchantList()\"><span translate=\"commissionpayout.title.configuration\"></span>\n</h1><uib-tabset><uib-tab index=\"0\" heading=\"Prefund Account\" ng-click=\"vm.initMerchantList()\"><br><div \nid=\"divPrefund\" class=\"col-md-12\"><div class=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div \nclass=\"col-md-3 col-xs-6\"></div><div class=\"col-md-1 col-xs-3\"></div><div class=\"col-md-2 col-md-offset-6 col-xs-3\"><a \nclass=\"btn btn-primary pull-right\" ng-show=\"vm.showAddPrefund()\" ng-click=\"vm.popupCreateOrUpdateForm()\"><i \nclass=\"glyphicon glyphicon-plus\"></i> <span translate=\"common.action.add\"></span></a></div></div></div><div \nclass=\"table-responsive form-group\"><table class=\"table table-striped table-bordered\"><thead><tr><th \ntranslate=\"commissionpayout.configuration.merchantId\"></th><th translate=\"commissionpayout.configuration.merchantName\">\n</th><th translate=\"commissionpayout.configuration.waasClient\"></th><th \ntranslate=\"commissionpayout.configuration.emailAddress\"></th><th \ntranslate=\"commissionpayout.configuration.createdDate\"></th><th translate=\"commissionpayout.configuration.action\"></th>\n</tr></thead><tbody><tr ng-repeat=\"merchant in vm.merchantListData\"><td>{{merchant.WebCashId}}</td><td>\n{{merchant.MerchantName}}</td><td>{{merchant.WaasClient}}</td><td>{{merchant.EmailAddress}}</td><td>\n{{merchant.CreateTime | date:\'yyyy-MM-dd\'}}</td><td class=\"center\"><a title=\"Edit\" class=\"btn btn-default margin-tl\" \nng-click=\"vm.popupCreateOrUpdateForm(merchant.MerchantId)\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a \ntitle=\"Remove\" class=\"btn btn-danger margin-tl\" ng-click=\"vm.popupremoveForm(merchant.MerchantId)\"><i \nclass=\"glyphicon glyphicon-remove\"></i></a></td></tr></tbody></table></div><ul id=\"pagingAccount\" uib-pagination \ntotal-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-change=\"vm.initMerchantList()\" \nng-model=\"vm.currentPage\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></uib-tab>\n<uib-tab index=\"1\" heading=\"User List\" ng-click=\"vm.initEmailList()\"><br><div id=\"divPrefund\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-6\"></div><div \nclass=\"col-md-1 col-xs-3\"></div><div class=\"col-md-2 col-md-offset-6 col-xs-3\"><a class=\"btn btn-primary pull-right\" \nng-show=\"vm.showAddPrefundForEmail()\" ng-click=\"vm.popupEmailCreateOrUpdateForm()\"><i class=\"glyphicon glyphicon-plus\">\n</i> <span translate=\"common.action.add\"></span></a></div></div></div><div class=\"table-responsive form-group\"><table \nclass=\"table table-striped table-bordered\"><thead><tr><th translate=\"commissionpayout.userEmail.merchantId\"></th><th \ntranslate=\"commissionpayout.userEmail.merchantName\"></th><th translate=\"commissionpayout.userEmail.emailAddress\"></th>\n<th translate=\"commissionpayout.userEmail.createdDate\"></th><th translate=\"commissionpayout.userEmail.userRole\"></th>\n<th translate=\"commissionpayout.userEmail.action\"></th></tr></thead><tbody><tr \nng-repeat=\"merchant in vm.emailListData\"><td>{{merchant.WebCashId}}</td><td>{{merchant.MerchantName}}</td><td>\n{{merchant.EmailAddress}}</td><td>{{merchant.CreateTime | date:\'yyyy-MM-dd\'}}</td><td>{{merchant.UserType}}</td><td \nclass=\"center\"><a title=\"Edit\" class=\"btn btn-default margin-tl\" ng-show=\"vm.disableEmailAction(merchant)\" \nng-click=\"vm.popupEmailCreateOrUpdateForm(merchant.PrefundEmailId)\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a \ntitle=\"Remove\" class=\"btn btn-danger margin-tl\" ng-show=\"vm.disableEmailAction(merchant)\" \nng-click=\"vm.popupRemoveEmailForm(merchant.PrefundEmailId)\"><i class=\"glyphicon glyphicon-remove\"></i></a></td></tr>\n</tbody></table></div><ul id=\"pagingEmail\" uib-pagination total-items=\"vm.emailTotalItems\" \nitems-per-page=\"vm.emailItemsPerPage\" ng-change=\"vm.initEmailList()\" ng-model=\"vm.emailCurrentPage\" \nclass=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></uib-tab></uib-tabset>");
$templateCache.put("app/commissionpayout/configuration/email.updatecreate.view.html","<div class=\"modal-content my-content\"><form id=\"emailForm\" name=\"emailForm\" class=\"form-horizontal\" \nng-submit=\"vm.onSubmit(emailForm.$valid)\" novalidate><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.modal.cancel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 \nclass=\"modal-title center\" id=\"modal-title\">{{vm.modalData.options.headerText}}</h3></div><div class=\"modal-body\"><div \nclass=\"form-group\" ng-class=\"{\'has-error\': emailForm.EmailAddress.$invalid && emailForm.EmailAddress.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"commissionpayout.userEmail.emailAddress\"></label><div \nclass=\"col-md-8\"><input name=\"EmailAddress\" type=\"email\" class=\"form-control margin-tb\" \nng-model=\"vm.formData.EmailAddress\" maxlength=\"50\" required><p \nng-show=\"emailForm.EmailAddress.$invalid && emailForm.EmailAddress.$touched\" class=\"help-block\">\nPlease enter a valid email address.</p></div></div></div><div class=\"alert alert-danger\" ng-if=\"vm.formError\">\n{{vm.formError}}</div><div class=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.modal.cancel()\" \ntranslate=\"common.action.cancel\"></a> <button type=\"submit\" class=\"btn btn-primary\" ng-disabled=\"emailForm.$invalid\" \ntranslate=\"common.action.save\"></button></div></form></div>");
$templateCache.put("app/commissionpayout/configuration/updatecreate.view.html","<div class=\"modal-content my-content\"><form id=\"configurationForm\" name=\"configurationForm\" class=\"form-horizontal\" \nng-submit=\"vm.onSubmit(configurationForm.$valid)\" novalidate><div class=\"modal-header\"><button type=\"button\" \nclass=\"close\" ng-click=\"vm.modal.cancel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span>\n</button><h3 class=\"modal-title center\" id=\"modal-title\" translate=\"commissionpayout.title.header\"></h3></div><div \nclass=\"modal-body\"><div class=\"form-group\" \nng-class=\"{ \'has-error\' : configurationForm.MerchantName.$invalid && configurationForm.MerchantName.$touched }\"><label \nclass=\"control-label col-md-3 required\" translate=\"commissionpayout.configuration.merchant\"></label><div \nclass=\"col-md-8\"><ui-select focus-on=\"focusMerchant\" ng-disabled=\"!vm.isCreateFlag\" ng-model=\"vm.formData.MerchantId\" \nname=\"MerchantName\" ng-keyup=\"vm.loadMerchant($select.search)\" theme=\"bootstrap\" required><ui-select-match \nallow-clear=\"true\" placeholder=\"Enter the merchant\'s name\">{{$select.selected.Name}}</ui-select-match>\n<ui-select-choices repeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh-delay=\"0\" \nminimum-input-length=\"0\"><div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div></ui-select-choices>\n<ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select><div ng-messages=\"configurationForm.MerchantName.$error\"><div ng-message=\"required\" \nng-if=\"configurationForm.MerchantName.$touched\" class=\"help-block\"><span \ntranslate=\"admin.sharedStoreCard.detail.validate.merchant\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': configurationForm.EmailAddress.$invalid && configurationForm.EmailAddress.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"commissionpayout.configuration.emailAddress\"></label><div \nclass=\"col-md-8\"><input name=\"EmailAddress\" type=\"email\" class=\"form-control margin-tb\" \nng-model=\"vm.formData.EmailAddress\" maxlength=\"50\" required><p \nng-show=\"configurationForm.EmailAddress.$invalid && configurationForm.EmailAddress.$touched\" class=\"help-block\">\nEmail Address is required or format is incorrect.</p></div></div></div><div class=\"alert alert-danger\" \nng-if=\"vm.formError\">{{vm.formError}}</div><div class=\"modal-footer\"><a class=\"btn btn-danger\" \nng-click=\"vm.modal.cancel()\" translate=\"common.action.cancel\"></a> <button type=\"submit\" class=\"btn btn-primary\" \nng-disabled=\"configurationForm.$invalid\" translate=\"common.action.save\"></button></div></form></div>");
$templateCache.put("app/commissionpayout/detail/detail.html","<h1 class=\"page-header\"><span translate=\"commissionpayout.title.report\"></span></h1><div id=\"divReport\" \nclass=\"col-md-12\"><div class=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div \nclass=\"col-md-3 margin-tb\"><input type=\"text\" ng-show=\"false\" class=\"form-control\" id=\"searchtxt\" ng-model=\"vm.Id\" \nng-hide=\"true\"><label class=\"control-label\" translate=\"commissionpayout.report.transactionStatus\"></label><select \nng-model=\"vm.serachModel.commissionCreditStatus\" class=\"form-control\"><option value=\"\">All</option><option \nng-repeat=\"option in vm.listStatus\" ng-value=\"option.value\">{{option.name}}</option></select></div></div><div \nclass=\"row\"><div class=\"col-md-3 margin-tb\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.searchReport()\">\nSearch</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.downloadCSV()\">Download</button></div><div \nclass=\"col-md-1 col-md-offset-8\"><button class=\"btn btn-danger\" \nui-sref=\"app.commissionpayout.bulkupload({id: vm.previousPage})\" translate=\"Back\"></button></div></div><div \nrole=\"alert\" ng-show=\"vm.errorMsg\" class=\"alert alert-danger\">{{vm.errorMsg}}</div><div \nclass=\"table-responsive form-group\"><table class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th \ntranslate=\"commissionpayout.bulkupload.merchantId\"></th><th translate=\"commissionpayout.bulkupload.userName\"></th><th \ntranslate=\"commissionpayout.bulkupload.fullName\"></th><th translate=\"commissionpayout.bulkupload.iDType\"></th><th \ntranslate=\"commissionpayout.bulkupload.iDNumber\"></th><th translate=\"commissionpayout.bulkupload.campaignName\"></th><th\n translate=\"commissionpayout.bulkupload.status\"></th><th translate=\"commissionpayout.bulkupload.entitlemaneDate\"></th>\n<th translate=\"commissionpayout.bulkupload.creditAmount\"></th><th \ntranslate=\"commissionpayout.bulkupload.additionalNote\"></th><th translate=\"commissionpayout.bulkupload.erroMessage\">\n</th></tr></thead><tbody><tr ng-repeat=\"batch in vm.batchListData\"><td class=\"center\">{{$index + 1}}</td><td>\n{{batch.WebCashId}}</td><td>{{batch.UserName}}</td><td>{{batch.FullName}}</td><td>{{batch.IDType}}</td><td>\n{{batch.IDNumber}}</td><td>{{batch.CampaignName}}</td><td>{{batch.CommissionCreditStatus}}</td><td>\n{{batch.EntitlementDate}}</td><td>{{batch.CreditAmount}}</td><td>{{batch.AdditionalNote}}</td><td>\n{{batch.StatusMessage}}</td></tr></tbody></table></div>\nPage {{vm.currentPage}} of {{(vm.totalItems / vm.itemsPerPage) | roundup }} , showing {{(vm.currentPage * vm.itemsPerPage) > vm.totalItems ? vm.totalItems : (vm.currentPage * vm.itemsPerPage)}} records out of {{vm.totalItems}} Records\n<ul uib-pagination total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-change=\"vm.searchReport()\" \nng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul>\n</div></div></div>");
$templateCache.put("app/commissionpayout/report/report.html","<uib-tabset><uib-tab index=\"0\" heading=\"Payout Report\"><h1 class=\"page-header\"><span \ntranslate=\"commissionpayout.title.report\"></span></h1><div id=\"divReport\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 margin-tb\"><label \nclass=\"control-label\" translate=\"report.common.transaction_start_date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" \nng-model=\"vm.serachModel.beginTime\"></div><div class=\"col-md-3 margin-tb\"><label class=\"control-label\" \ntranslate=\"report.common.transaction_end_date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" ng-click=\"vm.datePopup.EndOpen = true\" \nng-model=\"vm.serachModel.endTime\"></div><div class=\"col-md-3 margin-tb\"><label class=\"control-label\" \ntranslate=\"commissionpayout.report.transactionType\"></label><select ng-model=\"vm.serachModel.transactionType\" \nclass=\"form-control\"><option value=\"\">All</option><option ng-repeat=\"option in vm.listType\" ng-value=\"option.value\">\n{{option.name}}</option></select></div><div class=\"col-md-3 margin-tb\"><label class=\"control-label\" \ntranslate=\"commissionpayout.report.transactionStatus\"></label><select ng-model=\"vm.serachModel.commissionCreditStatus\" \nclass=\"form-control\"><option value=\"\">All</option><option ng-repeat=\"option in vm.listStatus\" ng-value=\"option.value\">\n{{option.name}}</option></select></div></div><div class=\"row\"><div class=\"col-md-3 margin-tb\"><label \nclass=\"control-label\">Action By</label><ui-select ng-model=\"vm.serachModel.ActionBy\" theme=\"bootstrap\" \ntitle=\"Select Action By\"><ui-select-match placeholder=\"Search for Action By...\">{{$select.selected.email}}\n</ui-select-match><ui-select-choices repeat=\"user.email as user in vm.userList | filter:{ email: $select.search }\"><div\n ng-bind=\"user.email\"></div></ui-select-choices></ui-select></div><div class=\"col-md-3 margin-tb\"><label \nclass=\"control-label\">Campaign Name</label><ui-select ng-model=\"vm.serachModel.CampaignName\" theme=\"bootstrap\" \ntitle=\"Select Campaign Name\"><ui-select-match placeholder=\"Search for Campaign...\">{{$select.selected.name}}\n</ui-select-match><ui-select-choices \nrepeat=\"campaign.name as campaign in vm.campaignList | filter:{ name: $select.search }\"><div ng-bind=\"campaign.name\">\n</div></ui-select-choices></ui-select></div><div class=\"col-md-3 margin-tb\"><label class=\"control-label\">MID</label>\n<ui-select ng-model=\"vm.serachModel.MID\" theme=\"bootstrap\" title=\"Select a MID\"><ui-select-match \nplaceholder=\"Search for MID...\">{{$select.selected.id}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.id as merchant in vm.merchantList | filter:{ id: $select.search }\"><div ng-bind=\"merchant.id\"></div>\n</ui-select-choices></ui-select></div></div><div class=\"row\"><div class=\"col-md-4 margin-tb\"><label \nclass=\"control-label\">&nbsp;</label><div><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.searchReport()\">\nSearch</button> <a class=\"btn btn-primary\" ng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span \ntranslate=\"common.action.reset\"></span></a> <a class=\"btn btn-primary\" ng-click=\"vm.downloadfullList()\"><i \nclass=\"glyphicon glyphicon-download\"></i> <span translate=\"Download\"></span></a></div></div><div \nclass=\"col-md-9 margin-tb\"></div></div><div role=\"alert\" ng-show=\"vm.errorMsg\" class=\"alert alert-danger\">\n{{vm.errorMsg}}</div><div class=\"table-responsive form-group\"><table class=\"table table-striped table-bordered\"><thead>\n<tr><th translate=\"commissionpayout.bulkupload.merchantId\"></th><th translate=\"commissionpayout.bulkupload.batchNo\">\n</th><th translate=\"commissionpayout.bulkupload.transactionID\"></th><th \ntranslate=\"commissionpayout.bulkupload.transactionDate\"></th><th translate=\"commissionpayout.bulkupload.campaignName\">\n</th><th translate=\"commissionpayout.bulkupload.transactionType\"></th><th \ntranslate=\"commissionpayout.bulkupload.totalCount\"></th><th translate=\"commissionpayout.bulkupload.totalAmount\"></th>\n<th translate=\"commissionpayout.bulkupload.status\"></th><th translate=\"commissionpayout.bulkupload.updatedBy\"></th><th \ntranslate=\"commissionpayout.bulkupload.list\"></th></tr></thead><tbody><tr ng-repeat=\"batch in vm.batchListData\"><td>\n{{batch.WebCashId}}</td><td>{{batch.BatchNo}}</td><td>{{batch.ReferenceNo}}</td><td>\n{{batch.TransactionDate | date:\'yyyy-MM-dd\'}}</td><td>{{batch.CampaignName}}</td><td>{{batch.TransactionType}}</td><td>\n{{batch.UploadCount}}</td><td>{{batch.TotalAmount}}</td><td>{{batch.CommissionCreditStatus}}</td><td>{{batch.UpdateBy}}\n</td><td class=\"center\"><button type=\"button\" class=\"btn btn-primary\" \nui-sref=\"app.commissionpayout.transaction({id:batch.BatchNo})\">View</button><br><br><button type=\"button\" \nclass=\"fa-cloud-download\" ng-click=\"vm.downloadCSV(batch)\">Download</button></td></tr></tbody></table></div><ul \nuib-pagination total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-change=\"vm.searchReport()\" \nng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul>\n</div></div></div></uib-tab><uib-tab index=\"1\" heading=\"Prefund Topup Report\"><h1 class=\"page-header\">\nPrefund Topup Report</h1><div id=\"divReport\" class=\"col-md-12\"><div class=\"form-horizontal\"><div class=\"form-group\">\n<div class=\"row\"><div class=\"col-md-3 margin-tb\"><label class=\"control-label\">Start Date</label><input type=\"text\" \nclass=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.MerchantStartOpen\" \nng-click=\"vm.datePopup.MerchantStartOpen = true\" ng-model=\"vm.merchantTopupSerachModel.beginTime\"></div><div \nclass=\"col-md-3 margin-tb\"><label class=\"control-label\">End Date</label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.MerchantEndOpen\" \nng-click=\"vm.datePopup.MerchantEndOpen = true\" ng-model=\"vm.merchantTopupSerachModel.endTime\"></div><div \nclass=\"col-md-3 margin-tb\"><label class=\"control-label\">Status</label><select \nng-model=\"vm.merchantTopupSerachModel.merchantTopupStatus\" class=\"form-control\"><option value=\"\">All</option><option \nng-repeat=\"option in vm.merchantTopupStatus\" value=\"{{option.value}}\">{{option.name}}</option></select></div><div \nclass=\"col-md-3 margin-tb\"><label class=\"control-label\">Action By</label><ui-select \nng-model=\"vm.merchantTopupSerachModel.ActionBy\" theme=\"bootstrap\" title=\"Select Action By\"><ui-select-match \nplaceholder=\"Search for Action By...\">{{$select.selected.email}}</ui-select-match><ui-select-choices \nrepeat=\"user.email as user in vm.topupUsers | filter:{ email: $select.search }\"><div ng-bind=\"user.email\"></div>\n</ui-select-choices></ui-select></div></div><div class=\"row\"><div class=\"col-md-3 margin-tb\"><label \nclass=\"control-label\">MID</label><ui-select ng-model=\"vm.merchantTopupSerachModel.MID\" theme=\"bootstrap\" \ntitle=\"Select a MID\"><ui-select-match placeholder=\"Search for MID...\">{{$select.selected.id}}</ui-select-match>\n<ui-select-choices repeat=\"merchant.id as merchant in vm.topupMerchants | filter:{ id: $select.search }\"><div \nng-bind=\"merchant.id\"></div></ui-select-choices></ui-select></div></div><div class=\"row\"><div \nclass=\"col-md-3 margin-tb\"><label class=\"control-label\">&nbsp;</label><div><button type=\"button\" \nclass=\"btn btn-primary\" ng-click=\"vm.searchMerchantTopupReport()\">Search</button> <button type=\"button\" \nclass=\"btn btn-primary\" ng-click=\"vm.merchantTopupReset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span \ntranslate=\"common.action.reset\"></span></button></div></div></div><div role=\"alert\" ng-show=\"vm.merchantTopupErrorMsg\" \nclass=\"alert alert-danger\">{{vm.merchantTopupErrorMsg}}</div><div class=\"table-responsive form-group\"><table \ndatatable=\"\" dt-options=\"vm.merchantTopUpdataTable.options\" dt-columns=\"vm.merchantTopUpdataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.dtInstance\"><thead><tr><th \ntranslate=\"commissionpayout.bulkupload.transactionID\"></th><th translate=\"commissionpayout.bulkupload.merchantId\"></th>\n<th translate=\"commissionpayout.bulkupload.transactionDate\"></th><th \ntranslate=\"commissionpayout.bulkupload.transactionID\"></th><th translate=\"commissionpayout.bulkupload.totalAmount\">\n</th><th translate=\"commissionpayout.bulkupload.status\"></th><th translate=\"commissionpayout.bulkupload.updatedBy\">\n</th></tr></thead></table></div></div></div></div></uib-tab></uib-tabset>");
$templateCache.put("app/commissionpayout/transaction/transaction.html","<h1 class=\"page-header\"><span translate=\"commissionpayout.title.report\"></span></h1><div id=\"divReport\" \nclass=\"col-md-12\"><div class=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div \nclass=\"col-md-3 margin-tb\"><input type=\"text\" class=\"form-control\" id=\"searchtxt\" ng-model=\"vm.Id\" ng-hide=\"true\">\n<label class=\"control-label\" translate=\"commissionpayout.report.transactionStatus\"></label><select \nng-model=\"vm.serachModel.commissionCreditStatus\" class=\"form-control\"><option value=\"\">All</option><option \nng-repeat=\"option in vm.listStatus\" ng-value=\"option.value\">{{option.name}}</option></select></div></div><div \nclass=\"row\"><div class=\"col-md-3 margin-tb\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.searchReport()\">\nSearch</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.downloadCSV()\">Download</button></div><div \nclass=\"col-md-1 col-md-offset-8\"><button class=\"btn btn-danger\" \nui-sref=\"app.commissionpayout.report({id: vm.previousPage})\" translate=\"Back\"></button></div></div><div role=\"alert\" \nng-show=\"vm.errorMsg\" class=\"alert alert-danger\">{{vm.errorMsg}}</div><div class=\"table-responsive form-group\" \nng-init=\"vm.searchReport()\"><table class=\"table table-striped table-bordered\"><thead><tr><th \ntranslate=\"commissionpayout.bulkupload.merchantId\"></th><th translate=\"commissionpayout.bulkupload.batchNo\"></th><th \ntranslate=\"commissionpayout.bulkupload.transactionID\"></th><th translate=\"commissionpayout.bulkupload.transactionDate\">\n</th><th translate=\"commissionpayout.bulkupload.userName\"></th><th translate=\"commissionpayout.bulkupload.fullName\">\n</th><th translate=\"commissionpayout.bulkupload.iDType\"></th><th translate=\"commissionpayout.bulkupload.iDNumber\"></th>\n<th translate=\"commissionpayout.bulkupload.transactionType\"></th><th translate=\"commissionpayout.bulkupload.status\">\n</th><th translate=\"commissionpayout.bulkupload.updatedBy\"></th><th \ntranslate=\"commissionpayout.bulkupload.campaignName\"></th><th translate=\"commissionpayout.bulkupload.entitlemaneDate\">\n</th><th translate=\"commissionpayout.bulkupload.creditAmount\"></th><th \ntranslate=\"commissionpayout.bulkupload.additionalNote\"></th><th translate=\"commissionpayout.bulkupload.erroMessage\">\n</th></tr></thead><tbody><tr ng-repeat=\"batch in vm.batchListData\"><td>{{batch.WebCashId}}</td><td>{{batch.BatchNo}}\n</td><td>{{batch.ReferenceNo}}</td><td>{{batch.TransactionDate | date:\'yyyy-MM-dd\'}}</td><td>{{batch.UserName}}</td>\n<td>{{batch.FullName}}</td><td>{{batch.IDType}}</td><td>{{batch.IDNumber}}</td><td>{{batch.TransactionType}}</td><td>\n{{batch.CommissionCreditStatus}}</td><td>{{batch.UpdateBy}}</td><td>{{batch.CampaignName}}</td><td>\n{{batch.EntitlementDate}}</td><td>{{batch.CreditAmount}}</td><td>{{batch.AdditionalNote}}</td><td>\n{{batch.StatusMessage}}</td></tr></tbody></table></div>\nPage {{vm.currentPage}} of {{(vm.totalItems / vm.itemsPerPage) | roundup }} , showing {{(vm.currentPage * vm.itemsPerPage) > vm.totalItems ? vm.totalItems : (vm.currentPage * vm.itemsPerPage)}} records out of {{vm.totalItems}} Records\n<ul uib-pagination total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-change=\"vm.searchReport()\" \nng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul>\n</div></div></div>");
$templateCache.put("app/community/configuration/configuration.html","<h1 class=\"page-header\" ng-init=\"vm.search()\">Community Configuration</h1><div id=\"communityConfiguration\" \nclass=\"col-md-12\" ng-controller=\"CommunityConfigurationController\"><div class=\"form-horizontal\"><div \nclass=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-6\"><input type=\"text\" class=\"form-control\" \nid=\"searchtxt\" ng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"Enter the Community name\"></div><div class=\"col-md-1 col-xs-3\"><a class=\"btn btn-primary pull-right\" \nng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a>\n</div><div class=\"col-md-2 col-md-offset-6 col-xs-3\"><a class=\"btn btn-primary pull-right\" \nng-click=\"vm.openDialog(\'new\', null,CommunityForm)\"><i class=\"glyphicon glyphicon-plus\"></i> <span \ntranslate=\"common.action.add\"></span></a></div></div></div><div class=\"table-responsive form-group\"><table \nclass=\"table table-striped table-bordered\"><thead><tr><th>Logo</th><th>Badge</th><th>Name</th><th>Description</th><th>\nCreated By</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"Community in vm.CommunityList\"><td width=\"20%\"><img \nstyle=\"width:100%\" class=\"photo\" ng-src=\"{{Community.Logo}}\"></td><td><img style=\"width:100%\" class=\"photo\" \nng-src=\"{{Community.Badges}}\"></td><td>{{Community.Name}}</td><td>{{Community.Description}}</td><td>\n{{Community.CreatedBy}}</td><td class=\"center\"><a title=\"Edit\" class=\"btn btn-default\" \nng-click=\"vm.openDialog(\'edit\', Community.Id, CommunityForm)\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a \nclass=\"btn btn-primary\" ng-if=\"Community.Publish === false\" mwl-confirm title=\"Publish\" \nmessage=\"Are you really <b>sure</b> you want to publish this Community?\" confirm-text=\"OK\" cancel-text=\"Cancel\" \non-confirm=\"vm.publish(Community.Id, true)\" on-cancel=\"\" confirm-button-type=\"danger\" cancel-button-type=\"default\"><i \nclass=\"glyphicon glyphicon-cloud-upload\"></i> </a><a class=\"btn btn-danger\" ng-if=\"Community.Publish === true\" \nmwl-confirm title=\"Unpublish\" message=\"Are you really <b>sure</b> you want to unpublish this Community\" \nconfirm-text=\"OK\" cancel-text=\"Cancel\" on-confirm=\"vm.publish(Community.Id, false)\" on-cancel=\"\" \nconfirm-button-type=\"danger\" cancel-button-type=\"default\"><i class=\"glyphicon glyphicon-cloud-download\"></i></a></td>\n</tr></tbody></table></div><ul uib-pagination total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" \nng-change=\"vm.search()\" ng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" \nboundary-link-numbers=\"true\" rotate=\"false\"></ul></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><form name=\"CommunityForm\" class=\"form-horizontal\" \nng-submit=\"vm.save(CommunityForm)\" novalidate><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.viewConfig.ShowDialog = false\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span>\n</button><h3 class=\"modal-title center\" id=\"modal-title\">Community Details</h3></div><div class=\"modal-body\"><div \nclass=\"form-group\" ng-class=\"{\'has-error\': CommunityForm.Name.$invalid && CommunityForm.Name.$touched }\"><label \nclass=\"control-label col-md-3\">Name*</label><div class=\"col-md-8\"><input name=\"CommunityName\" type=\"text\" \nclass=\"form-control\" ng-model=\"vm.community.Name\" required><div ng-messages=\"CommunityForm.Name.$error\"><div \nng-message=\"required\" ng-if=\"CommunityForm.Name.$touched\" class=\"help-block\"><span class=\"error\">Name is required field\n</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': CommunityForm.Description.$invalid && CommunityForm.Description.$touched }\"><label \nclass=\"control-label col-md-3\">Description*</label><div class=\"col-md-8\"><input name=\"CommunityDescription\" \ntype=\"text\" class=\"form-control\" ng-model=\"vm.community.Description\" required><div \nng-messages=\"CommunityForm.Description.$error\"><div ng-message=\"required\" ng-if=\"CommunityForm.Description.$touched\" \nclass=\"help-block\"><span class=\"error\">Description is required field</span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': CommunityForm.file.$invalid && CommunityForm.file.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"Image*\">Image*</label><div class=\"photos-form col-md-8\"><div \nclass=\"upload-controls\" ng-if=\"vm.community.Photos.length==0\"><input type=\"file\" class=\"button\" \nngf-select=\"vm.uploadPhoto($files, $invalidFiles)\" name=\"file\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" \nng-model=\"vm.temp.Photo\" ngf-multiple=\"false\"></div><div class=\"file-list\" style=\"width:100%\"><div \nng-messages=\"CommunityForm.file.$error\"><div ng-message=\"dimensions\" ng-if=\"CommunityForm.file.$dirty\" \nclass=\"help-block\"><p translate=\"community.configuration.validate.photo.dimension\"></p></div></div><ul \ndnd-list=\"vm.community.Photos\"><li ng-repeat=\"photo in vm.community.Photos\" style=\"font:smaller\"><div \nclass=\"preview-photos\"><span class=\"dnd\"></span> <img style=\"width:100%;padding-bottom:1%\" src=\"{{photo}}\" \nclass=\"thumb\"> <a ng-click=\"vm.removePhoto($index)\" class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-remove\"></i> \n<span translate=\"Remove\"></span></a></div></li></ul></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': CommunityForm.Badgefile.$invalid && CommunityForm.Badgefile.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"Community Badge*\">Community Badge*</label><div class=\"photos-form col-md-8\">\n<div class=\"upload-controls\" ng-if=\"vm.community.Badges.length==0\"><input type=\"file\" class=\"button\" \nngf-select=\"vm.uploadBadges($files, $invalidFiles)\" name=\"Badgefile\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" \nng-model=\"vm.temp1.badge\" ngf-multiple=\"false\"></div><div class=\"file-list\" style=\"width:100%\"><div \nng-messages=\"CommunityForm.Badgefile.$error\"><div ng-message=\"dimensions\" ng-if=\"CommunityForm.Badgefile.$dirty\" \nclass=\"help-block\"><p translate=\"community.configuration.validate.photo.dimension\"></p></div></div><ul \ndnd-list=\"vm.community.Badges\"><li ng-repeat=\"photo in vm.community.Badges\" style=\"font:smaller\"><div \nclass=\"preview-photos\"><span class=\"dnd\"></span> <img style=\"width:100%;padding-bottom:1%\" src=\"{{photo}}\" \nclass=\"thumb\"> <a ng-click=\"vm.removeBadge($index)\" class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-remove\"></i> \n<span translate=\"Remove\"></span></a></div></li></ul></div></div></div></div><div class=\"modal-footer\"><a \nclass=\"btn btn-danger\" ng-click=\"vm.cancel(width)\" translate=\"common.action.cancel\"></a> <button type=\"submit\" \nclass=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div></div></div>");
$templateCache.put("app/auth/forgot-password/forgot.password.html","<div id=\"forgotPassword\"><div class=\"container\"><form class=\"form-signin\" name=\"forgotPasswordForm\" \nng-submit=\"vm.requestResetPassword()\" novalidate ng-form-touched-on-submit><h2 class=\"form-signin-heading\" \ntranslate=\"AUTH.FORGOT_PASSWORD.TITLE\"></h2><div class=\"form-group\" \nng-class=\"{\'has-error\': (forgotPasswordForm.userName.$invalid && forgotPasswordForm.userName.$touched) || vm.errors.incorrect === true}\">\n<input type=\"text\" name=\"userName\" ng-model=\"vm.userName\" class=\"form-control\" \nplaceholder=\"{{\'AUTH.LOGIN.USER_NAME\' | translate}}\" required autofocus autocomplete=\"new-username\"><div \nclass=\"help-block\" ng-messages=\"forgotPasswordForm.userName.$error\"><div ng-message=\"required\" \ntranslate=\"AUTH.LOGIN.ERRORS.USER_NAME_REQUIRED\" ng-if=\"forgotPasswordForm.userName.$touched\"></div></div></div><button\n class=\"btn btn-lg btn-primary btn-block\" type=\"submit\" translate=\"AUTH.FORGOT_PASSWORD.SEND\"></button></form></div>\n</div>");
$templateCache.put("app/auth/login/login.html","<div class=\"login-page-container\"><div class=\"container\"><form class=\"form-signin\" name=\"signInForm\" \nng-submit=\"vm.signIn()\" novalidate ng-form-touched-on-submit><h2 class=\"form-signin-heading\" \ntranslate=\"AUTH.LOGIN.TITLE\"></h2><div class=\"form-group has-error\" ng-if=\"vm.errors\"><div class=\"help-block\"><div \ntranslate=\"AUTH.LOGIN.ERRORS.INCORRECT\" ng-if=\"vm.errors.incorrect === true\"></div><div \ntranslate=\"AUTH.LOGIN.ERRORS.INACTIVED\" ng-if=\"vm.errors.inactived === true\"></div><div \ntranslate=\"AUTH.LOGIN.ERRORS.SUSPENDED\" ng-if=\"vm.errors.suspended === true\"></div><div \ntranslate=\"AUTH.LOGIN.ERRORS.CLOSED\" ng-if=\"vm.errors.closed === true\"></div><div translate=\"AUTH.LOGIN.ERRORS.LOCKED\" \nng-if=\"vm.errors.locked === true\"></div><div translate=\"AUTH.LOGIN.ERRORS.CANNOT_SIGN_IN\" \nng-if=\"vm.errors.cannotSignIn === true\"></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': (signInForm.userName.$invalid && signInForm.userName.$touched) || vm.errors.incorrect === true}\">\n<input type=\"text\" name=\"userName\" ng-disabled=\"vm.signingIn\" ng-model=\"vm.signInModel.userName\" class=\"form-control\" \nplaceholder=\"{{\'AUTH.LOGIN.USER_NAME\' | translate}}\" required autofocus autocomplete=\"off\"><div class=\"help-block\" \nng-messages=\"signInForm.userName.$error\"><div ng-message=\"required\" translate=\"AUTH.LOGIN.ERRORS.USER_NAME_REQUIRED\" \nng-if=\"signInForm.userName.$touched\"></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': (signInForm.password.$invalid && signInForm.password.$touched) || vm.errors.incorrect === true}\">\n<div class=\"input-group\"><input type=\"password\" style=\"padding: 13px 0 13px 15px\" name=\"password\" \nng-disabled=\"vm.signingIn\" ng-model=\"vm.signInModel.password\" ng-attr-type=\"{{ vm.showPassword ? \'text\':\'password\'}}\" \nclass=\"form-control input-lg\" placeholder=\"{{\'AUTH.LOGIN.PASSWORD\' | translate}}\" required autocomplete=\"off\"> <span \nclass=\"input-group-addon\"><i id=\"pwdeye\" ng-class=\"{\'fa fa-eye\': vm.showPassword,\'fa fa-eye-slash\': !vm.showPassword}\" \nng-click=\"vm.toggleShowPassword()\" aria-hidden=\"true\"></i></span></div><div class=\"help-block\" \nng-messages=\"signInForm.password.$error\"><div ng-message=\"required\" translate=\"AUTH.LOGIN.ERRORS.PASSWORD_REQUIRED\" \nng-if=\"signInForm.password.$touched\"></div></div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-6\">\n<div class=\"checkbox\"><label class=\"control-label\"><input type=\"checkbox\" ng-disabled=\"vm.signingIn\" \nng-model=\"vm.signInModel.remember\"> {{\'AUTH.LOGIN.REMEMBER\' | translate}}</label></div></div><div class=\"col-md-6\"><div\n class=\"checkbox\"><a class=\"pull-right\" ui-sref=\"auth.forgot-password\">Forgot password</a></div></div></div></div>\n<button class=\"btn btn-lg btn-primary btn-block\" ng-disabled=\"vm.signingIn\" type=\"submit\" \ntranslate=\"AUTH.LOGIN.SIGN_IN\"></button></form><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><form name=\"VerifyForm\" class=\"form-horizontal\" \nng-submit=\"vm.VerifyCode()\" novalidate id=\"tagForm\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.cancelVerify()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 \nclass=\"modal-title center\" id=\"modal-title\" translate=\"Verify Code\"></h3></div><div class=\"modal-body\"><div \nclass=\"form-group\" ng-class=\"{\'has-error\': VerifyForm.code.$invalid && VerifyForm.code.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"Code\"></label><div class=\"col-md-8\"><div \nclass=\"input-group\"><input style=\"padding: 13px 0 13px 15px\" ng-keypress=\"vm.searchByKeyword($event)\" type=\"number\" \nclass=\"form-control input-lg\" ng-model=\"vm.verify.code\" ng-attr-type=\"{{ vm.showCode ? \'text\':\'password\'}}\" \nmaxlength=\"6\" placeholder=\"{{\'AUTH.LOGIN.EMAIL_OTP_PLACEHOLDER\' | translate}}\" required autocomplete=\"off\"> <span \nclass=\"input-group-addon\"><i ng-class=\"{\'fa fa-eye\': vm.showCode,\'fa fa-eye-slash\': !vm.showCode}\" \nng-click=\"vm.toggleShowCode()\" aria-hidden=\"true\"></i></span></div><div ng-messages=\"VerifyForm.code.$error\"><div \nng-message=\"required\" ng-if=\"VerifyForm.code.$touched\" class=\"help-block\"><span translate=\"Verify Code required\">\n</span></div><div ng-message=\"min, number, pattern\" ng-if=\"VerifyForm.code.$touched\" class=\"help-block\"><span \ntranslate=\"admin.configuration.errors.max_cash_invalid\"></span></div></div></div></div><div class=\"form-group\"><div \nclass=\"row\"><div class=\"col-md-3\"></div><div class=\"col-md-3\"><label col-md-3><span>Expires in</span>\n {{vm.countDown_tick}}</label></div><div class=\"col-md-2\"></div><div class=\"col-md-3\"><a \nng-show=\"vm.totalcountDown==0\" ng-click=\"vm.resendCode(\'edit\')\" translate=\"Resend Code\"></a></div></div></div></div>\n<div class=\"modal-footer\"><button class=\"btn btn-submit btn-primary\" type=\"submit\" translate=\"Submit\"></button> <a \nclass=\"btn btn-danger\" ng-click=\"vm.cancelVerify()\" translate=\"common.action.cancel\"></a></div></form></div></div>\n</div></div></div></div>");
$templateCache.put("app/partner/detail/partnerCategory.detail.html","<h1 class=\"page-header\" translate=\"partner.detail.title\"></h1><div class=\"header-modal\"><form \nname=\"partnerCategoryForm\" class=\"form-horizontal\" ng-submit=\"vm.save()\" novalidate id=\"partnerCategoryForm\"><div \nclass=\"form-group\" ng-class=\"{\'has-error\': partnerCategoryForm.Name.$invalid && partnerCategoryForm.Name.$touched}\">\n<label class=\"control-label col-md-3 required margin-tb\" translate=\"partner.name\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"Name\" class=\"form-control\" ng-model=\"vm.partnerCategory.Name\" required><div \nng-messages=\"partnerCategoryForm.Name.$error\"><div ng-message=\"required\" ng-if=\"partnerCategoryForm.Name.$touched\" \nclass=\"help-block\"><span translate=\"partner.detail.validate.name\"></span></div></div></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': partnerCategoryForm.MerChantName.$invalid && partnerCategoryForm.MerChantName.$touched}\"><label\n class=\"control-label col-md-3 margin-tb\" translate=\"partner.merchant_name\"></label><div class=\"col-md-8\"><ui-select \nfocus-on=\"focusMerchant\" ng-model=\"vm.partnerCategory.MerchantId\" name=\"MerChantName\" theme=\"bootstrap\" \nng-keyup=\"vm.loadMerchant($select.search)\"><ui-select-match allow-clear=\"true\" placeholder=\"Enter the merchant\'s name\">\n{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh-delay=\"0\" minimum-input-length=\"0\">\n<div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><div \nstyle=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select><div ng-messages=\"partnerCategoryForm.MerChantName.$error\"><div \nng-message=\"required\" ng-if=\"partnerCategoryForm.MerChantName.$touched\" class=\"help-block\"><span \ntranslate=\"partner.detail.validate.merchant\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': partnerCategoryForm.PartnerBank.$invalid && partnerCategoryForm.PartnerBank.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"merchant.partner.bank_name\"></label><div class=\"col-md-8\">\n<input type=\"text\" name=\"PartnerBank\" class=\"form-control\" ng-model=\"vm.partnerCategory.PartnerBankName\" required><div \nng-messages=\"partnerCategoryForm.PartnerBank.$error\"><div ng-message=\"required\" \nng-if=\"partnerCategoryForm.PartnerBank.$touched\" class=\"help-block\"><span translate=\"partner.detail.validate.name\">\n</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': partnerCategoryForm.PartnerBankAccountName.$invalid && partnerCategoryForm.PartnerBankAccountName.$touched}\">\n<label class=\"control-label col-md-3 required margin-tb\" translate=\"merchant.partner.bank_account_name\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"PartnerBankAccountName\" class=\"form-control\" \nng-model=\"vm.partnerCategory.PartnerBankAccountName\" required><div \nng-messages=\"partnerCategoryForm.PartnerBankAccountName.$error\"><div ng-message=\"required\" \nng-if=\"partnerCategoryForm.PartnerBankAccountName.$touched\" class=\"help-block\"><span \ntranslate=\"partner.detail.validate.name\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': partnerCategoryForm.PartnerBankAccountNo.$invalid && partnerCategoryForm.PartnerBankAccountNo.$touched}\">\n<label class=\"control-label col-md-3 required margin-tb\" translate=\"merchant.partner.bank_account_number\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"PartnerBankAccountNo\" class=\"form-control\" ng-pattern=\"/^\\d+$/\" \nng-model=\"vm.partnerCategory.PartnerBankAccountNumber\" required><div \nng-messages=\"partnerCategoryForm.PartnerBankAccountNo.$error\"><div ng-message=\"pattern\" \nng-if=\"partnerCategoryForm.PartnerBankAccountNo.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.partner.bank_account_number_format\"></span></div></div><div \nng-messages=\"partnerCategoryForm.PartnerBankAccountNo.$error\"><div ng-message=\"required\" \nng-if=\"partnerCategoryForm.PartnerBankAccountNo.$touched\" class=\"help-block\"><span \ntranslate=\"partner.detail.validate.name\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': partnerCategoryForm.PartnerEmail.$invalid && partnerCategoryForm.PartnerEmail.$touched}\"><label\n class=\"control-label col-md-3 required margin-tb\" translate=\"merchant.partner.email\"></label><div class=\"col-md-8\">\n<input type=\"text\" name=\"PartnerEmail\" class=\"form-control\" ng-model=\"vm.partnerCategory.PartnerEmail\" \nng-pattern=\"/^(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+\\s?,)*(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+)$/\" required><div \nng-messages=\"partnerCategoryForm.PartnerEmail.$error\"><div ng-message=\"required\" \nng-if=\"partnerCategoryForm.PartnerEmail.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.partner.email_required\"></span></div><div ng-message=\"pattern\" \nng-if=\"partnerCategoryForm.PartnerEmail.$touched\" class=\"help-block\" \ntranslate=\"merchant.validate.partner.email_invalid\"></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': partnerCategoryForm.PartnerType.$invalid && partnerCategoryForm.PartnerType.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"partner.partner_type\"></label><div class=\"col-md-8\">\n<select class=\"form-control\" name=\"PartnerType\" ng-model=\"vm.partnerCategory.PartnerType\" required><option \nng-repeat=\"partnerType in vm.partnerTypes\" ng-value=\"partnerType.Id\">{{partnerType.Name}}</option></select><div \nng-messages=\"partnerCategoryForm.PartnerType.$error\"><div ng-message=\"required\" \nng-if=\"partnerCategoryForm.PartnerType.$touched\" class=\"help-block\"><span \ntranslate=\"partner.detail.validate.partner_type\"></span></div></div></div></div><div \nclass=\"modal-footer footer-center\"><a class=\"btn btn-danger\" ui-sref=\"app.partner\" translate=\"common.action.cancel\">\n</a> <button type=\"submit\" class=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div>");
$templateCache.put("app/rcb-mara/ease-report/ease-withdrawal-report.html","<div show-permissions=\"[\'VIEW_EASE_REPORT\', \'ADMIN_USER\']\"><div id=\"ease_withdrawal_report\" \nng-controller=\"EaseWithdrawalReportController as vm\"><script \nsrc=\"https://cdn.datatables.net/buttons/1.6.5/js/dataTables.buttons.min.js\"></script><script \nsrc=\"https://cdn.datatables.net/buttons/1.6.5/js/buttons.html5.min.js\"></script><script \nsrc=\"https://cdnjs.cloudflare.com/ajax/libs/jszip/3.1.3/jszip.min.js\"></script><script \nsrc=\"https://cdn.datatables.net/buttons/1.6.5/js/buttons.print.min.js\"></script><script \nsrc=\"https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.53/pdfmake.min.js\"></script><script \nsrc=\"https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.53/vfs_fonts.js\"></script><style>\n.dt-buttons .dt-button {\r\n        margin-right: 5px;\r\n        margin-bottom: 5px;\r\n        color: #fff;\r\n        background-color: #337ab7;\r\n        border-color: #2e6da4;\r\n        display: inline-block;\r\n        font-weight: 400;\r\n        text-align: center;\r\n        white-space: nowrap;\r\n        vertical-align: middle;\r\n        touch-action: manipulation;\r\n        cursor: pointer;\r\n        padding: 6px 12px;\r\n        font-size: 14px;\r\n        line-height: 1.42857143;\r\n        border-radius: 4px;\r\n      }\n</style><h1 class=\"page-header\" translate=\"report.names.ease_withdrawal_report\"></h1><div class=\"report-filter\"><div \nclass=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" data-target=\"#collapse_panel\"><span \nclass=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\"><i \nclass=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.common.transaction_start_date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" \nng-model=\"vm.filter.TransactionStartDate\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.common.transaction_end_date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" ng-click=\"vm.datePopup.EndOpen = true\" \nng-model=\"vm.filter.TransactionEndDate\"></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button \ntype=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.getReport()\" translate=\"report.summarize\"></button></div>\n</div></div></div></div></div><div class=\"table-responsive\"><table datatable dt-options=\"vm.dataTable.options\" \ndt-columns=\"vm.dataTable.columns\" class=\"table table-bordered table-striped table-hover\" \ndt-instance=\"vm.dtInstanceCallback\"><thead><tr><th>MID</th><th>Transaction ID</th><th>Wakalu Transaction ID</th><th>\nTransaction Date</th><th>UserName</th><th>FullName</th><th>IDType</th><th>ID Number (NRIC)</th><th>Transaction Type\n</th><th>Withdrawal Reason</th><th>Status</th><th>Requested Amount</th><th>Credited Amount</th><th>Processing Fee</th>\n</tr></thead></table></div></div></div>");
$templateCache.put("app/merchant/info/merchant.view.info.html","<div class=\"alert alert-warning alert-dismissable\" ng-if=\"vm.error\"><a href=\"#\" class=\"close\" data-dismiss=\"alert\" \naria-label=\"close\">&times;</a> <strong>Warning!</strong> {{vm.error}}</div><div id=\"merchant-info\" class=\"col-md-12\">\n<div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3\"><h4 translate=\"merchant.profile.title\"></h4></div><div \nclass=\"col-md-2 col-md-offset-7\"><a show-permissions=\"[\'EDIT_MERCHANT\']\" class=\"btn btn-primary pull-right\" \nng-click=\"vm.edit()\"><i class=\"glyphicon glyphicon-edit\"></i> <span translate=\"common.action.edit\"></span></a></div>\n</div></div><form name=\"profileForm\" class=\"form-horizontal\" novalidate><div class=\"form-group\"><div class=\"col-md-12\">\n<h4 class=\"sub-title title-info\" translate=\"merchant.state\"></h4></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.state\"></label><div class=\"col-md-8\"><label class=\"control-label\">\n{{vm.merchant.State}}</label></div></div><div class=\"form-group\"><div class=\"col-md-12\"><h4 \nclass=\"sub-title title-info\" translate=\"merchant.company.title\"></h4></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.company.name\"></label><div class=\"col-md-8\"><label \nclass=\"control-label\">{{vm.merchant.Company.Name}}</label></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"common.email\"></label><div class=\"col-md-8\"><label class=\"control-label\">\n{{vm.merchant.Company.Email}}</label></div></div><div class=\"form-group\"><label class=\"control-label col-md-3\" \ntranslate=\"merchant.company.registration_number\"></label><div class=\"col-md-8\"><label class=\"control-label\">\n{{vm.merchant.Company.RegistrationNumber}}</label></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.main_contact_person\"></label><div class=\"col-md-8\"><label \nclass=\"control-label\">{{vm.merchant.Company.MainContactPerson}}</label></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.main_contact_number\"></label><div class=\"col-md-8\"><label \nclass=\"control-label\">{{vm.merchant.Company.MainContactNumber}}</label></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.web_url\"></label><div class=\"col-md-8\"><label class=\"control-label\">\n{{vm.merchant.Company.Website}}</label></div></div><div class=\"form-group\"><label class=\"control-label col-md-3\" \ntranslate=\"common.address.address\"></label><div class=\"col-md-8\"><label class=\"control-label\">\n{{vm.merchant.Company.Address.Street}}</label></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"common.address.city\"></label><div class=\"col-md-8\"><label \nclass=\"control-label\">{{vm.merchant.Company.Address.City}}</label></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"common.address.state\"></label><div class=\"col-md-8\"><label \nclass=\"control-label\">{{vm.merchant.Company.Address.State}}</label></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"common.address.district\"></label><div class=\"col-md-8\"><label \nclass=\"control-label\">{{vm.merchant.Company.Address.District}}</label></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"common.address.postcode\"></label><div class=\"col-md-8\"><label \nclass=\"control-label\">{{vm.merchant.Company.Address.PostCode}}</label></div></div><div class=\"form-group\"><div \nclass=\"col-md-12\"><h4 class=\"sub-title title-info\" translate=\"merchant.bank_information\"></h4></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"merchant.bank.name\"></label><div class=\"col-md-8\">\n<label class=\"control-label\">{{vm.merchant.Bank.Name}}</label></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.bank.account_number\"></label><div class=\"col-md-8\"><label \nclass=\"control-label\">{{vm.merchant.Bank.AccountNumber}}</label></div></div><div class=\"form-group\"><div \nclass=\"col-md-12 title-ìnfo\"><h4 class=\"sub-title title-info\" translate=\"merchant.information\"></h4></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"merchant.is_main\"></label><div class=\"col-md-8\">\n<label class=\"control-label\">{{vm.merchant.IsMain ? \"Yes\" : \"No\"}}</label></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.id\"></label><div class=\"col-md-8\"><label class=\"control-label\">\n{{vm.merchant.Id}}</label></div></div><div class=\"form-group\"><label class=\"control-label col-md-3\" \ntranslate=\"common.type\"></label><div class=\"col-md-8\"><label class=\"control-label\">{{vm.merchant.Type}}</label></div>\n</div><div class=\"form-group\"><label class=\"control-label col-md-3\" translate=\"merchant.partners_merchant\"></label><div\n class=\"col-md-8\"><label class=\"control-label\">{{vm.merchant.IsPartnerMerchant ? \"Yes\" : \"No\"}}</label></div></div><div\n class=\"form-group\" ng-if=\"vm.merchant.IsPartnerMerchant\"><label class=\"control-label col-md-3\" \ntranslate=\"merchant.partner_merchant\"></label><div class=\"col-md-8\"><label class=\"control-label\">\n{{vm.partnerCategoryName}}</label></div></div><div class=\"form-group\"><label class=\"control-label col-md-3\" \ntranslate=\"merchant.shared_store_card\"></label><div class=\"col-md-8\"><label class=\"control-label\">\n{{vm.merchant.UseSharedStoreCard ? \"Yes\" : \"No\"}}</label></div></div><div class=\"form-group\" \nng-if=\"vm.merchant.UseSharedStoreCard\"><label class=\"control-label col-md-3\" \ntranslate=\"merchant.use_shared_store_card_setting_id\"></label><div class=\"col-md-8\"><label class=\"control-label\">\n{{(vm.sharedStoreCardSetting | filter: {Id: vm.merchant.SharedStoreCardSettingId})[0].Name}}</label></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"merchant.tier_setting\"></label><div \nclass=\"col-md-8\"><label class=\"control-label\">{{vm.merchant.MerchantName}}</label></div></div><div class=\"form-group\">\n<label class=\"control-label col-md-3\" translate=\"merchant.logo\"></label><div class=\"col-md-8\"><div \nclass=\"logoForm-image upload-control image-uploader merchant-logo\"><div class=\"image-wrapper\"><img id=\"photo\" \nng-src=\"{{vm.merchant.Logo ? vm.merchant.Logo + \'?w=300&h=300\': \'../../assets/images/placeholder.png\'}}\"></div></div>\n</div></div><div class=\"form-group\"><label class=\"control-label col-md-3\" translate=\"common.webcash_id\"></label><div \nclass=\"col-md-8\"><label class=\"control-label\">{{vm.merchant.WebCashId}}</label></div></div><div class=\"form-group\">\n<label class=\"control-label control-label col-md-3\" translate=\"merchant.hash_key\"></label><div class=\"col-md-8\"><label \nclass=\"control-label\">{{vm.merchant.HashKey}}</label></div></div><div class=\"form-group\"><label \nclass=\"control-label control-label col-md-3\" translate=\"merchant.subscribed_services\"></label><div class=\"col-md-8\">\n<label class=\"control-label\" ng-if=\"vm.merchant.SubscribedServices == null\">None</label><label class=\"control-label\" \nng-if=\"vm.merchant.SubscribedServices\"><span ng-repeat=\"subscribedService in vm.merchant.SubscribedServices\"><span \nng-if=\"$index != (vm.merchant.SubscribedServices.length - 1)\">\n{{((vm.subscribedServices | filter: {Id: subscribedService})[0].Name | translate) + \", \"}} </span><span \nng-if=\"$index == (vm.merchant.SubscribedServices.length - 1)\">\n{{((vm.subscribedServices | filter: {Id: subscribedService})[0].Name | translate)}}</span></span></label></div></div>\n<div class=\"form-group\"><label class=\"control-label control-label col-md-3\" translate=\"merchant.contract_date\"></label>\n<div class=\"col-md-8\"><label class=\"control-label\">{{vm.merchant.ContractDate | date: \'yyyy-MM-dd\' }}</label></div>\n</div><div class=\"form-group\"><label class=\"control-label control-label col-md-3\" translate=\"merchant.service_date\">\n</label><div class=\"col-md-8\"><label class=\"control-label\">{{vm.merchant.ServiceDate | date: \'yyyy-MM-dd\' }}</label>\n</div></div><div class=\"form-group\"><label class=\"control-label control-label col-md-3\" \ntranslate=\"merchant.gst_setting\"></label><div class=\"col-md-8\"><label class=\"control-label\" \nng-if=\"vm.merchant.GSTSetting != \'GSTFree\'\">{{vm.merchant.GSTSetting}}</label><label class=\"control-label\" \nng-if=\"vm.merchant.GSTSetting == \'GSTFree\'\">GST Free</label></div></div><div class=\"form-group\"><label \nclass=\"control-label control-label col-md-3\" translate=\"common.partner_merchantId\"></label><div class=\"col-md-8\"><label\n class=\"control-label\">{{vm.merchant.PartnerMerchantId}}</label></div></div><div class=\"form-group\"><div \nclass=\"col-md-12\"><h4 class=\"sub-title title-info\" translate=\"merchant.store_card_topup_option.title\"></h4></div></div>\n<div class=\"form-group\" ng-repeat=\"storeCardTopupOption in vm.merchant.StoreCardTopupOptions track by $index\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.store_card_topup_option.name\"></label><div class=\"col-md-3\"><label \nclass=\"control-label\">{{storeCardTopupOption.Name}}</label></div><label class=\"control-label col-md-1\" \ntranslate=\"merchant.store_card_topup_option.amount\"></label><div class=\"col-md-1\"><label class=\"control-label\">\n{{storeCardTopupOption.Amount}}</label></div><label class=\"control-label col-md-1\" \ntranslate=\"merchant.store_card_topup_option.bonus\"></label><div class=\"col-md-1\"><label class=\"control-label\">\n{{storeCardTopupOption.Bonus}}</label></div></div><div class=\"form-group\" \nng-if=\"vm.merchant.StoreCardTopupOptions.length == 0\"><label class=\"control-label col-md-3\"></label><div \nclass=\"col-md-9\"><label class=\"control-label\" translate=\"merchant.store_card_topup_option.empty\"></label></div></div>\n</form><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowMerchantDialog\" \nclass=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-lg\"><div \nclass=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.viewConfig.ShowMerchantDialog = false\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close\n</span></button><h3 class=\"modal-title center\" id=\"modal-title\" translate=\"merchant.merchant_detail\"></h3></div><div \nclass=\"modal-body\"><ul class=\"nav nav-tabs\"><li class=\"active\"><a data-toggle=\"tab\" href=\"#merchantDiv\" \nid=\"merchantTab\">Information</a></li><li><a data-toggle=\"tab\" href=\"#storeCardTopupOptionsDiv\" \nid=\"storeCardTopupOptionsTab\">StoreCard Topup Options</a></li></ul><div class=\"tab-content\"><div id=\"merchantDiv\" \nclass=\"tab-pane fade in active\"><form name=\"merchantForm\" class=\"form-horizontal\" novalidate id=\"merchantForm\"><div \nclass=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" translate=\"merchant.company.title\"></h4></div></div>\n<div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.CompanyEmail.$invalid && merchantForm.CompanyEmail.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.company.email\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"CompanyEmail\" class=\"form-control\" ng-model=\"vm.merchant.Company.Email\"><div \nng-messages=\"merchantForm.CompanyEmail.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.CompanyEmail.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.company.email_required\"></span></div><div ng-message=\"email\" \nng-if=\"merchantForm.CompanyEmail.$touched\" class=\"help-block\" translate=\"merchant.validate.company.email_invalid\">\n</div></div></div></div><div class=\"form-group\"><label class=\"control-label col-md-3\" \ntranslate=\"merchant.company.registration_number\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"RegistrationNumber\" class=\"form-control\" ng-model=\"vm.merchant.Company.RegistrationNumber\"></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.MainContactPerson.$invalid && merchantForm.MainContactPerson.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.main_contact_person\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"MainContactPerson\" class=\"form-control\" ng-model=\"vm.merchant.Company.MainContactPerson\"><div \nng-messages=\"merchantForm.MainContactPerson.$error\"><div ng-message=\"required\" \nng-if=\"merchantForm.MainContactPerson.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.company.main_contact_person\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.MainContactNumber.$invalid && merchantForm.MainContactNumber.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.main_contact_number\"></label><div class=\"col-md-8\"><input \ntype=\"text\" class=\"form-control\" name=\"MainContactNumber\" ng-model=\"vm.merchant.Company.MainContactNumber\"><div \nng-messages=\"merchantForm.MainContactNumber.$error\"><div ng-message=\"required\" \nng-if=\"merchantForm.MainContactNumber.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.company.main_contact_number\"></span></div></div></div></div><div class=\"form-group\"><label\n class=\"control-label col-md-3\" translate=\"merchant.web_url\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"CompanyWebsite\" class=\"form-control\" ng-model=\"vm.merchant.Company.Website\"></div></div><div class=\"form-group\">\n<label class=\"control-label col-md-3\" translate=\"common.address.address\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"AddressStreet\" class=\"form-control\" ng-model=\"vm.merchant.Company.Address.Street\"></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"common.address.city\"></label><div class=\"col-md-8\">\n<input type=\"text\" name=\"AddressCity\" class=\"form-control\" ng-model=\"vm.merchant.Company.Address.City\"></div></div><div\n class=\"form-group\"><label class=\"control-label col-md-3\" translate=\"common.address.district\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"AddressDistrict\" class=\"form-control\" \nng-model=\"vm.merchant.Company.Address.District\"></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"common.address.state\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"AddressState\" class=\"form-control\" ng-model=\"vm.merchant.Company.Address.State\"></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"common.address.postcode\"></label><div \nclass=\"col-md-8\"><input type=\"text\" class=\"form-control\" name=\"PostCode\" \nng-model=\"vm.merchant.Company.Address.PostCode\"></div></div><div class=\"form-group\"><div class=\"col-md-12\"><h4 \nclass=\"sub-title\" translate=\"merchant.bank_information\"></h4></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.bank.name\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"BankName\" class=\"form-control\" ng-model=\"vm.merchant.Bank.Name\"></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.bank.account_number\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"AccountNumber\" class=\"form-control\" ng-model=\"vm.merchant.Bank.AccountNumber\"></div></div><div \nclass=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" translate=\"merchant.information\"></h4></div></div><div \nclass=\"form-group\"><div class=\"col-md-8\"><input type=\"text\" name=\"Id\" class=\"form-control\" ng-model=\"vm.merchant.Id\" \nng-hide=\"true\"></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.CompanyName.$invalid && merchantForm.CompanyName.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"merchant.company.name\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"CompanyName\" class=\"form-control\" ng-model=\"vm.merchant.Company.Name\" required \nis-merchant-name-available=\"vm.merchant.Company.Id\"><div ng-messages=\"merchantForm.CompanyName.$error\"><div \nng-message=\"required\" ng-if=\"merchantForm.CompanyName.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.company.name\"></span></div><div ng-message=\"isMerchantNameAvailable\" \nng-if=\"merchantForm.CompanyName.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.company.name_duplicate\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.Type.$invalid && merchantForm.Type.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"common.type\"></label><div class=\"col-md-8\"><select class=\"form-control\" \nng-model=\"vm.merchant.Type\" name=\"Type\"><option value=\"Own\">Own</option><option value=\"Franchise\">Franchise</option>\n</select><div ng-messages=\"merchantForm.Type.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.Type.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.merchant.type\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': merchantForm.TierSetting.$invalid && merchantForm.TierSetting.$touched}\">\n<label class=\"control-label col-md-3 required\" translate=\"merchant.tier_setting\"></label><div class=\"col-md-8\"><select \nclass=\"form-control\" name=\"TierSetting\" ng-model=\"vm.merchant.MerchantTierId\" ng-change=\"vm.checkRevenueShare()\" \nrequired><option ng-repeat=\"tier in vm.tierSettings\" ng-value=\"tier.Id\">{{tier.Name}}</option></select><div \nng-messages=\"merchantForm.TierSetting.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.TierSetting.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.merchant.tier_setting\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"merchant.partners_merchant\"></label><div \nclass=\"btn-group col-md-8\"><label class=\"btn btn-default\" ng-model=\"vm.merchant.IsPartnerMerchant\" \nng-click=\"vm.changeIsPartnerMerchant()\" uib-btn-radio=\"true\">Yes</label><label class=\"btn btn-default\" \nng-model=\"vm.merchant.IsPartnerMerchant\" ng-click=\"vm.changeIsPartnerMerchant()\" uib-btn-radio=\"false\">No</label></div>\n</div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.PartnerCategoryId.$invalid && merchantForm.PartnerCategoryId.$touched}\" \nng-if=\"vm.merchant.IsPartnerMerchant\"><label class=\"control-label col-md-3\" translate=\"merchant.partner_merchant\">\n</label><div class=\"col-md-8\"><select class=\"form-control\" name=\"PartnerCategoryId\" \nng-model=\"vm.merchant.PartnerCategoryId\" ng-change=\"vm.getPartnerType(vm.merchant.PartnerCategoryId)\" required><option \nng-repeat=\"partnerCategory in vm.partnerCategories\" ng-value=\"partnerCategory.Id\">{{partnerCategory.Name}}</option>\n</select><div ng-messages=\"merchantForm.PartnerCategoryId.$error\"><div ng-message=\"required\" \nng-if=\"merchantForm.PartnerCategoryId.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.merchant.partners_name\"></span></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.use_shared_store_card\"></label><div class=\"btn-group col-md-8\">\n<label class=\"btn btn-default\" ng-model=\"vm.merchant.UseSharedStoreCard\" uib-btn-radio=\"true\">Yes</label><label \nclass=\"btn btn-default\" ng-model=\"vm.merchant.UseSharedStoreCard\" uib-btn-radio=\"false\">No</label></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.SharedStoreCardSettingId.$invalid && merchantForm.SharedStoreCardSettingId.$touched}\" \nng-if=\"vm.merchant.UseSharedStoreCard\"><label class=\"control-label col-md-3 required\" \ntranslate=\"merchant.shared_store_card_setting_id\"></label><div class=\"col-md-8\"><select class=\"form-control\" \nname=\"SharedStoreCardSettingId\" ng-model=\"vm.merchant.SharedStoreCardSettingId\" required><option \nng-repeat=\"sharedStoreCardSetting in vm.sharedStoreCardSetting\" ng-value=\"sharedStoreCardSetting.Id\">\n{{sharedStoreCardSetting.Name}}</option></select><div ng-messages=\"merchantForm.SharedStoreCardSettingId.$error\"><div \nng-message=\"required\" ng-if=\"merchantForm.SharedStoreCardSettingId.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.merchant.shared_store_card_setting\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': merchantForm.Logo.$invalid && merchantForm.Logo.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.logo\"></label><div class=\"col-md-8\"><div class=\"logoForm-image\">\n<input type=\"text\" class=\"form-control\" ng-model=\"vm.merchant.Logo\" ng-hide=\"true\" name=\"Logo\"><div upload-control \nclass=\"upload-control image-uploader merchant-logo\" on-file-selected=\"vm.onMerchantLogoSelected($files, $control)\">\n<input type=\"file\" class=\"hidden\" accept=\".jpeg, .jpg, .png\"> <a translate=\"common.action.select_photo\" \nclass=\"btn btn-default\"></a><label>{{vm.temp.Logo}}</label><div class=\"image-wrapper\"><img id=\"photo\" \nng-src=\"{{vm.merchant.Logo ? vm.merchant.Logo + \'?w=300&h=300\': \'../../assets/images/placeholder.png\'}}\"></div></div>\n<button type=\"button\" class=\"btn-delete-photo\" ng-click=\"vm.deleteLogo()\" ng-hide=\"vm.disabledDeleteLogo\"><span \nclass=\"glyphicon glyphicon-trash\"></span></button></div><div ng-messages=\"merchantForm.Logo.$error\"><div \nng-message=\"required\" ng-if=\"merchantForm.Logo.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.merchant.logo\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.WebcashId.$invalid && merchantForm.WebcashId.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"common.webcash_id\"></label><div class=\"col-md-8\"><input type=\"text\" \nclass=\"form-control\" name=\"WebcashId\" ng-model=\"vm.merchant.WebCashId\" ng-required=\"vm.requiredWebcashId\"><div \nng-messages=\"merchantForm.WebcashId.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.WebcashId.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.merchant.webcash_id\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"merchant.hash_key\"></label><div class=\"col-md-8\">\n<div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"HashKey\" ng-model=\"vm.merchant.HashKey\"> <span \nclass=\"input-group-btn\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.createHashKey()\">Generate Hash\n</button></span></div></div></div><div class=\"form-group\"><label class=\"control-label col-md-3\" \ntranslate=\"merchant.subscribed_services\"></label><div class=\"col-md-8\"><ui-select multiple=\"multiple\" \nng-model=\"vm.merchant.SubscribedServices\" theme=\"bootstrap\" close-on-select=\"true\"><ui-select-match \nplaceholder=\"Select subscribed service...\">{{$item.Name | translate}}</ui-select-match><ui-select-choices \nrepeat=\"subscribedService.Id as subscribedService in vm.subscribedServices | filter:$select.search\"><div \nng-bind=\"subscribedService.Name | translate\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.ServiceDate.$invalid && merchantForm.ServiceDate.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.service_date\"></label><div class=\"col-md-8\"><div \nclass=\"input-group\"><input type=\"text\" name=\"ServiceDate\" class=\"form-control\" uib-datepicker-popup \nng-model=\"vm.merchant.ServiceDate\" is-open=\"vm.serviceDatePopup.opened\" datepicker-options=\"vm.dateOptions\" \nclose-text=\"Close\" autocomplete=\"off\" ng-click=\"vm.openServiceDatePopup()\" ng-required=\"vm.requiredServiceDate\"> <span \nclass=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.openServiceDatePopup()\"><i \nclass=\"glyphicon glyphicon-calendar\"></i></button></span></div><div ng-messages=\"merchantForm.ServiceDate.$error\"><div \nng-message=\"date\" ng-if=\"merchantForm.ServiceDate.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.merchant.service_date_valid\"></span></div><div ng-message=\"required\" \nng-if=\"merchantForm.ServiceDate.$touched\" class=\"help-block\"><span translate=\"merchant.validate.merchant.service_date\">\n</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.ContractDate.$invalid && merchantForm.ContractDate.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.contract_date\"></label><div class=\"col-md-8\"><div \nclass=\"input-group\"><input type=\"text\" name=\"ContractDate\" class=\"form-control\" uib-datepicker-popup \nng-model=\"vm.merchant.ContractDate\" is-open=\"vm.contractDatePopup.opened\" datepicker-options=\"vm.dateOptions\" \nclose-text=\"Close\" autocomplete=\"off\" ng-click=\"vm.openContractDatePopup()\"> <span class=\"input-group-btn\"><button \ntype=\"button\" class=\"btn btn-default\" ng-click=\"vm.openContractDatePopup()\"><i class=\"glyphicon glyphicon-calendar\">\n</i></button></span></div><div ng-messages=\"merchantForm.ContractDate.$error\"><div ng-message=\"date\" \nng-if=\"merchantForm.ContractDate.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.merchant.contract_date_valid\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.GSTSetting.$invalid && merchantForm.GSTSetting.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.gst_setting\"></label><div class=\"col-md-8\"><select \nclass=\"form-control\" ng-model=\"vm.merchant.GSTSetting\" name=\"GSTSetting\" required><option value=\"Inclusive\">Inclusive\n</option><option value=\"Exclusive\">Exclusive</option><option value=\"GSTFree\">GST Free</option></select><div \nng-messages=\"merchantForm.GSTSetting.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.GSTSetting.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.merchant.gst_setting\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"common.partner_merchantId\"></label><div \nclass=\"col-md-8\"><input type=\"text\" class=\"form-control\" name=\"PartnerMerchantId\" \nng-model=\"vm.merchant.PartnerMerchantId\"></div></div></form></div><div id=\"storeCardTopupOptionsDiv\" \nclass=\"tab-pane fade\"><form name=\"storeCardTopupOptionsForm\" class=\"form-horizontal\" novalidate \nid=\"storeCardTopupOptionsForm\"><br><div class=\"row\" \nng-repeat=\"storeCardTopupOption in vm.merchant.StoreCardTopupOptions track by $index\"><div class=\"form-group col-md-4\" \nng-class=\"{\'has-error\': storeCardTopupOptionsForm[\'storeCardTopupOptionName\'+$index].$invalid && storeCardTopupOptionsForm[\'storeCardTopupOptionName\'+$index].$touched}\">\n<div class=\"row\"><label class=\"control-label col-md-4 required\" translate=\"merchant.store_card_topup_option.name\">\n</label><div class=\"col-md-8\"><input type=\"text\" name=\"storeCardTopupOptionName{{$index}}\" class=\"form-control\" \nng-model=\"storeCardTopupOption.Name\" required></div></div><div class=\"row\"><div class=\"form-group col-md-12\"><div \nng-messages=\"storeCardTopupOptionsForm[\'storeCardTopupOptionName\'+$index].$error\" style=\"margin-left:33px\"><div \nng-message=\"required\" ng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionName\'+$index].$touched\" class=\"help-block\">\n<span translate=\"merchant.validate.store_card_topup_option.name\"></span></div></div></div></div></div><div \nclass=\"form-group col-md-3\" \nng-class=\"{\'has-error\': storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$invalid && storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$touched}\">\n<div class=\"row\"><label class=\"control-label col-md-6 required\" translate=\"merchant.store_card_topup_option.amount\">\n</label><div class=\"col-md-6\"><input type=\"number\" name=\"storeCardTopupOptionAmount{{$index}}\" class=\"form-control\" \nng-model=\"storeCardTopupOption.Amount\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\" required></div></div><div \nclass=\"row\"><div class=\"form-group col-md-12\"><div \nng-messages=\"storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$error\" style=\"margin-left:30px\"><div \nng-message=\"required\" ng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.store_card_topup_option.amount\"></span></div><div \nng-message=\"number\" ng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$touched\" class=\"help-block\">\n<span translate=\"merchant.validate.store_card_topup_option.amount_number\"></span></div><div ng-message=\"pattern\" \nng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.store_card_topup_option.amount_number\"></span></div></div></div></div></div><div \nclass=\"form-group col-md-3\" \nng-class=\"{\'has-error\': storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$invalid && storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$touched}\">\n<div class=\"row\"><label class=\"control-label col-md-6 required\" translate=\"merchant.store_card_topup_option.bonus\">\n</label><div class=\"col-md-6\"><input type=\"number\" name=\"storeCardTopupOptionBonus{{$index}}\" class=\"form-control\" \nng-model=\"storeCardTopupOption.Bonus\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\" required></div></div><div \nclass=\"row\"><div class=\"form-group col-md-12\"><div \nng-messages=\"storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$error\" style=\"margin-left:40px\"><div \nng-message=\"required\" ng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.store_card_topup_option.bonus\"></span></div><div \nng-message=\"number\" ng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$touched\" class=\"help-block\">\n<span translate=\"merchant.validate.store_card_topup_option.bonus_number\"></span></div><div ng-message=\"pattern\" \nng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.store_card_topup_option.bonus_number\"></span></div></div></div></div></div><div \nclass=\"form-group col-md-2\"><a style=\"margin-left:5px\" class=\"btn btn-danger\" \nng-click=\"vm.removeStoreCardTopupOption($index)\">Remove</a></div></div><div class=\"row\"><div \nclass=\"form-group col-md-12 text-right\"><a class=\"btn btn-primary\" ng-click=\"vm.addStoreCardTopupOption()\">Add</a>\n</div></div></form></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" \nng-click=\"vm.save()\" translate=\"common.action.update\"></button></div></div></div></div></div></div>");
$templateCache.put("app/merchant/info/merchant.view.layout.html","<div id=\"merchant-info\"><div id=\"exTab2\" class=\"container-fluid\"><ul class=\"nav nav-tabs\"><li class=\"active\"><a \ndata-target=\"#info\" data-toggle=\"tab\">Merchant Info</a></li><li ng-if=\"storeCardSetting\"><a data-target=\"#storecard\" \ndata-toggle=\"tab\">Store Card</a></li><li ng-if=\"accountType == 1\"><a data-target=\"#checkwallet\" data-toggle=\"tab\">\nCheck Wallet</a></li><li ng-if=\"accountType == 1\"><a data-target=\"#webhook\" data-toggle=\"tab\">Webhook Setting</a></li>\n<li ng-if=\"accountType == 1\"><a data-target=\"#prefund\" data-toggle=\"tab\">Prefund Setting</a></li></ul><div \nclass=\"tab-content\"><div class=\"tab-pane active\" id=\"info\"><div ui-view=\"merchantInfo\"></div></div><div \nclass=\"tab-pane\" id=\"storecard\"><div ui-view=\"merchantStoreCard\"></div></div><div class=\"tab-pane\" id=\"checkwallet\">\n<div ui-view=\"merchantWallet\"></div></div><div class=\"tab-pane\" id=\"webhook\"><div ui-view=\"merchantWebhook\"></div>\n</div><div class=\"tab-pane\" id=\"prefund\"><div ui-view=\"merchantPrefund\"></div></div></div></div></div>");
$templateCache.put("app/merchant/info/merchant.view.prefund.html","<form name=\"prefundForm\" novalidate class=\"form-horizontal\"><div class=\"form-group\"><div class=\"col-md-12\"><h4 \nclass=\"sub-title title-info\" translate=\"merchant.prefund.alert_config\"></h4></div></div><br><div class=\"row\"><div \nclass=\"form-group col-md-12\" \nng-class=\"{\'has-error\': prefundForm.PercentAlertAmount.$invalid && prefundForm.PercentAlertAmount.$touched}\"><div \nclass=\"row\"><label class=\"control-label col-md-4\" translate=\"merchant.prefund.amount_less_than\"></label><div \nclass=\"col-md-4\"><input type=\"number\" name=\"PercentAlertAmount\" class=\"form-control\" \nng-model=\"vm.merchant.PercentAlertAmount\" min=\"10\" max=\"100\" required><div \nng-messages=\"prefundForm.PercentAlertAmount.$error\"><div ng-message=\"min\" class=\"help-block\"><span \ntranslate=\"merchant.prefund.prefund_amount_alert_geater_than_zero\"></span></div><div ng-message=\"max\" \nclass=\"help-block\"><span translate=\"merchant.prefund.prefund_amount_alert_less_than_100\"></span></div><div \nng-message=\"required\" ng-if=\"prefundForm.PercentAlertAmount.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.prefund.prefund_amount_invalid\"></span></div></div></div></div></div><div \nclass=\"form-group col-md-12\" \nng-class=\"{\'has-error\': prefundForm.AlertPrefundEmail.$invalid && prefundForm.AlertPrefundEmail.$touched}\"><div \nclass=\"row\"><label class=\"control-label col-md-4\" translate=\"merchant.prefund.sent_to_emails\"></label><div \nclass=\"col-md-4\"><input type=\"text\" name=\"AlertPrefundEmail\" class=\"form-control margin-tb\" \nng-model=\"vm.merchant.AlertPrefundEmail\" \nng-pattern=\"/^(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+\\s?,)*(\\s?[^\\s,]+@[^\\s,]+\\.[^\\s,]+)$/\" required><div \nng-messages=\"prefundForm.AlertPrefundEmail.$error\"><div ng-message=\"pattern\" class=\"help-block\"><span \ntranslate=\"merchant.prefund.email_invalid\"></span></div><div ng-message=\"required\" \nng-if=\"prefundForm.AlertPrefundEmail.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.prefund.prefund_amount_invalid\"></span></div></div></div><div class=\"col-md-1\"><a \nclass=\"btn btn-primary pull-right margin-tb\" ng-click=\"vm.updatePrefundInfo()\"><span translate=\"common.action.save\">\n</span></a></div></div></div></div><div class=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title title-info\" \ntranslate=\"merchant.prefund.add_prefund\"></h4></div></div><div class=\"form-group col-md-12\" \nng-class=\"{\'has-error\': prefundForm.PrefundAmount.$invalid && prefundForm.PrefundAmount.$touched}\"><div class=\"row\">\n<label class=\"control-label col-md-4\" translate=\"merchant.prefund.prefund_amount\"></label><div class=\"col-md-4\"><input \ntype=\"text\" name=\"PrefundAmount\" class=\"form-control margin-tb\" ng-model=\"vm.merchant.PrefundAmount\" \nng-readonly=\"true\"><div ng-messages=\"prefundForm.PrefundAmount.$error\"><div ng-message=\"required\" \nng-if=\"prefundForm.PrefundAmount.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.prefund.prefund_amount_invalid\"></span></div></div></div><div class=\"col-md-2\"><a \nclass=\"btn btn-primary pull-right margin-tb margin-l\" ng-click=\"vm.openDialog(\'new\')\"><i \nclass=\"glyphicon glyphicon-plus\"></i> <span translate=\"merchant.prefund.add_prefund\"></span></a></div></div></div>\n</form><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" \ntabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><form \nname=\"addPrefundForm\" class=\"form-horizontal\" novalidate id=\"addPrefundForm\"><div class=\"modal-header\"><button \ntype=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowDialog = false\"><span aria-hidden=\"true\">&times;</span><span \nclass=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\" \ntranslate=\"merchant.prefund.add_amount\"></h3></div><div class=\"modal-body\"><div class=\"form-group\" \nng-class=\"{\'has-error\': addPrefundForm.PrefundAmount.$invalid && addPrefundForm.PrefundAmount.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"merchant.prefund.amount\"></label><div class=\"col-md-8\"><input \nname=\"PrefundAmount\" type=\"number\" class=\"form-control\" ng-model=\"vm.PrefundAmount\" min=\"1\" required><div \nng-messages=\"addPrefundForm.PrefundAmount.$error\"><div ng-message=\"min\" class=\"help-block\"><span \ntranslate=\"merchant.prefund.prefund_amount_geater_than_zero\"></span></div><div ng-message=\"required\" \nng-if=\"addPrefundForm.PrefundAmount.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.prefund.prefund_amount_invalid\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': addPrefundForm.PrefundDescription.$invalid && addPrefundForm.PrefundDescription.$touched}\">\n<label class=\"control-label col-md-3 required\" translate=\"merchant.prefund.description\"></label><div class=\"col-md-8\">\n<textarea name=\"PrefundDescription\" type=\"text\" rows=\"3\" class=\"form-control\" ng-model=\"vm.PrefundDescription\" \nrequired></textarea><div ng-messages=\"addPrefundForm.PrefundDescription.$error\"><div ng-message=\"required\" \nng-if=\"addPrefundForm.PrefundDescription.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.prefund.prefund_amount_invalid\"></span></div></div></div></div></div><div class=\"modal-footer\"><a \nclass=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button type=\"submit\" \nclass=\"btn btn-primary\" ng-click=\"vm.updatePrefund()\" translate=\"common.action.save\"></button></div></form></div></div>\n</div></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12\"><h4 class=\"sub-title title-info\" \ntranslate=\"merchant.prefund.title\"></h4></div></div></div><div class=\"row\"><div class=\"col-md-4 col-sm-6 col-xs-6\"><div\n class=\"form-group\"><div class=\"input-group\"><input type=\"text\" class=\"form-control margin-tb\" \nplaceholder=\"Transaction start date\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"vm.criteria.TransactionStartDate\" \nis-open=\"vm.datePopup.StartDate\" datepicker-options=\"vm.dateOptions\" close-text=\"Close\" autocomplete=\"off\" \nng-click=\"vm.datePopup.StartDate = true\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" \nng-click=\"vm.datePopup.StartDate = true\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div>\n<div class=\"col-md-4 col-sm-6 col-xs-6\"><div class=\"form-group\"><div class=\"input-group\"><input type=\"text\" \nclass=\"form-control margin-tb\" placeholder=\"Transaction end date\" uib-datepicker-popup=\"dd/MM/yyyy\" \nng-model=\"vm.criteria.TransactionEndDate\" is-open=\"vm.datePopup.EndDate\" datepicker-options=\"vm.dateOptions\" \nclose-text=\"Close\" autocomplete=\"off\" ng-click=\"vm.datePopup.EndDate = true\"> <span class=\"input-group-btn\"><button \ntype=\"button\" class=\"btn btn-default\" ng-click=\"vm.datePopup.EndDate = true\"><i class=\"glyphicon glyphicon-calendar\">\n</i></button></span></div></div></div><div class=\"col-md-2 pull-right\"><button type=\"button\" \nclass=\"btn btn-default pull-right margin-tb\" ng-click=\"vm.getCSV()\">Export CSV</button></div><div \nclass=\"col-md-2 pull-right\"><button type=\"button\" class=\"btn btn-primary pull-right margin-tb\" ng-click=\"vm.search()\">\nSearch</button></div></div><div class=\"table-responsive form-group\"><table class=\"table table-striped table-bordered\">\n<thead><tr><th>#</th><th translate=\"merchant.prefund.transaction_amount\"></th><th \ntranslate=\"merchant.prefund.new_amount\"></th><th translate=\"merchant.prefund.old_amount\"></th><th \ntranslate=\"merchant.prefund.new_alarm_amount\"></th><th translate=\"merchant.prefund.old_alarm_amount\"></th><th \ntranslate=\"merchant.prefund.created_at\"></th><th translate=\"merchant.prefund.created_by\"></th><th \ntranslate=\"merchant.prefund.description\"></th></tr></thead><tbody><tr ng-repeat=\"history in vm.prefundHistories\"><td \nclass=\"center\">{{$index + 1}}</td><td class=\"center\">{{history.PrefundAmount}}</td><td class=\"center\">\n{{history.NewPrefundAmount}}</td><td class=\"center\">{{history.OldPrefundAmount}}</td><td class=\"center\">\n{{history.NewAlertAmount}}</td><td class=\"center\">{{history.OldAlertAmount}}</td><td class=\"center\">\n{{history.CreatedAt | date: \'yyyy-MM-dd HH:mm:ss\'}}</td><td class=\"center\">{{history.CreatedBy}}</td><td>\n{{history.Description}}</td></tr></tbody></table><ul uib-pagination total-items=\"vm.totalItems\" \nng-change=\"vm.getPrefundHistory()\" ng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" \nboundary-link-numbers=\"true\" rotate=\"false\"></ul></div><div id=\"message\" class=\"form-group\"><div \ndata-ng-show=\"vm.showMessage\" \nng-class=\"{fade:vm.doFade,\'alert alert-danger\': !vm.isSuccess,\'alert alert-success\': vm.isSuccess}\"><strong>\n{{vm.alertTitle}}</strong> {{vm.errorMessage}}</div></div>");
$templateCache.put("app/merchant/info/merchant.view.storecard.html","<form name=\"storeCardForm\" ng-submit=\"vm.updateStoreCardSetting()\" novalidate><div class=\"form-group\"><h4></h4><div \nclass=\"row\"><div class=\"col-md-3\"><h4 class=\"sub-title\" translate=\"merchant.storecard.title\"></h4></div></div></div>\n<div class=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title title-info\" \ntranslate=\"merchant.storecard.max_amount\"></h4></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeCardForm.MaxAmount.$invalid && storeCardForm.MaxAmount.$touched}\"><div class=\"col-md-12\">\n<h4 class=\"sub-title\" translate=\"merchant.storecard.minimum\"></h4></div><div class=\"col-md-4\"><input type=\"text\" \nname=\"MaxAmount\" class=\"form-control\" ng-model=\"vm.MaxAmount\" maxlength=\"25\" ng-disabled=\"!vm.isMaxAmountEditing\" \nrequired><div ng-messages=\"storeCardForm.MaxAmount.$error\"><div ng-message=\"required\" \nng-if=\"storeCardForm.MaxAmount.$touched\" class=\"help-block\"><span translate=\"merchant.storecard.max_amount_required\">\n</span></div></div></div><div class=\"col-md-1 value-title\"><span>RM</span></div><div class=\"col-md-2\"><a \nclass=\"btn btn-primary pull-right\" ng-click=\"vm.editMaxAmountSetting()\"><i class=\"glyphicon glyphicon-edit\"></i> <span \ntranslate=\"common.action.edit\"></span></a></div></div><div class=\"form-group\"><div class=\"col-md-12\"><h4 \nclass=\"sub-title title-info\" translate=\"merchant.storecard.validity_period\"></h4></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeCardForm.ValidityPeriod.$invalid && profileForm.ValidityPeriod.$touched}\"><div \nclass=\"col-md-4\"><input type=\"text\" name=\"ValidityPeriod\" class=\"form-control col-md-4\" ng-model=\"vm.ValidityPeriod\" \nng-disabled=\"!vm.isValidityPeriorEditing\" required><div ng-messages=\"storeCardForm.ValidityPeriod.$error\"><div \nng-message=\"required\" ng-if=\"storeCardForm.ValidityPeriod.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.storecard.validity_period_required\"></span></div></div></div><div class=\"col-md-1 value-title\">\n<span>Months</span></div><div class=\"col-md-2\"><a class=\"btn btn-primary pull-right\" \nng-click=\"vm.editValidityPeriodSetting()\"><i class=\"glyphicon glyphicon-edit\"></i> <span \ntranslate=\"common.action.edit\"></span></a></div></div><div class=\"form-group\"><div class=\"col-md-12\"><h4 \nclass=\"sub-title title-info\" translate=\"merchant.storecard.denomination\"></h4></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeCardForm.Denomination.$invalid && profileForm.Denomination.$touched}\"><div \nclass=\"col-md-12\"><h4 class=\"sub-title\" translate=\"merchant.storecard.denomination_value\"></h4></div><div \nclass=\"col-md-4\"><input type=\"text\" name=\"Denomination\" class=\"form-control\"><div \nng-messages=\"profileForm.Denomination.$error\"><div ng-message=\"required\" ng-if=\"storeCardForm.Denomination.$touched\" \nclass=\"help-block\"><span translate=\"Denomination is required field.\"></span></div></div></div><div class=\"col-md-12\">\n<h4 class=\"denomination-max\" translate=\"merchant.storecard.denomination_maximum\"></h4></div></div><div \nclass=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title title-info\" \ntranslate=\"merchant.storecard.term_and_conditions\"></h4></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': storeCardForm.TermsAndConditions.$invalid && storeCardForm.TermsAndConditions.$touched}\"><div \nclass=\"col-md-4\"><textarea type=\"text\" name=\"TermsAndConditions\" class=\"form-control\" ng-model=\"vm.TermAndConditions\" \nng-disabled=\"!vm.isTermsAndConditionsEditing\" required></textarea><div \nng-messages=\"storeCardForm.TermsAndConditions.$error\"><div ng-message=\"required\" \nng-if=\"storeCardForm.TermsAndConditions.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.storecard.term_and_conditions_required\"></span></div></div></div><div class=\"col-md-1 value-title\">\n</div><div class=\"col-md-2\"><a class=\"btn btn-primary pull-right\" ng-click=\"vm.editTermsAndConditionsSetting()\"><i \nclass=\"glyphicon glyphicon-edit\"></i> <span translate=\"common.action.edit\"></span></a></div></div><div \nclass=\"col-md-12\"><h2></h2><button class=\"btn btn-primary\" type=\"submit\" translate=\"common.action.update\"></button>\n</div></form>");
$templateCache.put("app/merchant/info/merchant.view.wallet.html","<div class=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12\"><h4 \nclass=\"sub-title title-info\" translate=\"merchant.checkwallet.title\"></h4></div></div></div><div \nclass=\"table-responsive form-group\" ng-if=\"!vm.isNoUserData\"><table class=\"table table-striped table-bordered\"><thead>\n<tr><th>#</th><th translate=\"merchant.checkwallet.mobile_number\"></th><th translate=\"merchant.checkwallet.full_name\">\n</th><th translate=\"merchant.checkwallet.product_name\"></th><th translate=\"merchant.checkwallet.current_balance\"></th>\n<th translate=\"merchant.checkwallet.expired_date\"></th></tr></thead><tbody><tr \nng-repeat=\"walletInfo in vm.userWalletInfos\"><td class=\"center\">{{$index + 1}}</td><td>{{walletInfo.MobileNumber}}</td>\n<td>{{walletInfo.FullName}}</td><td>{{walletInfo.ProductName}}</td><td>{{walletInfo.CurrentBalance}}</td><td>\n{{walletInfo.ExpiredDate}}</td></tr><tr><td colspan=\"7\"></td></tr><tr><td colspan=\"3\"></td><td>Total:</td><td \ncolspan=\"1\">{{vm.totalBalance}}</td><td></td></tr></tbody></table><ul uib-pagination total-items=\"vm.totalItems\" \nng-change=\"vm.search()\" ng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" \nboundary-link-numbers=\"true\" rotate=\"false\"></ul></div><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-12\">\n<label ng-if=\"vm.isNoUserData\">There is no transaction!</label></div></div></div></div>");
$templateCache.put("app/merchant/info/merchant.view.webhook.html","<form name=\"webhookForm\" novalidate class=\"form-horizontal\"><br><div class=\"form-group\"><div class=\"col-md-12\"><h4 \nclass=\"sub-title\" translate=\"merchant.webhook.store_card\"></h4></div></div><br><div \nng-repeat=\"webhook in vm.webhooks | orderBy: \'Rank\'\"><div class=\"form-group\"><label class=\"control-label col-md-3\">\n{{webhook.TypeName}} - Url</label><div class=\"col-md-8\"><input type=\"url\" class=\"form-control\" \nng-model=\"webhook.CallBackUrl\"></div></div></div><br><div class=\"form-group\"><div class=\"col-md-12\"><h4 \nclass=\"sub-title\" translate=\"merchant.webhook.deeplink\"></h4></div></div><br><div \nng-repeat=\"webhook in vm.deeplinks | orderBy: \'Rank\'\"><div class=\"form-group\"><label class=\"control-label col-md-3\">\n{{webhook.TypeName}} - Url</label><div class=\"col-md-8\"><input type=\"url\" class=\"form-control\" \nng-model=\"webhook.CallBackUrl\"></div></div></div><div class=\"form-group\"><div class=\"col-md-10 text-right\"><a \nclass=\"btn btn-primary\" ng-click=\"vm.saveWebhook()\">Save</a></div></div></form>");
$templateCache.put("app/merchant/master-merchant/master-merchant.html","<div class=\"alert alert-warning alert-dismissable\" ng-if=\"vm.error\"><a href=\"#\" class=\"close\" data-dismiss=\"alert\" \naria-label=\"close\">&times;</a> <strong>Warning!</strong> {{vm.error}}</div><h1 class=\"page-header\" \ntranslate=\"master_merchant.title\"></h1><div id=\"master-merchant\" class=\"col-md-12\"><div class=\"form-horizontal\"><div \nclass=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><input type=\"text\" class=\"form-control\" \nng-model=\"vm.criteria.Keyword\" ng-keyup=\"vm.searchByKeyword($event)\" placeholder=\"Enter master merchant\'s name\"></div>\n<div class=\"col-md-1 col-sm-10\"><a class=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.reset()\"><i \nclass=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a></div><div \nclass=\"col-md-8 col-sm-2\"><a class=\"btn btn-primary pull-right margin-tl\" \nshow-permissions=\"[\'CREATE_MASTER_MERCHANT\']\" ng-click=\"vm.add()\"><i class=\"glyphicon glyphicon-plus\"></i> <span \ntranslate=\"common.action.add\"></span></a></div></div></div><div class=\"form-group\"><div class=\"table-responsive\"><table\n class=\"table table-striped table-bordered\"><thead thead-order=\"vm.sort($sortOpts)\"><tr><th width=\"10%\">#</th><th \nwidth=\"30%\" translate=\"master_merchant.id\"></th><th width=\"40%\" translate=\"master_merchant.name\"></th><th width=\"20%\" \ntranslate=\"common.action.title\"></th></tr></thead><tbody><tr ng-repeat=\"merchant in vm.merchants\"><td class=\"center\">\n{{$index + 1}}</td><td>{{merchant.WebCashMerchantId}}</td><td>{{merchant.Name}}</td><td class=\"center\"><a \ntitle=\"Edit merchant\" show-permissions=\"[\'EDIT_MASTER_MERCHANT\']\" class=\"btn btn-default margin-tl\" \nng-click=\"vm.edit(merchant.Id)\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a class=\"btn btn-danger margin-tl\" \nshow-permissions=\"[\'DELETE_MASTER_MERCHANT\']\" ng-click=\"vm.remove(merchant.Id)\"><i class=\"glyphicon glyphicon-remove\">\n</i></a></td></tr></tbody></table></div><ul uib-pagination total-items=\"vm.totalItems\" ng-click=\"vm.search()\" \nng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" items-per-page=\"vm.itemsPerPage\" class=\"pagination-sm\" \nboundary-link-numbers=\"true\" rotate=\"true\"></ul></div></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowMerchantDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" \nclass=\"close\" ng-click=\"vm.cancel()\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button>\n<h3 class=\"modal-title center\" id=\"modal-title\" translate=\"master_merchant.title\"></h3></div><div class=\"modal-body\">\n<form name=\"merchantForm\" class=\"form-horizontal\" novalidate id=\"merchantForm\"><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.WebCashMerchantId.$invalid && merchantForm.WebCashMerchantId.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"master_merchant.id\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"WebCashMerchantId\" class=\"form-control\" ng-model=\"vm.merchant.WebCashMerchantId\" required><div \nng-messages=\"merchantForm.WebCashMerchantId.$error\"><div ng-message=\"required\" \nng-if=\"merchantForm.WebCashMerchantId.$touched\" class=\"help-block\"><span \ntranslate=\"master_merchant.validate.id_required\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.Name.$invalid && merchantForm.Name.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"master_merchant.name\"></label><div class=\"col-md-8\"><input\n type=\"text\" name=\"Name\" class=\"form-control\" ng-model=\"vm.merchant.Name\" required><div \nng-messages=\"merchantForm.Name.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.Name.$touched\" \nclass=\"help-block\"><span translate=\"master_merchant.validate.name_required\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': merchantForm.Secret.$invalid && merchantForm.Secret.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"master_merchant.secret\"></label><div class=\"col-md-8\">\n<input type=\"text\" name=\"Secret\" class=\"form-control\" ng-model=\"vm.merchant.Secret\" required><div \nng-messages=\"merchantForm.Secret.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.Secret.$touched\" \nclass=\"help-block\"><span translate=\"master_merchant.validate.secret_required\"></span></div></div></div></div></form>\n</div><div class=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> \n<button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.save()\" translate=\"common.action.save\"></button></div></div>\n</div></div></div></div>");
$templateCache.put("app/merchant/user/merchant.user.html","<h1 class=\"page-header\" translate=\"merchant.user.title\"></h1><div id=\"merchantUser\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><input \ntype=\"text\" class=\"form-control\" ng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"{{\'merchant.placeholder.company_name\' | translate}}\"></div><div class=\"col-md-3 col-xs-12 margin-tb\" \nng-if=\"vm.isAdmin\"><ui-select ng-model=\"vm.criteria.MerchantId\" theme=\"bootstrap\" ng-change=\"vm.search()\">\n<ui-select-match placeholder=\"Enter the merchant\'s name\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" minimum-input-length=\"0\"><div \nng-bind-html=\"merchant.Name | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><div \nstyle=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div><div class=\"col-md-1\"><a class=\"btn btn-primary pull-right margin-tl\" \nng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a>\n</div></div></div><div class=\"form-group\"><div class=\"table-responsive\"><table \nclass=\"table table-striped table-bordered\"><thead><tr><th width=\"5%\">#</th><th width=\"10%\" translate=\"common.username\">\n</th><th width=\"15%\" translate=\"common.merchant\"></th><th width=\"50%\" translate=\"common.permission.title\"></th><th \nwidth=\"20%\" translate=\"common.action.title\"></th></tr></thead><tbody><tr ng-repeat=\"user in vm.users\"><td \nclass=\"center\">{{$index + 1}}</td><td>{{user.UserName}}</td><td>{{user.ObjectName}}</td><td><div class=\"row\"><div \nclass=\"col-md-6\" ng-repeat=\"permission in user.Permissions\">\n{{vm.permissions.findItem(\'Value\', permission).Name | translate}}</div></div></td><td class=\"center\"><a \nshow-permissions=\"[\'COMMISSION_PAYOUT_ADMIN\']\" title=\"Edit\" class=\"btn btn-default margin-tl\" ng-click=\"vm.edit(user)\">\n<i class=\"glyphicon glyphicon-edit\"></i></a> <a show-permissions=\"[\'CHANGE_PASSWORD_USER_MERCHANT\']\" \ntitle=\"Change password\" class=\"btn btn-primary margin-tl\" ng-click=\"vm.changePassword(user.UserId)\"><i \nclass=\"glyphicon glyphicon-wrench\"></i></a><a show-permissions=\"[\'COMMISSION_PAYOUT_ADMIN\']\" title=\"Remove\" \nclass=\"btn btn-danger margin-tl\" ng-click=\"vm.removeUser(user.UserId)\"><i class=\"glyphicon glyphicon-remove\"></i></a>\n</td></tr></tbody></table></div><ul uib-pagination total-items=\"vm.totalItems\" ng-change=\"vm.search()\" \nng-model=\"vm.currentPage\" items-per-page=\"vm.itemsPerPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" \nboundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.showDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-lg\"><div \nclass=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.showDialog = false\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 \nclass=\"modal-title center\" id=\"modal-title\" translate=\"merchant.user.add_user\"></h3></div><div class=\"modal-body\"><form\n name=\"merchantForm\" class=\"form-horizontal\"><div class=\"form-group\"><label class=\"control-label col-md-3\" \ntranslate=\"common.username\"></label><label class=\"col-md-8 control-label left\">{{vm.user.UserName}}</label></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"common.permission.title\"></label><div \nng-repeat=\"permission in vm.permissions\" class=\"checkbox col-md-3\" \nng-class=\"{\'col-md-offset-3\':$index%2==0&&$index!=0}\"><label><input type=\"checkbox\" \nng-click=\"vm.addPermission(permission.Value)\" ng-checked=\"vm.permissionSelected(permission.Value)\">\n{{permission.Name | translate}}</label></div></div></form></div><div class=\"modal-footer\"><a class=\"btn btn-warning\" \nng-click=\"vm.selectAll()\" translate=\"common.action.select_all\"></a> <a class=\"btn btn-danger\" \nng-click=\"vm.cancelAddUser()\" translate=\"common.action.cancel\"></a> <a class=\"btn btn-primary\" \nng-click=\"vm.saveUser()\" translate=\"common.action.save\"></a></div></div></div></div></div><div class=\"header-modal\">\n<div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowAddUserDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\">\n<div class=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><div class=\"modal-header\"><button \ntype=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowAddUserDialog = false\"><span aria-hidden=\"true\">&times;</span>\n<span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\">Add user to merchant</h3>\n</div><form name=\"merchantUserForm\" class=\"form-horizontal\" ng-submit=\"vm.saveNewUser()\" novalidate \nid=\"merchantUserForm\"><div class=\"modal-body\"><div class=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" \ntranslate=\"merchant.user_info\"></h4></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantUserForm.UserName.$invalid && merchantUserForm.UserName.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"common.username\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"UserName\" class=\"form-control\" ng-model=\"vm.user.UserName\" required><div \nng-messages=\"merchantUserForm.UserName.$error\"><div ng-message=\"required\" ng-if=\"merchantUserForm.UserName.$touched\" \nclass=\"help-block\"><span translate=\"merchant.user.validate.user_name\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': merchantUserForm.Password.$invalid && merchantUserForm.Password.$touched}\">\n<label class=\"control-label col-md-3\" translate=\"common.password\"></label><div class=\"col-md-8\"><input type=\"password\" \nname=\"Password\" class=\"form-control\" ng-model=\"vm.user.Password\" required><div \nng-messages=\"merchantUserForm.Password.$error\"><div ng-message=\"required\" ng-if=\"merchantUserForm.Password.$touched\" \nclass=\"help-block\"><span translate=\"merchant.user.validate.password\"></span></div></div></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': merchantUserForm.ConfirmPassword.$invalid && merchantUserForm.ConfirmPassword.$touched}\"><label\n class=\"control-label col-md-3\" translate=\"common.confirm_password\"></label><div class=\"col-md-8\"><input \ntype=\"password\" name=\"ConfirmPassword\" class=\"form-control\" ng-model=\"vm.user.ConfirmPassword\" \nng-pattern=\"{{vm.user.Password}}\" required><div ng-messages=\"merchantUserForm.ConfirmPassword.$error\"><div \nng-message=\"required\" ng-if=\"merchantUserForm.ConfirmPassword.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.user.validate.password_confirm\"></span></div><div ng-message=\"pattern\" class=\"help-block\"><span \ntranslate=\"merchant.user.validate.password_confirm_not_match\"></span></div></div></div></div><div class=\"form-group\">\n<div class=\"col-md-12\"><h4 class=\"sub-title\" translate=\"common.permission.title\"></h4></div></div><div \nclass=\"form-group\"><div class=\"col-md-3\"></div><div ng-repeat=\"permission in vm.permissions\" class=\"checkbox col-md-3\" \nng-class=\"{\'col-md-offset-3\':$index%2==0&&$index!=0}\"><label><input type=\"checkbox\" \nng-click=\"vm.addPermission(permission.Value)\" ng-checked=\"vm.permissionSelected(permission.Value)\">\n{{permission.Name | translate}}</label></div></div></div><div class=\"modal-footer\"><a class=\"btn btn-danger\" \nng-click=\"vm.viewConfig.ShowAddUserDialog = false\" translate=\"common.action.cancel\"></a> <button type=\"submit\" \nclass=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div></div><div \nclass=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowChangePasswordDialog\" class=\"modal fade\" \ntabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowChangePasswordDialog = false\">\n<span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" \nid=\"modal-title\">Change password</h3></div><form name=\"changePasswordForm\" class=\"form-horizontal\" \nng-submit=\"vm.saveChangePassword()\" novalidate id=\"changePasswordForm\"><div class=\"modal-body\"><div class=\"form-group\" \nng-class=\"{\'has-error\': changePasswordForm.Password.$invalid && changePasswordForm.Password.$touched}\"><label \nclass=\"control-label col-md-4 required\" translate=\"common.password\"></label><div class=\"col-md-8\"><input \ntype=\"password\" name=\"Password\" class=\"form-control\" ng-model=\"vm.changePasswordModel.NewPassword\" required><div \nng-messages=\"changePasswordForm.Password.$error\"><div ng-message=\"required\" \nng-if=\"changePasswordForm.Password.$touched\" class=\"help-block\"><span translate=\"merchant.user.validate.password\">\n</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': changePasswordForm.ConfirmPassword.$invalid && changePasswordForm.ConfirmPassword.$touched}\">\n<label class=\"control-label col-md-4 required\" translate=\"common.confirm_password\"></label><div class=\"col-md-8\"><input\n type=\"password\" name=\"ConfirmPassword\" class=\"form-control\" ng-model=\"vm.changePasswordModel.ConfirmPassword\" \nng-pattern=\"{{vm.changePasswordModel.Password}}\" required><div ng-messages=\"changePasswordForm.ConfirmPassword.$error\">\n<div ng-message=\"required\" ng-if=\"changePasswordForm.ConfirmPassword.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.user.validate.password_confirm\"></span></div><div ng-message=\"pattern\" class=\"help-block\"><span \ntranslate=\"merchant.user.validate.password_confirm_not_match\"></span></div></div></div></div></div><div \nclass=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.viewConfig.ShowChangePasswordDialog = false\" \ntranslate=\"common.action.cancel\"></a> <button type=\"submit\" class=\"btn btn-primary\" translate=\"common.action.save\">\n</button></div></form></div></div></div></div></div>");
$templateCache.put("app/report/bonus/credit-report.html","<div id=\"divCreditReport\"><h1 class=\"page-header\" translate=\"report.names.bonus_credit_report\"></h1><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">\n{{ \'report.credit_report.campaign_name\' | translate}}</label><input id=\"merchantName\" name=\"merchantName\" \nclass=\"form-control\" type=\"text\" ng-model=\"vm.serachModel.campaignName\"></div></div><div class=\"col-md-4\"><div \nclass=\"form-group\"><label class=\"control-label\">{{ \'report.credit_report.user_name\' | translate}}</label><input \nid=\"userName\" name=\"userName\" class=\"form-control\" type=\"text\" ng-model=\"vm.serachModel.userName\"></div></div><div \nclass=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">{{ \'report.credit_report.status\' | translate}}\n</label><select class=\"form-control\" ng-model=\"vm.serachModel.status\"><option ng-value=\"null\">\n{{ \'report.common.option_all\' | translate }}</option><option ng-repeat=\"v in vm.statusList\" ng-value=\"v.creditStatus\">\n{{v.displayText}}</option></select></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\"><div \nclass=\"form-group\"><label class=\"control-label required\" translate=\"report.common.transaction_start_date\"></label>\n<input type=\"text\" id=\"sdate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" \nng-click=\"vm.datePopup.StartOpen = true\" ng-model=\"vm.serachModel.beginTime\"></div></div><div class=\"col-md-6\"><div \nclass=\"form-group\"><label class=\"control-label required\" translate=\"report.common.transaction_end_date\"></label><input \ntype=\"text\" id=\"edate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" \nng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.serachModel.endTime\"></div></div></div><hr><div class=\"row\"><div \nclass=\"col-xs-12\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.searchReport()\" \ntranslate=\"report.summarize\"></button></div></div><div role=\"alert\" ng-show=\"vm.errorMsg\" class=\"alert alert-danger\">\n{{vm.errorMsg}}</div></div></div></div></div><div class=\"table-responsive\"><table datatable=\"\" \ndt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.dtInstance\"><thead><tr><th>\n{{ \'report.credit_report.campaign_name\' | translate}}</th><th>{{ \'report.credit_report.transactionDate\' | translate}}\n</th><th>{{ \'report.credit_report.user_name\' | translate }}</th><th>{{ \'report.credit_report.id_number\' | translate }}\n</th><th>{{ \'report.credit_report.ewallet_credit\' | translate }}</th><th>\n{{ \'report.credit_report.status\' | translate }}</th></tr></thead></table></div></div>");
$templateCache.put("app/report/bonus/peer-report.html","<div id=\"divCreditReport\"><h1 class=\"page-header\" translate=\"report.names.peer_to_peer_report\"></h1><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">\n{{ \'report.peer_report.request_Id\' | translate}}</label><input id=\"transactionId\" name=\"transactionId\" \nclass=\"form-control\" type=\"text\" ng-model=\"vm.searchModel.transactionId\"></div></div><div class=\"col-md-4\"><div \nclass=\"form-group\"><label class=\"control-label\">{{ \'report.peer_report.type\' | translate}}</label><select \nclass=\"form-control\" ng-model=\"vm.searchModel.transactionType\"><option ng-value=\"null\">\n{{ \'report.common.option_all\' | translate }}</option><option ng-repeat=\"v in vm.transactionType\" ng-value=\"v.Id\">\n{{v.displayText}}</option></select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label \nclass=\"control-label\">{{ \'report.peer_report.user_name\' | translate}}</label><input id=\"username\" name=\"username\" \nclass=\"form-control\" type=\"text\" ng-model=\"vm.searchModel.userName\"></div></div></div><hr><div class=\"row\"><div \nclass=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label required\" \ntranslate=\"report.common.transaction_start_date\"></label><input type=\"text\" id=\"sdate\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" \nng-model=\"vm.searchModel.beginTime\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label \nclass=\"control-label required\" translate=\"report.common.transaction_end_date\"></label><input type=\"text\" id=\"edate\" \nclass=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" \nng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.searchModel.endTime\"></div></div><div class=\"col-md-4\"><div \nclass=\"form-group\"><label class=\"control-label\">{{ \'report.peer_report.campaign_name\' | translate}}</label><input \nid=\"campaigname\" name=\"campaigname\" class=\"form-control\" type=\"text\" ng-model=\"vm.searchModel.campaignName\"></div>\n</div></div><hr><div class=\"row\"><div class=\"col-xs-12\"><button type=\"button\" class=\"btn btn-primary pull-right\" \nng-click=\"vm.searchReport()\" translate=\"report.summarize\"></button></div></div><div role=\"alert\" ng-show=\"vm.errorMsg\" \nclass=\"alert alert-danger\">{{vm.errorMsg}}</div></div></div></div></div><div class=\"table-responsive\"><table \ndatatable=\"\" dt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.dtInstance\"><thead><tr><th>\n{{ \'report.peer_report.request_Id\' | translate}}</th><th>{{ \'report.peer_report.requestdatetime\' | translate }}</th>\n<th>{{ \'report.peer_report.type\' | translate }}</th><th>{{ \'report.peer_report.username\' | translate }}</th><th>\n{{ \'report.peer_report.email\' | translate }}</th><th>{{ \'report.peer_report.mobilenumber\' | translate }}</th><th>\n{{ \'report.peer_report.paymenttype\' | translate }}</th><th>{{ \'report.peer_report.transactionamount\' | translate }}\n</th><th>{{ \'report.peer_report.status\' | translate }}</th><th>{{ \'report.peer_report.campaign_name\' | translate}}</th>\n<th>{{ \'report.peer_report.remarks\' | translate }}</th><th>{{ \'report.peer_report.recipent1\' | translate }}</th><th>\n{{ \'report.peer_report.amount1\' | translate }}</th><th>{{ \'report.peer_report.recipent2\' | translate }}</th><th>\n{{ \'report.peer_report.amount2\' | translate }}</th><th>{{ \'report.peer_report.recipent3\' | translate }}</th><th>\n{{ \'report.peer_report.amount3\' | translate }}</th><th>{{ \'report.peer_report.recipent4\' | translate }}</th><th>\n{{ \'report.peer_report.amount4\' | translate }}</th><th>{{ \'report.peer_report.recipent5\' | translate }}</th><th>\n{{ \'report.peer_report.amount5\' | translate }}</th><th>{{ \'report.peer_report.recipent6\' | translate }}</th><th>\n{{ \'report.peer_report.amount6\' | translate }}</th><th>{{ \'report.peer_report.recipent7\' | translate }}</th><th>\n{{ \'report.peer_report.amount7\' | translate }}</th><th>{{ \'report.peer_report.recipent8\' | translate }}</th><th>\n{{ \'report.peer_report.amount8\' | translate }}</th><th>{{ \'report.peer_report.recipent9\' | translate }}</th><th>\n{{ \'report.peer_report.amount9\' | translate }}</th><th>{{ \'report.peer_report.recipent10\' | translate }}</th><th>\n{{ \'report.peer_report.amount10\' | translate }}</th><th>{{ \'report.peer_report.recipent11\' | translate }}</th><th>\n{{ \'report.peer_report.amount11\' | translate }}</th><th>{{ \'report.peer_report.recipent12\' | translate }}</th><th>\n{{ \'report.peer_report.amount12\' | translate }}</th><th>{{ \'report.peer_report.recipent13\' | translate }}</th><th>\n{{ \'report.peer_report.amount13\' | translate }}</th><th>{{ \'report.peer_report.recipent14\' | translate }}</th><th>\n{{ \'report.peer_report.amount14\' | translate }}</th><th>{{ \'report.peer_report.recipent15\' | translate }}</th><th>\n{{ \'report.peer_report.amount15\' | translate }}</th><th>{{ \'report.peer_report.recipent16\' | translate }}</th><th>\n{{ \'report.peer_report.amount16\' | translate }}</th><th>{{ \'report.peer_report.recipent17\' | translate }}</th><th>\n{{ \'report.peer_report.amount17\' | translate }}</th><th>{{ \'report.peer_report.recipent18\' | translate }}</th><th>\n{{ \'report.peer_report.amount18\' | translate }}</th><th>{{ \'report.peer_report.recipent19\' | translate }}</th><th>\n{{ \'report.peer_report.amount19\' | translate }}</th><th>{{ \'report.peer_report.recipent20\' | translate }}</th><th>\n{{ \'report.peer_report.amount20\' | translate }}</th></tr></thead></table></div></div>");
$templateCache.put("app/report/generic/automation.detail.html","<h1 class=\"page-header\"><span>{{vm.pageHeader | translate}}</span></h1><div id=\"generic-repor-detail\" \nclass=\"col-md-12\"><div class=\"form-horizontal\"><form name=\"reportForm\" class=\"form-horizontal\" novalidate \nid=\"reportForm\"><div class=\"row\"><h3>Recipients and Email details</h3><br><div class=\"form-group col-md-12\" \nng-class=\"{\'has-error\': reportForm.Title.$invalid && reportForm.Title.$touched}\"><label class=\"col-md-12 required\" \ntranslate=\"report.generic_automation.title\"></label><div class=\"col-md-12\"><input type=\"text\" name=\"Title\" \nclass=\"form-control\" ng-model=\"vm.report.Name\" required><div ng-messages=\"reportForm.Title.$error\"><div \nng-message=\"required\" ng-if=\"reportForm.Title.$touched\" class=\"help-block\"><span>Report Name is required field.</span>\n</div></div></div></div><div class=\"form-group col-md-12\" \nng-class=\"{\'has-error\': reportForm.SendTo.$invalid && reportForm.SendTo.$touched}\"><label class=\"col-md-12 required\" \ntranslate=\"report.generic_automation.list_email\"></label><div class=\"col-md-12\"><input type=\"text\" name=\"SendTo\" \nclass=\"form-control\" ng-model=\"vm.report.SendTo\" required><div style=\"\">\neg : Recipients email address (tt@grr.la, t2,grr.la,......)</div><div ng-messages=\"reportForm.SendTo.$error\"><div \nng-message=\"required\" ng-if=\"reportForm.SendTo.$touched\" class=\"help-block\"><span>Send To is required field.</span>\n</div></div></div></div><div class=\"form-group col-md-12\" \nng-class=\"{\'has-error\': reportForm.Subject.$invalid && reportForm.Subject.$touched}\"><label class=\"col-md-12 required\" \ntranslate=\"report.generic_automation.subject\"></label><div class=\"col-md-12\"><input type=\"text\" name=\"Subject\" \nclass=\"form-control\" ng-model=\"vm.report.Subject\" required><div ng-messages=\"reportForm.Subject.$error\"><div \nng-message=\"required\" ng-if=\"reportForm.Subject.$touched\" class=\"help-block\"><span>Email Subject is required field.\n</span></div></div></div></div><div class=\"form-group col-md-12\" \nng-class=\"{\'has-error\': reportForm.Message.$invalid && reportForm.Message.$touched}\"><label class=\"col-md-12 required\" \ntranslate=\"report.generic_automation.message\"></label><div class=\"col-md-12\"><textarea required name=\"Message\" \nclass=\"form-control\" ng-model=\"vm.report.Message\"></textarea><div ng-messages=\"reportForm.Message.$error\"><div \nng-message=\"required\" ng-if=\"reportForm.Message.$touched\" class=\"help-block\"><span>Email Message is required field.\n</span></div></div></div></div></div><div class=\"row\"><h3>Reports</h3><br><div class=\"col-md-12\" \nng-repeat=\"GenericAutomationReportItem in vm.report.GenericAutomationReportItems track by $index\"><div \nclass=\"form-group\"><div class=\"form-group col-md-12\" \nng-class=\"{\'has-error\': reportForm[\'Name\'+$index].$invalid && reportForm[\'Name\'+$index].$touched}\"><label \nclass=\"col-md-2 required\" translate=\"report.generic_automation.name\"></label><div class=\"col-md-10\"><input type=\"text\" \ndisabled=\"disabled\" name=\"Name{{$index}}\" class=\"form-control\" ng-model=\"vm.report.Name\"></div></div><div \nclass=\"form-group col-md-12\" \nng-class=\"{\'has-error\': reportForm[\'Sql\'+$index].$invalid && reportForm[\'Sql\'+$index].$touched}\"><label \nclass=\"col-md-2 required\" translate=\"report.generic_automation.sql\"></label><div class=\"col-md-10\"><textarea \nname=\"Sql{{$index}}\" class=\"form-control\" ng-model=\"GenericAutomationReportItem.Sql\" rows=\"8\" required></textarea><div \nng-messages=\"reportForm[\'Sql\'+$index].$error\"><div ng-message=\"required\" ng-if=\"reportForm[\'Sql\'+$index].$touched\" \nclass=\"help-block\"><span>Query sql is required field.</span></div></div></div></div><div class=\"form-group col-md-12\">\n<div class=\"pull-right\"><a class=\"btn btn-danger\" ng-if=\"vm.report.GenericAutomationReportItem.length != 1\" \nng-click=\"vm.removeOption($index)\"><i class=\"glyphicon glyphicon-remove\"></i></a> <button type=\"button\" \nstyle=\"margin-right: 15px\" ng-click=\"vm.executesql(GenericAutomationReportItem)\" class=\"btn btn-default\">Test SQL\n</button></div></div></div></div><div class=\"form-group col-md-12\"><div class=\"pull-right\"><button type=\"button\" \nstyle=\"margin-right: 15px\" ng-click=\"vm.addreportOption()\" class=\"btn btn-success\">Add New</button></div></div></div>\n<div class=\"row\"><h3>Schedule Reports</h3><br><div class=\"col-md-12\"><div class=\"form-group interval col-md-12\"><label \nclass=\"control-label col-md-2 ng-scope\">Interval :</label><div class=\"btn-group col-md-10\"><label \nclass=\"btn btn-default {{vm.activedaily}}\" ng-click=\"vm.Daily()\" ng-model=\"vm.report.Interval\" uib-btn-radio=\"0\">Daily\n</label><label class=\"btn btn-default {{vm.activeweekly}}\" ng-click=\"vm.Weekly()\" ng-model=\"vm.report.Interval\" \nuib-btn-radio=\"1\">Weekly</label><label class=\"btn btn-default {{vm.activemonthly}}\" ng-click=\"vm.Monthly()\" \nng-model=\"vm.report.Interval\" uib-btn-radio=\"2\">Monthly</label></div></div><div class=\"form-group col-md-12\"><label \nclass=\"control-label col-md-2 ng-scope\">Send At * :</label><div class=\"col-md-10\" style=\"margin-top: 5px\"><div \nclass=\"row\"><div class=\"control col-md-4\" \nng-class=\"{\'has-error\': reportForm.time.$invalid && reportForm.time.$touched}\"><input required id=\"time\" \nclass=\"form-control\" placeholder=\"Time\" type=\"time\" name=\"time\" ng-model=\"vm.time\"><div \nng-messages=\"reportForm.time.$error\"><div ng-message=\"required\" ng-if=\"reportForm.time.$touched\" class=\"help-block\">\n<span>Send at is required field.</span></div></div></div></div></div></div><div ng-show=\"vm.openDay == true\" \nclass=\"form-group dayofweek col-md-12\"><label class=\"control-label col-md-2 ng-scope\">Time send Email :</label><div \nclass=\"btn-group col-md-10\"><label class=\"btn btn-default {{vm.activemon}}\" ng-model=\"vm.check.Mon\" \nng-click=\"vm.Mon()\" uib-btn-checkbox=\"2\">Mon</label><label class=\"btn btn-default {{vm.activetue}}\" \nng-model=\"vm.check.Tue\" ng-click=\"vm.Tue()\" uib-btn-checkbox=\"3\">Tue</label><label \nclass=\"btn btn-default {{vm.activewed}}\" ng-model=\"vm.check.Wed\" ng-click=\"vm.Wed()\" uib-btn-checkbox=\"4\">Wed</label>\n<label class=\"btn btn-default {{vm.activethu}}\" ng-model=\"vm.check.Thu\" ng-click=\"vm.Thu()\" uib-btn-checkbox=\"5\">Thu\n</label><label class=\"btn btn-default {{vm.activefri}}\" ng-model=\"vm.check.Fri\" ng-click=\"vm.Fri()\" \nuib-btn-checkbox=\"6\">Fri</label><label class=\"btn btn-default {{vm.activesat}}\" ng-model=\"vm.check.Sat\" \nng-click=\"vm.Sat()\" uib-btn-checkbox=\"7\">Sat</label><label class=\"btn btn-default {{vm.activesun}}\" \nng-model=\"vm.check.Sun\" ng-click=\"vm.Sun()\" uib-btn-checkbox=\"8\">Sun</label></div></div><div \nng-show=\"vm.openDay == false\" class=\"form-group dayofweek col-md-12\"><label class=\"control-label col-md-2 ng-scope\">\nTime send Email :</label><div class=\"btn-group col-md-10\"><label class=\"btn btn-default {{vm.activefirst}}\" \nng-model=\"vm.check.First\" ng-click=\"vm.First()\" uib-btn-checkbox=\"9\">First Of Month</label><label \nclass=\"btn btn-default {{vm.activelast}}\" ng-model=\"vm.check.Last\" ng-click=\"vm.Last()\" uib-btn-checkbox=\"10\">\nLast Of Month</label><label class=\"btn btn-default {{vm.activespecific}}\" ng-model=\"vm.check.Specific\" \nng-click=\"vm.Specific()\" uib-btn-checkbox=\"11\">Specific Day</label><div class=\"btn-group\" ng-show=\"vm.activespecific\">\n<button type=\"button\" class=\"btn btn-default dropdown-toggle dayofmonth\" data-toggle=\"dropdown\">{{vm.day}} <span \nclass=\"caret\"></span></button><ul class=\"dropdown-menu scrollable-menu\"><li><a \nng-click=\"vm.ChooseDay(daynumber.Value)\" ng-repeat=\"daynumber in vm.specificdays\">{{daynumber.Name}} </a></li></ul>\n</div></div></div></div></div></form><br><div><a ui-sref=\"app.reports.genericautomation\" style=\"margin-bottom:60px\" \nclass=\"btn btn-danger\" translate=\"common.action.cancel\"></a> <button style=\"margin:0 5px\" type=\"button\" \nng-click=\"vm.save()\" class=\"btn btn-primary pull-right\" translate=\"common.action.save\"></button> <button \nstyle=\"margin:0 5px\" type=\"button\" ng-click=\"vm.checkinput()\" class=\"btn btn-info pull-right\">Send me a test report\n</button></div></div><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowDialog\" \nclass=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-md\"><div \nclass=\"modal-content my-content\"><form name=\"sqlresultForm\" class=\"form-horizontal\" novalidate id=\"sqlresultForm\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowDialog = false\"><span \naria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" \nid=\"modal-title\">SQL Result</h3></div><div class=\"modal-body\"><table \nclass=\"table table-striped table-bordered table-fit\"><thead><tr><th style=\"width:auto\" \nng-if=\"vm.sqlheader != \'Error,\'\" ng-repeat=\"sqlheader in vm.sqlheader track by $index\">{{sqlheader}}</th><th \nng-if=\"vm.rows == \'NotRun\'\">The query is invalid.</th><th ng-if=\"vm.rows == \'Empty\'\">The report has no data.</th></tr>\n</thead><tbody><tr style=\"width:auto\" ng-if=\"vm.sqlheader != \'Error,\'\" ng-repeat=\"row in vm.rows track by $index\"><td \nng-repeat=\"col in row track by $index\">{{col}}</td></tr></tbody></table></div><div class=\"modal-footer\"><a \nclass=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a></div></form></div></div></div>\n</div><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowDialogTest\" class=\"modal fade\" \ntabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><form \nname=\"testsendmailForm\" class=\"form-horizontal\" novalidate><div class=\"modal-header\"><button type=\"button\" \nclass=\"close\" ng-click=\"vm.viewConfig.ShowDialogTest = false\"><span aria-hidden=\"true\">&times;</span><span \nclass=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\">Test Send Mail</h3></div><div \nclass=\"modal-body\"><div class=\"form-group\" \nng-class=\"{\'has-error\': testsendmailForm.EmailTest.$invalid && testsendmailForm.EmailTest.$touched}\"><label \nclass=\"control-label col-md-3 required\">Email</label><div class=\"col-md-8\"><input name=\"EmailTest\" type=\"text\" \nclass=\"form-control\" ng-model=\"vm.test.EmailTest\" required><div ng-messages=\"testsendmailForm.EmailTest.$error\"><div \nng-message=\"required\" ng-if=\"testsendmailForm.EmailTest.$touched\" class=\"help-block\"><span>Email is required field.\n</span></div></div></div></div></div><div class=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.cancel()\" \ntranslate=\"common.action.cancel\"></a> <button type=\"button\" ng-click=\"vm.sendmail()\" \nclass=\"btn btn-primary pull-right\">Send</button></div></form></div></div></div></div></div>");
$templateCache.put("app/report/generic/automation.html","<h1 class=\"page-header\">Generic Automation Report</h1><div id=\"generic-repor\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3\"><input type=\"text\" \nclass=\"form-control\" ng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"Enter the report\'s name\"></div><div class=\"col-md-1\"><a class=\"btn btn-primary pull-right margin-tl\" \nng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span>Reset</span></a></div><div \nng-class=\"{\'col-md-8\': !vm.isAdmin, \'col-md-2\': vm.isAdmin}\" show-permissions=\"[\'CREATE_GENERIC_REPORT\']\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ui-sref=\"app.reports.genericautomation.create\"><i \nclass=\"glyphicon glyphicon-plus\"></i><span>Add</span></a></div></div></div><div class=\"table-responsive form-group\">\n<table class=\"table table-striped table-bordered\"><thead><tr><th width=\"5%\">#</th><th width=\"10%\">ScheduleAt</th><th \nwidth=\"10%\">Repeat</th><th width=\"20%\">Name</th><th width=\"20%\">Send To</th><th width=\"10%\">Last Trigger</th><th \nwidth=\"25%\">Action</th></tr></thead><tbody><tr ng-repeat=\"report in vm.reports\"><td class=\"center\">{{$index + 1}}</td>\n<td>{{report.ScheduleAt | date: \'MM-dd-yyyy HH:mm:ss\'}}</td><td>{{report.RepeatToInterval}}</td><td>{{report.Name}}\n</td><td>{{report.SendTo}}</td><td>{{report.LastTrigger}}</td><td class=\"center\"><a title=\"Edit report\" \nclass=\"btn btn-default\" show-permissions=\"[\'EDIT_GENERIC_REPORT\']\" \nui-sref=\"app.reports.genericautomation.edit({id:report.Id})\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a \ntitle=\"Resume\" ng-if=\"report.Status == \'InActive\'\" class=\"btn btn-success\" ng-click=\"vm.active(report)\"><i \nclass=\"fa fa-play\"></i></a> <a title=\"Pause\" ng-if=\"report.Status == \'Active\'\" class=\"btn btn-warning\" \nng-click=\"vm.inactive(report)\"><i class=\"fa fa-pause\"></i></a> <a title=\"Delete\" class=\"btn btn-danger\" \nng-click=\"vm.delete(report)\"><i class=\"fa fa-trash\"></i></a></td></tr></tbody></table></div><ul uib-pagination \ntotal-items=\"vm.totalItems\" ng-change=\"vm.search()\" ng-model=\"vm.currentPage\" items-per-page=\"vm.criteria.Length\" \nmax-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div>");
$templateCache.put("app/report/external/insurance-report.html","<div id=\"statement_of_account_report\"><h1 class=\"page-header\" translate=\"report.names.Insurance_Report\"></h1><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label required\" translate=\"report.common.transaction_start_date\">Transaction Start Date</label><input \ntype=\"text\" id=\"sdate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" \nng-click=\"vm.datePopup.StartOpen = true\" ng-model=\"vm.filter.TransactionStartDate\" max-date=\"::vm.maxDate\" \ndatepicker-options=\"vm.dateOptions\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label required\" translate=\"report.common.transaction_end_date\">Transaction End Date</label><input \ntype=\"text\" id=\"edate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" \nng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.filter.TransactionEndDate\" max-date=\"::vm.maxDate\" \ndatepicker-options=\"vm.dateOptions\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\">\n<label class=\"control-label\" translate=\"report.Insurance_report.Employer\">Employer</label><input type=\"text\" \nclass=\"form-control\" ng-model=\"vm.filter.Employer\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.Insurance_report.Issuer\">Issuer</label><select class=\"form-control\" \nng-model=\"vm.filter.InsuranceProvider\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option>\n<option ng-repeat=\"v in vm.InsuranceProvider\" ng-value=\"v.Id\">{{v.Name}}</option></select></div></div><div \nclass=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"report.Insurance_report.Status\">\nTransaction Type</label><select class=\"form-control\" ng-model=\"vm.filter.TransactionAction\"><option ng-value=\"null\">\n{{ \'report.common.option_all\' | translate }}</option><option ng-repeat=\"v in vm.actionOptions\" ng-value=\"v.Id\">\n{{v.Name}}</option></select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.Insurance_report.InsuranceType\">Receive Money Method</label><select class=\"form-control\" \nng-model=\"vm.filter.InsuranceType\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option><option\n ng-repeat=\"v in vm.InsuranceType\" ng-value=\"v.Id\">{{v.Name}}</option></select></div></div><div class=\"col-md-6\"><div \nclass=\"form-group\"><label class=\"control-label\" translate=\"report.partner\"></label><select class=\"form-control\" \nng-model=\"vm.filter.Partner\"><option value=\"\">{{ \'report.common.option_all\' | translate }}</option><option \nng-repeat=\"type in vm.appTypes\" value=\"{{ type }}\">{{ type }}</option></select></div></div></div><div class=\"row\"><div \nclass=\"col-xs-12\"><div class=\"form-group\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.getReport()\">\nSearch</button> <a class=\"btn btn-primary\" ng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span \ntranslate=\"common.action.reset\"></span></a></div></div></div></div></div></div></div></div><div \nclass=\"table-responsive\"><table datatable dt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.tableInstance\"><thead><tr><th>\n{{ \'report.Insurance_report.CreationDate\' | translate}}</th><th>\n{{ \'report.Insurance_report.TransactionId\' | translate}}</th><th>{{ \'report.Insurance_report.UserName\' | translate}}\n</th><th>{{ \'report.Insurance_report.FullName\' | translate}}</th><th>{{ \'report.Insurance_report.IDType\' | translate}}\n</th><th>{{ \'report.Insurance_report.NoPlate\' | translate}}</th><th>\n{{ \'report.Insurance_report.PostCode\' | translate }}</th><th>{{ \'report.Insurance_report.InsuranceType\' | translate }}\n</th><th>{{ \'report.Insurance_report.VehicleCoverType\' | translate }}</th><th>\n{{ \'report.Insurance_report.AddOn\' | translate }}</th><th>{{ \'report.Insurance_report.SumInsured\' | translate }}</th>\n<th>{{ \'report.Insurance_report.Amount\' | translate }}</th><th>{{ \'report.Insurance_report.SST\' | translate }}</th><th>\n{{ \'report.Insurance_report.Status\' | translate }}</th><th>{{ \'report.Insurance_report.Partner\' | translate}}</th><th>\n{{ \'report.Insurance_report.Issuer\' | translate }}</th><th>{{ \'report.Insurance_report.Employer\' | translate }}</th>\n</tr></thead></table></div>");
$templateCache.put("app/report/external/remittance-report.html","<div id=\"statement_of_account_report\"><h1 class=\"page-header\" translate=\"report.names.remittance_report\"></h1><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.remittance_report.UserName\">Username</label><input type=\"text\" class=\"form-control\" \nng-model=\"vm.filter.UserName\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.remittance_report.MTCN\">MTCN number</label><input type=\"text\" class=\"form-control\" \nng-model=\"vm.filter.MTCN\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.remittance_report.RemittanceType\">Remittance Type</label><select class=\"form-control\" \nng-model=\"vm.filter.RemittanceType\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option>\n<option ng-repeat=\"v in vm.RemittanceType\" ng-value=\"v.Id\">{{v.Name}}</option></select></div></div><div \nclass=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.remittance_report.transaction_type\">Transaction Type</label><select class=\"form-control\" \nng-model=\"vm.filter.TransactionAction\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option>\n<option ng-repeat=\"v in vm.actionOptions\" ng-value=\"v.Id\">{{v.Name}}</option></select></div></div><div \nclass=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.remittance_report.ReceiveMoneyMethod\">Receive Money Method</label><select class=\"form-control\" \nng-model=\"vm.filter.ReceiveMoneyMethods\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option>\n<option ng-repeat=\"v in vm.ReceiveMoneyOptions\" ng-value=\"v.Id\">{{v.Name}}</option></select></div></div><div \nclass=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"report.partner\"></label><select \nclass=\"form-control\" ng-model=\"vm.filter.Partner\"><option value=\"\">{{ \'report.common.option_all\' | translate }}\n</option><option ng-repeat=\"type in vm.appTypes\" value=\"{{ type }}\">{{ type }}</option></select></div></div></div><div \nclass=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label required\" \ntranslate=\"report.common.transaction_start_date\">Transaction Start Date</label><input type=\"text\" id=\"sdate\" \nclass=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" \nng-click=\"vm.datePopup.StartOpen = true\" ng-model=\"vm.filter.TransactionStartDate\"></div></div><div class=\"col-md-6\">\n<div class=\"form-group\"><label class=\"control-label required\" translate=\"report.common.transaction_end_date\">\nTransaction End Date</label><input type=\"text\" id=\"edate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" \nis-open=\"vm.datePopup.EndOpen\" ng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.filter.TransactionEndDate\"></div>\n</div></div><div class=\"row\"><div class=\"col-xs-12\"><button type=\"button\" class=\"btn btn-primary pull-right\" \nng-click=\"vm.getReport()\" translate=\"report.summarize\"></button></div></div></div></div></div></div></div><div \nclass=\"table-responsive\"><table datatable dt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.tableInstance\"><thead><tr><th>\n{{ \'report.remittance_report.UserID\' | translate}}</th><th>{{ \'report.remittance_report.TransactionId\' | translate}}\n</th><th>{{ \'report.remittance_report.UserName\' | translate}}</th><th>\n{{ \'report.remittance_report.SenderName\' | translate}}</th><th>{{ \'report.remittance_report.ReceiverName\' | translate}}\n</th><th>{{ \'report.remittance_report.Status\' | translate}}</th><th>{{ \'report.remittance_report.MTCN\' | translate }}\n</th><th>{{ \'report.remittance_report.RemittanceType\' | translate }}</th><th>\n{{ \'report.remittance_report.TransactionSentDate\' | translate }}</th><th>\n{{ \'report.remittance_report.TransactionPaidDate\' | translate }}</th><th>\n{{ \'report.remittance_report.TransactionAmount\' | translate }}</th><th>\n{{ \'report.remittance_report.TransactionToCountry\' | translate }}</th><th>\n{{ \'report.remittance_report.TransactionFromCountry\' | translate }}</th><th>\n{{ \'report.remittance_report.SentCharge\' | translate }}</th><th>\n{{ \'report.remittance_report.RecevingMethod\' | translate}}</th><th>{{ \'report.remittance_report.Reason\' | translate}}\n</th><th>{{ \'report.remittance_report.Relation\' | translate}}</th><th>\n{{ \'report.remittance_report.EWagesEmployer\' | translate}}</th><th>{{ \'report.remittance_report.Partner\' | translate}}\n</th></tr></thead></table></div>");
$templateCache.put("app/report/external/transactions.html","<div class=\"alert alert-warning alert-dismissable\" ng-if=\"vm.error\"><a href=\"#\" class=\"close\" data-dismiss=\"alert\" \naria-label=\"close\">&times;</a> <strong>Warning!</strong> {{vm.error}}</div><h1 class=\"page-header\">\nExternal Transaction Report</h1><div id=\"external-transaction-report\" class=\"col-md-12\"><div class=\"form-horizontal\">\n<div class=\"form-group\"><div class=\"row\"><div class=\"col-md-4\"><select class=\"form-control\" \nng-model=\"vm.filter.MasterMerchantId\" ng-change=\"vm.search()\"><option value=\"\">Choose master merchant</option><option \nng-repeat=\"masterMerchant in vm.masterMerchants\" value=\"{{masterMerchant.Id}}\">{{masterMerchant.Name}}</option>\n</select></div></div></div><div class=\"form-group\"><div class=\"table-responsive\"><table \nclass=\"table table-striped table-bordered\"><thead thead-order=\"vm.sort($sortOpts)\"><tr><th width=\"5%\">#</th><th \nwidth=\"15%\">Date</th><th width=\"20%\">Action</th><th width=\"20%\">Webcash Store ID</th><th width=\"20%\">Service ID</th><th\n width=\"20%\">Amount</th></tr></thead><tbody><tr ng-repeat=\"transaction in vm.transactions\"><td class=\"center\">\n{{$index + 1}}</td><td>{{transaction.Date | date: \'MM-dd-yyyy HH:mm:ss\'}}</td><td>{{transaction.Action}}</td><td>\n{{transaction.WebCashMerchantId}}</td><td>{{transaction.ServiceId}}</td><td>{{transaction.Amount}}</td></tr></tbody>\n</table></div><ul uib-pagination total-items=\"vm.totalItems\" ng-change=\"vm.search()\" ng-model=\"vm.currentPage\" \nmax-size=\"vm.maxSize\" items-per-page=\"vm.itemsPerPage\" class=\"pagination-sm\" boundary-link-numbers=\"true\" \nrotate=\"false\"></ul></div></div></div>");
$templateCache.put("app/report/kiplemart/trans-report.html","<div id=\"divCreditReport\"><h1 class=\"page-header\" translate=\"report.names.kiplemart_trans_report\"></h1><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\">\nTransaction ID</label><input id=\"transactionId\" name=\"transactionId\" class=\"form-control\" type=\"text\" \nng-model=\"vm.serachCriteria.transactionId\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\">Merchant Ref No</label><input id=\"merchantRefNo\" name=\"merchantRefNo\" class=\"form-control\" \ntype=\"text\" ng-model=\"vm.serachCriteria.merchantRefNo\"></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\">\n<div class=\"form-group\"><label class=\"control-label\">Merchant Name</label><ui-select \nng-model=\"vm.serachCriteria.merchantId\" theme=\"bootstrap\"><ui-select-match placeholder=\"Enter the merchant\'s name\">\n{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh=\"vm.loadMerchant($select.search)\" \nrefresh-delay=\"0\" minimum-input-length=\"0\"><div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\">Payment Status</label><select class=\"form-control\" ng-model=\"vm.serachCriteria.paymentStatus\">\n<option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option><option ng-repeat=\"v in vm.statusList\" \nng-value=\"v.paymentStatus\">{{v.displayText}}</option></select></div></div></div><hr><div class=\"row\"><div \nclass=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"report.common.transaction_start_date\">\n</label><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" \nng-click=\"vm.datePopup.StartOpen = true\" ng-model=\"vm.serachCriteria.beginTime\"></div></div><div class=\"col-md-6\"><div \nclass=\"form-group\"><label class=\"control-label\" translate=\"report.common.transaction_end_date\"></label><input \ntype=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" \nng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.serachCriteria.endTime\"></div></div></div><hr><div class=\"row\"><div\n class=\"col-xs-12\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.searchReport()\">Search\n</button></div></div><div role=\"alert\" ng-show=\"vm.errorMsg\" class=\"alert alert-danger\">{{vm.errorMsg}}</div></div>\n</div></div></div><div class=\"table-responsive\"><table datatable=\"\" dt-options=\"vm.dataTable.options\" \ndt-columns=\"vm.dataTable.columns\" class=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.dtInstance\">\n<thead><tr><th>Trx ID</th><th>Transaction Date/time</th><th>User ID</th><th>Merchant Ref No</th><th>Merchant Name</th>\n<th>Amount (MYR)</th><th>Shipping Fee (MYR)</th><th>Discount (MYR)</th><th>Voucher ID</th><th>Payment Type</th><th>\nPayment Status</th><th>Refund (Yes/No)</th><th>Channel</th></tr></thead></table></div></div>");
$templateCache.put("app/report/merchant/community-report.html","<div id=\"divCommunityReport\"><h1 class=\"page-header\" translate=\"report.names.community_report\"></h1><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-4\"><div class=\"form-group\"><label \nclass=\"control-label\">{{ \'report.community_report.user_name\' | translate}}</label><input id=\"userName\" name=\"userName\" \nclass=\"form-control\" type=\"text\" ng-model=\"vm.searchModel.username\"></div></div><div class=\"col-md-4\"><div \nclass=\"form-group\"><label class=\"control-label\">{{ \'report.community_report.community_category\' | translate}}</label>\n<select id=\"category\" class=\"form-control\" ng-model=\"vm.searchModel.category\"><option ng-value=\"null\">\n{{ \'report.common.option_all\' | translate }}</option><option ng-repeat=\"v in vm.CommunityList\" ng-value=\"v.Id\">\n{{v.Name}}</option></select></div></div></div><div class=\"row\"><div class=\"col-md-2\"></div><div class=\"col-md-4\"><div \nclass=\"form-group\"><label class=\"control-label required\" translate=\"report.common.transaction_start_date\">\nTransaction Start Date</label><input type=\"text\" id=\"sdate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" \nis-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" \nng-model=\"vm.searchModel.TransactionStartDate\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label \nclass=\"control-label required\" translate=\"report.common.transaction_end_date\">Transaction End Date</label><input \ntype=\"text\" id=\"edate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" \nng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.searchModel.TransactionEndDate\"></div></div></div><div class=\"row\">\n<div class=\"col-xs-10\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.searchReport()\" \ntranslate=\"report.summarize\"></button></div></div><div role=\"alert\" ng-show=\"vm.errorMsg\" class=\"alert alert-danger\">\n{{vm.errorMsg}}</div></div></div></div></div><div class=\"table-responsive\"><table datatable \ndt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.dtInstance\"><thead><tr><th>\n{{ \'report.community_report.createDateTime\' | translate}}</th><th>{{ \'report.community_report.webcashid\' | translate}}\n</th><th>{{ \'report.community_report.user_name\' | translate }}</th><th>{{ \'report.community_report.Id\' | translate }}\n</th><th>{{ \'report.community_report.community_category\' | translate }}</th><th>\n{{ \'report.community_report.community_partner\' | translate }}</th><th>\n{{ \'report.community_report.verifiedBy\' | translate }}</th><th>{{ \'report.community_report.community_id\' | translate }}\n</th><th>{{ \'report.community_report.user_category\' | translate }}</th><th>\n{{ \'report.community_report.community_status\' | translate }}</th><th>\n{{ \'report.community_report.remarks\' | translate }}</th></tr></thead></table></div></div>");
$templateCache.put("app/report/merchant/exception-transactions.html","<div id=\"exception_transactions_report\"><h1 class=\"page-header\" translate=\"report.names.exception_transactions_report\">\n</h1><div class=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.common.transaction_start_date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" \nng-model=\"vm.filter.TransactionStartDate\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.common.transaction_end_date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" ng-click=\"vm.datePopup.EndOpen = true\" \nng-model=\"vm.filter.TransactionEndDate\"></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button \ntype=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.getReport()\" translate=\"report.summarize\"></button></div>\n</div></div></div></div></div><div class=\"table-responsive\"><table datatable dt-options=\"vm.dataTable.options\" \ndt-columns=\"vm.dataTable.columns\" class=\"table table-bordered table-striped table-hover\" \ndt-instance=\"vm.tableInstance\"><thead><tr><th>{{ \'report.exception_transactions.transaction_date_time\' | translate}}\n</th><th>{{ \'report.exception_transactions.merchant_name\' | translate }}</th><th>\n{{ \'report.exception_transactions.gross_amount\' | translate }}</th><th>\n{{ \'report.exception_transactions.deduction_mdr\' | translate }}</th><th>\n{{ \'report.exception_transactions.deduction_gst\' | translate }}</th><th>\n{{ \'report.exception_transactions.settlement_to_merchant\' | translate }}</th><th>\n{{ \'report.exception_transactions.user_id\' | translate }}</th><th>\n{{ \'report.exception_transactions.outlet_id\' | translate }}</th></tr></thead></table></div></div>");
$templateCache.put("app/report/merchant/merchant-gap.html","<div id=\"merchant_gap_report\"><h1 class=\"page-header\" translate=\"report.names.merchant_gap_report\"></h1><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-6 col-md-offset-3\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.merchant_gap.merchant_status\"></label><select class=\"form-control\" \nng-model=\"vm.filter.MerchantStatus\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option>\n<option ng-repeat=\"v in vm.merchantStatus\" ng-value=\"v.value\">{{v.display| translate}}</option></select></div></div>\n</div><div class=\"row\"><div class=\"col-md-6 col-md-offset-3\"><button type=\"button\" class=\"btn btn-primary pull-right\" \nng-click=\"vm.getReport()\" translate=\"report.summarize\"></button></div></div></div></div></div></div><div \nclass=\"table-responsive\"><table datatable dt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.tableInstance\"><thead><tr><th>\n{{ \'report.merchant_gap.merchant_name\' | translate}}</th><th>{{ \'report.merchant_gap.total_voucher\' | translate }}</th>\n<th>{{ \'report.merchant_gap.active_voucher\' | translate }}</th><th>\n{{ \'report.merchant_gap.total_purchased_voucher\' | translate }}</th><th>\n{{ \'report.merchant_gap.total_redeemed_voucher\' | translate }}</th><th>{{ \'report.merchant_gap.status\' | translate }}\n</th></tr></thead></table></div></div>");
$templateCache.put("app/report/merchant/merchant-terminals.html","<div id=\"store_list_report\"><h1 class=\"page-header\" translate=\"report.names.merchant_terminal_report\"></h1><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"form-group\"><label class=\"control-label\" translate=\"report.merchant_terminal.merchant\">\n</label><select class=\"form-control\" ng-model=\"vm.filter.MerchantId\"><option ng-value=\"null\">\n{{ \'report.common.option_all\' | translate }}</option><option ng-value=\"merchant.Id\" \nng-repeat=\"merchant in vm.merchants\">{{merchant.Name}}</option></select></div><div class=\"row\"><div class=\"col-xs-12\">\n<button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.getReport()\" translate=\"report.summarize\">\n</button></div></div></div></div></div></div><div class=\"table-responsive\"><table datatable \ndt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.tableInstance\"><thead><tr><th>\n{{ \'report.merchant_terminal.terminal_id\' | translate}}</th><th>{{ \'report.merchant_terminal.store_name\' | translate }}\n</th><th>{{ \'report.merchant_terminal.store_address\' | translate }}</th><th>\n{{ \'report.merchant_terminal.contact_number\' | translate }}</th><th>\n{{ \'report.merchant_terminal.mobile_number\' | translate }}</th><th>\n{{ \'report.merchant_terminal.last_activity_date_time\' | translate }}</th><th>\n{{ \'report.merchant_terminal.last_transaction_date_time\' | translate }}</th><th>\n{{ \'report.merchant_terminal.pos_version\' | translate }}</th></tr></thead></table></div></div>");
$templateCache.put("app/report/merchant/merchants-list.html","<div id=\"merchants_list_report\"><h1 class=\"page-header\" translate=\"report.names.merchants_list_report\"></h1><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.merchants_list.merchant_name\"></label><input type=\"text\" class=\"form-control\" \nng-model=\"vm.filter.MerchantName\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.merchants_list.merchant_status\"></label><select class=\"form-control\" \nng-model=\"vm.filter.MerchantStatus\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option>\n<option ng-repeat=\"v in vm.merchantStatus\" ng-value=\"v.value\">{{v.display| translate}}</option></select></div></div>\n</div><div class=\"row\"><div class=\"col-xs-12\"><button type=\"button\" class=\"btn btn-primary pull-right\" \nng-click=\"vm.getReport()\" translate=\"report.summarize\"></button></div></div></div></div></div></div><div \nclass=\"table-responsive\"><table datatable dt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.tableInstance\"><thead><tr><th>\n{{ \'report.merchants_list.merchant_id\' | translate}}</th><th>{{ \'report.merchants_list.merchant_name\' | translate}}\n</th><th>{{ \'report.merchants_list.tags\' | translate }}</th><th>{{ \'report.merchants_list.contact_name\' | translate }}\n</th><th>{{ \'report.merchants_list.mobile_number\' | translate }}</th><th>\n{{ \'report.merchants_list.email_address\' | translate }}</th><th>{{ \'report.merchants_list.address\' | translate }}</th>\n<th>{{ \'report.merchants_list.contract_date\' | translate }}</th><th>\n{{ \'report.merchants_list.service_date\' | translate }}</th><th>{{ \'report.merchants_list.webcash_id\' | translate }}\n</th><th>{{ \'report.merchants_list.webcash_hash_key\' | translate }}</th><th>\n{{ \'report.merchants_list.status\' | translate }}</th></tr></thead></table></div></div>");
$templateCache.put("app/report/merchant/outlet-transactions.html","<div id=\"outlet_transactions\"><h1 class=\"page-header\" translate=\"report.names.outlet_transactions_report\"></h1><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"form-group\" ng-if=\"vm.showMerchantFilter\"><label class=\"control-label\" \ntranslate=\"report.statement_of_account.merchant\"></label><ui-select ng-model=\"vm.filter.MerchantId\" theme=\"bootstrap\">\n<ui-select-match placeholder=\"All\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh=\"vm.loadMerchant($select.search)\" \nrefresh-delay=\"0\" minimum-input-length=\"0\"><div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.statement_of_account.outlet\"></label><select class=\"form-control\" ng-model=\"vm.filter.StoreId\">\n<option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option><option ng-value=\"store.Id\" \nng-repeat=\"store in vm.stores[vm.filter.MerchantId]\">{{store.Name}}</option></select></div><div class=\"row\"><div \nclass=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.statement_of_account.transaction_id\"></label><input type=\"text\" class=\"form-control\" \nng-model=\"vm.filter.TransactionId\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.statement_of_account.transaction_type\"></label><select class=\"form-control\" \nng-model=\"vm.filter.TransactionAction\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option>\n<option ng-repeat=\"v in vm.actionOptions\" ng-value=\"v.value\">{{v.display| translate}}</option></select></div></div>\n</div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label required\" \ntranslate=\"report.common.transaction_start_date\"></label><input type=\"text\" id=\"sdate\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" \nng-model=\"vm.filter.TransactionStartDate\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label required\" translate=\"report.common.transaction_end_date\"></label><input type=\"text\" id=\"edate\" \nclass=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" \nng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.filter.TransactionEndDate\"></div></div></div><div class=\"row\"><div \nclass=\"col-xs-12\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.getReport()\" \ntranslate=\"report.summarize\"></button></div></div></div></div></div></div><div class=\"table-responsive\"><table \ndatatable dt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.tableInstance\"><thead><tr><th>\n{{ \'report.statement_of_account.transaction_id\' | translate}}</th><th>\n{{ \'report.statement_of_account.transaction_date_time\' | translate}}</th><th>\n{{ \'report.statement_of_account.merchant_name\' | translate }}</th><th>\n{{ \'report.statement_of_account.transaction_type\' | translate }}</th><th>\n{{ \'report.statement_of_account.gross_amount\' | translate }}</th><th>\n{{ \'report.statement_of_account.cashback\' | translate }}</th><th>\n{{ \'report.statement_of_account.remarks\' | translate }}</th><th>{{ \'report.statement_of_account.user_id\' | translate }}\n</th><th>{{ \'report.statement_of_account.outlet_code\' | translate }}</th></tr></thead></table></div></div>");
$templateCache.put("app/report/merchant/promotion-summary.html","<div id=\"voucher_summary_report\"><h1 class=\"page-header\" translate=\"report.names.promotion_summary_report\"></h1><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"form-group\" ng-if=\"vm.showMerchantFilter\"><label class=\"control-label\" \ntranslate=\"report.promotion_summary.merchant\"></label><select class=\"form-control\" ng-model=\"vm.filter.MerchantId\">\n<option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option><option ng-value=\"merchant.Id\" \nng-repeat=\"merchant in vm.merchants\">{{merchant.Name}}</option></select></div><div class=\"row\"><div class=\"col-md-6\">\n<div class=\"form-group\"><label class=\"control-label\" translate=\"report.promotion_summary.promotion_name\"></label><input\n type=\"text\" class=\"form-control\" ng-model=\"vm.filter.PromotionName\"></div></div><div class=\"col-md-6\"><div \nclass=\"form-group\"><label class=\"control-label\" translate=\"report.promotion_summary.promotion_status\"></label><select \nclass=\"form-control\" ng-model=\"vm.filter.PromotionStatus\"><option ng-value=\"null\">\n{{ \'report.common.option_all\' | translate }}</option><option ng-repeat=\"v in vm.promotionStatus\" ng-value=\"v.value\">\n{{v.display| translate}}</option></select></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button \ntype=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.getReport()\" translate=\"report.summarize\"></button></div>\n</div></div></div></div></div><div class=\"table-responsive\"><table datatable dt-options=\"vm.dataTable.options\" \ndt-columns=\"vm.dataTable.columns\" class=\"table table-bordered table-striped table-hover\" \ndt-instance=\"vm.tableInstance\"><thead><tr><th>{{ \'report.promotion_summary.promotion_id\' | translate}}</th><th>\n{{ \'report.promotion_summary.title\' | translate}}</th><th>{{ \'report.promotion_summary.merchant_name\' | translate }}\n</th><th>{{ \'report.promotion_summary.promotion_type\' | translate }}</th><th>\n{{ \'report.promotion_summary.is_multiuse\' | translate }}</th><th>\n{{ \'report.promotion_summary.original_price\' | translate }}</th><th>\n{{ \'report.promotion_summary.max_quantity\' | translate }}</th><th>\n{{ \'report.promotion_summary.grabbed_quantity\' | translate }}</th><th>\n{{ \'report.promotion_summary.redeemed_quantity\' | translate }}</th><th>\n{{ \'report.promotion_summary.sales_start_date\' | translate }}</th><th>\n{{ \'report.promotion_summary.sales_stop_date\' | translate }}</th><th>\n{{ \'report.promotion_summary.promotion_expiry_date\' | translate }}</th><th>\n{{ \'report.promotion_summary.status\' | translate }}</th></tr></thead></table></div></div>");
$templateCache.put("app/report/merchant/remittance-report.html","<div id=\"statement_of_account_report\"><h1 class=\"page-header\" translate=\"report.names.remittance_report\"></h1><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.remittance_report.UserName\"></label><input type=\"text\" class=\"form-control\" \nng-model=\"vm.filter.UserName\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.remittance_report.MTCN\"></label><input type=\"text\" class=\"form-control\" ng-model=\"vm.filter.MTCN\">\n</div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.remittance_report.RemittanceType\"></label><select class=\"form-control\" \nng-model=\"vm.filter.RemittanceType\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option>\n<option ng-repeat=\"v in vm.RemittanceType\" ng-value=\"v.value\">{{v.display| translate}}</option></select></div></div>\n<div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.remittance_report.transaction_type\"></label><select class=\"form-control\" \nng-model=\"vm.filter.TransactionAction\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option>\n<option ng-repeat=\"v in vm.actionOptions\" ng-value=\"v.value\">{{v.display| translate}}</option></select></div></div><div\n class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.remittance_report.ReceiveMoneyMethod\"></label><select class=\"form-control\" \nng-model=\"vm.filter.ReceiveMoneyMethods\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option>\n<option ng-repeat=\"v in vm.ReceiveMoneyOptions\" ng-value=\"v.value\">{{v.display| translate}}</option></select></div>\n</div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.common.transaction_start_date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" \nng-model=\"vm.filter.TransactionStartDate\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.common.transaction_end_date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" ng-click=\"vm.datePopup.EndOpen = true\" \nng-model=\"vm.filter.TransactionEndDate\"></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button \ntype=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.getReport()\" translate=\"report.summarize\"></button></div>\n</div></div></div></div></div></div><div class=\"table-responsive\"><table datatable dt-options=\"vm.dataTable.options\" \ndt-columns=\"vm.dataTable.columns\" class=\"table table-bordered table-striped table-hover\" \ndt-instance=\"vm.tableInstance\"><thead><tr><th>{{ \'report.remittance_report.UserID\' | translate}}</th><th>\n{{ \'report.remittance_report.UserName\' | translate}}</th><th>{{ \'report.remittance_report.Status\' | translate}}</th>\n<th>{{ \'report.remittance_report.MTCN\' | translate }}</th><th>\n{{ \'report.remittance_report.RemittanceType\' | translate }}</th><th>\n{{ \'report.remittance_report.TransactionSentDate\' | translate }}</th><th>\n{{ \'report.remittance_report.TransactionPaidDate\' | translate }}</th><th>\n{{ \'report.remittance_report.TransactionAmount\' | translate }}</th><th>\n{{ \'report.remittance_report.TransactionToCountry\' | translate }}</th><th>\n{{ \'report.remittance_report.TransactionFromCountry\' | translate }}</th><th>\n{{ \'report.remittance_report.SentCharge\' | translate }}</th></tr></thead></table></div>");
$templateCache.put("app/report/merchant/statement-of-account-redpay.html","<div id=\"statement_of_account_redpay_report\"><h1 class=\"page-header\" \ntranslate=\"report.names.statement_of_account_redpay_report\"></h1><div class=\"report-filter\"><div \nclass=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" data-target=\"#collapse_panel\"><span \nclass=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\"><i \nclass=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.statement_of_account_redpay.merchant\"></label><ui-select ng-model=\"vm.filter.MerchantId\" \ntheme=\"bootstrap\"><ui-select-match placeholder=\"All\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh=\"vm.loadMerchant($select.search)\" \nrefresh-delay=\"0\" minimum-input-length=\"0\"><div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.statement_of_account_redpay.transaction_id\"></label><input type=\"text\" \nclass=\"form-control\" ng-model=\"vm.filter.TransactionId\"></div></div><div class=\"col-md-6\"><div class=\"form-group\">\n<label class=\"control-label\" translate=\"report.statement_of_account_redpay.transaction_type\"></label><select \nclass=\"form-control\" ng-model=\"vm.filter.TransactionAction\"><option ng-value=\"null\">\n{{ \'report.common.option_all\' | translate }}</option><option ng-repeat=\"v in vm.actionOptions\" ng-value=\"v.value\">\n{{v.display| translate}}</option></select></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div \nclass=\"form-group\"><label class=\"control-label required\" translate=\"report.common.transaction_start_date\"></label>\n<input type=\"text\" id=\"sdate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" \nng-click=\"vm.datePopup.StartOpen = true\" ng-model=\"vm.filter.TransactionStartDate\"></div></div><div class=\"col-md-6\">\n<div class=\"form-group\"><label class=\"control-label required\" translate=\"report.common.transaction_end_date\"></label>\n<input type=\"text\" id=\"edate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" \nng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.filter.TransactionEndDate\"></div></div></div><div class=\"row\"><div \nclass=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"Payment Type\"></label><select \nclass=\"form-control\" id=\"type\" ng-model=\"vm.filter.PaymentChannel\"><option ng-value=\"null\">\n{{ \'report.common.option_all\' | translate }}</option><option ng-repeat=\"v in vm.PaymentChannel\" ng-value=\"v.value\">\n{{v.display| translate}}</option></select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"User Name\"></label><input type=\"text\" class=\"form-control\" \nng-model=\"vm.filter.UserName\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"Campaign Name\"></label><input type=\"text\" class=\"form-control\" \nng-model=\"vm.filter.CampaignName\"></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button type=\"button\" \nclass=\"btn btn-primary pull-right\" ng-click=\"vm.getReport()\" translate=\"report.summarize\"></button></div></div></div>\n</div></div></div></div><div class=\"table-responsive\"><table datatable dt-options=\"vm.dataTable.options\" \ndt-columns=\"vm.dataTable.columns\" class=\"table table-bordered table-striped table-hover\" \ndt-instance=\"vm.tableInstance\"><thead><tr><th>{{ \'report.statement_of_account_redpay.transaction_id\' | translate}}</th>\n<th>{{ \'report.statement_of_account_redpay.external_reference_id\' | translate}}</th><th>\n{{ \'report.statement_of_account_redpay.transaction_date_time\' | translate}}</th><th>\n{{ \'report.statement_of_account_redpay.merchant_name\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.transaction_type\' | translate }}</th><th>Payment Type</th><th>\n{{ \'report.statement_of_account_redpay.wallet_main\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.wallet_visa\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.wallet_zakat\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.wallet_meal_plan\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.wallet_saved_card\' | translate }}</th><th>\n{{ \'report.statement_of_account.gross_amount\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.voucher_id\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.Campaign_Name\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.Kiple_Subsidy\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.Merchant_Subsidy\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.deduction_mdr\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.deduction_gst\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.deduction_storecard_cashback\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.settlement_to_merchant\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.cashback\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.user_id\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.outlet_id\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.outlet_code\' | translate }}</th><th>\n{{ \'report.statement_of_account.username\' | translate }}</th><th>\n{{ \'report.statement_of_account.beforewalletbalance\' | translate }}</th><th>\n{{ \'report.statement_of_account.afterwalletbalance\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.Reward_OffSet_Amount\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.Reward_Offset_Percentage\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.Reward_Converstion_Rate\' | translate }}</th><th>\n{{ \'report.statement_of_account_redpay.Reward_OffSet_Points\' | translate }}</th><th>RewardLink Processing Fee</th><th>\nLDR Share Rate</th></tr></thead></table></div>");
$templateCache.put("app/report/merchant/statement-of-account.html","<div id=\"statement_of_account_report\"><h1 class=\"page-header\" translate=\"report.names.statement_of_account_report\">\n</h1><div class=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"form-group\" ng-if=\"vm.showMerchantFilter\"><label class=\"control-label\" \ntranslate=\"report.statement_of_account.merchant\"></label><ui-select ng-model=\"vm.filter.MerchantId\" theme=\"bootstrap\">\n<ui-select-match placeholder=\"All\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh=\"vm.loadMerchant($select.search)\" \nrefresh-delay=\"0\" minimum-input-length=\"0\"><div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.statement_of_account.transaction_id\"></label><input type=\"text\" \nclass=\"form-control\" ng-model=\"vm.filter.TransactionId\"></div></div><div class=\"col-md-6\"><div class=\"form-group\">\n<label class=\"control-label\" translate=\"report.statement_of_account.transaction_type\"></label><select \nclass=\"form-control\" ng-model=\"vm.filter.TransactionAction\"><option ng-value=\"null\">\n{{ \'report.common.option_all\' | translate }}</option><option ng-repeat=\"v in vm.actionOptions\" ng-value=\"v.value\">\n{{v.display| translate}}</option></select></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div \nclass=\"form-group\"><label class=\"control-label required\" translate=\"report.common.transaction_start_date\"></label>\n<input type=\"text\" id=\"sdate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" \nng-click=\"vm.datePopup.StartOpen = true\" ng-model=\"vm.filter.TransactionStartDate\"></div></div><div class=\"col-md-6\">\n<div class=\"form-group\"><label class=\"control-label required\" translate=\"report.common.transaction_end_date\"></label>\n<input type=\"text\" id=\"edate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" \nng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.filter.TransactionEndDate\"></div></div></div><div class=\"row\"><div \nclass=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"Payment Type\"></label><select \nclass=\"form-control\" id=\"type\" ng-model=\"vm.filter.PaymentChannel\"><option ng-value=\"null\">\n{{ \'report.common.option_all\' | translate }}</option><option ng-repeat=\"v in vm.PaymentChannel\" ng-value=\"v.value\">\n{{v.display| translate}}</option></select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"User Name\"></label><input type=\"text\" class=\"form-control\" \nng-model=\"vm.filter.UserName\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"Campaign Name\"></label><input type=\"text\" class=\"form-control\" \nng-model=\"vm.filter.CampaignName\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\">\n<label class=\"control-label\" translate=\"User Name\"></label><input type=\"text\" class=\"form-control\" \nng-model=\"vm.filter.UserName\"></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button type=\"button\" \nclass=\"btn btn-primary pull-right\" ng-click=\"vm.getReport()\" translate=\"report.summarize\"></button></div></div></div>\n</div></div></div></div><div class=\"table-responsive\"><table datatable dt-options=\"vm.dataTable.options\" \ndt-columns=\"vm.dataTable.columns\" class=\"table table-bordered table-striped table-hover\" \ndt-instance=\"vm.tableInstance\"><thead><tr><th>{{ \'report.statement_of_account.transaction_id\' | translate}}</th><th>\n{{ \'report.statement_of_account.external_reference_id\' | translate}}</th><th>\n{{ \'report.statement_of_account.transaction_date_time\' | translate}}</th><th>\n{{ \'report.statement_of_account.merchant_name\' | translate }}</th><th>\n{{ \'report.statement_of_account.transaction_type\' | translate }}</th><th>Payment Type</th><th>\n{{ \'report.statement_of_account.wallet_main\' | translate }}</th><th>\n{{ \'report.statement_of_account.wallet_visa\' | translate }}</th><th>\n{{ \'report.statement_of_account.wallet_zakat\' | translate }}</th><th>\n{{ \'report.statement_of_account.wallet_meal_plan\' | translate }}</th><th>\n{{ \'report.statement_of_account.wallet_saved_card\' | translate }}</th><th>\n{{ \'report.statement_of_account.gross_amount\' | translate }}</th><th>\n{{ \'report.statement_of_account.voucher_id\' | translate }}</th><th>\n{{ \'report.statement_of_account.Campaign_Name\' | translate }}</th><th>\n{{ \'report.statement_of_account.Kiple_Subsidy\' | translate }}</th><th>\n{{ \'report.statement_of_account.Merchant_Subsidy\' | translate }}</th><th>\n{{ \'report.statement_of_account.deduction_mdr\' | translate }}</th><th>\n{{ \'report.statement_of_account.deduction_gst\' | translate }}</th><th>\n{{ \'report.statement_of_account.deduction_storecard_cashback\' | translate }}</th><th>\n{{ \'report.statement_of_account.settlement_to_merchant\' | translate }}</th><th>\n{{ \'report.statement_of_account.cashback\' | translate }}</th><th>\n{{ \'report.statement_of_account.user_id\' | translate }}</th><th>\n{{ \'report.statement_of_account.outlet_id\' | translate }}</th><th>\n{{ \'report.statement_of_account.outlet_code\' | translate }}</th><th>\n{{ \'report.statement_of_account.username\' | translate }}</th><th>\n{{ \'report.statement_of_account.beforewalletbalance\' | translate }}</th><th>\n{{ \'report.statement_of_account.afterwalletbalance\' | translate }}</th><th>\n{{ \'report.statement_of_account.rewardoffsetamount\' | translate }}</th><th>\n{{ \'report.statement_of_account.rewardoffsetpoint\' | translate }}</th><th>\n{{ \'report.statement_of_account.rewardoffsetpercent\' | translate }}</th></tr></thead></table></div>");
$templateCache.put("app/report/merchant/store-list.html","<div id=\"store_list_report\"><h1 class=\"page-header\" translate=\"report.names.store_list_report\"></h1><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"form-group\"><label class=\"control-label\" translate=\"report.store_list.merchant\"></label>\n<select class=\"form-control\" ng-model=\"vm.filter.MerchantId\"><option ng-value=\"null\">\n{{ \'report.common.option_all\' | translate }}</option><option ng-value=\"merchant.Id\" \nng-repeat=\"merchant in vm.merchants\">{{merchant.Name}}</option></select></div><div class=\"row\"><div class=\"col-xs-12\">\n<button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.getReport()\" translate=\"report.summarize\">\n</button></div></div></div></div></div></div><div class=\"table-responsive\"><table datatable \ndt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.tableInstance\"><thead><tr><th>\n{{ \'report.store_list.merchant_name\' | translate}}</th><th>{{ \'report.store_list.store_name\' | translate }}</th><th>\n{{ \'report.store_list.store_address\' | translate }}</th><th>{{ \'report.store_list.contact_number\' | translate }}</th>\n<th>{{ \'report.store_list.mobile_number\' | translate }}</th></tr></thead></table></div></div>");
$templateCache.put("app/report/merchant/storecard-transactions.html","<div id=\"storecard_transaction\"><h1 class=\"page-header\" translate=\"report.names.storecard_transactions\"></h1><div><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"form-group\" ng-if=\"vm.isAdmin\"><label class=\"control-label\" \ntranslate=\"report.storecard_transactions.merchant\"></label><ui-select ng-model=\"vm.filter.MerchantId\" \ntheme=\"bootstrap\"><ui-select-match placeholder=\"All\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh=\"vm.loadMerchant($select.search)\" \nrefresh-delay=\"0\" minimum-input-length=\"0\"><div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.common.transaction_start_date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" \nng-model=\"vm.filter.TransactionStartDate\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.common.transaction_end_date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" ng-click=\"vm.datePopup.EndOpen = true\" \nng-model=\"vm.filter.TransactionEndDate\"></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button \ntype=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.getReport()\" translate=\"report.summarize\"></button></div>\n</div></div></div></div></div><ul class=\"nav nav-tabs\" role=\"tablist\"><li role=\"presentation\" class=\"active\"><a \nhref=\"#topup\" aria-controls=\"home\" role=\"tab\" data-toggle=\"tab\" translate=\"report.storecard_transactions.topup\">Topup\n</a></li><li role=\"presentation\"><a href=\"#redemption\" aria-controls=\"profile\" role=\"tab\" data-toggle=\"tab\" \ntranslate=\"report.storecard_transactions.redemption\">Redemption</a></li><li role=\"presentation\"><a href=\"#adjustment\" \naria-controls=\"messages\" role=\"tab\" data-toggle=\"tab\" translate=\"report.storecard_transactions.adjustment\">Adjustment\n</a></li><li role=\"presentation\"><a href=\"#statement\" aria-controls=\"settings\" role=\"tab\" data-toggle=\"tab\" \ntranslate=\"report.storecard_transactions.statement\">Statement</a></li></ul><div class=\"tab-content\"><div \nrole=\"tabpanel\" class=\"tab-pane active\" id=\"topup\"><h3 translate=\"report.storecard_transactions.summary\"></h3><div \nclass=\"table-responsive\"><table datatable dt-options=\"vm.topupSummaryDT.options\" \ndt-columns=\"vm.topupSummaryDT.columns\" class=\"table table-bordered table-striped table-hover\" \ndt-instance=\"vm.topupSummaryDTInstance\"><thead><tr><th>{{ \'report.storecard_transactions.outlet\' | translate }}</th>\n<th>{{ \'report.storecard_transactions.overcounter\' | translate}}</th><th>\n{{ \'report.storecard_transactions.apponline\' | translate}}</th><th>\n{{ \'report.storecard_transactions.bonus\' | translate}}</th></tr></thead></table></div><h3 \ntranslate=\"report.storecard_transactions.details\"></h3><div class=\"table-responsive\"><table datatable \ndt-options=\"vm.topupDetailDT.options\" dt-columns=\"vm.topupDetailDT.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.topupDetailDTInstance\"><thead><tr><th>\n{{ \'report.storecard_transactions.outlet\' | translate }}</th><th>\n{{ \'report.storecard_transactions.media\' | translate }}</th><th>\n{{ \'report.storecard_transactions.transaction_date_time\' | translate}}</th><th>\n{{ \'report.storecard_transactions.billno\' | translate}}</th><th>\n{{ \'report.storecard_transactions.membershipno\' | translate}}</th><th>\n{{ \'report.storecard_transactions.amount\' | translate}}</th><th>{{ \'report.storecard_transactions.bonus\' | translate}}\n</th><th>{{ \'report.storecard_transactions.commission\' | translate}}</th></tr></thead></table></div></div><div \nrole=\"tabpanel\" class=\"tab-pane\" id=\"redemption\"><h3 translate=\"report.storecard_transactions.summary\"></h3><div \nclass=\"table-responsive\"><table datatable dt-options=\"vm.redemptionSummaryDT.options\" \ndt-columns=\"vm.redemptionSummaryDT.columns\" class=\"table table-bordered table-striped table-hover\" \ndt-instance=\"vm.redemptionSummaryDTInstance\"><thead><tr><th>{{ \'report.storecard_transactions.summary\' | translate }}\n</th><th>{{ \'report.storecard_transactions.total\' | translate}}</th></tr></thead></table></div><h3 \ntranslate=\"report.storecard_transactions.details\"></h3><div class=\"table-responsive\"><table datatable \ndt-options=\"vm.redemptionDetailDT.options\" dt-columns=\"vm.redemptionDetailDT.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.redemptionDetailDTInstance\"><thead><tr><th>\n{{ \'report.storecard_transactions.outlet\' | translate }}</th><th>\n{{ \'report.storecard_transactions.transaction_date_time\' | translate}}</th><th>\n{{ \'report.storecard_transactions.billno\' | translate}}</th><th>\n{{ \'report.storecard_transactions.membershipno\' | translate}}</th><th>\n{{ \'report.storecard_transactions.amount\' | translate}}</th></tr></thead></table></div></div><div role=\"tabpanel\" \nclass=\"tab-pane\" id=\"adjustment\"><h3 translate=\"report.storecard_transactions.summary\"></h3><div \nclass=\"table-responsive\"><table datatable dt-options=\"vm.adjustmentSummaryDT.options\" \ndt-columns=\"vm.adjustmentSummaryDT.columns\" class=\"table table-bordered table-striped table-hover\" \ndt-instance=\"vm.adjustmentSummaryDTInstance\"><thead><tr><th>{{ \'report.storecard_transactions.summary\' | translate }}\n</th><th>{{ \'report.storecard_transactions.total\' | translate}}</th></tr></thead></table></div><h3 \ntranslate=\"report.storecard_transactions.details\"></h3><div class=\"table-responsive\"><table datatable \ndt-options=\"vm.adjustmentDetailDT.options\" dt-columns=\"vm.adjustmentDetailDT.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.adjustmentDetailDTInstance\"><thead><tr><th>\n{{ \'report.storecard_transactions.outlet\' | translate }}</th><th>\n{{ \'report.storecard_transactions.transaction_date_time\' | translate}}</th><th>\n{{ \'report.storecard_transactions.voidtype\' | translate}}</th><th>\n{{ \'report.storecard_transactions.billno\' | translate}}</th><th>\n{{ \'report.storecard_transactions.membershipno\' | translate}}</th><th>\n{{ \'report.storecard_transactions.amount\' | translate}}</th><th>{{ \'report.storecard_transactions.reason\' | translate}}\n</th></tr></thead></table></div></div><div role=\"tabpanel\" class=\"tab-pane\" id=\"statement\"><h3 \ntranslate=\"report.storecard_transactions.summary\"></h3><div class=\"table-responsive\"><table \nclass=\"table table-bordered table-striped table-hover\"><thead><tr><th>\n{{ \'report.storecard_transactions.summary\' | translate }}</th><th>\n{{ \'report.storecard_transactions.total\' | translate}}</th></tr></thead><tbody><tr><td>\n{{ \'report.storecard_transactions.openingbalance\' | translate }}</td><td>{{vm.statementSummary.OpeningBalance}}</td>\n</tr><tr><td>{{ \'report.storecard_transactions.topup\' | translate }}</td><td>\n{{vm.statementSummary.TopupOnline + statementSummary.TopupOverCounter}}</td></tr><tr><td>\n*- {{ \'report.storecard_transactions.overcounter_generated\' | translate }}</td><td>\n{{vm.statementSummary.TopupOverCounterGenerated}}</td></tr><tr><td>\n*- {{ \'report.storecard_transactions.overcounter_redeemed\' | translate }}</td><td>\n{{vm.statementSummary.TopupOverCounter}}</td></tr><tr><td>\n*- {{ \'report.storecard_transactions.apponline\' | translate }}</td><td>{{vm.statementSummary.TopupOnline}}</td></tr>\n<tr><td>{{ \'report.storecard_transactions.bonus\' | translate }}</td><td>{{vm.statementSummary.Bonus}}</td></tr><tr><td>\n{{ \'report.storecard_transactions.closingbalance\' | translate }}</td><td>{{vm.statementSummary.ClosingBalance}}</td>\n</tr></tbody></table></div><h3 translate=\"report.storecard_transactions.details\"></h3><div class=\"table-responsive\">\n<table datatable dt-options=\"vm.statementDetailDT.options\" dt-columns=\"vm.statementDetailDT.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.statementDetailDTInstance\"><thead><tr><th>\n{{ \'report.storecard_transactions.membershipno\' | translate }}</th><th>\n{{ \'report.storecard_transactions.openingbalance\' | translate}}</th><th>\n{{ \'report.storecard_transactions.apponline\' | translate}}</th><th>\n{{ \'report.storecard_transactions.overcounter\' | translate}}</th><th>\n{{ \'report.storecard_transactions.bonus\' | translate}}</th><th>\n{{ \'report.storecard_transactions.adjustment\' | translate}}</th><th>\n{{ \'report.storecard_transactions.closingbalance\' | translate}}</th></tr></thead></table></div></div></div></div></div>");
$templateCache.put("app/report/merchant/voucher-summary.html","<div id=\"voucher_summary_report\"><h1 class=\"page-header\" translate=\"report.names.voucher_summary_report\"></h1><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"form-group\" ng-if=\"vm.showMerchantFilter\"><label class=\"control-label\" \ntranslate=\"report.voucher_summary.merchant\"></label><ui-select ng-model=\"vm.filter.MerchantId\" theme=\"bootstrap\">\n<ui-select-match placeholder=\"All\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh=\"vm.loadMerchant($select.search)\" \nrefresh-delay=\"0\" minimum-input-length=\"0\"><div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.voucher_summary.voucher_name\"></label><input type=\"text\" class=\"form-control\" \nng-model=\"vm.filter.VoucherName\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.voucher_summary.voucher_status\"></label><select class=\"form-control\" \nng-model=\"vm.filter.Status\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option><option \nng-repeat=\"v in vm.voucherStatus\" ng-value=\"v.value\">{{v.display| translate}}</option></select></div></div><div \nclass=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"Campaign Name\"></label><input \ntype=\"text\" class=\"form-control\" ng-model=\"vm.filter.CampaignName\"></div></div></div><div class=\"row\"><div \nclass=\"col-xs-12\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.getReport()\" \ntranslate=\"report.summarize\"></button></div></div></div></div></div></div><div class=\"table-responsive\"><table \ndatatable dt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.tableInstance\"><thead><tr><th>\n{{ \'report.voucher_summary.voucher_id\' | translate}}</th><th>{{ \'report.voucher_summary.title\' | translate}}</th><th>\n{{ \'report.voucher_summary.merchant_name\' | translate }}</th><th>\n{{ \'report.voucher_summary.original_price\' | translate }}</th><th>\n{{ \'report.voucher_summary.offered_price\' | translate }}</th><th>{{ \'report.voucher_summary.amount\' | translate }}</th>\n<th>{{ \'report.voucher_summary.Campaign_Name\' | translate }}</th><th>\n{{ \'report.voucher_summary.SubsidyType\' | translate }}</th><th>{{ \'report.voucher_summary.Kiple_Subsidy\' | translate }}\n</th><th>{{ \'report.voucher_summary.Merchant_Subsidy\' | translate }}</th><th>\n{{ \'report.voucher_summary.discount_type\' | translate }}</th><th>\n{{ \'report.voucher_summary.max_quantity\' | translate }}</th><th>\n{{ \'report.voucher_summary.purchased_quantity\' | translate }}</th><th>\n{{ \'report.voucher_summary.redeemed_quantity\' | translate }}</th><th>\n{{ \'report.voucher_summary.sales_start_date\' | translate }}</th><th>\n{{ \'report.voucher_summary.sales_stop_date\' | translate }}</th><th>\n{{ \'report.voucher_summary.voucher_expiry_date\' | translate }}</th><th>\n{{ \'report.voucher_summary.status\' | translate }}</th><th>{{ \'report.voucher_summary.UserCategory\' | translate }}</th>\n<th>{{ \'report.voucher_summary.UniversityId\' | translate }}</th><th>\n{{ \'report.voucher_summary.IsUniversity\' | translate }}</th><th>{{ \'report.voucher_summary.IsPublish\' | translate }}\n</th></tr></thead></table></div></div>");
$templateCache.put("app/report/merchant/webcash-settlement.html","<div id=\"webcash_settlement_report\"><h1 class=\"page-header\" translate=\"report.names.webcash_settlement_report\"></h1>\n<div class=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.statement_of_account.merchant\"></label><ui-select ng-model=\"vm.filter.MerchantId\" theme=\"bootstrap\" \nng-change=\"vm.search()\"><ui-select-match placeholder=\"All\">{{$select.selected.Name}}</ui-select-match>\n<ui-select-choices repeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" \nrefresh=\"vm.loadMerchant($select.search)\" refresh-delay=\"0\" minimum-input-length=\"0\"><div \nng-bind-html=\"merchant.Name | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><div \nstyle=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.common.transaction_start_date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" \nng-model=\"vm.filter.TransactionStartDate\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.common.transaction_end_date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" ng-click=\"vm.datePopup.EndOpen = true\" \nng-model=\"vm.filter.TransactionEndDate\"></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button \ntype=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.getReport()\" translate=\"report.summarize\"></button></div>\n</div></div></div></div></div><div class=\"table-responsive\"><table datatable dt-options=\"vm.dataTable.options\" \ndt-columns=\"vm.dataTable.columns\" class=\"table table-bordered table-striped table-hover\" \ndt-instance=\"vm.tableInstance\"><thead><tr><th>{{ \'report.statement_of_account.webcash_id_merchant_name\' | translate }}\n</th><th>{{ \'report.statement_of_account.transaction_date_time\' | translate}}</th><th>\n{{ \'report.statement_of_account.kiple_transaction_id\' | translate}}</th><th>\n{{ \'report.statement_of_account.webcash_transaction_id\' | translate}}</th><th>\n{{ \'report.statement_of_account.transaction_amount\' | translate }}</th><th>\n{{ \'report.statement_of_account.cash\' | translate }}</th><th>{{ \'report.statement_of_account.kiplekash\' | translate }}\n</th><th>{{ \'report.statement_of_account.store_card\' | translate }}</th><th>\n{{ \'report.statement_of_account.card_payment\' | translate }}</th><th>\n{{ \'report.statement_of_account.deduction_mdr\' | translate }}</th><th>\n{{ \'report.statement_of_account.deduction_gst\' | translate }}</th><th>\n{{ \'report.statement_of_account.deduction_storecard_payment\' | translate }}</th><th>\n{{ \'report.statement_of_account.deduction_subtotal\' | translate }}</th><th>\n{{ \'report.statement_of_account.settlement_to_merchant\' | translate }}</th></tr></thead></table></div></div>");
$templateCache.put("app/report/system/confirmed-users-daily.html","<h1 class=\"page-header\" translate=\"report.names.confirmed_user_report\"></h1><table datatable \ndt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\"><thead><tr><th>\n{{\'report.confirmed_users_daily.date\' | translate}}</th><th>\n{{\'report.confirmed_users_daily.total_confirmed_users\' | translate}}</th></tr></thead></table>");
$templateCache.put("app/report/system/mobilityone-settlement.html","<div id=\"mobilityone_settlement_report\" ng-controller=\"MobilityoneSettlementReportController as vm\" \nng-init=\"vm.init()\"><h1 class=\"page-header\" translate=\"report.names.mobilityone_settlement_report\"></h1><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label required\" translate=\"report.common.transaction_start_date\"></label><input type=\"text\" id=\"sdate\" \nclass=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" \nng-click=\"vm.datePopup.StartOpen = true\" ng-model=\"vm.filter.TransactionStartDate\"></div></div><div class=\"col-md-6\">\n<div class=\"form-group\"><label class=\"control-label required\" translate=\"report.common.transaction_end_date\"></label>\n<input type=\"text\" id=\"edate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" \nng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.filter.TransactionEndDate\"></div></div></div><div class=\"row\"><div \nclass=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.mobilityone_settlement.transaction_type\"></label><select class=\"form-control\" \nng-model=\"vm.filter.TransactionAction\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option>\n<option ng-value=\"action.value\" ng-repeat=\"action in vm.transactionActions\">{{action.display | translate}}</option>\n</select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.lcrpartner\"></label><select class=\"form-control\" ng-model=\"vm.filter.LCRPartner\"><option \nng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option><option ng-value=\"lcrpartner.Id\" \nng-repeat=\"lcrpartner in vm.lcrPartners\">{{lcrpartner.Name | translate}}</option></select></div></div><div \nclass=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"report.partner\"></label><select \nclass=\"form-control\" ng-model=\"vm.filter.Partner\"><option value=\"\">{{ \'report.common.option_all\' | translate }}\n</option><option ng-repeat=\"type in vm.appTypes\" value=\"{{ type }}\">{{ type }}</option></select></div></div></div><div \nclass=\"row\"><div class=\"col-xs-12\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.getReport()\" \ntranslate=\"report.summarize\"></button></div></div></div></div></div></div><div class=\"table-responsive\"><table \ndatatable dt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.tableInstance\"><thead><tr><th>\n{{ \'report.mobilityone_settlement.transaction_id\' | translate }}</th><th>\n{{ \'report.mobilityone_settlement.transaction_date_time\' | translate}}</th><th>\n{{ \'report.mobilityone_settlement.user_id\' | translate}}</th><th>User Name</th><th>Email</th><th>Mobile Number</th><th>\nStatus</th><th>{{ \'report.mobilityone_settlement.transaction_type\' | translate}}</th><th>\n{{ \'report.mobilityone_settlement.lcr_partner\' | translate}}</th><th>\n{{ \'report.mobilityone_settlement.biller_mobile_operator\' | translate }}</th><th>\n{{ \'report.mobilityone_settlement.account_mobile_number\' | translate }}</th><th>\n{{ \'report.mobilityone_settlement.cash\' | translate }}</th><th>\n{{ \'report.mobilityone_settlement.kiplekash\' | translate }}</th><th>\n{{ \'report.mobilityone_settlement.card_payment\' | translate }}</th><th>\n{{ \'report.mobilityone_settlement.transaction_amount\' | translate }}</th><th>PTPTN - Account No</th><th>PTPTN -Loan No\n</th><th>PTPTN -IC</th><th>PTPTN -Beneficiary IC</th><th>Employer</th><th>Reward Amount</th><th>Reward Percentage</th>\n<th>Reward Points</th><th>Transaction Reference</th></tr></thead><tfoot><tr><th colspan=\"11\">\n{{ \'report.mobilityone_settlement.total\' | translate }}</th><th>({{vm.report.TotalCash}})</th><th>\n({{vm.report.TotalKiplekash}})</th><th>({{vm.report.TotalCardPayment}})</th><th>({{vm.report.TotalAmount}})</th></tr>\n</tfoot></table></div></div>");
$templateCache.put("app/report/system/user-registration-report.html","<div id=\"divUserRegistrationReport\" ng-controller=\"UserRegistrationReportController as vm\"><h1 class=\"page-header\" \ntranslate=\"report.names.user_registration_report\"></h1><div class=\"report-filter\"><div class=\"panel panel-default\"><div\n class=\"panel-heading\" data-toggle=\"collapse\" data-target=\"#collapse_panel\"><span class=\"panel-title\" \ntranslate=\"report.report_filter\"></span> <a class=\"pull-right\"><i class=\"glyphicon glyphicon-fullscreen\"></i></a></div>\n<div id=\"collapse_panel\" class=\"collapse in\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4\"><div \nclass=\"form-group\"><label class=\"control-label\">Registration Start Date <span class=\"text-danger\">*</span></label>\n<input id=\"registrationStartDate\" name=\"registrationStartDate\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" \nis-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" \nng-model=\"vm.searchModel.registrationStartDate\" max-date=\"vm.maxDate\" placeholder=\"YYYY-MM-DD (Required)\" required>\n</div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">Registration End Date <span \nclass=\"text-danger\">*</span></label><input id=\"registrationEndDate\" name=\"registrationEndDate\" class=\"form-control\" \nuib-datepicker-popup=\"yyyy-MM-dd\" is-open=\"vm.datePopup.EndOpen\" ng-click=\"vm.datePopup.EndOpen = true\" \nng-model=\"vm.searchModel.registrationEndDate\" max-date=\"vm.maxDate\" min-date=\"vm.searchModel.registrationStartDate\" \nplaceholder=\"YYYY-MM-DD (Required)\" required></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label \nclass=\"control-label\">Partner</label><select class=\"form-control\" ng-model=\"vm.searchModel.projectType\"><option \nvalue=\"\">All</option><option ng-repeat=\"type in vm.appTypes\" value=\"{{type}}\">{{type}}</option></select></div></div>\n</div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">ID Type</label>\n<select class=\"form-control\" ng-model=\"vm.searchModel.idType\"><option value=\"\">All</option><option \nng-repeat=\"type in vm.idTypes\" value=\"{{type}}\">{{type}}</option></select></div></div><div class=\"col-md-4\"><div \nclass=\"form-group\"><label class=\"control-label\">VISA Card Status</label><select class=\"form-control\" \nng-model=\"vm.searchModel.visaCardStatus\"><option value=\"\">All</option><option \nng-repeat=\"status in vm.visaCardStatuses\" value=\"{{status}}\">{{status}}</option></select></div></div><div \nclass=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">eKYC Status</label><select class=\"form-control\" \nng-model=\"vm.searchModel.ekycStatus\"><option value=\"\">All</option><option value=\"Approved\">Approved</option><option \nvalue=\"Pending\">Pending</option><option value=\"Failed\">Failed</option><option value=\"NotStart\">NotStart</option><option\n value=\"HardRejected\">HardRejected</option><option value=\"Terminated\">Terminated</option></select></div></div></div>\n<div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">Wallet Status</label>\n<select class=\"form-control\" ng-model=\"vm.searchModel.walletStatus\"><option value=\"\">All</option><option value=\"1\">\nActive</option><option value=\"0\">Inactive</option></select></div></div><div class=\"col-md-4\"><div class=\"form-group\">\n<label class=\"control-label\">Wallet Type</label><select class=\"form-control\" ng-model=\"vm.searchModel.walletType\">\n<option value=\"\">All</option><option value=\"0\">Basic</option><option value=\"1\">Premium</option><option value=\"2\">\nPlatinum</option></select></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button type=\"button\" \nclass=\"btn btn-primary pull-right\" ng-click=\"vm.searchReport()\" translate=\"report.summarize\"></button> <button \ntype=\"button\" class=\"btn btn-default pull-right\" style=\"margin-right: 10px\" ng-click=\"vm.reset()\">Reset</button> \n<button type=\"button\" class=\"btn btn-success pull-right\" style=\"margin-right: 10px\" ng-click=\"vm.exportToCSV()\"><i \nclass=\"glyphicon glyphicon-download-alt\"></i> Export</button></div></div><div role=\"alert\" ng-if=\"vm.errorMsg\" \nclass=\"alert alert-danger\">{{vm.errorMsg}}</div></div></div></div></div><div class=\"table-responsive\"><table \ndatatable=\"\" dt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.dtInstanceCallback\"></table></div><div \nclass=\"row\" ng-if=\"vm.totalPages > 0\"><div class=\"col-xs-6\"><div class=\"dataTables_info\">\nPage {{ vm.currentPage }} of {{ vm.totalPages }}, showing {{ vm.data.length }} records out of {{ vm.totalCount }} Records\n</div></div><div class=\"col-xs-6\"><div class=\"dataTables_paginate paging_simple_numbers text-right\"><ul \nclass=\"pagination\"><li class=\"paginate_button previous\" ng-class=\"{disabled: vm.currentPage === 1}\"><a href \nng-click=\"vm.currentPage > 1 && vm.goToPage(vm.currentPage - 1)\">Previous</a></li><li class=\"paginate_button\" \nng-repeat=\"page in vm.pages\" ng-class=\"{active: page === vm.currentPage}\"><a href ng-click=\"vm.goToPage(page)\">\n{{ page }}</a></li><li class=\"paginate_button next\" ng-class=\"{disabled: vm.currentPage === vm.totalPages}\"><a href \nng-click=\"vm.currentPage < vm.totalPages && vm.goToPage(vm.currentPage + 1)\">Next</a></li></ul></div></div></div></div>");
$templateCache.put("app/store/manager/store.manager.html","<h1 class=\"page-header\" translate=\"store.manager.title\"></h1><div id=\"storeManager\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 margin-tb\"><input type=\"text\" \nclass=\"form-control\" ng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"{{ \'store.placeholder.search_store\' | translate}}\"></div><div class=\"col-md-1 margin-tl\"><a \nclass=\"btn btn-primary pull-right\" ng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span \ntranslate=\"common.action.reset\"></span></a></div></div></div><div class=\"form-group\"><div class=\"table-responsive\">\n<table class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th translate=\"store.manager.pin\"></th><th \ntranslate=\"common.store\"></th><th translate=\"common.status\"></th><th translate=\"common.action.title\"></th></tr></thead>\n<tbody><tr ng-repeat=\"manager in vm.managers\"><td class=\"center\">{{$index + 1}}</td><td>{{manager.Pin}}</td><td>\n{{manager.StoreName}}</td><td>{{manager.Status}}</td><td class=\"center\"><a ng-if=\"manager.Status == \'Inactive\'\" \ntitle=\"Active\" class=\"btn btn-default\" ng-click=\"vm.setStatus(manager, \'Active\')\"><i \nclass=\"glyphicon glyphicon-cloud-upload\"></i></a> <a ng-if=\"manager.Status == \'Active\'\" title=\"Inactive\" \nclass=\"btn btn-danger\" ng-click=\"vm.setStatus(manager, \'Inactive\')\"><i class=\"glyphicon glyphicon-cloud-download\"></i>\n</a></td></tr></tbody></table></div><ul uib-pagination total-items=\"vm.totalItems\" ng-model=\"vm.currentPage\" \nitemsperpage=\"vm.itemsPerPage\" max-size=\"vm.maxSize\" ng-change=\"vm.search()\" class=\"pagination-sm\" \nboundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div></div>");
$templateCache.put("app/store/static-qr/static-qr.html","<h1 class=\"page-header\" translate=\"store.static_qr.title\"></h1><div id=\"storeTable\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-2 col-md-offset-10\"><a \nclass=\"btn btn-primary\" ng-click=\"vm.createFull()\"><i class=\"glyphicon\"></i><span translate=\"store.static_qr.show_all\">\n</span></a> <a class=\"btn btn-primary\" ng-click=\"vm.add()\"><i class=\"glyphicon glyphicon-plus\"></i> <span \ntranslate=\"common.action.add\"></span></a></div></div></div><div class=\"table-responsive form-group\"><table \nclass=\"table table-striped table-bordered\"><thead><tr><th>#</th><th translate=\"store.static_qr.name\"></th><th \ntranslate=\"store.static_qr.qr_code_id\"></th><th translate=\"common.action.title\"></th></tr></thead><tbody><tr \nng-repeat=\"static_qr in vm.static_qrs\"><td class=\"center\">{{$index + 1}}</td><td>{{static_qr.Name}}</td><td>\n{{static_qr.QrCodeId}}</td><td class=\"center\"><a title=\"Edit\" class=\"btn btn-default\" ng-click=\"vm.edit(static_qr)\"><i \nclass=\"glyphicon glyphicon-edit\"></i></a> <a title=\"Unactive\" ng-if=\"static_qr.Status == \'Active\'\" \nclass=\"btn btn-danger\" ng-click=\"vm.inActive(static_qr)\"><i class=\"glyphicon glyphicon-cloud-download\"></i></a> <a \ntitle=\"Active\" ng-if=\"static_qr.Status == \'InActive\'\" class=\"btn btn-primary\" ng-click=\"vm.active(static_qr)\"><i \nclass=\"glyphicon glyphicon-cloud-upload\"></i></a> <a title=\"Generate qrcode\" class=\"btn btn-default\" \nng-click=\"vm.getQRCode(static_qr.QrCodeId)\"><i class=\"glyphicon glyphicon-qrcode\"></i></a> <a title=\"Remove\" \nclass=\"btn btn-danger\" ng-click=\"vm.remove(static_qr.Id)\" ng-if=\"vm.Tag==0\"><i class=\"glyphicon glyphicon-remove\"></i>\n</a></td></tr></tbody></table><ul uib-pagination total-items=\"vm.totalItems\" ng-change=\"vm.search()\" \nitems-per-page=\"vm.itemsPerPage\" ng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" \nboundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.showDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-md\"><div \nclass=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.showDialog = false\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 \nclass=\"modal-title center\" id=\"modal-title\">Static QR detail</h3></div><form name=\"staticQRForm\" \nclass=\"form-horizontal\" ng-submit=\"vm.save()\" novalidate id=\"staticQRForm\"><input type=\"hidden\" \nng-model=\"vm.static_qr.StoreId\"><div class=\"modal-body\"><div class=\"form-group\" \nng-class=\"{\'has-error\': staticQRForm.StoreName.$invalid && staticQRForm.StoreName.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"store.static_qr.store_name\"></label><div class=\"col-md-9\"><input type=\"text\" \nclass=\"form-control\" value=\"{{vm.storeName}}\" disabled=\"disabled\"></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': staticQRForm.Name.$invalid && staticQRForm.Name.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"store.static_qr.name\"></label><div class=\"col-md-9\"><input type=\"text\" \nclass=\"form-control\" name=\"Name\" ng-model=\"vm.static_qr.Name\" required><div ng-messages=\"staticQRForm.Name.$error\"><div\n ng-message=\"required\" ng-if=\"staticQRForm.Name.$touched\" class=\"help-block\"><span \ntranslate=\"store.static_qr.name_required\"></span></div></div></div></div></div><div class=\"modal-footer\"><a \nclass=\"btn btn-danger\" ng-click=\"vm.showDialog = false\" translate=\"common.action.cancel\"></a> <button \nclass=\"btn btn-primary\" type=\"submit\" translate=\"common.action.save\"></button></div></form></div></div></div></div><div\n class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.qrcodeDialog\" class=\"modal fade\" tabindex=\"-1\" \nrole=\"dialog\"><div class=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><div class=\"modal-header\">\n<button type=\"button\" class=\"close\" ng-click=\"vm.qrcodeDialog = false\"><span aria-hidden=\"true\">&times;</span><span \nclass=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\">QRCode</h3></div><div \nid=\"qrcodeBody\" class=\"modal-body center\"><div class=\"form-group\"><img src=\"{{vm.qrcode}}\"></div><div \nclass=\"form-group\"><label translate=\"store.table.store_name_qr\"></label><label>{{vm.storeName}}</label></div></div><div\n class=\"modal-footer\"><a class=\"btn btn-primary\" ng-click=\"vm.print()\"><i class=\"glyphicon glyphicon-print\"></i> <span \ntranslate=\"common.action.print\"></span></a></div></div></div></div></div><div class=\"header-modal\"><div \ncommon-bs-modal bs-modal-show=\"vm.listQRCodeDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-md\"><div class=\"modal-content\" \nng-class=\"{\'modal-content-A\': vm.qrCodes.length <=16, \'modal-content-B\': vm.qrCodes.length > 16}\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.listQRCodeDialog = false\"><span \naria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" \nid=\"modal-title\">{{vm.storeName}}</h3></div><div id=\"qrCodeListBody\"><div ng-if=\"vm.qrCodes.length > 0\" \nclass=\"qr-code\" ng-repeat=\"qrCodes in vm.qrCodes\"><img class=\"image\" ng-src=\"{{qrCodes.Image}}\"><label class=\"title\">\n{{qrCodes.TableName}}</label></div><div ng-if=\"vm.qrCodes.length == 0\"><h4 class=\"text-center\">\nNo static QR at this store</h4></div></div><div class=\"modal-footer\"><a class=\"btn btn-primary\" \nng-click=\"vm.printList()\"><i class=\"glyphicon glyphicon-print\"></i> <span translate=\"common.action.print\"></span></a> \n<a class=\"btn btn-danger\" ng-click=\"vm.listQRCodeDialog = false\" translate=\"common.action.close\"></a></div></div></div>\n</div></div></div>");
$templateCache.put("app/store/terminal/store.terminal.html","<h1 class=\"page-header\" translate=\"store.user.title\"></h1><div id=\"terminal\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 margin-tb\"><input type=\"text\" \nclass=\"form-control\" ng-model=\"vm.criteria.Keyword\" ng-change=\"vm.searchChange()\" \nng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"{{\'store.placeholder.search_store\' | translate}}\"></div><div \nclass=\"col-md-1 margin-tl\"><a class=\"btn btn-primary pull-right\" ng-click=\"vm.reset()\"><i \nclass=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a></div></div></div><div \nclass=\"form-group\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered\"><thead><tr><th>#\n</th><th translate=\"common.terminal\"></th><th translate=\"common.store\"></th><th translate=\"common.type\"></th><th \ntranslate=\"common.status\"></th><th translate=\"common.action.title\"></th></tr></thead><tbody><tr \nng-repeat=\"terminal in vm.terminals\"><td class=\"center\">{{$index + 1}}</td><td>{{terminal.POSId}}</td><td>\n{{terminal.ObjectName}}</td><td ng-if=\"terminal.Type == \'KiplePOS\'\">Kiple POS</td><td \nng-if=\"terminal.Type == \'MerchantPhone\'\">Merchant Phone</td><td>{{terminal.Status}}</td><td class=\"center\"><a \nshow-permissions=\"[\'ADD_TERMINAL_TO_STORE\']\" title=\"Edit\" class=\"btn btn-default margin-tl\" \nng-click=\"vm.edit(terminal)\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a \nshow-permissions=\"[\'REMOVE_TERMINAL_FROM_STORE\']\" title=\"Remove\" class=\"btn btn-danger margin-tl\" \nng-click=\"vm.removeTerminal(terminal.POSId)\"><i class=\"glyphicon glyphicon-remove\"></i></a></td></tr></tbody></table>\n</div><ul uib-pagination total-items=\"vm.totalItems\" ng-change=\"vm.search()\" items-per-page=\"vm.itemsPerPage\" \nvm.itemperpage ng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" \nrotate=\"false\"></ul></div></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowEditUserDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" \nclass=\"close\" ng-click=\"vm.viewConfig.ShowEditUserDialog = false\"><span aria-hidden=\"true\">&times;</span><span \nclass=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\">Edit Terminal</h3></div><div \nclass=\"modal-body\"><form name=\"terminalForm\" class=\"form-horizontal\"><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"common.terminal\"></label><div class=\"col-md-8\"><input type=\"text\" \nclass=\"form-control\" ng-model=\"vm.terminal.POSId\" readonly=\"readonly\"></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"common.terminal_type\"></label><div class=\"col-md-8\"><select \nclass=\"form-control\" ng-model=\"vm.terminal.Type\"><option value=\"\" hidden>Select device type</option><option \nvalue=\"KiplePOS\">Kiple POS</option><option value=\"MerchantPhone\">Merchant Phone</option></select></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"common.status\"></label><div class=\"col-md-8\">\n<select class=\"form-control\" ng-model=\"vm.terminal.Status\"><option value=\"Active\">Active</option><option \nvalue=\"Inactive\">Inactive</option></select></div></div></form></div><div class=\"modal-footer\"><a \nclass=\"btn btn-primary\" ng-click=\"vm.saveTerminal(vm.terminal)\" translate=\"common.action.save\"></a> <a \nclass=\"btn btn-danger\" ng-click=\"vm.viewConfig.ShowEditUserDialog = false\" translate=\"common.action.cancel\"></a></div>\n</div></div></div></div></div>");
$templateCache.put("app/university/university-merchant/merchant.html","<div class=\"alert alert-warning alert-dismissable\" ng-if=\"vm.error\"><a href=\"#\" class=\"close\" data-dismiss=\"alert\" \naria-label=\"close\">&times;</a> <strong>Warning!</strong> {{vm.error}}</div><h1 class=\"page-header\" \ntranslate=\"merchant.title\" ng-init=\"vm.universityMerchantList()\"></h1><div id=\"merchant\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 margin-tb\"><input type=\"text\" \nclass=\"form-control\" ng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"{{\'merchant.placeholder.company_name\' | translate}}\"></div><div class=\"col-md-1\"><a \nclass=\"btn btn-primary pull-right margin-tl\" ng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span \ntranslate=\"common.action.reset\"></span></a></div><div class=\"col-md-2 col-md-offset-6\"></div></div></div><div \nclass=\"form-group\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered\"><thead \nthead-order=\"vm.sort($sortOpts)\"><tr><th>#</th><th translate=\"merchant.name\"></th><th translate=\"common.address.city\">\n</th><th translate=\"common.address.state\"></th><th translate=\"common.address.district\"></th><th \ntranslate=\"merchant.number_of_store\"></th><th th-order=\"\'CreatedAt\'\"><span translate=\"common.created_date\"></span></th>\n<th translate=\"common.status\"></th></tr></thead><tbody><tr ng-repeat=\"merchant in vm.merchants\"><td class=\"center\">\n{{$index + 1}}</td><td><a ui-sref=\"app.merchant.info({merchantId: merchant.Id})\">{{merchant.Name}}</a></td><td>\n{{merchant.City}}</td><td>{{merchant.Province}}</td><td>{{merchant.District}}</td><td>{{merchant.NumberOfStore}}</td>\n<td>{{merchant.CreatedAt | date:\'yyyy-MM-dd\'}}</td><td>{{merchant.State}}</td></tr></tbody></table></div><ul \nuib-pagination total-items=\"vm.totalItems\" ng-change=\"vm.search()\" ng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" \nitems-per-page=\"vm.itemsPerPage\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div>\n<div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowMerchantDialog\" class=\"modal fade\" \ntabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowMerchantDialog = false\"><span \naria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" \nid=\"modal-title\" translate=\"merchant.merchant_detail\"></h3></div><div class=\"modal-body\"><ul class=\"nav nav-tabs\"><li \nclass=\"active\"><a data-toggle=\"tab\" href=\"#merchantDiv\" id=\"merchantTab\">Information</a></li><li><a data-toggle=\"tab\" \nhref=\"#storeCardTopupOptionsDiv\" id=\"storeCardTopupOptionsTab\">StoreCard Topup Options</a></li></ul><div \nclass=\"tab-content\"><div id=\"merchantDiv\" class=\"tab-pane fade in active\"><form name=\"merchantForm\" \nclass=\"form-horizontal\" novalidate id=\"merchantForm\"><br><div class=\"form-group\"><div class=\"col-md-12\"><h4 \nclass=\"sub-title\" translate=\"merchant.company.title\"></h4></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"common.brand\"></label><div class=\"col-md-8\"><select class=\"form-control\" \nname=\"BrandId\" ng-model=\"vm.merchant.BrandId\" ng-change=\"vm.loadBrandInfo(vm.merchant.BrandId)\"><option ng-value=\"0\">\n-- Seclect an option --</option><option ng-repeat=\"brand in vm.brands\" ng-value=\"brand.Id\">{{brand.Name}}</option>\n</select><div ng-messages=\"merchantForm.BrandId.$error\"><div ng-message=\"required\" \nng-if=\"merchantForm.BrandId.$touched\" class=\"help-block\"><span translate=\"merchant.validate.merchant.brand\"></span>\n</div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.CompanyEmail.$invalid && merchantForm.CompanyEmail.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.company.email\"></label><div class=\"col-md-8\"><input type=\"email\" \nname=\"CompanyEmail\" class=\"form-control\" ng-model=\"vm.merchant.Company.Email\"><div \nng-messages=\"merchantForm.CompanyEmail.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.CompanyEmail.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.company.email_required\"></span></div><div ng-message=\"email\" \nng-if=\"merchantForm.CompanyEmail.$touched\" class=\"help-block\" translate=\"merchant.validate.company.email_invalid\">\n</div></div></div></div><div class=\"form-group\"><label class=\"control-label col-md-3\" \ntranslate=\"merchant.company.registration_number\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"RegistrationNumber\" class=\"form-control\" ng-model=\"vm.merchant.Company.RegistrationNumber\"></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.MainContactPerson.$invalid && merchantForm.MainContactPerson.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.main_contact_person\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"MainContactPerson\" class=\"form-control\" ng-model=\"vm.merchant.Company.MainContactPerson\"><div \nng-messages=\"merchantForm.MainContactPerson.$error\"><div ng-message=\"required\" \nng-if=\"merchantForm.MainContactPerson.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.company.main_contact_person\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.MainContactNumber.$invalid && merchantForm.MainContactNumber.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.main_contact_number\"></label><div class=\"col-md-8\"><input \ntype=\"text\" class=\"form-control\" name=\"MainContactNumber\" ng-pattern=\"/^\\d+$/\" \nng-model=\"vm.merchant.Company.MainContactNumber\"><div ng-messages=\"merchantForm.MainContactNumber.$error\"><div \nng-message=\"required\" ng-if=\"merchantForm.MainContactNumber.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.company.main_contact_number\"></span></div><div ng-message=\"pattern\" \nng-if=\"merchantForm.MainContactNumber.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.company.main_contact_number_format\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"merchant.web_url\"></label><div class=\"col-md-8\">\n<input type=\"text\" name=\"CompanyWebsite\" class=\"form-control\" ng-model=\"vm.merchant.Company.Website\"></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"common.address.address\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"AddressStreet\" class=\"form-control\" \nng-model=\"vm.merchant.Company.Address.Street\"></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"common.address.city\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"AddressCity\" class=\"form-control\" ng-model=\"vm.merchant.Company.Address.City\"></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"common.address.district\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"AddressDistrict\" class=\"form-control\" \nng-model=\"vm.merchant.Company.Address.District\"></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3\" translate=\"common.address.state\"></label><div class=\"col-md-8\"><input type=\"text\" \nname=\"AddressState\" class=\"form-control\" ng-model=\"vm.merchant.Company.Address.State\"></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': merchantForm.PostCode.$invalid && merchantForm.PostCode.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"common.address.postcode\"></label><div class=\"col-md-8\"><input type=\"text\" \nclass=\"form-control\" name=\"PostCode\" ng-pattern=\"/^\\d+$/\" ng-model=\"vm.merchant.Company.Address.PostCode\"><div \nng-messages=\"merchantForm.PostCode.$error\"><div ng-message=\"pattern\" ng-if=\"merchantForm.PostCode.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.company.postcode_format\"></span></div></div></div></div><div \nclass=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" translate=\"merchant.bank_information\"></h4></div></div>\n<div class=\"form-group\"><label class=\"control-label col-md-3\" translate=\"merchant.bank.name\"></label><div \nclass=\"col-md-8\"><input type=\"text\" name=\"BankName\" class=\"form-control\" ng-model=\"vm.merchant.Bank.Name\"></div></div>\n<div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.AccountNumber.$invalid && merchantForm.AccountNumber.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.bank.account_number\"></label><div class=\"col-md-8\"><input \ntype=\"text\" ng-pattern=\"/^\\d+$/\" name=\"AccountNumber\" class=\"form-control\" ng-model=\"vm.merchant.Bank.AccountNumber\">\n<div ng-messages=\"merchantForm.AccountNumber.$error\"><div ng-message=\"pattern\" \nng-if=\"merchantForm.AccountNumber.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.bank.account_number_format\"></span></div></div></div></div><div class=\"form-group\"><div \nclass=\"col-md-12\"><h4 class=\"sub-title\" translate=\"merchant.information\"></h4></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.CompanyName.$invalid && merchantForm.CompanyName.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"merchant.company.name\"></label><div class=\"col-md-8\"><input \ntype=\"text\" name=\"CompanyName\" class=\"form-control\" ng-model=\"vm.merchant.Company.Name\" required \nis-merchant-name-available=\"vm.merchant.Company.Id\"><div ng-messages=\"merchantForm.CompanyName.$error\"><div \nng-message=\"required\" ng-if=\"merchantForm.CompanyName.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.company.name\"></span></div><div ng-message=\"isMerchantNameAvailable\" \nng-if=\"merchantForm.CompanyName.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.company.name_duplicate\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.Type.$invalid && merchantForm.Type.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"common.type\"></label><div class=\"col-md-8\"><select class=\"form-control\" \nng-model=\"vm.merchant.Type\" name=\"Type\"><option ng-repeat=\"type in vm.types\" ng-value=\"type.Id\">{{type.Name}}</option>\n</select><div ng-messages=\"merchantForm.Type.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.Type.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.merchant.type\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': merchantForm.TierSetting.$invalid && merchantForm.TierSetting.$touched}\">\n<label class=\"control-label col-md-3 required\" translate=\"merchant.tier_setting\"></label><div class=\"col-md-8\"><select \nclass=\"form-control\" name=\"TierSetting\" ng-model=\"vm.merchant.MerchantTierId\" required><option \nng-repeat=\"tier in vm.tierSettings\" ng-value=\"tier.Id\">{{tier.Name}}</option></select><div \nng-messages=\"merchantForm.TierSetting.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.TierSetting.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.merchant.tier_setting\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': merchantForm.Logo.$invalid && merchantForm.Logo.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.logo\"></label><div class=\"col-md-8\"><div class=\"logoForm-image\">\n<input type=\"text\" class=\"form-control\" ng-model=\"vm.merchant.Logo\" ng-hide=\"true\" name=\"Logo\"><div upload-control \nclass=\"upload-control image-uploader merchant-logo\" on-file-selected=\"vm.onMerchantLogoSelected($files, $control)\">\n<input name=\"file\" type=\"file\" accept=\".jpeg, .jpg, .png\" ng-show=\"false\" ng-model=\"file\"> <a class=\"btn btn-default\" \ntranslate=\"common.action.select_photo\"></a><label>{{vm.temp}}</label><div class=\"image-wrapper\"><img id=\"photo\" \nng-src=\"{{vm.merchant.Logo ? vm.merchant.Logo + \'?w=300&h=300\': \'../../assets/images/placeholder.png\'}}\"></div></div>\n<button type=\"button\" class=\"btn-delete-photo\" ng-click=\"vm.deleteLogo()\" ng-hide=\"vm.disabledDeleteLogo\"><span \nclass=\"glyphicon glyphicon-trash\"></span></button></div><div><label class=\"note\" translate=\"merchant.note\"></label>\n</div><div ng-messages=\"merchantForm.Logo.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.Logo.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.merchant.logo\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"common.webcash_id\"></label><div class=\"col-md-8\">\n<input type=\"text\" class=\"form-control\" name=\"WebcashId\" ng-model=\"vm.merchant.WebCashId\"></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"common.access_id\"></label><div class=\"col-md-8\">\n<input type=\"text\" class=\"form-control\" name=\"WebcashId\" ng-model=\"vm.merchant.AccessId\"></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"merchant.hash_key\"></label><div class=\"col-md-8\">\n<input type=\"text\" class=\"form-control\" name=\"HashKey\" ng-model=\"vm.merchant.HashKey\"></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3\" translate=\"merchant.subscribed_services\"></label><div \nclass=\"col-md-8\"><ui-select multiple=\"multiple\" ng-model=\"vm.merchant.SubscribedServices\" theme=\"bootstrap\" \nclose-on-select=\"true\"><ui-select-match placeholder=\"Select subscribed service...\">{{$item.Name | translate}}\n</ui-select-match><ui-select-choices \nrepeat=\"subscribedService.Id as subscribedService in vm.subscribedServices | filter:$select.search\"><div \nng-bind=\"subscribedService.Name | translate\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.ServiceDate.$invalid && merchantForm.ServiceDate.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.service_date\"></label><div class=\"col-md-8\"><div \nclass=\"input-group\"><input type=\"text\" name=\"ServiceDate\" class=\"form-control\" uib-datepicker-popup \nng-model=\"vm.merchant.ServiceDate\" is-open=\"vm.serviceDatePopup.opened\" datepicker-options=\"vm.dateOptions\" \nclose-text=\"Close\" autocomplete=\"off\" ng-click=\"vm.openServiceDatePopup()\"> <span class=\"input-group-btn\"><button \ntype=\"button\" class=\"btn btn-default\" ng-click=\"vm.openServiceDatePopup()\"><i class=\"glyphicon glyphicon-calendar\"></i>\n</button></span></div><div ng-messages=\"merchantForm.ServiceDate.$error\"><div ng-message=\"date\" \nng-if=\"merchantForm.ServiceDate.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.merchant.service_date_valid\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.ContractDate.$invalid && merchantForm.ContractDate.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.contract_date\"></label><div class=\"col-md-8\"><div \nclass=\"input-group\"><input type=\"text\" name=\"ContractDate\" class=\"form-control\" uib-datepicker-popup \nng-model=\"vm.merchant.ContractDate\" is-open=\"vm.contractDatePopup.opened\" datepicker-options=\"vm.dateOptions\" \nclose-text=\"Close\" autocomplete=\"off\" ng-click=\"vm.openContractDatePopup()\"> <span class=\"input-group-btn\"><button \ntype=\"button\" class=\"btn btn-default\" ng-click=\"vm.openContractDatePopup()\"><i class=\"glyphicon glyphicon-calendar\">\n</i></button></span></div><div ng-messages=\"merchantForm.ContractDate.$error\"><div ng-message=\"date\" \nng-if=\"merchantForm.ContractDate.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.merchant.contract_date_valid\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantForm.GSTSetting.$invalid && merchantForm.GSTSetting.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"merchant.gst_setting\"></label><div class=\"col-md-8\"><select \nclass=\"form-control\" ng-model=\"vm.merchant.GSTSetting\" name=\"GSTSetting\" required><option value=\"Inclusive\">Inclusive\n</option><option value=\"Exclusive\">Exclusive</option><option value=\"GSTFree\">GST Free</option></select><div \nng-messages=\"merchantForm.GSTSetting.$error\"><div ng-message=\"required\" ng-if=\"merchantForm.GSTSetting.$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.merchant.gst_setting\"></span></div></div></div></div></form>\n</div><div id=\"storeCardTopupOptionsDiv\" class=\"tab-pane fade\"><form name=\"storeCardTopupOptionsForm\" \nclass=\"form-horizontal\" novalidate id=\"storeCardTopupOptionsForm\"><br><div class=\"row\" \nng-repeat=\"storeCardTopupOption in vm.merchant.StoreCardTopupOptions track by $index\"><div class=\"form-group col-md-4\" \nng-class=\"{\'has-error\': storeCardTopupOptionsForm[\'storeCardTopupOptionName\'+$index].$invalid && storeCardTopupOptionsForm[\'storeCardTopupOptionName\'+$index].$touched}\">\n<div class=\"row\"><label class=\"control-label col-md-4 required\" translate=\"merchant.store_card_topup_option.name\">\n</label><div class=\"col-md-8\"><input type=\"text\" name=\"storeCardTopupOptionName{{$index}}\" class=\"form-control\" \nng-model=\"storeCardTopupOption.Name\" required></div></div><div class=\"row\"><div class=\"form-group col-md-12\"><div \nng-messages=\"storeCardTopupOptionsForm[\'storeCardTopupOptionName\'+$index].$error\" style=\"margin-left:33px\"><div \nng-message=\"required\" ng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionName\'+$index].$touched\" class=\"help-block\">\n<span translate=\"merchant.validate.store_card_topup_option.name\"></span></div></div></div></div></div><div \nclass=\"form-group col-md-3\" \nng-class=\"{\'has-error\': storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$invalid && storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$touched}\">\n<div class=\"row\"><label class=\"control-label col-md-6 required\" translate=\"merchant.store_card_topup_option.amount\">\n</label><div class=\"col-md-6\"><input type=\"number\" name=\"storeCardTopupOptionAmount{{$index}}\" class=\"form-control\" \nng-model=\"storeCardTopupOption.Amount\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\" required></div></div><div \nclass=\"row\"><div class=\"form-group col-md-12\"><div \nng-messages=\"storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$error\" style=\"margin-left:30px\"><div \nng-message=\"required\" ng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.store_card_topup_option.amount\"></span></div><div \nng-message=\"number\" ng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$touched\" class=\"help-block\">\n<span translate=\"merchant.validate.store_card_topup_option.amount_number\"></span></div><div ng-message=\"pattern\" \nng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionAmount\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.store_card_topup_option.amount_number\"></span></div></div></div></div></div><div \nclass=\"form-group col-md-3\" \nng-class=\"{\'has-error\': storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$invalid && storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$touched}\">\n<div class=\"row\"><label class=\"control-label col-md-6 required\" translate=\"merchant.store_card_topup_option.bonus\">\n</label><div class=\"col-md-6\"><input type=\"number\" name=\"storeCardTopupOptionBonus{{$index}}\" class=\"form-control\" \nng-model=\"storeCardTopupOption.Bonus\" ng-pattern=\"/^[0-9]+(\\.[0-9]{1,2})?$/\" step=\"0.01\" required></div></div><div \nclass=\"row\"><div class=\"form-group col-md-12\"><div \nng-messages=\"storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$error\" style=\"margin-left:40px\"><div \nng-message=\"required\" ng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$touched\" \nclass=\"help-block\"><span translate=\"merchant.validate.store_card_topup_option.bonus\"></span></div><div \nng-message=\"number\" ng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$touched\" class=\"help-block\">\n<span translate=\"merchant.validate.store_card_topup_option.bonus_number\"></span></div><div ng-message=\"pattern\" \nng-if=\"storeCardTopupOptionsForm[\'storeCardTopupOptionBonus\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"merchant.validate.store_card_topup_option.bonus_number\"></span></div></div></div></div></div><div \nclass=\"form-group col-md-2\"><a style=\"margin-left:5px\" class=\"btn btn-danger\" \nng-click=\"vm.removeStoreCardTopupOption($index)\">Remove</a></div></div><div class=\"row\"><div \nclass=\"form-group col-md-12 text-right\"><a class=\"btn btn-primary\" ng-click=\"vm.addStoreCardTopupOption()\">Add</a>\n</div></div></form></div></div></div><div class=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.cancel()\" \ntranslate=\"common.action.cancel\"></a> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.save()\" \ntranslate=\"common.action.save\"></button></div></div></div></div></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowAddUserDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" \nclass=\"close\" ng-click=\"vm.viewConfig.ShowAddUserDialog = false\"><span aria-hidden=\"true\">&times;</span><span \nclass=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\">Add user to merchant</h3></div>\n<form name=\"merchantUserForm\" class=\"form-horizontal\" ng-submit=\"vm.saveUser()\" novalidate id=\"merchantUserForm\"><div \nclass=\"modal-body\"><div class=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" translate=\"merchant.user_info\">\n</h4></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantUserForm.UserName.$invalid && merchantUserForm.UserName.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"common.username\"></label><div class=\"col-md-8\"><input type=\"email\" \nname=\"UserName\" class=\"form-control\" ng-model=\"vm.user.UserName\" required><div \nng-messages=\"merchantUserForm.UserName.$error\"><div ng-message=\"required\" ng-if=\"merchantUserForm.UserName.$touched\" \nclass=\"help-block\"><span translate=\"merchant.user.validate.user_name\"></span></div><div ng-message=\"email\" \nng-if=\"merchantUserForm.UserName.$touched\" class=\"help-block\" translate=\"merchant.user.validate.user_name_invalid\">\n</div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': merchantUserForm.Password.$invalid && merchantUserForm.Password.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"common.password\"></label><div class=\"col-md-8\"><input \ntype=\"password\" name=\"Password\" class=\"form-control\" ng-model=\"vm.user.Password\" required><div \nng-messages=\"merchantUserForm.Password.$error\"><div ng-message=\"required\" ng-if=\"merchantUserForm.Password.$touched\" \nclass=\"help-block\"><span translate=\"merchant.user.validate.password\"></span></div></div></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': merchantUserForm.ConfirmPassword.$invalid && merchantUserForm.ConfirmPassword.$touched}\"><label\n class=\"control-label col-md-3 required\" translate=\"common.confirm_password\"></label><div class=\"col-md-8\"><input \ntype=\"password\" name=\"ConfirmPassword\" class=\"form-control\" ng-model=\"vm.user.ConfirmPassword\" \nng-pattern=\"{{vm.user.Password}}\" required><div ng-messages=\"merchantUserForm.ConfirmPassword.$error\"><div \nng-message=\"required\" ng-if=\"merchantUserForm.ConfirmPassword.$touched\" class=\"help-block\"><span \ntranslate=\"merchant.user.validate.password_confirm\"></span></div><div ng-message=\"pattern\" class=\"help-block\"><span \ntranslate=\"merchant.user.validate.password_confirm_not_match\"></span></div></div></div></div><div class=\"form-group\">\n<div class=\"col-md-12\"><h4 class=\"sub-title\" translate=\"common.permission.title\"></h4></div></div><div \nclass=\"form-group\"><div class=\"col-md-3\"></div><div ng-repeat=\"permission in vm.permissions\" class=\"checkbox col-md-4\" \nng-class=\"{\'col-md-offset-3\':$index%2==0&&$index!=0}\"><label><input type=\"checkbox\" \nng-click=\"vm.addPermission(permission.Value)\" ng-checked=\"vm.permissionSelected(permission.Value)\">\n{{permission.Name | translate}}</label></div></div></div><div class=\"modal-footer\"><a class=\"btn btn-warning\" \nng-click=\"vm.selectAll()\" translate=\"common.action.select_all\"></a> <a class=\"btn btn-danger\" \nng-click=\"vm.viewConfig.ShowAddUserDialog = false\" translate=\"common.action.cancel\"></a> <button type=\"submit\" \nclass=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div></div></div>");
$templateCache.put("app/university/university-portal/portal-campus.html","<h1 class=\"page-header\" ng-init=\"vm.search()\">Campus</h1><div id=\"brand\" class=\"col-md-12\" \nng-controller=\"portalcampusController\" ng-init=\"vm.getUniversities()\"><div class=\"form-horizontal\"><div \nclass=\"form-group\"><div class=\"row\"><div class=\"col-md-3 col-xs-6\"><input type=\"text\" class=\"form-control\" \nid=\"searchtxt\" ng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"Enter the campus name\"></div><div class=\"col-md-1 col-xs-3\"><a class=\"btn btn-primary pull-right\" \nng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a>\n</div><div class=\"col-md-2 col-md-offset-6 col-xs-3\"><a class=\"btn btn-primary pull-right\" \nng-click=\"vm.openDialog(\'new\',null, brandForm)\"><i class=\"glyphicon glyphicon-plus\"></i> <span \ntranslate=\"common.action.add\"></span></a></div></div></div><div class=\"table-responsive form-group\"><table \nclass=\"table table-striped table-bordered\"><thead><tr><th style=\"display:none\">Campus ID</th><th>Campus Name</th><th>\nUniversity</th><th>Address</th><th>State</th><th>Created By</th><td>Action</td></tr></thead><tbody><tr \nng-repeat=\"campus in vm.campusList\"><td style=\"display:none\">{{campus.CmapusId}}</td><td>{{campus.Name}}</td><td \nclass=\"center\">{{campus.UniveristyId}}</td><td>{{campus.Address}}</td><td>{{campus.Location}}</td><td>\n{{campus.CreatedBy}}</td><td class=\"center\"><a title=\"Edit\" class=\"btn btn-default\" \nng-click=\"vm.openDialog(\'edit\', campus.CmapusId, brandForm)\"><i class=\"glyphicon glyphicon-edit\"></i></a><a \nclass=\"btn btn-primary\" ng-if=\"campus.Publish === false\" mwl-confirm title=\"Publish\" \nmessage=\"Are you really <b>sure</b> you want to publish this campus?\" confirm-text=\"OK\" cancel-text=\"Cancel\" \non-confirm=\"vm.publish(campus.CmapusId, campus.Publish)\" on-cancel=\"\" confirm-button-type=\"danger\" \ncancel-button-type=\"default\"><i class=\"glyphicon glyphicon-cloud-upload\"></i> </a><a class=\"btn btn-danger\" \nng-if=\"campus.Publish === true\" mwl-confirm title=\"Unpublish\" \nmessage=\"Are you really <b>sure</b> you want to unpublish this campus?\" confirm-text=\"OK\" cancel-text=\"Cancel\" \non-confirm=\"vm.publish(campus.CmapusId, campus.Publish)\" on-cancel=\"\" confirm-button-type=\"danger\" \ncancel-button-type=\"default\"><i class=\"glyphicon glyphicon-cloud-download\"></i></a></td></tr></tbody></table></div><ul \nuib-pagination total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-change=\"vm.search()\" \nng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul>\n</div><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" \ntabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><form \nname=\"brandForm\" class=\"form-horizontal\" ng-submit=\"vm.save(brandForm)\" novalidate id=\"brandForm\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowDialog = false\"><span \naria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" \nid=\"modal-title\">Campus Details</h3></div><div class=\"modal-body\"><div class=\"form-group\" id=\"universityBlock1\"><label \nclass=\"control-label col-md-3\">University ID</label><div class=\"col-md-8\"><input name=\"UniversityId\" type=\"text\" \nclass=\"form-control\" ng-model=\"vm.campus.UniveristyId\"></div></div><div class=\"form-group\" id=\"universityBlock2\" \nng-class=\"{\'has-error\': brandForm.UniversityId.$invalid && brandForm.UniversityId.$touched }\"><label \nclass=\"control-label col-md-3\">University *</label><div class=\"col-md-8\"><select class=\"form-control\" \nid=\"UniversityId\" name=\"UniversityId\" ng-model=\"vm.campus.UniveristyId\" required ng-change=\"vm.getSelected(brandForm)\">\n<option value=\"\">--Select University--</option><option ng-repeat=\"university in vm.universtyList\" \nvalue=\"{{university.UniversityId}}\">{{university.Name}}</option></select><div \nng-messages=\"brandForm.UniversityId.$error\"><div ng-message=\"required\" ng-if=\"brandForm.UniversityId.$touched\" \nclass=\"help-block\"><span class=\"error\">Id is required field</span></div></div></div></div><div class=\"form-group\" \nstyle=\"display:none\" ng-class=\"{\'has-error\': brandForm.CampusId.$invalid && brandForm.CampusId.$touched }\"><label \nclass=\"control-label col-md-3\">Campus ID *</label><div class=\"col-md-8\"><input name=\"CampusId\" type=\"text\" \nclass=\"form-control\" readonly=\"readonly\" ng-model=\"vm.campus.CmapusId\"><div ng-messages=\"brandForm.CampusId.$error\">\n<div ng-message=\"required\" ng-if=\"brandForm.CampusId.$touched && !vm.CampusId\" class=\"help-block\"><span class=\"error\">\nId is required field</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': brandForm.CampusName.$invalid && brandForm.CampusName.$touched}\"><label \nclass=\"control-label col-md-3\">Campus Name *</label><div class=\"col-md-8\"><input name=\"CampusName\" type=\"text\" \nclass=\"form-control\" ng-model=\"vm.campus.Name\" required><div ng-messages=\"brandForm.CampusName.$error\"><div \nng-message=\"required\" ng-if=\"brandForm.CampusName.$touched && !vm.CampusName\" class=\"help-block\"><span class=\"error\">\nName is required field</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': brandForm.CampusLocation.$invalid && brandForm.CampusLocation.$touched}\"><label \nclass=\"control-label col-md-3\">State *</label><div class=\"col-md-8\"><input name=\"CampusLocation\" type=\"text\" \nclass=\"form-control\" ng-model=\"vm.campus.Location\" required><div ng-messages=\"brandForm.CampusLocation.$error\"><div \nng-message=\"required\" ng-if=\"brandForm.CampusLocation.$touched\" class=\"help-block\"><span class=\"error\">\nState is required field</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': brandForm.CampusAddress.$invalid && brandForm.CampusAddress.$touched}\"><label \nclass=\"control-label col-md-3\">Address *</label><div class=\"col-md-8\"><input name=\"CampusAddress\" type=\"text\" \nclass=\"form-control\" ng-model=\"vm.campus.Address\" required><div ng-messages=\"brandForm.CampusAddress.$error\"><div \nng-message=\"required\" ng-if=\"brandForm.CampusAddress.$touched && !vm.CampusId\" class=\"help-block\"><span class=\"error\">\nAddress is required field</span></div></div></div></div></div><div class=\"modal-footer\"><a class=\"btn btn-danger\" \nng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button type=\"submit\" class=\"btn btn-primary\" \ntranslate=\"common.action.save\"></button></div></form></div></div></div></div></div>");
$templateCache.put("app/university/university-portal/portal.html","<h1 class=\"page-header\" ng-init=\"vm.search()\">University</h1><div id=\"brand\" class=\"col-md-12\" \nng-controller=\"portalController\"><div class=\"form-horizontal\"><div class=\"form-group\" ng-init=\"vm.getBrands()\"><div \nclass=\"row\"><div class=\"col-md-3 col-xs-6\"><input type=\"text\" class=\"form-control\" id=\"searchtxt\" \nng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" placeholder=\"Enter the university name\"></div>\n<div class=\"col-md-1 col-xs-3\"><a class=\"btn btn-primary pull-right\" ng-click=\"vm.reset()\"><i \nclass=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a></div><div \nclass=\"col-md-2 col-md-offset-6 col-xs-3\"><a class=\"btn btn-primary pull-right\" \nng-click=\"vm.openDialog(\'new\', null, brandForm)\"><i class=\"glyphicon glyphicon-plus\"></i> <span \ntranslate=\"common.action.add\"></span></a></div></div></div><div class=\"table-responsive form-group\"><table \nclass=\"table table-striped table-bordered\"><thead><tr><th>Id</th><th>Name</th><th>Created By</th><th>Zakat</th><th>\nBankIslam</th><th>Meal Plan</th><th>Zakat Transfer</th><th>Action</th></tr></thead><tbody><tr \nng-repeat=\"university in vm.universtyList\"><td class=\"center\">{{university.UniversityId}}</td><td>{{university.Name}}\n</td><td>{{university.CreatedBy}}</td><td>{{university.IsZakatAvailable ? \'Yes\':\'No\'}}</td><td>\n{{university.IsBankIslamEnabled ? \'Yes\':\'No\'}}</td><td>{{university.IsMealPlanEnabled ? \'Yes\':\'No\'}}</td><td>\n{{university.IsZakatTransferEnabled ? \'Yes\':\'No\'}}</td><td class=\"center\"><a title=\"Edit\" class=\"btn btn-default\" \nng-click=\"vm.openDialog(\'edit\', university.UniversityId, brandForm)\"><i class=\"glyphicon glyphicon-edit\"></i></a> <a \nclass=\"btn btn-primary\" ng-if=\"university.Publish === false\" mwl-confirm title=\"Publish\" \nmessage=\"Are you really <b>sure</b> you want to publish this university?\" confirm-text=\"OK\" cancel-text=\"Cancel\" \non-confirm=\"vm.publish(university.UniversityId, university.Publish)\" on-cancel=\"\" confirm-button-type=\"danger\" \ncancel-button-type=\"default\"><i class=\"glyphicon glyphicon-cloud-upload\"></i> </a><a class=\"btn btn-danger\" \nng-if=\"university.Publish === true\" mwl-confirm title=\"Unpublish\" \nmessage=\"Are you really <b>sure</b> you want to unpublish this university, any merchant belongs to this university will become normal merchant!\" \nconfirm-text=\"OK\" cancel-text=\"Cancel\" on-confirm=\"vm.publish(university.UniversityId, university.Publish)\" \non-cancel=\"\" confirm-button-type=\"danger\" cancel-button-type=\"default\"><i class=\"glyphicon glyphicon-cloud-download\">\n</i> </a><a class=\"btn btn-primary\" ng-if=\"university.IsPortalPublish === false\" mwl-confirm title=\"Publish-Portal\" \nmessage=\"Are you really <b>sure</b> you want to publish this university only in portal?\" confirm-text=\"OK\" \ncancel-text=\"Cancel\" on-confirm=\"vm.publishPortal(university.UniversityId, university.IsPortalPublish)\" on-cancel=\"\" \nconfirm-button-type=\"danger\" cancel-button-type=\"default\"><i class=\"glyphicon glyphicon-cloud-upload\"></i> </a><a \nclass=\"btn btn-danger\" ng-if=\"university.IsPortalPublish === true\" mwl-confirm title=\"Unpublish-Portal\" \nmessage=\"Are you really <b>sure</b> you want to unpublish this university in portal, any merchant belongs to this university will become normal merchant!\" \nconfirm-text=\"OK\" cancel-text=\"Cancel\" \non-confirm=\"vm.publishPortal(university.UniversityId, university.IsPortalPublish)\" on-cancel=\"\" \nconfirm-button-type=\"danger\" cancel-button-type=\"default\"><i class=\"glyphicon glyphicon-cloud-download\"></i></a></td>\n</tr></tbody></table></div><ul uib-pagination total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" \nng-change=\"vm.search()\" ng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" \nboundary-link-numbers=\"true\" rotate=\"false\"></ul></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div \nclass=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><form name=\"brandForm\" class=\"form-horizontal\" \nng-submit=\"vm.save(brandForm)\" novalidate><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.viewConfig.ShowDialog = false\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span>\n</button><h3 class=\"modal-title center\" id=\"modal-title\">University Details</h3></div><div class=\"modal-body\"><div \nclass=\"form-group\" id=\"Brand\" ng-class=\"{\'has-error\': brandForm.BrandId.$touched && brandForm.BrandId.$invalid}\"><label\n class=\"control-label col-md-3\">Brand *</label><div class=\"col-md-8\"><select class=\"form-control\" name=\"BrandId\" \nid=\"BrandId\" ng-model=\"vm.university.BrandId\" required ng-change=\"vm.getSelected(brandForm)\"><option value=\"\">\n-- seclect an option --</option><option ng-repeat=\"brand in vm.brands\" value=\"{{brand.Id}}\">{{brand.Name}}</option>\n</select><div ng-messages=\"brandForm.BrandId.$error\"><div ng-message=\"required\" ng-if=\"brandForm.BrandId.$touched\" \nclass=\"help-block\"><span>Brand is required field</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': brandForm.universityId.$invalid && brandForm.universityId.$touched }\"><label \nclass=\"control-label col-md-3\">University Id *</label><div class=\"col-md-8\"><input name=\"universityId\" type=\"text\" \nng-blur=\"vm.changetext($event)\" ng-pattern=\"/^[a-zA-Z0-9]*$/\" class=\"form-control\" \nng-model=\"vm.university.UniversityId\" required><div ng-messages=\"brandForm.universityId.$error\"><div \nng-message=\"required\" ng-if=\"brandForm.universityId.$touched\" class=\"help-block\"><span class=\"error\">\nId is required field//Space Not allowed</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': brandForm.universityname.$invalid && brandForm.universityname.$touched }\"><label \nclass=\"control-label col-md-3\">Name *</label><div class=\"col-md-8\"><input name=\"universityname\" type=\"text\" \nclass=\"form-control\" ng-model=\"vm.university.Name\" required><div ng-messages=\"brandForm.universityname.$error\"><div \nng-message=\"required\" ng-if=\"brandForm.universityname.$touched\" class=\"help-block\"><span class=\"error\">\nName is required field</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': brandForm.universitylogo.$invalid && brandForm.universitylogo.$touched }\"><label \nclass=\"control-label col-md-3\">Logo URL</label><div class=\"col-md-8\"><input name=\"universitylogo\" id=\"universitylogo\" \ntype=\"text\" class=\"form-control\" ng-model=\"vm.university.LogoUrl\"><div ng-messages=\"brandForm.universitylogo.$error\">\n<div ng-message=\"required\" ng-if=\"brandForm.universitylogo.$touched\" class=\"help-block\"><span class=\"error\">\nLogo is required field</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': brandForm.Badgefile.$invalid && brandForm.Badgefile.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"Badges*\">Badge*</label><div class=\"photos-form col-md-8\"><div \nclass=\"upload-controls\" ng-if=\"vm.university.Badges.length==0\"><input type=\"file\" class=\"button\" \nngf-select=\"vm.uploadBadges($files, $invalidFiles)\" name=\"Badgefile\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" \nng-model=\"vm.temp1.badge\" ngf-multiple=\"false\"></div><div class=\"file-list\" style=\"width:100%\"><div \nng-messages=\"brandForm.Badgefile.$error\"><div ng-message=\"dimensions\" ng-if=\"brandForm.Badgefile.$dirty\" \nclass=\"help-block\"><p translate=\"community.configuration.validate.photo.dimension\"></p></div></div><ul \ndnd-list=\"vm.university.Badges\"><li ng-repeat=\"photo in vm.university.Badges\" style=\"font:smaller\"><div \nclass=\"preview-photos\"><span class=\"dnd\"></span> <img style=\"width:100%;padding-bottom:1%\" src=\"{{photo}}\" \nclass=\"thumb\"> <a ng-click=\"vm.removeBadge($index)\" class=\"btn btn-danger\"><i class=\"glyphicon glyphicon-remove\"></i> \n<span translate=\"Remove\"></span></a></div></li></ul></div></div></div><div class=\"form-group\" id=\"Zakat\" \nng-class=\"{\'has-error\': brandForm.Zakat.$touched && brandForm.Zakat.$invalid}\"><label class=\"control-label col-md-3\">\nZakat Available?</label><div class=\"btn-group col-md-8\"><label class=\"btn btn-default\" name=\"KiplekashBillPayment\" \nng-model=\"vm.university.IsZakatAvailable\" uib-btn-radio=\"true\">YES</label><label class=\"btn btn-default\" \nname=\"KiplekashBillPayment\" ng-model=\"vm.university.IsZakatAvailable\" uib-btn-radio=\"false\">NO</label><div \nng-messages=\"brandForm.Zakat.$error\"><div ng-message=\"required\" ng-if=\"brandForm.Zakat.$touched\" class=\"help-block\">\n<span>Zakat is required field</span></div></div></div></div><div class=\"form-group\" id=\"ZakatBankIslam\" \nng-class=\"{\'has-error\': brandForm.ZakatBankIslam.$touched && brandForm.ZakatBankIslam.$invalid}\"><label \nclass=\"control-label col-md-3\">Bank Islam Enabled?</label><div class=\"btn-group col-md-8\"><label \nclass=\"btn btn-default\" name=\"BankIslamEnabled\" ng-model=\"vm.university.IsBankIslamEnabled\" uib-btn-radio=\"true\">YES\n</label><label class=\"btn btn-default\" name=\"BankIslamEnabled\" ng-model=\"vm.university.IsBankIslamEnabled\" \nuib-btn-radio=\"false\">NO</label><div ng-messages=\"brandForm.ZakatBankIslam.$error\"><div ng-message=\"required\" \nng-if=\"brandForm.ZakatBankIslam.$touched\" class=\"help-block\"><span>BankIslam Enabled is required field</span></div>\n</div></div></div><div class=\"form-group\" id=\"ZakatBankIslam\" \nng-class=\"{\'has-error\': brandForm.IsMealPlan.$touched && brandForm.IsMealPlan.$invalid}\"><label \nclass=\"control-label col-md-3\">Meal Plan Enabled?</label><div class=\"btn-group col-md-8\"><label \nclass=\"btn btn-default\" name=\"IsMealPlanEnabled\" ng-model=\"vm.university.IsMealPlanEnabled\" uib-btn-radio=\"true\">YES\n</label><label class=\"btn btn-default\" name=\"IsMealPlanEnabled\" ng-model=\"vm.university.IsMealPlanEnabled\" \nuib-btn-radio=\"false\">NO</label><div ng-messages=\"brandForm.IsMealPlan.$error\"><div ng-message=\"required\" \nng-if=\"brandForm.IsMealPlan.$touched\" class=\"help-block\"><span>Meal Plan Enabled is required field</span></div></div>\n</div></div><div class=\"form-group\" id=\"IsZakatTransfer\" \nng-class=\"{\'has-error\': brandForm.IsZakatTransfer.$touched && brandForm.IsZakatTransfer.$invalid}\"><label \nclass=\"control-label col-md-3\">Zakat Transfer Enabled?</label><div class=\"btn-group col-md-8\"><label \nclass=\"btn btn-default\" name=\"IsZakatTransferEnabled\" ng-model=\"vm.university.IsZakatTransferEnabled\" \nuib-btn-radio=\"true\">YES</label><label class=\"btn btn-default\" name=\"IsZakatTransferEnabled\" \nng-model=\"vm.university.IsZakatTransferEnabled\" uib-btn-radio=\"false\">NO</label><div \nng-messages=\"brandForm.IsZakatTransfer.$error\"><div ng-message=\"required\" ng-if=\"brandForm.IsZakatTransfer.$touched\" \nclass=\"help-block\"><span>Zakat Transfer Enabled is required field</span></div></div></div></div></div><div \nclass=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.cancel(brandForm)\" translate=\"common.action.cancel\"></a> \n<button type=\"submit\" class=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div>\n</div></div>");
$templateCache.put("app/university/verify-student/verify.student.html","<h1 class=\"page-header\">Verify Students</h1><div id=\"main\"><div class=\"container\"><form \nclass=\"form-signin form-horizontal\" name=\"uploadfile_form\" ng-submit=\"vm.verifyStudent()\" novalidate \nng-form-touched-on-submit><div class=\"btn btn-rounded form-control\"><input name=\"files\" id=\"myfile\" type=\"file\" \nclass=\"input_file form-control\" placeholder=\"select file\" multiple=\"multiple\"></div><div class=\"btn-submit\"><button \nclass=\"btn btn-lg btn-primary\" type=\"submit\">Submit</button></div></form></div></div>");
$templateCache.put("app/university/university-report/outlet-transactions.html","<div id=\"outlet_transactions\"><h1 class=\"page-header\" translate=\"report.names.outlet_transactions_report\" \nng-init=\"vm.getUniversities()\"></h1><div class=\"report-filter\"><div class=\"panel panel-default\"><div \nclass=\"panel-heading\" data-toggle=\"collapse\" data-target=\"#collapse_panel\"><span class=\"panel-title\" \ntranslate=\"report.report_filter\"></span> <a class=\"pull-right\"><i class=\"glyphicon glyphicon-fullscreen\"></i></a></div>\n<div id=\"collapse_panel\" class=\"collapse in\"><div class=\"panel-body\"><div class=\"form-group\" id=\"univeristyDiv\"><label \nclass=\"control-label col-md-3\">University</label><select class=\"form-control\" id=\"UniversityId\" name=\"UniversityId\" \nng-model=\"vm.university.UniversityId\" ng-change=\"vm.getSelected()\"><option value=\"\">--Select University--</option>\n<option value=\"all\">All</option><option ng-repeat=\"university in vm.universtyList\" value=\"{{university.UniversityId}}\">\n{{university.Name}}</option></select></div><div class=\"form-group\"><label class=\"control-label col-md-3\">Campus</label>\n<select class=\"form-control\" id=\"CampusId\" name=\"CampusId\" ng-model=\"vm.filter.CampusId\"><option value=\"\">All</option>\n<option ng-repeat=\"campus in vm.CampusList\" value=\"{{campus.CmapusId}}\">{{campus.Name}}</option></select></div><div \nclass=\"form-group\"><label class=\"control-label\" translate=\"report.statement_of_account.merchant\"></label><ui-select \nng-model=\"vm.filter.MerchantId\" theme=\"bootstrap\"><ui-select-match placeholder=\"All\">{{$select.selected.Name}}\n</ui-select-match><ui-select-choices repeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" \nrefresh=\"vm.loadMerchant($select.search)\" refresh-delay=\"0\" minimum-input-length=\"0\"><div \nng-bind-html=\"merchant.Name | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><div \nstyle=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.statement_of_account.outlet\"></label><select class=\"form-control\" ng-model=\"vm.filter.StoreId\">\n<option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option><option ng-value=\"store.Id\" \nng-repeat=\"store in vm.stores[vm.filter.MerchantId]\">{{store.Name}}</option></select></div><div class=\"row\"><div \nclass=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.statement_of_account.transaction_id\"></label><input type=\"text\" id=\"tid\" class=\"form-control\" \nng-model=\"vm.filter.TransactionId\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.statement_of_account.transaction_type\"></label><select class=\"form-control\" \nid=\"ttype\" ng-model=\"vm.filter.TransactionAction\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}\n</option><option ng-repeat=\"v in vm.actionOptions\" ng-value=\"v.value\">{{v.display| translate}}</option></select></div>\n</div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label required\" \ntranslate=\"report.common.transaction_start_date\"></label><input type=\"text\" id=\"sdate\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" \nng-model=\"vm.filter.TransactionStartDate\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label required\" translate=\"report.common.transaction_end_date\"></label><input type=\"text\" id=\"edate\" \nclass=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" \nng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.filter.TransactionEndDate\"></div></div></div><div class=\"row\"><div \nclass=\"col-xs-12\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.getReport()\" \ntranslate=\"report.summarize\"></button></div></div></div></div></div></div><div class=\"table-responsive\"><table \ndatatable dt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.tableInstance\"><thead><tr><th>\n{{ \'report.statement_of_account.transaction_id\' | translate}}</th><th>\n{{ \'report.statement_of_account.transaction_date_time\' | translate}}</th><th>\n{{ \'report.statement_of_account.merchant_name\' | translate }}</th><th>\n{{ \'report.statement_of_account.transaction_type\' | translate }}</th><th>\n{{ \'report.statement_of_account.gross_amount\' | translate }}</th><th>\n{{ \'report.statement_of_account.cashback\' | translate }}</th><th>\n{{ \'report.statement_of_account.remarks\' | translate }}</th><th>{{ \'report.statement_of_account.user_id\' | translate }}\n</th><th>{{ \'report.statement_of_account.UserCategoryType\' | translate }}</th><th>University ID</th><th>Campaingn Name\n</th><th>Inasis</th></tr></thead></table></div></div>");
$templateCache.put("app/university/university-report/referral-code-summary-report.html","<div id=\"referral_code\"><h1 class=\"page-header\" translate=\"Referral Code Summary Report\"></h1><div \nclass=\"report-filter\"><div class=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" \ndata-target=\"#collapse_panel\"><span class=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\">\n<i class=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"RegistrationStartDate\"></label><input type=\"text\" id=\"Regsdate\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.RegStartOpen\" ng-click=\"vm.datePopup.RegStartOpen = true\" \nng-model=\"vm.filter.RegStartDate\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"RegistrationEndDate\"></label><input type=\"text\" id=\"Regedate\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.RegEndOpen\" ng-click=\"vm.datePopup.RegEndOpen = true\" \nng-model=\"vm.filter.RegEndDate\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label\n class=\"control-label\" translate=\"ReferralStartDate\"></label><input type=\"text\" id=\"Refsdate\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.RefStartOpen\" ng-click=\"vm.datePopup.RefStartOpen = true\" \nng-model=\"vm.filter.RefStartDate\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"ReferralEndDate\"></label><input type=\"text\" id=\"Refedate\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.RefEndOpen\" ng-click=\"vm.datePopup.RefEndOpen = true\" \nng-model=\"vm.filter.RefEndDate\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label\n class=\"control-label\" translate=\"ReferralCode\"></label><input type=\"text\" id=\"RCodeFilter\" class=\"form-control\" \nng-model=\"vm.filter.ReferralCode\"></div></div><div class=\"col-md-6\" style=\"padding-top:3%\"><button type=\"button\" \nclass=\"btn btn-primary pull-right\" ng-click=\"showcase.getReport()\" translate=\"report.summarize\"></button></div></div>\n</div></div></div></div><div class=\"form-group\"><div class=\"row\"><div id=\"PrincipalUserNameDiv\" \nclass=\"col-md-3 col-xs-12 margin-tb\"><label class=\"col-md-4\" translate=\"UserName\"></label><div class=\"col-md-8\"><span \nid=\"PrincipalUserName\"></span></div></div><div id=\"PrincipalReferralCodeDiv\" class=\"col-md-5 col-xs-12 margin-tb\">\n<label class=\"col-md-4\" translate=\"ReferralCode\"></label><div class=\"col-md-8\"><span id=\"PrincipalReferralCode\"></span>\n</div></div></div></div><div class=\"table-responsive\"><table datatable dt-options=\"showcase.dataTable.options\" \ndt-columns=\"showcase.dataTable.columns\" class=\"table table-bordered table-striped table-hover\" \ndt-instance=\"showcase.tableInstance\"><thead><tr><th>UserId</th><th>User Name</th><th>Email</th><th>PhoneNumber</th><th>\nReferralCode</th><th>ReferralDate</th><th>Used</th><th>Shared</th><th>RegistrationDate</th><th>Status</th><th>Tag</th>\n</tr></thead></table></div></div>");
$templateCache.put("app/university/university-report/university-payment-report.html","<div id=\"statement_of_account_report\"><h1 class=\"page-header\" translate=\"report.names.university_payment_report\" \nng-init=\"vm.getUniversities()\"></h1><div class=\"report-filter\"><div class=\"panel panel-default\"><div \nclass=\"panel-heading\" data-toggle=\"collapse\" data-target=\"#collapse_panel\"><span class=\"panel-title\" \ntranslate=\"report.report_filter\"></span> <a class=\"pull-right\"><i class=\"glyphicon glyphicon-fullscreen\"></i></a></div>\n<div id=\"collapse_panel\" class=\"collapse in\"><div class=\"panel-body\"><div class=\"form-group\" id=\"univeristyDiv\"><label \nclass=\"control-label col-md-3\">University</label><select class=\"form-control\" id=\"UniversityId\" name=\"UniversityId\" \nng-model=\"vm.filter.UniversityId\" ng-change=\"vm.getSelected()\"><option value=\"\">--Select University--</option><option \nvalue=\"all\">All</option><option ng-repeat=\"university in vm.universtyList\" value=\"{{university.UniversityId}}\">\n{{university.Name}}</option></select></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label required\" translate=\"report.common.transaction_start_date\"></label><input type=\"text\" id=\"sdate\" \nclass=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" \nng-click=\"vm.datePopup.StartOpen = true\" ng-model=\"vm.filter.TransactionStartDate\"></div></div><div class=\"col-md-6\">\n<div class=\"form-group\"><label class=\"control-label required\" translate=\"report.common.transaction_end_date\"></label>\n<input type=\"text\" id=\"edate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" \nng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.filter.TransactionEndDate\"></div></div></div><div class=\"row\"><div \nclass=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" translate=\"UserName\"></label><input type=\"text\" \nclass=\"form-control\" ng-model=\"vm.filter.UserName\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"Organization Category\"></label><select name=\"channel\" class=\"form-control\" \nng-model=\"vm.filter.OrganizationCategory\" required><option ng-value=\"null\"></option><option \nng-repeat=\"option in vm.OrganizationCategory\" value=\"{{option.Id}}\">{{option.Name}}</option></select></div></div></div>\n<div class=\"row\"><div class=\"col-xs-12\"><button type=\"button\" class=\"btn btn-primary pull-right\" \nng-click=\"vm.getReport()\" translate=\"report.summarize\">Search</button></div></div></div></div></div></div><div \nclass=\"table-responsive\"><table datatable dt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.tableInstance\"><thead><tr><th hidden>\n{{ \'report.university_payment_report.id\' | translate}}</th><th>Transaction Id</th><th>Created At</th><th>User Name</th>\n<th>Email</th><th>Organization Category</th><th>University Id</th><th>Merchant Name</th><th>Bill Code</th><th>\nAccount Number</th><th>Cash</th><th>Kiplekash</th><th>Card</th><th>Amount</th><th>Status</th><th>Student Id</th><th>\nInasis</th></tr></thead></table></div></div>");
$templateCache.put("app/university/university-report/university-statement-of-account.html","<div id=\"statement_of_account_report\"><h1 class=\"page-header\" translate=\"report.names.statement_of_account_report\" \nng-init=\"vm.getUniversities()\"></h1><div class=\"report-filter\"><div class=\"panel panel-default\"><div \nclass=\"panel-heading\" data-toggle=\"collapse\" data-target=\"#collapse_panel\"><span class=\"panel-title\" \ntranslate=\"report.report_filter\"></span> <a class=\"pull-right\"><i class=\"glyphicon glyphicon-fullscreen\"></i></a></div>\n<div id=\"collapse_panel\" class=\"collapse in\"><div class=\"panel-body\"><div class=\"form-group\" id=\"univeristyDiv\"><label \nclass=\"control-label col-md-3\">University</label><select class=\"form-control\" id=\"UniversityId\" name=\"UniversityId\" \nng-model=\"vm.university.UniversityId\" ng-change=\"vm.getSelected()\"><option value=\"\">--Select University--</option>\n<option value=\"all\">All</option><option ng-repeat=\"university in vm.universtyList\" value=\"{{university.UniversityId}}\">\n{{university.Name}}</option></select></div><div class=\"form-group\"><label class=\"control-label col-md-3\">Campus</label>\n<select class=\"form-control\" id=\"CampusId\" name=\"CampusId\" ng-model=\"vm.filter.CampusId\"><option value=\"\">All</option>\n<option ng-repeat=\"campus in vm.CampusList\" value=\"{{campus.CmapusId}}\">{{campus.Name}}</option></select></div><div \nclass=\"form-group\"><label class=\"control-label\" translate=\"report.statement_of_account.merchant\"></label><ui-select \nng-model=\"vm.filter.MerchantId\" theme=\"bootstrap\"><ui-select-match placeholder=\"All\">{{$select.selected.Name}}\n</ui-select-match><ui-select-choices repeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" \nrefresh=\"vm.loadMerchant($select.search)\" refresh-delay=\"0\" minimum-input-length=\"0\"><div \nng-bind-html=\"merchant.Name | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><div \nstyle=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.statement_of_account.transaction_id\"></label><input type=\"text\" id=\"tid\" \nclass=\"form-control\" ng-model=\"vm.filter.TransactionId\"></div></div><div class=\"col-md-6\"><div class=\"form-group\">\n<label class=\"control-label\" translate=\"report.statement_of_account.transaction_type\"></label><select \nclass=\"form-control\" id=\"type\" ng-model=\"vm.filter.TransactionAction\"><option ng-value=\"null\">\n{{ \'report.common.option_all\' | translate }}</option><option ng-repeat=\"v in vm.actionOptions\" ng-value=\"v.value\">\n{{v.display| translate}}</option></select></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div \nclass=\"form-group\"><label class=\"control-label required\" translate=\"report.common.transaction_start_date\"></label>\n<input type=\"text\" id=\"sdate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" \nng-click=\"vm.datePopup.StartOpen = true\" ng-model=\"vm.filter.TransactionStartDate\"></div></div><div class=\"col-md-6\">\n<div class=\"form-group\"><label class=\"control-label required\" translate=\"report.common.transaction_end_date\"></label>\n<input type=\"text\" id=\"edate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" \nng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.filter.TransactionEndDate\"></div></div><div class=\"col-md-6\"><div \nclass=\"form-group\"><label class=\"control-label\" translate=\"Campaign Name\"></label><input type=\"text\" \nclass=\"form-control\" ng-model=\"vm.filter.CampaignName\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div \nclass=\"form-group\"><label class=\"control-label\" translate=\"Payment Type\"></label><select class=\"form-control\" \nid=\"type\" ng-model=\"vm.filter.PaymentChannel\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}\n</option><option ng-repeat=\"v in vm.PaymentChannel\" ng-value=\"v.value\">{{v.display| translate}}</option></select></div>\n</div></div><div class=\"row\"><div class=\"col-xs-12\"><button type=\"button\" class=\"btn btn-primary pull-right\" \nng-click=\"vm.getReport()\" translate=\"report.summarize\">Search</button></div></div></div></div></div></div><div \nclass=\"table-responsive\"><table datatable dt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.tableInstance\"><thead><tr><th>\n{{ \'report.statement_of_account.transaction_id\' | translate}}</th><th>\n{{ \'report.statement_of_account.transaction_date_time\' | translate}}</th><th>\n{{ \'report.statement_of_account.merchant_name\' | translate }}</th><th>\n{{ \'report.statement_of_account.transaction_type\' | translate }}</th><th>Payment Type</th><th>\n{{ \'report.statement_of_account.gross_amount\' | translate }}</th><th>\n{{ \'report.statement_of_account.deduction_mdr\' | translate }}</th><th>\n{{ \'report.statement_of_account.deduction_gst\' | translate }}</th><th>\n{{ \'report.statement_of_account.settlement_to_merchant\' | translate }}</th><th>\n{{ \'report.statement_of_account.user_id\' | translate }}</th><th>\n{{ \'report.statement_of_account.UserCategoryType\' | translate }}</th><th>\n{{ \'report.statement_of_account.outlet_id\' | translate }}</th><th>\n{{ \'report.statement_of_account.CampaignName\' | translate }}</th><th>University ID</th><th>Inasis</th></tr></thead>\n</table></div></div>");
$templateCache.put("app/store/table/table.html","<h1 class=\"page-header\" translate=\"store.table.title\"></h1><div id=\"storeTable\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div class=\"col-md-3 margin-tb\"><input type=\"text\" \nclass=\"form-control\" ng-model=\"vm.criteria.Keyword\" ng-keypress=\"vm.searchByKeyword($event)\" \nplaceholder=\"Enter the name of table\"></div><div class=\"col-md-1\"><a class=\"btn btn-primary pull-right margin-tl\" \nng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a>\n</div><div class=\"col-md-8\"><a class=\"btn btn-primary margin-tl pull-right\" ng-click=\"vm.openQRCode()\"><i \nclass=\"glyphicon\"></i><span translate=\"store.table.create_qr_code\"></span></a> <a \nclass=\"btn btn-primary margin-tl pull-right\" ng-click=\"vm.add()\"><i class=\"glyphicon glyphicon-plus\"></i> <span \ntranslate=\"common.action.add\"></span></a></div></div></div><div class=\"form-group\"><div class=\"table-responsive\"><table\n class=\"table table-striped table-bordered\"><thead><tr><th>#</th><th translate=\"common.name\"></th><th \ntranslate=\"store.table.number_of_seat\"></th><th translate=\"store.table.store_name\"></th><th \ntranslate=\"common.action.title\"></th></tr></thead><tbody><tr ng-repeat=\"table in vm.tables\"><td class=\"center\">\n{{$index + 1}}</td><td>{{table.Name}}</td><td>{{table.NumberOfSeat}}</td><td>{{table.StoreName}}</td><td \nclass=\"center\"><a title=\"Edit\" class=\"btn btn-default margin-tl\" ng-click=\"vm.edit(table)\"><i \nclass=\"glyphicon glyphicon-edit\"></i></a> <a title=\"Generate qrcode\" class=\"btn btn-default margin-tl\" \nng-click=\"vm.getQRCode(table)\"><i class=\"glyphicon glyphicon-qrcode\"></i></a> <a title=\"Remove\" \nclass=\"btn btn-danger margin-tl\" ng-click=\"vm.remove(table.Id)\"><i class=\"glyphicon glyphicon-remove\"></i></a></td>\n</tr></tbody></table></div><ul uib-pagination total-items=\"vm.totalItems\" ng-change=\"vm.search()\" \nitems-per-page=\"vm.itemsPerPage\" ng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" \nboundary-link-numbers=\"true\" rotate=\"false\"></ul></div></div><div class=\"header-modal\"><div common-bs-modal \nbs-modal-show=\"vm.showDialog\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-md\"><div \nclass=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.showDialog = false\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 \nclass=\"modal-title center\" id=\"modal-title\">Table Detail</h3></div><form name=\"tableForm\" class=\"form-horizontal\" \nng-submit=\"vm.save()\" novalidate id=\"tableForm\"><div class=\"modal-body\"><div class=\"form-group\" \nng-class=\"{\'has-error\': tableForm.Name.$invalid && tableForm.Name.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"common.name\"></label><div class=\"col-md-9\"><input name=\"Name\" \ntype=\"text\" class=\"form-control\" ng-model=\"vm.table.Name\" required><div ng-messages=\"tableForm.Name.$error\"><div \nng-message=\"required\" ng-if=\"tableForm.Name.$touched\" class=\"help-block\"><span \ntranslate=\"store.table.table_name_required\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': tableForm.NumberOfSeat.$invalid && tableForm.NumberOfSeat.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"store.table.number_of_seat\"></label><div class=\"col-md-9\"><input \ntype=\"number\" name=\"NumberOfSeat\" class=\"form-control\" ng-model=\"vm.table.NumberOfSeat\" required min=\"0\" \nng-pattern=\"/^[0-9]+$/\"><div ng-messages=\"tableForm.NumberOfSeat.$error\"><div ng-message=\"required\" \nng-if=\"tableForm.NumberOfSeat.$touched\" class=\"help-block\"><span translate=\"store.table.number_of_seat_required\">\n</span></div><div ng-message=\"min\" ng-if=\"tableForm.NumberOfSeat.$touched\" class=\"help-block\"><span \ntranslate=\"store.table.number_of_seat_pattern\"></span></div><div ng-message=\"pattern\" \nng-if=\"tableForm.NumberOfSeat.$touched\" class=\"help-block\"><span translate=\"store.table.number_of_seat_pattern\"></span>\n</div><div ng-message=\"number\" ng-if=\"tableForm.NumberOfSeat.$touched\" class=\"help-block\"><span \ntranslate=\"store.table.number_of_seat_pattern\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': tableForm.StoreName.$invalid && tableForm.StoreName.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"store.table.store_name\"></label><div class=\"col-md-9\"><ui-select \nname=\"StoreName\" ng-model=\"vm.table.StoreId\" theme=\"bootstrap\" ng-keyup=\"vm.LoadStoreDetails($select.search)\" required>\n<ui-select-match placeholder=\"Enter the store\'s name\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"store.Id as store in vm.stores\" refresh=\"vm.loadMerchant($select.search)\" refresh-delay=\"0\" \nminimum-input-length=\"0\"><div ng-bind-html=\"store.Name | highlight: $select.search\"></div></ui-select-choices>\n<ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The store cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select><div ng-messages=\"tableForm.StoreName.$error\"><div ng-message=\"required\" \nng-if=\"tableForm.StoreName.$touched\" class=\"help-block\"><span translate=\"store.table.store_name_required\"></span></div>\n</div></div></div></div><div class=\"modal-footer\"><a class=\"btn btn-danger\" \nng-click=\"vm.showDialog = false; vm.cleanStoreChanged()\" translate=\"common.action.cancel\"></a> <button \nclass=\"btn btn-primary\" type=\"submit\" translate=\"common.action.save\"></button></div></form></div></div></div></div><div\n class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.qrcodeDialog\" class=\"modal fade\" tabindex=\"-1\" \nrole=\"dialog\"><div class=\"modal-dialog modal-md\"><div class=\"modal-content my-content\"><div class=\"modal-header\">\n<button type=\"button\" class=\"close\" ng-click=\"vm.qrcodeDialog = false\"><span aria-hidden=\"true\">&times;</span><span \nclass=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" id=\"modal-title\">QRCode</h3></div><div \nid=\"qrcodeBody\" class=\"modal-body center\"><div class=\"form-group\"><img src=\"{{vm.qrcode}}\"></div><div \nclass=\"form-group\"><label translate=\"store.table.store_name_qr\"></label><label>{{vm.storeName}}</label></div><div \nclass=\"form-group\"><label translate=\"store.table.name\"></label><label>{{vm.tableName}}</label></div><div \nclass=\"form-group\"><label>{{vm.actionType}}</label></div></div><div class=\"modal-footer\"><a class=\"btn btn-primary\" \nng-click=\"vm.print()\"><i class=\"glyphicon glyphicon-print\"></i> <span translate=\"common.action.print\"></span></a></div>\n</div></div></div></div><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.createQRCodeDialog\" \nclass=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-md\"><div \nclass=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.createQRCodeDialog = false\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span>\n</button><h3 class=\"modal-title center\" id=\"modal-title\"><span translate=\"store.table.create_qr_code\"></span></h3>\n</div><form name=\"qrCodeForm\" class=\"form-horizontal\" ng-submit=\"vm.createQRCode()\" novalidate id=\"qrCodeForm\"><div \nclass=\"modal-body\"><div ng-if=\"vm.isAdmin\" class=\"form-group\" \nng-class=\"{\'has-error\': qrCodeForm.MerchantId.$invalid && qrCodeForm.MerchantId.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"store.table.merchant_name\"></label><div class=\"col-md-9\"><ui-select \nng-model=\"vm.qrCode.MerchantId\" name=\"MerchantId\" theme=\"bootstrap\" ng-change=\"vm.merchantIdChanged()\" required>\n<ui-select-match placeholder=\"Enter the merchant\'s name\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\"><div \nng-bind-html=\"merchant.Name | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><div \nstyle=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select><div ng-messages=\"qrCodeForm.MerchantId.$error\"><div ng-message=\"required\" \nng-if=\"qrCodeForm.MerchantId.$touched\" class=\"help-block\"><span translate=\"store.table.merchant_name_required\"></span>\n</div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': qrCodeForm.StoreId.$invalid && qrCodeForm.StoreId.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"store.table.store_name\"></label><div class=\"col-md-9\"><ui-select \nname=\"StoreId\" ng-model=\"vm.qrCode.StoreId\" theme=\"bootstrap\" ng-change=\"vm.storeIdChanged()\" required><ui-select-match\n placeholder=\"Enter the store\'s name\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"store.Id as store in vm.stores | filter: $select.search\"><div \nng-bind-html=\"store.Name | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><div \nstyle=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The store cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select><div ng-messages=\"qrCodeForm.StoreId.$error\"><div ng-message=\"required\" \nng-if=\"qrCodeForm.StoreId.$touched\" class=\"help-block\"><span translate=\"store.table.store_name_required\"></span></div>\n</div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': qrCodeForm.Action.$invalid && qrCodeForm.Action.$touched}\"><label \nclass=\"control-label col-md-3\" translate=\"store.table.action\"></label><div class=\"col-md-9\"><select \nclass=\"form-control\" name=\"Action\" ng-model=\"vm.qrCode.Action\" required><option value=\"\">-- Select Action --</option>\n<option value=\"PayAtTable\" ng-if=\"!vm.showUnifyQR\">Order@table/Pay@table</option><option value=\"UnifyQR\" \nng-if=\"vm.showUnifyQR\">UnifyQR</option></select><div ng-messages=\"qrCodeForm.Action.$error\"><div ng-message=\"required\" \nng-if=\"qrCodeForm.Action.$touched\" class=\"help-block\"><span translate=\"store.table.action_required\"></span></div></div>\n</div></div></div><div class=\"modal-footer\"><button class=\"btn btn-primary\" type=\"submit\" \ntranslate=\"store.table.create\"></button> <a class=\"btn btn-danger\" \nng-click=\"vm.createQRCodeDialog = false; vm.cleanStoreChanged()\" translate=\"common.action.cancel\"></a></div></form>\n</div></div></div></div><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.listQRCodeDialog\" \nclass=\"modal fade\" tabindex=\"-2\" role=\"dialog\"><div class=\"modal-dialog modal-md\"><div class=\"modal-content\" \nng-class=\"{\'modal-content-A\': vm.qrCodes.length <=16, \'modal-content-B\': vm.qrCodes.length > 16}\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.listQRCodeDialog = false\"><span \naria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" \nid=\"modal-title\">{{(vm.stores | filter:{Id: vm.qrCode.StoreId })[0].Name}}</h3></div><div id=\"qrCodeListBody\"><div \nng-if=\"vm.qrCodes.length > 0\" class=\"qr-code\" ng-repeat=\"qrCodes in vm.qrCodes\"><img class=\"image\" \nng-src=\"{{qrCodes.Image}}\"><label class=\"title\">{{qrCodes.TableName}}</label></div><div ng-if=\"vm.qrCodes.length == 0\">\n<h4 class=\"text-center\">No table at this store</h4></div></div><div class=\"modal-footer\"><a class=\"btn btn-primary\" \nng-click=\"vm.printList()\"><i class=\"glyphicon glyphicon-print\"></i> <span translate=\"common.action.print\"></span></a> \n<a class=\"btn btn-danger\" ng-click=\"vm.listQRCodeDialog = false\" translate=\"common.action.close\"></a></div></div></div>\n</div></div><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.chooseActionCeateQRCodeDialog\" \nclass=\"modal fade\" tabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-md\"><div \nclass=\"modal-content my-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" \nng-click=\"vm.chooseActionCeateQRCodeDialog = false\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close\n</span></button><h3 class=\"modal-title center\" id=\"modal-title\"><span translate=\"store.table.create_qr_code\"></span>\n</h3></div><form class=\"form-horizontal\" novalidate><div class=\"modal-body\"><label class=\"control-label col-md-3\" \ntranslate=\"store.table.action\"></label><div class=\"col-md-9\"><select class=\"form-control\" name=\"Action\" \nng-model=\"vm.actionCreateQRCode\"><option value=\"PayAtTable\" ng-if=\"!vm.showUnifyQR\">Order@table/Pay@table</option>\n<option value=\"UnifyQR\" ng-if=\"vm.showUnifyQR\">UnifyQR</option></select></div></div><div class=\"modal-footer\"><a \nclass=\"btn btn-primary\" ng-click=\"vm.generateQRCode()\" translate=\"store.table.create\"></a> <a class=\"btn btn-danger\" \nng-click=\"vm.chooseActionCeateQRCodeDialog = false\" translate=\"common.action.cancel\"></a></div></form></div></div>\n</div></div></div>");
$templateCache.put("app/admin/BulkRegister/BulkRegister-partner/BulkRegister-partner.html","<h1 class=\"page-header\" translate=\"admin.BulkRegisterPartner_kiplekash.title\"></h1><div id=\"bonus-BulkRegisterPartner\" \nclass=\"col-md-12\"><div class=\"col-md-6\"><form name=\"BulkRegisterPartnerkiplekashForm\" class=\"form-horizontal\" \nng-submit=\"vm.save()\" novalidate id=\"BulkRegisterPartnerkiplekashForm\"><div class=\"form-group\" \nng-class=\"{\'has-error\': BulkRegisterPartnerkiplekashForm.file.$invalid && BulkRegisterPartnerkiplekashForm.file.$touched}\">\n<label class=\"control-label col-md-3 required\" translate=\"admin.BulkRegisterPartner_kiplekash.import_csv\"></label><div \nclass=\"col-md-9\"><input type=\"file\" name=\"file\" class=\"input_file\" file-reader=\"vm.fileContent\" accept=\".csv\"></div>\n</div><div class=\"modal-footer\"><a href=\"{{vm.templateLink}}\" target=\"_blank\" \ntranslate=\"common.action.download_template\"></a> | <button type=\"reset\" class=\"btn btn-danger\" \ntranslate=\"common.action.reset\"></button> <button type=\"submit\" class=\"btn btn-primary\" \ntranslate=\"common.action.import\"></button></div></form></div><div class=\"col-md-12\"><div \nstyle=\"border-style: ridge;padding: 1em 3em 3em 3em;margin: 1em 1em 1em 0\"><div class=\"ak-renderer-document\"><h2><em>\n<strong><u>Education Tips</u></strong></em></h2><p data-renderer-start-pos=\"77\"><strong style=\"font-size: 15px\"><u \ndata-renderer-mark=\"true\">File Upload Tips</u></strong></p><ol class=\"ak-ol\" data-indent-level=\"1\"><li><p \ndata-renderer-start-pos=\"97\">Maximum upload data is 1000 per entry</p></li><li><p data-renderer-start-pos=\"138\">\nMaximum file size is 1M</p></li><li><p data-renderer-start-pos=\"165\">File format is .csv files</p></li><li><p \ndata-renderer-start-pos=\"194\">Data upload must be consistent, if fail please check:</p><ol class=\"ak-ol\" \ndata-indent-level=\"2\" type=\"a\"><li><p data-renderer-start-pos=\"251\">\nNo extra spacing before or after entering the details in each column</p></li><li><p data-renderer-start-pos=\"323\">\nData entered is according to the format</p><ol class=\"ak-ol\" data-indent-level=\"3\" type=\"i\"><li><p \ndata-renderer-start-pos=\"366\">Full Name&nbsp;<strong data-renderer-mark=\"true\">MUST&nbsp;</strong>\nbe as per identity card/passport</p></li><li><p data-renderer-start-pos=\"417\"><strong data-renderer-mark=\"true\">MUST \n</strong>entered only numbers/alphabets for NRIC/Passport &amp; no special characters</p></li><li><p \ndata-renderer-start-pos=\"498\">Nationality <strong data-renderer-mark=\"true\">MUST </strong>be provided</p></li><li><p \ndata-renderer-start-pos=\"530\"><strong data-renderer-mark=\"true\">MUST&nbsp;</strong>\ninclude prefix 6 before enter mobile number</p></li><li><p data-renderer-start-pos=\"582\">Login ID is the <strong \ndata-renderer-mark=\"true\">SAME</strong> as Mobile Number and ensure prefix 6 is included</p></li><li><p \ndata-renderer-start-pos=\"655\">Address entered&nbsp;<strong data-renderer-mark=\"true\">MUST</strong>\n&nbsp;be address staying in Malaysia</p></li><li><p data-renderer-start-pos=\"710\"><strong data-renderer-mark=\"true\">\nMUST</strong> enter a valid email address</p></li><li><p data-renderer-start-pos=\"746\">Campaign ID <strong \ndata-renderer-mark=\"true\">MUST</strong> be added</p></li></ol></li></ol></li><li><p data-renderer-start-pos=\"779\">\nUpon file upload processed successfully, target recipient will be notified via email &amp; SMS of the account login details\n</p></li></ol><p data-renderer-start-pos=\"902\"><strong style=\"font-size: 15px\"><u data-renderer-mark=\"true\">\nBulk Upload Steps/Tips</u></strong></p><ol class=\"ak-ol\" data-indent-level=\"1\"><li><p data-renderer-start-pos=\"928\">\nPartner upload file consist of data (according to the file format)</p><ol class=\"ak-ol\" data-indent-level=\"2\" type=\"a\">\n<li><p data-renderer-start-pos=\"998\">Recipients&nbsp;<strong data-renderer-mark=\"true\">MUST</strong>\n&nbsp;provide the details as requested in the file template</p></li><li><p data-renderer-start-pos=\"1071\">\nUsername (mobile number)&nbsp;<strong data-renderer-mark=\"true\">MUST</strong>&nbsp;be registered under 1 recipient</p>\n</li><li><p data-renderer-start-pos=\"1136\">Identity card (NRIC/Passport) <strong data-renderer-mark=\"true\">MUST\n</strong>&nbsp;be registered under 1 recipient</p></li></ol></li><li><p data-renderer-start-pos=\"1208\">\nAccount creation details will be sent to target recipients on the same day upon file uploaded processed successfully (Subject to details are provided according to format)\n</p></li><li><p data-renderer-start-pos=\"1382\">File upload status can be viewed in Bulk Report tab</p></li><li><p \ndata-renderer-start-pos=\"1437\">Remark reference in report:</p><ol class=\"ak-ol\" data-indent-level=\"2\" type=\"a\"><li><p \ndata-renderer-start-pos=\"1468\"><strong data-renderer-mark=\"true\">Pending&nbsp;</strong></p></li><li><p \ndata-renderer-start-pos=\"1480\"><strong data-renderer-mark=\"true\">Successful</strong>&nbsp;</p></li><li><p \ndata-renderer-start-pos=\"1495\"><strong data-renderer-mark=\"true\">Fail</strong>&nbsp;– Username belongs to another user\n</p></li><li><p data-renderer-start-pos=\"1538\"><strong data-renderer-mark=\"true\">Fail&nbsp;</strong>\n– ID belongs to another user</p></li><li><p data-renderer-start-pos=\"1575\"><strong data-renderer-mark=\"true\">Fail \n</strong>– Campaign not found</p></li></ol></li></ol></div></div></div></div>");
$templateCache.put("app/admin/BulkRegister/user-creation-report/user-creation-report.html","<div id=\"divUserCreationReport\"><h1 class=\"page-header\" translate=\"admin.UserCreationReport.title\"></h1><div \nclass=\"report-filter\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\">\n{{ \'admin.UserCreationReport.creation_start_date\' |translate}}</label><input id=\"CreationStartDate\" type=\"text\" \nname=\"CreationStartDate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" \nis-open=\"vm.datePopup.StartOpenCreation\" ng-click=\"vm.datePopup.StartOpenCreation = true\" \nng-model=\"vm.serachModel.CreationStartDate\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label \nclass=\"control-label\">{{ \'admin.UserCreationReport.creation_end_date\' | translate}}</label><input id=\"CreationEndDate\" \ntype=\"text\" name=\"CreationEndDate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" \nis-open=\"vm.datePopup.EndOpenCreation\" ng-click=\"vm.datePopup.EndOpenCreation = true\" \nng-model=\"vm.serachModel.CreationEndDate\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label \nclass=\"control-label\">{{ \'admin.UserCreationReport.creation_type\' | translate}}</label><select class=\"form-control\" \nng-model=\"vm.serachModel.creationType\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option>\n<option ng-repeat=\"v in vm.creationTypeList\" ng-value=\"v.status\">{{v.displayText}}</option></select></div></div><div \nclass=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\">\n{{ \'admin.UserCreationReport.status\' | translate}}</label><select class=\"form-control\" \nng-model=\"vm.serachModel.status\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option><option \nng-repeat=\"v in vm.statusList\" ng-value=\"v.status\">{{v.displayText}}</option></select></div></div></div><div \nclass=\"row\"><div class=\"col-md-1 col-xs-12 margin-tb\"><a style=\"margin-top:6px\" class=\"btn btn-primary pull-right\" \nng-click=\"vm.searchReport()\"><span>Search</span></a></div><div class=\"col-md-1 col-xs-12 margin-tb\"><a \nstyle=\"margin-top:6px\" class=\"btn btn-primary pull-right\" ng-click=\"vm.resetPage()\"><i \nclass=\"glyphicon glyphicon-refresh\"></i><span>Reset</span></a></div></div><div role=\"alert\" ng-show=\"vm.errorMsg\" \nclass=\"alert alert-danger\">{{vm.errorMsg}}</div></div><div class=\"table-responsive\"><table datatable \ndt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.dtInstance\"><thead><tr><th>\n{{ \'admin.UserCreationReport.batch_no\' | translate}}</th><th>{{ \'admin.UserCreationReport.creation_date\' | translate}}\n</th><th>{{ \'admin.UserCreationReport.creation_type\' | translate}}</th><th>\n{{ \'admin.UserCreationReport.creation_id\' | translate}}</th><th>\n{{ \'admin.UserCreationReport.total_creation_profile\' | translate}}</th><th>\n{{ \'admin.UserCreationReport.status\' | translate}}</th><th>{{ \'admin.UserCreationReport.action_by\' | translate}}</th>\n<th>{{ \'admin.UserCreationReport.action\' | translate}}</th></tr></thead></table></div></div>");
$templateCache.put("app/admin/BulkRegister/user-profile-report/user-profile-report.html","<h1 class=\"page-header\" translate=\"admin.user_profile_report.title\"></h1><div id=\"user-profile-report\" \nclass=\"col-md-12\"><div class=\"col-md-6\"><form name=\"UserProfileReportForm\" class=\"form-horizontal\" \nng-submit=\"vm.save()\" novalidate id=\"UserProfileReportForm\"><div class=\"form-group\" \nng-class=\"{\'has-error\': UserProfileReportForm.file.$invalid && UserProfileReportForm.file.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"admin.user_profile_report.import_csv\"></label><div class=\"col-md-9\">\n<input type=\"file\" name=\"file\" class=\"input_file\" file-reader=\"vm.fileContent\" accept=\".csv\"></div></div><div \nclass=\"modal-footer\"><a href=\"{{vm.templateLink}}\" target=\"_blank\" translate=\"common.action.download_template\"></a> | \n<button type=\"reset\" class=\"btn btn-danger\" translate=\"common.action.reset\"></button> <button type=\"submit\" \nclass=\"btn btn-primary\" translate=\"common.action.import\"></button></div></form></div><div class=\"col-md-12\"><div \nstyle=\"border-style: ridge;padding: 1em 3em 3em 3em;margin: 1em 1em 1em 0\"><div class=\"ak-renderer-document\"><h2><em>\n<strong><u>Education Tips</u></strong></em></h2><p data-renderer-start-pos=\"77\"><strong style=\"font-size: 15px\"><u \ndata-renderer-mark=\"true\">File Upload Tips</u></strong></p><ol class=\"ak-ol\" data-indent-level=\"1\"><li><p \ndata-renderer-start-pos=\"97\">Maximum upload data is 10,000 entries per file</p></li><li><p \ndata-renderer-start-pos=\"138\">Maximum file size is 1MB</p></li><li><p data-renderer-start-pos=\"165\">\nFile format is .csv files</p></li><li><p data-renderer-start-pos=\"194\">\nData upload must be consistent, if fail please check:</p><ol class=\"ak-ol\" data-indent-level=\"2\" type=\"a\"><li><p \ndata-renderer-start-pos=\"251\">No extra spacing before or after entering the details in each column</p></li><li><p \ndata-renderer-start-pos=\"323\">Data entered is according to the format</p><ol class=\"ak-ol\" data-indent-level=\"3\" \ntype=\"i\"><li><p data-renderer-start-pos=\"366\">Login ID is the&nbsp;<strong data-renderer-mark=\"true\">SAME&nbsp;\n</strong>as Mobile Number and ensure prefix 6 is included (eg 60125554422)</p></li></ol></li></ol></li><li><p \ndata-renderer-start-pos=\"779\">\nUpon file upload processed successfully, a KiplePay User Profile Report shall be generated for the admin user.</p></li>\n</ol></div></div></div></div>");
$templateCache.put("app/admin/BulkRegister/user-wallet-upgrade/user-wallet-upgrade.html","<h1 class=\"page-header\" translate=\"admin.user_wallet_upgrade.title\"></h1><div id=\"user-wallet-upgrade\" \nclass=\"col-md-12\"><div class=\"col-md-6\"><form name=\"UserWalletUpgradeForm\" class=\"form-horizontal\" \nng-submit=\"vm.save()\" novalidate id=\"UserWalletUpgradeForm\"><div class=\"form-group\" \nng-class=\"{\'has-error\': UserWalletUpgradeForm.file.$invalid && UserWalletUpgradeForm.file.$touched}\"><label \nclass=\"control-label col-md-5 required\" translate=\"admin.user_wallet_upgrade.import_csv\"></label><div class=\"col-md-7\">\n<input type=\"file\" name=\"file\" class=\"input_file\" file-reader=\"vm.fileContent\" accept=\".csv\"></div></div><div \nclass=\"modal-footer\"><a href=\"{{vm.templateLink}}\" target=\"_blank\" translate=\"common.action.download_template\"></a> | \n<button type=\"reset\" class=\"btn btn-danger\" translate=\"common.action.reset\"></button> <button type=\"submit\" \nclass=\"btn btn-primary\" translate=\"common.action.import\"></button></div></form></div><div class=\"col-md-12\"><div \nstyle=\"border-style: ridge;padding: 1em 3em 3em 3em;margin: 1em 1em 1em 0\"><div class=\"ak-renderer-document\"><p \ndata-renderer-start-pos=\"77\"><strong style=\"font-size: 15px\"><u data-renderer-mark=\"true\">File Upload Tips</u></strong>\n</p><ol class=\"ak-ol\" data-indent-level=\"1\"><li><p data-renderer-start-pos=\"97\">\nMaximum upload data is 10,000 entries per file</p></li><li><p data-renderer-start-pos=\"138\">Maximum file size is 1M</p>\n</li><li><p data-renderer-start-pos=\"165\">File format is .csv files</p></li><li><p data-renderer-start-pos=\"194\">\nData upload must be consistent, if fail please check:</p><ol class=\"ak-ol\" data-indent-level=\"2\" type=\"a\"><li><p \ndata-renderer-start-pos=\"251\">No extra spacing before or after entering the details in each column</p></li><li><p \ndata-renderer-start-pos=\"323\">Data entered is according to the format</p><ol class=\"ak-ol\" data-indent-level=\"3\" \ntype=\"i\"><li><p data-renderer-start-pos=\"366\">Login ID is the&nbsp;<strong data-renderer-mark=\"true\">SAME&nbsp;\n</strong>as Mobile Number and ensure prefix 6 is included (eg 60125554422)</p></li></ol></li></ol></li><li><p \ndata-renderer-start-pos=\"779\">\nUpon file upload processed successfully, a KiplePay Wallet Upgrade Report shall be generated for the admin user.</p>\n</li></ol></div></div></div></div>");
$templateCache.put("app/admin/category/merchant/category-merchant.html","<h1 class=\"page-header\" translate=\"admin.category.merchant_title\"></h1><div id=\"category\" class=\"col-md-12\"><div \nclass=\"form-horizontal\"><div id=\"brandDiv\" class=\"tab-pane fade in active\"><div class=\"row\"><div class=\"col-md-6\"><div \nui-tree class=\"angular-ui-tree\" data-nodrop-enabled=\"true\" data-drag-enabled=\"false\"><ol ui-tree-nodes=\"\" \nclass=\"angular-ui-tree-nodes\" ng-model=\"vm.categoriesBrand\"><li ng-repeat=\"categoryBrand in vm.categoriesBrand\" \nui-tree-node class=\"angular-ui-tree-node\"><div ui-tree-handle \nclass=\"tree-node tree-node-content angular-ui-tree-handle\" title=\"{{categoryBrand.Description}}\" \nng-click=\"vm.showDetailBrand(categoryBrand.Id)\"><a class=\"btn btn-success btn-xs\" \nng-if=\"categoryBrand.ChildrenCategories && categoryBrand.ChildrenCategories.length > 0\" data-nodrag=\"\" \nng-click=\"vm.toggle(this)\"><span class=\"glyphicon glyphicon-chevron-right\" \nng-class=\"{\'glyphicon-chevron-right\': collapsed, \'glyphicon-chevron-down\': !collapsed}\"></span> </a>\n{{categoryBrand.Name}} <a ng-if=\"categoryBrand.ChildrenCategories.length == 0\" \nclass=\"pull-right btn btn-danger btn-xs\" data-nodrag=\"\" ng-click=\"vm.removeBrand(categoryBrand.Id)\"><span \nclass=\"glyphicon glyphicon-remove\"></span></a></div><ol ui-tree-nodes=\"\" ng-class=\"{hidden: collapsed}\" \nng-model=\"categoryBrand.ChildrenCategories\" class=\"angular-ui-tree-nodes\"><li \nng-repeat=\"childrenCategoryBrand in categoryBrand.ChildrenCategories\" ui-tree-node class=\"angular-ui-tree-node\"><div \nui-tree-handle class=\"tree-node tree-node-content angular-ui-tree-handle\" \ntitle=\"{{childrenCategoryBrand.Description}}\" ng-click=\"vm.showDetailBrand(childrenCategoryBrand.Id)\">\n{{childrenCategoryBrand.Name}} <a class=\"pull-right btn btn-danger btn-xs\" data-nodrag=\"\" \nng-click=\"vm.removeBrand(childrenCategoryBrand.Id)\"><span class=\"glyphicon glyphicon-remove\"></span></a></div></li>\n</ol></li></ol></div><a class=\"btn bxtn-primary pull-right\" ng-click=\"vm.addNewBrand()\"><i \nclass=\"glyphicon glyphicon-plus\"></i> <span translate=\"common.action.add\"></span></a></div><div class=\"col-md-6\"><form \nname=\"categoryFormBrand\" class=\"form-horizontal\" ng-submit=\"vm.saveBrand()\" novalidate id=\"categoryForm\" \nng-hide=\"!vm.categoryBrand\"><div class=\"modal-header\"><h3 class=\"modal-title center\" id=\"modal-title\" \ntranslate=\"admin.category.category_detail\"></h3></div><div class=\"modal-body\"><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.category.parent_category\"></label><div class=\"col-md-8\">\n<select name=\"ParentCategoryId\" type=\"text\" class=\"form-control\" ng-model=\"vm.categoryBrand.ParentCategoryId\" \nng-options=\"value.Id as value.Name for (key,value) in vm.categories_filteredBrand\" \nng-disabled=\"vm.categoryBrand.Id && vm.categoryBrand.ChildrenCategories.length > 0\"><option value=\"\">None</option>\n</select></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': categoryFormBrand.Name.$invalid && categoryFormBrand.Name.$touched}\"><label \nclass=\"control-label col-md-3 required margin-tb\" translate=\"common.name\"></label><div class=\"col-md-8\"><input \nid=\"nameBrand\" name=\"Name\" type=\"text\" class=\"form-control\" ng-model=\"vm.categoryBrand.Name\" required \nis-category-merchant-name-available-brand=\"vm.categoryBrand.Id\"><div ng-messages=\"categoryFormBrand.Name.$error\"><div \nng-message=\"required\" ng-if=\"categoryFormBrand.Name.$touched\" class=\"help-block\"><span \ntranslate=\"admin.category.validate.name\"></span></div><div ng-message=\"isCategoryMerchantNameAvailableBrand\" \nng-if=\"categoryFormBrand.Name.$touched\" class=\"help-block\"><span translate=\"admin.category.validate.name_duplicate\">\n</span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': categoryFormBrand.channel.$invalid && categoryFormBrand.channel.$touched}\"><label \nclass=\"control-label col-md-3 required\">Channel</label><div class=\"col-md-8\"><select name=\"channel\" \nclass=\"form-control\" ng-model=\"vm.categoryBrand.Channel\" required><option ng-repeat=\"option in vm.channelList\" \nvalue=\"{{option.Value}}\">{{option.Text}}</option></select><p \nng-show=\"categoryFormBrand.channel.$invalid && categoryFormBrand.channel.$touched\" class=\"help-block\">\nThe channel is required.</p></div></div><div class=\"form-group\" ng-if=\"vm.categoryBrand.Channel === \'Kiplemart\'\"><label\n class=\"control-label col-md-3 margin-tb\">Category Icon(Home)</label><div class=\"photos-form col-md-8\"><div \nclass=\"upload-controls\"><input type=\"file\" class=\"button\" ngf-select=\"vm.uploadPhoto($files, $invalidFiles, 1)\" \nname=\"homeLogo\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" \nngf-dimensions=\"($width >= 74) && ($height >= 54) && (($width / $height) >= 1)\"></div><div><label class=\"note\">\nNote: Suggested image resolution 74*54px</label></div><div class=\"file-list\" ng-if=\"vm.categoryBrand.HomeLogo\"><img \nng-src=\"{{vm.categoryBrand.HomeLogo}}\" style=\"width: 318px; height: 200px\"><p></p><a ng-click=\"vm.removePhoto(1)\" \nclass=\"btn btn-danger\"><i class=\"glyphicon glyphicon-remove\"></i> <span translate=\"Remove\"></span></a></div></div>\n</div><div class=\"form-group\" ng-if=\"vm.categoryBrand.Channel === \'Kiplemart\' && !vm.categoryBrand.ParentCategoryId\">\n<label class=\"control-label col-md-3 margin-tb\">Category Icon(Mail)</label><div class=\"photos-form col-md-8\"><div \nclass=\"upload-controls\"><input type=\"file\" class=\"button\" ngf-select=\"vm.uploadPhoto($files, $invalidFiles, 2)\" \nname=\"mailLogo\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/*\'\" \nngf-dimensions=\"($width >= 56) && ($height >= 56) && (($width / $height) >= 1)\"></div><div><label class=\"note\">\nNote: Suggested image resolution 56*56px</label></div><div class=\"file-list\" ng-if=\"vm.categoryBrand.MailLogo\"><img \nng-src=\"{{vm.categoryBrand.MailLogo}}\" style=\"width: 318px; height: 200px\"><p></p><a ng-click=\"vm.removePhoto(2)\" \nclass=\"btn btn-danger\"><i class=\"glyphicon glyphicon-remove\"></i> <span translate=\"Remove\"></span></a></div></div>\n</div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"common.description\"></label>\n<div class=\"col-md-8\"><textarea name=\"Description\" rows=\"4\" class=\"form-control\" \nng-model=\"vm.categoryBrand.Description\"></textarea></div></div></div><div class=\"modal-footer\"><a \nclass=\"btn btn-danger\" ng-click=\"vm.cancelBrand()\" translate=\"common.action.cancel\"></a> <button type=\"submit\" \nclass=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div></div></div>");
$templateCache.put("app/admin/sharedStoreCard/detail/sharedStoreCard.detail.html","<h1 class=\"page-header\" translate=\"admin.sharedStoreCard.detail.title\"></h1><div class=\"header-modal\"><form \nname=\"sharedStoreCardForm\" class=\"form-horizontal\" ng-submit=\"vm.save()\" novalidate id=\"sharedStoreCardForm\"><div \nclass=\"form-group\" ng-class=\"{\'has-error\': sharedStoreCardForm.Name.$invalid && sharedStoreCardForm.Name.$touched}\">\n<label class=\"control-label col-md-3 margin-tb\" translate=\"admin.sharedStoreCard.name\"></label><div class=\"col-md-8\">\n<input type=\"text\" name=\"Name\" class=\"form-control\" ng-model=\"vm.sharedStoreCard.Name\" required \nis-shared-store-card-name-available=\"vm.sharedStoreCard.Id\"><div ng-messages=\"sharedStoreCardForm.Name.$error\"><div \nng-message=\"required\" ng-if=\"sharedStoreCardForm.Name.$touched\" class=\"help-block\"><span \ntranslate=\"admin.sharedStoreCard.detail.validate.name\"></span></div><div ng-message=\"isSharedStoreCardNameAvailable\" \nng-if=\"sharedStoreCardForm.Name.$touched\" class=\"help-block\"><span \ntranslate=\"admin.sharedStoreCard.detail.validate.name_duplicate\"></span></div></div></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': sharedStoreCardForm.MerChantName.$invalid && sharedStoreCardForm.MerChantName.$touched}\"><label\n class=\"control-label col-md-3 margin-tb\" translate=\"admin.sharedStoreCard.merchant_name\"></label><div \nclass=\"col-md-8\"><ui-select focus-on=\"focusMerchant\" ng-model=\"vm.sharedStoreCard.MerchantId\" name=\"MerChantName\" \nng-keyup=\"vm.loadMerchant($select.search)\" theme=\"bootstrap\" required><ui-select-match allow-clear=\"true\" \nplaceholder=\"Enter the merchant\'s name\">{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh-delay=\"0\" minimum-input-length=\"0\">\n<div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><div \nstyle=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select><div ng-messages=\"sharedStoreCardForm.MerChantName.$error\"><div \nng-message=\"required\" ng-if=\"sharedStoreCardForm.MerChantName.$touched\" class=\"help-block\"><span \ntranslate=\"admin.sharedStoreCard.detail.validate.merchant\"></span></div></div></div></div><div class=\"form-group\">\n<label class=\"control-label col-md-3\" translate=\"admin.sharedStoreCard.display_on_kiple_pay_app\"></label><div \nclass=\"btn-group col-md-8\"><label class=\"btn btn-default\" ng-model=\"vm.sharedStoreCard.DisplayOnKiplePayApp\" \nuib-btn-radio=\"true\">Yes</label><label class=\"btn btn-default\" ng-model=\"vm.sharedStoreCard.DisplayOnKiplePayApp\" \nuib-btn-radio=\"false\">No</label></div></div><div class=\"modal-footer footer-center\"><a class=\"btn btn-danger\" \nui-sref=\"app.admin.sharedStoreCard\" translate=\"common.action.cancel\"></a> <button type=\"submit\" \nclass=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div>");
$templateCache.put("app/admin/settlement-transaction/summary/settlement-transaction.summary.html","<h1 class=\"page-header\" translate=\"admin.settlement_transaction.summary\"></h1><div id=\"settlement_transaction\" \nclass=\"col-md-12\"><div class=\"form-horizontal\"><div class=\"form-group\"><div class=\"row\"><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\">Start Date</label></div><div \nclass=\"col-md-3 col-xs-12 margin-tb\"><label class=\"control-label\">End Date</label></div></div><div class=\"row\"><div \nclass=\"col-md-3 col-xs-12 dropdown dropdown-date margin-tb\"><a class=\"dropdown-toggle\" id=\"dropdownStart\" \nrole=\"button\" data-toggle=\"dropdown\" data-target=\".dropdown-Startdate\" href=\"#\"><div class=\"input-group date\"><input \ntype=\"text\" class=\"form-control\" readonly=\"readonly\" data-date-time-input=\"YYYY-MM-DD\" placeholder=\"YYYY-MM-DD\" \ndata-ng-model=\"vm.criteria.Date\"> <span class=\"input-group-addon\"><i class=\"glyphicon glyphicon-calendar\"></i></span>\n</div></a><ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"dLabel\"><datetimepicker \ndata-ng-model=\"vm.criteria.Date\" \ndata-datetimepicker-config=\"{ dropdownSelector: \'#dropdownStart\', modelType: \'YYYY-MM-DD\', minView: \'day\' }\">\n</datetimepicker></ul></div><div class=\"col-md-3 col-xs-12 dropdown dropdown-date margin-tb\"><a \nclass=\"dropdown-toggle\" id=\"dropdownEnd\" role=\"button\" data-toggle=\"dropdown\" data-target=\".dropdown-Enddate\" href=\"#\">\n<div class=\"input-group date\"><input type=\"text\" class=\"form-control\" readonly=\"readonly\" \ndata-date-time-input=\"YYYY-MM-DD\" placeholder=\"YYYY-MM-DD\" data-ng-model=\"vm.criteria.EndDate\"> <span \nclass=\"input-group-addon\"><i class=\"glyphicon glyphicon-calendar\"></i></span></div></a><ul class=\"dropdown-menu\" \nrole=\"menu\" aria-labelledby=\"dLabel\"><datetimepicker data-ng-model=\"vm.criteria.EndDate\" \ndata-on-set-time=\"vm.summary(\'summary\')\" \ndata-datetimepicker-config=\"{ dropdownSelector: \'#dropdownEnd\', modelType: \'YYYY-MM-DD\', minView: \'day\' }\">\n</datetimepicker></ul></div><div class=\"col-md-1 col-sm-10\"><a class=\"btn btn-primary pull-right margin-tl\" \nng-click=\"vm.reset()\"><i class=\"glyphicon glyphicon-refresh\"></i> <span translate=\"common.action.reset\"></span></a>\n</div><div class=\"col-md-6 col-xs-2\"><a class=\"btn btn-primary pull-right\" ng-show=\"vm.isShowCommitButton\" \nng-click=\"vm.openDialog()\"><i class=\"glyphicon glyphicon-plus\"></i> <span translate=\"common.action.commit\"></span></a>\n</div></div><div class=\"row\"><div class=\"col-md-3 col-xs-12 margin-tb\"><select class=\"form-control\" \nng-model=\"vm.criteria.MasterMerchantId\" ng-change=\"vm.summary(\'summary\')\" name=\"MasterMerchantId\" required><option \nvalue=\"\" selected=\"selected\">-- Select Master Merchant --</option><option \nng-repeat=\"masterMerchant in vm.masterMerchants\" ng-value=\"masterMerchant.Id\">{{masterMerchant.Name}}</option></select>\n</div><div class=\"col-md-3 col-xs-12 margin-tb\"><ui-select ng-model=\"vm.criteria.MerchantId\" theme=\"bootstrap\" \nng-change=\"vm.summary(\'summary\')\"><ui-select-match placeholder=\"Merchant name\" allow-clear=\"true\">\n{{$select.selected.Name}}</ui-select-match><ui-select-choices \nrepeat=\"merchant.Id as merchant in vm.merchants | filter: $select.search\" refresh=\"vm.loadMerchant($select.search)\" \nrefresh-delay=\"0\" minimum-input-length=\"3\"><div ng-bind-html=\"merchant.Name | highlight: $select.search\"></div>\n</ui-select-choices><ui-select-no-choice><div style=\"padding-left:20px\">\n{{$select.search.length >= 3 ? \"The merchant cannot be found\" : \"Please enter more than 3 characters\"}}</div>\n</ui-select-no-choice></ui-select></div><div class=\"col-md-3 col-xs-12 margin-tb\"><select class=\"form-control\" \nng-model=\"vm.criteria.Status\" ng-change=\"vm.summary(\'summary\')\" name=\"SettlementStatus\" required><option value=\"\" \nselected=\"selected\">-- Select Status --</option><option value=\"0\">Processing</option><option value=\"1\">Settled</option>\n</select></div><div class=\"col-md-3 col-xs-12 margin-tb\"><select class=\"form-control\" \nng-model=\"vm.criteria.Clientname\" ng-change=\"vm.summary(\'summary\')\" name=\"clientname\" required><option value=\"\" \nselected=\"selected\">-- Select Client --</option><option value=\"0\">All</option><option value=\"petronas\">petronas\n</option></select></div></div></div><div class=\"form-group\"><div class=\"table-responsive\"><table \nclass=\"table table-striped table-bordered\"><thead><tr><th><input type=\"checkbox\" ng-model=\"vm.isCheckAll\" \nng-change=\"vm.checkAll()\"></th><th translate=\"admin.settlement_transaction.merchant_id\"></th><th \ntranslate=\"admin.settlement_transaction.merchant_name\"></th><th>Start Date</th><th>End Date</th><th>Total Transactions\n</th><th translate=\"admin.settlement_transaction.value\">Total Amount</th><th>MDRFee</th><th \ntranslate=\"admin.settlement_transaction.amount\"></th><th translate=\"admin.settlement_transaction.status\"></th><th \ntranslate=\"admin.settlement_transaction.settlement_date\"></th></tr></thead><tbody><tr \nng-repeat=\"transaction in vm.transactions\"><td class=\"text-center\"><input type=\"checkbox\" \nng-model=\"transaction.IsChecked\" ng-change=\"vm.checkItem(transaction)\" ng-show=\"transaction.Status != \'Settled\'\"></td>\n<td>{{transaction.MerchantId}}</td><td>{{transaction.MerchantName}}</td><td>\n{{transaction.StartDate| date: \'yyyy-MM-dd\'}}</td><td>{{transaction.EndDate | date: \'yyyy-MM-dd\'}}</td><td \nclass=\"center\"><a ng-click=\"vm.redirectToTransactions(transaction)\">{{transaction.Count}}</a></td><td class=\"right\">\n{{transaction.TotalAmount | currency :\"\"}}</td><td class=\"right\">{{transaction.MDRFee | currency :\"\"}}</td><td \nclass=\"right\">{{transaction.SettlementAmount | currency :\"\"}}</td><td class=\"center\">{{transaction.Status}}</td><td>\n{{transaction.SettlementDate | date: \'yyyy-MM-dd\'}}</td></tr><tr><td></td><td></td><td></td><td></td><td>Total :</td>\n<td class=\"center\">{{getTotal().totalCount }}</td><td class=\"right\">{{getTotal().totalamt | currency :\"\"}}</td><td \nclass=\"right\">{{getTotal().totalMDR | currency :\"\"}}</td><td class=\"right\">\n{{getTotal().totalSettlementamt | currency :\"\"}}</td><td></td><td></td></tr></tbody></table></div>\nPage {{vm.currentPage}} of {{(vm.totalItems / vm.itemsPerPage) | roundup }} , showing {{(vm.currentPage * vm.itemsPerPage) > vm.totalItems ? vm.totalItems : (vm.currentPage * vm.itemsPerPage)}} records out of {{vm.totalItems}} Records\n<ul uib-pagination total-items=\"vm.totalItems\" items-per-page=\"vm.itemsPerPage\" ng-change=\"vm.summary()\" \nng-model=\"vm.currentPage\" max-size=\"vm.maxSize\" class=\"pagination-sm\" boundary-link-numbers=\"true\" rotate=\"false\"></ul>\n</div></div><div class=\"header-modal\"><div common-bs-modal bs-modal-show=\"vm.viewConfig.ShowDialog\" class=\"modal fade\" \ntabindex=\"-1\" role=\"dialog\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content my-content\"><form \nname=\"transactionForm\" class=\"form-horizontal\" ng-submit=\"vm.save()\" novalidate id=\"transactionForm\"><div \nclass=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"vm.viewConfig.ShowDialog = false\"><span \naria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button><h3 class=\"modal-title center\" \nid=\"modal-title\" translate=\"admin.settlement_transaction.title\"></h3></div><div class=\"modal-body\" \nstyle=\"min-height: 300px\"><div class=\"form-group\" \nng-class=\"{\'has-error\': transactionForm.SettlementDate.$invalid && transactionForm.SettlementDate.$touched}\"><label \nclass=\"control-label col-md-3 required\" translate=\"common.date\"></label><div class=\"col-md-8\"><div \nclass=\"dropdown dropdown-settlement-date\"><a class=\"dropdown-toggle\" id=\"settlement-date\" role=\"button\" \ndata-toggle=\"dropdown\" data-target=\".dropdown-settlement-date\" href=\"#\"><div class=\"input-group date\"><input \ntype=\"text\" class=\"form-control\" name=\"SettlementDate\" required readonly=\"readonly\" data-date-time-input=\"YYYY-MM-DD\" \nplaceholder=\"YYYY-MM-DD\" data-ng-model=\"vm.settlementTransactions.Date\"> <span class=\"input-group-addon\"><i \nclass=\"glyphicon glyphicon-calendar\"></i></span></div></a><ul class=\"dropdown-menu\" role=\"menu\" \naria-labelledby=\"dLabel\"><datetimepicker data-ng-model=\"vm.settlementTransactions.Date\" \ndata-datetimepicker-config=\"{ dropdownSelector: \'#settlement-date\', modelType: \'YYYY-MM-DD\', minView: \'day\' }\">\n</datetimepicker></ul></div><div ng-messages=\"transactionForm.SettlementDate.$error\"><div ng-message=\"required\" \nng-if=\"transactionForm.SettlementDate.$touched\" class=\"help-block\"><span \ntranslate=\"admin.settlement_transaction.validate.date_required\"></span></div></div></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': transactionForm.SettlementStatus.$invalid && transactionForm.SettlementStatus.$touched}\"><label\n class=\"control-label col-md-3 required\" translate=\"common.status\"></label><div class=\"col-md-8\"><select \nclass=\"form-control\" name=\"SettlementStatus\" ng-model=\"vm.settlementTransactions.Status\" required><option value=\"\">\nPlease select status</option><option value=\"Processing\">Processing</option><option value=\"Settled\">Settled</option>\n</select><div ng-messages=\"transactionForm.SettlementStatus.$error\"><div ng-message=\"required\" \nng-if=\"transactionForm.SettlementStatus.$touched\" class=\"help-block\"><span \ntranslate=\"admin.settlement_transaction.validate.status_required\"></span></div></div></div></div></div><div \nclass=\"modal-footer\"><a class=\"btn btn-danger\" ng-click=\"vm.cancel()\" translate=\"common.action.cancel\"></a> <button \ntype=\"submit\" class=\"btn btn-primary\" translate=\"common.action.save\"></button></div></form></div></div></div></div>\n</div>");
$templateCache.put("app/admin/tierSetting/detail/tierSetting.detail.html","<h1 class=\"page-header\" translate=\"admin.tierSetting.detail.title\"></h1><div class=\"header-modal\"><form \nname=\"tierForm\" class=\"form-horizontal\" ng-submit=\"vm.save()\" novalidate id=\"tierForm\"><div class=\"modal-body\"><div \nclass=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" translate=\"admin.tierSetting.detail.basic_group\"></h4>\n</div></div><div class=\"form-group\" ng-class=\"{\'has-error\': tierForm.TierName.$invalid && tierForm.TierName.$touched}\">\n<label class=\"control-label col-md-3 margin-tb\" translate=\"admin.tierSetting.tier_name\"></label><div class=\"col-md-8\">\n<input type=\"text\" name=\"TierName\" class=\"form-control\" ng-model=\"vm.tier.Name\" required \nis-merchant-tier-name-available=\"vm.tier.Id\"><div ng-messages=\"tierForm.TierName.$error\"><div ng-message=\"required\" \nng-if=\"tierForm.TierName.$touched\" class=\"help-block\"><span translate=\"admin.tierSetting.detail.validate.tier_name\">\n</span></div><div ng-message=\"isMerchantTierNameAvailable\" ng-if=\"tierForm.TierName.$touched\" class=\"help-block\"><span \ntranslate=\"admin.tierSetting.detail.validate.tier_name_duplicate\"></span></div></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': tierForm.AnnualFee.$invalid && tierForm.AnnualFee.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.tierSetting.annual_fee\"></label><div class=\"col-md-8\"><div \nclass=\"input-group\"><input type=\"number\" name=\"AnnualFee\" class=\"form-control\" ng-model=\"vm.tier.AnnualFee\" min=\"0\" \nrequired> <span class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div><div \nng-messages=\"tierForm.AnnualFee.$error\"><div ng-message=\"required\" ng-if=\"tierForm.AnnualFee.$touched\" \nclass=\"help-block\"><span translate=\"admin.tierSetting.detail.validate.annual_fee\"></span></div><div ng-message=\"min\" \nclass=\"help-block\"><span translate=\"admin.tierSetting.detail.validate.annual_fee_not_negative\"></span></div></div>\n</div></div><div class=\"form-group\"><label class=\"control-label col-md-3\" \ntranslate=\"admin.tierSetting.detail.pos_android\"></label></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.tierSetting.detail.device\"></label><div class=\"col-md-3\" \nng-class=\"{\'has-error\': tierForm.Device.$invalid && tierForm.Device.$touched}\"><div class=\"input-group\"><span \nclass=\"input-group-addon\">Up to</span> <input type=\"number\" name=\"Device\" class=\"form-control\" \nng-blur=\"vm.checkNull()\" min=\"0\" ng-pattern=\"/^[0-9]*$/\" ng-model=\"vm.tier.POSAndroidTerminalsThreshold\"> <span \nclass=\"input-group-addon\" id=\"basic-addon1\">devices</span></div><div ng-messages=\"tierForm.Device.$error\"><div \nng-message=\"pattern\" ng-if=\"tierForm.Device.$touched\" class=\"help-block\"><span \ntranslate=\"admin.tierSetting.detail.validate.device\"></span></div></div></div><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"admin.tierSetting.detail.addtional\"></label><div class=\"col-md-3\">\n<div class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">RM</span> <input type=\"number\" \nname=\"AndroidTerminals\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.tier.POSAndroidTerminalsAmount\"> <span class=\"input-group-addon\" id=\"basic-addon1\">/ yr</span></div></div>\n</div><div class=\"form-group\" ng-class=\"{\'has-error\': tierForm.ReferralFee.$invalid && tierForm.ReferralFee.$touched}\">\n<label class=\"control-label col-md-3 margin-tb\" translate=\"admin.tierSetting.detail.user_refferral_fee\"></label><div \nclass=\"col-md-8\"><div class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">RM</span> <input \ntype=\"number\" name=\"ReferralFee\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.tier.UserReferralFee\"> <span class=\"input-group-addon\" id=\"basic-addon1\">/ user</span></div></div></div>\n<div class=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" \ntranslate=\"kiplePay E-Wallet MDR and Revenue Share\"></h4></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.tierSetting.detail.mdr\"></label><div class=\"col-md-8\"><div \nclass=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">RM</span> <input type=\"number\" \nname=\"ReferralFee\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" ng-model=\"vm.tier.MDRThreshold\" \nng-change=\"vm.checkMDRType()\" ng-disabled=\"vm.disabledMDRThreshold\"></div></div></div><div \nng-if=\"vm.tier.MdrTierSettingOptions.length>=1\" class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\">\nE-Wallet Merchant MDR</label><div class=\"col-md-2\"><div class=\"input-group\"><select disabled=\"disabled\" name=\"Group\" \nclass=\"form-control\" ng-model=\"vm.tier.MdrOptionType\" ng-disabled=\"vm.DisableMdrOptionType\"><option \nng-repeat=\"day in vm.topupFPXMDRoptionList\" ng-value=\"day.Id\">{{day.Name}}</option></select></div></div><div \nclass=\"col-md-6\"><div ng-if=\"vm.tier.MdrOptionType==1\" class=\"input-group\"><input disabled=\"disabled\" type=\"number\" \nname=\"ReferralFee\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" max=\"=100\" \nng-model=\"vm.tier.MDRAdditionalAmount\" ng-change=\"vm.checkMDRType()\" ng-disabled=\"vm.DisableMDRAdditionalAmount\"> <span\n class=\"input-group-addon\" id=\"basic-addon1\">%</span></div><div ng-if=\"vm.tier.MdrOptionType==2\" class=\"input-group\">\n<input disabled=\"disabled\" type=\"number\" name=\"ReferralFee\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.tier.FixedMDRAdditionalAmount\" ng-change=\"vm.checkMDRType()\" ng-disabled=\"vm.FixedMDRAdditionalAmount\"> \n<span class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div><div ng-if=\"vm.tier.MdrOptionType==3\"><div \nclass=\"col-md-6\"><div class=\"input-group\"><input disabled=\"disabled\" type=\"number\" name=\"ReferralFee\" \nclass=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" max=\"=100\" ng-model=\"vm.tier.MDRAdditionalAmount\" \nng-change=\"vm.checkMDRType()\" ng-disabled=\"vm.DisableMDRAdditionalAmount\"> <span class=\"input-group-addon\" \nid=\"basic-addon1\">%</span></div></div><div class=\"col-md-6\"><div class=\"input-group\"><input disabled=\"disabled\" \ntype=\"number\" name=\"ReferralFee\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.tier.FixedMDRAdditionalAmount\" ng-change=\"vm.checkMDRType()\" ng-disabled=\"vm.FixedMDRAdditionalAmount\"> \n<span class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div></div><div class=\"col-md-1\"><div \nclass=\"input-group\"><a class=\"btn btn-primary\" ng-click=\"vm.addThreshold()\"><i class=\"glyphicon glyphicon-plus\"></i>\n</a></div></div></div><div ng-if=\"vm.tier.MdrTierSettingOptions.length==0\" class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\">E-Wallet Merchant MDR</label><div class=\"col-md-2\"><div class=\"input-group\">\n<select name=\"Group\" class=\"form-control\" ng-model=\"vm.tier.MdrOptionType\" ng-disabled=\"vm.DisableMdrOptionType\">\n<option ng-repeat=\"day in vm.topupFPXMDRoptionList\" ng-value=\"day.Id\">{{day.Name}}</option></select></div></div><div \nclass=\"col-md-6\"><div ng-if=\"vm.tier.MdrOptionType==1\" class=\"input-group\"><input type=\"number\" name=\"ReferralFee\" \nclass=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" max=\"=100\" ng-model=\"vm.tier.MDRAdditionalAmount\" \nng-change=\"vm.checkMDRType()\" ng-disabled=\"vm.DisableMDRAdditionalAmount\"> <span class=\"input-group-addon\" \nid=\"basic-addon1\">%</span></div><div ng-if=\"vm.tier.MdrOptionType==2\" class=\"input-group\"><input type=\"number\" \nname=\"ReferralFee\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" ng-model=\"vm.tier.FixedMDRAdditionalAmount\" \nng-change=\"vm.checkMDRType()\" ng-disabled=\"vm.FixedMDRAdditionalAmount\"> <span class=\"input-group-addon\" \nid=\"basic-addon1\">RM</span></div><div ng-if=\"vm.tier.MdrOptionType==3\"><div class=\"col-md-6\"><div class=\"input-group\">\n<input type=\"number\" name=\"ReferralFee\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" max=\"=100\" \nng-model=\"vm.tier.MDRAdditionalAmount\" ng-change=\"vm.checkMDRType()\" ng-disabled=\"vm.DisableMDRAdditionalAmount\"> <span\n class=\"input-group-addon\" id=\"basic-addon1\">%</span></div></div><div class=\"col-md-6\"><div class=\"input-group\"><input \ntype=\"number\" name=\"ReferralFee\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.tier.FixedMDRAdditionalAmount\" ng-change=\"vm.checkMDRType()\" ng-disabled=\"vm.FixedMDRAdditionalAmount\"> \n<span class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div></div><div \nng-if=\"(vm.tier.MDRThreshold==0 && vm.tier.MDRActiveDay==0) && (vm.tier.FixedMDRAdditionalAmount==0) && (vm.tier.MDRAdditionalAmount==0)\" \nclass=\"col-md-1\"><div class=\"input-group\"><a class=\"btn btn-primary\" ng-click=\"vm.addThreshold()\"><i \nclass=\"glyphicon glyphicon-plus\"></i></a></div></div></div><div ng-if=\"vm.tier.MdrTierSettingOptions.length>=1\" \nclass=\"form-group\"><div class=\"col-md-3\"></div><div class=\"col-md-2\"><div class=\"input-group\"><label>For Threshold\n</label></div></div><div class=\"col-md-2\"><div class=\"input-group\"><label>Max Transaction Value</label></div></div><div\n class=\"col-md-2\"><div class=\"input-group\"><label>Apply MDR Value</label></div></div><div class=\"col-md-2\"><div \nclass=\"input-group\"><label>MDR Type</label></div></div></div><div \nng-repeat=\"mdrOptionDetails in vm.tier.MdrTierSettingOptions track by $index\" class=\"form-group\"><div class=\"col-md-3\">\n</div><div class=\"col-md-2\"><div class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">RM</span> <input\n type=\"text\" disabled=\"disabled\" name=\"ThresholdFrom{{$index}}\" class=\"form-control\" \nng-model=\"mdrOptionDetails.ForThreshold\" required></div></div><div class=\"col-md-2\"><div class=\"input-group\"><span \nclass=\"input-group-addon\" id=\"basic-addon1\">RM</span> <input type=\"number\" name=\"ThresholdTo{{$index}}\" \nclass=\"form-control\" min=\"0\" ng-blur=\"vm.AmountChange($index)\" ng-model=\"mdrOptionDetails.MaxThreshold\" \nng-disabled=\"vm.disabledMaxThreshold{{$index}}\"></div></div><div ng-if=\"vm.tier.MdrType==1\" class=\"col-md-2\"><div \nclass=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">%</span> <input type=\"number\" \nname=\"ThresholdFixedAmount{{$index}}\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" max=\"=100\" \nng-model=\"mdrOptionDetails.MDRValue\"></div></div><div ng-if=\"vm.tier.MdrType==2\" class=\"col-md-2\"><div \nclass=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">RM</span> <input type=\"number\" \nname=\"ThresholdFixedAmount{{$index}}\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"mdrOptionDetails.MDRValue\"></div></div><div ng-if=\"$index == 0\" class=\"col-md-2\"><div class=\"input-group\">\n<select name=\"MdrThresholdOptionTypeList{{$index}}\" class=\"form-control\" ng-model=\"vm.tier.MdrType\"><option \nng-repeat=\"day in vm.MdrOptionTypeList\" ng-value=\"day.Id\">{{day.Name}}</option></select></div></div><div \nng-if=\"$index != 0\" class=\"col-md-2\"><div class=\"input-group\"><select disabled=\"disabled\" \nname=\"MdrThresholdOptionTypeList{{$index}}\" class=\"form-control\" ng-model=\"vm.tier.MdrType\"><option \nng-repeat=\"day in vm.MdrOptionTypeList\" ng-value=\"day.Id\">{{day.Name}}</option></select></div></div><div \nclass=\"col-md-1\" ng-if=\"vm.tier.MdrTierSettingOptions.length == $index+1\"><div class=\"row\"><a class=\"btn btn-danger\" \nng-click=\"vm.removeThresholdOption($index)\"><i class=\"glyphicon glyphicon-remove\"></i></a></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"admin.tierSetting.detail.mdr_active_day\">\n</label><div class=\"col-md-3\"><div class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">RM</span> \n<input type=\"number\" name=\"ReferralFee\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.tier.MDRActiveDay\" ng-change=\"vm.checkMDRType()\" ng-disabled=\"vm.disabledMDRActiveDay\"> <span \nclass=\"input-group-addon\" id=\"basic-addon1\">per active day</span></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.tierSetting.detail.LDRRate\"></label><div class=\"col-md-3\">\n<div class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">%</span> <input type=\"number\" \nname=\"ReferralFee\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" ng-model=\"vm.tier.LDRShareRate\"></div></div>\n</div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"admin.tierSetting.detail.revenue_share\"></label><div class=\"btn-group col-md-8\"><label \nclass=\"btn btn-default\" ng-model=\"vm.tier.RevenueShare\" uib-btn-radio=\"true\">Yes</label><label class=\"btn btn-default\" \nng-model=\"vm.tier.RevenueShare\" uib-btn-radio=\"false\">No</label></div></div><div ng-if=\"vm.tier.RevenueShare == true\" \nng-repeat=\"revenueShareOption in vm.tier.RevenueShareOptions track by $index\" class=\"form-group\" \nng-class=\"{\'has-error\': (tierForm[\'PercentNumber\'+$index].$invalid && tierForm[\'PercentNumber\'+$index].$touched) ||\r\n                                         (tierForm[\'Months\'+$index].$invalid && tierForm[\'Months\'+$index].$touched)}\">\n<label ng-if=\"$index == 0\" class=\"control-label col-md-3 margin-tb\" translate=\"Partner\'s MDR Share\"></label><label \nng-if=\"$index != 0\" class=\"control-label col-md-3 margin-tb\"></label><div class=\"col-md-3\"><div class=\"input-group\">\n<input type=\"number\" name=\"PercentNumber{{$index}}\" class=\"form-control\" min=\"0\" max=\"100\" \nng-model=\"revenueShareOption.PercentNumber\" required> <span ng-if=\"vm.tier.MdrOptionType!=2\" class=\"input-group-addon\" \nid=\"basic-addon1\">%</span> <span ng-if=\"vm.tier.MdrOptionType==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM</span>\n</div><div ng-messages=\"tierForm[\'PercentNumber\'+$index].$error\"><div ng-message=\"required\" \nng-if=\"tierForm[\'PercentNumber\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"admin.tierSetting.detail.validate.percent_number\"></span></div><div ng-message=\"min\" \nng-if=\"tierForm[\'PercentNumber\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"admin.tierSetting.detail.validate.percent_number_min\"></span></div><div ng-message=\"max\" \nng-if=\"tierForm[\'PercentNumber\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"admin.tierSetting.detail.validate.percent_number_max\"></span></div></div></div><label ng-if=\"$index == 0\" \nclass=\"control-label col-md-2 margin-tb\" translate=\"admin.tierSetting.detail.for_the_first\"></label><label \nng-if=\"$index != 0\" class=\"control-label col-md-2 margin-tb\" translate=\"admin.tierSetting.detail.for_the_next\"></label>\n<div class=\"col-md-2\"><div class=\"input-group\"><input type=\"number\" name=\"Months{{$index}}\" class=\"form-control\" \nmin=\"0\" ng-model=\"revenueShareOption.Months\" required> <span class=\"input-group-addon\" id=\"basic-addon1\">months</span>\n</div><div ng-messages=\"tierForm[\'Months\'+$index].$error\"><div ng-message=\"required\" \nng-if=\"tierForm[\'Months\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"admin.tierSetting.detail.validate.months_required\"></span></div><div ng-message=\"min\" \nng-if=\"tierForm[\'Months\'+$index].$touched\" class=\"help-block\"><span \ntranslate=\"admin.tierSetting.detail.validate.months_min\"></span></div></div><label \nng-if=\"revenueShareOption.Months == 0\">(0 indicates perpetually)</label></div><div class=\"col-md-2\"><div class=\"row\"><a\n class=\"btn btn-danger\" ng-if=\"vm.tier.RevenueShareOptions.length != 1\" ng-click=\"vm.removeOption($index)\"><i \nclass=\"glyphicon glyphicon-remove\"></i></a> <a class=\"btn btn-primary\" \nng-if=\"vm.tier.RevenueShareOptions.length == $index+1\" ng-click=\"vm.addNew()\"><i class=\"glyphicon glyphicon-plus\"></i>\n</a></div></div></div><div class=\"form-group\" ng-if=\"vm.tier.RevenueShare == true\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.tierSetting.detail.revenue_share_monthly_report\"></label><div\n class=\"btn-group col-md-3\"><label class=\"btn btn-default\" ng-model=\"vm.tier.RevenueShareMonthlyReport\" \nuib-btn-radio=\"true\">ON</label><label class=\"btn btn-default\" ng-model=\"vm.tier.RevenueShareMonthlyReport\" \nuib-btn-radio=\"false\">OFF</label></div><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"admin.tierSetting.detail.revenue_share_daily_report\"></label><div class=\"col-md-3 btn-group\"><label \nclass=\"btn btn-default\" ng-model=\"vm.tier.RevenueShareDailyReport\" uib-btn-radio=\"true\">ON</label><label \nclass=\"btn btn-default\" ng-model=\"vm.tier.RevenueShareDailyReport\" uib-btn-radio=\"false\">OFF</label></div></div><div \nclass=\"form-group\" ng-if=\"vm.tier.RevenueShare\"><label class=\"control-label col-md-3\" \ntranslate=\"merchant.rev_share_report\" ng-if=\"vm.tier.RevenueShareMonthlyReport || vm.tier.RevenueShareDailyReport\">\n</label><div class=\"col-md-8\"><div class=\"row form-group\" ng-if=\"vm.tier.RevenueShareMonthlyReport\"><label \nclass=\"control-label col-md-2\">Monthly on</label><div class=\"col-md-2\" \nng-class=\"{\'has-error\': tierForm.MonthlyDay.$invalid && tierForm.MonthlyDay.$touched}\"><select class=\"form-control\" \nng-model=\"vm.monthly.day\" name=\"MonthlyDay\" required><option ng-repeat=\"day in vm.daysOfMonth\" ng-value=\"day.Id\">\n{{day.Name}}</option></select><div ng-messages=\"tierForm.MonthlyDay.$error\"><div ng-message=\"required\" \nng-if=\"tierForm.MonthlyDay.$touched\" class=\"help-block\"><span translate=\"merchant.validate.merchant.monthly_day\">\n</span></div></div></div><label class=\"control-label col-md-1 center\">at</label><div class=\"col-md-2\" \nng-class=\"{\'has-error\': tierForm.MonthlyHour.$invalid && tierForm.MonthlyHour.$touched}\"><select class=\"form-control\" \nng-model=\"vm.monthly.hour\" name=\"MonthlyHour\" required><option ng-repeat=\"hour in vm.hours\" ng-value=\"hour.Id\">\n{{hour.Name}}</option></select><div ng-messages=\"tierForm.MonthlyHour.$error\"><div ng-message=\"required\" \nng-if=\"tierForm.MonthlyHour.$touched\" class=\"help-block\"><span translate=\"merchant.validate.merchant.monthly_hour\">\n</span></div></div></div><label class=\"control-label col-md-1 center\">:</label><div class=\"col-md-2\" \nng-class=\"{\'has-error\': tierForm.MonthlyMin.$invalid && tierForm.MonthlyMin.$touched}\"><select class=\"form-control\" \nng-model=\"vm.monthly.min\" name=\"MonthlyMin\" required><option ng-repeat=\"min in vm.mins\" ng-value=\"min.Id\">{{min.Name}}\n</option></select><div ng-messages=\"tierForm.MonthlyMin.$error\"><div ng-message=\"required\" \nng-if=\"tierForm.MonthlyMin.$touched\" class=\"help-block\"><span translate=\"merchant.validate.merchant.monthly_min\">\n</span></div></div></div></div><div class=\"row form-group\" ng-if=\"vm.tier.RevenueShareDailyReport\"><label \nclass=\"control-label col-md-2\">Daily at</label><div class=\"col-md-2\" \nng-class=\"{\'has-error\': tierForm.DailyHour.$invalid && tierForm.DailyHour.$touched}\"><select class=\"form-control\" \nng-model=\"vm.daily.hour\" name=\"DailyHour\" required><option ng-repeat=\"hour in vm.hours\" ng-value=\"hour.Id\">\n{{hour.Name}}</option></select><div ng-messages=\"tierForm.DailyHour.$error\"><div ng-message=\"required\" \nng-if=\"tierForm.DailyHour.$touched\" class=\"help-block\"><span translate=\"merchant.validate.merchant.daily_hour\"></span>\n</div></div></div><label class=\"control-label col-md-1 center\">:</label><div class=\"col-md-2\" \nng-class=\"{\'has-error\': tierForm.DailyMin.$invalid && tierForm.DailyMin.$touched}\"><select class=\"form-control\" \nng-model=\"vm.daily.min\" name=\"DailyMin\" required><option ng-repeat=\"min in vm.mins\" ng-value=\"min.Id\">{{min.Name}}\n</option></select><div ng-messages=\"tierForm.DailyMin.$error\"><div ng-message=\"required\" \nng-if=\"tierForm.DailyMin.$touched\" class=\"help-block\"><span translate=\"merchant.validate.merchant.daily_min\"></span>\n</div></div></div></div></div></div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"admin.tierSetting.detail.topupFPXMDR\"></label><div class=\"col-md-9 input-group\"><div class=\"col-md-3\">\n<select name=\"Group\" class=\"form-control\" ng-model=\"vm.tier.TopupFPXType\"><option \nng-repeat=\"day in vm.topupFPXMDRoptionList\" ng-value=\"day.Id\">{{day.Name}}</option></select></div><div \nclass=\"col-md-9\"><div class=\"col-md-10\"><div ng-if=\"vm.tier.TopupFPXType==1\" class=\"input-group\"><input type=\"number\" \nname=\"TopupFPXMDR\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" ng-model=\"vm.tier.TopupFPXMDR\"> <span \nclass=\"input-group-addon\" id=\"basic-addon1\">%</span></div><div ng-if=\"vm.tier.TopupFPXType==2\" class=\"input-group\">\n<input type=\"number\" name=\"TopupFPXMDRFixed\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.tier.TopupFPXMDR\"> <span class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div><div \nng-if=\"vm.tier.TopupFPXType==3\"><div class=\"col-md-6\"><div class=\"input-group\"><input type=\"number\" name=\"TopupFPXMDR\" \nclass=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" ng-model=\"vm.tier.TopupFPXMDR\"> <span class=\"input-group-addon\" \nid=\"basic-addon1\">%</span></div></div><div class=\"col-md-6\"><div class=\"input-group\"><input type=\"number\" \nname=\"TopupFPXMDRFixed\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" ng-model=\"vm.tier.TopupFPXMDRFixed\"> \n<span class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"admin.tierSetting.detail.topupCreditCardMDR\"></label><div class=\"col-md-9 input-group\"><div \nclass=\"col-md-3\"><select name=\"Group\" class=\"form-control\" ng-model=\"vm.tier.TopupCreditCardMDRType\"><option \nng-repeat=\"day in vm.topupFPXMDRoptionList\" ng-value=\"day.Id\">{{day.Name}}</option></select></div><div \nclass=\"col-md-9\"><div class=\"col-md-10\"><div ng-if=\"vm.tier.TopupCreditCardMDRType==1\" class=\"input-group\"><input \ntype=\"number\" name=\"TopupCreditCardMDR\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.tier.TopupCreditCardMDR\"> <span class=\"input-group-addon\" id=\"basic-addon1\">%</span></div><div \nng-if=\"vm.tier.TopupCreditCardMDRType==2\" class=\"input-group\"><input type=\"number\" name=\"TopupCreditCardMDRFixed\" \nclass=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" ng-model=\"vm.tier.TopupCreditCardMDRFixed\"> <span \nclass=\"input-group-addon\" id=\"basic-addon1\">RM</span></div><div ng-if=\"vm.tier.TopupCreditCardMDRType==3\"><div \nclass=\"col-md-6\"><div class=\"input-group\"><input type=\"number\" name=\"TopupCreditCardMDR\" class=\"form-control\" \nng-blur=\"vm.checkNull()\" min=\"0\" ng-model=\"vm.tier.TopupCreditCardMDR\"> <span class=\"input-group-addon\" \nid=\"basic-addon1\">%</span></div></div><div class=\"col-md-6\"><div class=\"input-group\"><input type=\"number\" \nname=\"TopupCreditCardMDRFixed\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.tier.TopupCreditCardMDRFixed\"> <span class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div>\n</div></div></div></div></div><div class=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" \ntranslate=\"Linked Card MDR and Revenue Share\"></h4></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"Credit Card\"></label><div class=\"col-md-10 input-group\"><div \nclass=\"col-md-2\"><select name=\"Group\" class=\"form-control\" ng-model=\"vm.tier.CreditCardPaymentMdr\"><option \nng-repeat=\"day in vm.MdrOptionTypeList\" ng-value=\"day.Id\">{{day.Name}}</option></select></div><div class=\"col-md-5\">\n<div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" translate=\"Merchant MDR\"></label><div \nclass=\"col-md-6 input-group\"><input type=\"number\" name=\"CreditCardPaymentMDRValue\" class=\"form-control\" \nng-blur=\"vm.checkMDrRevnueshare()\" min=\"0\" ng-model=\"vm.tier.CreditCardPaymentMDRValue\"> <span \nng-if=\"vm.tier.CreditCardPaymentMdr==1\" class=\"input-group-addon\" id=\"basic-addon1\">%</span> <span \nng-if=\"vm.tier.CreditCardPaymentMdr==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div><div \nclass=\"col-md-5\"><div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" \ntranslate=\"Partner\'s MDR Share\"></label><div class=\"col-md-6 input-group\"><input type=\"number\" \nname=\"CreditCardRevenueShareValue\" class=\"form-control\" ng-blur=\"vm.checkMDrRevnueshare()\" min=\"0\" \nng-model=\"vm.tier.CreditCardRevenueShareValue\"> <span ng-if=\"vm.tier.CreditCardPaymentMdr==1\" \nclass=\"input-group-addon\" id=\"basic-addon1\">%</span> <span ng-if=\"vm.tier.CreditCardPaymentMdr==2\" \nclass=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"Debit Card\"></label><div class=\"col-md-10 input-group\"><div \nclass=\"col-md-2\"><select name=\"Group\" class=\"form-control\" ng-model=\"vm.tier.DebitCardPaymentMdr\"><option \nng-repeat=\"day in vm.MdrOptionTypeList\" ng-value=\"day.Id\">{{day.Name}}</option></select></div><div class=\"col-md-5\">\n<div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" translate=\"Merchant MDR\"></label><div \nclass=\"col-md-6 input-group\"><input type=\"number\" name=\"DebitCardPaymentMDRValue\" class=\"form-control\" min=\"0\" \nng-model=\"vm.tier.DebitCardPaymentMDRValue\"> <span ng-if=\"vm.tier.DebitCardPaymentMdr==1\" class=\"input-group-addon\" \nid=\"basic-addon1\">%</span> <span ng-if=\"vm.tier.DebitCardPaymentMdr==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM\n</span></div></div></div><div class=\"col-md-5\"><div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" \ntranslate=\"Partner\'s MDR Share\"></label><div class=\"col-md-6 input-group\"><input type=\"number\" \nname=\"DebitCardRevenueShareValue\" class=\"form-control\" min=\"0\" ng-model=\"vm.tier.DebitCardRevenueShareValue\"> <span \nng-if=\"vm.tier.DebitCardPaymentMdr==1\" class=\"input-group-addon\" id=\"basic-addon1\">%</span> <span \nng-if=\"vm.tier.DebitCardPaymentMdr==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div></div>\n</div><div class=\"form-group\"><label class=\"control-label col-md-2 margin-tb\" translate=\"Foreign Card\"></label><div \nclass=\"col-md-10 input-group\"><div class=\"col-md-2\"><select name=\"Group\" class=\"form-control\" \nng-model=\"vm.tier.ForeignCardPaymentMdr\"><option ng-repeat=\"day in vm.MdrOptionTypeList\" ng-value=\"day.Id\">{{day.Name}}\n</option></select></div><div class=\"col-md-5\"><div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" \ntranslate=\"Merchant MDR\"></label><div class=\"col-md-6 input-group\"><input type=\"number\" \nname=\"ForeignCardPaymentMDRValue\" class=\"form-control\" min=\"0\" ng-model=\"vm.tier.ForeignCardPaymentMDRValue\"> <span \nng-if=\"vm.tier.ForeignCardPaymentMdr==1\" class=\"input-group-addon\" id=\"basic-addon1\">%</span> <span \nng-if=\"vm.tier.ForeignCardPaymentMdr==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div><div \nclass=\"col-md-5\"><div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" \ntranslate=\"Partner\'s MDR Share\"></label><div class=\"col-md-6 input-group\"><input type=\"number\" \nname=\"ForeignCardRevenueShareValue\" class=\"form-control\" min=\"0\" ng-model=\"vm.tier.ForeignCardRevenueShareValue\"> <span\n ng-if=\"vm.tier.ForeignCardPaymentMdr==1\" class=\"input-group-addon\" id=\"basic-addon1\">%</span> <span \nng-if=\"vm.tier.ForeignCardPaymentMdr==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div></div>\n</div><div class=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" \ntranslate=\"Other E-Wallet MDR and Revenue Share\"></h4></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"TNG Digital\"></label><div class=\"col-md-10 input-group\"><div \nclass=\"col-md-2\"><select name=\"Group\" class=\"form-control\" ng-model=\"vm.tier.TnGPaymentOption\"><option \nng-repeat=\"day in vm.MdrOptionTypeList\" ng-value=\"day.Id\">{{day.Name}}</option></select></div><div class=\"col-md-5\">\n<div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" translate=\"Merchant MDR\"></label><div \nclass=\"col-md-6 input-group\"><input type=\"number\" name=\"TNGMDRValue\" class=\"form-control\" min=\"0\" \nng-model=\"vm.tier.TNGMDRValue\"> <span ng-if=\"vm.tier.TnGPaymentOption==1\" class=\"input-group-addon\" id=\"basic-addon1\">%\n</span> <span ng-if=\"vm.tier.TnGPaymentOption==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div>\n</div><div class=\"col-md-5\"><div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" \ntranslate=\"Partner\'s MDR Share\"></label><div class=\"col-md-6 input-group\"><input type=\"number\" \nname=\"TNGRevenueShareValue\" class=\"form-control\" min=\"0\" ng-model=\"vm.tier.TNGRevenueShareValue\"> <span \nng-if=\"vm.tier.TnGPaymentOption==1\" class=\"input-group-addon\" id=\"basic-addon1\">%</span> <span \nng-if=\"vm.tier.TnGPaymentOption==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div></div></div>\n<div class=\"form-group\"><label class=\"control-label col-md-2 margin-tb\" translate=\"GrabPay\"></label><div \nclass=\"col-md-10 input-group\"><div class=\"col-md-2\"><select name=\"Group\" class=\"form-control\" \nng-model=\"vm.tier.GrabPayPaymentOption\"><option ng-repeat=\"day in vm.MdrOptionTypeList\" ng-value=\"day.Id\">{{day.Name}}\n</option></select></div><div class=\"col-md-5\"><div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" \ntranslate=\"Merchant MDR\"></label><div class=\"col-md-6 input-group\"><input type=\"number\" name=\"GrabPayMDRValue\" \nclass=\"form-control\" min=\"0\" ng-model=\"vm.tier.GrabPayMDRValue\"> <span ng-if=\"vm.tier.GrabPayPaymentOption==1\" \nclass=\"input-group-addon\" id=\"basic-addon1\">%</span> <span ng-if=\"vm.tier.GrabPayPaymentOption==2\" \nclass=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div><div class=\"col-md-5\"><div class=\"col-md-12\">\n<label class=\"control-label col-md-6 margin-tb\" translate=\"Partner\'s MDR Share\"></label><div \nclass=\"col-md-6 input-group\"><input type=\"number\" name=\"GrabPayRevenueShareValue\" class=\"form-control\" min=\"0\" \nng-model=\"vm.tier.GrabPayRevenueShareValue\"> <span ng-if=\"vm.tier.GrabPayPaymentOption==1\" class=\"input-group-addon\" \nid=\"basic-addon1\">%</span> <span ng-if=\"vm.tier.GrabPayPaymentOption==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM\n</span></div></div></div></div></div><div class=\"form-group\"><label class=\"control-label col-md-2 margin-tb\" \ntranslate=\"Boost\"></label><div class=\"col-md-10 input-group\"><div class=\"col-md-2\"><select name=\"Group\" \nclass=\"form-control\" ng-model=\"vm.tier.BoostPaymentOption\"><option ng-repeat=\"day in vm.MdrOptionTypeList\" \nng-value=\"day.Id\">{{day.Name}}</option></select></div><div class=\"col-md-5\"><div class=\"col-md-12\"><label \nclass=\"control-label col-md-6 margin-tb\" translate=\"Merchant MDR\"></label><div class=\"col-md-6 input-group\"><input \ntype=\"number\" name=\"BoostPaymentMDRValue\" class=\"form-control\" min=\"0\" ng-model=\"vm.tier.BoostPaymentMDRValue\"> <span \nng-if=\"vm.tier.BoostPaymentOption==1\" class=\"input-group-addon\" id=\"basic-addon1\">%</span> <span \nng-if=\"vm.tier.BoostPaymentOption==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div><div \nclass=\"col-md-5\"><div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" \ntranslate=\"Partner\'s MDR Share\"></label><div class=\"col-md-6 input-group\"><input type=\"number\" \nname=\"BoostRevenueShareValue\" class=\"form-control\" min=\"0\" ng-model=\"vm.tier.BoostRevenueShareValue\"> <span \nng-if=\"vm.tier.BoostPaymentOption==1\" class=\"input-group-addon\" id=\"basic-addon1\">%</span> <span \nng-if=\"vm.tier.BoostPaymentOption==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div></div>\n</div><div class=\"form-group\"><label class=\"control-label col-md-2 margin-tb\" translate=\"WeChat\"></label><div \nclass=\"col-md-10 input-group\"><div class=\"col-md-2\"><select name=\"Group\" class=\"form-control\" \nng-model=\"vm.tier.WeChatPaymentOption\"><option ng-repeat=\"day in vm.MdrOptionTypeList\" ng-value=\"day.Id\">{{day.Name}}\n</option></select></div><div class=\"col-md-5\"><div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" \ntranslate=\"Merchant MDR\"></label><div class=\"col-md-6 input-group\"><input type=\"number\" name=\"WechatPaymentMDRValue\" \nclass=\"form-control\" min=\"0\" ng-model=\"vm.tier.WechatPaymentMDRValue\"> <span ng-if=\"vm.tier.WeChatPaymentOption==1\" \nclass=\"input-group-addon\" id=\"basic-addon1\">%</span> <span ng-if=\"vm.tier.WeChatPaymentOption==2\" \nclass=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div><div class=\"col-md-5\"><div class=\"col-md-12\">\n<label class=\"control-label col-md-6 margin-tb\" translate=\"Partner\'s MDR Share\"></label><div \nclass=\"col-md-6 input-group\"><input type=\"number\" name=\"WeChatRevenueShareValue\" class=\"form-control\" min=\"0\" \nng-model=\"vm.tier.WeChatRevenueShareValue\"> <span ng-if=\"vm.tier.WeChatPaymentOption==1\" class=\"input-group-addon\" \nid=\"basic-addon1\">%</span> <span ng-if=\"vm.tier.WeChatPaymentOption==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM\n</span></div></div></div></div></div><div class=\"form-group\"><label class=\"control-label col-md-2 margin-tb\" \ntranslate=\"Alipay\"></label><div class=\"col-md-10 input-group\"><div class=\"col-md-2\"><select name=\"Group\" \nclass=\"form-control\" ng-model=\"vm.tier.AlipayPaymentOption\"><option ng-repeat=\"day in vm.MdrOptionTypeList\" \nng-value=\"day.Id\">{{day.Name}}</option></select></div><div class=\"col-md-5\"><div class=\"col-md-12\"><label \nclass=\"control-label col-md-6 margin-tb\" translate=\"Merchant MDR\"></label><div class=\"col-md-6 input-group\"><input \ntype=\"number\" name=\"AlipayPaymentMDRValue\" class=\"form-control\" min=\"0\" ng-model=\"vm.tier.AlipayPaymentMDRValue\"> <span\n ng-if=\"vm.tier.AlipayPaymentOption==1\" class=\"input-group-addon\" id=\"basic-addon1\">%</span> <span \nng-if=\"vm.tier.AlipayPaymentOption==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div><div \nclass=\"col-md-5\"><div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" \ntranslate=\"Partner\'s MDR Share\"></label><div class=\"col-md-6 input-group\"><input type=\"number\" \nname=\"AlipayRevenueShareValue\" class=\"form-control\" min=\"0\" ng-model=\"vm.tier.AlipayRevenueShareValue\"> <span \nng-if=\"vm.tier.AlipayPaymentOption==1\" class=\"input-group-addon\" id=\"basic-addon1\">%</span> <span \nng-if=\"vm.tier.AlipayPaymentOption==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div></div>\n</div><div class=\"form-group\"><label class=\"control-label col-md-2 margin-tb\" translate=\"MayBank QR\"></label><div \nclass=\"col-md-10 input-group\"><div class=\"col-md-2\"><select name=\"Group\" class=\"form-control\" \nng-model=\"vm.tier.MayBankPaymentOption\"><option ng-repeat=\"day in vm.MdrOptionTypeList\" ng-value=\"day.Id\">{{day.Name}}\n</option></select></div><div class=\"col-md-5\"><div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" \ntranslate=\"Merchant MDR\"></label><div class=\"col-md-6 input-group\"><input type=\"number\" name=\"MayBankPaymentMDRValue\" \nclass=\"form-control\" min=\"0\" ng-model=\"vm.tier.MayBankPaymentMDRValue\"> <span ng-if=\"vm.tier.MayBankPaymentOption==1\" \nclass=\"input-group-addon\" id=\"basic-addon1\">%</span> <span ng-if=\"vm.tier.MayBankPaymentOption==2\" \nclass=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div><div class=\"col-md-5\"><div class=\"col-md-12\">\n<label class=\"control-label col-md-6 margin-tb\" translate=\"Partner\'s MDR Share\"></label><div \nclass=\"col-md-6 input-group\"><input type=\"number\" name=\"MayBankRevenueShareValue\" class=\"form-control\" min=\"0\" \nng-model=\"vm.tier.MayBankRevenueShareValue\"> <span ng-if=\"vm.tier.MayBankPaymentOption==1\" class=\"input-group-addon\" \nid=\"basic-addon1\">%</span> <span ng-if=\"vm.tier.MayBankPaymentOption==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM\n</span></div></div></div></div></div><div class=\"form-group\"><label class=\"control-label col-md-2 margin-tb\" \ntranslate=\"RazerPay\"></label><div class=\"col-md-10 input-group\"><div class=\"col-md-2\"><select name=\"Group\" \nclass=\"form-control\" ng-model=\"vm.tier.RazerPayPaymentOption\"><option ng-repeat=\"day in vm.MdrOptionTypeList\" \nng-value=\"day.Id\">{{day.Name}}</option></select></div><div class=\"col-md-5\"><div class=\"col-md-12\"><label \nclass=\"control-label col-md-6 margin-tb\" translate=\"Merchant MDR\"></label><div class=\"col-md-6 input-group\"><input \ntype=\"number\" name=\"RazerPayPaymentMDRValue\" class=\"form-control\" min=\"0\" ng-model=\"vm.tier.RazerPayPaymentMDRValue\"> \n<span ng-if=\"vm.tier.RazerPayPaymentOption==1\" class=\"input-group-addon\" id=\"basic-addon1\">%</span> <span \nng-if=\"vm.tier.RazerPayPaymentOption==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div><div \nclass=\"col-md-5\"><div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" \ntranslate=\"Partner\'s MDR Share\"></label><div class=\"col-md-6 input-group\"><input type=\"number\" \nname=\"RazerPayRevenueShareValue\" class=\"form-control\" min=\"0\" ng-model=\"vm.tier.RazerPayRevenueShareValue\"> <span \nng-if=\"vm.tier.RazerPayPaymentOption==1\" class=\"input-group-addon\" id=\"basic-addon1\">%</span> <span \nng-if=\"vm.tier.RazerPayPaymentOption==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div></div>\n</div><div class=\"form-group\"><label class=\"control-label col-md-2 margin-tb\" translate=\"Wechat Int\"></label><div \nclass=\"col-md-10 input-group\"><div class=\"col-md-2\"><select name=\"Group\" class=\"form-control\" \nng-model=\"vm.tier.WechatIntPaymentOption\"><option ng-repeat=\"day in vm.MdrOptionTypeList\" ng-value=\"day.Id\">\n{{day.Name}}</option></select></div><div class=\"col-md-5\"><div class=\"col-md-12\"><label \nclass=\"control-label col-md-6 margin-tb\" translate=\"Merchant MDR\"></label><div class=\"col-md-6 input-group\"><input \ntype=\"number\" name=\"WechatIntPaymentMDRValue\" class=\"form-control\" min=\"0\" ng-model=\"vm.tier.WechatIntPaymentMDRValue\">\n <span ng-if=\"vm.tier.WechatIntPaymentOption==1\" class=\"input-group-addon\" id=\"basic-addon1\">%</span> <span \nng-if=\"vm.tier.WechatIntPaymentOption==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div><div \nclass=\"col-md-5\"><div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" \ntranslate=\"Partner\'s MDR Share\"></label><div class=\"col-md-6 input-group\"><input type=\"number\" \nname=\"WechatIntRevenueShareValue\" class=\"form-control\" min=\"0\" ng-model=\"vm.tier.WechatIntRevenueShareValue\"> <span \nng-if=\"vm.tier.WechatIntPaymentOption==1\" class=\"input-group-addon\" id=\"basic-addon1\">%</span> <span \nng-if=\"vm.tier.WechatIntPaymentOption==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div></div>\n</div><div class=\"form-group\"><label class=\"control-label col-md-2 margin-tb\" translate=\"Alipay Int\"></label><div \nclass=\"col-md-10 input-group\"><div class=\"col-md-2\"><select name=\"Group\" class=\"form-control\" \nng-model=\"vm.tier.AlipayIntPayPaymentOption\"><option ng-repeat=\"day in vm.MdrOptionTypeList\" ng-value=\"day.Id\">\n{{day.Name}}</option></select></div><div class=\"col-md-5\"><div class=\"col-md-12\"><label \nclass=\"control-label col-md-6 margin-tb\" translate=\"Merchant MDR\"></label><div class=\"col-md-6 input-group\"><input \ntype=\"number\" name=\"AlipayIntyPaymentMDRValue\" class=\"form-control\" min=\"0\" \nng-model=\"vm.tier.AlipayIntyPaymentMDRValue\"> <span ng-if=\"vm.tier.AlipayIntPayPaymentOption==1\" \nclass=\"input-group-addon\" id=\"basic-addon1\">%</span> <span ng-if=\"vm.tier.AlipayIntPayPaymentOption==2\" \nclass=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div><div class=\"col-md-5\"><div class=\"col-md-12\">\n<label class=\"control-label col-md-6 margin-tb\" translate=\"Partner\'s MDR Share\"></label><div \nclass=\"col-md-6 input-group\"><input type=\"number\" name=\"AlipayIntRevenueShareValue\" class=\"form-control\" min=\"0\" \nng-model=\"vm.tier.AlipayIntRevenueShareValue\"> <span ng-if=\"vm.tier.AlipayIntPayPaymentOption==1\" \nclass=\"input-group-addon\" id=\"basic-addon1\">%</span> <span ng-if=\"vm.tier.AlipayIntPayPaymentOption==2\" \nclass=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"Selangkah Wallet\"></label><div class=\"col-md-10 input-group\"><div \nclass=\"col-md-2\"><select name=\"Group\" class=\"form-control\" ng-model=\"vm.tier.SelangkahWalletPaymentOption\"><option \nng-repeat=\"day in vm.MdrOptionTypeList\" ng-value=\"day.Id\">{{day.Name}}</option></select></div><div class=\"col-md-5\">\n<div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" translate=\"Merchant MDR\"></label><div \nclass=\"col-md-6 input-group\"><input type=\"number\" name=\"SelangkahWalletPaymentMDRValue\" class=\"form-control\" min=\"0\" \nng-model=\"vm.tier.SelangkahWalletPaymentMDRValue\"> <span ng-if=\"vm.tier.SelangkahWalletPaymentOption==1\" \nclass=\"input-group-addon\" id=\"basic-addon1\">%</span> <span ng-if=\"vm.tier.SelangkahWalletPaymentOption==2\" \nclass=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div><div class=\"col-md-5\"><div class=\"col-md-12\">\n<label class=\"control-label col-md-6 margin-tb\" translate=\"Partner\'s MDR Share\"></label><div \nclass=\"col-md-6 input-group\"><input type=\"number\" name=\"SelangkahWalletRevenueShareValue\" class=\"form-control\" min=\"0\" \nng-model=\"vm.tier.SelangkahWalletRevenueShareValue\"> <span ng-if=\"vm.tier.SelangkahWalletPaymentOption==1\" \nclass=\"input-group-addon\" id=\"basic-addon1\">%</span> <span ng-if=\"vm.tier.SelangkahWalletPaymentOption==2\" \nclass=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-2 margin-tb\" translate=\"DuitNow\"></label><div class=\"col-md-10 input-group\"><div \nclass=\"col-md-2\"><select name=\"Group\" class=\"form-control\" ng-model=\"vm.tier.DuitNowPaymentOption\"><option \nng-repeat=\"day in vm.MdrOptionTypeList\" ng-value=\"day.Id\">{{day.Name}}</option></select></div><div class=\"col-md-5\">\n<div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" translate=\"Merchant MDR\"></label><div \nclass=\"col-md-6 input-group\"><input type=\"number\" name=\"DuitNowPaymentMDRValue\" class=\"form-control\" min=\"0\" \nng-model=\"vm.tier.DuitNowPaymentMDRValue\"> <span ng-if=\"vm.tier.DuitNowPaymentOption==1\" class=\"input-group-addon\" \nid=\"basic-addon1\">%</span> <span ng-if=\"vm.tier.DuitNowPaymentOption==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM\n</span></div></div></div><div class=\"col-md-5\"><div class=\"col-md-12\"><label class=\"control-label col-md-6 margin-tb\" \ntranslate=\"Partner\'s MDR Share\"></label><div class=\"col-md-6 input-group\"><input type=\"number\" \nname=\"DuitNowRevenueShareValue\" class=\"form-control\" min=\"0\" ng-model=\"vm.tier.DuitNowRevenueShareValue\"> <span \nng-if=\"vm.tier.DuitNowPaymentOption==1\" class=\"input-group-addon\" id=\"basic-addon1\">%</span> <span \nng-if=\"vm.tier.DuitNowPaymentOption==2\" class=\"input-group-addon\" id=\"basic-addon1\">RM</span></div></div></div></div>\n</div><div class=\"form-group\"><div class=\"col-md-12\"><h4 class=\"sub-title\" \ntranslate=\"admin.tierSetting.detail.marketing_group\"></h4></div></div><div class=\"form-group\" \nng-class=\"{\'has-error\': tierForm.Concurrent.$invalid && tierForm.Concurrent.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.tierSetting.detail.concurrent\"></label><div class=\"col-md-8\">\n<div class=\"input-group\"><input type=\"number\" name=\"Concurrent\" class=\"form-control\" min=\"-1\" \nng-model=\"vm.tier.ConcurrentPromos\"> <span class=\"input-group-addon\" id=\"basic-addon1\">(Unlimited = -1)</span></div>\n<div ng-messages=\"tierForm.Concurrent.$error\"><div ng-message=\"min\" ng-if=\"tierForm.Concurrent.$touched\" \nclass=\"help-block\"><span translate=\"admin.tierSetting.detail.validate.concurrent\"></span></div></div></div></div><div \nclass=\"form-group\" \nng-class=\"{\'has-error\': tierForm.ConcurrentDealVouchers.$invalid && tierForm.ConcurrentDealVouchers.$touched}\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.tierSetting.detail.concurrent_deal_vouchers\"></label><div \nclass=\"col-md-8\"><div class=\"input-group\"><input type=\"number\" name=\"ConcurrentDealVouchers\" class=\"form-control\" \nng-model=\"vm.tier.ConcurrentDealVouchers\" min=\"-1\"> <span class=\"input-group-addon\" id=\"basic-addon1\">(Unlimited = -1)\n</span></div><div ng-messages=\"tierForm.ConcurrentDealVouchers.$error\"><div ng-message=\"min\" \nng-if=\"tierForm.ConcurrentDealVouchers.$touched\" class=\"help-block\"><span \ntranslate=\"admin.tierSetting.detail.validate.concurrent_deal_vouchers\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"admin.tierSetting.detail.minimum_cash_back\"></label><div class=\"col-md-8\"><div class=\"input-group\"><input \ntype=\"number\" name=\"MinimumCash\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.tier.MinimumCashBackRequired\"> <span class=\"input-group-addon\" id=\"basic-addon1\">%</span></div></div>\n</div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"admin.tierSetting.detail.deal_voucher\"></label><div class=\"col-md-8\"><div class=\"input-group\"><input \ntype=\"number\" name=\"DealVouchers\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.tier.DealVoucherCommission\"> <span class=\"input-group-addon\" id=\"basic-addon1\">%</span></div></div></div>\n<div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"admin.tierSetting.detail.cash_back_matching\"></label><div class=\"col-md-8\"><div class=\"input-group\"><input \ntype=\"number\" name=\"CashBack\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-model=\"vm.tier.CashBackMatching\"> <span class=\"input-group-addon\" id=\"basic-addon1\">%</span></div></div></div><div \nclass=\"form-group\" ng-class=\"{\'has-error\': tierForm.FeaturedMerchant.$invalid && tierForm.FeaturedMerchant.$touched}\">\n<label class=\"control-label col-md-3 margin-tb\" translate=\"admin.tierSetting.detail.featured_merchant\"></label><div \nclass=\"col-md-8\"><div class=\"input-group\"><input type=\"number\" name=\"FeaturedMerchant\" class=\"form-control\" \nng-blur=\"vm.checkNull()\" min=\"0\" ng-pattern=\"/^[0-9]*$/\" ng-model=\"vm.tier.FeaturedMerchantListing\"> <span \nclass=\"input-group-addon\" id=\"basic-addon1\">month</span></div><div ng-messages=\"tierForm.FeaturedMerchant.$error\"><div \nng-message=\"pattern\" ng-if=\"tierForm.FeaturedMerchant.$touched\" class=\"help-block\"><span \ntranslate=\"admin.tierSetting.detail.validate.featured_merchant\"></span></div></div></div></div><div class=\"form-group\">\n<label class=\"control-label col-md-3 margin-tb\" translate=\"admin.tierSetting.detail.deal_voucher_edm\"></label><div \nclass=\"col-md-4 margin-tb\"><div class=\"input-group\"><input type=\"number\" name=\"DealVoucherEdm\" class=\"form-control\" \nng-blur=\"vm.checkNull()\" min=\"0\" ng-model=\"vm.tier.DealVoucherEDMBlastAmount\"> <span class=\"input-group-addon\" \nid=\"basic-addon1\"></span></div></div><div class=\"col-md-4 margin-tb\"><div class=\"input-group\" \nng-class=\"{\'has-error\': tierForm.FeaturedMerchantMonth.$invalid && tierForm.FeaturedMerchantMonth.$touched}\"><span \nclass=\"input-group-addon\" id=\"basic-addon1\">every</span> <input type=\"number\" name=\"FeaturedMerchantMonth\" \nclass=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" ng-pattern=\"/^[0-9]*$/\" \nng-model=\"vm.tier.DealVoucherEDMBlastMonthThreshold\"> <span class=\"input-group-addon\" id=\"basic-addon1\">months</span>\n</div><div ng-messages=\"tierForm.FeaturedMerchantMonth.$error\"><div ng-message=\"pattern\" \nng-if=\"tierForm.FeaturedMerchantMonth.$touched\" class=\"help-block\"><span \ntranslate=\"admin.tierSetting.detail.validate.deal_voucher_month\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"admin.tierSetting.detail.pop_up_notification\"></label><div class=\"col-md-8\"><div class=\"input-group\"><span \nclass=\"input-group-addon\" id=\"basic-addon1\">RM</span> <input type=\"number\" name=\"PopUp\" class=\"form-control\" \nng-blur=\"vm.checkNull()\" min=\"0\" ng-model=\"vm.tier.PopupNotifications\"> <span class=\"input-group-addon\" \nid=\"basic-addon1\">per blast</span></div></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.tierSetting.detail.featured_mer_email\"></label><div \nclass=\"col-md-4 margin-tb\" \nng-class=\"{\'has-error\': tierForm.FeaturedMerchantEmailAmount.$invalid && tierForm.FeaturedMerchantEmailAmount.$touched}\">\n<div class=\"input-group\"><input type=\"number\" name=\"FeaturedMerchantEmailAmount\" class=\"form-control\" \nng-blur=\"vm.checkNull()\" min=\"0\" ng-pattern=\"/^[0-9]*$/\" ng-model=\"vm.tier.FeaturedMerchantEmailAmount\"> <span \nclass=\"input-group-addon\" id=\"basic-addon1\"></span></div><div \nng-messages=\"tierForm.FeaturedMerchantEmailAmount.$error\"><div ng-message=\"pattern\" \nng-if=\"tierForm.FeaturedMerchantEmailAmount.$touched\" class=\"help-block\"><span \ntranslate=\"admin.tierSetting.detail.validate.featured_mer_email\"></span></div></div></div><div \nclass=\"col-md-4 margin-tb\" \nng-class=\"{\'has-error\': tierForm.FeaturedMerchantEmailMonthsThreshold.$invalid && tierForm.FeaturedMerchantEmailMonthsThreshold.$touched}\">\n<div class=\"input-group\"><span class=\"input-group-addon\" id=\"basic-addon1\">per</span> <input type=\"number\" \nname=\"FeaturedMerchantEmailMonthsThreshold\" class=\"form-control\" ng-blur=\"vm.checkNull()\" min=\"0\" \nng-pattern=\"/^[0-9]*$/\" ng-model=\"vm.tier.FeaturedMerchantEmailMonthsThreshold\"> <span class=\"input-group-addon\" \nid=\"basic-addon1\">months</span></div><div ng-messages=\"tierForm.FeaturedMerchantEmailMonthsThreshold.$error\"><div \nng-message=\"pattern\" ng-if=\"tierForm.FeaturedMerchantEmailMonthsThreshold.$touched\" class=\"help-block\"><span \ntranslate=\"admin.tierSetting.detail.validate.featured_mer_email_month\"></span></div></div></div></div><div \nclass=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" translate=\"admin.tierSetting.detail.register_code\">\n</label><div class=\"btn-group col-md-8\"><label class=\"btn btn-default\" ng-model=\"vm.tier.RegisterationCodes\" \nuib-btn-radio=\"true\">Yes</label><label class=\"btn btn-default\" ng-model=\"vm.tier.RegisterationCodes\" \nuib-btn-radio=\"false\">No</label></div></div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"admin.tierSetting.detail.sale_report\"></label><div class=\"btn-group col-md-8\"><label \nclass=\"btn btn-default\" ng-model=\"vm.tier.SalesReports\" uib-btn-radio=\"true\">Yes</label><label class=\"btn btn-default\" \nng-model=\"vm.tier.SalesReports\" uib-btn-radio=\"false\">No</label></div></div><div class=\"form-group\"><label \nclass=\"control-label col-md-3 margin-tb\" translate=\"admin.tierSetting.detail.marketing_campaign\"></label><div \nclass=\"btn-group col-md-8\"><label class=\"btn btn-default\" ng-model=\"vm.tier.MarketingCampaignReports\" \nuib-btn-radio=\"true\">Yes</label><label class=\"btn btn-default\" ng-model=\"vm.tier.MarketingCampaignReports\" \nuib-btn-radio=\"false\">No</label></div></div><div class=\"form-group\"><label class=\"control-label col-md-3 margin-tb\" \ntranslate=\"admin.tierSetting.detail.online_web_portal\"></label><div class=\"btn-group col-md-8\"><label \nclass=\"btn btn-default\" ng-model=\"vm.tier.OnlineWebPortal\" uib-btn-radio=\"true\">Yes</label><label \nclass=\"btn btn-default\" ng-model=\"vm.tier.OnlineWebPortal\" uib-btn-radio=\"false\">No</label></div></div></div><div \nclass=\"modal-footer footer-center\"><a class=\"btn btn-danger\" ui-sref=\"app.admin.tierSetting\" \ntranslate=\"common.action.cancel\"></a> <button type=\"submit\" class=\"btn btn-primary\" translate=\"common.action.save\">\n</button></div></form><div id=\"message\" class=\"form-group\"><div data-ng-show=\"vm.showMessage\" \nng-class=\"{fade:vm.doFade,\'alert alert-danger\': !vm.isSuccess,\'alert alert-success\': vm.isSuccess}\"><strong>\n{{vm.alertTitle}}</strong> {{vm.errorMessage}}</div></div></div>");
$templateCache.put("app/report/bonus/disbursement/bonus-disbursement-report.html","<div id=\"divDisbursementReport\" ng-init=\"vm.getUniversities()\"><h1 class=\"page-header\" \ntranslate=\"report.names.bonus_disbursement_report\"></h1><div class=\"report-filter\"><div class=\"panel panel-default\">\n<div class=\"panel-heading\" data-toggle=\"collapse\" data-target=\"#collapse_panel\"><span class=\"panel-title\" \ntranslate=\"report.report_filter\"></span> <a class=\"pull-right\"><i class=\"glyphicon glyphicon-fullscreen\"></i></a></div>\n<div id=\"collapse_panel\" class=\"collapse in\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4\"><div \nclass=\"form-group\"><label class=\"control-label\">\n{{ \'report.disbursement_report.start_disbursement_dateTime\' | translate}}</label><input \nid=\"disbursementReportStartDate\" type=\"text\" name=\"disbursementReportStartDate\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpenDisbursement\" \nng-click=\"vm.datePopup.StartOpenDisbursement = true\" ng-model=\"vm.serachModel.disbursementReportStartDate\"></div></div>\n<div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">\n{{ \'report.disbursement_report.end_disbursement_dateTime\' | translate}}</label><input id=\"disbursementReportEndDate\" \ntype=\"text\" name=\"disbursementReportEndDate\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" \nis-open=\"vm.datePopup.EndOpenDisbursement\" ng-click=\"vm.datePopup.EndOpenDisbursement = true\" \nng-model=\"vm.serachModel.disbursementReportEndDate\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label \nclass=\"control-label\">{{ \'report.disbursement_report.status\' | translate}}</label><select class=\"form-control\" \nng-model=\"vm.serachModel.status\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}</option><option \nng-repeat=\"v in vm.statusList\" ng-value=\"v.status\">{{v.displayText}}</option></select></div></div></div><hr><div \nclass=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">\n{{ \'report.disbursement_report.id_number\' | translate}}</label><input id=\"idNo\" name=\"idNo\" class=\"form-control\" \ntype=\"text\" ng-model=\"vm.serachModel.idNo\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label \nclass=\"control-label\">{{ \'report.disbursement_report.university_id\' | translate}}</label><input id=\"UniversityId\" \nname=\"UniversityId\" class=\"form-control\" type=\"text\" ng-model=\"vm.serachModel.universityId\"></div></div><div \nclass=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">\n{{ \'report.disbursement_report.university\' | translate}}</label><select class=\"form-control\" id=\"UniversityCode\" \nname=\"UniversityCode\" ng-model=\"vm.serachModel.universityCode\" ng-change=\"vm.UniversityIdClick()\" \nng-disabled=\"vm.isReadonly\"><option value=\"\">--Select University--</option><option \nng-repeat=\"university in vm.UniversityItems\" value=\"{{university.UniversityId}}\">{{university.UniversityId}}</option>\n</select></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">\n{{ \'report.disbursement_report.user_name\' | translate}}</label><input id=\"userName\" name=\"userName\" \nclass=\"form-control\" type=\"text\" ng-model=\"vm.serachModel.userName\"></div></div></div><hr><div class=\"row\"><div \nclass=\"col-xs-12\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.searchReport()\" \ntranslate=\"report.summarize\"></button></div></div><div role=\"alert\" ng-show=\"vm.errorMsg\" class=\"alert alert-danger\">\n{{vm.errorMsg}}</div></div></div></div></div><div class=\"table-responsive\"><table datatable=\"\" \ndt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.dtInstance\"><thead><tr><th>\n{{ \'report.disbursement_report.disbursement_dateTime\' | translate}}</th><th>\n{{ \'report.disbursement_report.user_name\' | translate }}</th><th>\n{{ \'report.disbursement_report.id_number\' | translate }}</th><th>\n{{ \'report.disbursement_report.university_id\' | translate }}</th><th>\n{{ \'report.disbursement_report.university\' | translate }}</th><th>\n{{ \'report.disbursement_report.totalPrefund\' | translate }}</th><th>\n{{ \'report.disbursement_report.status\' | translate }}</th><th>{{ \'report.disbursement_report.remarks\' | translate }}\n</th></tr></thead></table></div></div>");
$templateCache.put("app/report/redpay/redpayTransaction/redpay-transaction.html","<div id=\"divRedPayTransactionReport\" ng-init=\"vm.init()\"><h1 class=\"page-header\" \ntranslate=\"report.names.redpay_transaction_report\"></h1><div class=\"report-filter\"><div class=\"panel panel-default\">\n<div class=\"panel-heading\" data-toggle=\"collapse\" data-target=\"#collapse_panel\"><span class=\"panel-title\" \ntranslate=\"report.report_filter\"></span> <a class=\"pull-right\"><i class=\"glyphicon glyphicon-fullscreen\"></i></a></div>\n<div id=\"collapse_panel\" class=\"collapse in\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4\"><div \nclass=\"form-group\"><label class=\"control-label\">Start Date</label><input id=\"startDate\" name=\"startDate\" \nclass=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" is-open=\"vm.datePopup.StartOpen\" \nng-click=\"vm.datePopup.StartOpen = true\" ng-model=\"vm.searchModel.startDate\" placeholder=\"YYYY-MM-DD\"></div></div><div \nclass=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">End Date</label><input id=\"endDate\" \nname=\"endDate\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" is-open=\"vm.datePopup.EndOpen\" \nng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.searchModel.endDate\" placeholder=\"YYYY-MM-DD\"></div></div><div \nclass=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">Username</label><input id=\"username\" \nname=\"username\" class=\"form-control\" type=\"text\" ng-model=\"vm.searchModel.username\" placeholder=\"Enter username\"></div>\n</div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">Full Name\n</label><input id=\"fullName\" name=\"fullName\" class=\"form-control\" type=\"text\" ng-model=\"vm.searchModel.fullName\" \nplaceholder=\"Enter full name\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">\nTransaction Type</label><select class=\"form-control\" ng-model=\"vm.searchModel.transactionType\"><option value=\"\">All\n</option><option value=\"VISA\">VISA</option><option value=\"Wallet\">Wallet</option></select></div></div><div \nclass=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\">Merchant Name</label><input id=\"merchantName\" \nname=\"merchantName\" class=\"form-control\" type=\"text\" ng-model=\"vm.searchModel.merchantName\" \nplaceholder=\"Enter merchant name\"></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><button type=\"button\" \nclass=\"btn btn-primary pull-right\" ng-click=\"vm.searchReport()\" translate=\"report.summarize\">Summarize</button></div>\n</div><div role=\"alert\" ng-show=\"vm.errorMsg\" class=\"alert alert-danger\">{{vm.errorMsg}}</div></div></div></div></div>\n<div class=\"table-responsive\"><table datatable=\"\" dt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.dtInstance\"></table></div></div>");
$templateCache.put("app/report/wallet/monthlyWalletUtilization/wallet-monthly-wallet-utilization.html","<div id=\"divMonthlyWalletUtilizationReport\" ng-init=\"vm.init()\"><h1 class=\"page-header\" \ntranslate=\"report.names.monthly_wallet_utilization\"></h1><div class=\"report-filter\"><div class=\"panel panel-default\">\n<div class=\"panel-heading\" data-toggle=\"collapse\" data-target=\"#collapse_panel\"><span class=\"panel-title\" \ntranslate=\"report.report_filter\"></span> <a class=\"pull-right\"><i class=\"glyphicon glyphicon-fullscreen\"></i></a></div>\n<div id=\"collapse_panel\" class=\"collapse in\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4\"><div \nclass=\"form-group\"><label class=\"control-label\"><span \ntranslate=\"report.monthly_wallet_utilization.TransactionStartMonth\"></span> <span class=\"text-danger\">*</span></label>\n<input id=\"startMonth\" name=\"startMonth\" class=\"form-control\" uib-datepicker-popup=\"MM/yyyy\" \nis-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" ng-model=\"vm.searchModel.startMonth\" \nplaceholder=\"MM/YYYY\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\"><span \ntranslate=\"report.monthly_wallet_utilization.TransactionEndMonth\"></span> <span class=\"text-danger\">*</span></label>\n<input id=\"endMonth\" name=\"endMonth\" class=\"form-control\" uib-datepicker-popup=\"MM/yyyy\" \nis-open=\"vm.datePopup.EndOpen\" ng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.searchModel.endMonth\" \nplaceholder=\"MM/YYYY\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.monthly_wallet_utilization.RegDate\"></label><input id=\"regDate\" name=\"regDate\" class=\"form-control\" \nuib-datepicker-popup=\"yyyy-MM-dd\" is-open=\"vm.datePopup.RegDateOpen\" ng-click=\"vm.datePopup.RegDateOpen = true\" \nng-model=\"vm.searchModel.regDate\" placeholder=\"YYYY-MM-DD\"></div></div></div><div class=\"row\"><div class=\"col-md-4\">\n<div class=\"form-group\"><label class=\"control-label\" translate=\"report.monthly_wallet_utilization.UserID\"></label>\n<input id=\"userId\" name=\"userId\" class=\"form-control\" type=\"text\" ng-model=\"vm.searchModel.userId\" \nplaceholder=\"Enter User ID\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.monthly_wallet_utilization.WebcashID\"></label><input id=\"webcashId\" name=\"webcashId\" \nclass=\"form-control\" type=\"text\" ng-model=\"vm.searchModel.webcashId\" placeholder=\"Enter Webcash ID\"></div></div><div \nclass=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.monthly_wallet_utilization.FullName\"></label><input id=\"fullName\" name=\"fullName\" \nclass=\"form-control\" type=\"text\" ng-model=\"vm.searchModel.fullName\" placeholder=\"Enter full name\"></div></div></div>\n<div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.monthly_wallet_utilization.WalletType\"></label><select class=\"form-control\" \nng-model=\"vm.searchModel.walletType\"><option value=\"0\">\n{{ \'report.monthly_wallet_utilization.walletType0\' | translate }}</option><option value=\"1\">\n{{ \'report.monthly_wallet_utilization.walletType1\' | translate }}</option><option value=\"2\">\n{{ \'report.monthly_wallet_utilization.walletType2\' | translate }}</option></select></div></div><div class=\"col-md-4\">\n<div class=\"form-group\"><label class=\"control-label\" translate=\"report.monthly_wallet_utilization.eKYCStatus\"></label>\n<select class=\"form-control\" ng-model=\"vm.searchModel.ekycStatus\"><option value=\"1\">\n{{ \'report.monthly_wallet_utilization.eKYCStatus0\' | translate }}</option><option value=\"2\">\n{{ \'report.monthly_wallet_utilization.eKYCStatus1\' | translate }}</option><option value=\"3\">\n{{ \'report.monthly_wallet_utilization.eKYCStatus2\' | translate }}</option><option value=\"4\">\n{{ \'report.monthly_wallet_utilization.eKYCStatus3\' | translate }}</option><option value=\"5\">\n{{ \'report.monthly_wallet_utilization.eKYCStatus4\' | translate }}</option><option value=\"6\">\n{{ \'report.monthly_wallet_utilization.eKYCStatus5\' | translate }}</option></select></div></div><div class=\"col-md-4\">\n<div class=\"form-group\"><label class=\"control-label\" translate=\"report.monthly_wallet_utilization.EWagesEmployer\">\n</label><input id=\"ewagesEmployer\" name=\"ewagesEmployer\" class=\"form-control\" type=\"text\" \nng-model=\"vm.searchModel.ewagesEmployer\" placeholder=\"Enter eWages Employer Name\"></div></div><div class=\"col-md-4\">\n<div class=\"form-group\"><label class=\"control-label\" translate=\"report.partner\"></label><select class=\"form-control\" \nng-model=\"vm.searchModel.partner\"><option value=\"\">{{ \'report.common.option_all\' | translate }}</option><option \nng-repeat=\"type in vm.appTypes\" value=\"{{ type }}\">{{ type }}</option></select></div></div><div class=\"row\"><div \nclass=\"col-xs-12\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.searchReport()\" \ntranslate=\"report.summarize\"></button></div></div><div role=\"alert\" ng-show=\"vm.errorMsg\" class=\"alert alert-danger\">\n{{vm.errorMsg}}</div></div></div></div></div><div class=\"table-responsive\"><table datatable=\"\" \ndt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.dtInstanceCallback\"><thead><tr><th>\n{{ \'report.monthly_wallet_utilization.Month\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.RegDate\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.UserID\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.WebcashID\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.Partner\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.FullName\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.WalletType\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.eKYCStatus\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.EWagesEmployer\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.in_cards\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.in_fpx\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.in_p2p\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.in_prefund\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.in_zakat\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.in_visa\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.in_wu\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.in_va\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.in_otc\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.TotalIncomingFunds\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.out_p2p\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.out_visa\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.out_atm\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.out_ptptn\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.out_bills\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.out_qr\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.out_wu\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.out_duitnow\' | translate }}</th><th>\n{{ \'report.monthly_wallet_utilization.TotalOutgoingFunds\' | translate }}</th></tr></thead></table></div></div></div>");
$templateCache.put("app/report/wallet/walletSourceOfFundReport/wallet-source-of-fund-report.html","<div id=\"divWalletSourceOfFundReport\" ng-init=\"vm.getUniversities()\"><h1 class=\"page-header\" \ntranslate=\"report.names.wallet_source_of_fund_report\"></h1><div class=\"report-filter\"><div class=\"panel panel-default\">\n<div class=\"panel-heading\" data-toggle=\"collapse\" data-target=\"#collapse_panel\"><span class=\"panel-title\" \ntranslate=\"report.report_filter\"></span> <a class=\"pull-right\"><i class=\"glyphicon glyphicon-fullscreen\"></i></a></div>\n<div id=\"collapse_panel\" class=\"collapse in\"><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4\"><div \nclass=\"form-group\"><label class=\"control-label\">{{ \'report.wallet_source_of_fund_report.username\' | translate}}</label>\n<input id=\"userName\" name=\"userName\" class=\"form-control\" type=\"text\" ng-model=\"vm.serachModel.userName\"></div></div>\n<div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label required\" \ntranslate=\"report.common.transaction_start_date\"></label><input type=\"text\" id=\"sdate\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" \nng-model=\"vm.serachModel.beginTime\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label \nclass=\"control-label required\" translate=\"report.common.transaction_end_date\"></label><input type=\"text\" id=\"edate\" \nclass=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" \nng-click=\"vm.datePopup.EndOpen = true\" ng-model=\"vm.serachModel.endTime\"></div></div></div><hr><div class=\"row\"><div \nclass=\"col-xs-12\"><button type=\"button\" class=\"btn btn-primary pull-right\" ng-click=\"vm.searchReport()\" \ntranslate=\"report.summarize\"></button></div></div><div role=\"alert\" ng-show=\"vm.errorMsg\" class=\"alert alert-danger\">\n{{vm.errorMsg}}</div></div></div></div></div><div class=\"table-responsive\"><table datatable=\"\" \ndt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.dtInstance\"><thead><tr><th>\n{{ \'report.wallet_source_of_fund_report.transactionId\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.transactionDateTime\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.webcashId\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.username\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.fullName\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.email\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.walletCategory\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.totalWalletRm\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.bucket_1RmFpx\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.bucket_2RmCc\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.bucket_3RmLinkCard\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.bucket_4RmSalaryDisbursementCommissionPayout\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.bucket_5RmBonusCreditPrepaid\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.bucket_6RmBonusZakatTransfer\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.bucket_7RmRemittance\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.bucket_8RmVirtualAccount\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.bucket_9RmTransferWithinKipleWallet\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.bucket_10RmOffline\' | translate}}</th><th>\n{{ \'report.wallet_source_of_fund_report.bucket_11RmOthers\' | translate}}</th><th>Bucket 12 (RM) DuitNow</th></tr>\n</thead></table></div></div>");
$templateCache.put("app/report/zakat/zakatTransaction/zakat-transaction-report.html","<div id=\"divZakatTransactionReport\" ng-init=\"vm.getUniversities()\"><h1 class=\"page-header\" \ntranslate=\"report.names.bonus_zakat_transaction_report\"></h1><div class=\"report-filter\"><div \nclass=\"panel panel-default\"><div class=\"panel-heading\" data-toggle=\"collapse\" data-target=\"#collapse_panel\"><span \nclass=\"panel-title\" translate=\"report.report_filter\"></span> <a class=\"pull-right\"><i \nclass=\"glyphicon glyphicon-fullscreen\"></i></a></div><div id=\"collapse_panel\" class=\"collapse in\"><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\">\n{{ \'report.zakat_transaction_report.university\' | translate}}</label><select ng-disable=\"vm.isReadonly\" \nclass=\"form-control\" id=\"University\" name=\"University\" ng-model=\"vm.serachModel.university\" \nng-change=\"vm.UniversityIdClick()\" ng-disabled=\"vm.isReadonly\"><option value=\"\">--Select University--</option><option \nng-repeat=\"university in vm.UniversityItems\" value=\"{{university.UniversityId}}\">{{university.UniversityId}}</option>\n</select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\">\n{{ \'report.zakat_transaction_report.universityId\' | translate}}</label><input id=\"merchantName\" name=\"merchantName\" \nclass=\"form-control\" type=\"text\" ng-model=\"vm.serachModel.universityId\"></div></div><div class=\"col-md-6\"><div \nclass=\"form-group\"><label class=\"control-label\">{{ \'report.zakat_transaction_report.username\' | translate}}</label>\n<input id=\"userName\" name=\"userName\" class=\"form-control\" type=\"text\" ng-model=\"vm.serachModel.userName\"></div></div>\n<div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\">\n{{ \'report.zakat_transaction_report.transanctionType\' | translate}}</label><select class=\"form-control\" \nng-model=\"vm.serachModel.transanctionType\"><option ng-value=\"null\">{{ \'report.common.option_all\' | translate }}\n</option><option ng-repeat=\"v in vm.transanctionTypeList\" ng-value=\"v.value\">{{v.display| translate}}</option></select>\n</div></div></div><hr><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" \ntranslate=\"report.common.transaction_start_date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.StartOpen\" ng-click=\"vm.datePopup.StartOpen = true\" \nng-model=\"vm.serachModel.beginTime\"></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label \nclass=\"control-label\" translate=\"report.common.transaction_end_date\"></label><input type=\"text\" class=\"form-control\" \nuib-datepicker-popup=\"dd/MM/yyyy\" is-open=\"vm.datePopup.EndOpen\" ng-click=\"vm.datePopup.EndOpen = true\" \nng-model=\"vm.serachModel.endTime\"></div></div></div><hr><div class=\"row\"><div class=\"col-xs-12\"><button type=\"button\" \nclass=\"btn btn-primary pull-right\" ng-click=\"vm.searchReport()\" translate=\"report.summarize\"></button></div></div><div \nrole=\"alert\" ng-show=\"vm.errorMsg\" class=\"alert alert-danger\">{{vm.errorMsg}}</div></div></div></div></div><div \nclass=\"table-responsive\"><table datatable=\"\" dt-options=\"vm.dataTable.options\" dt-columns=\"vm.dataTable.columns\" \nclass=\"table table-bordered table-striped table-hover\" dt-instance=\"vm.dtInstance\"><thead><tr><th>\n{{ \'report.zakat_transaction_report.transactionDateTime\' | translate}}</th><th>\n{{ \'report.zakat_transaction_report.webcashId\' | translate}}</th><th>\n{{ \'report.zakat_transaction_report.username\' | translate}}</th><th>\n{{ \'report.zakat_transaction_report.fullName\' | translate}}</th><th>\n{{ \'report.zakat_transaction_report.email\' | translate}}</th><th>\n{{ \'report.zakat_transaction_report.university\' | translate}}</th><th>\n{{ \'report.zakat_transaction_report.universityId\' | translate}}</th><th>\n{{ \'report.zakat_transaction_report.zakatGained\' | translate}}</th><th>\n{{ \'report.zakat_transaction_report.zakatUtilised\' | translate}}</th><th>\n{{ \'report.zakat_transaction_report.transactionType\' | translate}}</th><th>\n{{ \'report.zakat_transaction_report.zakatExpired\' | translate}}</th><th>\n{{ \'report.zakat_transaction_report.endingBalance\' | translate}}</th></tr></thead></table></div></div>");}]);